import { defineComponent as ae, h as Mr, toRefs as ye, ref as B, reactive as qt, computed as F, nextTick as Je, openBlock as f, createElementBlock as C, normalizeClass as x, unref as o, renderSlot as ee, createVNode as R, Transition as mt, withCtx as H, withDirectives as rt, createElementVNode as A, normalizeStyle as De, vShow as C0, watch as ce, getCurrentScope as Bn, onScopeDispose as Rn, readonly as Ma, onUnmounted as Vn, getCurrentInstance as V2, onMounted as Be, isRef as fe, toValue as xe, shallowRef as ba, watchEffect as Na, markRaw as ot, mergeProps as Ye, Fragment as X, renderList as le, toDisplayString as G, createCommentVNode as _, createBlock as K, mergeModels as $a, useModel as Da, pushScopeId as Ia, popScopeId as Aa, normalizeProps as Q2, guardReactiveProps as H2, withScopeId as xa, resolveComponent as v0, withKeys as m0, useSlots as It, onBeforeMount as wa, createTextVNode as Oe, createSlots as Pt, withModifiers as Mt, vModelText as i0, toRef as v2, vModelRadio as Sa, vModelSelect as ja, useTemplateRef as Ta, TransitionGroup as Qn, effectScope as Hn, toRaw as e2, hasInjectionContext as Oa, inject as _a, isReactive as B0, Teleport as za, vModelCheckbox as La } from "vue";
const Zn = /^[a-z0-9]+(-[a-z0-9]+)*$/, Z2 = (e, t, r, n = "") => {
  const s = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (s.length < 2 || s.length > 3)
      return null;
    n = s.shift().slice(1);
  }
  if (s.length > 3 || !s.length)
    return null;
  if (s.length > 1) {
    const l = s.pop(), u = s.pop(), d = {
      // Allow provider without '@': "provider:prefix:name"
      provider: s.length > 0 ? s[0] : n,
      prefix: u,
      name: l
    };
    return t && !m2(d) ? null : d;
  }
  const a = s[0], i = a.split("-");
  if (i.length > 1) {
    const l = {
      provider: n,
      prefix: i.shift(),
      name: i.join("-")
    };
    return t && !m2(l) ? null : l;
  }
  if (r && n === "") {
    const l = {
      provider: n,
      prefix: "",
      name: a
    };
    return t && !m2(l, r) ? null : l;
  }
  return null;
}, m2 = (e, t) => e ? !!// Check prefix: cannot be empty, unless allowSimpleName is enabled
// Check name: cannot be empty
((t && e.prefix === "" || e.prefix) && e.name) : !1, Gn = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), _2 = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), G2 = Object.freeze({
  ...Gn,
  ..._2
}), M0 = Object.freeze({
  ...G2,
  body: "",
  hidden: !1
});
function ka(e, t) {
  const r = {};
  !e.hFlip != !t.hFlip && (r.hFlip = !0), !e.vFlip != !t.vFlip && (r.vFlip = !0);
  const n = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return n && (r.rotate = n), r;
}
function br(e, t) {
  const r = ka(e, t);
  for (const n in M0)
    n in _2 ? n in e && !(n in r) && (r[n] = _2[n]) : n in t ? r[n] = t[n] : n in e && (r[n] = e[n]);
  return r;
}
function Ea(e, t) {
  const r = e.icons, n = e.aliases || /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
  function a(i) {
    if (r[i])
      return s[i] = [];
    if (!(i in s)) {
      s[i] = null;
      const l = n[i] && n[i].parent, u = l && a(l);
      u && (s[i] = [l].concat(u));
    }
    return s[i];
  }
  return Object.keys(r).concat(Object.keys(n)).forEach(a), s;
}
function Pa(e, t, r) {
  const n = e.icons, s = e.aliases || /* @__PURE__ */ Object.create(null);
  let a = {};
  function i(l) {
    a = br(
      n[l] || s[l],
      a
    );
  }
  return i(t), r.forEach(i), br(e, a);
}
function Wn(e, t) {
  const r = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return r;
  e.not_found instanceof Array && e.not_found.forEach((s) => {
    t(s, null), r.push(s);
  });
  const n = Ea(e);
  for (const s in n) {
    const a = n[s];
    a && (t(s, Pa(e, s, a)), r.push(s));
  }
  return r;
}
const Ya = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Gn
};
function l0(e, t) {
  for (const r in t)
    if (r in e && typeof e[r] != typeof t[r])
      return !1;
  return !0;
}
function Kn(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !l0(e, Ya))
    return null;
  const r = t.icons;
  for (const s in r) {
    const a = r[s];
    if (
      // Name cannot be empty
      !s || // Must have body
      typeof a.body != "string" || // Check other props
      !l0(
        a,
        M0
      )
    )
      return null;
  }
  const n = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const s in n) {
    const a = n[s], i = a.parent;
    if (
      // Name cannot be empty
      !s || // Parent must be set and point to existing icon
      typeof i != "string" || !r[i] && !n[i] || // Check other props
      !l0(
        a,
        M0
      )
    )
      return null;
  }
  return t;
}
const Nr = /* @__PURE__ */ Object.create(null);
function Ua(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function Lt(e, t) {
  const r = Nr[e] || (Nr[e] = /* @__PURE__ */ Object.create(null));
  return r[t] || (r[t] = Ua(e, t));
}
function Jn(e, t) {
  return Kn(t) ? Wn(t, (r, n) => {
    n ? e.icons[r] = n : e.missing.add(r);
  }) : [];
}
function Fa(e, t, r) {
  try {
    if (typeof r.body == "string")
      return e.icons[t] = { ...r }, !0;
  } catch {
  }
  return !1;
}
let t2 = !1;
function Xn(e) {
  return typeof e == "boolean" && (t2 = e), t2;
}
function Ba(e) {
  const t = typeof e == "string" ? Z2(e, !0, t2) : e;
  if (t) {
    const r = Lt(t.provider, t.prefix), n = t.name;
    return r.icons[n] || (r.missing.has(n) ? null : void 0);
  }
}
function Ra(e, t) {
  const r = Z2(e, !0, t2);
  if (!r)
    return !1;
  const n = Lt(r.provider, r.prefix);
  return t ? Fa(n, r.name, t) : (n.missing.add(r.name), !0);
}
function Va(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), t2 && !t && !e.prefix) {
    let s = !1;
    return Kn(e) && (e.prefix = "", Wn(e, (a, i) => {
      Ra(a, i) && (s = !0);
    })), s;
  }
  const r = e.prefix;
  if (!m2({
    provider: t,
    prefix: r,
    name: "a"
  }))
    return !1;
  const n = Lt(t, r);
  return !!Jn(n, e);
}
const qn = Object.freeze({
  width: null,
  height: null
}), es = Object.freeze({
  // Dimensions
  ...qn,
  // Transformations
  ..._2
}), Qa = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Ha = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function $r(e, t, r) {
  if (t === 1)
    return e;
  if (r = r || 100, typeof e == "number")
    return Math.ceil(e * t * r) / r;
  if (typeof e != "string")
    return e;
  const n = e.split(Qa);
  if (n === null || !n.length)
    return e;
  const s = [];
  let a = n.shift(), i = Ha.test(a);
  for (; ; ) {
    if (i) {
      const l = parseFloat(a);
      isNaN(l) ? s.push(a) : s.push(Math.ceil(l * t * r) / r);
    } else
      s.push(a);
    if (a = n.shift(), a === void 0)
      return s.join("");
    i = !i;
  }
}
function Za(e, t = "defs") {
  let r = "";
  const n = e.indexOf("<" + t);
  for (; n >= 0; ) {
    const s = e.indexOf(">", n), a = e.indexOf("</" + t);
    if (s === -1 || a === -1)
      break;
    const i = e.indexOf(">", a);
    if (i === -1)
      break;
    r += e.slice(s + 1, a).trim(), e = e.slice(0, n).trim() + e.slice(i + 1);
  }
  return {
    defs: r,
    content: e
  };
}
function Ga(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function Wa(e, t, r) {
  const n = Za(e);
  return Ga(n.defs, t + n.content + r);
}
const Ka = (e) => e === "unset" || e === "undefined" || e === "none";
function Ja(e, t) {
  const r = {
    ...G2,
    ...e
  }, n = {
    ...es,
    ...t
  }, s = {
    left: r.left,
    top: r.top,
    width: r.width,
    height: r.height
  };
  let a = r.body;
  [r, n].forEach((g) => {
    const v = [], m = g.hFlip, I = g.vFlip;
    let N = g.rotate;
    m ? I ? N += 2 : (v.push(
      "translate(" + (s.width + s.left).toString() + " " + (0 - s.top).toString() + ")"
    ), v.push("scale(-1 1)"), s.top = s.left = 0) : I && (v.push(
      "translate(" + (0 - s.left).toString() + " " + (s.height + s.top).toString() + ")"
    ), v.push("scale(1 -1)"), s.top = s.left = 0);
    let w;
    switch (N < 0 && (N -= Math.floor(N / 4) * 4), N = N % 4, N) {
      case 1:
        w = s.height / 2 + s.top, v.unshift(
          "rotate(90 " + w.toString() + " " + w.toString() + ")"
        );
        break;
      case 2:
        v.unshift(
          "rotate(180 " + (s.width / 2 + s.left).toString() + " " + (s.height / 2 + s.top).toString() + ")"
        );
        break;
      case 3:
        w = s.width / 2 + s.left, v.unshift(
          "rotate(-90 " + w.toString() + " " + w.toString() + ")"
        );
        break;
    }
    N % 2 === 1 && (s.left !== s.top && (w = s.left, s.left = s.top, s.top = w), s.width !== s.height && (w = s.width, s.width = s.height, s.height = w)), v.length && (a = Wa(
      a,
      '<g transform="' + v.join(" ") + '">',
      "</g>"
    ));
  });
  const i = n.width, l = n.height, u = s.width, d = s.height;
  let c, p;
  i === null ? (p = l === null ? "1em" : l === "auto" ? d : l, c = $r(p, u / d)) : (c = i === "auto" ? u : i, p = l === null ? $r(c, d / u) : l === "auto" ? d : l);
  const h = {}, y = (g, v) => {
    Ka(v) || (h[g] = v.toString());
  };
  y("width", c), y("height", p);
  const M = [s.left, s.top, u, d];
  return h.viewBox = M.join(" "), {
    attributes: h,
    viewBox: M,
    body: a
  };
}
const Xa = /\sid="(\S+)"/g, qa = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let eo = 0;
function to(e, t = qa) {
  const r = [];
  let n;
  for (; n = Xa.exec(e); )
    r.push(n[1]);
  if (!r.length)
    return e;
  const s = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return r.forEach((a) => {
    const i = typeof t == "function" ? t(a) : t + (eo++).toString(), l = a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + l + ')([")]|\\.[a-z])', "g"),
      "$1" + i + s + "$3"
    );
  }), e = e.replace(new RegExp(s, "g"), ""), e;
}
const b0 = /* @__PURE__ */ Object.create(null);
function ro(e, t) {
  b0[e] = t;
}
function N0(e) {
  return b0[e] || b0[""];
}
function R0(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    // API hosts
    resources: t,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const V0 = /* @__PURE__ */ Object.create(null), Rt = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], M2 = [];
for (; Rt.length > 0; )
  Rt.length === 1 || Math.random() > 0.5 ? M2.push(Rt.shift()) : M2.push(Rt.pop());
V0[""] = R0({
  resources: ["https://api.iconify.design"].concat(M2)
});
function no(e, t) {
  const r = R0(t);
  return r === null ? !1 : (V0[e] = r, !0);
}
function Q0(e) {
  return V0[e];
}
const so = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Dr = so();
function ao(e, t) {
  const r = Q0(e);
  if (!r)
    return 0;
  let n;
  if (!r.maxURL)
    n = 0;
  else {
    let s = 0;
    r.resources.forEach((i) => {
      s = Math.max(s, i.length);
    });
    const a = t + ".json?icons=";
    n = r.maxURL - s - r.path.length - a.length;
  }
  return n;
}
function oo(e) {
  return e === 404;
}
const io = (e, t, r) => {
  const n = [], s = ao(e, t), a = "icons";
  let i = {
    type: a,
    provider: e,
    prefix: t,
    icons: []
  }, l = 0;
  return r.forEach((u, d) => {
    l += u.length + 1, l >= s && d > 0 && (n.push(i), i = {
      type: a,
      provider: e,
      prefix: t,
      icons: []
    }, l = u.length), i.icons.push(u);
  }), n.push(i), n;
};
function lo(e) {
  if (typeof e == "string") {
    const t = Q0(e);
    if (t)
      return t.path;
  }
  return "/";
}
const uo = (e, t, r) => {
  if (!Dr) {
    r("abort", 424);
    return;
  }
  let n = lo(t.provider);
  switch (t.type) {
    case "icons": {
      const a = t.prefix, l = t.icons.join(","), u = new URLSearchParams({
        icons: l
      });
      n += a + ".json?" + u.toString();
      break;
    }
    case "custom": {
      const a = t.uri;
      n += a.slice(0, 1) === "/" ? a.slice(1) : a;
      break;
    }
    default:
      r("abort", 400);
      return;
  }
  let s = 503;
  Dr(e + n).then((a) => {
    const i = a.status;
    if (i !== 200) {
      setTimeout(() => {
        r(oo(i) ? "abort" : "next", i);
      });
      return;
    }
    return s = 501, a.json();
  }).then((a) => {
    if (typeof a != "object" || a === null) {
      setTimeout(() => {
        a === 404 ? r("abort", a) : r("next", s);
      });
      return;
    }
    setTimeout(() => {
      r("success", a);
    });
  }).catch(() => {
    r("next", s);
  });
}, co = {
  prepare: io,
  send: uo
};
function po(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, r = /* @__PURE__ */ Object.create(null);
  e.sort((s, a) => s.provider !== a.provider ? s.provider.localeCompare(a.provider) : s.prefix !== a.prefix ? s.prefix.localeCompare(a.prefix) : s.name.localeCompare(a.name));
  let n = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((s) => {
    if (n.name === s.name && n.prefix === s.prefix && n.provider === s.provider)
      return;
    n = s;
    const a = s.provider, i = s.prefix, l = s.name, u = r[a] || (r[a] = /* @__PURE__ */ Object.create(null)), d = u[i] || (u[i] = Lt(a, i));
    let c;
    l in d.icons ? c = t.loaded : i === "" || d.missing.has(l) ? c = t.missing : c = t.pending;
    const p = {
      provider: a,
      prefix: i,
      name: l
    };
    c.push(p);
  }), t;
}
function ts(e, t) {
  e.forEach((r) => {
    const n = r.loaderCallbacks;
    n && (r.loaderCallbacks = n.filter((s) => s.id !== t));
  });
}
function fo(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let r = !1;
    const n = e.provider, s = e.prefix;
    t.forEach((a) => {
      const i = a.icons, l = i.pending.length;
      i.pending = i.pending.filter((u) => {
        if (u.prefix !== s)
          return !0;
        const d = u.name;
        if (e.icons[d])
          i.loaded.push({
            provider: n,
            prefix: s,
            name: d
          });
        else if (e.missing.has(d))
          i.missing.push({
            provider: n,
            prefix: s,
            name: d
          });
        else
          return r = !0, !0;
        return !1;
      }), i.pending.length !== l && (r || ts([e], a.id), a.callback(
        i.loaded.slice(0),
        i.missing.slice(0),
        i.pending.slice(0),
        a.abort
      ));
    });
  }));
}
let go = 0;
function ho(e, t, r) {
  const n = go++, s = ts.bind(null, r, n);
  if (!t.pending.length)
    return s;
  const a = {
    id: n,
    icons: t,
    callback: e,
    abort: s
  };
  return r.forEach((i) => {
    (i.loaderCallbacks || (i.loaderCallbacks = [])).push(a);
  }), s;
}
function yo(e, t = !0, r = !1) {
  const n = [];
  return e.forEach((s) => {
    const a = typeof s == "string" ? Z2(s, t, r) : s;
    a && n.push(a);
  }), n;
}
var Co = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function vo(e, t, r, n) {
  const s = e.resources.length, a = e.random ? Math.floor(Math.random() * s) : e.index;
  let i;
  if (e.random) {
    let $ = e.resources.slice(0);
    for (i = []; $.length > 1; ) {
      const D = Math.floor(Math.random() * $.length);
      i.push($[D]), $ = $.slice(0, D).concat($.slice(D + 1));
    }
    i = i.concat($);
  } else
    i = e.resources.slice(a).concat(e.resources.slice(0, a));
  const l = Date.now();
  let u = "pending", d = 0, c, p = null, h = [], y = [];
  typeof n == "function" && y.push(n);
  function M() {
    p && (clearTimeout(p), p = null);
  }
  function g() {
    u === "pending" && (u = "aborted"), M(), h.forEach(($) => {
      $.status === "pending" && ($.status = "aborted");
    }), h = [];
  }
  function v($, D) {
    D && (y = []), typeof $ == "function" && y.push($);
  }
  function m() {
    return {
      startTime: l,
      payload: t,
      status: u,
      queriesSent: d,
      queriesPending: h.length,
      subscribe: v,
      abort: g
    };
  }
  function I() {
    u = "failed", y.forEach(($) => {
      $(void 0, c);
    });
  }
  function N() {
    h.forEach(($) => {
      $.status === "pending" && ($.status = "aborted");
    }), h = [];
  }
  function w($, D, z) {
    const k = D !== "success";
    switch (h = h.filter((b) => b !== $), u) {
      case "pending":
        break;
      case "failed":
        if (k || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (D === "abort") {
      c = z, I();
      return;
    }
    if (k) {
      c = z, h.length || (i.length ? E() : I());
      return;
    }
    if (M(), N(), !e.random) {
      const b = e.resources.indexOf($.resource);
      b !== -1 && b !== e.index && (e.index = b);
    }
    u = "completed", y.forEach((b) => {
      b(z);
    });
  }
  function E() {
    if (u !== "pending")
      return;
    M();
    const $ = i.shift();
    if ($ === void 0) {
      if (h.length) {
        p = setTimeout(() => {
          M(), u === "pending" && (N(), I());
        }, e.timeout);
        return;
      }
      I();
      return;
    }
    const D = {
      status: "pending",
      resource: $,
      callback: (z, k) => {
        w(D, z, k);
      }
    };
    h.push(D), d++, p = setTimeout(E, e.rotate), r($, t, D.callback);
  }
  return setTimeout(E), m;
}
function rs(e) {
  const t = {
    ...Co,
    ...e
  };
  let r = [];
  function n() {
    r = r.filter((l) => l().status === "pending");
  }
  function s(l, u, d) {
    const c = vo(
      t,
      l,
      u,
      (p, h) => {
        n(), d && d(p, h);
      }
    );
    return r.push(c), c;
  }
  function a(l) {
    return r.find((u) => l(u)) || null;
  }
  return {
    query: s,
    find: a,
    setIndex: (l) => {
      t.index = l;
    },
    getIndex: () => t.index,
    cleanup: n
  };
}
function Ir() {
}
const u0 = /* @__PURE__ */ Object.create(null);
function mo(e) {
  if (!u0[e]) {
    const t = Q0(e);
    if (!t)
      return;
    const r = rs(t), n = {
      config: t,
      redundancy: r
    };
    u0[e] = n;
  }
  return u0[e];
}
function Mo(e, t, r) {
  let n, s;
  if (typeof e == "string") {
    const a = N0(e);
    if (!a)
      return r(void 0, 424), Ir;
    s = a.send;
    const i = mo(e);
    i && (n = i.redundancy);
  } else {
    const a = R0(e);
    if (a) {
      n = rs(a);
      const i = e.resources ? e.resources[0] : "", l = N0(i);
      l && (s = l.send);
    }
  }
  return !n || !s ? (r(void 0, 424), Ir) : n.query(t, s, r)().abort;
}
function Ar() {
}
function bo(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, fo(e);
  }));
}
function No(e) {
  const t = [], r = [];
  return e.forEach((n) => {
    (n.match(Zn) ? t : r).push(n);
  }), {
    valid: t,
    invalid: r
  };
}
function Vt(e, t, r) {
  function n() {
    const s = e.pendingIcons;
    t.forEach((a) => {
      s && s.delete(a), e.icons[a] || e.missing.add(a);
    });
  }
  if (r && typeof r == "object")
    try {
      if (!Jn(e, r).length) {
        n();
        return;
      }
    } catch (s) {
      console.error(s);
    }
  n(), bo(e);
}
function xr(e, t) {
  e instanceof Promise ? e.then((r) => {
    t(r);
  }).catch(() => {
    t(null);
  }) : t(e);
}
function $o(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: r, prefix: n } = e, s = e.iconsToLoad;
    if (delete e.iconsToLoad, !s || !s.length)
      return;
    const a = e.loadIcon;
    if (e.loadIcons && (s.length > 1 || !a)) {
      xr(
        e.loadIcons(s, n, r),
        (c) => {
          Vt(e, s, c);
        }
      );
      return;
    }
    if (a) {
      s.forEach((c) => {
        const p = a(c, n, r);
        xr(p, (h) => {
          const y = h ? {
            prefix: n,
            icons: {
              [c]: h
            }
          } : null;
          Vt(e, [c], y);
        });
      });
      return;
    }
    const { valid: i, invalid: l } = No(s);
    if (l.length && Vt(e, l, null), !i.length)
      return;
    const u = n.match(Zn) ? N0(r) : null;
    if (!u) {
      Vt(e, i, null);
      return;
    }
    u.prepare(r, n, i).forEach((c) => {
      Mo(r, c, (p) => {
        Vt(e, c.icons, p);
      });
    });
  }));
}
const Do = (e, t) => {
  const r = yo(e, !0, Xn()), n = po(r);
  if (!n.pending.length) {
    let u = !0;
    return t && setTimeout(() => {
      u && t(
        n.loaded,
        n.missing,
        n.pending,
        Ar
      );
    }), () => {
      u = !1;
    };
  }
  const s = /* @__PURE__ */ Object.create(null), a = [];
  let i, l;
  return n.pending.forEach((u) => {
    const { provider: d, prefix: c } = u;
    if (c === l && d === i)
      return;
    i = d, l = c, a.push(Lt(d, c));
    const p = s[d] || (s[d] = /* @__PURE__ */ Object.create(null));
    p[c] || (p[c] = []);
  }), n.pending.forEach((u) => {
    const { provider: d, prefix: c, name: p } = u, h = Lt(d, c), y = h.pendingIcons || (h.pendingIcons = /* @__PURE__ */ new Set());
    y.has(p) || (y.add(p), s[d][c].push(p));
  }), a.forEach((u) => {
    const d = s[u.provider][u.prefix];
    d.length && $o(u, d);
  }), t ? ho(t, n, a) : Ar;
};
function Io(e, t) {
  const r = {
    ...e
  };
  for (const n in t) {
    const s = t[n], a = typeof s;
    n in qn ? (s === null || s && (a === "string" || a === "number")) && (r[n] = s) : a === typeof r[n] && (r[n] = n === "rotate" ? s % 4 : s);
  }
  return r;
}
const Ao = /[\s,]+/;
function xo(e, t) {
  t.split(Ao).forEach((r) => {
    switch (r.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function wo(e, t = 0) {
  const r = e.replace(/^-?[0-9.]*/, "");
  function n(s) {
    for (; s < 0; )
      s += 4;
    return s % 4;
  }
  if (r === "") {
    const s = parseInt(e);
    return isNaN(s) ? 0 : n(s);
  } else if (r !== e) {
    let s = 0;
    switch (r) {
      case "%":
        s = 25;
        break;
      case "deg":
        s = 90;
    }
    if (s) {
      let a = parseFloat(e.slice(0, e.length - r.length));
      return isNaN(a) ? 0 : (a = a / s, a % 1 === 0 ? n(a) : 0);
    }
  }
  return t;
}
function So(e, t) {
  let r = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const n in t)
    r += " " + n + '="' + t[n] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + r + ">" + e + "</svg>";
}
function jo(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function To(e) {
  return "data:image/svg+xml," + jo(e);
}
function Oo(e) {
  return 'url("' + To(e) + '")';
}
const wr = {
  ...es,
  inline: !1
}, _o = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, zo = {
  display: "inline-block"
}, $0 = {
  backgroundColor: "currentColor"
}, ns = {
  backgroundColor: "transparent"
}, Sr = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, jr = {
  webkitMask: $0,
  mask: $0,
  background: ns
};
for (const e in jr) {
  const t = jr[e];
  for (const r in Sr)
    t[e + r] = Sr[r];
}
const b2 = {};
["horizontal", "vertical"].forEach((e) => {
  const t = e.slice(0, 1) + "Flip";
  b2[e + "-flip"] = t, b2[e.slice(0, 1) + "-flip"] = t, b2[e + "Flip"] = t;
});
function Tr(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const Or = (e, t) => {
  const r = Io(wr, t), n = { ..._o }, s = t.mode || "svg", a = {}, i = t.style, l = typeof i == "object" && !(i instanceof Array) ? i : {};
  for (let g in t) {
    const v = t[g];
    if (v !== void 0)
      switch (g) {
        // Properties to ignore
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
        case "ssr":
          break;
        // Boolean attributes
        case "inline":
        case "hFlip":
        case "vFlip":
          r[g] = v === !0 || v === "true" || v === 1;
          break;
        // Flip as string: 'horizontal,vertical'
        case "flip":
          typeof v == "string" && xo(r, v);
          break;
        // Color: override style
        case "color":
          a.color = v;
          break;
        // Rotation as string
        case "rotate":
          typeof v == "string" ? r[g] = wo(v) : typeof v == "number" && (r[g] = v);
          break;
        // Remove aria-hidden
        case "ariaHidden":
        case "aria-hidden":
          v !== !0 && v !== "true" && delete n["aria-hidden"];
          break;
        default: {
          const m = b2[g];
          m ? (v === !0 || v === "true" || v === 1) && (r[m] = !0) : wr[g] === void 0 && (n[g] = v);
        }
      }
  }
  const u = Ja(e, r), d = u.attributes;
  if (r.inline && (a.verticalAlign = "-0.125em"), s === "svg") {
    n.style = {
      ...a,
      ...l
    }, Object.assign(n, d);
    let g = 0, v = t.id;
    return typeof v == "string" && (v = v.replace(/-/g, "_")), n.innerHTML = to(u.body, v ? () => v + "ID" + g++ : "iconifyVue"), Mr("svg", n);
  }
  const { body: c, width: p, height: h } = e, y = s === "mask" || (s === "bg" ? !1 : c.indexOf("currentColor") !== -1), M = So(c, {
    ...d,
    width: p + "",
    height: h + ""
  });
  return n.style = {
    ...a,
    "--svg": Oo(M),
    width: Tr(d.width),
    height: Tr(d.height),
    ...zo,
    ...y ? $0 : ns,
    ...l
  }, Mr("span", n);
};
Xn(!0);
ro("", co);
if (typeof document < "u" && typeof window < "u") {
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const t = e.IconifyPreload, r = "Invalid IconifyPreload syntax.";
    typeof t == "object" && t !== null && (t instanceof Array ? t : [t]).forEach((n) => {
      try {
        // Check if item is an object and not null/array
        (typeof n != "object" || n === null || n instanceof Array || // Check for 'icons' and 'prefix'
        typeof n.icons != "object" || typeof n.prefix != "string" || // Add icon set
        !Va(n)) && console.error(r);
      } catch {
        console.error(r);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const t = e.IconifyProviders;
    if (typeof t == "object" && t !== null)
      for (let r in t) {
        const n = "IconifyProviders[" + r + "] is invalid.";
        try {
          const s = t[r];
          if (typeof s != "object" || !s || s.resources === void 0)
            continue;
          no(r, s) || console.error(n);
        } catch {
          console.error(n);
        }
      }
  }
}
const Lo = {
  ...G2,
  body: ""
}, W = ae({
  // Do not inherit other attributes: it is handled by render()
  inheritAttrs: !1,
  // Set initial data
  data() {
    return {
      // Current icon name
      _name: "",
      // Loading
      _loadingIcon: null,
      // Mounted status
      iconMounted: !1,
      // Callback counter to trigger re-render
      counter: 0
    };
  },
  mounted() {
    this.iconMounted = !0;
  },
  unmounted() {
    this.abortLoading();
  },
  methods: {
    abortLoading() {
      this._loadingIcon && (this._loadingIcon.abort(), this._loadingIcon = null);
    },
    // Get data for icon to render or null
    getIcon(e, t, r) {
      if (typeof e == "object" && e !== null && typeof e.body == "string")
        return this._name = "", this.abortLoading(), {
          data: e
        };
      let n;
      if (typeof e != "string" || (n = Z2(e, !1, !0)) === null)
        return this.abortLoading(), null;
      let s = Ba(n);
      if (!s)
        return (!this._loadingIcon || this._loadingIcon.name !== e) && (this.abortLoading(), this._name = "", s !== null && (this._loadingIcon = {
          name: e,
          abort: Do([n], () => {
            this.counter++;
          })
        })), null;
      if (this.abortLoading(), this._name !== e && (this._name = e, t && t(e)), r) {
        s = Object.assign({}, s);
        const i = r(s.body, n.name, n.prefix, n.provider);
        typeof i == "string" && (s.body = i);
      }
      const a = ["iconify"];
      return n.prefix !== "" && a.push("iconify--" + n.prefix), n.provider !== "" && a.push("iconify--" + n.provider), { data: s, classes: a };
    }
  },
  // Render icon
  render() {
    this.counter;
    const e = this.$attrs, t = this.iconMounted || e.ssr ? this.getIcon(e.icon, e.onLoad, e.customise) : null;
    if (!t)
      return Or(Lo, e);
    let r = e;
    return t.classes && (r = {
      ...e,
      class: (typeof e.class == "string" ? e.class + " " : "") + t.classes.join(" ")
    }), Or({
      ...G2,
      ...t.data
    }, r);
  }
}), ko = ["header", "button"], Eo = {
  accordionItems: {
    type: Array,
    required: !0,
    default: () => []
  },
  alwaysOpen: {
    type: Boolean,
    default: !1
  },
  isDefaultOpen: {
    type: Boolean,
    default: !1
  },
  accordionTrigger: {
    type: String,
    validator: (e) => ko.includes(e),
    default: "button"
  },
  bordered: {
    type: Boolean,
    default: !0
  }
}, Po = (e) => {
  const { accordionItems: t, isDefaultOpen: r, alwaysOpen: n } = ye(e), s = B(), a = qt(t.value.map(() => r.value && n.value));
  return {
    accordionItems: t,
    isDefaultOpen: r,
    alwaysOpen: n,
    collapsedState: a,
    toggleCollapse: (d) => {
      d < 0 || d >= a.length || (a[d] = !a[d], e.alwaysOpen || a.forEach((c, p) => {
        p !== d && (a[p] = !1);
      }));
    },
    setClickedIndex: (d) => {
      s.value = d;
    },
    clearIndex: () => {
      s.value = void 0;
    },
    clickedIndex: s
  };
}, Yo = {
  modelValue: {
    type: Boolean,
    required: !0
  },
  transitionDuration: {
    type: Number,
    default: 150
    // Default transition duration in milliseconds
  }
}, Uo = {
  "update:modelValue": (e) => typeof e == "boolean"
}, Fo = (e, t) => {
  const { modelValue: r, transitionDuration: n } = ye(e), s = F(() => ({
    container: "spr-w-full"
  })), a = F(() => ({
    overflow: "hidden",
    transition: `max-height ${n.value}ms ease-in-out`
  }));
  return {
    collapsibleClasses: s,
    contentStyle: a,
    toggleCollapsible: () => {
      t("update:modelValue", !r.value);
    },
    onBeforeEnter: (p) => {
      p.style.maxHeight = "0px";
    },
    onEnter: async (p, h) => {
      await Je();
      const y = p;
      y.style.maxHeight = `${y.scrollHeight}px`, setTimeout(() => {
        y.style.maxHeight = "", h();
      }, n.value);
    },
    onBeforeLeave: (p) => {
      const h = p;
      h.style.maxHeight = `${h.scrollHeight}px`;
    },
    onLeave: (p, h) => {
      const y = p;
      y.offsetHeight, y.style.maxHeight = "0px", setTimeout(h, n.value);
    }
  };
}, ss = /* @__PURE__ */ ae({
  __name: "collapsible",
  props: Yo,
  emits: Uo,
  setup(e, { emit: t }) {
    const r = e, n = t, { collapsibleClasses: s, contentStyle: a, toggleCollapsible: i, onBeforeEnter: l, onEnter: u, onBeforeLeave: d, onLeave: c } = Fo(r, n);
    return (p, h) => (f(), C("div", {
      class: x(o(s).container)
    }, [
      ee(p.$slots, "trigger", { toggleCollapsible: o(i) }),
      R(mt, {
        css: !1,
        onBeforeEnter: o(l),
        onEnter: o(u),
        onBeforeLeave: o(d),
        onLeave: o(c)
      }, {
        default: H(() => [
          rt(A("div", {
            style: De(o(a))
          }, [
            ee(p.$slots, "default")
          ], 4), [
            [C0, p.modelValue]
          ])
        ]),
        _: 3
      }, 8, ["onBeforeEnter", "onEnter", "onBeforeLeave", "onLeave"])
    ], 2));
  }
}), Bo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ss
}, Symbol.toStringTag, { value: "Module" })), Ro = ["neutral", "success", "danger"], Vo = ["small", "medium", "large"], Qo = ["button", "submit", "reset"], Ho = ["base", "hover", "pressed", "focus"], Zo = ["primary", "secondary", "tertiary"], as = {
  /**
   * @description Button tone
   */
  tone: {
    type: String,
    validator: (e) => Ro.includes(e),
    default: "neutral"
  },
  /**
   * @description Button size
   */
  size: {
    type: String,
    validator: (e) => Vo.includes(e),
    default: "medium"
  },
  /**
   * @description Native button type
   */
  type: {
    type: String,
    validator: (e) => Qo.includes(e),
    default: "button"
  },
  /**
   * @description Button state
   */
  state: {
    type: String,
    validator: (e) => Ho.includes(e),
    default: "base"
  },
  /**
   * @description Button Variant
   */
  variant: {
    type: String,
    validator: (e) => Zo.includes(e),
    default: "primary"
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  hasIcon: {
    type: Boolean,
    default: !1
  },
  fullwidth: {
    type: Boolean,
    default: !1
  }
}, Go = {
  click: (e) => e instanceof MouseEvent
};
function d2(e) {
  return Bn() ? (Rn(e), !0) : !1;
}
const H0 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Wo = (e) => typeof e < "u", os = (e) => e != null, Ko = Object.prototype.toString, Jo = (e) => Ko.call(e) === "[object Object]", Xo = () => +Date.now(), Pe = () => {
}, qo = /* @__PURE__ */ ei();
function ei() {
  var e, t;
  return H0 && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Z0(e, t) {
  function r(...n) {
    return new Promise((s, a) => {
      Promise.resolve(e(() => t.apply(this, n), { fn: t, thisArg: this, args: n })).then(s).catch(a);
    });
  }
  return r;
}
const is = (e) => e();
function ti(e, t = {}) {
  let r, n, s = Pe;
  const a = (u) => {
    clearTimeout(u), s(), s = Pe;
  };
  let i;
  return (u) => {
    const d = xe(e), c = xe(t.maxWait);
    return r && a(r), d <= 0 || c !== void 0 && c <= 0 ? (n && (a(n), n = null), Promise.resolve(u())) : new Promise((p, h) => {
      s = t.rejectOnCancel ? h : p, i = u, c && !n && (n = setTimeout(() => {
        r && a(r), n = null, p(i());
      }, c)), r = setTimeout(() => {
        n && a(n), n = null, p(u());
      }, d);
    });
  };
}
function ri(...e) {
  let t = 0, r, n = !0, s = Pe, a, i, l, u, d;
  !fe(e[0]) && typeof e[0] == "object" ? { delay: i, trailing: l = !0, leading: u = !0, rejectOnCancel: d = !1 } = e[0] : [i, l = !0, u = !0, d = !1] = e;
  const c = () => {
    r && (clearTimeout(r), r = void 0, s(), s = Pe);
  };
  return (h) => {
    const y = xe(i), M = Date.now() - t, g = () => a = h();
    return c(), y <= 0 ? (t = Date.now(), g()) : (M > y && (u || !n) ? (t = Date.now(), g()) : l && (a = new Promise((v, m) => {
      s = d ? m : v, r = setTimeout(() => {
        t = Date.now(), n = !0, v(g()), c();
      }, Math.max(0, y - M));
    })), !u && !r && (r = setTimeout(() => n = !0, y)), n = !1, a);
  };
}
function ni(e = is) {
  const t = B(!0);
  function r() {
    t.value = !1;
  }
  function n() {
    t.value = !0;
  }
  const s = (...a) => {
    t.value && e(...a);
  };
  return { isActive: Ma(t), pause: r, resume: n, eventFilter: s };
}
function ls(e) {
  return V2();
}
function Gt(e) {
  return Array.isArray(e) ? e : [e];
}
function W2(e, t = 200, r = {}) {
  return Z0(
    ti(t, r),
    e
  );
}
function si(e, t = 200, r = !1, n = !0, s = !1) {
  return Z0(
    ri(t, r, n, s),
    e
  );
}
function ai(e, t = !0, r) {
  ls() ? Be(e, r) : t ? e() : Je(e);
}
function oi(e, t) {
  ls() && Vn(e, t);
}
function ii(e, t, r) {
  return ce(
    e,
    t,
    {
      ...r,
      deep: !0
    }
  );
}
function li(e, t, r = {}) {
  const {
    eventFilter: n = is,
    ...s
  } = r, a = Z0(
    n,
    t
  );
  let i, l, u;
  if (s.flush === "sync") {
    const d = B(!1);
    l = () => {
    }, i = (c) => {
      d.value = !0, c(), d.value = !1;
    }, u = ce(
      e,
      (...c) => {
        d.value || a(...c);
      },
      s
    );
  } else {
    const d = [], c = B(0), p = B(0);
    l = () => {
      c.value = p.value;
    }, d.push(
      ce(
        e,
        () => {
          p.value++;
        },
        { ...s, flush: "sync" }
      )
    ), i = (h) => {
      const y = p.value;
      h(), c.value += p.value - y;
    }, d.push(
      ce(
        e,
        (...h) => {
          const y = c.value > 0 && c.value === p.value;
          c.value = 0, p.value = 0, !y && a(...h);
        },
        s
      )
    ), u = () => {
      d.forEach((h) => h());
    };
  }
  return { stop: u, ignoreUpdates: i, ignorePrevAsyncUpdates: l };
}
function ui(e, t, r) {
  return ce(
    e,
    t,
    {
      ...r,
      immediate: !0
    }
  );
}
const qe = H0 ? window : void 0;
function Le(e) {
  var t;
  const r = xe(e);
  return (t = r == null ? void 0 : r.$el) != null ? t : r;
}
function $e(...e) {
  const t = [], r = () => {
    t.forEach((l) => l()), t.length = 0;
  }, n = (l, u, d, c) => (l.addEventListener(u, d, c), () => l.removeEventListener(u, d, c)), s = F(() => {
    const l = Gt(xe(e[0])).filter((u) => u != null);
    return l.every((u) => typeof u != "string") ? l : void 0;
  }), a = ui(
    () => {
      var l, u;
      return [
        (u = (l = s.value) == null ? void 0 : l.map((d) => Le(d))) != null ? u : [qe].filter((d) => d != null),
        Gt(xe(s.value ? e[1] : e[0])),
        Gt(o(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        xe(s.value ? e[3] : e[2])
      ];
    },
    ([l, u, d, c]) => {
      if (r(), !(l != null && l.length) || !(u != null && u.length) || !(d != null && d.length))
        return;
      const p = Jo(c) ? { ...c } : c;
      t.push(
        ...l.flatMap(
          (h) => u.flatMap(
            (y) => d.map((M) => n(h, y, M, p))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    a(), r();
  };
  return d2(r), i;
}
let _r = !1;
function Yt(e, t, r = {}) {
  const { window: n = qe, ignore: s = [], capture: a = !0, detectIframe: i = !1 } = r;
  if (!n)
    return Pe;
  if (qo && !_r) {
    _r = !0;
    const g = { passive: !0 };
    Array.from(n.document.body.children).forEach((v) => $e(v, "click", Pe, g)), $e(n.document.documentElement, "click", Pe, g);
  }
  let l = !0;
  const u = (g) => xe(s).some((v) => {
    if (typeof v == "string")
      return Array.from(n.document.querySelectorAll(v)).some((m) => m === g.target || g.composedPath().includes(m));
    {
      const m = Le(v);
      return m && (g.target === m || g.composedPath().includes(m));
    }
  });
  function d(g) {
    const v = xe(g);
    return v && v.$.subTree.shapeFlag === 16;
  }
  function c(g, v) {
    const m = xe(g), I = m.$.subTree && m.$.subTree.children;
    return I == null || !Array.isArray(I) ? !1 : I.some((N) => N.el === v.target || v.composedPath().includes(N.el));
  }
  const p = (g) => {
    const v = Le(e);
    if (g.target != null && !(!(v instanceof Element) && d(e) && c(e, g)) && !(!v || v === g.target || g.composedPath().includes(v))) {
      if (g.detail === 0 && (l = !u(g)), !l) {
        l = !0;
        return;
      }
      t(g);
    }
  };
  let h = !1;
  const y = [
    $e(n, "click", (g) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), p(g));
    }, { passive: !0, capture: a }),
    $e(n, "pointerdown", (g) => {
      const v = Le(e);
      l = !u(g) && !!(v && !g.composedPath().includes(v));
    }, { passive: !0 }),
    i && $e(n, "blur", (g) => {
      setTimeout(() => {
        var v;
        const m = Le(e);
        ((v = n.document.activeElement) == null ? void 0 : v.tagName) === "IFRAME" && !(m != null && m.contains(n.document.activeElement)) && t(g);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean);
  return () => y.forEach((g) => g());
}
function di() {
  const e = B(!1), t = V2();
  return t && Be(() => {
    e.value = !0;
  }, t), e;
}
function G0(e) {
  const t = di();
  return F(() => (t.value, !!e()));
}
function ci(e, t, r = {}) {
  const { window: n = qe, ...s } = r;
  let a;
  const i = G0(() => n && "MutationObserver" in n), l = () => {
    a && (a.disconnect(), a = void 0);
  }, u = F(() => {
    const h = xe(e), y = Gt(h).map(Le).filter(os);
    return new Set(y);
  }), d = ce(
    () => u.value,
    (h) => {
      l(), i.value && h.size && (a = new MutationObserver(t), h.forEach((y) => a.observe(y, s)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => a == null ? void 0 : a.takeRecords(), p = () => {
    d(), l();
  };
  return d2(p), {
    isSupported: i,
    stop: p,
    takeRecords: c
  };
}
function pi(e, t, r = {}) {
  const {
    window: n = qe,
    document: s = n == null ? void 0 : n.document,
    flush: a = "sync"
  } = r;
  if (!n || !s)
    return Pe;
  let i;
  const l = (c) => {
    i == null || i(), i = c;
  }, u = Na(() => {
    const c = Le(e);
    if (c) {
      const { stop: p } = ci(
        s,
        (h) => {
          h.map((M) => [...M.removedNodes]).flat().some((M) => M === c || M.contains(c)) && t(h);
        },
        {
          window: n,
          childList: !0,
          subtree: !0
        }
      );
      l(p);
    }
  }, { flush: a }), d = () => {
    u(), l();
  };
  return d2(d), d;
}
function W0(e) {
  return JSON.parse(JSON.stringify(e));
}
function us(e) {
  return e;
}
function fi(e, t) {
  return e.value = t;
}
function gi(e) {
  return e ? typeof e == "function" ? e : W0 : us;
}
function hi(e) {
  return e ? typeof e == "function" ? e : W0 : us;
}
function yi(e, t = {}) {
  const {
    clone: r = !1,
    dump: n = gi(r),
    parse: s = hi(r),
    setSource: a = fi
  } = t;
  function i() {
    return ot({
      snapshot: n(e.value),
      timestamp: Xo()
    });
  }
  const l = B(i()), u = B([]), d = B([]), c = (N) => {
    a(e, s(N.snapshot)), l.value = N;
  }, p = () => {
    u.value.unshift(l.value), l.value = i(), t.capacity && u.value.length > t.capacity && u.value.splice(t.capacity, Number.POSITIVE_INFINITY), d.value.length && d.value.splice(0, d.value.length);
  }, h = () => {
    u.value.splice(0, u.value.length), d.value.splice(0, d.value.length);
  }, y = () => {
    const N = u.value.shift();
    N && (d.value.unshift(l.value), c(N));
  }, M = () => {
    const N = d.value.shift();
    N && (u.value.unshift(l.value), c(N));
  }, g = () => {
    c(l.value);
  }, v = F(() => [l.value, ...u.value]), m = F(() => u.value.length > 0), I = F(() => d.value.length > 0);
  return {
    source: e,
    undoStack: u,
    redoStack: d,
    last: l,
    history: v,
    canUndo: m,
    canRedo: I,
    clear: h,
    commit: p,
    reset: g,
    undo: y,
    redo: M
  };
}
function Ci(e, t = {}) {
  const {
    deep: r = !1,
    flush: n = "pre",
    eventFilter: s
  } = t, {
    eventFilter: a,
    pause: i,
    resume: l,
    isActive: u
  } = ni(s), {
    ignoreUpdates: d,
    ignorePrevAsyncUpdates: c,
    stop: p
  } = li(
    e,
    v,
    { deep: r, flush: n, eventFilter: a }
  );
  function h(w, E) {
    c(), d(() => {
      w.value = E;
    });
  }
  const y = yi(e, { ...t, clone: t.clone || r, setSource: h }), { clear: M, commit: g } = y;
  function v() {
    c(), g();
  }
  function m(w) {
    l(), w && v();
  }
  function I(w) {
    let E = !1;
    const $ = () => E = !0;
    d(() => {
      w($);
    }), E || v();
  }
  function N() {
    p(), M();
  }
  return {
    ...y,
    isTracking: u,
    pause: i,
    resume: m,
    commit: v,
    batch: I,
    dispose: N
  };
}
function vi(e, t = {}) {
  var r, n;
  const s = B(!1), a = ba(null);
  let i = 0, l = !0;
  if (H0) {
    const u = typeof t == "function" ? { onDrop: t } : t, d = (r = u.multiple) != null ? r : !0, c = (n = u.preventDefaultForUnhandled) != null ? n : !1, p = (v) => {
      var m, I;
      const N = Array.from((I = (m = v.dataTransfer) == null ? void 0 : m.files) != null ? I : []);
      return N.length === 0 ? null : d ? N : [N[0]];
    }, h = (v) => {
      const m = o(u.dataTypes);
      return typeof m == "function" ? m(v) : m != null && m.length ? v.length === 0 ? !1 : v.every(
        (I) => m.some((N) => I.includes(N))
      ) : !0;
    }, y = (v) => {
      const m = Array.from(v ?? []).map((w) => w.type), I = h(m), N = d || v.length <= 1;
      return I && N;
    }, M = () => /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) && !("chrome" in window), g = (v, m) => {
      var I, N, w, E, $, D;
      const z = (I = v.dataTransfer) == null ? void 0 : I.items;
      if (l = (N = z && y(z)) != null ? N : !1, c && v.preventDefault(), !M() && !l) {
        v.dataTransfer && (v.dataTransfer.dropEffect = "none");
        return;
      }
      v.preventDefault(), v.dataTransfer && (v.dataTransfer.dropEffect = "copy");
      const k = p(v);
      switch (m) {
        case "enter":
          i += 1, s.value = !0, (w = u.onEnter) == null || w.call(u, null, v);
          break;
        case "over":
          (E = u.onOver) == null || E.call(u, null, v);
          break;
        case "leave":
          i -= 1, i === 0 && (s.value = !1), ($ = u.onLeave) == null || $.call(u, null, v);
          break;
        case "drop":
          i = 0, s.value = !1, l && (a.value = k, (D = u.onDrop) == null || D.call(u, k, v));
          break;
      }
    };
    $e(e, "dragenter", (v) => g(v, "enter")), $e(e, "dragover", (v) => g(v, "over")), $e(e, "dragleave", (v) => g(v, "leave")), $e(e, "drop", (v) => g(v, "drop"));
  }
  return {
    files: a,
    isOverDropZone: s
  };
}
function mi(e, t, r = {}) {
  const { window: n = qe, ...s } = r;
  let a;
  const i = G0(() => n && "ResizeObserver" in n), l = () => {
    a && (a.disconnect(), a = void 0);
  }, u = F(() => {
    const p = xe(e);
    return Array.isArray(p) ? p.map((h) => Le(h)) : [Le(p)];
  }), d = ce(
    u,
    (p) => {
      if (l(), i.value && n) {
        a = new ResizeObserver(t);
        for (const h of p)
          h && a.observe(h, s);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), d();
  };
  return d2(c), {
    isSupported: i,
    stop: c
  };
}
function K0(e, t = {}) {
  const {
    delayEnter: r = 0,
    delayLeave: n = 0,
    triggerOnRemoval: s = !1,
    window: a = qe
  } = t, i = B(!1);
  let l;
  const u = (d) => {
    const c = d ? r : n;
    l && (clearTimeout(l), l = void 0), c ? l = setTimeout(() => i.value = d, c) : i.value = d;
  };
  return a && ($e(e, "mouseenter", () => u(!0), { passive: !0 }), $e(e, "mouseleave", () => u(!1), { passive: !0 }), s && pi(
    F(() => Le(e)),
    () => u(!1)
  )), i;
}
function Mi(e, t, r = {}) {
  const {
    root: n,
    rootMargin: s = "0px",
    threshold: a = 0,
    window: i = qe,
    immediate: l = !0
  } = r, u = G0(() => i && "IntersectionObserver" in i), d = F(() => {
    const M = xe(e);
    return Gt(M).map(Le).filter(os);
  });
  let c = Pe;
  const p = B(l), h = u.value ? ce(
    () => [d.value, Le(n), p.value],
    ([M, g]) => {
      if (c(), !p.value || !M.length)
        return;
      const v = new IntersectionObserver(
        t,
        {
          root: Le(g),
          rootMargin: s,
          threshold: a
        }
      );
      M.forEach((m) => m && v.observe(m)), c = () => {
        v.disconnect(), c = Pe;
      };
    },
    { immediate: l, flush: "post" }
  ) : Pe, y = () => {
    c(), h(), p.value = !1;
  };
  return d2(y), {
    isSupported: u,
    isActive: p,
    pause() {
      c(), p.value = !1;
    },
    resume() {
      p.value = !0;
    },
    stop: y
  };
}
function bi(e, t = {}) {
  const {
    window: r = qe,
    scrollTarget: n,
    threshold: s = 0,
    rootMargin: a
  } = t, i = B(!1);
  return Mi(
    e,
    (l) => {
      let u = i.value, d = 0;
      for (const c of l)
        c.time >= d && (d = c.time, u = c.isIntersecting);
      i.value = u;
    },
    {
      root: n,
      window: r,
      threshold: s,
      rootMargin: xe(a)
    }
  ), i;
}
function J0(e, t = {}) {
  const { initialValue: r = !1, focusVisible: n = !1, preventScroll: s = !1 } = t, a = B(!1), i = F(() => Le(e)), l = { passive: !0 };
  $e(i, "focus", (d) => {
    var c, p;
    (!n || (p = (c = d.target).matches) != null && p.call(c, ":focus-visible")) && (a.value = !0);
  }, l), $e(i, "blur", () => a.value = !1, l);
  const u = F({
    get: () => a.value,
    set(d) {
      var c, p;
      !d && a.value ? (c = i.value) == null || c.blur() : d && !a.value && ((p = i.value) == null || p.focus({ preventScroll: s }));
    }
  });
  return ce(
    i,
    () => {
      u.value = r;
    },
    { immediate: !0, flush: "post" }
  ), { focused: u };
}
function Ni(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
const zr = 1;
function $i(e, t = {}) {
  const {
    throttle: r = 0,
    idle: n = 200,
    onStop: s = Pe,
    onScroll: a = Pe,
    offset: i = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: l = {
      capture: !1,
      passive: !0
    },
    behavior: u = "auto",
    window: d = qe,
    onError: c = (D) => {
      console.error(D);
    }
  } = t, p = B(0), h = B(0), y = F({
    get() {
      return p.value;
    },
    set(D) {
      g(D, void 0);
    }
  }), M = F({
    get() {
      return h.value;
    },
    set(D) {
      g(void 0, D);
    }
  });
  function g(D, z) {
    var k, b, P, V;
    if (!d)
      return;
    const Z = xe(e);
    if (!Z)
      return;
    (P = Z instanceof Document ? d.document.body : Z) == null || P.scrollTo({
      top: (k = xe(z)) != null ? k : M.value,
      left: (b = xe(D)) != null ? b : y.value,
      behavior: xe(u)
    });
    const j = ((V = Z == null ? void 0 : Z.document) == null ? void 0 : V.documentElement) || (Z == null ? void 0 : Z.documentElement) || Z;
    y != null && (p.value = j.scrollLeft), M != null && (h.value = j.scrollTop);
  }
  const v = B(!1), m = qt({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), I = qt({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), N = (D) => {
    v.value && (v.value = !1, I.left = !1, I.right = !1, I.top = !1, I.bottom = !1, s(D));
  }, w = W2(N, r + n), E = (D) => {
    var z;
    if (!d)
      return;
    const k = ((z = D == null ? void 0 : D.document) == null ? void 0 : z.documentElement) || (D == null ? void 0 : D.documentElement) || Le(D), { display: b, flexDirection: P, direction: V } = getComputedStyle(k), Z = V === "rtl" ? -1 : 1, j = k.scrollLeft;
    I.left = j < p.value, I.right = j > p.value;
    const T = j * Z <= (i.left || 0), O = j * Z + k.clientWidth >= k.scrollWidth - (i.right || 0) - zr;
    b === "flex" && P === "row-reverse" ? (m.left = O, m.right = T) : (m.left = T, m.right = O), p.value = j;
    let S = k.scrollTop;
    D === d.document && !S && (S = d.document.body.scrollTop), I.top = S < h.value, I.bottom = S > h.value;
    const Y = S <= (i.top || 0), U = S + k.clientHeight >= k.scrollHeight - (i.bottom || 0) - zr;
    b === "flex" && P === "column-reverse" ? (m.top = U, m.bottom = Y) : (m.top = Y, m.bottom = U), h.value = S;
  }, $ = (D) => {
    var z;
    if (!d)
      return;
    const k = (z = D.target.documentElement) != null ? z : D.target;
    E(k), v.value = !0, w(D), a(D);
  };
  return $e(
    e,
    "scroll",
    r ? si($, r, !0, !1) : $,
    l
  ), ai(() => {
    try {
      const D = xe(e);
      if (!D)
        return;
      E(D);
    } catch (D) {
      c(D);
    }
  }), $e(
    e,
    "scrollend",
    N,
    l
  ), {
    x: y,
    y: M,
    isScrolling: v,
    arrivedState: m,
    directions: I,
    measure() {
      const D = xe(e);
      d && D && E(D);
    }
  };
}
function kt(e, t, r = {}) {
  var n;
  const {
    direction: s = "bottom",
    interval: a = 100,
    canLoadMore: i = () => !0
  } = r, l = qt($i(
    e,
    {
      ...r,
      offset: {
        [s]: (n = r.distance) != null ? n : 0,
        ...r.offset
      }
    }
  )), u = B(), d = F(() => !!u.value), c = F(() => Ni(xe(e))), p = bi(c);
  function h() {
    if (l.measure(), !c.value || !p.value || !i(c.value))
      return;
    const { scrollHeight: M, clientHeight: g, scrollWidth: v, clientWidth: m } = c.value, I = s === "bottom" || s === "top" ? M <= g : v <= m;
    (l.arrivedState[s] || I) && (u.value || (u.value = Promise.all([
      t(l),
      new Promise((N) => setTimeout(N, a))
    ]).finally(() => {
      u.value = null, Je(() => h());
    })));
  }
  const y = ce(
    () => [l.arrivedState[s], p.value],
    h,
    { immediate: !0 }
  );
  return oi(y), {
    isLoading: d,
    reset() {
      Je(() => h());
    }
  };
}
function ds(e = {}) {
  const {
    touch: t = !0,
    drag: r = !0,
    capture: n = !1,
    initialValue: s = !1,
    window: a = qe
  } = e, i = B(s), l = B(null);
  if (!a)
    return {
      pressed: i,
      sourceType: l
    };
  const u = (h) => (y) => {
    var M;
    i.value = !0, l.value = h, (M = e.onPressed) == null || M.call(e, y);
  }, d = (h) => {
    var y;
    i.value = !1, l.value = null, (y = e.onReleased) == null || y.call(e, h);
  }, c = F(() => Le(e.target) || a), p = { passive: !0, capture: n };
  return $e(c, "mousedown", u("mouse"), p), $e(a, "mouseleave", d, p), $e(a, "mouseup", d, p), r && ($e(c, "dragstart", u("mouse"), p), $e(a, "drop", d, p), $e(a, "dragend", d, p)), t && ($e(c, "touchstart", u("touch"), p), $e(a, "touchend", d, p), $e(a, "touchcancel", d, p)), {
    pressed: i,
    sourceType: l
  };
}
function Ie(e, t, r, n = {}) {
  var s, a, i;
  const {
    clone: l = !1,
    passive: u = !1,
    eventName: d,
    deep: c = !1,
    defaultValue: p,
    shouldEmit: h
  } = n, y = V2(), M = r || (y == null ? void 0 : y.emit) || ((s = y == null ? void 0 : y.$emit) == null ? void 0 : s.bind(y)) || ((i = (a = y == null ? void 0 : y.proxy) == null ? void 0 : a.$emit) == null ? void 0 : i.bind(y == null ? void 0 : y.proxy));
  let g = d;
  t || (t = "modelValue"), g = g || `update:${t.toString()}`;
  const v = (N) => l ? typeof l == "function" ? l(N) : W0(N) : N, m = () => Wo(e[t]) ? v(e[t]) : p, I = (N) => {
    h ? h(N) && M(g, N) : M(g, N);
  };
  if (u) {
    const N = m(), w = B(N);
    let E = !1;
    return ce(
      () => e[t],
      ($) => {
        E || (E = !0, w.value = v($), Je(() => E = !1));
      }
    ), ce(
      w,
      ($) => {
        !E && ($ !== e[t] || c) && I($);
      },
      { deep: c }
    ), w;
  } else
    return F({
      get() {
        return m();
      },
      set(N) {
        I(N);
      }
    });
}
function c2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var d0 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Lr;
function Di() {
  return Lr || (Lr = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var a = "", i = 0; i < arguments.length; i++) {
          var l = arguments[i];
          l && (a = s(a, n(l)));
        }
        return a;
      }
      function n(a) {
        if (typeof a == "string" || typeof a == "number")
          return a;
        if (typeof a != "object")
          return "";
        if (Array.isArray(a))
          return r.apply(null, a);
        if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
          return a.toString();
        var i = "";
        for (var l in a)
          t.call(a, l) && a[l] && (i = s(i, l));
        return i;
      }
      function s(a, i) {
        return i ? a ? a + " " + i : a + i : a;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(d0)), d0.exports;
}
var Ii = Di();
const L = /* @__PURE__ */ c2(Ii), Ai = (e, t) => {
  const { state: r, type: n, size: s, tone: a, variant: i, disabled: l, hasIcon: u, fullwidth: d } = ye(e), c = B(null), p = K0(c), { pressed: h } = ds({ target: c }), { focused: y } = J0(c), M = F(() => {
    const k = L(
      "spr-background-color spr-flex spr-items-center spr-gap-1.5 spr-w-fit spr-min-w-[24px] spr-items-center spr-justify-center spr-rounded-md spr-outline-2 spr-outline-offset-4",
      {
        "spr-w-full": d.value
      }
    ), b = L("spr-font-medium", {
      "spr-min-w-6 spr-p-1.5 spr-leading-100 spr-font-size-100": !u.value && s.value === "small",
      "spr-min-w-7 spr-p-2 spr-leading-100 spr-font-size-100": !u.value && s.value === "medium",
      "spr-max-h-9 spr-min-w-9 spr-px-2 spr-py-3 spr-leading-300 spr-font-size-200": !u.value && s.value === "large",
      // Has Icon
      "spr-min-w-6 spr-p-1.5 spr-leading-100 spr-font-size-100 [&>svg]:spr-font-size-200": u.value && s.value === "small",
      "spr-min-w-7 spr-p-2 spr-leading-100 spr-font-size-100 [&>svg]:spr-font-size-300": u.value && s.value === "medium",
      "spr-max-h-9 spr-min-w-9 spr-px-2 spr-py-3 spr-leading-300 spr-font-size-200 [&>svg]:spr-font-size-400": u.value && s.value === "large"
    }), P = L(
      v.value,
      g.value,
      $.value
    ), V = L([
      "spr-transition spr-duration-150 spr-ease-in-out",
      "hover:spr-shadow-button-hover",
      "active:spr-scale-95"
    ]);
    if (l.value) {
      if (i.value === "primary")
        return L(
          k,
          b,
          "spr-text-color-disabled spr-background-color-disabled !spr-shadow-none !spr-cursor-not-allowed spr-border-none"
        );
      if (i.value === "secondary")
        return L(
          k,
          b,
          "spr-text-color-disabled !spr-shadow-none !spr-cursor-not-allowed spr-border spr-border-solid spr-border-color-disabled"
        );
      if (i.value === "tertiary")
        return L(
          k,
          b,
          "spr-text-color-disabled !spr-shadow-none !spr-cursor-not-allowed spr-border-none"
        );
    }
    return L(k, b, P, V);
  }), g = F(() => i.value === "secondary" || i.value === "tertiary" ? L({
    "spr-text-color-strong": a.value === "neutral",
    "spr-text-color-brand-base": a.value === "success",
    "spr-text-color-danger-base": a.value === "danger"
  }) : L({
    "spr-text-color-strong": a.value === "neutral",
    "spr-text-color-inverted-strong": a.value === "success" || a.value === "danger"
  })), v = F(() => i.value === "secondary" ? h.value ? "spr-background-color-pressed !spr-shadow-button" : p.value ? "spr-background-color-hover" : "spr-background-color " : i.value === "tertiary" ? m() : I()), m = () => h.value ? "spr-background-color-pressed !spr-shadow-button" : L("!border-none", {
    "spr-background-color-hover": p.value
  }), I = () => h.value ? N() : p.value ? w() : E(), N = () => ({
    neutral: "spr-background-color-pressed !spr-shadow-button",
    success: "spr-background-color-brand-pressed !spr-shadow-button",
    danger: "spr-background-color-danger-pressed !spr-shadow-button"
  })[a.value] || "", w = () => ({
    neutral: "spr-background-color-hover",
    success: "spr-background-color-success-pressed",
    danger: "spr-background-color-danger-hover"
  })[a.value] || "", E = () => ({
    neutral: "spr-background-color-base",
    success: "spr-background-color-brand-base",
    danger: "spr-background-color-danger-base"
  })[a.value] || "", $ = F(() => L(
    "spr-border spr-border-solid",
    {
      "spr-border-transparent": i.value === "primary" || i.value === "tertiary",
      "spr-border-white-50": y.value && i.value === "primary" || i.value === "tertiary",
      "spr-border-color-base": i.value === "secondary" && a.value === "neutral",
      "spr-border-color-brand-base": i.value === "secondary" && a.value === "success",
      "spr-border-color-danger-base": i.value === "secondary" && a.value === "danger"
    }
  )), D = F(() => ({
    ...l.value && { ariaDisabled: !0 },
    disabled: l.value,
    autofocus: r.value === "focus",
    type: n.value
  }));
  return {
    buttonClassses: M,
    buttonRef: c,
    buttonProps: D,
    handleClick: (k) => {
      if (l.value) {
        k.stopPropagation();
        return;
      }
      t("click", k);
    }
  };
}, be = /* @__PURE__ */ ae({
  __name: "button",
  props: as,
  emits: Go,
  setup(e, { emit: t }) {
    const r = e, n = t, { buttonRef: s, buttonClassses: a, buttonProps: i, handleClick: l } = Ai(r, n);
    return (u, d) => (f(), C("button", Ye({
      ref_key: "buttonRef",
      ref: s,
      class: o(a)
    }, o(i), {
      onClick: d[0] || (d[0] = //@ts-ignore
      (...c) => o(l) && o(l)(...c))
    }), [
      ee(u.$slots, "default")
    ], 16));
  }
}), xi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: be
}, Symbol.toStringTag, { value: "Module" })), wi = ["id"], Si = ["onMousedown", "onClick"], ji = { class: "spr-flex spr-w-[95%] spr-flex-col" }, Ti = { class: "spr-text-base spr-font-medium spr-leading-5 spr-text-mushroom-950" }, Oi = {
  key: 0,
  class: "spr-text-200 spr-font-normal spr-leading-5 spr-text-mushroom-600"
}, _i = { class: "spr-px-size-spacing-xs spr-pb-size-spacing-sm" }, zi = /* @__PURE__ */ ae({
  __name: "accordion",
  props: Eo,
  setup(e) {
    const t = e, { collapsedState: r, toggleCollapse: n, setClickedIndex: s, clearIndex: a, clickedIndex: i } = Po(t);
    return (l, u) => (f(), C("div", {
      id: "accordion",
      class: x({ "spr-rounded-border-radius-xl spr-border spr-border-solid spr-border-mushroom-200": t.bordered })
    }, [
      (f(!0), C(X, null, le(t.accordionItems, (d, c) => (f(), C("div", {
        key: d.collapseId,
        id: `accordion_item_${d.collapseId}`,
        class: x({ "spr-border-x-0 spr-border-b-0 spr-border-t spr-border-solid spr-border-mushroom-200": c !== 0 })
      }, [
        A("div", {
          id: "header",
          class: x([
            "spr-flex spr-items-center spr-justify-between spr-px-size-spacing-xs spr-py-size-spacing-sm",
            {
              "hover:spr-cursor-pointer": t.accordionTrigger === "header",
              "active:spr-background-color-pressed": o(i) === c && t.accordionTrigger === "header",
              "spr-rounded-t-border-radius-xl": o(i) === 0,
              "spr-rounded-b-border-radius-xl": o(i) === t.accordionItems.length - 1 && !o(r)[c]
            }
          ]),
          onMousedown: (p) => o(s)(c),
          onMouseup: u[0] || (u[0] = //@ts-ignore
          (...p) => o(a) && o(a)(...p)),
          onMouseleave: u[1] || (u[1] = //@ts-ignore
          (...p) => o(a) && o(a)(...p)),
          onClick: (p) => t.accordionTrigger === "header" && o(n)(c)
        }, [
          A("div", ji, [
            A("span", Ti, G(d.title), 1),
            d.subtitle ? (f(), C("span", Oi, G(d.subtitle), 1)) : _("", !0)
          ]),
          t.accordionTrigger === "button" ? (f(), K(be, {
            key: 0,
            variant: "secondary",
            "has-icon": "",
            size: "medium",
            class: "!spr-h-7 !spr-w-7 !spr-p-0",
            onClick: (p) => o(n)(c)
          }, {
            default: H(() => [
              R(o(W), {
                icon: o(r)[c] ? "ph:caret-up" : "ph:caret-down",
                width: "16",
                height: "16"
              }, null, 8, ["icon"])
            ]),
            _: 2
          }, 1032, ["onClick"])) : (f(), K(o(W), {
            key: 1,
            icon: o(r)[c] ? "ph:caret-up" : "ph:caret-down",
            width: "16",
            height: "16"
          }, null, 8, ["icon"]))
        ], 42, Si),
        R(ss, {
          modelValue: o(r)[c],
          "onUpdate:modelValue": (p) => o(r)[c] = p
        }, {
          default: H(() => [
            A("div", _i, [
              ee(l.$slots, d.collapseId)
            ])
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])
      ], 10, wi))), 128))
    ], 2));
  }
}), Li = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zi
}, Symbol.toStringTag, { value: "Module" })), ki = ["2xl", "xl", "lg", "md", "sm", "xs", "2xs"], Ei = ["primary", "secondary"], Pi = ["danger", "disabled", "information", "brand"], Yi = ["image", "initial", "client", "user", "user-group", "count"], Ui = {
  src: {
    type: String
  },
  alt: {
    type: String,
    default: "Avatar"
  },
  badge: {
    type: Boolean,
    default: !1
  },
  size: {
    type: String,
    validator: (e) => ki.includes(e),
    default: "2xl"
  },
  notification: {
    type: Boolean,
    default: !1
  },
  notificationText: {
    type: String,
    default: "0"
  },
  initial: {
    type: String,
    default: "Avatar"
  },
  color: {
    type: String,
    validator: (e) => Ei.includes(e),
    default: "primary"
  },
  status: {
    type: String,
    validator: (e) => Pi.includes(e),
    default: "brand"
  },
  count: {
    type: Number,
    default: 0
  },
  variant: {
    type: String,
    validator: (e) => Yi.includes(e),
    default: "initial"
  },
  loading: {
    type: Boolean,
    default: !1
  }
}, Fi = (e) => {
  const { size: t, color: r, variant: n, initial: s, loading: a } = ye(e), i = F(() => {
    const c = L("spr-relative spr-inline-block spr-rounded-full", {
      "spr-background-color-surface": r.value === "primary",
      "spr-background-color": r.value === "secondary",
      "spr-background-color spr-border-color-success-base spr-border spr-border-solid": r.value === "tertiary",
      "spr-skeletal-loader spr-h-full spr-w-full": a.value
    }), p = L(
      "avatar__slot spr-border-color-weak spr-border spr-border-solid",
      "spr-rounded-full spr-object-cover spr-flex spr-items-center spr-justify-center spr-overflow-hidden",
      {
        "spr-h-20 spr-min-w-20 spr-text-[36px]": t.value === "2xl",
        "spr-h-14 spr-min-w-14 spr-font-size-600": t.value === "xl",
        "spr-h-10 spr-min-w-10 spr-font-size-400": t.value === "lg",
        "spr-h-9 spr-min-w-9 spr-font-size-300": t.value === "md",
        "spr-h-6 spr-min-w-6 spr-font-size-200": t.value === "sm",
        "spr-h-5 spr-min-w-5 spr-text-[10px]": t.value === "xs",
        "spr-h-4 spr-min-w-4 spr-text-[10px]": t.value === "2xs"
      },
      // Image Size
      {
        "[&>img]:spr-h-20 [&>img]:spr-w-20 [&>img]:spr-min-h-20 [&>img]:spr-min-w-20": t.value === "2xl",
        "[&>img]:spr-h-14 [&>img]:spr-w-14 [&>img]:spr-min-h-14 [&>img]:spr-min-w-14": t.value === "xl",
        "[&>img]:spr-h-10 [&>img]:spr-w-10 [&>img]:spr-min-h-10 [&>img]:spr-min-w-10": t.value === "lg",
        "[&>img]:spr-h-9 [&>img]:spr-w-9 [&>img]:spr-min-h-9 [&>img]:spr-min-w-9": t.value === "md",
        "[&>img]:spr-h-6 [&>img]:spr-w-6 [&>img]:spr-min-h-6 [&>img]:spr-min-w-6": t.value === "sm",
        "[&>img]:spr-h-5 [&>img]:spr-w-5 [&>img]:spr-min-h-5 [&>img]:spr-min-w-5": t.value === "xs",
        "[&>img]:spr-h-4 [&>img]:spr-w-4 [&>img]:spr-min-h-4 [&>img]:spr-min-w-4": t.value === "2xs"
      }
    ), h = L(
      "spr-rounded-full spr-border-color-weak spr-border spr-border-solid spr-items-center spr-flex spr-justify-center spr-heading-xs spr-text-color-strong",
      {
        "spr-h-20 spr-min-w-20": t.value === "2xl",
        "spr-h-14 spr-min-w-14 spr-body-lg-regular-medium": t.value === "xl",
        "spr-h-10 spr-min-w-10 spr-body-sm-regular-medium": t.value === "lg",
        "spr-h-9 spr-min-w-9 spr-body-sm-regular-medium": t.value === "md",
        "spr-h-6 spr-min-w-6 spr-body-xs-regular-medium": t.value === "sm",
        "spr-h-5 spr-min-w-5 !spr-text-[10px]": t.value === "xs",
        "spr-h-4 spr-min-w-4 !spr-text-[10px]": t.value === "2xs"
      }
    ), y = L("spr-absolute spr-right-0 spr-top-0", {
      "spr-right-[-5px] spr-top-[-6.3px]": t.value === "xl",
      "spr-right-[-7px] spr-top-[-8px]": t.value === "lg",
      "spr-right-[-5px] spr-top-[-6px]": t.value === "md",
      "spr-right-[-7px] spr-top-[-7px]": t.value === "sm",
      "spr-right-[-5px] spr-top-[-4px]": t.value === "xs",
      "spr-right-[-4px] spr-top-[-4px]": t.value === "2xs"
    }), M = L("spr-absolute spr-bottom-0 spr-right-0", {
      "spr-bottom-0 spr-right-0": t.value === "xl" || t.value === "lg" || t.value === "md",
      "spr-bottom-[1px] spr-right-[1px]": t.value === "xl",
      "spr-bottom-[-3px] spr-right-[-4px]": t.value === "sm",
      "spr-bottom-[-4px] spr-right-[-3px]": t.value === "xs",
      "spr-bottom-[-2px] spr-right-[-4px]": t.value === "2xs"
    });
    return {
      baseClasses: c,
      imageContainerClasses: p,
      initialsContainerClasses: h,
      notificationClasses: y,
      onlineNotificationClasses: M
    };
  }), l = F(() => ["2xl"].includes(t.value) ? { notif: "big", badge: "big" } : ["xl", "lg"].includes(t.value) ? { notif: "big", badge: "tiny" } : ["md", "sm"].includes(t.value) ? { notif: "small", badge: "tiny" } : { notif: "tiny", badge: "tiny" }), u = F(() => {
    switch (n.value) {
      case "user-group":
        return "ph:users-three";
      case "user":
        return "ph:user";
      case "client":
        return "ph:building";
      case "admin":
        return "ph:shield-check";
      case "guest":
        return "ph:user-circle";
      default:
        return "";
    }
  }), d = F(() => {
    const c = ["xs", "2xs"].includes(t.value) ? 1 : 2;
    if (typeof s.value != "string" || s.value.trim().length === 0)
      return "";
    const p = s.value.trim().split(/\s+/);
    if (p.length === 1)
      return p[0].charAt(0).toUpperCase();
    const h = p[0].charAt(0).toUpperCase(), y = p[p.length - 1].charAt(0).toUpperCase();
    return (h + y).slice(0, c);
  });
  return {
    avatarClasses: i,
    getAvatarSize: l,
    getIconVariant: u,
    getInitials: d
  };
}, Bi = ["danger", "disabled", "information", "brand"], Ri = ["small", "big", "tiny"], Vi = ["top", "bottom", "default"], Qi = {
  /**
   * @description Badge Label
   */
  text: {
    type: String,
    default: "0"
  },
  /**
   * @description Badge variant
   */
  variant: {
    type: String,
    validator: (e) => Bi.includes(e),
    default: "brand"
  },
  /**
   * @description Badge size
   */
  size: {
    type: String,
    validator: (e) => Ri.includes(e),
    default: "small"
  },
  /**
   * @description Badge position (top, bottom, default)
   */
  position: {
    type: String,
    validator: (e) => Vi.includes(e),
    default: "default"
  }
}, Hi = (e) => {
  const { variant: t, size: r, position: n } = ye(e);
  return {
    badgeClasses: F(() => {
      const a = L({
        "spr-flex spr-items-center spr-gap-2": n.value === "default",
        "spr-relative": n.value === "top" || n.value === "bottom"
      }), i = L({
        "spr-background-color-danger-base spr-text-color-inverted-strong": t.value === "danger",
        "spr-background-color-disabled spr-text-color-on-fill-disabled": t.value === "disabled",
        "spr-background-color-information-base spr-text-color-inverted-strong": t.value === "information",
        "spr-background-color-brand-base spr-text-color-inverted-strong": t.value === "brand"
      }), l = L({
        "spr-label-sm-medium !spr-leading-[0] !spr-tracking-normal spr-h-[20px] spr-min-w-[20px] spr-rounded-[32px] spr-py-size-spacing-3xs spr-px-size-spacing-5xs spr-box-border": r.value === "big",
        "spr-label-xs-medium !spr-leading-[0] !spr-tracking-normal spr-h-[16px] spr-min-w-[16px] spr-rounded-[32px] spr-py-size-spacing-6xs spr-px-size-spacing-5xs spr-box-border": r.value === "small",
        "spr-h-[10px] spr-min-w-[10px] spr-rounded-full": r.value === "tiny"
      }), u = L({
        "spr-absolute -spr-top-1 spr-right-1": n.value === "top" && r.value === "tiny",
        "spr-absolute -spr-bottom-1 spr-right-1": n.value === "bottom" && r.value === "tiny",
        "spr-absolute -spr-top-2 -spr-right-1": n.value === "top" && r.value === "small",
        "spr-absolute -spr-bottom-2 -spr-right-1": n.value === "bottom" && r.value === "small",
        "spr-absolute -spr-top-3 -spr-right-2": n.value === "top" && r.value === "big",
        "spr-absolute -spr-bottom-3 -spr-right-2": n.value === "bottom" && r.value === "big"
      });
      return {
        baseClasses: a,
        variantClasses: i,
        sizeClasses: l,
        positionClasses: u
      };
    })
  };
}, Zi = { class: "spr-flex spr-gap-2" }, bt = /* @__PURE__ */ ae({
  __name: "badge",
  props: Qi,
  setup(e) {
    const t = e, { badgeClasses: r } = Hi(t);
    return (n, s) => (f(), C("div", Zi, [
      ee(n.$slots, "default"),
      A("div", {
        class: x(o(r).baseClasses)
      }, [
        A("section", {
          class: x(o(r).positionClasses)
        }, [
          A("div", {
            class: x([
              "spr-flex spr-items-center spr-justify-center",
              o(r).variantClasses,
              o(r).sizeClasses
            ])
          }, G(t.size === "tiny" ? "" : n.text), 3)
        ], 2)
      ], 2)
    ]));
  }
}), Gi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bt
}, Symbol.toStringTag, { value: "Module" })), Wi = { class: "spr-h-fit spr-w-fit" }, Ki = ["src", "alt"], Et = /* @__PURE__ */ ae({
  __name: "avatar",
  props: Ui,
  setup(e) {
    const t = e, { avatarClasses: r, getAvatarSize: n, getIconVariant: s, getInitials: a } = Fi(t);
    return (i, l) => (f(), C("div", Wi, [
      t.loading ? (f(), C("div", {
        key: 1,
        class: x(o(r).baseClasses)
      }, [
        A("div", {
          class: x(o(r).initialsContainerClasses)
        }, null, 2)
      ], 2)) : (f(), C("div", {
        key: 0,
        class: x(o(r).baseClasses)
      }, [
        ["image", "client", "user", "user-group"].includes(t.variant) || i.$slots.default ? (f(), C("div", {
          key: 0,
          class: x(o(r).imageContainerClasses)
        }, [
          ee(i.$slots, "default", {}, () => [
            i.src ? (f(), C("img", {
              key: 0,
              src: i.src,
              alt: i.alt,
              class: ""
            }, null, 8, Ki)) : (f(), K(o(W), {
              key: 1,
              icon: o(s)
            }, null, 8, ["icon"]))
          ])
        ], 2)) : (f(), C("div", {
          key: 1,
          class: x(o(r).initialsContainerClasses)
        }, G(t.variant === "count" ? `+${t.count}` : o(a)), 3)),
        t.notification ? (f(), C("span", {
          key: 2,
          class: x(o(r).notificationClasses)
        }, [
          R(bt, {
            text: t.notificationText,
            variant: "danger",
            size: o(n).notif
          }, null, 8, ["text", "size"])
        ], 2)) : _("", !0),
        t.badge ? (f(), C("span", {
          key: 3,
          class: x(o(r).onlineNotificationClasses)
        }, [
          R(bt, {
            variant: i.status,
            size: o(n).badge
          }, null, 8, ["variant", "size"])
        ], 2)) : _("", !0)
      ], 2))
    ]));
  }
}), Ji = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Et
}, Symbol.toStringTag, { value: "Module" })), Xi = ["success", "error", "info", "pending", "caution"], qi = {
  type: {
    type: String,
    validator: (e) => Xi.includes(e),
    default: "success"
  },
  showCloseButton: {
    type: Boolean,
    default: !1
  },
  message: {
    type: String
  }
}, el = (e, t) => {
  const r = () => t.value = !1, n = F(() => {
    const a = L(
      "spr-w-full spr-flex spr-flex-row spr-items-top spr-p-size-spacing-3xs spr-rounded-border-radius-md",
      {
        "spr-background-color-success-weak": e.type === "success",
        "spr-background-color-danger-weak": e.type === "error",
        "spr-background-color-information-weak": e.type === "info",
        "spr-background-color-pending-weak": e.type === "pending",
        "spr-background-color-caution-weak": e.type === "caution"
      }
    ), i = L(
      "spr-flex-auto"
    ), l = L(
      "spr-mt-[2px]",
      {
        "spr-text-color-brand-base": e.type === "success",
        "spr-text-color-danger-base": e.type === "error",
        "spr-text-color-information-base": e.type === "info",
        "spr-text-color-pending-base": e.type === "pending",
        "spr-text-color-caution-base": e.type === "caution"
      }
    ), u = L(
      "spr-body-sm-regular",
      {
        "spr-text-color-brand-base": e.type === "success",
        "spr-text-color-danger-pressed": e.type === "error",
        "spr-text-color-information-pressed": e.type === "info",
        "spr-text-color-pending-pressed": e.type === "pending",
        "spr-text-color-caution-pressed": e.type === "caution"
      }
    ), d = L(
      "spr-flex-none spr-cursor-pointer spr-mt-[2px]",
      {
        "spr-text-color-brand-base": e.type === "success",
        "spr-text-color-danger-base": e.type === "error",
        "spr-text-color-information-base": e.type === "info",
        "spr-text-color-pending-base": e.type === "pending",
        "spr-text-color-caution-base": e.type === "caution"
      }
    );
    return {
      base: a,
      content: i,
      icon: l,
      message: u,
      close: d
    };
  }), s = F(() => {
    switch (e.type) {
      case "success":
        return "ph:check-circle-fill";
      case "error":
        return "ph:warning-circle-fill";
      case "info":
        return "ph:info-fill";
      case "pending":
        return "ph:info-fill";
      case "caution":
        return "ph:warning-fill";
      default:
        return "";
    }
  });
  return {
    closeBanner: r,
    bannerClasses: n,
    bannerIcon: s
  };
}, tl = { class: "spr-flex spr-items-top spr-gap-size-spacing-3xs" }, rl = /* @__PURE__ */ ae({
  __name: "banner",
  props: /* @__PURE__ */ $a(qi, {
    show: { type: Boolean, default: !0, required: !0 },
    showModifiers: {}
  }),
  emits: ["update:show"],
  setup(e) {
    const t = e, r = Da(e, "show"), { bannerClasses: n, closeBanner: s, bannerIcon: a } = el(t, r);
    return (i, l) => r.value ? (f(), C("div", {
      key: 0,
      id: "spr-banner",
      class: x([o(n).base])
    }, [
      A("div", {
        class: x([o(n).content])
      }, [
        ee(i.$slots, "default", {}, () => [
          A("div", tl, [
            A("span", {
              class: x([o(n).icon])
            }, [
              R(o(W), {
                icon: o(a),
                width: "16px",
                height: "16px"
              }, null, 8, ["icon"])
            ], 2),
            A("span", {
              class: x([o(n).message])
            }, G(t.message), 3)
          ])
        ])
      ], 2),
      t.showCloseButton ? (f(), K(o(W), {
        key: 0,
        icon: "ph:x-bold",
        width: "16px",
        height: "16px",
        class: x([o(n).close]),
        onClick: o(s)
      }, null, 8, ["class", "onClick"])) : _("", !0)
    ], 2)) : _("", !0);
  }
}), nl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rl
}, Symbol.toStringTag, { value: "Module" })), sl = ["A-Z", "Z-A"], cs = [
  "auto",
  "auto-start",
  "auto-end",
  "top",
  "top-start",
  "top-end",
  "right",
  "right-start",
  "right-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "left",
  "left-start",
  "left-end"
], al = ["fixed", "absolute"], ol = {
  id: {
    type: String,
    required: !0
  },
  modelValue: {
    type: [String, Number, Object, Array],
    default: () => []
  },
  menuList: {
    type: Array,
    required: !0,
    default: []
  },
  textField: {
    type: String,
    default: "text",
    description: "Field name to use for display text when using dynamic object arrays"
  },
  valueField: {
    type: String,
    default: "value",
    description: "Field name to use for value when using dynamic object arrays"
  },
  searchString: {
    type: String,
    default: ""
  },
  multiSelect: {
    type: Boolean,
    default: !1
  },
  placement: {
    type: String,
    validator: (e) => cs.includes(e),
    default: "bottom"
  },
  groupItemsBy: {
    type: String,
    validator: (e) => e === void 0 || sl.includes(e)
  },
  wrapperPosition: {
    type: String,
    default: "relative"
  },
  width: {
    type: String,
    default: "100%"
  },
  popperWidth: {
    type: String,
    default: "100%"
  },
  popperInnerWidth: {
    type: String,
    default: "unset"
  },
  popperStrategy: {
    type: String,
    validator: (e) => al.includes(e),
    default: "absolute"
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  ladderized: {
    type: Boolean,
    default: !1
  },
  removeCurrentLevelInBackLabel: {
    type: Boolean,
    default: !1
  },
  noCheckInList: {
    type: Boolean,
    default: !1
  }
}, il = {
  "infinite-scroll-trigger": Boolean,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  "update:modelValue": (e) => !0
  // Accept any type of value
}, ll = ["primary", "secondary"], ul = ["neutral", "success"], dl = {
  modelValue: {
    type: Array,
    required: !0,
    default: []
  },
  ...as,
  // Inherit button properties
  tone: {
    type: String,
    validator: (e) => ul.includes(e),
    default: "neutral"
  },
  variant: {
    type: String,
    validator: (e) => ll.includes(e),
    default: "primary"
  },
  dropdownId: {
    type: String,
    required: !0
  },
  menuList: {
    type: Array,
    required: !0,
    default: []
  },
  placement: {
    type: String,
    validator: (e) => cs.includes(e),
    default: "bottom"
  },
  width: {
    type: String,
    default: "fit-content"
  },
  popperWidth: {
    type: String,
    default: "fit-content"
  },
  popperInnerWidth: {
    type: String,
    default: "unset"
  }
}, cl = ["click", "update:modelValue"], pl = (e, t) => {
  const { tone: r, variant: n, disabled: s } = ye(e), a = Ie(e, "modelValue", t), i = F(() => {
    const l = L("spr-rounded-r-none spr-border-r", {
      "!spr-border-solid spr-border-l-0 spr-border-t-0 spr-border-b-0": s.value && n.value !== "secondary",
      "spr-border-r-kangkong-800": r.value === "success" && !s.value,
      "spr-border-r-mushroom-200": r.value !== "success" || r.value === "success" && s.value
    }), u = L("spr-rounded-l-none", {
      "spr-border-solid spr-border-l-0": n.value === "secondary",
      "spr-border-l-transparent": n.value !== "secondary"
    });
    return { mainButtonClasses: l, dropdownButtonClasses: u };
  });
  return {
    selectedMenu: a,
    buttonDropdownClasses: i
  };
}, fl = ["top", "right", "bottom", "left"], kr = ["start", "end"], Er = /* @__PURE__ */ fl.reduce((e, t) => e.concat(t, t + "-" + kr[0], t + "-" + kr[1]), []), r2 = Math.min, yt = Math.max, gl = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, hl = {
  start: "end",
  end: "start"
};
function D0(e, t, r) {
  return yt(e, r2(t, r));
}
function At(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Xe(e) {
  return e.split("-")[0];
}
function He(e) {
  return e.split("-")[1];
}
function ps(e) {
  return e === "x" ? "y" : "x";
}
function X0(e) {
  return e === "y" ? "height" : "width";
}
function Nt(e) {
  return ["top", "bottom"].includes(Xe(e)) ? "y" : "x";
}
function q0(e) {
  return ps(Nt(e));
}
function fs(e, t, r) {
  r === void 0 && (r = !1);
  const n = He(e), s = q0(e), a = X0(s);
  let i = s === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = L2(i)), [i, L2(i)];
}
function yl(e) {
  const t = L2(e);
  return [z2(e), t, z2(t)];
}
function z2(e) {
  return e.replace(/start|end/g, (t) => hl[t]);
}
function Cl(e, t, r) {
  const n = ["left", "right"], s = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? s : n : t ? n : s;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function vl(e, t, r, n) {
  const s = He(e);
  let a = Cl(Xe(e), r === "start", n);
  return s && (a = a.map((i) => i + "-" + s), t && (a = a.concat(a.map(z2)))), a;
}
function L2(e) {
  return e.replace(/left|right|bottom|top/g, (t) => gl[t]);
}
function ml(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function gs(e) {
  return typeof e != "number" ? ml(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Wt(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: s
  } = e;
  return {
    width: n,
    height: s,
    top: r,
    left: t,
    right: t + n,
    bottom: r + s,
    x: t,
    y: r
  };
}
function Pr(e, t, r) {
  let {
    reference: n,
    floating: s
  } = e;
  const a = Nt(t), i = q0(t), l = X0(i), u = Xe(t), d = a === "y", c = n.x + n.width / 2 - s.width / 2, p = n.y + n.height / 2 - s.height / 2, h = n[l] / 2 - s[l] / 2;
  let y;
  switch (u) {
    case "top":
      y = {
        x: c,
        y: n.y - s.height
      };
      break;
    case "bottom":
      y = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      y = {
        x: n.x + n.width,
        y: p
      };
      break;
    case "left":
      y = {
        x: n.x - s.width,
        y: p
      };
      break;
    default:
      y = {
        x: n.x,
        y: n.y
      };
  }
  switch (He(t)) {
    case "start":
      y[i] -= h * (r && d ? -1 : 1);
      break;
    case "end":
      y[i] += h * (r && d ? -1 : 1);
      break;
  }
  return y;
}
const Ml = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: s = "absolute",
    middleware: a = [],
    platform: i
  } = r, l = a.filter(Boolean), u = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let d = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: c,
    y: p
  } = Pr(d, n, u), h = n, y = {}, M = 0;
  for (let g = 0; g < l.length; g++) {
    const {
      name: v,
      fn: m
    } = l[g], {
      x: I,
      y: N,
      data: w,
      reset: E
    } = await m({
      x: c,
      y: p,
      initialPlacement: n,
      placement: h,
      strategy: s,
      middlewareData: y,
      rects: d,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = I ?? c, p = N ?? p, y = {
      ...y,
      [v]: {
        ...y[v],
        ...w
      }
    }, E && M <= 50 && (M++, typeof E == "object" && (E.placement && (h = E.placement), E.rects && (d = E.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : E.rects), {
      x: c,
      y: p
    } = Pr(d, h, u)), g = -1);
  }
  return {
    x: c,
    y: p,
    placement: h,
    strategy: s,
    middlewareData: y
  };
};
async function K2(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: s,
    platform: a,
    rects: i,
    elements: l,
    strategy: u
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: p = "floating",
    altBoundary: h = !1,
    padding: y = 0
  } = At(t, e), M = gs(y), v = l[h ? p === "floating" ? "reference" : "floating" : p], m = Wt(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(v))) == null || r ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: d,
    rootBoundary: c,
    strategy: u
  })), I = p === "floating" ? {
    x: n,
    y: s,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, N = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), w = await (a.isElement == null ? void 0 : a.isElement(N)) ? await (a.getScale == null ? void 0 : a.getScale(N)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = Wt(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: I,
    offsetParent: N,
    strategy: u
  }) : I);
  return {
    top: (m.top - E.top + M.top) / w.y,
    bottom: (E.bottom - m.bottom + M.bottom) / w.y,
    left: (m.left - E.left + M.left) / w.x,
    right: (E.right - m.right + M.right) / w.x
  };
}
const bl = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: s,
      rects: a,
      platform: i,
      elements: l,
      middlewareData: u
    } = t, {
      element: d,
      padding: c = 0
    } = At(e, t) || {};
    if (d == null)
      return {};
    const p = gs(c), h = {
      x: r,
      y: n
    }, y = q0(s), M = X0(y), g = await i.getDimensions(d), v = y === "y", m = v ? "top" : "left", I = v ? "bottom" : "right", N = v ? "clientHeight" : "clientWidth", w = a.reference[M] + a.reference[y] - h[y] - a.floating[M], E = h[y] - a.reference[y], $ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(d));
    let D = $ ? $[N] : 0;
    (!D || !await (i.isElement == null ? void 0 : i.isElement($))) && (D = l.floating[N] || a.floating[M]);
    const z = w / 2 - E / 2, k = D / 2 - g[M] / 2 - 1, b = r2(p[m], k), P = r2(p[I], k), V = b, Z = D - g[M] - P, j = D / 2 - g[M] / 2 + z, T = D0(V, j, Z), O = !u.arrow && He(s) != null && j !== T && a.reference[M] / 2 - (j < V ? b : P) - g[M] / 2 < 0, S = O ? j < V ? j - V : j - Z : 0;
    return {
      [y]: h[y] + S,
      data: {
        [y]: T,
        centerOffset: j - T - S,
        ...O && {
          alignmentOffset: S
        }
      },
      reset: O
    };
  }
});
function Nl(e, t, r) {
  return (e ? [...r.filter((s) => He(s) === e), ...r.filter((s) => He(s) !== e)] : r.filter((s) => Xe(s) === s)).filter((s) => e ? He(s) === e || (t ? z2(s) !== s : !1) : !0);
}
const $l = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var r, n, s;
      const {
        rects: a,
        middlewareData: i,
        placement: l,
        platform: u,
        elements: d
      } = t, {
        crossAxis: c = !1,
        alignment: p,
        allowedPlacements: h = Er,
        autoAlignment: y = !0,
        ...M
      } = At(e, t), g = p !== void 0 || h === Er ? Nl(p || null, y, h) : h, v = await K2(t, M), m = ((r = i.autoPlacement) == null ? void 0 : r.index) || 0, I = g[m];
      if (I == null)
        return {};
      const N = fs(I, a, await (u.isRTL == null ? void 0 : u.isRTL(d.floating)));
      if (l !== I)
        return {
          reset: {
            placement: g[0]
          }
        };
      const w = [v[Xe(I)], v[N[0]], v[N[1]]], E = [...((n = i.autoPlacement) == null ? void 0 : n.overflows) || [], {
        placement: I,
        overflows: w
      }], $ = g[m + 1];
      if ($)
        return {
          data: {
            index: m + 1,
            overflows: E
          },
          reset: {
            placement: $
          }
        };
      const D = E.map((b) => {
        const P = He(b.placement);
        return [b.placement, P && c ? (
          // Check along the mainAxis and main crossAxis side.
          b.overflows.slice(0, 2).reduce((V, Z) => V + Z, 0)
        ) : (
          // Check only the mainAxis.
          b.overflows[0]
        ), b.overflows];
      }).sort((b, P) => b[1] - P[1]), k = ((s = D.filter((b) => b[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        He(b[0]) ? 2 : 3
      ).every((P) => P <= 0))[0]) == null ? void 0 : s[0]) || D[0][0];
      return k !== l ? {
        data: {
          index: m + 1,
          overflows: E
        },
        reset: {
          placement: k
        }
      } : {};
    }
  };
}, Dl = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: s,
        middlewareData: a,
        rects: i,
        initialPlacement: l,
        platform: u,
        elements: d
      } = t, {
        mainAxis: c = !0,
        crossAxis: p = !0,
        fallbackPlacements: h,
        fallbackStrategy: y = "bestFit",
        fallbackAxisSideDirection: M = "none",
        flipAlignment: g = !0,
        ...v
      } = At(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const m = Xe(s), I = Nt(l), N = Xe(l) === l, w = await (u.isRTL == null ? void 0 : u.isRTL(d.floating)), E = h || (N || !g ? [L2(l)] : yl(l)), $ = M !== "none";
      !h && $ && E.push(...vl(l, g, M, w));
      const D = [l, ...E], z = await K2(t, v), k = [];
      let b = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (c && k.push(z[m]), p) {
        const j = fs(s, i, w);
        k.push(z[j[0]], z[j[1]]);
      }
      if (b = [...b, {
        placement: s,
        overflows: k
      }], !k.every((j) => j <= 0)) {
        var P, V;
        const j = (((P = a.flip) == null ? void 0 : P.index) || 0) + 1, T = D[j];
        if (T)
          return {
            data: {
              index: j,
              overflows: b
            },
            reset: {
              placement: T
            }
          };
        let O = (V = b.filter((S) => S.overflows[0] <= 0).sort((S, Y) => S.overflows[1] - Y.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!O)
          switch (y) {
            case "bestFit": {
              var Z;
              const S = (Z = b.filter((Y) => {
                if ($) {
                  const U = Nt(Y.placement);
                  return U === I || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  U === "y";
                }
                return !0;
              }).map((Y) => [Y.placement, Y.overflows.filter((U) => U > 0).reduce((U, J) => U + J, 0)]).sort((Y, U) => Y[1] - U[1])[0]) == null ? void 0 : Z[0];
              S && (O = S);
              break;
            }
            case "initialPlacement":
              O = l;
              break;
          }
        if (s !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
async function Il(e, t) {
  const {
    placement: r,
    platform: n,
    elements: s
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(s.floating)), i = Xe(r), l = He(r), u = Nt(r) === "y", d = ["left", "top"].includes(i) ? -1 : 1, c = a && u ? -1 : 1, p = At(t, e);
  let {
    mainAxis: h,
    crossAxis: y,
    alignmentAxis: M
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return l && typeof M == "number" && (y = l === "end" ? M * -1 : M), u ? {
    x: y * c,
    y: h * d
  } : {
    x: h * d,
    y: y * c
  };
}
const Al = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: s,
        y: a,
        placement: i,
        middlewareData: l
      } = t, u = await Il(t, e);
      return i === ((r = l.offset) == null ? void 0 : r.placement) && (n = l.arrow) != null && n.alignmentOffset ? {} : {
        x: s + u.x,
        y: a + u.y,
        data: {
          ...u,
          placement: i
        }
      };
    }
  };
}, xl = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: s
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: l = {
          fn: (v) => {
            let {
              x: m,
              y: I
            } = v;
            return {
              x: m,
              y: I
            };
          }
        },
        ...u
      } = At(e, t), d = {
        x: r,
        y: n
      }, c = await K2(t, u), p = Nt(Xe(s)), h = ps(p);
      let y = d[h], M = d[p];
      if (a) {
        const v = h === "y" ? "top" : "left", m = h === "y" ? "bottom" : "right", I = y + c[v], N = y - c[m];
        y = D0(I, y, N);
      }
      if (i) {
        const v = p === "y" ? "top" : "left", m = p === "y" ? "bottom" : "right", I = M + c[v], N = M - c[m];
        M = D0(I, M, N);
      }
      const g = l.fn({
        ...t,
        [h]: y,
        [p]: M
      });
      return {
        ...g,
        data: {
          x: g.x - r,
          y: g.y - n,
          enabled: {
            [h]: a,
            [p]: i
          }
        }
      };
    }
  };
}, wl = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: s,
        rects: a,
        platform: i,
        elements: l
      } = t, {
        apply: u = () => {
        },
        ...d
      } = At(e, t), c = await K2(t, d), p = Xe(s), h = He(s), y = Nt(s) === "y", {
        width: M,
        height: g
      } = a.floating;
      let v, m;
      p === "top" || p === "bottom" ? (v = p, m = h === (await (i.isRTL == null ? void 0 : i.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (m = p, v = h === "end" ? "top" : "bottom");
      const I = g - c.top - c.bottom, N = M - c.left - c.right, w = r2(g - c[v], I), E = r2(M - c[m], N), $ = !t.middlewareData.shift;
      let D = w, z = E;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (z = N), (n = t.middlewareData.shift) != null && n.enabled.y && (D = I), $ && !h) {
        const b = yt(c.left, 0), P = yt(c.right, 0), V = yt(c.top, 0), Z = yt(c.bottom, 0);
        y ? z = M - 2 * (b !== 0 || P !== 0 ? b + P : yt(c.left, c.right)) : D = g - 2 * (V !== 0 || Z !== 0 ? V + Z : yt(c.top, c.bottom));
      }
      await u({
        ...t,
        availableWidth: z,
        availableHeight: D
      });
      const k = await i.getDimensions(l.floating);
      return M !== k.width || g !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Fe(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ge(e) {
  return Fe(e).getComputedStyle(e);
}
const Yr = Math.min, Kt = Math.max, k2 = Math.round;
function hs(e) {
  const t = Ge(e);
  let r = parseFloat(t.width), n = parseFloat(t.height);
  const s = e.offsetWidth, a = e.offsetHeight, i = k2(r) !== s || k2(n) !== a;
  return i && (r = s, n = a), { width: r, height: n, fallback: i };
}
function ft(e) {
  return Cs(e) ? (e.nodeName || "").toLowerCase() : "";
}
let h2;
function ys() {
  if (h2) return h2;
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? (h2 = e.brands.map((t) => t.brand + "/" + t.version).join(" "), h2) : navigator.userAgent;
}
function We(e) {
  return e instanceof Fe(e).HTMLElement;
}
function ut(e) {
  return e instanceof Fe(e).Element;
}
function Cs(e) {
  return e instanceof Fe(e).Node;
}
function Ur(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof Fe(e).ShadowRoot || e instanceof ShadowRoot;
}
function J2(e) {
  const { overflow: t, overflowX: r, overflowY: n, display: s } = Ge(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(s);
}
function Sl(e) {
  return ["table", "td", "th"].includes(ft(e));
}
function I0(e) {
  const t = /firefox/i.test(ys()), r = Ge(e), n = r.backdropFilter || r.WebkitBackdropFilter;
  return r.transform !== "none" || r.perspective !== "none" || !!n && n !== "none" || t && r.willChange === "filter" || t && !!r.filter && r.filter !== "none" || ["transform", "perspective"].some((s) => r.willChange.includes(s)) || ["paint", "layout", "strict", "content"].some((s) => {
    const a = r.contain;
    return a != null && a.includes(s);
  });
}
function vs() {
  return !/^((?!chrome|android).)*safari/i.test(ys());
}
function er(e) {
  return ["html", "body", "#document"].includes(ft(e));
}
function ms(e) {
  return ut(e) ? e : e.contextElement;
}
const Ms = { x: 1, y: 1 };
function Ot(e) {
  const t = ms(e);
  if (!We(t)) return Ms;
  const r = t.getBoundingClientRect(), { width: n, height: s, fallback: a } = hs(t);
  let i = (a ? k2(r.width) : r.width) / n, l = (a ? k2(r.height) : r.height) / s;
  return i && Number.isFinite(i) || (i = 1), l && Number.isFinite(l) || (l = 1), { x: i, y: l };
}
function n2(e, t, r, n) {
  var s, a;
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const i = e.getBoundingClientRect(), l = ms(e);
  let u = Ms;
  t && (n ? ut(n) && (u = Ot(n)) : u = Ot(e));
  const d = l ? Fe(l) : window, c = !vs() && r;
  let p = (i.left + (c && ((s = d.visualViewport) == null ? void 0 : s.offsetLeft) || 0)) / u.x, h = (i.top + (c && ((a = d.visualViewport) == null ? void 0 : a.offsetTop) || 0)) / u.y, y = i.width / u.x, M = i.height / u.y;
  if (l) {
    const g = Fe(l), v = n && ut(n) ? Fe(n) : n;
    let m = g.frameElement;
    for (; m && n && v !== g; ) {
      const I = Ot(m), N = m.getBoundingClientRect(), w = getComputedStyle(m);
      N.x += (m.clientLeft + parseFloat(w.paddingLeft)) * I.x, N.y += (m.clientTop + parseFloat(w.paddingTop)) * I.y, p *= I.x, h *= I.y, y *= I.x, M *= I.y, p += N.x, h += N.y, m = Fe(m).frameElement;
    }
  }
  return { width: y, height: M, top: h, right: p + y, bottom: h + M, left: p, x: p, y: h };
}
function dt(e) {
  return ((Cs(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function X2(e) {
  return ut(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function bs(e) {
  return n2(dt(e)).left + X2(e).scrollLeft;
}
function s2(e) {
  if (ft(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || Ur(e) && e.host || dt(e);
  return Ur(t) ? t.host : t;
}
function Ns(e) {
  const t = s2(e);
  return er(t) ? t.ownerDocument.body : We(t) && J2(t) ? t : Ns(t);
}
function E2(e, t) {
  var r;
  t === void 0 && (t = []);
  const n = Ns(e), s = n === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Fe(n);
  return s ? t.concat(a, a.visualViewport || [], J2(n) ? n : []) : t.concat(n, E2(n));
}
function Fr(e, t, r) {
  return t === "viewport" ? Wt(function(n, s) {
    const a = Fe(n), i = dt(n), l = a.visualViewport;
    let u = i.clientWidth, d = i.clientHeight, c = 0, p = 0;
    if (l) {
      u = l.width, d = l.height;
      const h = vs();
      (h || !h && s === "fixed") && (c = l.offsetLeft, p = l.offsetTop);
    }
    return { width: u, height: d, x: c, y: p };
  }(e, r)) : ut(t) ? Wt(function(n, s) {
    const a = n2(n, !0, s === "fixed"), i = a.top + n.clientTop, l = a.left + n.clientLeft, u = We(n) ? Ot(n) : { x: 1, y: 1 };
    return { width: n.clientWidth * u.x, height: n.clientHeight * u.y, x: l * u.x, y: i * u.y };
  }(t, r)) : Wt(function(n) {
    const s = dt(n), a = X2(n), i = n.ownerDocument.body, l = Kt(s.scrollWidth, s.clientWidth, i.scrollWidth, i.clientWidth), u = Kt(s.scrollHeight, s.clientHeight, i.scrollHeight, i.clientHeight);
    let d = -a.scrollLeft + bs(n);
    const c = -a.scrollTop;
    return Ge(i).direction === "rtl" && (d += Kt(s.clientWidth, i.clientWidth) - l), { width: l, height: u, x: d, y: c };
  }(dt(e)));
}
function Br(e) {
  return We(e) && Ge(e).position !== "fixed" ? e.offsetParent : null;
}
function Rr(e) {
  const t = Fe(e);
  let r = Br(e);
  for (; r && Sl(r) && Ge(r).position === "static"; ) r = Br(r);
  return r && (ft(r) === "html" || ft(r) === "body" && Ge(r).position === "static" && !I0(r)) ? t : r || function(n) {
    let s = s2(n);
    for (; We(s) && !er(s); ) {
      if (I0(s)) return s;
      s = s2(s);
    }
    return null;
  }(e) || t;
}
function jl(e, t, r) {
  const n = We(t), s = dt(t), a = n2(e, !0, r === "fixed", t);
  let i = { scrollLeft: 0, scrollTop: 0 };
  const l = { x: 0, y: 0 };
  if (n || !n && r !== "fixed") if ((ft(t) !== "body" || J2(s)) && (i = X2(t)), We(t)) {
    const u = n2(t, !0);
    l.x = u.x + t.clientLeft, l.y = u.y + t.clientTop;
  } else s && (l.x = bs(s));
  return { x: a.left + i.scrollLeft - l.x, y: a.top + i.scrollTop - l.y, width: a.width, height: a.height };
}
const Tl = { getClippingRect: function(e) {
  let { element: t, boundary: r, rootBoundary: n, strategy: s } = e;
  const a = r === "clippingAncestors" ? function(d, c) {
    const p = c.get(d);
    if (p) return p;
    let h = E2(d).filter((v) => ut(v) && ft(v) !== "body"), y = null;
    const M = Ge(d).position === "fixed";
    let g = M ? s2(d) : d;
    for (; ut(g) && !er(g); ) {
      const v = Ge(g), m = I0(g);
      (M ? m || y : m || v.position !== "static" || !y || !["absolute", "fixed"].includes(y.position)) ? y = v : h = h.filter((I) => I !== g), g = s2(g);
    }
    return c.set(d, h), h;
  }(t, this._c) : [].concat(r), i = [...a, n], l = i[0], u = i.reduce((d, c) => {
    const p = Fr(t, c, s);
    return d.top = Kt(p.top, d.top), d.right = Yr(p.right, d.right), d.bottom = Yr(p.bottom, d.bottom), d.left = Kt(p.left, d.left), d;
  }, Fr(t, l, s));
  return { width: u.right - u.left, height: u.bottom - u.top, x: u.left, y: u.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: r, strategy: n } = e;
  const s = We(r), a = dt(r);
  if (r === a) return t;
  let i = { scrollLeft: 0, scrollTop: 0 }, l = { x: 1, y: 1 };
  const u = { x: 0, y: 0 };
  if ((s || !s && n !== "fixed") && ((ft(r) !== "body" || J2(a)) && (i = X2(r)), We(r))) {
    const d = n2(r);
    l = Ot(r), u.x = d.x + r.clientLeft, u.y = d.y + r.clientTop;
  }
  return { width: t.width * l.x, height: t.height * l.y, x: t.x * l.x - i.scrollLeft * l.x + u.x, y: t.y * l.y - i.scrollTop * l.y + u.y };
}, isElement: ut, getDimensions: function(e) {
  return We(e) ? hs(e) : e.getBoundingClientRect();
}, getOffsetParent: Rr, getDocumentElement: dt, getScale: Ot, async getElementRects(e) {
  let { reference: t, floating: r, strategy: n } = e;
  const s = this.getOffsetParent || Rr, a = this.getDimensions;
  return { reference: jl(t, await s(r), n), floating: { x: 0, y: 0, ...await a(r) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => Ge(e).direction === "rtl" }, Ol = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), s = { platform: Tl, ...r }, a = { ...s.platform, _c: n };
  return Ml(e, t, { ...s, platform: a });
}, vt = {
  // Disable popper components
  disabled: !1,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: !1,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 150,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: !0,
  // Flip to the opposite placement if needed
  flip: !0,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: !0,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: !0,
  /**
   * By default, compute autohide on 'click'.
   */
  autoHideOnMousedown: !1,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (e) => [...e, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: !1,
      // Enable HTML content in directive
      html: !1,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: !0,
      // Hide on clock outside
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function A0(e, t) {
  let r = vt.themes[e] || {}, n;
  do
    n = r[t], typeof n > "u" ? r.$extend ? r = vt.themes[r.$extend] || {} : (r = null, n = vt[t]) : r = null;
  while (r);
  return n;
}
function _l(e) {
  const t = [e];
  let r = vt.themes[e] || {};
  do
    r.$extend && !r.$resetCss ? (t.push(r.$extend), r = vt.themes[r.$extend] || {}) : r = null;
  while (r);
  return t.map((n) => `v-popper--theme-${n}`);
}
function Vr(e) {
  const t = [e];
  let r = vt.themes[e] || {};
  do
    r.$extend ? (t.push(r.$extend), r = vt.themes[r.$extend] || {}) : r = null;
  while (r);
  return t;
}
let a2 = !1;
if (typeof window < "u") {
  a2 = !1;
  try {
    const e = Object.defineProperty({}, "passive", {
      get() {
        a2 = !0;
      }
    });
    window.addEventListener("test", null, e);
  } catch {
  }
}
let $s = !1;
typeof window < "u" && typeof navigator < "u" && ($s = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const zl = ["auto", "top", "bottom", "left", "right"].reduce((e, t) => e.concat([
  t,
  `${t}-start`,
  `${t}-end`
]), []), Qr = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, Hr = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function Zr(e, t) {
  const r = e.indexOf(t);
  r !== -1 && e.splice(r, 1);
}
function c0() {
  return new Promise((e) => requestAnimationFrame(() => {
    requestAnimationFrame(e);
  }));
}
const Qe = [];
let ht = null;
const Gr = {};
function Wr(e) {
  let t = Gr[e];
  return t || (t = Gr[e] = []), t;
}
let x0 = function() {
};
typeof window < "u" && (x0 = window.Element);
function he(e) {
  return function(t) {
    return A0(t.theme, e);
  };
}
const p0 = "__floating-vue__popper", Ds = () => ae({
  name: "VPopper",
  provide() {
    return {
      [p0]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [p0]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: he("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: he("positioningDisabled")
    },
    placement: {
      type: String,
      default: he("placement"),
      validator: (e) => zl.includes(e)
    },
    delay: {
      type: [String, Number, Object],
      default: he("delay")
    },
    distance: {
      type: [Number, String],
      default: he("distance")
    },
    skidding: {
      type: [Number, String],
      default: he("skidding")
    },
    triggers: {
      type: Array,
      default: he("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: he("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: he("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: he("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: he("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: he("popperHideTriggers")
    },
    container: {
      type: [String, Object, x0, Boolean],
      default: he("container")
    },
    boundary: {
      type: [String, x0],
      default: he("boundary")
    },
    strategy: {
      type: String,
      validator: (e) => ["absolute", "fixed"].includes(e),
      default: he("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: he("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: he("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: he("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: he("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: he("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: he("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: he("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: he("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: he("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: he("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: he("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: he("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: he("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: he("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: he("flip")
    },
    shift: {
      type: Boolean,
      default: he("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: he("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: he("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: he("disposeTimeout")
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      randomId: `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join("_")}`,
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0,
      pendingHide: !1,
      containsGlobalTarget: !1,
      isDisposed: !0,
      mouseDownContains: !1
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var e;
      return (e = this[p0]) == null ? void 0 : e.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var e, t;
      return ((e = this.popperTriggers) == null ? void 0 : e.includes("hover")) || ((t = this.popperShowTriggers) == null ? void 0 : t.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(e) {
      e ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    triggers: {
      handler: "$_refreshListeners",
      deep: !0
    },
    positioningDisabled: "$_refreshListeners",
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((e, t) => (e[t] = "$_computePosition", e), {})
  },
  created() {
    this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: e = null, skipDelay: t = !1, force: r = !1 } = {}) {
      var n, s;
      (n = this.parentPopper) != null && n.lockedChild && this.parentPopper.lockedChild !== this || (this.pendingHide = !1, (r || !this.disabled) && (((s = this.parentPopper) == null ? void 0 : s.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(e, t), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: e = null, skipDelay: t = !1 } = {}) {
      var r;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: t }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((r = this.parentPopper) == null ? void 0 : r.lockedChild) === this && (this.parentPopper.lockedChild = null), this.pendingHide = !1, this.$_scheduleHide(e, t), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var e;
      this.isDisposed && (this.isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = ((e = this.referenceNode) == null ? void 0 : e.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((t) => t.nodeType === t.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.isDisposed || (this.isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.isDisposed || this.positioningDisabled)
        return;
      const e = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && e.middleware.push(Al({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const t = this.placement.startsWith("auto");
      if (t ? e.middleware.push($l({
        alignment: this.placement.split("-")[1] ?? ""
      })) : e.placement = this.placement, this.preventOverflow && (this.shift && e.middleware.push(xl({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !t && this.flip && e.middleware.push(Dl({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), e.middleware.push(bl({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && e.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: n, rects: s, middlewareData: a }) => {
          let i;
          const { centerOffset: l } = a.arrow;
          return n.startsWith("top") || n.startsWith("bottom") ? i = Math.abs(l) > s.reference.width / 2 : i = Math.abs(l) > s.reference.height / 2, {
            data: {
              overflow: i
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const n = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        e.middleware.push({
          name: "autoSize",
          fn: ({ rects: s, placement: a, middlewareData: i }) => {
            var l;
            if ((l = i.autoSize) != null && l.skip)
              return {};
            let u, d;
            return a.startsWith("top") || a.startsWith("bottom") ? u = s.reference.width : d = s.reference.height, this.$_innerNode.style[n === "min" ? "minWidth" : n === "max" ? "maxWidth" : "width"] = u != null ? `${u}px` : null, this.$_innerNode.style[n === "min" ? "minHeight" : n === "max" ? "maxHeight" : "height"] = d != null ? `${d}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, e.middleware.push(wl({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: n, availableHeight: s }) => {
          this.$_innerNode.style.maxWidth = n != null ? `${n}px` : null, this.$_innerNode.style.maxHeight = s != null ? `${s}px` : null;
        }
      })));
      const r = await Ol(this.$_referenceNode, this.$_popperNode, e);
      Object.assign(this.result, {
        x: r.x,
        y: r.y,
        placement: r.placement,
        strategy: r.strategy,
        arrow: {
          ...r.middlewareData.arrow,
          ...r.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(e, t = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), ht && this.instantMove && ht.instantMove && ht !== this.parentPopper) {
        ht.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      t ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(e, t = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (ht = this), t ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(e) {
      const t = this.delay;
      return parseInt(t && t[e] || t || 0);
    },
    async $_applyShow(e = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = e, !this.isShown && (this.$_ensureTeleport(), await c0(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...E2(this.$_referenceNode),
        ...E2(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const t = this.$_referenceNode.getBoundingClientRect(), r = this.$_popperNode.querySelector(".v-popper__wrapper"), n = r.parentNode.getBoundingClientRect(), s = t.x + t.width / 2 - (n.left + r.offsetLeft), a = t.y + t.height / 2 - (n.top + r.offsetTop);
        this.result.transformOrigin = `${s}px ${a}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const e = this.showGroup;
      if (e) {
        let t;
        for (let r = 0; r < Qe.length; r++)
          t = Qe[r], t.showGroup !== e && (t.hide(), t.$emit("close-group"));
      }
      Qe.push(this), document.body.classList.add("v-popper--some-open");
      for (const t of Vr(this.theme))
        Wr(t).push(this), document.body.classList.add(`v-popper--some-open--${t}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await c0(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(e = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = e, Zr(Qe, this), Qe.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const r of Vr(this.theme)) {
        const n = Wr(r);
        Zr(n, this), n.length === 0 && document.body.classList.remove(`v-popper--some-open--${r}`);
      }
      ht === this && (ht = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const t = this.disposeTimeout;
      t !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, t)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await c0(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.isDisposed)
        return;
      let e = this.container;
      if (typeof e == "string" ? e = window.document.querySelector(e) : e === !1 && (e = this.$_targetNodes[0].parentNode), !e)
        throw new Error("No container for popover: " + this.container);
      e.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const e = (r) => {
        this.isShown && !this.$_hideInProgress || (r.usedByTooltip = !0, !this.$_preventShow && this.show({ event: r }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Qr, this.triggers, this.showTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], Qr, this.popperTriggers, this.popperShowTriggers, e);
      const t = (r) => {
        r.usedByTooltip || this.hide({ event: r });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Hr, this.triggers, this.hideTriggers, t), this.$_registerTriggerListeners([this.$_popperNode], Hr, this.popperTriggers, this.popperHideTriggers, t);
    },
    $_registerEventListeners(e, t, r) {
      this.$_events.push({ targetNodes: e, eventType: t, handler: r }), e.forEach((n) => n.addEventListener(t, r, a2 ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(e, t, r, n, s) {
      let a = r;
      n != null && (a = typeof n == "function" ? n(a) : n), a.forEach((i) => {
        const l = t[i];
        l && this.$_registerEventListeners(e, l, s);
      });
    },
    $_removeEventListeners(e) {
      const t = [];
      this.$_events.forEach((r) => {
        const { targetNodes: n, eventType: s, handler: a } = r;
        !e || e === s ? n.forEach((i) => i.removeEventListener(s, a)) : t.push(r);
      }), this.$_events = t;
    },
    $_refreshListeners() {
      this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(e, t = !1) {
      this.$_showFrameLocked || (this.hide({ event: e }), e.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), t && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(e, t) {
      for (const r of this.$_targetNodes) {
        const n = r.getAttribute(e);
        n && (r.removeAttribute(e), r.setAttribute(t, n));
      }
    },
    $_applyAttrsToTarget(e) {
      for (const t of this.$_targetNodes)
        for (const r in e) {
          const n = e[r];
          n == null ? t.removeAttribute(r) : t.setAttribute(r, n);
        }
    },
    $_updateParentShownChildren(e) {
      let t = this.parentPopper;
      for (; t; )
        e ? t.shownChildren.add(this.randomId) : (t.shownChildren.delete(this.randomId), t.pendingHide && t.hide()), t = t.parentPopper;
    },
    $_isAimingPopper() {
      const e = this.$_referenceNode.getBoundingClientRect();
      if (Jt >= e.left && Jt <= e.right && Xt >= e.top && Xt <= e.bottom) {
        const t = this.$_popperNode.getBoundingClientRect(), r = Jt - st, n = Xt - at, s = t.left + t.width / 2 - st + (t.top + t.height / 2) - at + t.width + t.height, a = st + r * s, i = at + n * s;
        return y2(st, at, a, i, t.left, t.top, t.left, t.bottom) || // Left edge
        y2(st, at, a, i, t.left, t.top, t.right, t.top) || // Top edge
        y2(st, at, a, i, t.right, t.top, t.right, t.bottom) || // Right edge
        y2(st, at, a, i, t.left, t.bottom, t.right, t.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
if (typeof document < "u" && typeof window < "u") {
  if ($s) {
    const e = a2 ? {
      passive: !0,
      capture: !0
    } : !0;
    document.addEventListener("touchstart", (t) => Kr(t), e), document.addEventListener("touchend", (t) => Jr(t, !0), e);
  } else
    window.addEventListener("mousedown", (e) => Kr(e), !0), window.addEventListener("click", (e) => Jr(e, !1), !0);
  window.addEventListener("resize", El);
}
function Kr(e, t) {
  for (let r = 0; r < Qe.length; r++) {
    const n = Qe[r];
    try {
      n.mouseDownContains = n.popperNode().contains(e.target);
    } catch {
    }
  }
}
function Jr(e, t) {
  Ll(e, t);
}
function Ll(e, t) {
  const r = {};
  for (let n = Qe.length - 1; n >= 0; n--) {
    const s = Qe[n];
    try {
      const a = s.containsGlobalTarget = s.mouseDownContains || s.popperNode().contains(e.target);
      s.pendingHide = !1, requestAnimationFrame(() => {
        if (s.pendingHide = !1, !r[s.randomId] && Xr(s, a, e)) {
          if (s.$_handleGlobalClose(e, t), !e.closeAllPopover && e.closePopover && a) {
            let l = s.parentPopper;
            for (; l; )
              r[l.randomId] = !0, l = l.parentPopper;
            return;
          }
          let i = s.parentPopper;
          for (; i && Xr(i, i.containsGlobalTarget, e); )
            i.$_handleGlobalClose(e, t), i = i.parentPopper;
        }
      });
    } catch {
    }
  }
}
function Xr(e, t, r) {
  return r.closeAllPopover || r.closePopover && t || kl(e, r) && !t;
}
function kl(e, t) {
  if (typeof e.autoHide == "function") {
    const r = e.autoHide(t);
    return e.lastAutoHide = r, r;
  }
  return e.autoHide;
}
function El() {
  for (let e = 0; e < Qe.length; e++)
    Qe[e].$_computePosition();
}
let st = 0, at = 0, Jt = 0, Xt = 0;
typeof window < "u" && window.addEventListener("mousemove", (e) => {
  st = Jt, at = Xt, Jt = e.clientX, Xt = e.clientY;
}, a2 ? {
  passive: !0
} : void 0);
function y2(e, t, r, n, s, a, i, l) {
  const u = ((i - s) * (t - a) - (l - a) * (e - s)) / ((l - a) * (r - e) - (i - s) * (n - t)), d = ((r - e) * (t - a) - (n - t) * (e - s)) / ((l - a) * (r - e) - (i - s) * (n - t));
  return u >= 0 && u <= 1 && d >= 0 && d <= 1;
}
const Pl = {
  extends: Ds()
}, tr = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, s] of t)
    r[n] = s;
  return r;
};
function Yl(e, t, r, n, s, a) {
  return f(), C("div", {
    ref: "reference",
    class: x(["v-popper", {
      "v-popper--shown": e.slotData.isShown
    }])
  }, [
    ee(e.$slots, "default", Q2(H2(e.slotData)))
  ], 2);
}
const Ul = /* @__PURE__ */ tr(Pl, [["render", Yl]]);
function Fl() {
  var e = window.navigator.userAgent, t = e.indexOf("MSIE ");
  if (t > 0)
    return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
  var r = e.indexOf("Trident/");
  if (r > 0) {
    var n = e.indexOf("rv:");
    return parseInt(e.substring(n + 3, e.indexOf(".", n)), 10);
  }
  var s = e.indexOf("Edge/");
  return s > 0 ? parseInt(e.substring(s + 5, e.indexOf(".", s)), 10) : -1;
}
let N2;
function w0() {
  w0.init || (w0.init = !0, N2 = Fl() !== -1);
}
var q2 = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    w0(), Je(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", N2 && this.$el.appendChild(e), e.data = "about:blank", N2 || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!N2 && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const Bl = /* @__PURE__ */ xa("data-v-b329ee4c");
Ia("data-v-b329ee4c");
const Rl = {
  class: "resize-observer",
  tabindex: "-1"
};
Aa();
const Vl = /* @__PURE__ */ Bl((e, t, r, n, s, a) => (f(), K("div", Rl)));
q2.render = Vl;
q2.__scopeId = "data-v-b329ee4c";
q2.__file = "src/components/ResizeObserver.vue";
const Is = (e = "theme") => ({
  computed: {
    themeClass() {
      return _l(this[e]);
    }
  }
}), Ql = ae({
  name: "VPopperContent",
  components: {
    ResizeObserver: q2
  },
  mixins: [
    Is()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(e) {
      return e != null && !isNaN(e) ? `${e}px` : null;
    }
  }
}), Hl = ["id", "aria-hidden", "tabindex", "data-popper-placement"], Zl = {
  ref: "inner",
  class: "v-popper__inner"
}, Gl = /* @__PURE__ */ A("div", { class: "v-popper__arrow-outer" }, null, -1), Wl = /* @__PURE__ */ A("div", { class: "v-popper__arrow-inner" }, null, -1), Kl = [
  Gl,
  Wl
];
function Jl(e, t, r, n, s, a) {
  const i = v0("ResizeObserver");
  return f(), C("div", {
    id: e.popperId,
    ref: "popover",
    class: x(["v-popper__popper", [
      e.themeClass,
      e.classes.popperClass,
      {
        "v-popper__popper--shown": e.shown,
        "v-popper__popper--hidden": !e.shown,
        "v-popper__popper--show-from": e.classes.showFrom,
        "v-popper__popper--show-to": e.classes.showTo,
        "v-popper__popper--hide-from": e.classes.hideFrom,
        "v-popper__popper--hide-to": e.classes.hideTo,
        "v-popper__popper--skip-transition": e.skipTransition,
        "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
        "v-popper__popper--no-positioning": !e.result
      }
    ]]),
    style: De(e.result ? {
      position: e.result.strategy,
      transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`
    } : void 0),
    "aria-hidden": e.shown ? "false" : "true",
    tabindex: e.autoHide ? 0 : void 0,
    "data-popper-placement": e.result ? e.result.placement : void 0,
    onKeyup: t[2] || (t[2] = m0((l) => e.autoHide && e.$emit("hide"), ["esc"]))
  }, [
    A("div", {
      class: "v-popper__backdrop",
      onClick: t[0] || (t[0] = (l) => e.autoHide && e.$emit("hide"))
    }),
    A("div", {
      class: "v-popper__wrapper",
      style: De(e.result ? {
        transformOrigin: e.result.transformOrigin
      } : void 0)
    }, [
      A("div", Zl, [
        e.mounted ? (f(), C(X, { key: 0 }, [
          A("div", null, [
            ee(e.$slots, "default")
          ]),
          e.handleResize ? (f(), K(i, {
            key: 0,
            onNotify: t[1] || (t[1] = (l) => e.$emit("resize", l))
          })) : _("", !0)
        ], 64)) : _("", !0)
      ], 512),
      A("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: De(e.result ? {
          left: e.toPx(e.result.arrow.x),
          top: e.toPx(e.result.arrow.y)
        } : void 0)
      }, Kl, 4)
    ], 4)
  ], 46, Hl);
}
const As = /* @__PURE__ */ tr(Ql, [["render", Jl]]), xs = {
  methods: {
    show(...e) {
      return this.$refs.popper.show(...e);
    },
    hide(...e) {
      return this.$refs.popper.hide(...e);
    },
    dispose(...e) {
      return this.$refs.popper.dispose(...e);
    },
    onResize(...e) {
      return this.$refs.popper.onResize(...e);
    }
  }
};
let S0 = function() {
};
typeof window < "u" && (S0 = window.Element);
const Xl = ae({
  name: "VPopperWrapper",
  components: {
    Popper: Ul,
    PopperContent: As
  },
  mixins: [
    xs,
    Is("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    },
    referenceNode: {
      type: Function,
      default: null
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    delay: {
      type: [String, Number, Object],
      default: void 0
    },
    distance: {
      type: [Number, String],
      default: void 0
    },
    skidding: {
      type: [Number, String],
      default: void 0
    },
    triggers: {
      type: Array,
      default: void 0
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperTriggers: {
      type: Array,
      default: void 0
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    container: {
      type: [String, Object, S0, Boolean],
      default: void 0
    },
    boundary: {
      type: [String, S0],
      default: void 0
    },
    strategy: {
      type: String,
      default: void 0
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0
    },
    handleResize: {
      type: Boolean,
      default: void 0
    },
    instantMove: {
      type: Boolean,
      default: void 0
    },
    eagerMount: {
      type: Boolean,
      default: void 0
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: void 0
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: void 0
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0
    },
    preventOverflow: {
      type: Boolean,
      default: void 0
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: void 0
    },
    shift: {
      type: Boolean,
      default: void 0
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0
    },
    disposeTimeout: {
      type: Number,
      default: void 0
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    }
  }
});
function ql(e, t, r, n, s, a) {
  const i = v0("PopperContent"), l = v0("Popper");
  return f(), K(l, Ye({ ref: "popper" }, e.$props, {
    theme: e.finalTheme,
    "target-nodes": e.getTargetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    class: [
      e.themeClass
    ],
    onShow: t[0] || (t[0] = () => e.$emit("show")),
    onHide: t[1] || (t[1] = () => e.$emit("hide")),
    "onUpdate:shown": t[2] || (t[2] = (u) => e.$emit("update:shown", u)),
    onApplyShow: t[3] || (t[3] = () => e.$emit("apply-show")),
    onApplyHide: t[4] || (t[4] = () => e.$emit("apply-hide")),
    onCloseGroup: t[5] || (t[5] = () => e.$emit("close-group")),
    onCloseDirective: t[6] || (t[6] = () => e.$emit("close-directive")),
    onAutoHide: t[7] || (t[7] = () => e.$emit("auto-hide")),
    onResize: t[8] || (t[8] = () => e.$emit("resize"))
  }), {
    default: H(({
      popperId: u,
      isShown: d,
      shouldMountContent: c,
      skipTransition: p,
      autoHide: h,
      show: y,
      hide: M,
      handleResize: g,
      onResize: v,
      classes: m,
      result: I
    }) => [
      ee(e.$slots, "default", {
        shown: d,
        show: y,
        hide: M
      }),
      R(i, {
        ref: "popperContent",
        "popper-id": u,
        theme: e.finalTheme,
        shown: d,
        mounted: c,
        "skip-transition": p,
        "auto-hide": h,
        "handle-resize": g,
        classes: m,
        result: I,
        onHide: M,
        onResize: v
      }, {
        default: H(() => [
          ee(e.$slots, "popper", {
            shown: d,
            hide: M
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 16, ["theme", "target-nodes", "popper-node", "class"]);
}
const rr = /* @__PURE__ */ tr(Xl, [["render", ql]]);
({
  ...rr
});
const e1 = {
  ...rr,
  name: "VMenu",
  vPopperTheme: "menu"
}, t1 = {
  ...rr,
  name: "VTooltip",
  vPopperTheme: "tooltip"
};
ae({
  name: "VTooltipDirective",
  components: {
    Popper: Ds(),
    PopperContent: As
  },
  mixins: [
    xs
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (e) => A0(e.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (e) => A0(e.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(e) {
      if (typeof this.content == "function" && this.$_isShown && (e || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const t = ++this.$_fetchId, r = this.content(this);
        r.then ? r.then((n) => this.onResult(t, n)) : this.onResult(t, r);
      }
    },
    onResult(e, t) {
      e === this.$_fetchId && (this.$_loading = !1, this.asyncContent = t);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
});
const we = e1, Qt = t1, r1 = ["A-Z", "Z-A", "default"], n1 = {
  modelValue: {
    type: Array,
    default: []
  },
  searchValue: {
    type: String,
    default: ""
  },
  menuList: {
    type: Array,
    required: !0,
    default: []
  },
  groupItemsBy: {
    type: String,
    validator: (e) => e === void 0 || r1.includes(e)
  },
  multiSelect: {
    type: Boolean,
    default: !1
  },
  menuLevel: {
    type: Number,
    default: 0
  },
  searchableMenu: {
    type: Boolean,
    default: !1
  },
  searchableMenuPlaceholder: {
    type: String,
    default: "Search..."
  },
  preSelectedItems: {
    type: Array,
    default: () => []
  },
  ladderized: {
    type: Boolean,
    default: !1
  },
  disabledLocalSearch: {
    type: Boolean,
    default: !1
  },
  loading: {
    type: Boolean,
    default: !1
  },
  noCheck: {
    type: Boolean,
    default: !1
  }
}, s1 = {
  "update:modelValue": (e) => e,
  "update:search": (e) => typeof e == "string"
}, a1 = (e, t) => {
  const r = Ie(e, "modelValue", t), n = Ie(e, "searchValue", t), { menuList: s, menuLevel: a, groupItemsBy: i, multiSelect: l, preSelectedItems: u, disabledLocalSearch: d, noCheck: c } = ye(e), p = F(() => ({ listItemClasses: L(
    "spr-flex spr-cursor-pointer spr-items-center spr-gap-1.5 spr-rounded-lg spr-p-2",
    "spr-transition spr-duration-150 spr-ease-in-out",
    "hover:spr-background-color-hover",
    "active:spr-background-color-single-active active:spr-scale-[.98]"
  ) })), h = B(""), y = B([]), M = B([]), g = B([
    {
      groupLabel: "no-group",
      items: []
    }
  ]), v = F(() => a.value === 0), m = (b) => {
    var Z;
    return r.value.some((j) => {
      if (j.text === b.text) return !0;
      const T = j.value, O = b.value;
      return typeof T != "object" && typeof O != "object" ? String(T) === String(O) : typeof T == "object" && T !== null && typeof O == "object" && O !== null ? JSON.stringify(T) === JSON.stringify(O) : !1;
    }) ? !0 : "_originalObject" in b && b._originalObject && ((Z = u.value) != null && Z.length) ? u.value.some((j) => {
      if (j === b._originalObject)
        return !0;
      if (typeof j == "object" && j !== null) {
        const T = b._originalObject;
        if (typeof T == "object") {
          if ("id" in j && "id" in T)
            return j.id === T.id;
          const O = JSON.stringify(j), S = JSON.stringify(T);
          return O === S;
        }
        if ("id" in j)
          return String(b.value).includes(String(j.id));
      }
      return !1;
    }) : M.value.some((j) => j.value === b.value) ? (z(b), !0) : !1;
  }, I = () => {
    y.value = [...e.menuList], y.value && y.value.length > 0 && i != null && i.value && (i.value === "default" ? N() : w());
  }, N = () => {
    i != null && i.value && y.value.forEach((b) => {
      var V;
      let P = b.group;
      P || (P = "no-group"), g.value.some((Z) => Z.groupLabel === P) ? (V = g.value.find((Z) => Z.groupLabel === P)) == null || V.items.push(b) : g.value.push({ groupLabel: P, items: [b] });
    });
  }, w = () => {
    i != null && i.value && y.value.sort((b, P) => i.value === "A-Z" ? b.text.localeCompare(P.text) : i.value === "Z-A" ? P.text.localeCompare(b.text) : 0).forEach((b) => {
      var Z;
      const P = b.text.charAt(0), V = /^\d/.test(P) ? "no-group" : P.toUpperCase();
      g.value.some((j) => j.groupLabel === V) ? (Z = g.value.find((j) => j.groupLabel === V)) == null || Z.items.push(b) : g.value.push({ groupLabel: V, items: [b] });
    });
  }, E = () => {
    var P;
    if (!((P = u.value) != null && P.length)) return;
    const b = u.value.map((V) => {
      if (typeof V == "object" && V !== null) {
        const j = y.value.find((T) => T._originalObject ? JSON.stringify(T._originalObject) === JSON.stringify(V) : !1);
        if (j) return j;
        if ("id" in V) {
          const T = y.value.find((O) => O._originalObject && "id" in O._originalObject ? O._originalObject.id === V.id : String(O.value).includes(String(V.id)));
          if (T) return T;
        }
      }
      const Z = y.value.find((j) => j.value === V);
      if (Z) return Z;
      if (typeof V == "number") {
        const j = y.value.find(
          (T) => (
            // Match if menuItem.value is the same number
            typeof T.value == "number" && T.value === V || // Match if menuItem.value is a string representation of the number
            typeof T.value == "string" && T.value === String(V)
          )
        );
        if (j) return j;
      }
      return y.value.find((j) => String(j.value) === String(V));
    }).filter(Boolean);
    if (l.value)
      r.value = b;
    else {
      const V = b[0];
      V && !r.value.some((Z) => Z.text === V.text ? !0 : String(Z.value) === String(V.value)) && (r.value = [V]);
    }
  }, $ = (b) => ({
    [p.value.listItemClasses]: !b.disabled,
    "spr-background-color-single-active": m(b) && !b.disabled && !c.value,
    "hover:spr-cursor-not-allowed spr-flex spr-cursor-pointer spr-items-center spr-gap-1.5 spr-rounded-lg spr-p-2": b.disabled
  }), D = () => {
    const b = h.value.trim().toLowerCase();
    if (!b) {
      I();
      return;
    }
    const P = e.menuList.filter((V) => {
      const Z = V.text.toLowerCase().includes(b), j = V.subtext ? V.subtext.toLowerCase().includes(b) : !1;
      return Z || j;
    });
    y.value = P, i != null && i.value && (g.value = [{ groupLabel: "no-group", items: [] }], i.value === "default" ? P.forEach((V) => {
      var j;
      const Z = V.group || "no-group";
      g.value.some((T) => T.groupLabel === Z) ? (j = g.value.find((T) => T.groupLabel === Z)) == null || j.items.push(V) : g.value.push({ groupLabel: Z, items: [V] });
    }) : P.sort((V, Z) => i.value === "A-Z" ? V.text.localeCompare(Z.text) : i.value === "Z-A" ? Z.text.localeCompare(V.text) : 0).forEach((V) => {
      var T;
      const Z = V.text.charAt(0), j = /^\d/.test(Z) ? "no-group" : Z.toUpperCase();
      g.value.some((O) => O.groupLabel === j) ? (T = g.value.find((O) => O.groupLabel === j)) == null || T.items.push(V) : g.value.push({ groupLabel: j, items: [V] });
    }));
  }, z = (b) => {
    if (!b.disabled)
      if (l.value) {
        const P = r.value.findIndex((V) => {
          if (V.text === b.text) return !0;
          if (typeof V.value != "object" && typeof b.value != "object")
            return String(V.value) === String(b.value);
          if (typeof V.value == "object" && V.value !== null && typeof b.value == "object" && b.value !== null)
            return JSON.stringify(V.value) === JSON.stringify(b.value);
          if ("_originalObject" in V && V._originalObject && "_originalObject" in b && b._originalObject) {
            if (V._originalObject === b._originalObject)
              return !0;
            const Z = V._originalObject, j = b._originalObject;
            return "id" in Z && "id" in j ? Z.id === j.id : JSON.stringify(V._originalObject) === JSON.stringify(b._originalObject);
          }
          return !1;
        });
        if (P === -1)
          r.value = d.value ? k(b, !1) : [...r.value, b];
        else {
          const V = [...r.value];
          V.splice(P, 1), r.value = d.value ? k(b, !0) : V;
        }
      } else
        r.value = [b], b.onClickFn && b.onClickFn();
  }, k = (b, P) => {
    if (!M.value.some((Z) => Z.value === b.value))
      M.value.push(b);
    else {
      const Z = M.value.findIndex((j) => j.value === b.value);
      Z !== -1 && P && M.value.splice(Z, 1);
    }
    return M.value;
  };
  return ce(
    s,
    () => {
      y.value = [], g.value = [], I(), E();
    },
    { deep: !0 }
  ), ce(h, () => {
    if (d.value) {
      n.value = h.value;
      return;
    }
    D();
  }), ce(
    M,
    () => {
      M.value.forEach((b) => {
        r.value.some((V) => V.value === b.value) || r.value.push(b);
      });
    },
    { deep: !0 }
  ), Be(() => {
    I(), E();
  }), {
    searchText: h,
    listClasses: p,
    localizedMenuList: y,
    groupedMenuList: g,
    apiSelectedList: M,
    isParentMenu: v,
    isItemSelected: m,
    getListItemClasses: $,
    handleSearch: D,
    handleSelectedItem: z,
    trackNewlySelectedItems: k
  };
}, o1 = {
  modelValue: {
    type: Boolean,
    default: !1
  },
  label: {
    type: String,
    default: ""
  },
  description: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  checked: {
    type: Boolean,
    default: !1
  },
  indeterminate: {
    type: Boolean,
    default: !1
  },
  bordered: {
    type: Boolean,
    default: !1
  },
  fullWidth: {
    type: Boolean,
    default: !1
  }
}, i1 = {
  "update:modelValue": (e) => typeof e == "boolean"
}, l1 = (e, t) => {
  const { modelValue: r, disabled: n, checked: s, bordered: a, fullWidth: i } = ye(e), l = F(() => {
    const p = L(
      "spr-flex spr-w-fit spr-select-none spr-items-center spr-gap-1.5 spr-transition spr-duration-150 spr-ease-in-out",
      {
        "spr-cursor-not-allowed": n.value,
        "spr-cursor-pointer": !n.value
      }
    ), h = L(
      "spr-h-[20px] spr-w-[20px] spr-appearance-none spr-rounded-[2.5px] spr-border-color-supporting spr-border-[1.25px] spr-border-solid spr-m-1",
      "spr-transition spr-duration-150 spr-ease-in-out",
      {
        "spr-background-color-brand-base spr-border-color-brand-base": c.value && !n.value,
        "hover:spr-background-color-brand-hover hover:spr-border-color-brand-hover": c.value && !a.value && !n.value,
        //remove hover checkbox styling when bordered
        "hover:spr-background-color-hover": !c.value && !a.value,
        //remove hover checkbox styling when bordered
        "spr-border-color-on-fill-disabled spr-background-color-disabled spr-cursor-not-allowed": !c.value && n.value,
        "spr-bg-white-300 spr-border-none": c.value && n.value,
        "spr-cursor-pointer": !n.value
      }
    ), y = L(
      "spr-h-[20px] spr-w-[20px] spr-flex spr-items-center spr-justify-center spr-pointer-events-none spr-absolute spr-left-1/2 spr-top-1/2 -spr-translate-x-1/2 -spr-translate-y-1/2 spr-transform spr-font-bold spr-opacity-0 spr-text-color-inverted-strong",
      {
        "spr-opacity-100": c.value
      }
    ), M = L("spr-body-sm-regular spr-text-color-strong spr-block", {
      "spr-text-color-on-fill-disabled": n.value
    }), g = L("spr-body-xs-regular spr-block", {
      "spr-text-color-on-fill-disabled": n.value
    }), v = L(
      "spr-border spr-rounded-md spr-p-size-spacing-2xs spr-border-solid spr-box-border",
      {
        "spr-border-kangkong-700 spr-bg-kangkong-100": (r.value || s.value) && !n.value,
        "spr-border-mushroom-200": (!r.value || !s.value) && !n.value,
        "hover:spr-background-color-hover": !r.value && !s.value || n.value,
        "spr-border-0 spr-bg-white-100": n.value,
        "spr-w-fit": !i.value,
        "spr-w-full": i.value
      }
    );
    return {
      baseClasses: p,
      inputCheckboxClasses: h,
      inputCheckboxCheckIconClasses: y,
      labelClasses: M,
      descriptionClasses: g,
      borderedClasses: v
    };
  }), u = (p) => {
    p.target instanceof HTMLInputElement && t("update:modelValue", p.target.checked);
  }, d = F(() => e.indeterminate ? "ph:minus-bold" : "ph:check-bold"), c = F(() => r.value || s.value);
  return {
    checkboxClasses: l,
    handleCheckbox: u,
    resolveCheckboxIcon: d
  };
}, u1 = { class: "spr-relative spr-flex spr-items-center" }, d1 = ["disabled", "checked"], c1 = {
  key: 0,
  class: "spr-grid spr-gap-0.5"
}, $t = /* @__PURE__ */ ae({
  __name: "checkbox",
  props: o1,
  emits: i1,
  setup(e, { emit: t }) {
    const r = e, n = t, { checkboxClasses: s, handleCheckbox: a, resolveCheckboxIcon: i } = l1(r, n);
    return (l, u) => (f(), C("label", {
      class: x([o(s).baseClasses, { [o(s).borderedClasses]: r.bordered }])
    }, [
      A("div", u1, [
        A("input", {
          type: "checkbox",
          class: x(o(s).inputCheckboxClasses),
          disabled: r.disabled,
          checked: r.modelValue || r.checked,
          onChange: u[0] || (u[0] = //@ts-ignore
          (...d) => o(a) && o(a)(...d))
        }, null, 42, d1),
        A("span", {
          class: x(o(s).inputCheckboxCheckIconClasses)
        }, [
          R(o(W), { icon: o(i) }, null, 8, ["icon"])
        ], 2)
      ]),
      r.label || r.description ? (f(), C("div", c1, [
        r.label ? (f(), C("span", {
          key: 0,
          class: x(o(s).labelClasses)
        }, G(r.label), 3)) : _("", !0),
        r.description ? (f(), C("span", {
          key: 1,
          class: x(o(s).descriptionClasses)
        }, G(r.description), 3)) : _("", !0)
      ])) : _("", !0)
    ], 2));
  }
}), p1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $t
}, Symbol.toStringTag, { value: "Module" })), f1 = ["xs", "sm", "md"], g1 = [
  "button",
  "checkbox",
  "color",
  "date",
  "datetime-local",
  "email",
  "file",
  "hidden",
  "image",
  "month",
  "contact-number",
  "password",
  "radio",
  "range",
  "reset",
  "search",
  "submit",
  "tel",
  "text",
  "time",
  "url",
  "week"
], h1 = {
  id: {
    type: String,
    default: "spr-input"
  },
  modelValue: {
    type: [String, Number],
    default: ""
  },
  label: {
    type: String,
    default: ""
  },
  showCharCount: {
    type: Boolean,
    default: !1
  },
  type: {
    type: String,
    validator: (e) => !e || g1.includes(e),
    default: "text"
  },
  placeholder: {
    type: String,
    default: ""
  },
  active: {
    type: Boolean,
    default: !1
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  error: {
    type: Boolean,
    default: !1
  },
  minLength: {
    type: Number
  },
  maxLength: {
    type: Number
  },
  offsetSize: {
    type: String,
    validator: (e) => f1.includes(e),
    default: "sm"
  },
  displayHelper: {
    type: Boolean,
    default: !1
  },
  helperIcon: {
    type: String,
    default: null
  },
  helperText: {
    type: String,
    default: ""
  }
}, y1 = {
  "update:modelValue": (e) => typeof e == "string" || typeof e == "number"
}, C1 = (e, t, r) => {
  const { active: n, error: s, disabled: a, offsetSize: i, showCharCount: l, maxLength: u } = ye(e), d = B(null), { focused: c } = J0(d), p = Ie(e, "modelValue", t), h = F(() => p.value ? String(p.value).length : 0), y = F(() => u.value !== void 0 && u.value > 0), M = F(() => {
    const m = L("spr-flex spr-flex-col spr-gap-size-spacing-4xs"), I = L("spr-body-sm-regular spr-text-color-strong spr-block", {
      "spr-text-color-on-fill-disabled": a.value
    }), N = L(
      "spr-relative spr-flex spr-items-center spr-p-[1.5px] spr-rounded-border-radius-md spr-border-[1.5px] spr-border-solid",
      {
        // Border State
        "spr-border-color-weak": !c.value && !s.value && !a.value && !n.value,
        "spr-border-color-brand-base": !c.value && n.value,
        "spr-border-color-danger-base": !c.value && s.value,
        // Border State Focused
        "focus: spr-border-kangkong-700": c.value && !s.value && !a.value && !n.value,
        "focus: spr-border-tomato-600": c.value && s.value,
        "focus: spr-border-white-100": c.value && a.value,
        // Disabled State
        "spr-background-color-disabled spr-cursor-not-allowed spr-border-mushroom-100": a.value
      }
    ), w = L(
      "spr-block spr-h-8 spr-py-size-spacing-4xs spr-outline-none spr-ring-0 spr-border-none spr-rounded-border-radius-md spr-font-size-200",
      "spr-font-size-200 [font-weight:inherit]",
      "placeholder:spr-text-mushroom-300",
      {
        "spr-text-color-strong": !a.value,
        // Disabled State
        "spr-text-color-on-fill-disabled !spr-cursor-not-allowed": a.value,
        // Prefix, Suffix, Trailing
        "spr-px-3": !r.prefix && !r.icon && !r.trailing,
        "spr-pr-3": r.prefix && !r.icon && !r.trailing,
        "spr-pl-3": !r.prefix && (r.icon || r.trailing),
        // Trailing Width Adjustments
        "spr-w-full": !r.trailing,
        "spr-w-[50px]": r.trailing && i.value === "xs",
        "spr-w-[40%]": r.trailing && i.value === "sm",
        "spr-w-[100%]": r.trailing && i.value === "md"
      }
    ), E = L(
      "spr-flex spr-items-center spr-justify-center spr-h-8 spr-px-2 [&>svg]:spr-min-h-4 [&>svg]:spr-min-w-4",
      {
        "spr-text-mushroom-300": !s.value,
        "spr-text-tomato-600": s.value
      }
    ), $ = L(
      "spr-flex spr-items-center spr-justify-center spr-h-8 spr-px-2 [&>svg]:spr-min-h-4 [&>svg]:spr-min-w-4",
      {
        "spr-text-mushroom-300": !s.value,
        "spr-text-tomato-600": s.value,
        "spr-font-size-200": e.type === "url"
      }
    ), D = L("spr-flex spr-items-center spr-h-8 spr-w-full spr-px-2", {
      "spr-text-mushroom-300": !s.value,
      "spr-text-tomato-600": s.value
    }), z = L("spr-flex spr-flex-row spr-items-start spr-justify-between spr-w-full", {
      "spr-mt-1": l.value || e.displayHelper
    }), k = L("spr-body-sm-regular spr-flex spr-items-center spr-gap-size-spacing-5xs spr-flex-1", {
      "spr-text-color-danger-base": s.value,
      "spr-text-color-supporting": !s.value
    }), b = L("spr-ml-auto spr-body-2xs-regular spr-text-right spr-text-xs spr-text-color-supporting", {
      "spr-text-color-danger-base": y.value && h.value >= (u.value || 0)
    });
    return {
      baseClasses: m,
      labelClasses: I,
      inputTextBaseClasses: N,
      inputTextClasses: w,
      iconSlotClasses: E,
      prefixSlotClasses: $,
      trailingSlotClasses: D,
      helperClasses: k,
      charCountClasses: b,
      helperContainerClasses: z
    };
  });
  return {
    inputTextRef: d,
    inputClasses: M,
    onInput: (m) => {
      let N = m.target.value;
      e.type === "number" && N !== "" && (N = Number(N)), p.value = N;
    },
    disableClickEvent: (m) => {
      a.value && (m.preventDefault(), m.stopPropagation());
    },
    currentLength: h,
    hasCharLimit: y
  };
}, v1 = ["for"], m1 = ["id", "placeholder", "type", "minlength", "maxlength", "value", "disabled", "readonly"], M1 = /* @__PURE__ */ ae({
  __name: "input",
  props: h1,
  emits: y1,
  setup(e, { emit: t }) {
    const r = t, n = e, s = It(), { inputClasses: a, inputTextRef: i, onInput: l, disableClickEvent: u, currentLength: d } = C1(n, r, s);
    return (c, p) => (f(), C("div", {
      class: x(o(a).baseClasses)
    }, [
      n.label ? (f(), C("label", {
        key: 0,
        for: c.id,
        class: x(o(a).labelClasses)
      }, G(n.label), 11, v1)) : _("", !0),
      A("div", {
        class: x(o(a).inputTextBaseClasses)
      }, [
        c.$slots.prefix ? (f(), C("div", {
          key: 0,
          class: x(o(a).prefixSlotClasses)
        }, [
          ee(c.$slots, "prefix", {}, void 0, !0)
        ], 2)) : _("", !0),
        A("input", Ye(c.$attrs, {
          id: n.id,
          ref_key: "inputTextRef",
          ref: i,
          class: [o(a).inputTextClasses, { "number-input": n.type === "number" }],
          placeholder: n.placeholder,
          type: n.type,
          minlength: n.minLength,
          maxlength: n.maxLength,
          value: c.modelValue,
          disabled: n.disabled,
          readonly: n.readonly,
          onInput: p[0] || (p[0] = //@ts-ignore
          (...h) => o(l) && o(l)(...h))
        }), null, 16, m1),
        c.$slots.trailing ? (f(), C("div", {
          key: 1,
          class: x(o(a).trailingSlotClasses)
        }, [
          ee(c.$slots, "trailing", {}, void 0, !0)
        ], 2)) : _("", !0),
        c.$slots.icon ? (f(), C("div", {
          key: 2,
          class: x(o(a).iconSlotClasses),
          onClick: p[1] || (p[1] = //@ts-ignore
          (...h) => o(u) && o(u)(...h))
        }, [
          ee(c.$slots, "icon", {}, void 0, !0)
        ], 2)) : _("", !0)
      ], 2),
      n.displayHelper || n.showCharCount ? (f(), C("div", {
        key: 1,
        class: x(o(a).helperContainerClasses)
      }, [
        n.displayHelper ? (f(), C("div", {
          key: 0,
          class: x(o(a).helperClasses)
        }, [
          ee(c.$slots, "helperMessage", {}, () => [
            n.helperIcon ? (f(), K(o(W), {
              key: 0,
              icon: n.helperIcon,
              width: "20px",
              height: "20px"
            }, null, 8, ["icon"])) : _("", !0),
            A("span", null, G(n.helperText), 1)
          ], !0)
        ], 2)) : _("", !0),
        n.showCharCount ? (f(), C("div", {
          key: 1,
          class: x(o(a).charCountClasses)
        }, G(o(d)) + G(n.maxLength ? "/" + n.maxLength : ""), 3)) : _("", !0)
      ], 2)) : _("", !0)
    ], 2));
  }
}), gt = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, s] of t)
    r[n] = s;
  return r;
}, Ee = /* @__PURE__ */ gt(M1, [["__scopeId", "data-v-e253c7bc"]]), b1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ee
}, Symbol.toStringTag, { value: "Module" })), nr = /* @__PURE__ */ ae({
  __name: "input-search",
  setup(e) {
    return (t, r) => (f(), K(Ee, Q2(H2(t.$attrs)), {
      icon: H(() => [
        R(o(W), { icon: "ph:magnifying-glass" })
      ]),
      _: 1
    }, 16));
  }
}), N1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nr
}, Symbol.toStringTag, { value: "Module" })), $1 = { class: "spr-font-main" }, D1 = {
  key: 0,
  class: "spr-mb-3 spr-grid spr-gap-3"
}, I1 = {
  key: 0,
  class: "spr-background-color-surface spr-h-[1px]"
}, A1 = {
  key: 1,
  class: "spr-grid spr-gap-2"
}, x1 = {
  key: 0,
  class: "spr-label-xs-medium spr-text-color-base spr-px-size-spacing-4xs spr-py-size-spacing-3xs spr-uppercase"
}, w1 = ["onClick"], S1 = { class: "spr-flex spr-flex-auto spr-flex-col spr-justify-start" }, j1 = { class: "spr-text-left spr-text-xs" }, T1 = {
  key: 0,
  class: "spr-body-xs-regular spr-text-color-base spr-text-left"
}, O1 = ["onClick"], _1 = { class: "spr-text-left spr-text-xs" }, z1 = {
  key: 0,
  class: "spr-skeletal-loader spr-h-8 spr-w-full spr-rounded-md"
}, L1 = {
  key: 1,
  class: "spr-flex spr-items-center spr-justify-center spr-p-2 spr-text-center"
}, ct = /* @__PURE__ */ ae({
  __name: "list",
  props: n1,
  emits: s1,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      searchText: s,
      localizedMenuList: a,
      groupedMenuList: i,
      isParentMenu: l,
      isItemSelected: u,
      getListItemClasses: d,
      handleSelectedItem: c
    } = a1(r, n);
    return (p, h) => (f(), C("div", $1, [
      r.searchableMenu ? (f(), C("div", D1, [
        R(nr, {
          modelValue: o(s),
          "onUpdate:modelValue": h[0] || (h[0] = (y) => fe(s) ? s.value = y : null),
          placeholder: r.searchableMenuPlaceholder,
          autocomplete: "off"
        }, null, 8, ["modelValue", "placeholder"]),
        o(l) ? (f(), C("div", I1)) : _("", !0)
      ])) : _("", !0),
      r.groupItemsBy && o(i).length > 0 ? (f(), C("div", A1, [
        (f(!0), C(X, null, le(o(i), (y, M) => (f(), C("div", {
          key: M,
          class: "spr-grid spr-gap-0.5"
        }, [
          y.groupLabel !== "no-group" ? (f(), C("div", x1, [
            A("span", null, G(y.groupLabel), 1)
          ])) : _("", !0),
          (f(!0), C(X, null, le(y.items, (g, v) => {
            var m;
            return f(), C("div", {
              key: v,
              class: x(o(d)(g)),
              onClick: (I) => o(c)(g)
            }, [
              r.multiSelect ? (f(), K($t, {
                key: 0,
                checked: o(u)(g)
              }, null, 8, ["checked"])) : _("", !0),
              A("div", S1, [
                A("span", j1, G(g.text), 1),
                g.subtext ? (f(), C("span", T1, G(g.subtext), 1)) : _("", !0)
              ]),
              o(u)(g) && !r.multiSelect ? (f(), K(o(W), {
                key: 1,
                class: "spr-text-color-brand-base spr-w-[1.39em]",
                icon: "ph:check"
              })) : r.ladderized && g.sublevel && ((m = g.sublevel) == null ? void 0 : m.length) > 0 ? (f(), K(o(W), {
                key: 2,
                class: "spr-text-color-weak spr-size-4",
                icon: "ph:caret-right"
              })) : _("", !0)
            ], 10, w1);
          }), 128))
        ]))), 128))
      ])) : _("", !0),
      o(a).length > 0 ? (f(!0), C(X, { key: 2 }, le(o(a), (y, M) => {
        var g;
        return f(), C("div", {
          key: M,
          class: x(o(d)(y)),
          onClick: (v) => o(c)(y)
        }, [
          r.multiSelect ? (f(), K($t, {
            key: 0,
            disabled: y.disabled,
            checked: o(u)(y)
          }, null, 8, ["disabled", "checked"])) : _("", !0),
          A("div", {
            class: x([
              "spr-flex spr-flex-auto spr-flex-col spr-justify-start",
              { "spr-text-color-disabled": y.disabled }
            ])
          }, [
            A("span", _1, G(y.text), 1),
            y.subtext ? (f(), C("span", {
              key: 0,
              class: x([
                "spr-body-xs-regular spr-text-color-base spr-text-left",
                { "spr-text-color-disabled": y.disabled }
              ])
            }, G(y.subtext), 3)) : _("", !0)
          ], 2),
          o(u)(y) && !r.multiSelect ? (f(), K(o(W), {
            key: 1,
            class: "spr-text-color-brand-base spr-w-[1.39em]",
            icon: "ph:check"
          })) : r.ladderized && y.sublevel && ((g = y.sublevel) == null ? void 0 : g.length) > 0 ? (f(), K(o(W), {
            key: 2,
            class: "spr-text-color-weak spr-size-4",
            icon: "ph:caret-right"
          })) : _("", !0)
        ], 10, O1);
      }), 128)) : (f(), C(X, { key: 3 }, [
        r.loading ? (f(), C("div", z1)) : (f(), C("div", L1, h[1] || (h[1] = [
          A("span", { class: "spr-body-sm-regular spr-m-0" }, "No results found", -1)
        ])))
      ], 64))
    ]));
  }
}), k1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ct
}, Symbol.toStringTag, { value: "Module" })), E1 = {
  modelValue: {
    type: Array,
    required: !0,
    default: []
  },
  menuList: {
    type: Array,
    required: !0,
    default: []
  },
  menuLevel: {
    type: Number,
    default: 0
  },
  searchableMenu: {
    type: Boolean,
    default: !1
  },
  searchableMenuPlaceholder: {
    type: String,
    default: "Search..."
  },
  removeCurrentLevelInBackLabel: {
    type: Boolean,
    default: !1
  }
}, P1 = {
  "update:modelValue": (e) => e
}, Y1 = (e, t) => {
  const r = Ie(e, "modelValue", t), { menuList: n, removeCurrentLevelInBackLabel: s } = ye(e), a = B("slide-left"), i = B(""), l = B([]), u = B(0), d = B(n.value), c = B([]), p = (I) => {
    a.value = "slide-left", h(I), F(() => c.value.some((w) => w.value === I.value)).value ? g(I) : M(I), I.sublevel && I.sublevel.length > 0 && y(I), t("update:modelValue", r.value);
  }, h = (I) => {
    l.value[u.value] ? l.value[u.value] = I : l.value.push(I);
  }, y = (I) => {
    u.value += 1, c.value = d.value, d.value = I.sublevel ?? d.value;
  }, M = (I) => {
    if (r.value[r.value.length - 1] !== I.value) {
      if (i.value !== "") {
        const N = i.value.split(", ");
        N == null || N.push(I.text), i.value = (N == null ? void 0 : N.join(", ")) ?? "";
      } else
        i.value = I.text;
      r.value.push(I.value.toString());
    }
  }, g = (I) => {
    const N = i.value.trim().split(",");
    N == null || N.pop(), N == null || N.push(I.text), i.value = (N == null ? void 0 : N.join(", ")) ?? "";
    const w = r.value;
    w == null || w.pop(), w == null || w.push(I.value), r.value = w ?? [];
  }, v = () => {
    var I;
    if (a.value = "slide-right", u.value -= 1, u.value > 0) {
      const N = i.value.trim().split(",");
      N == null || N.pop(), i.value = (N == null ? void 0 : N.join(", ")) ?? "";
      const w = r.value;
      w == null || w.pop(), r.value = w ?? [];
      for (let E = 0; E < u.value; E++)
        d.value = ((I = e.menuList.find(($) => $.value === r.value[E])) == null ? void 0 : I.sublevel) ?? [];
    } else
      d.value = e.menuList, r.value = [], i.value = "", u.value = 0;
  }, m = () => {
    if (r.value && r.value.length > 0) {
      const I = [];
      c.value = [], r.value.forEach((N) => {
        const w = d.value.find((E) => String(E.value) === String(N));
        if (w)
          h(w), I.push(w.text), c.value = d.value, d.value = w.sublevel ?? c.value, u.value += w.sublevel ? 1 : 0;
        else
          return;
      }), s.value && I.length > 0 && I.pop(), i.value = I.length > 0 ? I.join(", ") : "Back";
    }
  };
  return ce(
    () => e.modelValue,
    (I) => {
      (!I || Array.isArray(I) && I.length === 0) && (l.value = []);
    }
  ), wa(() => {
    d.value = n.value, m();
  }), {
    activeLevel: u,
    activeList: d,
    handleSelectedListItem: p,
    handleBackClick: v,
    selectedListItem: l,
    transitionName: a,
    backLabel: i
  };
}, j0 = /* @__PURE__ */ ae({
  __name: "ladderized-list-back",
  props: {
    label: {
      type: String,
      default: "Back"
    }
  },
  emits: {
    back: () => !0
  },
  setup(e, { emit: t }) {
    const r = e, n = t, s = () => {
      n("back");
    };
    return (a, i) => (f(), C("div", {
      class: x([
        "spr-flex spr-cursor-pointer spr-items-center spr-gap-size-spacing-5xs spr-px-size-spacing-xs spr-py-size-spacing-2xs",
        "spr-body-xs-regular",
        "spr-border-color-weak spr-border-0 spr-border-b spr-border-solid"
      ]),
      onClick: s
    }, [
      R(o(W), {
        icon: "ph:arrow-left",
        class: "spr-size-4"
      }),
      A("span", null, G(r.label), 1)
    ]));
  }
}), U1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j0
}, Symbol.toStringTag, { value: "Module" })), F1 = { class: "ladderized-list" }, B1 = { key: 0 }, R1 = { key: 1 }, V1 = /* @__PURE__ */ ae({
  __name: "ladderized-list",
  props: E1,
  emits: P1,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      activeLevel: s,
      selectedListItem: a,
      handleSelectedListItem: i,
      activeList: l,
      handleBackClick: u,
      transitionName: d,
      backLabel: c
    } = Y1(r, n);
    return (p, h) => (f(), C("div", F1, [
      R(mt, {
        name: o(d),
        mode: "out-in"
      }, {
        default: H(() => [
          o(s) % 2 === 0 ? (f(), C("div", B1, [
            o(s) > 0 ? (f(), K(j0, {
              key: 0,
              label: o(c) ?? "Back",
              onBack: o(u)
            }, null, 8, ["label", "onBack"])) : _("", !0),
            R(ct, {
              modelValue: o(a),
              "onUpdate:modelValue": [
                h[0] || (h[0] = (y) => fe(a) ? a.value = y : null),
                h[1] || (h[1] = (y) => o(i)(y[0]))
              ],
              class: "spr-p-size-spacing-3xs",
              "menu-list": o(l),
              "menu-level": r.menuLevel,
              "multi-select": !1,
              ladderized: !0,
              "searchable-menu": r.searchableMenu,
              "searchable-menu-placeholder": r.searchableMenuPlaceholder
            }, null, 8, ["modelValue", "menu-list", "menu-level", "searchable-menu", "searchable-menu-placeholder"])
          ])) : (f(), C("div", R1, [
            o(s) > 0 ? (f(), K(j0, {
              key: 0,
              label: o(c) ?? "Back",
              onBack: o(u)
            }, null, 8, ["label", "onBack"])) : _("", !0),
            R(ct, {
              modelValue: o(a),
              "onUpdate:modelValue": [
                h[2] || (h[2] = (y) => fe(a) ? a.value = y : null),
                h[3] || (h[3] = (y) => o(i)(y[0]))
              ],
              class: "spr-p-size-spacing-3xs",
              "menu-list": o(l),
              "menu-level": r.menuLevel,
              "multi-select": !1,
              ladderized: !0,
              "searchable-menu": r.searchableMenu,
              "searchable-menu-placeholder": r.searchableMenuPlaceholder
            }, null, 8, ["modelValue", "menu-list", "menu-level", "searchable-menu", "searchable-menu-placeholder"])
          ]))
        ]),
        _: 1
      }, 8, ["name"])
    ]));
  }
}), sr = /* @__PURE__ */ gt(V1, [["__scopeId", "data-v-763cd796"]]), Q1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sr
}, Symbol.toStringTag, { value: "Module" })), H1 = (e, t) => {
  const { menuList: r, searchString: n, disabled: s, multiSelect: a, removeCurrentLevelInBackLabel: i, ladderized: l, textField: u, valueField: d } = ye(e), c = Ie(e, "modelValue", t), p = B(null), h = B([]), y = B([]), M = F(() => Array.isArray(c.value) ? c.value : c.value !== void 0 && c.value !== null ? [c.value] : []), g = F(() => {
    var j;
    return e.ladderized && Array.isArray(c.value) && c.value.length === 2 ? [((j = c.value[1]) == null ? void 0 : j.toString()) || ""] : Array.isArray(c.value) ? c.value.map((T) => T == null ? "" : typeof T == "number" || typeof T == "object" ? T : T.toString()) : c.value !== void 0 && c.value !== null ? [typeof c.value == "object" || // For numbers, preserve the original number value
    typeof c.value == "number" ? (
      // Pass object reference directly instead of stringifying
      c.value
    ) : c.value.toString()] : [];
  }), v = B(!1), m = F(() => s.value), I = F(
    () => l.value && n.value !== "" && M.value.length === 0
  ), N = () => {
    if (!r.value || !Array.isArray(r.value) || r.value.length === 0) {
      y.value = [];
      return;
    }
    if (l.value) {
      r.value.every(
        (O) => typeof O == "object" && O !== null && "text" in O && "value" in O
      ) ? y.value = r.value : (console.warn("Ladderized dropdown requires menu items in {text, value} format"), y.value = []);
      return;
    }
    const j = r.value[0];
    if (typeof j == "string") {
      y.value = r.value.map((T) => ({
        text: T,
        value: T
      }));
      return;
    }
    if (typeof j == "number") {
      y.value = r.value.map((T) => ({
        text: T.toString(),
        value: T
        // Keep the value as a number instead of converting to string
      }));
      return;
    }
    if (typeof j == "object" && j !== null) {
      if ("text" in j && "value" in j) {
        y.value = r.value;
        return;
      }
      y.value = r.value.map((T) => {
        const O = T[u.value] || "Unnamed", S = d.value && T[d.value] !== void 0 ? T[d.value] : T;
        return {
          text: O,
          value: typeof S == "object" ? JSON.stringify(S) : S.toString(),
          _originalObject: T
          // Store the original object for reference
        };
      });
      return;
    }
    y.value = r.value;
  };
  ce(r, () => {
    N();
  });
  const w = () => {
    r.value && r.value.length === 0 || (a.value ? (N(), n.value.trim() !== "" && (y.value = k(y.value))) : E());
  }, E = () => {
    e.ladderized ? D() : $();
  }, $ = () => {
    N(), n.value.trim() !== "" && (y.value = k(y.value));
  }, D = () => {
    if (n.value === "" || M.value.length > 0) {
      y.value = [...r.value];
      return;
    }
    const j = z(r.value), T = k(r.value), O = k(j);
    T.length > 0 ? y.value = z(T) : O.length > 0 ? y.value = O : y.value = [];
  }, z = (j) => j.reduce((T, O) => {
    if (O.sublevel) {
      const S = O.sublevel.map((Y) => ({
        ...Y,
        //text and value of a sublevel item
        subtext: O.text,
        // text of parent of a sublevel item
        subvalue: typeof O.value == "string" ? O.value : String(O.value)
        // value of parent of a sublevel item as string
      }));
      return [...T, ...S];
    }
    return T;
  }, []), k = (j) => j.filter((T) => {
    const O = n.value.toLowerCase().trim();
    return T.text.toLowerCase().includes(O);
  });
  ce(n, () => {
    w();
  }), Yt(p, () => {
    v.value = !1;
  }), kt(
    p,
    () => {
      t("infinite-scroll-trigger", !0);
    },
    { distance: 10 }
  );
  const b = (j) => {
    var T, O;
    if (e.ladderized) {
      if (e.ladderized) {
        if (e.searchString !== "") {
          const S = (T = j[0]) == null ? void 0 : T.subvalue, Y = (O = j[0]) == null ? void 0 : O.value;
          S !== void 0 && Y !== void 0 && (c.value = [S, Y]);
        } else if (j.length > 0) {
          const S = j[0];
          S && S.value && (c.value = S.value);
        }
      }
    } else if (a.value) {
      const S = j.map((Y) => {
        if ("_originalObject" in Y)
          return Y._originalObject;
        const U = Y.value;
        return typeof U == "number" ? U : typeof U == "string" && !isNaN(Number(U)) && U.trim() !== "" && /^-?\d+(\.\d+)?$/.test(U) ? Number(U) : U;
      });
      c.value = S;
    } else {
      if (j.length === 0) {
        c.value = e.multiSelect ? [] : "";
        return;
      }
      const S = j[0];
      if ("_originalObject" in S)
        c.value = S._originalObject;
      else {
        const Y = S.value;
        typeof Y == "string" && !isNaN(Number(Y)) && Y.trim() !== "" ? c.value = Number(Y) : c.value = Y;
      }
    }
    a.value || setTimeout(() => {
      v.value = !1;
    }, 10);
  }, P = (j) => {
    j.length > 0 && (c.value = j), V(j) && (v.value = !1);
  }, V = (j) => {
    let T = y.value;
    return j.forEach((O) => {
      var S;
      T = ((S = T.find((Y) => O === Y.value)) == null ? void 0 : S.sublevel) ?? [];
    }), !(T.length > 0);
  }, Z = () => {
    var S, Y;
    if (!y.value.length) return;
    const j = M.value;
    if (!j || !j.length) {
      h.value = [];
      return;
    }
    const T = j.map((U) => U == null ? { original: "", string: "" } : typeof U == "object" ? {
      original: U,
      string: JSON.stringify(U),
      isObject: !0,
      id: "id" in U ? U.id : void 0
    } : {
      original: U,
      string: U.toString(),
      isObject: !1
    }), O = T.map((U) => U.string);
    if (e.ladderized)
      if (Array.isArray(c.value) && c.value.length === 2) {
        const U = ((S = c.value[0]) == null ? void 0 : S.toString()) || "", J = ((Y = c.value[1]) == null ? void 0 : Y.toString()) || "";
        h.value = y.value.filter((oe) => oe.value === J && (!oe.subvalue || oe.subvalue === U));
      } else
        h.value = y.value.filter((U) => typeof U.value == "number" ? T.some((J) => J.original === U.value || J.string === String(U.value)) : O.includes(String(U.value)));
    else
      h.value = y.value.filter((U) => "_originalObject" in U && U._originalObject ? T.some((J) => {
        if (J.isObject && typeof J.original == "object") {
          const oe = U._originalObject;
          if (J.original === oe) return !0;
          const de = JSON.stringify(oe);
          if (J.string === de) return !0;
          if (J.id !== void 0 && "id" in oe)
            return J.id === oe.id;
        }
        return !1;
      }) : typeof U.value == "number" ? T.some((J) => J.original === U.value || J.string === String(U.value)) : O.includes(String(U.value)));
  };
  return ce(c, () => {
    Z();
  }), ce(y, () => {
    Z();
  }), Be(() => {
    N(), M.value.length > 0 && Z();
  }), {
    dropdownPopperState: v,
    dropdownRef: p,
    dropdownMenuList: y,
    isDropdownPopperDisabled: m,
    selectedListItems: h,
    handleSelectedItem: b,
    handleSelectedLadderizedItem: P,
    dropdownValue: g,
    // Use compatible format for lists
    removeCurrentLevelInBackLabel: i,
    isLadderizedSearch: I
  };
}, Z1 = ["id"], G1 = {
  key: 1,
  class: "spr-flex spr-items-center spr-justify-center spr-p-2 spr-text-center"
}, e0 = /* @__PURE__ */ ae({
  __name: "dropdown",
  props: ol,
  emits: il,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      dropdownPopperState: s,
      dropdownRef: a,
      dropdownMenuList: i,
      isDropdownPopperDisabled: l,
      selectedListItems: u,
      handleSelectedItem: d,
      handleSelectedLadderizedItem: c,
      dropdownValue: p,
      removeCurrentLevelInBackLabel: h,
      isLadderizedSearch: y
    } = H1(r, n);
    return (M, g) => (f(), K(o(we), {
      shown: o(s),
      "aria-id": "dropdown-wrapper",
      distance: "4",
      placement: r.placement,
      triggers: [],
      "popper-hide-triggers": [],
      "auto-hide": !1,
      disabled: o(l),
      container: `#${r.id}`,
      strategy: r.popperStrategy === "fixed" || r.popperStrategy === "absolute" ? r.popperStrategy : "absolute",
      delay: 0,
      style: De({
        position: r.wrapperPosition,
        width: r.width
      })
    }, {
      popper: H(() => [
        A("div", {
          ref_key: "dropdownRef",
          ref: a,
          class: x([
            (!r.ladderized || o(y)) && "spr-p-2",
            "spr-grid spr-max-h-[300px] spr-gap-0.5 spr-overflow-y-auto spr-overflow-x-hidden"
          ]),
          style: De({
            width: r.popperInnerWidth
          })
        }, [
          o(i).length > 0 ? (f(), C(X, { key: 0 }, [
            !r.ladderized || o(y) ? (f(), K(ct, {
              key: 0,
              modelValue: o(u),
              "onUpdate:modelValue": [
                g[1] || (g[1] = (v) => fe(u) ? u.value = v : null),
                o(d)
              ],
              "menu-list": o(i),
              "group-items-by": r.groupItemsBy,
              "multi-select": r.multiSelect,
              "pre-selected-items": o(p),
              "no-check": r.noCheckInList
            }, null, 8, ["modelValue", "menu-list", "group-items-by", "multi-select", "pre-selected-items", "no-check", "onUpdate:modelValue"])) : (f(), K(sr, {
              key: 1,
              modelValue: o(p),
              "onUpdate:modelValue": [
                g[2] || (g[2] = (v) => fe(p) ? p.value = v : null),
                o(c)
              ],
              ladderized: r.ladderized,
              "menu-list": o(i),
              "remove-current-level-in-back-label": o(h)
            }, null, 8, ["modelValue", "ladderized", "menu-list", "remove-current-level-in-back-label", "onUpdate:modelValue"]))
          ], 64)) : (f(), C("div", G1, g[3] || (g[3] = [
            A("span", { class: "spr-body-sm-regular spr-m-0" }, "No results found", -1)
          ])))
        ], 6)
      ]),
      default: H(() => [
        A("div", {
          onClick: g[0] || (g[0] = (v) => s.value = !0)
        }, [
          ee(M.$slots, "default")
        ]),
        A("div", {
          id: r.id,
          style: De({
            width: r.popperWidth
          })
        }, null, 12, Z1)
      ]),
      _: 3
    }, 8, ["shown", "placement", "disabled", "container", "strategy", "style"]));
  }
}), W1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e0
}, Symbol.toStringTag, { value: "Module" })), K1 = { class: "spr-flex spr-h-fit spr-flex-row" }, J1 = /* @__PURE__ */ ae({
  __name: "button-dropdown",
  props: dl,
  emits: cl,
  setup(e, { emit: t }) {
    const r = e, n = t, { selectedMenu: s, buttonDropdownClasses: a } = pl(r, n);
    return (i, l) => (f(), C("div", K1, [
      R(be, Ye(r, {
        class: o(a).mainButtonClasses,
        onClick: l[0] || (l[0] = (u) => n("click", u))
      }), {
        default: H(() => [
          ee(i.$slots, "default")
        ]),
        _: 3
      }, 16, ["class"]),
      R(e0, {
        id: r.dropdownId,
        modelValue: o(s),
        "onUpdate:modelValue": l[1] || (l[1] = (u) => fe(s) ? s.value = u : null),
        "menu-list": i.menuList,
        width: r.width,
        "popper-width": r.popperWidth,
        "popper-inner-width": r.popperInnerWidth,
        placement: r.placement,
        "no-check-in-list": ""
      }, {
        default: H(() => [
          R(be, Ye(r, {
            fullwidth: !1,
            "has-icon": !0,
            class: o(a).dropdownButtonClasses
          }), {
            default: H(() => [
              R(o(W), { icon: "ph:caret-down" })
            ]),
            _: 1
          }, 16, ["class"])
        ]),
        _: 1
      }, 8, ["id", "modelValue", "menu-list", "width", "popper-width", "popper-inner-width", "placement"])
    ]));
  }
}), X1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J1
}, Symbol.toStringTag, { value: "Module" })), q1 = ["success", "information", "pending", "caution", "danger"], eu = {
  type: {
    type: String,
    default: "standard"
  },
  title: {
    type: String,
    default: ""
  },
  description: {
    type: String,
    default: ""
  },
  status: {
    type: String,
    default: "default"
  },
  className: {
    type: String,
    default: ""
  },
  state: {
    type: String,
    validator: (e) => q1.includes(e),
    default: "danger"
  },
  fullwidth: {
    type: Boolean,
    default: !1
  },
  viewOnly: {
    type: Boolean,
    default: !0
  },
  subDescription: {
    type: String,
    default: ""
  },
  icon: {
    type: String,
    default: ""
  },
  loading: {
    type: Boolean,
    default: !1
  },
  customColor: {
    type: String,
    default: ""
  }
}, tu = {
  onClick: (e) => e instanceof MouseEvent
}, ru = (e, t) => {
  const { title: r, description: n, type: s, status: a, subDescription: i, icon: l, fullwidth: u, viewOnly: d, loading: c, customColor: p } = ye(e), h = ["restday", "vacation", "holiday", "exempt", "sick", "emergency"], y = {
    standard: "Standard Day Shift",
    "early-morning": "Early Morning",
    "late-morning": "Late Morning",
    afternoon: "Afternoon Shift",
    graveyard: "Graveyard Shift",
    broken: "Broken Shift",
    "multi-break": "Multi Break Shift",
    "flexible-break": "Flexible Break Shift",
    "flexible-weekly": "Flexible Weekly",
    "flexible-daily": "Flexible Daily",
    "fixed-flexible": "Fixed Flexible",
    restday: "RESTDAY",
    vacation: "VACATION",
    emergency: "EMERGENCY",
    exempt: "EXEMPT",
    sick: "SICK",
    holiday: "HOLIDAY"
  }, M = {
    restday: "ph:prohibit",
    holiday: "ph:prohibit",
    exempt: "ph:prohibit",
    vacation: "ph:island",
    sick: "ph:pill",
    emergency: "ph:ambulance"
  }, g = {
    standard: "spr-border-kangkong-700 spr-bg-kangkong-50",
    "early-morning": "spr-border-blueberry-700 spr-bg-blueberry-50",
    "late-morning": "spr-border-color-pending-base spr-bg-mango-50",
    afternoon: "spr-border-carrot-600 spr-bg-carrot-50",
    graveyard: "spr-border-wintermelon-600 spr-bg-wintermelon-50",
    broken: "spr-border-ubas-700 spr-bg-ubas-50",
    "multi-break": "spr-border-[#F652F2] spr-bg-[#FDECFD]",
    "flexible-break": "spr-border-[#24B155] spr-bg-[#CEFFE1]",
    "flexible-weekly": "spr-border-[#539300] spr-bg-[#EBFFD2]",
    "flexible-daily": "spr-border-[#0084CB] spr-bg-[#D4F0FF]",
    "fixed-flexible": "spr-border-[#C771A6] spr-bg-[#FFF2FA]"
  }, v = F(() => r.value || n.value || N.value), m = F(() => h.includes(s.value) && a.value != "error"), I = F(() => a.value === "error"), N = F(() => i.value || y[s.value]), w = F(() => l.value || M[s.value]), E = F(() => g[s.value] || "spr-border-color-supporting spr-background-color-surface"), $ = F(() => !p.value || !p.value.startsWith("#") ? {} : {
    borderColor: p.value,
    backgroundColor: p.value.startsWith("#") ? `${p.value}20` : p.value
  });
  return {
    getCalendarCellClassess: F(() => {
      const k = L(
        "spr-flex spr-items-center spr-p-size-spacing-3xs spr-gap-size-spacing-3xs spr-relative spr-rounded-lg spr-border-2 spr-transition-all sm:spr-flex-col spr-overflow-hidden",
        {
          "spr-w-full": u.value,
          "spr-max-w-[217px]": !u.value,
          "hover:spr-drop-shadow-sm spr-cursor-pointer": !d.value,
          "spr-h-[80px] spr-skeletal-loader": c.value
        }
      ), b = L({
        "spr-border-dashed": a.value === "pending",
        "spr-border-solid spr-border-color-danger-base": a.value === "error",
        "spr-border-solid": !a.value || a.value !== "pending" && a.value !== "error"
      }), P = L("spr-text-color-strong spr-body-sm-regular-medium", {
        "spr-text-color-danger-base": a.value === "error"
      }), V = L("spr-text-color-strong spr-body-sm-regular", {
        "spr-text-color-danger-base": a.value === "error"
      }), Z = L("spr-text-color-strong spr-body-sm-regular", {
        "spr-text-color-danger-base": a.value === "error",
        "spr-text-color-strong spr-body-sm-regular-medium": h.includes(s.value)
      }), j = L(k, E.value, b);
      return {
        titleClasses: P,
        descriptionClasses: V,
        getTypeLabelClassess: Z,
        getMainClasses: j,
        getCellClasses: E
      };
    }),
    getCellIcon: w,
    offlineStatus: h,
    getShiftLabel: N,
    hasIconStatus: m,
    isError: I,
    hasContent: v,
    handleClick: (k) => {
      if (d.value) {
        k.stopPropagation();
        return;
      }
      t("onClick", k);
    },
    getCustomColorStyles: $
  };
}, nu = ["success", "information", "pending", "caution", "danger"], su = ["2xs", "xs", "sm", "base", "lg", "xl", "2xl"], au = {
  state: {
    type: String,
    validator: (e) => nu.includes(e),
    default: "success"
  },
  size: {
    type: String,
    validator: (e) => su.includes(e),
    default: "base"
  }
}, ou = (e) => {
  const t = F(() => ({
    "2xs": "spr-w-[14px] spr-h-[14px]",
    xs: "spr-w-4 spr-h-4",
    sm: "spr-w-5 spr-h-5",
    base: "spr-w-6 spr-h-6",
    lg: "spr-w-8 spr-h-8",
    xl: "spr-w-10 spr-h-10",
    "2xl": "spr-w-12 spr-h-12"
  })[e.size] || "spr-w-6 spr-h-6"), r = F(() => ({
    success: "spr-text-kangkong-600",
    information: "spr-text-blueberry-700",
    pending: "spr-text-mango-500",
    caution: "spr-text-carrot-500",
    danger: "spr-text-tomato-600"
  })[e.state] || "spr-text-kangkong-600"), n = F(() => ({
    success: "ph:check-circle-fill",
    information: "ph:info-fill",
    pending: "ph:warning-fill",
    caution: "ph:warning-fill",
    danger: "ph:warning-circle-fill"
  })[e.state] || "ph:check-circle-fill"), s = F(() => ({
    success: "Success",
    information: "Information",
    pending: "Pending",
    caution: "Caution",
    danger: "Danger"
  })[e.state] || "Success");
  return {
    statusIcon: n,
    statusClass: r,
    statusDescription: s,
    statusSize: t
  };
}, ws = /* @__PURE__ */ ae({
  __name: "status",
  props: au,
  setup(e) {
    const t = e, { statusIcon: r, statusClass: n, statusDescription: s, statusSize: a } = ou(t);
    return (i, l) => (f(), K(o(W), {
      icon: o(r),
      class: x([o(n), o(a)]),
      "aria-label": o(s)
    }, null, 8, ["icon", "class", "aria-label"]));
  }
}), iu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ws
}, Symbol.toStringTag, { value: "Module" })), lu = {
  key: 1,
  class: "spr-break-words"
}, Ht = /* @__PURE__ */ ae({
  __name: "calendar-cell",
  props: eu,
  emits: tu,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      getCalendarCellClassess: s,
      getShiftLabel: a,
      getCellIcon: i,
      hasIconStatus: l,
      isError: u,
      hasContent: d,
      handleClick: c,
      getCustomColorStyles: p
    } = ru(r, n);
    return (h, y) => r.loading ? (f(), C("div", {
      key: 1,
      class: x(o(s).getMainClasses),
      style: De(r.customColor ? o(p) : {})
    }, null, 6)) : (f(), C("div", {
      key: 0,
      class: x(o(s).getMainClasses),
      style: De(r.customColor ? o(p) : {}),
      onClick: y[0] || (y[0] = //@ts-ignore
      (...M) => o(c) && o(c)(...M))
    }, [
      ee(h.$slots, "prefix", {}, () => [
        o(l) ? (f(), K(o(W), {
          key: 0,
          icon: o(i)
        }, null, 8, ["icon"])) : _("", !0)
      ]),
      ee(h.$slots, "default", {}, () => [
        o(u) ? (f(), K(ws, {
          key: 0,
          state: r.state,
          size: "sm"
        }, null, 8, ["state"])) : _("", !0),
        o(d) ? (f(), C("div", lu, [
          r.title ? (f(), C("div", {
            key: 0,
            class: x(o(s).titleClasses)
          }, G(r.title), 3)) : _("", !0),
          h.description ? (f(), C("div", {
            key: 1,
            class: x(o(s).descriptionClasses)
          }, G(r.description), 3)) : _("", !0),
          o(a) ? (f(), C("div", {
            key: 2,
            class: x(o(s).getTypeLabelClassess)
          }, G(o(a)), 3)) : _("", !0)
        ])) : _("", !0)
      ])
    ], 6));
  }
}), uu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ht
}, Symbol.toStringTag, { value: "Module" })), du = ["xl", "lg", "md", "sm", "xs", "2xs"], cu = {
  title: {
    type: String,
    default: ""
  },
  subtitle: {
    type: String,
    default: ""
  },
  headerIcon: {
    type: String,
    default: ""
  },
  showHeader: {
    type: Boolean,
    default: !0
  },
  showFooter: {
    type: Boolean,
    default: !0
  },
  borderRadiusSize: {
    type: String,
    validator: (e) => du.includes(e),
    default: "xl"
  },
  hasCollapsible: {
    type: Boolean,
    default: !1
  },
  isCollapsibleOpen: {
    type: Boolean,
    default: !1
  },
  hasContentPadding: {
    type: Boolean,
    default: !0
  },
  flexbox: {
    type: Boolean,
    default: !1
  }
}, pu = (e, t) => {
  const { title: r, headerIcon: n, borderRadiusSize: s, hasCollapsible: a, isCollapsibleOpen: i, hasContentPadding: l, flexbox: u } = ye(e);
  return {
    cardClasses: F(() => {
      const c = L(
        "spr-bg-white-50 spr-text-color-strong spr-border spr-border-solid spr-border-mushroom-200",
        {
          "spr-rounded-border-radius-2xs": s.value === "xs",
          "spr-rounded-border-radius-xs": s.value === "sm",
          "spr-rounded-border-radius-sm": s.value === "md",
          "spr-rounded-border-radius-md": s.value === "xs",
          "spr-rounded-border-radius-lg": s.value === "lg",
          "spr-rounded-border-radius-xl": s.value === "xl" || !s.value
        }
      ), p = L("spr-flex spr-items-center transition-all duration-300 ease-in-out", {
        "spr-min-h-[18px]": t.header,
        "spr-border-0 spr-border-b spr-border-solid spr-border-mushroom-200": (r.value || n.value) && (t.content || t.default),
        "spr-border-transparent": a.value && !i.value,
        "spr-py-size-spacing-2xs spr-px-size-spacing-xs": r.value || n.value,
        "spr-rounded-t-border-radius-2xs": s.value === "xs",
        "spr-rounded-t-border-radius-xs": s.value === "sm",
        "spr-rounded-t-border-radius-sm": s.value === "md",
        "spr-rounded-t-border-radius-md": s.value === "xs",
        "spr-rounded-t-border-radius-lg": s.value === "lg",
        "spr-rounded-t-border-radius-xl": s.value === "xl" || !s.value
      }), h = L({
        "spr-py-size-spacing-2xs spr-px-size-spacing-xs": l.value
      }), y = L(
        "spr-flex spr-items-center spr-border-0 spr-border-t spr-border-solid spr-border-mushroom-200 spr-py-size-spacing-2xs spr-px-size-spacing-xs",
        {
          "spr-rounded-b-border-radius-2xs": s.value === "xs",
          "spr-rounded-b-border-radius-xs": s.value === "sm",
          "spr-rounded-b-border-radius-sm": s.value === "md",
          "spr-rounded-b-border-radius-md": s.value === "xs",
          "spr-rounded-b-border-radius-lg": s.value === "lg",
          "spr-rounded-b-border-radius-xl": s.value === "xl" || !s.value
        }
      ), M = L({
        "spr-flex spr-flex-col spr-h-full": u.value
      });
      return {
        baseClasses: c,
        headerClasses: p,
        contentPaddingSizeClasses: h,
        footerClasses: y,
        hasFlexBox: M
      };
    })
  };
}, fu = {
  key: 0,
  class: "spr-flex spr-items-center"
}, gu = { class: "spr-mr-size-spacing-3xs" }, hu = { class: "spr-body-md-regular-medium spr-text-mushroom-950" }, yu = {
  key: 0,
  class: "spr-body-xs-regular spr-text-mushroom-600"
}, Ss = /* @__PURE__ */ ae({
  __name: "card",
  props: cu,
  setup(e) {
    const t = e, r = It(), { cardClasses: n } = pu(t, r);
    return (s, a) => (f(), C("div", {
      class: x(o(n).baseClasses)
    }, [
      t.showHeader && (s.$slots.header || t.title) ? (f(), C("div", {
        key: 0,
        class: x(o(n).headerClasses)
      }, [
        t.title ? (f(), C("div", fu, [
          t.headerIcon ? (f(), K(o(W), {
            key: 0,
            icon: t.headerIcon,
            class: "spr-me-size-spacing-3xs spr-h-6 spr-w-6 spr-text-kangkong-600"
          }, null, 8, ["icon"])) : _("", !0),
          A("div", gu, [
            A("div", hu, G(t.title), 1),
            t.subtitle ? (f(), C("div", yu, G(t.subtitle), 1)) : _("", !0)
          ])
        ])) : _("", !0),
        s.$slots.header ? ee(s.$slots, "header", { key: 1 }) : _("", !0)
      ], 2)) : _("", !0),
      s.$slots.content ? (f(), C("div", {
        key: 1,
        class: x([o(n).contentPaddingSizeClasses, o(n).hasFlexBox])
      }, [
        ee(s.$slots, "content")
      ], 2)) : _("", !0),
      ee(s.$slots, "default"),
      s.$slots.footer && s.$props.showFooter ? (f(), C("div", {
        key: 2,
        class: x(o(n).footerClasses)
      }, [
        ee(s.$slots, "footer")
      ], 2)) : _("", !0)
    ], 2));
  }
}), Cu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ss
}, Symbol.toStringTag, { value: "Module" })), vu = ["plain", "pending", "information", "success", "danger", "neutral", "caution"], mu = {
  /**
   * @description Lozenge Label
   */
  label: {
    type: String,
    default: "label"
  },
  /**
   * @description Lozenge tone
   */
  tone: {
    type: String,
    validator: (e) => vu.includes(e),
    default: "plain"
  },
  /**
   * @description Lozenge type (fill or outline)
   */
  fill: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Lozenge removable
   */
  removable: {
    type: Boolean,
    default: !1
  },
  /**
   * @description avatar image url
   */
  url: {
    type: String,
    default: ""
  },
  /**
   * @description handler if the lozenge is visible
   */
  visible: {
    type: Boolean,
    default: !0
  },
  loading: {
    type: Boolean,
    default: !1
  }
}, Mu = (e) => {
  const { tone: t, fill: r, loading: n } = ye(e);
  return {
    lozengeClasses: F(() => {
      const a = L({
        "spr-h-fit spr-w-fit": !n.value,
        "spr-flex spr-w-full": n.value
      }), i = L({
        "spr-flex spr-flex-wrap spr-rounded-md": !r.value,
        "spr-flex spr-flex-wrap": r.value,
        "spr-skeletal-loader spr-flex spr-h-6 spr-w-full spr-rounded-md": n.value
      }), l = L(
        "spr-label-xs-medium spr-inline-flex spr-items-center spr-gap-size-spacing-6xs spr-rounded-md spr-border spr-border-solid spr-p-size-spacing-5xs spr-text-xs spr-uppercase",
        {
          "spr-text-color-pending-base spr-background-color-pending-weak !spr-border-color-pending-base": t.value === "pending" && !r.value,
          "spr-text-color-information-base spr-background-color-information-weak !spr-border-color-information-base": t.value === "information" && !r.value,
          "spr-text-color-success-base spr-background-color-success-weak !spr-border-color-success-base": t.value === "success" && !r.value,
          "spr-text-color-base spr-background-color-base !spr-border-color-base": t.value === "neutral" && !r.value,
          "spr-text-color-danger-base spr-background-color-danger-weak !spr-border-color-danger-base": t.value === "danger" && !r.value,
          "spr-text-color-caution-base spr-background-color-caution-weak !spr-border-color-caution-base": t.value === "caution" && !r.value,
          "spr-text-color-strong !spr-border-color-base spr-background-color": t.value === "plain" && !r.value,
          "spr-background-color-pending-base spr-text-color-strong !spr-border-0": t.value === "pending" && r.value,
          "spr-background-color-information-base spr-text-color-inverted-strong !spr-border-0": t.value === "information" && r.value,
          "spr-background-color-success-base spr-text-color-inverted-strong !spr-border-0": t.value === "success" && r.value,
          "spr-background-color-base spr-text-color-strong !spr-border-0": t.value === "neutral" && r.value,
          "spr-background-color-danger-base spr-text-color-inverted-strong !spr-border-0": t.value === "danger" && r.value,
          "spr-background-color-caution-base spr-text-color-strong !spr-border-0": t.value === "caution" && r.value,
          "spr-text-color-strong spr-background-color !spr-border-0": t.value === "plain" && r.value
        }
      );
      return {
        wrapperClasses: a,
        baseClasses: i,
        toneClasses: l
      };
    })
  };
}, bu = {
  key: 0,
  class: "spr-flex spr-h-3 spr-w-3 spr-items-center spr-overflow-hidden"
}, Nu = {
  key: 1,
  class: "spr-flex spr-items-center"
}, $u = {
  key: 2,
  class: "spr-h-4 spr-w-4 spr-overflow-hidden"
}, Du = ["src"], P2 = /* @__PURE__ */ ae({
  __name: "lozenge",
  props: mu,
  setup(e) {
    const t = e, { lozengeClasses: r } = Mu(t);
    return (n, s) => (f(), C("div", {
      class: x(o(r).wrapperClasses)
    }, [
      n.visible && !n.loading ? (f(), C("div", {
        key: 0,
        class: x(o(r).baseClasses)
      }, [
        A("div", {
          class: x(o(r).toneClasses)
        }, [
          n.$slots.icon ? (f(), C("div", bu, [
            ee(n.$slots, "icon")
          ])) : _("", !0),
          n.$slots.avatar ? (f(), C("div", Nu, [
            ee(n.$slots, "avatar")
          ])) : _("", !0),
          n.url && !n.$slots.avatar ? (f(), C("div", $u, [
            A("img", {
              class: "spr-h-full spr-w-full spr-rounded-full spr-object-cover",
              src: n.url,
              alt: "avatar"
            }, null, 8, Du)
          ])) : _("", !0),
          A("div", null, G(n.label), 1)
        ], 2)
      ], 2)) : _("", !0),
      n.visible && n.loading ? (f(), C("div", {
        key: 1,
        class: x(o(r).baseClasses)
      }, null, 2)) : _("", !0)
    ], 2));
  }
}), Iu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P2
}, Symbol.toStringTag, { value: "Module" })), Au = ["small", "large"], xu = [
  "bug",
  "clock",
  "dashboard",
  "employees",
  "government-id",
  "integration",
  "list",
  "social-media-handles",
  "work-in-progress",
  "work-location"
], wu = {
  description: {
    type: String,
    required: !1,
    default: "No results found"
  },
  subDescription: {
    type: String,
    required: !1,
    default: "Try a different search term."
  },
  size: {
    type: String,
    validator: (e) => Au.includes(e),
    default: "small"
  },
  image: {
    type: String,
    default: "list",
    validator: (e) => e === void 0 || xu.includes(e)
  },
  hasButton: {
    type: Boolean,
    default: !1
  },
  emptyStateCustomClasses: {
    type: String,
    default: ""
  }
}, Su = "data:image/svg+xml,%3csvg%20width='120'%20height='120'%20viewBox='0%200%20120%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_4843_5570)'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3cg%20clip-path='url(%23clip1_4843_5570)'%3e%3cpath%20d='M33.9068%20100.598C34.7864%2098.712%2035.6653%2096.7974%2036.047%2094.7534C36.4287%2092.7093%2036.2685%2090.4909%2035.1752%2088.718C34.082%2086.945%2031.9293%2085.7428%2029.8751%2086.1436C28.1878%2086.4728%2026.8331%2087.7923%2026.0398%2089.3073C25.2465%2090.8222%2024.9282%2092.5308%2024.6197%2094.2106C24.52%2092.3023%2024.4144%2090.3632%2023.776%2088.5605C23.1376%2086.7579%2021.8806%2085.0779%2020.089%2084.3804C18.2975%2083.6828%2015.9669%2084.2314%2015.0227%2085.8964C13.6924%2088.2422%2015.4563%2091.5326%2013.9267%2093.7553C13.6643%2091.5257%2011.3164%2089.7642%209.08488%2090.1227C6.85338%2090.4813%205.18467%2092.8882%205.64372%2095.0861C5.91687%2096.394%206.81547%2097.5064%207.88981%2098.3101C8.96415%2099.1137%2010.2136%20100.045%2011.4497%20100.572L33.9068%20100.598Z'%20fill='%23F2F2F2'%20/%3e%3cpath%20d='M6.81533%2091.6981C8.5879%2092.3133%2010.3768%2092.9355%2011.995%2093.8974C13.4454%2094.7595%2014.7369%2095.9202%2015.5526%2097.4066C15.9995%2098.2041%2016.2648%2099.0891%2016.3299%2099.9994C16.3417%20100.19%2016.6416%20100.191%2016.6298%2099.9994C16.5249%2098.3042%2015.6929%2096.7529%2014.5409%2095.526C13.2778%2094.1808%2011.6411%2093.2621%209.95115%2092.5493C8.94917%2092.1267%207.92228%2091.7675%206.89506%2091.4109C6.71251%2091.3476%206.63403%2091.6351%206.81533%2091.6981Z'%20fill='white'%20/%3e%3cpath%20d='M17.0397%2084.6759C18.1287%2086.4776%2019.0008%2088.4%2019.638%2090.4038C20.2765%2092.4068%2020.6786%2094.4767%2020.8364%2096.5718C20.9238%2097.7447%2020.9333%2098.922%2020.865%20100.096C20.8539%20100.287%2021.1538%20100.287%2021.1648%20100.096C21.2858%2097.9792%2021.1568%2095.8556%2020.7804%2093.7686C20.4047%2091.6818%2019.787%2089.6452%2018.9399%2087.6993C18.4644%2086.6064%2017.9161%2085.5461%2017.2986%2084.5256C17.2778%2084.493%2017.2451%2084.4696%2017.2073%2084.4604C17.1695%2084.4513%2017.1296%2084.457%2017.096%2084.4765C17.0624%2084.496%2017.0378%2084.5277%2017.0272%2084.5649C17.0167%2084.6021%2017.0212%2084.6419%2017.0397%2084.6759Z'%20fill='white'%20/%3e%3cpath%20d='M31.7166%2086.3865C30.1762%2089.8234%2029.0921%2093.4445%2028.4917%2097.1588C28.3232%2098.2022%2028.1927%2099.2506%2028.1003%20100.304C28.0835%20100.495%2028.3835%20100.494%2028.4001%20100.304C28.7267%2096.5981%2029.5333%2092.9493%2030.8%2089.4482C31.156%2088.4639%2031.5478%2087.4934%2031.9755%2086.5368C32.0531%2086.3632%2031.7948%2086.2115%2031.7166%2086.3865Z'%20fill='white'%20/%3e%3cpath%20d='M84.9008%20104.655L84.8767%20102.806L76.0999%20102.919L76.124%20104.767L84.9008%20104.655Z'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M88.0195%20105.067L86.7661%20105.064L85.9913%20103.691L86.8288%20102.323L87.9933%20102.326C87.7017%20101.958%2087.3012%20101.689%2086.8481%20101.558C86.395%20101.427%2085.912%20101.44%2085.4668%20101.596C85.0215%20101.751%2084.6364%20102.041%2084.3654%20102.424C84.0944%20102.808%2083.951%20103.266%2083.9555%20103.735C83.96%20104.203%2084.112%20104.659%2084.3903%20105.037C84.6686%20105.416%2085.0592%20105.698%2085.5073%20105.845C85.9555%20105.992%2086.4387%20105.996%2086.8892%20105.857C87.3397%20105.717%2087.7349%20105.441%2088.0195%20105.067Z'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M72.9813%20105.067L74.2346%20105.064L75.0095%20103.691L74.172%20102.323L73.0074%20102.326C73.2991%20101.958%2073.6995%20101.689%2074.1526%20101.558C74.6057%20101.427%2075.0888%20101.44%2075.534%20101.596C75.9792%20101.751%2076.3644%20102.041%2076.6354%20102.424C76.9064%20102.808%2077.0497%20103.266%2077.0452%20103.735C77.0408%20104.203%2076.8887%20104.659%2076.6104%20105.037C76.3321%20105.416%2075.9416%20105.698%2075.4934%20105.845C75.0453%20105.992%2074.5621%20105.996%2074.1116%20105.857C73.6611%20105.717%2073.2658%20105.441%2072.9813%20105.067Z'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M123.812%20100.759H-5.81159C-5.86156%20100.759%20-5.90948%20100.739%20-5.94482%20100.704C-5.98015%20100.669%20-6%20100.622%20-6%20100.572C-6%20100.522%20-5.98015%20100.475%20-5.94482%20100.44C-5.90948%20100.405%20-5.86156%20100.385%20-5.81159%20100.385H123.812C123.862%20100.385%20123.909%20100.405%20123.945%20100.44C123.98%20100.475%20124%20100.522%20124%20100.572C124%20100.622%20123.98%20100.669%20123.945%20100.704C123.909%20100.739%20123.862%20100.759%20123.812%20100.759Z'%20fill='%23E4E4E4'%20/%3e%3cpath%20d='M95.8307%2065.2121C99.2645%2065.2121%20102.048%2062.4479%20102.048%2059.0381C102.048%2055.6283%2099.2645%2052.8641%2095.8307%2052.8641C92.397%2052.8641%2089.6133%2055.6283%2089.6133%2059.0381C89.6133%2062.4479%2092.397%2065.2121%2095.8307%2065.2121Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M98.3503%2093.6977L98.8292%2095.9415L107.773%2095.1753L107.066%2091.8636L98.3503%2093.6977Z'%20fill='%23FFB8B8'%20/%3e%3cpath%20d='M97.6544%20100.711L96.1494%2093.6585L98.8933%2093.0811L99.8168%2097.4085C99.971%2098.1311%2099.8298%2098.885%2099.4242%2099.5043C99.0187%20100.124%2098.3821%20100.557%2097.6544%20100.711Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M92.7472%2093.578L91.7406%2095.6426L83.2427%2092.7694L84.7285%2089.7227L92.7472%2093.578Z'%20fill='%23FFB8B8'%20/%3e%3cpath%20d='M90.4277%2096.8314L92.3689%2092.8501L94.8934%2094.0638L91.7298%20100.552C91.3983%20100.393%2091.1016%20100.17%2090.8568%2099.8967C90.6119%2099.6235%2090.4237%2099.305%2090.3028%2098.9595C90.1819%2098.614%2090.1307%2098.2483%2090.1521%2097.8832C90.1735%2097.518%2090.2672%2097.1606%2090.4277%2096.8314Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M76.0054%2089.5008C76.2963%2089.5546%2076.5955%2089.5443%2076.882%2089.4709C77.1685%2089.3974%2077.4353%2089.2624%2077.6636%2089.0755C77.8918%2088.8886%2078.0761%2088.6542%2078.2033%2088.3889C78.3305%2088.1236%2078.3976%2087.8339%2078.3998%2087.54L92.4123%2074.7111L88.9324%2072.0347L76.2456%2085.4946C75.7483%2085.5236%2075.279%2085.7327%2074.9266%2086.0823C74.5742%2086.432%2074.3632%2086.8979%2074.3336%2087.3917C74.3039%2087.8855%2074.4578%2088.373%2074.7659%2088.7617C75.074%2089.1504%2075.515%2089.4134%2076.0054%2089.5008Z'%20fill='%23FFB8B8'%20/%3e%3cpath%20d='M95.0504%2065.4908C97.6061%2065.4908%2099.6779%2063.4335%2099.6779%2060.8957C99.6779%2058.3578%2097.6061%2056.3005%2095.0504%2056.3005C92.4948%2056.3005%2090.423%2058.3578%2090.423%2060.8957C90.423%2063.4335%2092.4948%2065.4908%2095.0504%2065.4908Z'%20fill='%23FFB8B8'%20/%3e%3cpath%20d='M99.2032%2087.9067C95.9572%2087.9068%2092.0479%2087.2279%2089.6362%2084.4499L89.5819%2084.3873L89.6378%2084.3259C89.656%2084.3059%2091.4302%2082.2925%2089.6587%2078.7018L87.223%2079.4459L84.7982%2076.2675L86.1414%2072.2658L91.6386%2067.8685C92.4263%2067.2419%2093.3853%2066.8646%2094.3914%2066.7854C96.2121%2066.6106%2097.9858%2066.109%2099.6261%2065.3049C100.377%2064.9428%20101.203%2064.7634%20102.038%2064.7814L102.146%2064.7844C102.4%2064.7915%20102.649%2064.8497%20102.88%2064.9555C103.11%2065.0612%20103.316%2065.2123%20103.486%2065.3996C103.656%2065.5869%20103.786%2065.8066%20103.868%2066.0452C103.949%2066.2837%20103.982%2066.5364%20103.962%2066.7877C103.589%2071.5828%20102.931%2083.1662%20104.865%2087.1545L104.915%2087.2576L104.803%2087.2857C102.965%2087.6964%20101.087%2087.9046%2099.2032%2087.9067Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M90.2728%2084.3888C90.2728%2084.3888%2078.0264%2083.2662%2076.7075%2086.821C75.3887%2090.3757%2076.8959%2092.0595%2079.1568%2092.8078C81.4177%2093.5562%2086.8815%2094.4916%2086.8815%2094.4916L89.3307%2091.4982L95.7365%2091.8724C95.7365%2091.8724%20102.874%2095.9833%20104.848%20100.38C105.271%20101.332%20105.946%20102.151%20106.802%20102.752C107.657%20103.353%20108.66%20103.713%20109.704%20103.792C111.287%20103.902%20112.693%20103.308%20112.693%20100.853C112.693%2095.24%20104.78%2087.1951%20104.78%2087.1951L90.2728%2084.3888Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M80.9467%2089.9079C80.9467%2089.9079%2084.1496%2088.9725%2089.2365%2091.4046L80.9467%2089.9079Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M90.4341%2057.9652C92.2413%2059.0607%2094.2787%2059.7273%2096.3876%2059.9132L95.7601%2059.1665C96.217%2059.3343%2096.6978%2059.4291%2097.1846%2059.4474C97.4284%2059.4544%2097.6704%2059.4046%2097.8912%2059.302C98.112%2059.1993%2098.3056%2059.0467%2098.4563%2058.8563C98.5794%2058.6587%2098.6525%2058.4344%2098.6694%2058.2026C98.6863%2057.9708%2098.6465%2057.7384%2098.5534%2057.5252C98.3622%2057.0999%2098.0645%2056.7303%2097.6887%2056.4516C97.0227%2055.9284%2096.2367%2055.577%2095.4007%2055.4286C94.5647%2055.2802%2093.7048%2055.3396%2092.8975%2055.6013C92.3437%2055.7656%2091.8478%2056.0815%2091.4664%2056.5128C91.279%2056.7301%2091.1488%2056.9901%2091.0876%2057.2697C91.0263%2057.5492%2091.0359%2057.8395%2091.1155%2058.1145'%20fill='%232F2E41'%20/%3e%3cpath%20d='M95.7974%2054.2924C96.6196%2052.3967%2097.8503%2050.703%2099.4029%2049.3305C100.4%2048.4507%20101.564%2047.6948%20102.878%2047.4666C104.192%2047.2384%20105.673%2047.6293%20106.479%2048.6848C107.138%2049.5478%20107.261%2050.704%20107.188%2051.7847C107.116%2052.8653%20106.873%2053.9355%20106.896%2055.0184C106.92%2056.1232%20107.221%2057.2047%20107.772%2058.1646C108.324%2059.1246%20109.108%2059.9325%20110.054%2060.5152C110.999%2061.0978%20112.076%2061.4367%20113.187%2061.5011C114.298%2061.5655%20115.408%2061.3533%20116.416%2060.8838C115.281%2061.5066%20114.397%2062.4924%20113.344%2063.2427C112.29%2063.993%20110.901%2064.5074%20109.705%2064.0117C108.439%2063.4871%20107.859%2062.0623%20107.405%2060.7769L105.383%2055.0445C105.04%2054.0701%20104.679%2053.0667%20103.978%2052.3045C103.276%2051.5424%20102.138%2051.0778%20101.172%2051.461C100.441%2051.7514%2099.9641%2052.4446%2099.5463%2053.1082C99.1285%2053.7717%2098.6878%2054.4776%2097.9819%2054.8255C97.276%2055.1734%2096.23%2054.9592%2095.9993%2054.211'%20fill='%232F2E41'%20/%3e%3cpath%20d='M95.6686%2082.0918L94.3691%2083.416L100.656%2089.499L101.955%2088.1749L95.6686%2082.0918Z'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M100.734%2088.2839C100.477%2088.5458%20100.304%2088.8775%20100.237%2089.237C100.169%2089.5966%20100.211%2089.9678%20100.356%2090.3038C100.502%2090.6398%20100.744%2090.9255%20101.053%2091.1247C101.362%2091.3239%20101.723%2091.4277%20102.091%2091.423C102.46%2091.4182%20102.818%2091.3052%20103.122%2091.0981C103.425%2090.891%20103.66%2090.5992%20103.796%2090.2596C103.933%2089.92%20103.965%2089.5478%20103.889%2089.1901C103.812%2088.8324%20103.63%2088.5053%20103.367%2088.2501C103.013%2087.9078%20102.537%2087.7192%20102.043%2087.7255C101.549%2087.7318%20101.078%2087.9327%20100.734%2088.2839ZM102.639%2090.1272C102.529%2090.2395%20102.387%2090.3168%20102.233%2090.3493C102.079%2090.3819%20101.918%2090.3683%20101.771%2090.3102C101.625%2090.2521%20101.499%2090.1521%20101.41%2090.0229C101.32%2089.8938%20101.271%2089.7412%20101.269%2089.5845C101.267%2089.4278%20101.312%2089.274%20101.398%2089.1426C101.484%2089.0111%20101.607%2088.908%20101.752%2088.8462C101.897%2088.7843%20102.058%2088.7666%20102.213%2088.7951C102.368%2088.8237%20102.511%2088.8974%20102.624%2089.0067C102.776%2089.1534%20102.862%2089.3538%20102.865%2089.564C102.868%2089.7741%20102.786%2089.9767%20102.639%2090.1272Z'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M93.757%2079.6104L94.6407%2080.493L94.2111%2082.0077L92.6448%2082.387L91.8237%2081.567C91.7676%2082.0323%2091.8595%2082.5033%2092.0866%2082.9141C92.3137%2083.3249%2092.6646%2083.6548%2093.09%2083.8576C93.5154%2084.0604%2093.9941%2084.1259%2094.4589%2084.045C94.9238%2083.964%2095.3514%2083.7406%2095.6819%2083.4061C96.0124%2083.0716%2096.2293%2082.6428%2096.302%2082.1798C96.3747%2081.7168%2096.2997%2081.2427%2096.0874%2080.8242C95.8752%2080.4056%2095.5363%2080.0635%2095.1184%2079.8459C94.7005%2079.6282%2094.2244%2079.5458%2093.757%2079.6104Z'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M97.385%2087.9228C97.3052%2087.9227%2097.2254%2087.9184%2097.1461%2087.9096C96.681%2087.8561%2096.2478%2087.648%2095.9167%2087.3192C95.5856%2086.9904%2095.3762%2086.5602%2095.3223%2086.0984C95.2892%2085.8102%2095.3178%2085.5184%2095.4062%2085.242C95.4946%2084.9656%2095.6408%2084.7109%2095.8352%2084.4945C96.0297%2084.2781%2096.268%2084.105%2096.5345%2083.9864C96.801%2083.8679%2097.0897%2083.8066%2097.3818%2083.8065C97.4742%2083.807%2097.5665%2083.8138%2097.658%2083.827L103.984%2077.1394L103.324%2074.9534L106.641%2073.4769L107.57%2075.7332C107.882%2076.4976%20107.937%2077.3413%20107.727%2078.1391C107.518%2078.9369%20107.054%2079.6463%20106.407%2080.1621L99.4429%2085.6627C99.4503%2085.7297%2099.454%2085.7971%2099.4542%2085.8645C99.454%2086.1539%2099.3925%2086.44%2099.2735%2086.7043C99.1546%2086.9685%2098.981%2087.2049%2098.7639%2087.398C98.386%2087.7371%2097.8944%2087.9242%2097.385%2087.9228Z'%20fill='%23FFB8B8'%20/%3e%3cpath%20d='M102.331%2065.6798C102.55%2065.583%20102.787%2065.5312%20103.027%2065.5276C103.267%2065.5239%20103.505%2065.5685%20103.727%2065.6586C103.95%2065.7487%20104.151%2065.8825%20104.32%2066.0519C104.489%2066.2213%20104.621%2066.4229%20104.71%2066.6445L107.983%2074.8472L102.896%2078.2148L102.331%2065.6798Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M78.4974%2067.5951V26.7263C78.4956%2025.4734%2077.9936%2024.2722%2077.1014%2023.3863C76.2092%2022.5003%2074.9996%2022.0018%2073.7378%2022H9.06376C7.802%2022.0018%206.59242%2022.5003%205.70022%2023.3863C4.80801%2024.2722%204.30599%2025.4734%204.3042%2026.7263V67.5951C4.30599%2068.8481%204.80801%2070.0492%205.70022%2070.9352C6.59242%2071.8211%207.802%2072.3197%209.06376%2072.3214H73.7378C74.9996%2072.3197%2076.2092%2071.8211%2077.1014%2070.9352C77.9936%2070.0492%2078.4956%2068.8481%2078.4974%2067.5951ZM9.06376%2071.7654C7.95037%2071.764%206.88297%2071.3242%206.09568%2070.5424C5.30839%2069.7607%204.8655%2068.7007%204.86415%2067.5951V26.7263C4.8655%2025.6207%205.30839%2024.5608%206.09568%2023.779C6.88297%2022.9972%207.95037%2022.5574%209.06376%2022.556H73.7378C74.8512%2022.5574%2075.9186%2022.9972%2076.7059%2023.779C77.4932%2024.5608%2077.9361%2025.6207%2077.9374%2026.7263V67.5951C77.9361%2068.7007%2077.4932%2069.7607%2076.7059%2070.5424C75.9186%2071.3242%2074.8512%2071.764%2073.7378%2071.7654H9.06376Z'%20fill='%23E4E4E4'%20/%3e%3cpath%20d='M77.9375%2029.3533H4.86417C4.78991%2029.3533%204.7187%2029.324%204.6662%2029.2718C4.6137%2029.2197%204.5842%2029.149%204.5842%2029.0753C4.5842%2029.0015%204.6137%2028.9308%204.6662%2028.8787C4.7187%2028.8265%204.78991%2028.7972%204.86417%2028.7972H77.9375C78.0117%2028.7972%2078.0829%2028.8265%2078.1354%2028.8787C78.1879%2028.9308%2078.2174%2029.0015%2078.2174%2029.0753C78.2174%2029.149%2078.1879%2029.2197%2078.1354%2029.2718C78.0829%2029.324%2078.0117%2029.3533%2077.9375%2029.3533Z'%20fill='%23E4E4E4'%20/%3e%3cpath%20d='M9.62372%2027.2824C10.3968%2027.2824%2011.0236%2026.66%2011.0236%2025.8923C11.0236%2025.1246%2010.3968%2024.5022%209.62372%2024.5022C8.85059%2024.5022%208.22385%2025.1246%208.22385%2025.8923C8.22385%2026.66%208.85059%2027.2824%209.62372%2027.2824Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M14.3833%2027.2824C15.1564%2027.2824%2015.7831%2026.66%2015.7831%2025.8923C15.7831%2025.1246%2015.1564%2024.5022%2014.3833%2024.5022C13.6101%2024.5022%2012.9834%2025.1246%2012.9834%2025.8923C12.9834%2026.66%2013.6101%2027.2824%2014.3833%2027.2824Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M19.1429%2027.2824C19.916%2027.2824%2020.5427%2026.66%2020.5427%2025.8923C20.5427%2025.1246%2019.916%2024.5022%2019.1429%2024.5022C18.3697%2024.5022%2017.743%2025.1246%2017.743%2025.8923C17.743%2026.66%2018.3697%2027.2824%2019.1429%2027.2824Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M29.6047%2059.2743C29.5799%2059.2743%2029.5554%2059.2695%2029.5326%2059.2601C29.5097%2059.2507%2029.4889%2059.2369%2029.4714%2059.2195C29.4539%2059.2021%2029.4401%2059.1815%2029.4306%2059.1588C29.4211%2059.1361%2029.4163%2059.1118%2029.4163%2059.0872C29.4163%2057.1365%2028.5551%2056.0484%2027.1657%2054.925C27.1464%2054.9095%2027.1304%2054.8904%2027.1186%2054.8688C27.1068%2054.8471%2027.0994%2054.8234%2027.0969%2054.7989C27.0943%2054.7744%2027.0966%2054.7497%2027.1037%2054.7261C27.1108%2054.7025%2027.1225%2054.6806%2027.1382%2054.6615C27.1538%2054.6424%2027.1731%2054.6266%2027.1949%2054.6149C27.2167%2054.6032%2027.2407%2054.5959%2027.2653%2054.5935C27.29%2054.591%2027.3149%2054.5934%2027.3386%2054.6005C27.3623%2054.6076%2027.3844%2054.6193%2027.4036%2054.6349C28.8788%2055.8276%2029.7931%2056.9885%2029.7931%2059.0872C29.7931%2059.1118%2029.7882%2059.1361%2029.7787%2059.1588C29.7693%2059.1815%2029.7554%2059.2021%2029.7379%2059.2195C29.7204%2059.2369%2029.6996%2059.2507%2029.6768%2059.2601C29.6539%2059.2695%2029.6294%2059.2743%2029.6047%2059.2743Z'%20fill='black'%20/%3e%3cpath%20d='M13.4654%2059.2743C13.4407%2059.2743%2013.4162%2059.2695%2013.3933%2059.2601C13.3705%2059.2507%2013.3497%2059.2369%2013.3322%2059.2195C13.3147%2059.2021%2013.3008%2059.1815%2013.2914%2059.1588C13.2819%2059.1361%2013.277%2059.1118%2013.277%2059.0872C13.277%2056.9885%2014.1913%2055.8276%2015.6665%2054.6349C15.6857%2054.6193%2015.7078%2054.6076%2015.7315%2054.6005C15.7552%2054.5934%2015.7801%2054.591%2015.8048%2054.5935C15.8295%2054.5959%2015.8534%2054.6032%2015.8752%2054.6149C15.897%2054.6266%2015.9163%2054.6424%2015.932%2054.6615C15.9476%2054.6806%2015.9593%2054.7025%2015.9664%2054.7261C15.9735%2054.7497%2015.9758%2054.7744%2015.9733%2054.7989C15.9707%2054.8234%2015.9633%2054.8471%2015.9515%2054.8688C15.9397%2054.8904%2015.9237%2054.9095%2015.9044%2054.925C14.515%2056.0484%2013.6539%2057.1366%2013.6539%2059.0872C13.6539%2059.1118%2013.649%2059.1361%2013.6395%2059.1588C13.6301%2059.1815%2013.6162%2059.2021%2013.5987%2059.2195C13.5812%2059.2369%2013.5604%2059.2507%2013.5376%2059.2601C13.5147%2059.2695%2013.4902%2059.2743%2013.4654%2059.2743Z'%20fill='black'%20/%3e%3cpath%20d='M27.9909%2046.4529C27.952%2046.4529%2027.914%2046.441%2027.8822%2046.4187C27.8504%2046.3964%2027.8264%2046.3649%2027.8133%2046.3285C27.8003%2046.2921%2027.7989%2046.2526%2027.8094%2046.2154C27.8199%2046.1782%2027.8417%2046.1451%2027.8719%2046.1207C29.3001%2044.9661%2029.4163%2043.3259%2029.4163%2041.4578C29.4163%2041.4082%2029.4361%2041.3606%2029.4715%2041.3256C29.5068%2041.2905%2029.5547%2041.2708%2029.6047%2041.2708C29.6546%2041.2708%2029.7026%2041.2905%2029.7379%2041.3256C29.7732%2041.3606%2029.7931%2041.4082%2029.7931%2041.4578C29.7931%2043.4232%2029.6664%2045.1524%2028.1098%2046.4109C28.0762%2046.4381%2028.0342%2046.453%2027.9909%2046.4529Z'%20fill='black'%20/%3e%3cpath%20d='M15.0793%2046.3528C15.036%2046.3529%2014.994%2046.338%2014.9605%2046.3108C13.4037%2045.0522%2013.277%2043.3684%2013.277%2041.4578C13.277%2041.4082%2013.2969%2041.3606%2013.3322%2041.3256C13.3676%2041.2905%2013.4155%2041.2708%2013.4654%2041.2708C13.5154%2041.2708%2013.5633%2041.2905%2013.5987%2041.3256C13.634%2041.3606%2013.6539%2041.4082%2013.6539%2041.4578C13.6539%2043.3356%2013.7676%2044.8639%2015.1984%2046.0206C15.2285%2046.045%2015.2503%2046.0781%2015.2608%2046.1153C15.2713%2046.1525%2015.2699%2046.192%2015.2569%2046.2284C15.2438%2046.2648%2015.2198%2046.2963%2015.188%2046.3186C15.1562%2046.3409%2015.1182%2046.3528%2015.0793%2046.3528Z'%20fill='black'%20/%3e%3cpath%20d='M32.0256%2050.4661H27.9908C27.9408%2050.4661%2027.8929%2050.4464%2027.8576%2050.4113C27.8223%2050.3762%2027.8024%2050.3286%2027.8024%2050.279C27.8024%2050.2294%2027.8223%2050.1818%2027.8576%2050.1467C27.8929%2050.1116%2027.9408%2050.0919%2027.9908%2050.0919H32.0256C32.0756%2050.0919%2032.1235%2050.1116%2032.1588%2050.1467C32.1942%2050.1818%2032.214%2050.2294%2032.214%2050.279C32.214%2050.3286%2032.1942%2050.3762%2032.1588%2050.4113C32.1235%2050.4464%2032.0756%2050.4661%2032.0256%2050.4661Z'%20fill='black'%20/%3e%3cpath%20d='M15.0794%2050.4661H11.0446C10.9946%2050.4661%2010.9467%2050.4464%2010.9114%2050.4113C10.8761%2050.3762%2010.8562%2050.3286%2010.8562%2050.279C10.8562%2050.2294%2010.8761%2050.1818%2010.9114%2050.1467C10.9467%2050.1116%2010.9946%2050.0919%2011.0446%2050.0919H15.0794C15.1294%2050.0919%2015.1773%2050.1116%2015.2126%2050.1467C15.248%2050.1818%2015.2678%2050.2294%2015.2678%2050.279C15.2678%2050.3286%2015.248%2050.3762%2015.2126%2050.4113C15.1773%2050.4464%2015.1294%2050.4661%2015.0794%2050.4661Z'%20fill='black'%20/%3e%3cpath%20d='M21.5351%2058.4729C21.5103%2058.4729%2021.4858%2058.468%2021.4629%2058.4586C21.4401%2058.4492%2021.4193%2058.4355%2021.4018%2058.4181C21.3843%2058.4007%2021.3704%2058.3801%2021.361%2058.3574C21.3515%2058.3347%2021.3466%2058.3104%2021.3466%2058.2858V45.4646C21.3466%2045.4149%2021.3665%2045.3673%2021.4018%2045.3323C21.4372%2045.2972%2021.4851%2045.2775%2021.5351%2045.2775C21.585%2045.2775%2021.6329%2045.2972%2021.6683%2045.3323C21.7036%2045.3673%2021.7235%2045.4149%2021.7235%2045.4646V58.2858C21.7235%2058.3104%2021.7186%2058.3347%2021.7091%2058.3574C21.6997%2058.3801%2021.6858%2058.4007%2021.6683%2058.4181C21.6508%2058.4355%2021.63%2058.4492%2021.6072%2058.4586C21.5843%2058.468%2021.5598%2058.4729%2021.5351%2058.4729Z'%20fill='black'%20/%3e%3cpath%20d='M21.5351%2058.4729C19.7735%2058.4709%2018.0848%2057.7751%2016.8392%2056.5382C15.5936%2055.3013%2014.893%2053.6243%2014.891%2051.8751V47.0637C14.891%2043.9826%2017.4369%2042.0686%2021.5351%2042.0686C25.8196%2042.0686%2028.1792%2043.8426%2028.1792%2047.0637V51.8751C28.1772%2053.6243%2027.4766%2055.3013%2026.231%2056.5382C24.9854%2057.7751%2023.2966%2058.4709%2021.5351%2058.4729ZM21.5351%2042.4428C18.5053%2042.4428%2015.2678%2043.6567%2015.2678%2047.0637V51.8751C15.2673%2052.6927%2015.4291%2053.5023%2015.7439%2054.2578C16.0586%2055.0133%2016.5202%2055.6997%2017.1022%2056.278C17.6842%2056.8563%2018.3753%2057.315%2019.1359%2057.628C19.8965%2057.941%2020.7118%2058.1021%2021.5351%2058.1021C22.3584%2058.1021%2023.1737%2057.941%2023.9343%2057.628C24.6949%2057.315%2025.3859%2056.8563%2025.968%2056.278C26.55%2055.6997%2027.0116%2055.0133%2027.3263%2054.2578C27.6411%2053.5023%2027.8028%2052.6927%2027.8024%2051.8751V47.0637C27.8024%2043.0432%2023.8757%2042.4428%2021.5351%2042.4428Z'%20fill='black'%20/%3e%3cpath%20d='M17.6734%2043.2236C17.6357%2043.2237%2017.5988%2043.2124%2017.5676%2043.1914C17.5364%2043.1704%2017.5123%2043.1406%2017.4983%2043.1058C17.3895%2042.8353%2017.3266%2042.5489%2017.3121%2042.258C17.3154%2041.1488%2017.7599%2040.0858%2018.5488%2039.3005C19.3376%2038.5153%2020.407%2038.0714%2021.524%2038.0654H21.5456C22.6612%2038.0707%2023.7295%2038.5131%2024.5184%2039.2963C25.3072%2040.0796%2025.7528%2041.1404%2025.7583%2042.2482C25.7485%2042.5188%2025.6904%2042.7856%2025.5868%2043.036C25.5675%2043.0816%2025.5309%2043.1177%2025.485%2043.1365C25.439%2043.1554%2025.3874%2043.1554%2025.3414%2043.1366C25.2954%2043.1179%2025.2587%2043.0818%2025.2394%2043.0363C25.2201%2042.9907%2025.2197%2042.9395%2025.2383%2042.8937C25.3243%2042.6863%2025.3729%2042.4654%2025.3816%2042.2412C25.375%2041.2336%2024.9684%2040.2693%2024.2501%2039.5575C23.5319%2038.8458%2022.5599%2038.4441%2021.5452%2038.4396H21.5245C20.5086%2038.4446%2019.5358%2038.8476%2018.8175%2039.561C18.0993%2040.2743%2017.6936%2041.2403%2017.6886%2042.2491C17.702%2042.4955%2017.7559%2042.738%2017.8483%2042.9671C17.8596%2042.9955%2017.8638%2043.0262%2017.8605%2043.0566C17.8572%2043.087%2017.8464%2043.116%2017.8292%2043.1413C17.8119%2043.1666%2017.7887%2043.1874%2017.7616%2043.2017C17.7344%2043.216%2017.7041%2043.2236%2017.6734%2043.2236Z'%20fill='black'%20/%3e%3cpath%20d='M40.6701%2042.2062H38.4092C38.0594%2042.2062%2037.724%2042.0682%2037.4766%2041.8226C37.2293%2041.577%2037.0904%2041.2439%2037.0904%2040.8965C37.0904%2040.5492%2037.2293%2040.2161%2037.4766%2039.9705C37.724%2039.7249%2038.0594%2039.5869%2038.4092%2039.5869H40.6701C41.0199%2039.5869%2041.3553%2039.7249%2041.6026%2039.9705C41.85%2040.2161%2041.9889%2040.5492%2041.9889%2040.8965C41.9889%2041.2439%2041.85%2041.577%2041.6026%2041.8226C41.3553%2042.0682%2041.0199%2042.2062%2040.6701%2042.2062Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M56.1194%2047.7253H53.8585C53.5087%2047.7253%2053.1732%2047.5874%2052.9259%2047.3418C52.6786%2047.0962%2052.5396%2046.763%2052.5396%2046.4157C52.5396%2046.0684%2052.6786%2045.7353%2052.9259%2045.4897C53.1732%2045.2441%2053.5087%2045.1061%2053.8585%2045.1061H56.1194C56.4691%2045.1061%2056.8046%2045.2441%2057.0519%2045.4897C57.2992%2045.7353%2057.4382%2046.0684%2057.4382%2046.4157C57.4382%2046.763%2057.2992%2047.0962%2057.0519%2047.3418C56.8046%2047.5874%2056.4691%2047.7253%2056.1194%2047.7253Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M63.2788%2047.7253H61.0179C60.6681%2047.7253%2060.3327%2047.5874%2060.0853%2047.3418C59.838%2047.0962%2059.6991%2046.763%2059.6991%2046.4157C59.6991%2046.0684%2059.838%2045.7353%2060.0853%2045.4897C60.3327%2045.2441%2060.6681%2045.1061%2061.0179%2045.1061H63.2788C63.6286%2045.1061%2063.964%2045.2441%2064.2113%2045.4897C64.4587%2045.7353%2064.5976%2046.0684%2064.5976%2046.4157C64.5976%2046.763%2064.4587%2047.0962%2064.2113%2047.3418C63.964%2047.5874%2063.6286%2047.7253%2063.2788%2047.7253Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M70.4382%2047.7253H68.1773C67.8276%2047.7253%2067.4921%2047.5874%2067.2448%2047.3418C66.9974%2047.0962%2066.8585%2046.763%2066.8585%2046.4157C66.8585%2046.0684%2066.9974%2045.7353%2067.2448%2045.4897C67.4921%2045.2441%2067.8276%2045.1061%2068.1773%2045.1061H70.4382C70.788%2045.1061%2071.1234%2045.2441%2071.3708%2045.4897C71.6181%2045.7353%2071.757%2046.0684%2071.757%2046.4157C71.757%2046.763%2071.6181%2047.0962%2071.3708%2047.3418C71.1234%2047.5874%2070.788%2047.7253%2070.4382%2047.7253Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M56.3078%2042.2998H45.757C45.4073%2042.2998%2045.0718%2042.1618%2044.8245%2041.9162C44.5771%2041.6706%2044.4382%2041.3375%2044.4382%2040.9902C44.4382%2040.6428%2044.5771%2040.3097%2044.8245%2040.0641C45.0718%2039.8185%2045.4073%2039.6805%2045.757%2039.6805H56.3078C56.6575%2039.6805%2056.993%2039.8185%2057.2403%2040.0641C57.4877%2040.3097%2057.6266%2040.6428%2057.6266%2040.9902C57.6266%2041.3375%2057.4877%2041.6706%2057.2403%2041.9162C56.993%2042.1618%2056.6575%2042.2998%2056.3078%2042.2998Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M48.9599%2047.5383H38.4092C38.0594%2047.5383%2037.724%2047.4003%2037.4766%2047.1547C37.2293%2046.9091%2037.0904%2046.576%2037.0904%2046.2287C37.0904%2045.8814%2037.2293%2045.5483%2037.4766%2045.3027C37.724%2045.057%2038.0594%2044.9191%2038.4092%2044.9191H48.9599C49.3097%2044.9191%2049.6452%2045.057%2049.8925%2045.3027C50.1398%2045.5483%2050.2788%2045.8814%2050.2788%2046.2287C50.2788%2046.576%2050.1398%2046.9091%2049.8925%2047.1547C49.6452%2047.4003%2049.3097%2047.5383%2048.9599%2047.5383Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M69.6846%2042.2998H61.5831C61.2333%2042.2998%2060.8979%2042.1618%2060.6506%2041.9162C60.4032%2041.6706%2060.2643%2041.3375%2060.2643%2040.9902C60.2643%2040.6428%2060.4032%2040.3097%2060.6506%2040.0641C60.8979%2039.8185%2061.2333%2039.6805%2061.5831%2039.6805H69.6846C70.0344%2039.6805%2070.3698%2039.8185%2070.6171%2040.0641C70.8645%2040.3097%2071.0034%2040.6428%2071.0034%2040.9902C71.0034%2041.3375%2070.8645%2041.6706%2070.6171%2041.9162C70.3698%2042.1618%2070.0344%2042.2998%2069.6846%2042.2998Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M40.6701%2053.2445H38.4092C38.0594%2053.2445%2037.724%2053.1065%2037.4766%2052.8609C37.2293%2052.6153%2037.0904%2052.2822%2037.0904%2051.9349C37.0904%2051.5875%2037.2293%2051.2544%2037.4766%2051.0088C37.724%2050.7632%2038.0594%2050.6252%2038.4092%2050.6252H40.6701C41.0199%2050.6252%2041.3553%2050.7632%2041.6026%2051.0088C41.85%2051.2544%2041.9889%2051.5875%2041.9889%2051.9349C41.9889%2052.2822%2041.85%2052.6153%2041.6026%2052.8609C41.3553%2053.1065%2041.0199%2053.2445%2040.6701%2053.2445Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M56.3078%2053.338H45.757C45.4073%2053.338%2045.0718%2053.2%2044.8245%2052.9544C44.5771%2052.7088%2044.4382%2052.3757%2044.4382%2052.0284C44.4382%2051.681%2044.5771%2051.3479%2044.8245%2051.1023C45.0718%2050.8567%2045.4073%2050.7188%2045.757%2050.7188H56.3078C56.6575%2050.7188%2056.993%2050.8567%2057.2403%2051.1023C57.4877%2051.3479%2057.6266%2051.681%2057.6266%2052.0284C57.6266%2052.3757%2057.4877%2052.7088%2057.2403%2052.9544C56.993%2053.2%2056.6575%2053.338%2056.3078%2053.338Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M69.6846%2053.338H61.5831C61.2333%2053.338%2060.8979%2053.2%2060.6506%2052.9544C60.4032%2052.7088%2060.2643%2052.3757%2060.2643%2052.0284C60.2643%2051.681%2060.4032%2051.3479%2060.6506%2051.1023C60.8979%2050.8567%2061.2333%2050.7188%2061.5831%2050.7188H69.6846C70.0344%2050.7188%2070.3698%2050.8567%2070.6171%2051.1023C70.8645%2051.3479%2071.0034%2051.681%2071.0034%2052.0284C71.0034%2052.3757%2070.8645%2052.7088%2070.6171%2052.9544C70.3698%2053.2%2070.0344%2053.338%2069.6846%2053.338Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M66.1049%2057.7347C66.1053%2057.3875%2066.2443%2057.0546%2066.4916%2056.8091C66.7388%2056.5635%2067.074%2056.4254%2067.4237%2056.425H69.6846C70.0343%2056.425%2070.3698%2056.563%2070.6171%2056.8086C70.8645%2057.0542%2071.0034%2057.3873%2071.0034%2057.7347C71.0034%2058.082%2070.8645%2058.4151%2070.6171%2058.6607C70.3698%2058.9063%2070.0343%2059.0443%2069.6846%2059.0443H67.4237C67.074%2059.0439%2066.7388%2058.9058%2066.4916%2058.6603C66.2443%2058.4148%2066.1052%2058.0819%2066.1049%2057.7347Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M50.4672%2057.8282C50.4676%2057.481%2050.6067%2057.1481%2050.8539%2056.9026C51.1012%2056.657%2051.4364%2056.5189%2051.786%2056.5186H62.3368C62.6865%2056.5186%2063.022%2056.6565%2063.2693%2056.9021C63.5167%2057.1477%2063.6556%2057.4808%2063.6556%2057.8282C63.6556%2058.1755%2063.5167%2058.5086%2063.2693%2058.7542C63.022%2058.9998%2062.6865%2059.1378%2062.3368%2059.1378H51.786C51.4364%2059.1374%2051.1012%2058.9993%2050.8539%2058.7538C50.6067%2058.5083%2050.4676%2058.1754%2050.4672%2057.8282Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M37.0904%2057.8282C37.0908%2057.481%2037.2298%2057.1481%2037.4771%2056.9026C37.7243%2056.657%2038.0595%2056.5189%2038.4092%2056.5186H46.5107C46.8604%2056.5186%2047.1959%2056.6565%2047.4432%2056.9021C47.6905%2057.1477%2047.8295%2057.4808%2047.8295%2057.8282C47.8295%2058.1755%2047.6905%2058.5086%2047.4432%2058.7542C47.1959%2058.9998%2046.8604%2059.1378%2046.5107%2059.1378H38.4092C38.0595%2059.1374%2037.7243%2058.9993%2037.4771%2058.7538C37.2298%2058.5083%2037.0908%2058.1754%2037.0904%2057.8282Z'%20fill='%23CCCCCC'%20/%3e%3c/g%3e%3cg%20style='mix-blend-mode:%20color'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4843_5570'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_4843_5570'%3e%3crect%20width='130'%20height='83.9583'%20fill='white'%20transform='translate(-6%2022)'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ju = "data:image/svg+xml;base64,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", Tu = "data:image/svg+xml,%3csvg%20width='120'%20height='120'%20viewBox='0%200%20120%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_3271_26064)'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3cpath%20d='M108.688%20100H8.2717C7.01888%20100%206%2098.9674%206%2097.6977V29.3023C6%2028.0326%207.01888%2027%208.2717%2027H108.688C109.941%2027%20110.96%2028.0326%20110.96%2029.3023V97.6961C110.96%2098.9658%20109.941%2099.9984%20108.688%2099.9984V100Z'%20fill='white'%20/%3e%3cpath%20d='M108.688%20100H8.2717C7.01888%20100%206%2098.9674%206%2097.6977V29.3023C6%2028.0326%207.01888%2027%208.2717%2027H108.688C109.941%2027%20110.96%2028.0326%20110.96%2029.3023V97.6961C110.96%2098.9658%20109.941%2099.9984%20108.688%2099.9984V100ZM8.2717%2027.9359C7.52832%2027.9359%206.92345%2028.5489%206.92345%2029.3023V97.6961C6.92345%2098.4495%207.52832%2099.0625%208.2717%2099.0625H108.688C109.432%2099.0625%20110.036%2098.4495%20110.036%2097.6961V29.3023C110.036%2028.5489%20109.432%2027.9359%20108.688%2027.9359H8.2717Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M110.498%2029.3024V31.1929H6.46173V29.3024C6.46173%2028.2885%207.27283%2027.468%208.2717%2027.468H108.688C109.689%2027.468%20110.498%2028.29%20110.498%2029.3024Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M8.67649%2029.8469C8.96975%2029.8469%209.20748%2029.606%209.20748%2029.3088C9.20748%2029.0116%208.96975%2028.7706%208.67649%2028.7706C8.38324%2028.7706%208.14551%2029.0116%208.14551%2029.3088C8.14551%2029.606%208.38324%2029.8469%208.67649%2029.8469Z'%20fill='white'%20/%3e%3cpath%20d='M10.448%2029.8469C10.7413%2029.8469%2010.979%2029.606%2010.979%2029.3088C10.979%2029.0116%2010.7413%2028.7706%2010.448%2028.7706C10.1548%2028.7706%209.91702%2029.0116%209.91702%2029.3088C9.91702%2029.606%2010.1548%2029.8469%2010.448%2029.8469Z'%20fill='white'%20/%3e%3cpath%20d='M12.2195%2029.8469C12.5127%2029.8469%2012.7505%2029.606%2012.7505%2029.3088C12.7505%2029.0116%2012.5127%2028.7706%2012.2195%2028.7706C11.9262%2028.7706%2011.6885%2029.0116%2011.6885%2029.3088C11.6885%2029.606%2011.9262%2029.8469%2012.2195%2029.8469Z'%20fill='white'%20/%3e%3cpath%20d='M99.0273%2033.1692H16.7813C16.0231%2033.1692%2015.4085%2033.7921%2015.4085%2034.5606C15.4085%2035.329%2016.0231%2035.9519%2016.7813%2035.9519H99.0273C99.7855%2035.9519%20100.4%2035.329%20100.4%2034.5606C100.4%2033.7921%2099.7855%2033.1692%2099.0273%2033.1692Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M42.7427%2066.1579H24.4337C23.3286%2066.1579%2022.4298%2065.247%2022.4298%2064.127V48.2636C22.4298%2047.1436%2023.3286%2046.2327%2024.4337%2046.2327H42.7427C43.8478%2046.2327%2044.7466%2047.1436%2044.7466%2048.2636V64.127C44.7466%2065.247%2043.8478%2066.1579%2042.7427%2066.1579ZM24.4337%2046.8566C23.6688%2046.8566%2023.0454%2047.4883%2023.0454%2048.2636V64.127C23.0454%2064.9023%2023.6688%2065.534%2024.4337%2065.534H42.7427C43.5077%2065.534%2044.131%2064.9023%2044.131%2064.127V48.2636C44.131%2047.4883%2043.5077%2046.8566%2042.7427%2046.8566H24.4337Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M67.6345%2066.1579H49.3254C48.2204%2066.1579%2047.3215%2065.247%2047.3215%2064.127V48.2636C47.3215%2047.1436%2048.2204%2046.2327%2049.3254%2046.2327H67.6345C68.7395%2046.2327%2069.6384%2047.1436%2069.6384%2048.2636V64.127C69.6384%2065.247%2068.7395%2066.1579%2067.6345%2066.1579ZM49.3254%2046.8566C48.5605%2046.8566%2047.9372%2047.4883%2047.9372%2048.2636V64.127C47.9372%2064.9023%2048.5605%2065.534%2049.3254%2065.534H67.6345C68.3994%2065.534%2069.0227%2064.9023%2069.0227%2064.127V48.2636C69.0227%2047.4883%2068.3994%2046.8566%2067.6345%2046.8566H49.3254Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M92.5262%2066.1579H74.2171C73.1121%2066.1579%2072.2132%2065.247%2072.2132%2064.127V48.2636C72.2132%2047.1436%2073.1121%2046.2327%2074.2171%2046.2327H92.5262C93.6312%2046.2327%2094.5301%2047.1436%2094.5301%2048.2636V64.127C94.5301%2065.247%2093.6312%2066.1579%2092.5262%2066.1579ZM74.2171%2046.8566C73.4522%2046.8566%2072.8289%2047.4883%2072.8289%2048.2636V64.127C72.8289%2064.9023%2073.4522%2065.534%2074.2171%2065.534H92.5262C93.2911%2065.534%2093.9144%2064.9023%2093.9144%2064.127V48.2636C93.9144%2047.4883%2093.2911%2046.8566%2092.5262%2046.8566H74.2171Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M42.7427%2090.9593H24.4337C23.3286%2090.9593%2022.4298%2090.0484%2022.4298%2088.9284V73.065C22.4298%2071.945%2023.3286%2071.0341%2024.4337%2071.0341H42.7427C43.8478%2071.0341%2044.7466%2071.945%2044.7466%2073.065V88.9284C44.7466%2090.0484%2043.8478%2090.9593%2042.7427%2090.9593ZM24.4337%2071.658C23.6688%2071.658%2023.0454%2072.2897%2023.0454%2073.065V88.9284C23.0454%2089.7037%2023.6688%2090.3354%2024.4337%2090.3354H42.7427C43.5077%2090.3354%2044.131%2089.7037%2044.131%2088.9284V73.065C44.131%2072.2897%2043.5077%2071.658%2042.7427%2071.658H24.4337Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M67.6345%2090.9593H49.3254C48.2204%2090.9593%2047.3215%2090.0484%2047.3215%2088.9284V73.065C47.3215%2071.945%2048.2204%2071.0341%2049.3254%2071.0341H67.6345C68.7395%2071.0341%2069.6384%2071.945%2069.6384%2073.065V88.9284C69.6384%2090.0484%2068.7395%2090.9593%2067.6345%2090.9593ZM49.3254%2071.658C48.5605%2071.658%2047.9372%2072.2897%2047.9372%2073.065V88.9284C47.9372%2089.7037%2048.5605%2090.3354%2049.3254%2090.3354H67.6345C68.3994%2090.3354%2069.0227%2089.7037%2069.0227%2088.9284V73.065C69.0227%2072.2897%2068.3994%2071.658%2067.6345%2071.658H49.3254Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M92.5262%2090.9593H74.2171C73.1121%2090.9593%2072.2132%2090.0484%2072.2132%2088.9284V73.065C72.2132%2071.945%2073.1121%2071.0341%2074.2171%2071.0341H92.5262C93.6312%2071.0341%2094.5301%2071.945%2094.5301%2073.065V88.9284C94.5301%2090.0484%2093.6312%2090.9593%2092.5262%2090.9593Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M98.6718%2040.9496L100.56%2039.46C100.56%2039.46%20102.715%2040.14%20102.77%2040.1681C102.826%2040.1962%20106.115%2047.9267%20106.115%2047.9267C106.115%2047.9267%2097.6899%2052.2974%2098.3055%2051.87C98.9211%2051.4457%2098.7934%2045.6852%2098.2208%2044.935C97.6468%2044.1831%2098.1362%2042.2957%2098.1362%2042.2957L98.6672%2040.948H98.6703L98.6718%2040.9496Z'%20fill='%232F2E43'%20/%3e%3cpath%20d='M103.892%2044.4327H101.331V48.5507L104.156%2047.6101L103.892%2044.4327Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M95.5259%2070.9888C95.5921%2070.6129%2095.5659%2070.2245%2095.4489%2069.8564L96.3416%2065.9677L94.4378%2065.5637L93.739%2069.5522C93.5112%2069.8579%2093.3635%2070.2167%2093.3081%2070.5942C93.1542%2071.5379%2093.5282%2072.3927%2094.1407%2072.5003C94.7533%2072.6095%2095.3735%2071.9325%2095.5274%2070.9888H95.5259Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M103.094%2093.714H100.449V97.5153H103.094V93.714Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M97.8761%2099.8163C99.0365%2099.8163%20100.731%2099.693%20100.743%2099.6915C101.197%2099.732%20103.46%2099.913%20103.572%2099.3889C103.675%2098.9069%20103.523%2098.403%20103.501%2098.3329C103.283%2096.1413%20103.203%2096.1148%20103.154%2096.1007C103.077%2096.0773%20102.852%2096.1865%20102.487%2096.4252L102.464%2096.4408L102.459%2096.4673C102.453%2096.5001%20102.292%2097.3049%20101.525%2097.1833C101%2097.099%20100.83%2096.9805%20100.776%2096.9228C100.82%2096.9025%20100.876%2096.8666%20100.914%2096.8058C100.971%2096.7169%20100.98%2096.6014%20100.943%2096.4626C100.845%2096.0992%20100.549%2095.561%20100.537%2095.5376L100.503%2095.4768L97.499%2097.5311L95.6428%2098.0692C95.5028%2098.1082%2095.3904%2098.2112%2095.3335%2098.3469C95.255%2098.5356%2095.3027%2098.7571%2095.4551%2098.8944C95.7921%2099.2017%2096.4632%2099.7273%2097.165%2099.7929C97.3512%2099.81%2097.599%2099.8178%2097.8776%2099.8178L97.8761%2099.8163Z'%20fill='%232F2E43'%20/%3e%3cpath%20d='M110.623%2090.7262L108.379%2092.1443L110.364%2095.3697L112.608%2093.9516L110.623%2090.7262Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M107.642%2099.2968C108.011%2099.2968%20108.419%2099.2437%20108.762%2099.0675C109.629%2098.626%20111.736%2097.074%20111.748%2097.0631C112.153%2096.8556%20114.167%2095.7949%20113.989%2095.2896C113.824%2094.8247%20113.432%2094.4784%20113.378%2094.4317C112.048%2092.6878%20111.968%2092.7096%20111.919%2092.7236C111.84%2092.7455%20111.708%2092.9576%20111.522%2093.3554L111.511%2093.3803L111.522%2093.4053C111.534%2093.438%20111.817%2094.207%20111.103%2094.5128C110.614%2094.7233%20110.407%2094.7155%20110.332%2094.6937C110.36%2094.6516%20110.387%2094.5923%20110.389%2094.519C110.392%2094.4129%20110.34%2094.3084%20110.235%2094.2117C109.961%2093.9559%20109.43%2093.658%20109.407%2093.6455L109.347%2093.6127L107.869%2096.9679L106.575%2098.4186C106.477%2098.5278%20106.435%2098.6744%20106.458%2098.821C106.49%2099.0238%20106.647%2099.1845%20106.847%2099.2203C107.051%2099.2562%20107.335%2099.2952%20107.646%2099.2952L107.642%2099.2968Z'%20fill='%232F2E43'%20/%3e%3cpath%20d='M105.041%2061.9215C105.041%2061.9215%20105.898%2061.9215%20107.241%2064.645C108.585%2067.37%20106.875%2078.3044%20106.875%2078.3044L111.662%2090.8579L108.303%2093.2413L102.173%2079.7956L103.685%2094.6888H99.9061L96.9664%2068.9017L97.6375%2061.9231H105.041V61.9215Z'%20fill='%232F2E43'%20/%3e%3cpath%20d='M105.616%2046.9441H100.494L95.8752%2062.3474H108.722L105.616%2046.9441Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M101.304%2046.9442L96.0969%2068.8161H93.4927C93.4927%2068.8161%2097.439%2048.5617%2097.776%2047.7101C98.1116%2046.8584%20101.302%2046.9442%20101.302%2046.9442H101.304Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M101.682%2045.5715C103.236%2045.5715%20104.496%2044.2949%20104.496%2042.7201C104.496%2041.1454%20103.236%2039.8688%20101.682%2039.8688C100.128%2039.8688%2098.8687%2041.1454%2098.8687%2042.7201C98.8687%2044.2949%20100.128%2045.5715%20101.682%2045.5715Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M98.1777%2042.2007L98.8672%2042.3193C99.5105%2039.7081%20100.968%2040.5613%20101.107%2040.5317C101.245%2040.502%20103.317%2042.7997%20103.149%2045.1269C102.981%2047.4526%20105.949%2048.543%20105.949%2048.543C105.949%2048.543%20106.986%2050.5177%20106.061%2054.0913C105.136%2057.6649%20107.097%2058.8644%20107.097%2058.8644C110.96%2058.5321%20108.637%2053.0696%20108.022%2052.0775C107.406%2051.0839%20107.826%2049.3541%20107.826%2049.3541C108.779%2048.5024%20107.658%2046.6306%20107.658%2046.6306C107.658%2046.6306%20107.856%2044.1333%20107.268%2043.6513C106.68%2043.1694%20106.652%2041.9776%20106.652%2041.9776C105.615%2037.4105%20102.229%2038.2902%20102.229%2038.2902C97.8899%2037.8082%2098.1792%2042.1991%2098.1792%2042.1991L98.1777%2042.2007Z'%20fill='%232F2E43'%20/%3e%3cpath%20d='M110.915%2070.5318C110.844%2070.1559%20110.684%2069.8018%20110.446%2069.5007L109.916%2065.5435L107.994%2065.8523L108.737%2069.833C108.634%2070.2011%20108.622%2070.5879%20108.701%2070.9623C108.887%2071.8998%20109.535%2072.5627%20110.146%2072.4441C110.757%2072.3256%20111.102%2071.4692%20110.914%2070.5318H110.915Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M108.203%2068.5586H110.808C110.808%2068.5586%20106.861%2048.3042%20106.524%2047.4525C106.189%2046.6008%20103.378%2046.9627%20103.378%2046.9627L108.203%2068.5586Z'%20fill='%2317AD49'%20/%3e%3cg%20style='mix-blend-mode:%20color'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_3271_26064'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Ou = "data:image/svg+xml,%3csvg%20width='120'%20height='120'%20viewBox='0%200%20120%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3cpath%20d='M1.25%2060.5C1.25%2028.0188%2027.5813%201.6875%2060.0625%201.6875C92.5437%201.6875%20118.875%2028.0188%20118.875%2060.5C118.875%2092.9812%2092.5437%20119.312%2060.0625%20119.312C27.5813%20119.312%201.25%2092.9812%201.25%2060.5Z'%20stroke='%23F1F2F3'%20stroke-width='0.5'%20/%3e%3cpath%20d='M13.25%2060.5009C13.25%2034.7555%2034.1207%2013.8848%2059.8661%2013.8848C85.6115%2013.8848%20106.482%2034.7555%20106.482%2060.5009C106.482%2086.2462%2085.6115%20107.117%2059.8661%20107.117C34.1207%20107.117%2013.25%2086.2462%2013.25%2060.5009Z'%20stroke='%23E6EAEA'%20stroke-width='0.5'%20/%3e%3cpath%20d='M27.2375%2060.5008C27.2375%2042.372%2041.9338%2027.6758%2060.0625%2027.6758C78.1913%2027.6758%2092.8876%2042.372%2092.8876%2060.5008C92.8876%2078.6295%2078.1913%2093.3258%2060.0625%2093.3258C41.9338%2093.3258%2027.2375%2078.6295%2027.2375%2060.5008Z'%20stroke='%23D9DEDE'%20stroke-width='0.5'%20/%3e%3cpath%20d='M39.0106%2060.4825C39.0106%2048.0658%2049.0764%2038%2061.4931%2038C73.9098%2038%2083.9756%2048.0658%2083.9756%2060.4825C83.9756%2072.8992%2073.9098%2082.965%2061.4931%2082.965C49.0764%2082.965%2039.0106%2072.8992%2039.0106%2060.4825Z'%20fill='url(%23paint0_linear_5860_17372)'%20/%3e%3cpath%20d='M36.7527%2060.8815C36.7527%2048.8805%2046.4815%2039.1518%2058.4825%2039.1518C70.4835%2039.1518%2080.2122%2048.8805%2080.2122%2060.8815C80.2122%2072.8825%2070.4835%2082.6113%2058.4825%2082.6113C46.4815%2082.6113%2036.7527%2072.8825%2036.7527%2060.8815Z'%20fill='url(%23paint1_linear_5860_17372)'%20stroke='%23738482'%20stroke-width='1.50552'%20/%3e%3cpath%20d='M57.5912%2065.3233C61.52%2065.3233%2064.7049%2062.1383%2064.7049%2058.2095C64.7049%2054.2807%2061.52%2051.0958%2057.5912%2051.0958C53.6624%2051.0958%2050.4774%2054.2807%2050.4774%2058.2095C50.4774%2062.1383%2053.6624%2065.3233%2057.5912%2065.3233Z'%20fill='%234C5857'%20/%3e%3cpath%20d='M58.1778%2065.3212C61.3704%2065.3212%2063.9585%2062.7331%2063.9585%2059.5405C63.9585%2056.3479%2061.3704%2053.7598%2058.1778%2053.7598C54.9852%2053.7598%2052.3971%2056.3479%2052.3971%2059.5405C52.3971%2062.7331%2054.9852%2065.3212%2058.1778%2065.3212Z'%20fill='%23D9DEDE'%20/%3e%3cpath%20d='M50.4819%2044.2201C49.496%2043.7993%2048.412%2043.6628%2047.3526%2043.826C46.2931%2043.9892%2045.3005%2044.4456%2044.487%2045.1436C43.6913%2045.8615%2043.0856%2046.7651%2042.7239%2047.7738C42.3621%2048.7826%2042.2556%2049.8651%2042.4136%2050.925C42.732%2053.0808%2044.0426%2054.9373%2045.2507%2056.7509C46.4587%2058.5646%2047.639%2060.552%2047.6376%2062.7311C47.6366%2064.3007%2047.0133%2065.8058%2045.9042%2066.9164C44.7951%2068.027%2043.2908%2068.6525%2041.7213%2068.6556C43.5634%2069.4486%2045.4861%2070.2572%2047.4895%2070.1632C49.4929%2070.0692%2051.5927%2068.7813%2051.9195%2066.8025C52.155%2065.3767%2051.4554%2063.9864%2050.872%2062.6643C49.9217%2060.51%2049.2349%2058.2489%2048.8263%2055.93C48.561%2054.8327%2048.5745%2053.6864%2048.8654%2052.5955C49.1527%2051.8069%2049.6858%2051.1314%2050.3862%2050.6688C51.0866%2050.2061%2051.917%2049.9808%2052.7552%2050.026L53.4171%2049.4305C53.5305%2048.3646%2053.3087%2047.2899%2052.7826%2046.356C52.2565%2045.4221%2051.4522%2044.6755%2050.4819%2044.2201Z'%20fill='%234C5857'%20/%3e%3cpath%20d='M73.5238%2075.424C70.078%2079.3448%2065.2286%2081.7532%2060.0224%2082.1295C54.8163%2082.5057%2049.671%2080.8196%2045.6972%2077.435L47.4032%2072.6748C47.7887%2071.8294%2048.3971%2071.1048%2049.1631%2070.5788C49.9291%2070.0528%2050.8238%2069.7452%2051.7514%2069.689L52.8366%2069.6224L55.4245%2067.3904C55.4245%2067.3904%2062.3974%2067.1414%2062.2939%2067.0222L66.5176%2069.5627L66.5141%2069.5452L68.1745%2069.6469C69.102%2069.7028%2069.9969%2070.0103%2070.7629%2070.5364C71.529%2071.0624%2072.1373%2071.7871%2072.5226%2072.6328L73.5238%2075.424Z'%20fill='%23919F9D'%20/%3e%3cpath%20d='M53.0963%2054.6525C54.6471%2054.6525%2055.9043%2053.3953%2055.9043%2051.8444C55.9043%2050.2936%2054.6471%2049.0364%2053.0963%2049.0364C51.5454%2049.0364%2050.2882%2050.2936%2050.2882%2051.8444C50.2882%2053.3953%2051.5454%2054.6525%2053.0963%2054.6525Z'%20fill='%234C5857'%20/%3e%3cpath%20d='M8.19385%20102.91C8.19385%2097.9891%2012.1829%2094%2017.1037%2094C22.0245%2094%2026.0135%2097.9891%2026.0135%20102.91C26.0135%20107.831%2022.0245%20111.82%2017.1037%20111.82C12.1829%20111.82%208.19385%20107.831%208.19385%20102.91Z'%20fill='url(%23paint2_linear_5860_17372)'%20/%3e%3cpath%20d='M7.29869%20103.069C7.29869%2098.3126%2011.1542%2094.4571%2015.9102%2094.4571C20.6662%2094.4571%2024.5217%2098.3126%2024.5217%20103.069C24.5217%20107.825%2020.6662%20111.68%2015.9102%20111.68C11.1542%20111.68%207.29869%20107.825%207.29869%20103.069Z'%20fill='%23E6EAEA'%20stroke='%23738482'%20stroke-width='0.596642'%20/%3e%3cpath%20d='M15.6138%20103.03C17.1776%20103.03%2018.4453%20101.762%2018.4453%20100.198C18.4453%2098.6345%2017.1776%2097.3668%2015.6138%2097.3668C14.0501%2097.3668%2012.7823%2098.6345%2012.7823%20100.198C12.7823%20101.762%2014.0501%20103.03%2015.6138%20103.03Z'%20fill='%23D9DEDE'%20/%3e%3cpath%20d='M22.6324%20107.962C21.3198%20109.991%2018.7492%20111.255%2016.4273%20111.422C13.5635%20111.542%2011.1769%20110.229%209.86429%20108.797L10.8638%20106.641C11.0357%20106.264%2011.307%20105.941%2011.6487%20105.706C11.9903%20105.472%2012.3893%20105.335%2012.803%20105.31L13.287%20105.28L14.4411%20104.284C14.4411%20104.284%2017.5509%20104.173%2017.5048%20104.12L19.3885%20105.253L19.3869%20105.245L20.1274%20105.291C20.5411%20105.316%2020.9402%20105.453%2021.2818%20105.687C21.6234%20105.922%2021.8947%20106.245%2022.0666%20106.622L22.6324%20107.962Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M18.6008%2098.4415C18.3615%2097.5851%2017.8179%2096.8454%2017.072%2096.3614C16.4775%2095.9812%2015.7358%2095.7871%2015.0623%2095.9882C14.3888%2096.1892%2013.8313%2096.8502%2013.8753%2097.5643C13.7506%2097.5315%2013.6191%2097.5343%2013.4959%2097.5723C13.3726%2097.6104%2013.2625%2097.6822%2013.1779%2097.7796C13.009%2097.9791%2012.8915%2098.217%2012.8358%2098.4724C12.6197%2099.273%2012.634%20100.118%2012.8771%20100.911L12.8637%20101.025C13.0263%20100.982%2013.1768%20100.902%2013.3038%20100.792C13.4308%20100.681%2013.5309%20100.543%2013.5965%20100.388C13.7514%20100.088%2013.8406%2099.7548%2014.0086%2099.4618C14.0811%2099.3102%2014.1904%2099.1792%2014.3266%2099.0807C14.4628%2098.9823%2014.6215%2098.9196%2014.7882%2098.8983L14.7589%2099.4069C15.0452%2099.2594%2015.3314%2099.1119%2015.6177%2098.9644L15.4134%2099.4531L16.1634%2099.1396C16.1355%2099.2962%2016.1076%2099.4529%2016.0796%2099.6095C16.1452%2099.4735%2016.2376%2099.3523%2016.3514%2099.2531C16.4651%2099.1539%2016.5979%2099.0788%2016.7415%2099.0324C16.8851%2098.9859%2017.0366%2098.9691%2017.1869%2098.9829C17.3372%2098.9967%2017.4832%2099.0409%2017.6159%2099.1128C17.9149%2099.3139%2018.1304%2099.6171%2018.2222%2099.9656C18.3129%20100.313%2018.3617%20100.671%2018.3673%20101.03C18.7536%20100.223%2018.8365%2099.3043%2018.6008%2098.4415Z'%20fill='%235D6C6B'%20/%3e%3cpath%20d='M89.4089%2083.5143C89.4089%2077.7074%2094.1163%2073%2099.9232%2073C105.73%2073%20110.438%2077.7074%20110.438%2083.5143C110.438%2089.3212%20105.73%2094.0286%2099.9232%2094.0286C94.1163%2094.0286%2089.4089%2089.3212%2089.4089%2083.5143Z'%20fill='url(%23paint3_linear_5860_17372)'%20/%3e%3cpath%20d='M88.3523%2083.7004C88.3523%2078.088%2092.9021%2073.5382%2098.5146%2073.5382C104.127%2073.5382%20108.677%2078.088%20108.677%2083.7004C108.677%2089.3129%20104.127%2093.8627%2098.5146%2093.8627C92.9021%2093.8627%2088.3523%2089.3129%2088.3523%2083.7004Z'%20fill='%23E6EAEA'%20stroke='%23738482'%20stroke-width='0.704082'%20/%3e%3cpath%20d='M93.2%2078.5751C93.6751%2077.061%2094.7555%2075.6723%2096.2496%2075.1605C97.7439%2074.6486%2099.9318%2075.4284%20101.055%2076.5479C103.11%2078.5957%20103.611%2085.6308%20102.2%2087.8539C101.919%2087.8391%20100.95%2087.8281%20100.666%2087.8174L100.264%2086.4775V87.8042C99.8109%2087.7902%2099.3546%2087.7806%2098.8948%2087.7752C97.353%2087.7561%2095.8786%2087.14%2094.7817%2086.0564C93.6848%2084.9727%2093.0507%2083.506%2093.0128%2081.9646C92.976%2080.4899%2093.0128%2079.1718%2093.2%2078.5751Z'%20fill='%235D6C6B'%20/%3e%3cpath%20d='M98.3549%2083.5939C100.163%2083.5939%20101.629%2082.1278%20101.629%2080.3194C101.629%2078.511%20100.163%2077.0449%2098.3549%2077.0449C96.5465%2077.0449%2095.0804%2078.511%2095.0804%2080.3194C95.0804%2082.1278%2096.5465%2083.5939%2098.3549%2083.5939Z'%20fill='%23D9DEDE'%20/%3e%3cpath%20d='M95.5291%2077.4425L99.2993%2075.5547C100.07%2075.902%20100.734%2076.4493%20101.222%2077.1396C101.71%2077.83%20102.004%2078.6383%20102.075%2079.4809L102.169%2080.6065L100.59%2080.2046L100.417%2078.7653L100.149%2080.0924L99.4203%2079.907L99.4273%2077.6724L98.6982%2079.9054L96.0959%2079.3075L95.5291%2077.4425Z'%20fill='%235D6C6B'%20/%3e%3cpath%20d='M106.447%2089.4749C104.898%2091.8688%20101.865%2093.3605%2099.125%2093.5586C95.7454%2093.6994%2092.929%2092.1504%2091.3801%2090.4606L92.5595%2087.9163C92.7624%2087.4714%2093.0826%2087.09%2093.4858%2086.8132C93.8889%2086.5364%2094.3598%2086.3745%2094.8479%2086.3449L95.4191%2086.3098L96.7811%2085.1352C96.7811%2085.1352%20100.451%2085.0042%20100.396%2084.9414L102.619%2086.2785L102.617%2086.2692L103.491%2086.3227C103.979%2086.3522%20104.45%2086.514%20104.854%2086.7909C105.257%2087.0677%20105.577%2087.4491%20105.78%2087.8942L106.447%2089.4749Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M30.2714%2019.4887C30.2714%2014.2482%2034.5196%2010%2039.7601%2010C45.0005%2010%2049.2488%2014.2482%2049.2488%2019.4887C49.2488%2024.7291%2045.0005%2028.9773%2039.7601%2028.9773C34.5196%2028.9773%2030.2714%2024.7291%2030.2714%2019.4887Z'%20fill='url(%23paint4_linear_5860_17372)'%20/%3e%3cpath%20d='M29.3181%2019.6579C29.3181%2014.5929%2033.4241%2010.4869%2038.489%2010.4869C43.554%2010.4869%2047.66%2014.5929%2047.66%2019.6579C47.66%2024.7228%2043.554%2028.8288%2038.489%2028.8288C33.4241%2028.8288%2029.3181%2024.7228%2029.3181%2019.6579Z'%20fill='%23E6EAEA'%20stroke='%23738482'%20stroke-width='0.635402'%20/%3e%3cpath%20d='M38.1734%2019.6165C39.8388%2019.6165%2041.1889%2018.2664%2041.1889%2016.601C41.1889%2014.9356%2039.8388%2013.5856%2038.1734%2013.5856C36.508%2013.5856%2035.158%2014.9356%2035.158%2016.601C35.158%2018.2664%2036.508%2019.6165%2038.1734%2019.6165Z'%20fill='%23D9DEDE'%20/%3e%3cpath%20d='M45.648%2024.869C44.2501%2027.0293%2041.5125%2028.3756%2039.0398%2028.5543C35.9898%2028.6814%2033.4482%2027.2835%2032.0504%2025.7585L33.1148%2023.4625C33.2979%2023.0609%2033.5868%2022.7167%2033.9506%2022.4669C34.3145%2022.2171%2034.7394%2022.071%2035.1799%2022.0443L35.6954%2022.0127L36.9245%2020.9526C36.9245%2020.9526%2040.2363%2020.8343%2040.1872%2020.7777L42.1933%2021.9843L42.1916%2021.976L42.9802%2022.0243C43.4208%2022.0509%2043.8458%2022.1969%2044.2096%2022.4468C44.5734%2022.6966%2044.8624%2023.0408%2045.0454%2023.4425L45.648%2024.869Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M41.3544%2014.7301C41.0996%2013.8181%2040.5207%2013.0304%2039.7263%2012.5149C39.0932%2012.11%2038.3032%2011.9033%2037.586%2012.1174C36.8688%2012.3316%2036.275%2013.0354%2036.322%2013.7959C36.1891%2013.761%2036.0491%2013.764%2035.9178%2013.8045C35.7866%2013.845%2035.6693%2013.9215%2035.5793%2014.0253C35.3993%2014.2377%2035.2742%2014.491%2035.2149%2014.763C34.9847%2015.6157%2035%2016.516%2035.2589%2017.3603L35.2446%2017.4815C35.4177%2017.4354%2035.578%2017.3504%2035.7133%2017.2329C35.8485%2017.1154%2035.9551%2016.9685%2036.025%2016.8035C36.19%2016.4837%2036.285%2016.1288%2036.4639%2015.8167C36.5411%2015.6553%2036.6575%2015.5157%2036.8026%2015.4109C36.9476%2015.3061%2037.1166%2015.2393%2037.2941%2015.2166L37.2629%2015.7583C37.5678%2015.6012%2037.8727%2015.4441%2038.1775%2015.287L37.96%2015.8074L38.7587%2015.4736C38.729%2015.6404%2038.6992%2015.8072%2038.6694%2015.974C38.7392%2015.8292%2038.8377%2015.7001%2038.9589%2015.5944C39.08%2015.4888%2039.2213%2015.4088%2039.3743%2015.3594C39.5272%2015.3099%2039.6886%2015.292%2039.8487%2015.3067C40.0088%2015.3215%2040.1642%2015.3685%2040.3056%2015.445C40.624%2015.6592%2040.8535%2015.9821%2040.9512%2016.3532C41.0478%2016.7235%2041.0997%2017.104%2041.1058%2017.4867C41.5172%2016.6275%2041.6055%2015.649%2041.3544%2014.7301Z'%20fill='%235D6C6B'%20/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_5860_17372'%20x1='61.4931'%20y1='38'%20x2='61.4931'%20y2='82.965'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23B8C1C0'%20/%3e%3cstop%20offset='1'%20stop-color='%2399A3A3'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_5860_17372'%20x1='58.4825'%20y1='38.399'%20x2='58.4825'%20y2='83.364'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23EFF1F1'%20/%3e%3cstop%20offset='1'%20stop-color='%23D9DEDE'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_5860_17372'%20x1='17.1037'%20y1='94'%20x2='17.1037'%20y2='111.82'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23B8C1C0'%20/%3e%3cstop%20offset='1'%20stop-color='%2399A3A3'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_5860_17372'%20x1='99.9232'%20y1='73'%20x2='99.9232'%20y2='94.0286'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23B8C1C0'%20/%3e%3cstop%20offset='1'%20stop-color='%2399A3A3'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint4_linear_5860_17372'%20x1='39.7601'%20y1='10'%20x2='39.7601'%20y2='28.9773'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23B8C1C0'%20/%3e%3cstop%20offset='1'%20stop-color='%2399A3A3'%20/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", _u = "data:image/svg+xml,%3csvg%20width='388'%20height='297'%20viewBox='0%200%20388%20297'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_3273_18484)'%3e%3crect%20width='120'%20height='120'%20transform='translate(268)'%20fill='white'%20/%3e%3cpath%20d='M376.688%20100H276.272C275.019%20100%20274%2098.9674%20274%2097.6977V29.3023C274%2028.0326%20275.019%2027%20276.272%2027H376.688C377.941%2027%20378.96%2028.0326%20378.96%2029.3023V97.6961C378.96%2098.9658%20377.941%2099.9984%20376.688%2099.9984V100Z'%20fill='white'%20/%3e%3cpath%20d='M376.688%20100H276.272C275.019%20100%20274%2098.9674%20274%2097.6977V29.3023C274%2028.0326%20275.019%2027%20276.272%2027H376.688C377.941%2027%20378.96%2028.0326%20378.96%2029.3023V97.6961C378.96%2098.9658%20377.941%2099.9984%20376.688%2099.9984V100ZM276.272%2027.9359C275.528%2027.9359%20274.923%2028.5489%20274.923%2029.3023V97.6961C274.923%2098.4495%20275.528%2099.0625%20276.272%2099.0625H376.688C377.432%2099.0625%20378.036%2098.4495%20378.036%2097.6961V29.3023C378.036%2028.5489%20377.432%2027.9359%20376.688%2027.9359H276.272Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M378.498%2029.3024V31.1929H274.462V29.3024C274.462%2028.2885%20275.273%2027.468%20276.272%2027.468H376.688C377.689%2027.468%20378.498%2028.29%20378.498%2029.3024Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M276.676%2029.8469C276.97%2029.8469%20277.207%2029.606%20277.207%2029.3088C277.207%2029.0116%20276.97%2028.7706%20276.676%2028.7706C276.383%2028.7706%20276.146%2029.0116%20276.146%2029.3088C276.146%2029.606%20276.383%2029.8469%20276.676%2029.8469Z'%20fill='white'%20/%3e%3cpath%20d='M278.448%2029.8469C278.741%2029.8469%20278.979%2029.606%20278.979%2029.3088C278.979%2029.0116%20278.741%2028.7706%20278.448%2028.7706C278.155%2028.7706%20277.917%2029.0116%20277.917%2029.3088C277.917%2029.606%20278.155%2029.8469%20278.448%2029.8469Z'%20fill='white'%20/%3e%3cpath%20d='M280.219%2029.8469C280.513%2029.8469%20280.75%2029.606%20280.75%2029.3088C280.75%2029.0116%20280.513%2028.7706%20280.219%2028.7706C279.926%2028.7706%20279.688%2029.0116%20279.688%2029.3088C279.688%2029.606%20279.926%2029.8469%20280.219%2029.8469Z'%20fill='white'%20/%3e%3cpath%20d='M367.027%2033.1692H284.781C284.023%2033.1692%20283.408%2033.7921%20283.408%2034.5606C283.408%2035.329%20284.023%2035.9519%20284.781%2035.9519H367.027C367.786%2035.9519%20368.4%2035.329%20368.4%2034.5606C368.4%2033.7921%20367.786%2033.1692%20367.027%2033.1692Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M310.743%2066.1579H292.434C291.329%2066.1579%20290.43%2065.247%20290.43%2064.127V48.2636C290.43%2047.1436%20291.329%2046.2327%20292.434%2046.2327H310.743C311.848%2046.2327%20312.747%2047.1436%20312.747%2048.2636V64.127C312.747%2065.247%20311.848%2066.1579%20310.743%2066.1579ZM292.434%2046.8566C291.669%2046.8566%20291.045%2047.4883%20291.045%2048.2636V64.127C291.045%2064.9023%20291.669%2065.534%20292.434%2065.534H310.743C311.508%2065.534%20312.131%2064.9023%20312.131%2064.127V48.2636C312.131%2047.4883%20311.508%2046.8566%20310.743%2046.8566H292.434Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M335.634%2066.1579H317.325C316.22%2066.1579%20315.322%2065.247%20315.322%2064.127V48.2636C315.322%2047.1436%20316.22%2046.2327%20317.325%2046.2327H335.634C336.74%2046.2327%20337.638%2047.1436%20337.638%2048.2636V64.127C337.638%2065.247%20336.74%2066.1579%20335.634%2066.1579ZM317.325%2046.8566C316.561%2046.8566%20315.937%2047.4883%20315.937%2048.2636V64.127C315.937%2064.9023%20316.561%2065.534%20317.325%2065.534H335.634C336.399%2065.534%20337.023%2064.9023%20337.023%2064.127V48.2636C337.023%2047.4883%20336.399%2046.8566%20335.634%2046.8566H317.325Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M360.526%2066.1579H342.217C341.112%2066.1579%20340.213%2065.247%20340.213%2064.127V48.2636C340.213%2047.1436%20341.112%2046.2327%20342.217%2046.2327H360.526C361.631%2046.2327%20362.53%2047.1436%20362.53%2048.2636V64.127C362.53%2065.247%20361.631%2066.1579%20360.526%2066.1579ZM342.217%2046.8566C341.452%2046.8566%20340.829%2047.4883%20340.829%2048.2636V64.127C340.829%2064.9023%20341.452%2065.534%20342.217%2065.534H360.526C361.291%2065.534%20361.914%2064.9023%20361.914%2064.127V48.2636C361.914%2047.4883%20361.291%2046.8566%20360.526%2046.8566H342.217Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M310.743%2090.9593H292.434C291.329%2090.9593%20290.43%2090.0484%20290.43%2088.9284V73.065C290.43%2071.945%20291.329%2071.0341%20292.434%2071.0341H310.743C311.848%2071.0341%20312.747%2071.945%20312.747%2073.065V88.9284C312.747%2090.0484%20311.848%2090.9593%20310.743%2090.9593ZM292.434%2071.658C291.669%2071.658%20291.045%2072.2897%20291.045%2073.065V88.9284C291.045%2089.7037%20291.669%2090.3354%20292.434%2090.3354H310.743C311.508%2090.3354%20312.131%2089.7037%20312.131%2088.9284V73.065C312.131%2072.2897%20311.508%2071.658%20310.743%2071.658H292.434Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M335.634%2090.9593H317.325C316.22%2090.9593%20315.322%2090.0484%20315.322%2088.9284V73.065C315.322%2071.945%20316.22%2071.0341%20317.325%2071.0341H335.634C336.74%2071.0341%20337.638%2071.945%20337.638%2073.065V88.9284C337.638%2090.0484%20336.74%2090.9593%20335.634%2090.9593ZM317.325%2071.658C316.561%2071.658%20315.937%2072.2897%20315.937%2073.065V88.9284C315.937%2089.7037%20316.561%2090.3354%20317.325%2090.3354H335.634C336.399%2090.3354%20337.023%2089.7037%20337.023%2088.9284V73.065C337.023%2072.2897%20336.399%2071.658%20335.634%2071.658H317.325Z'%20fill='%23DFDFDF'%20/%3e%3cpath%20d='M360.526%2090.9593H342.217C341.112%2090.9593%20340.213%2090.0484%20340.213%2088.9284V73.065C340.213%2071.945%20341.112%2071.0341%20342.217%2071.0341H360.526C361.631%2071.0341%20362.53%2071.945%20362.53%2073.065V88.9284C362.53%2090.0484%20361.631%2090.9593%20360.526%2090.9593Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M366.672%2040.9496L368.56%2039.46C368.56%2039.46%20370.715%2040.14%20370.77%2040.1681C370.826%2040.1962%20374.115%2047.9267%20374.115%2047.9267C374.115%2047.9267%20365.69%2052.2974%20366.306%2051.87C366.921%2051.4457%20366.793%2045.6852%20366.221%2044.935C365.647%2044.1831%20366.136%2042.2957%20366.136%2042.2957L366.667%2040.948H366.67L366.672%2040.9496Z'%20fill='%232F2E43'%20/%3e%3cpath%20d='M371.892%2044.4327H369.331V48.5507L372.156%2047.6101L371.892%2044.4327Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M363.526%2070.9888C363.592%2070.6129%20363.566%2070.2245%20363.449%2069.8564L364.342%2065.9677L362.438%2065.5637L361.739%2069.5522C361.511%2069.8579%20361.363%2070.2167%20361.308%2070.5942C361.154%2071.5379%20361.528%2072.3927%20362.141%2072.5003C362.753%2072.6095%20363.374%2071.9325%20363.527%2070.9888H363.526Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M371.094%2093.714H368.449V97.5153H371.094V93.714Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M365.876%2099.8163C367.037%2099.8163%20368.731%2099.693%20368.743%2099.6915C369.197%2099.732%20371.46%2099.913%20371.572%2099.3889C371.675%2098.9069%20371.523%2098.403%20371.501%2098.3329C371.283%2096.1413%20371.203%2096.1148%20371.154%2096.1007C371.077%2096.0773%20370.852%2096.1865%20370.487%2096.4252L370.464%2096.4408L370.459%2096.4673C370.453%2096.5001%20370.292%2097.3049%20369.525%2097.1833C369%2097.099%20368.83%2096.9805%20368.776%2096.9228C368.82%2096.9025%20368.876%2096.8666%20368.914%2096.8058C368.971%2096.7169%20368.98%2096.6014%20368.943%2096.4626C368.845%2096.0992%20368.549%2095.561%20368.537%2095.5376L368.503%2095.4768L365.499%2097.5311L363.643%2098.0692C363.503%2098.1082%20363.39%2098.2112%20363.333%2098.3469C363.255%2098.5356%20363.303%2098.7571%20363.455%2098.8944C363.792%2099.2017%20364.463%2099.7273%20365.165%2099.7929C365.351%2099.81%20365.599%2099.8178%20365.878%2099.8178L365.876%2099.8163Z'%20fill='%232F2E43'%20/%3e%3cpath%20d='M378.623%2090.7262L376.379%2092.1443L378.364%2095.3697L380.608%2093.9516L378.623%2090.7262Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M375.642%2099.2968C376.011%2099.2968%20376.419%2099.2437%20376.762%2099.0675C377.629%2098.626%20379.736%2097.074%20379.748%2097.0631C380.153%2096.8556%20382.167%2095.7949%20381.989%2095.2896C381.824%2094.8247%20381.432%2094.4784%20381.378%2094.4317C380.048%2092.6878%20379.968%2092.7096%20379.919%2092.7236C379.84%2092.7455%20379.708%2092.9576%20379.522%2093.3554L379.511%2093.3803L379.522%2093.4053C379.534%2093.438%20379.817%2094.207%20379.103%2094.5128C378.614%2094.7233%20378.407%2094.7155%20378.332%2094.6937C378.36%2094.6516%20378.387%2094.5923%20378.389%2094.519C378.392%2094.4129%20378.34%2094.3084%20378.235%2094.2117C377.961%2093.9559%20377.43%2093.658%20377.407%2093.6455L377.347%2093.6127L375.869%2096.9679L374.575%2098.4186C374.477%2098.5278%20374.435%2098.6744%20374.458%2098.821C374.49%2099.0238%20374.647%2099.1845%20374.847%2099.2203C375.051%2099.2562%20375.335%2099.2952%20375.646%2099.2952L375.642%2099.2968Z'%20fill='%232F2E43'%20/%3e%3cpath%20d='M373.041%2061.9215C373.041%2061.9215%20373.898%2061.9215%20375.241%2064.645C376.585%2067.37%20374.875%2078.3044%20374.875%2078.3044L379.662%2090.8579L376.303%2093.2413L370.173%2079.7956L371.685%2094.6888H367.906L364.966%2068.9017L365.637%2061.9231H373.041V61.9215Z'%20fill='%232F2E43'%20/%3e%3cpath%20d='M373.616%2046.9441H368.494L363.875%2062.3474H376.722L373.616%2046.9441Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M369.304%2046.9442L364.097%2068.8161H361.493C361.493%2068.8161%20365.439%2048.5617%20365.776%2047.7101C366.112%2046.8584%20369.302%2046.9442%20369.302%2046.9442H369.304Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M369.682%2045.5715C371.236%2045.5715%20372.496%2044.2949%20372.496%2042.7201C372.496%2041.1454%20371.236%2039.8688%20369.682%2039.8688C368.128%2039.8688%20366.869%2041.1454%20366.869%2042.7201C366.869%2044.2949%20368.128%2045.5715%20369.682%2045.5715Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M366.178%2042.2007L366.867%2042.3193C367.511%2039.7081%20368.968%2040.5613%20369.107%2040.5317C369.245%2040.502%20371.317%2042.7997%20371.149%2045.1269C370.981%2047.4526%20373.949%2048.543%20373.949%2048.543C373.949%2048.543%20374.986%2050.5177%20374.061%2054.0913C373.136%2057.6649%20375.097%2058.8644%20375.097%2058.8644C378.96%2058.5321%20376.637%2053.0696%20376.022%2052.0775C375.406%2051.0839%20375.826%2049.3541%20375.826%2049.3541C376.779%2048.5024%20375.658%2046.6306%20375.658%2046.6306C375.658%2046.6306%20375.856%2044.1333%20375.268%2043.6513C374.68%2043.1694%20374.652%2041.9776%20374.652%2041.9776C373.615%2037.4105%20370.229%2038.2902%20370.229%2038.2902C365.89%2037.8082%20366.179%2042.1991%20366.179%2042.1991L366.178%2042.2007Z'%20fill='%232F2E43'%20/%3e%3cpath%20d='M378.915%2070.5318C378.844%2070.1559%20378.684%2069.8018%20378.446%2069.5007L377.916%2065.5435L375.994%2065.8523L376.737%2069.833C376.634%2070.2011%20376.622%2070.5879%20376.701%2070.9623C376.887%2071.8998%20377.535%2072.5627%20378.146%2072.4441C378.757%2072.3256%20379.102%2071.4692%20378.914%2070.5318H378.915Z'%20fill='%23F2A2A5'%20/%3e%3cpath%20d='M376.203%2068.5586H378.808C378.808%2068.5586%20374.861%2048.3042%20374.524%2047.4525C374.189%2046.6008%20371.378%2046.9627%20371.378%2046.9627L376.203%2068.5586Z'%20fill='%2317AD49'%20/%3e%3cg%20style='mix-blend-mode:%20color'%3e%3crect%20x='268'%20width='120'%20height='120'%20fill='white'%20/%3e%3c/g%3e%3c/g%3e%3crect%20width='120'%20height='120'%20transform='translate(0%20177)'%20fill='white'%20/%3e%3cpath%20d='M7.20357%20245.902C7.47016%20245.383%208.21187%20245.383%208.47846%20245.902L9.19529%20247.297C9.2637%20247.43%209.37208%20247.538%209.50522%20247.607L10.9004%20248.324C11.4192%20248.59%2011.4192%20249.332%2010.9004%20249.599L9.50522%20250.315C9.37208%20250.384%209.2637%20250.492%209.19529%20250.625L8.47846%20252.02C8.21187%20252.539%207.47016%20252.539%207.20357%20252.02L6.48674%20250.625C6.41833%20250.492%206.30995%20250.384%206.17681%20250.315L4.78167%20249.599C4.26281%20249.332%204.26281%20248.59%204.78167%20248.324L6.17681%20247.607C6.30995%20247.538%206.41833%20247.43%206.48674%20247.297L7.20357%20245.902Z'%20fill='%23E6EFFF'%20/%3e%3cpath%20d='M106.204%20219.902C106.47%20219.383%20107.212%20219.383%20107.478%20219.902L108.195%20221.297C108.264%20221.43%20108.372%20221.538%20108.505%20221.607L109.9%20222.324C110.419%20222.59%20110.419%20223.332%20109.9%20223.599L108.505%20224.315C108.372%20224.384%20108.264%20224.492%20108.195%20224.625L107.478%20226.02C107.212%20226.539%20106.47%20226.539%20106.204%20226.02L105.487%20224.625C105.418%20224.492%20105.31%20224.384%20105.177%20224.315L103.782%20223.599C103.263%20223.332%20103.263%20222.59%20103.782%20222.324L105.177%20221.607C105.31%20221.538%20105.418%20221.43%20105.487%20221.297L106.204%20219.902Z'%20fill='%23E6EFFF'%20/%3e%3cpath%20d='M76.2036%20197.902C76.4702%20197.383%2077.2119%20197.383%2077.4785%20197.902L78.1953%20199.297C78.2637%20199.43%2078.3721%20199.538%2078.5052%20199.607L79.9004%20200.324C80.4192%20200.59%2080.4192%20201.332%2079.9004%20201.599L78.5052%20202.315C78.3721%20202.384%2078.2637%20202.492%2078.1953%20202.625L77.4785%20204.02C77.2119%20204.539%2076.4702%20204.539%2076.2036%20204.02L75.4867%20202.625C75.4183%20202.492%2075.31%20202.384%2075.1768%20202.315L73.7817%20201.599C73.2628%20201.332%2073.2628%20200.59%2073.7817%20200.324L75.1768%20199.607C75.31%20199.538%2075.4183%20199.43%2075.4867%20199.297L76.2036%20197.902Z'%20fill='%23E6EFFF'%20/%3e%3cpath%20d='M57.7702%20207.902C58.0368%20207.383%2058.7785%20207.383%2059.0451%20207.902L59.2755%20208.35C59.3439%20208.483%2059.4523%20208.592%2059.5854%20208.66L60.0337%20208.89C60.5526%20209.157%2060.5526%20209.899%2060.0337%20210.165L59.5854%20210.396C59.4523%20210.464%2059.3439%20210.572%2059.2755%20210.706L59.0451%20211.154C58.7785%20211.673%2058.0368%20211.673%2057.7702%20211.154L57.5399%20210.706C57.4715%20210.572%2057.3631%20210.464%2057.23%20210.396L56.7817%20210.165C56.2628%20209.899%2056.2628%20209.157%2056.7817%20208.89L57.23%20208.66C57.3631%20208.592%2057.4715%20208.483%2057.5399%20208.35L57.7702%20207.902Z'%20fill='%23E6EFFF'%20/%3e%3cpath%20d='M26.7702%20221.902C27.0368%20221.383%2027.7785%20221.383%2028.0451%20221.902L28.2755%20222.35C28.3439%20222.483%2028.4523%20222.592%2028.5854%20222.66L29.0337%20222.89C29.5526%20223.157%2029.5526%20223.899%2029.0337%20224.165L28.5854%20224.396C28.4523%20224.464%2028.3439%20224.572%2028.2755%20224.706L28.0451%20225.154C27.7785%20225.673%2027.0368%20225.673%2026.7702%20225.154L26.5399%20224.706C26.4715%20224.572%2026.3631%20224.464%2026.23%20224.396L25.7817%20224.165C25.2628%20223.899%2025.2628%20223.157%2025.7817%20222.89L26.23%20222.66C26.3631%20222.592%2026.4715%20222.483%2026.5399%20222.35L26.7702%20221.902Z'%20fill='%23E6EFFF'%20/%3e%3cpath%20d='M89.2702%20210.902C89.5368%20210.383%2090.2785%20210.383%2090.5451%20210.902L90.7755%20211.35C90.8439%20211.483%2090.9523%20211.592%2091.0854%20211.66L91.5337%20211.89C92.0526%20212.157%2092.0526%20212.899%2091.5337%20213.165L91.0854%20213.396C90.9523%20213.464%2090.8439%20213.572%2090.7755%20213.706L90.5451%20214.154C90.2785%20214.673%2089.5368%20214.673%2089.2702%20214.154L89.0399%20213.706C88.9715%20213.572%2088.8631%20213.464%2088.73%20213.396L88.2817%20213.165C87.7628%20212.899%2087.7628%20212.157%2088.2817%20211.89L88.73%20211.66C88.8631%20211.592%2088.9715%20211.483%2089.0399%20211.35L89.2702%20210.902Z'%20fill='%23E6EFFF'%20/%3e%3cpath%20d='M108.77%20244.902C109.037%20244.383%20109.779%20244.383%20110.045%20244.902L110.275%20245.35C110.344%20245.483%20110.452%20245.592%20110.585%20245.66L111.034%20245.89C111.553%20246.157%20111.553%20246.899%20111.034%20247.165L110.585%20247.396C110.452%20247.464%20110.344%20247.572%20110.275%20247.706L110.045%20248.154C109.779%20248.673%20109.037%20248.673%20108.77%20248.154L108.54%20247.706C108.471%20247.572%20108.363%20247.464%20108.23%20247.396L107.782%20247.165C107.263%20246.899%20107.263%20246.157%20107.782%20245.89L108.23%20245.66C108.363%20245.592%20108.471%20245.483%20108.54%20245.35L108.77%20244.902Z'%20fill='%23E6EFFF'%20/%3e%3cpath%20d='M29.2036%20201.902C29.4702%20201.383%2030.2119%20201.383%2030.4785%20201.902L31.1953%20203.297C31.2637%20203.43%2031.3721%20203.538%2031.5052%20203.607L32.9004%20204.324C33.4192%20204.59%2033.4192%20205.332%2032.9004%20205.599L31.5052%20206.315C31.3721%20206.384%2031.2637%20206.492%2031.1953%20206.625L30.4785%20208.02C30.2119%20208.539%2029.4702%20208.539%2029.2036%20208.02L28.4867%20206.625C28.4183%20206.492%2028.31%20206.384%2028.1768%20206.315L26.7817%20205.599C26.2628%20205.332%2026.2628%20204.59%2026.7817%20204.324L28.1768%20203.607C28.31%20203.538%2028.4183%20203.43%2028.4867%20203.297L29.2036%20201.902Z'%20fill='%23E6EFFF'%20/%3e%3cpath%20d='M8.77023%20227.902C9.03682%20227.383%209.77854%20227.383%2010.0451%20227.902L10.2755%20228.35C10.3439%20228.483%2010.4523%20228.592%2010.5854%20228.66L11.0337%20228.89C11.5526%20229.157%2011.5526%20229.899%2011.0337%20230.165L10.5854%20230.396C10.4523%20230.464%2010.3439%20230.572%2010.2755%20230.706L10.0451%20231.154C9.77854%20231.673%209.03682%20231.673%208.77023%20231.154L8.5399%20230.706C8.47149%20230.572%208.36311%20230.464%208.22997%20230.396L7.78167%20230.165C7.26281%20229.899%207.26281%20229.157%207.78167%20228.89L8.22997%20228.66C8.36311%20228.592%208.47149%20228.483%208.5399%20228.35L8.77023%20227.902Z'%20fill='%23E6EFFF'%20/%3e%3cpath%20d='M45.7702%20192.902C46.0368%20192.383%2046.7785%20192.383%2047.0451%20192.902L47.2755%20193.35C47.3439%20193.483%2047.4523%20193.592%2047.5854%20193.66L48.0337%20193.89C48.5526%20194.157%2048.5526%20194.899%2048.0337%20195.165L47.5854%20195.396C47.4523%20195.464%2047.3439%20195.572%2047.2755%20195.706L47.0451%20196.154C46.7785%20196.673%2046.0368%20196.673%2045.7702%20196.154L45.5399%20195.706C45.4715%20195.572%2045.3631%20195.464%2045.23%20195.396L44.7817%20195.165C44.2628%20194.899%2044.2628%20194.157%2044.7817%20193.89L45.23%20193.66C45.3631%20193.592%2045.4715%20193.483%2045.5399%20193.35L45.7702%20192.902Z'%20fill='%23E6EFFF'%20/%3e%3cpath%20d='M22.4889%20210.661C19.3426%20210.661%2018.7866%20212.562%2017.9344%20213.414C19.193%20212.155%2021.3746%20212.038%2022.4889%20212.234C45.8237%20215.708%2093.3978%20222.695%2097.016%20222.853C100.634%20223.01%20101.67%20226.982%20101.735%20228.949V280.862C102.522%20280.39%20102.587%20277.912%20102.522%20276.733V226.982C102.365%20222.892%2098.7858%20221.476%2097.016%20221.28C97.016%20221.28%2025.6351%20210.661%2022.4889%20210.661Z'%20fill='%2333DA6B'%20/%3e%3cpath%20d='M17.5726%20266.508V214.398C18.0445%20212.195%2019.9979%20211.776%2020.9156%20211.841L96.8192%20222.657C100.595%20222.971%20101.67%20226.327%20101.735%20227.966C101.932%20244.746%20102.207%20278.778%20101.735%20280.666C101.263%20282.554%2097.999%20282.501%2096.4259%20282.239L22.0954%20271.817C18.0052%20270.873%2017.376%20267.884%2017.5726%20266.508Z'%20fill='url(%23paint0_linear_3273_18484)'%20/%3e%3cpath%20d='M60.8251%20239.011C60.8641%20238.564%2061.268%20238.24%2061.7125%20238.299L88.3448%20241.844C88.7617%20241.9%2089.0612%20242.273%2089.0246%20242.692L88.7856%20245.433C88.7467%20245.88%2088.3427%20246.204%2087.8983%20246.145L61.2659%20242.6C60.849%20242.544%2060.5495%20242.171%2060.5861%20241.752L60.8251%20239.011Z'%20fill='%236FE697'%20/%3e%3cpath%20d='M60.937%20249.63C60.976%20249.183%2061.3799%20248.859%2061.8244%20248.918L88.4568%20252.463C88.8736%20252.519%2089.1731%20252.892%2089.1366%20253.311L88.8976%20256.052C88.8586%20256.499%2088.4547%20256.823%2088.0102%20256.763L61.3778%20253.219C60.961%20253.163%2060.6615%20252.79%2060.698%20252.371L60.937%20249.63Z'%20fill='%236FE697'%20/%3e%3cpath%20d='M60.8251%20259.855C60.8641%20259.409%2061.268%20259.085%2061.7125%20259.144L88.3448%20262.689C88.7617%20262.744%2089.0612%20263.118%2089.0246%20263.537L88.7856%20266.278C88.7467%20266.724%2088.3427%20267.048%2087.8983%20266.989L61.2659%20263.444C60.849%20263.389%2060.5495%20263.015%2060.5861%20262.596L60.8251%20259.855Z'%20fill='%236FE697'%20/%3e%3cpath%20d='M27.3733%20236.504C27.3733%20234.661%2028.9504%20233.213%2030.7869%20233.369L49.8611%20234.996C51.4892%20235.135%2052.74%20236.497%2052.74%20238.131V259.345C52.74%20261.188%2051.1629%20262.637%2049.3265%20262.48L30.2522%20260.854C28.6241%20260.715%2027.3733%20259.353%2027.3733%20257.719V236.504Z'%20fill='%2333DA6B'%20/%3e%3cpath%20d='M101.845%20233.828L17.541%20221.673V215.38C17.541%20212.245%2019.7041%20211.644%2021.0223%20211.855C21.7287%20211.882%2022.2604%20211.841%2022.2604%20211.841C22.2604%20211.841%2092.8547%20222.263%2096.7875%20222.46C101.541%20223.161%20101.91%20227.507%20101.845%20229.932V233.828Z'%20fill='url(%23paint1_linear_3273_18484)'%20/%3e%3cpath%20d='M38.6305%20239.575C38.9216%20239.37%2039.3135%20239.387%2039.5864%20239.615L46.2813%20245.204C46.8728%20245.698%2046.4751%20246.66%2045.7076%20246.592L32.695%20245.436C31.9644%20245.371%2031.7124%20244.43%2032.3127%20244.008L38.6305%20239.575Z'%20fill='%23E6FFEE'%20/%3e%3cpath%20d='M31.906%20253.807C31.9449%20253.36%2032.3489%20253.036%2032.7933%20253.095L45.3471%20254.766C45.764%20254.822%2046.0634%20255.195%2046.0269%20255.614L45.9756%20256.203C45.9366%20256.65%2045.5327%20256.974%2045.0882%20256.914L32.5344%20255.244C32.1176%20255.188%2031.8181%20254.814%2031.8546%20254.395L31.906%20253.807Z'%20fill='%23E6FFEE'%20/%3e%3cpath%20d='M38.7425%20252.843C38.2773%20252.896%2037.8692%20252.533%2037.8671%20252.065L37.8487%20248.024C37.8469%20247.623%2038.1476%20247.285%2038.5464%20247.239L39.0085%20247.187C39.4737%20247.134%2039.8818%20247.496%2039.884%20247.965L39.9023%20252.005C39.9041%20252.407%2039.6035%20252.745%2039.2047%20252.791L38.7425%20252.843Z'%20fill='%23E6FFEE'%20/%3e%3cpath%20d='M43.4619%20253.236C42.9967%20253.289%2042.5885%20252.927%2042.5864%20252.458L42.5681%20248.418C42.5662%20248.016%2042.8669%20247.678%2043.2657%20247.633L43.7279%20247.58C44.1931%20247.527%2044.6012%20247.89%2044.6033%20248.358L44.6217%20252.399C44.6235%20252.8%2044.3228%20253.139%2043.924%20253.184L43.4619%20253.236Z'%20fill='%23E6FFEE'%20/%3e%3cpath%20d='M34.4162%20252.056C33.951%20252.109%2033.5429%20251.747%2033.5408%20251.278L33.5224%20247.237C33.5206%20246.836%2033.8213%20246.498%2034.2201%20246.452L34.6822%20246.4C35.1474%20246.347%2035.5555%20246.71%2035.5577%20247.178L35.576%20251.219C35.5778%20251.62%2035.2772%20251.958%2034.8784%20252.004L34.4162%20252.056Z'%20fill='%23E6FFEE'%20/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_3273_18484'%20x1='111.156'%20y1='252.587'%20x2='6.05453'%20y2='237.08'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23AFF7C7'%20/%3e%3cstop%20offset='1'%20stop-color='%23E1FFEB'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_3273_18484'%20x1='86.3655'%20y1='227.572'%20x2='17.541'%20y2='217.937'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%2317AD49'%20/%3e%3cstop%20offset='1'%20stop-color='%2334DB6C'%20/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_3273_18484'%3e%3crect%20width='120'%20height='120'%20fill='white'%20transform='translate(268)'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", zu = "data:image/svg+xml,%3csvg%20width='120'%20height='120'%20viewBox='0%200%20120%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_4886_419)'%3e%3cpath%20d='M119.335%2022.2175H0.664712C0.488478%2022.2174%200.319518%2022.1476%200.194902%2022.0235C0.0702863%2021.8994%200.000192624%2021.7311%200%2021.5556V17.6619C0.000192624%2017.4864%200.0702863%2017.3182%200.194902%2017.1941C0.319518%2017.07%200.488478%2017.0002%200.664712%2017H119.335C119.512%2017.0002%20119.68%2017.07%20119.805%2017.1941C119.93%2017.3182%20120%2017.4864%20120%2017.6619V21.5556C120%2021.7311%20119.93%2021.8994%20119.805%2022.0235C119.68%2022.1476%20119.512%2022.2174%20119.335%2022.2175Z'%20fill='%23E4E4E4'%20/%3e%3cpath%20d='M3.8576%2020.3587C4.37881%2020.3587%204.80133%2019.9379%204.80133%2019.4189C4.80133%2018.8999%204.37881%2018.4791%203.8576%2018.4791C3.3364%2018.4791%202.91388%2018.8999%202.91388%2019.4189C2.91388%2019.9379%203.3364%2020.3587%203.8576%2020.3587Z'%20fill='white'%20/%3e%3cpath%20d='M7.4397%2020.3587C7.9609%2020.3587%208.38342%2019.9379%208.38342%2019.4189C8.38342%2018.8999%207.9609%2018.4791%207.4397%2018.4791C6.91849%2018.4791%206.49597%2018.8999%206.49597%2019.4189C6.49597%2019.9379%206.91849%2020.3587%207.4397%2020.3587Z'%20fill='white'%20/%3e%3cpath%20d='M11.0219%2020.3587C11.5431%2020.3587%2011.9656%2019.9379%2011.9656%2019.4189C11.9656%2018.8999%2011.5431%2018.4791%2011.0219%2018.4791C10.5007%2018.4791%2010.0782%2018.8999%2010.0782%2019.4189C10.0782%2019.9379%2010.5007%2020.3587%2011.0219%2020.3587Z'%20fill='white'%20/%3e%3cpath%20d='M115.826%2018.772H111.701C111.62%2018.7718%20111.542%2018.7397%20111.485%2018.6826C111.428%2018.6256%20111.396%2018.5483%20111.396%2018.4677C111.396%2018.3871%20111.428%2018.3099%20111.485%2018.2528C111.542%2018.1958%20111.62%2018.1636%20111.701%2018.1635H115.826C115.907%2018.1634%20115.984%2018.1953%20116.042%2018.2523C116.099%2018.3092%20116.131%2018.3865%20116.131%2018.4672C116.132%2018.5478%20116.1%2018.6252%20116.042%2018.6823C115.985%2018.7395%20115.908%2018.7717%20115.827%2018.772H115.826Z'%20fill='white'%20/%3e%3cpath%20d='M115.826%2019.913H111.701C111.62%2019.9128%20111.542%2019.8807%20111.485%2019.8236C111.428%2019.7666%20111.396%2019.6893%20111.396%2019.6087C111.396%2019.5281%20111.428%2019.4508%20111.485%2019.3938C111.542%2019.3368%20111.62%2019.3046%20111.701%2019.3044H115.826C115.907%2019.3044%20115.984%2019.3363%20116.042%2019.3933C116.099%2019.4502%20116.131%2019.5275%20116.131%2019.6081C116.132%2019.6888%20116.1%2019.7662%20116.042%2019.8233C115.985%2019.8805%20115.908%2019.9127%20115.827%2019.913H115.826Z'%20fill='white'%20/%3e%3cpath%20d='M115.826%2021.0541H111.701C111.62%2021.0541%20111.542%2021.022%20111.485%2020.965C111.427%2020.9079%20111.395%2020.8305%20111.395%2020.7498C111.395%2020.6691%20111.427%2020.5917%20111.485%2020.5347C111.542%2020.4776%20111.62%2020.4456%20111.701%2020.4456H115.826C115.907%2020.4454%20115.984%2020.4773%20116.042%2020.5343C116.099%2020.5912%20116.132%2020.6686%20116.132%2020.7493C116.132%2020.83%20116.1%2020.9074%20116.043%2020.9646C115.985%2021.0217%20115.908%2021.0539%20115.827%2021.0541H115.826Z'%20fill='white'%20/%3e%3cpath%20d='M33.8373%2094.3736C34.274%2090.877%2036.4501%2087.4317%2039.7989%2086.2938C38.4782%2089.8929%2038.4785%2093.8411%2039.7997%2097.4399C40.3143%2098.826%2041.0315%20100.314%2040.5475%20101.711C40.2463%20102.581%2039.5096%20103.246%2038.6861%20103.661C37.8625%20104.077%2036.9485%20104.275%2036.046%20104.47L35.8684%20104.616C34.4356%20101.394%2033.4007%2097.8703%2033.8373%2094.3736Z'%20fill='%23F0F0F0'%20/%3e%3cpath%20d='M39.8322%2086.36C37.882%2088.5359%2036.6699%2091.2685%2036.3681%2094.1695C36.292%2094.7929%2036.315%2095.4243%2036.4363%2096.0405C36.574%2096.637%2036.8696%2097.1859%2037.2923%2097.6301C37.6781%2098.0523%2038.1219%2098.4395%2038.3979%2098.9477C38.5353%2099.2099%2038.6155%2099.4981%2038.6333%2099.7933C38.651%20100.089%2038.6059%20100.384%2038.5009%20100.661C38.2571%20101.357%2037.7768%20101.924%2037.2877%20102.463C36.7446%20103.061%2036.171%20103.674%2035.9401%20104.466C35.9122%20104.562%2035.7641%20104.514%2035.7921%20104.418C36.1937%20103.038%2037.5383%20102.255%2038.1796%20101.012C38.4788%20100.433%2038.6044%2099.7597%2038.3239%2099.1478C38.0786%2098.6126%2037.6213%2098.2129%2037.227%2097.7888C36.8082%2097.3615%2036.5009%2096.8385%2036.3319%2096.2656C36.1794%2095.6575%2036.132%2095.028%2036.1916%2094.4041C36.3034%2092.9973%2036.6366%2091.6167%2037.179%2090.313C37.7897%2088.8216%2038.6522%2087.4453%2039.729%2086.2435C39.7957%2086.1692%2039.8984%2086.2861%2039.8322%2086.36Z'%20fill='white'%20/%3e%3cpath%20d='M36.4101%2093.2296C35.9282%2093.1131%2035.5035%2092.8298%2035.212%2092.4303C34.9205%2092.0309%2034.7811%2091.5412%2034.8187%2091.0488C34.8204%2091.0287%2034.8299%2091.0101%2034.8451%2090.9968C34.8603%2090.9836%2034.8801%2090.9768%2034.9003%2090.9778C34.9205%2090.9788%2034.9396%2090.9875%2034.9534%2091.0022C34.9672%2091.0169%2034.9748%2091.0364%2034.9745%2091.0565C34.9387%2091.515%2035.0686%2091.9711%2035.3408%2092.3425C35.613%2092.714%2036.0096%2092.9763%2036.4589%2093.0822C36.5566%2093.1053%2036.5071%2093.2526%2036.4101%2093.2296Z'%20fill='white'%20/%3e%3cpath%20d='M37.0683%2097.4418C37.9387%2096.9242%2038.5812%2096.0991%2038.8677%2095.1308C38.8961%2095.0348%2039.0441%2095.0836%2039.0158%2095.1795C38.7158%2096.1865%2038.0454%2097.0439%2037.1385%2097.5805C37.052%2097.6315%2036.9823%2097.4926%2037.0683%2097.4418Z'%20fill='white'%20/%3e%3cpath%20d='M37.9344%2088.9687C38.1114%2089.0525%2038.3065%2089.0912%2038.5023%2089.0813C38.698%2089.0714%2038.8882%2089.0132%2039.0558%2088.912C39.1416%2088.8599%2039.2112%2088.9989%2039.1259%2089.0507C38.9403%2089.1617%2038.7301%2089.2256%2038.5139%2089.2371C38.2976%2089.2485%2038.0819%2089.207%2037.8855%2089.1162C37.8662%2089.1092%2037.8504%2089.0951%2037.8412%2089.0769C37.832%2089.0587%2037.8301%2089.0377%2037.8359%2089.0181C37.8424%2088.9986%2037.8565%2088.9825%2037.8749%2088.9732C37.8934%2088.964%2037.9147%2088.9624%2037.9344%2088.9687Z'%20fill='white'%20/%3e%3cpath%20d='M50.0063%2092.5393C49.9537%2092.5734%2049.901%2092.6075%2049.8483%2092.6429C49.1431%2093.1047%2048.4767%2093.6228%2047.8557%2094.1921C47.807%2094.2353%2047.7583%2094.2799%2047.7109%2094.3245C46.2295%2095.7119%2045.0196%2097.3612%2044.1428%2099.1884C43.7945%2099.9158%2043.5023%20100.669%2043.2688%20101.44C42.9463%20102.506%2042.6818%20103.687%2042.0434%20104.558C41.9778%20104.65%2041.9066%20104.737%2041.8302%20104.82H36.0614C36.0482%20104.814%2036.0351%20104.809%2036.0219%20104.802L35.7916%20104.813C35.8008%20104.772%2035.8113%20104.73%2035.8206%20104.689C35.8258%20104.666%2035.8324%20104.642%2035.8377%20104.619C35.8416%20104.603%2035.8456%20104.587%2035.8482%20104.573C35.8495%20104.567%2035.8508%20104.562%2035.8521%20104.558C35.8547%20104.544%2035.8587%20104.531%2035.8614%20104.518C35.9193%20104.283%2035.9789%20104.048%2036.0403%20103.814C36.0403%20103.812%2036.0403%20103.812%2036.0416%20103.811C36.4925%20102.019%2037.1552%20100.286%2038.0159%2098.6497C38.0423%2098.6012%2038.0685%2098.5514%2038.0975%2098.5029C38.4961%2097.7784%2038.9535%2097.0875%2039.465%2096.4372C39.7463%2096.0821%2040.0455%2095.7413%2040.3614%2095.4162C41.1792%2094.5779%2042.1244%2093.8729%2043.1622%2093.327C45.2312%2092.2391%2047.6267%2091.8223%2049.8379%2092.4868C49.8944%2092.5039%2049.9498%2092.521%2050.0063%2092.5393Z'%20fill='%23F0F0F0'%20/%3e%3cpath%20d='M49.9933%2092.6122C47.1207%2093.1804%2044.5008%2094.6355%2042.5059%2096.7708C42.0682%2097.2229%2041.7049%2097.7408%2041.4292%2098.3056C41.1785%2098.8644%2041.0826%2099.4799%2041.1515%20100.088C41.2044%20100.656%2041.3245%20101.232%2041.2377%20101.803C41.1889%20102.095%2041.0787%20102.373%2040.9144%20102.619C40.7501%20102.866%2040.5353%20103.075%2040.2841%20103.232C39.6687%20103.642%2038.9421%20103.807%2038.2259%20103.944C37.4308%20104.096%2036.6024%20104.241%2035.9388%20104.736C35.8583%20104.796%2035.7697%20104.668%2035.85%20104.608C37.0046%20103.748%2038.5519%20103.928%2039.815%20103.321C40.4044%20103.037%2040.9116%20102.575%2041.0576%20101.918C41.1853%20101.344%2041.0619%20100.751%2041.0034%20100.176C40.9274%2099.5833%2040.9983%2098.9814%2041.2097%2098.4227C41.4556%2097.8457%2041.7983%2097.3147%2042.2232%2096.8523C43.1629%2095.796%2044.2636%2094.8935%2045.4849%2094.1777C46.8743%2093.3531%2048.395%2092.7713%2049.9814%2092.4574C50.0796%2092.438%2050.0909%2092.593%2049.9933%2092.6122Z'%20fill='white'%20/%3e%3cpath%20d='M43.1077%2096.0455C42.7933%2095.6636%2042.6256%2095.1828%2042.6344%2094.689C42.6431%2094.1953%2042.8279%2093.7207%2043.1556%2093.3501C43.2221%2093.2753%2043.3419%2093.3748%2043.2753%2093.4497C42.9695%2093.7943%2042.7974%2094.2363%2042.7902%2094.6961C42.783%2095.1559%2042.941%2095.6031%2043.2359%2095.9571C43.2998%2096.0341%2043.1713%2096.1221%2043.1077%2096.0455Z'%20fill='white'%20/%3e%3cpath%20d='M41.0867%2099.8033C42.0945%2099.9119%2043.1064%2099.6383%2043.9206%2099.037C44.0012%2098.9773%2044.0899%2099.1051%2044.0094%2099.1646C43.1609%2099.7888%2042.1073%20100.071%2041.0588%2099.9561C40.9589%2099.9451%2040.9873%2099.7923%2041.0867%2099.8033Z'%20fill='white'%20/%3e%3cpath%20d='M46.9009%2093.5573C46.9916%2093.7303%2047.124%2093.8782%2047.2863%2093.9877C47.4485%2094.0971%2047.6356%2094.1647%2047.8306%2094.1844C47.9306%2094.1942%2047.9021%2094.347%2047.8027%2094.3372C47.5874%2094.3145%2047.3809%2094.2396%2047.2013%2094.119C47.0218%2093.9985%2046.8746%2093.836%2046.7727%2093.6458C46.7616%2093.6286%2046.7574%2093.6079%2046.7611%2093.5879C46.7647%2093.5678%2046.7759%2093.5499%2046.7924%2093.5377C46.8094%2093.5261%2046.8304%2093.5216%2046.8507%2093.5253C46.871%2093.529%2046.889%2093.5405%2046.9009%2093.5573Z'%20fill='white'%20/%3e%3cpath%20d='M38.8956%2044.1488H19.8096C19.2198%2044.1481%2018.6543%2043.9145%2018.2373%2043.4992C17.8202%2043.0839%2017.5856%2042.5208%2017.585%2041.9334V31.5817C17.5856%2030.9944%2017.8202%2030.4313%2018.2373%2030.016C18.6543%2029.6007%2019.2198%2029.3671%2019.8096%2029.3665H38.8956C39.4854%2029.3671%2040.0508%2029.6007%2040.4679%2030.016C40.8849%2030.4313%2041.1195%2030.9944%2041.1202%2031.5817V41.9334C41.1195%2042.5208%2040.8849%2043.0839%2040.4679%2043.4992C40.0508%2043.9145%2039.4854%2044.1481%2038.8956%2044.1488Z'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M68.0344%2044.1488H48.9484C48.3585%2044.1481%2047.7931%2043.9145%2047.376%2043.4992C46.959%2043.0839%2046.7244%2042.5208%2046.7238%2041.9334V31.5817C46.7244%2030.9944%2046.959%2030.4313%2047.3761%2030.016C47.7931%2029.6007%2048.3586%2029.3671%2048.9484%2029.3665H68.0344C68.6242%2029.3671%2069.1896%2029.6007%2069.6067%2030.016C70.0237%2030.4313%2070.2583%2030.9944%2070.259%2031.5817V41.9334C70.2583%2042.5208%2070.0237%2043.0839%2069.6067%2043.4992C69.1896%2043.9145%2068.6242%2044.1481%2068.0344%2044.1488Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M97.1732%2044.1488H78.0872C77.4974%2044.1481%2076.9319%2043.9145%2076.5149%2043.4992C76.0978%2043.0839%2075.8633%2042.5208%2075.8626%2041.9334V31.5817C75.8633%2030.9944%2076.0979%2030.4313%2076.5149%2030.016C76.932%2029.6007%2077.4974%2029.3671%2078.0872%2029.3665H97.1732C97.763%2029.3671%2098.3285%2029.6007%2098.7455%2030.016C99.1626%2030.4313%2099.3972%2030.9944%2099.3978%2031.5817V41.9334C99.3972%2042.5208%2099.1626%2043.0839%2098.7455%2043.4992C98.3285%2043.9145%2097.763%2044.1481%2097.1732%2044.1488Z'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M38.8956%2067.2137H19.8096C19.2198%2067.2131%2018.6543%2066.9794%2018.2373%2066.5641C17.8202%2066.1488%2017.5856%2065.5857%2017.585%2064.9984V54.6466C17.5856%2054.0593%2017.8202%2053.4962%2018.2373%2053.0809C18.6543%2052.6656%2019.2198%2052.432%2019.8096%2052.4314H38.8956C39.4854%2052.432%2040.0508%2052.6656%2040.4679%2053.0809C40.8849%2053.4962%2041.1195%2054.0593%2041.1202%2054.6466V64.9984C41.1195%2065.5857%2040.8849%2066.1488%2040.4679%2066.5641C40.0508%2066.9794%2039.4854%2067.2131%2038.8956%2067.2137Z'%20fill='%23F2F2F2'%20/%3e%3cpath%20d='M97.1732%2066.7676H78.0872C77.4974%2066.7669%2076.9319%2066.5333%2076.5149%2066.118C76.0979%2065.7026%2075.8633%2065.1395%2075.8626%2064.5522V54.2005C75.8633%2053.6131%2076.0979%2053.0501%2076.5149%2052.6348C76.932%2052.2195%2077.4974%2051.9859%2078.0872%2051.9852H97.1732C97.763%2051.9859%2098.3285%2052.2195%2098.7455%2052.6348C99.1626%2053.0501%2099.3972%2053.6131%2099.3978%2054.2005V64.5522C99.3972%2065.1395%2099.1626%2065.7026%2098.7455%2066.118C98.3285%2066.5333%2097.763%2066.7669%2097.1732%2066.7676Z'%20fill='%23F2F2F2'%20/%3e%3cpath%20d='M68.0344%2067.2136H48.9484C48.3585%2067.2129%2047.7931%2066.9793%2047.376%2066.564C46.959%2066.1487%2046.7244%2065.5856%2046.7238%2064.9982V54.6465C46.7244%2054.0592%2046.959%2053.4961%2047.3761%2053.0808C47.7931%2052.6655%2048.3586%2052.4319%2048.9484%2052.4313H68.0344C68.6242%2052.4319%2069.1896%2052.6655%2069.6067%2053.0808C70.0237%2053.4961%2070.2583%2054.0592%2070.259%2054.6465V64.9982C70.2583%2065.5856%2070.0237%2066.1487%2069.6067%2066.564C69.1896%2066.9793%2068.6242%2067.2129%2068.0344%2067.2136Z'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M69.382%2069.1185C71.2646%2069.1185%2072.7908%2067.5987%2072.7908%2065.7239C72.7908%2063.8492%2071.2646%2062.3293%2069.382%2062.3293C67.4994%2062.3293%2065.9732%2063.8492%2065.9732%2065.7239C65.9732%2067.5987%2067.4994%2069.1185%2069.382%2069.1185Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M70.7975%2065.4389H69.6385V64.2848C69.6385%2064.2491%2069.6315%2064.2138%2069.6178%2064.1808C69.6041%2064.1479%2069.584%2064.118%2069.5587%2064.0927C69.5333%2064.0675%2069.5033%2064.0475%2069.4702%2064.0339C69.4371%2064.0202%2069.4016%2064.0132%2069.3658%2064.0132C69.33%2064.0132%2069.2945%2064.0202%2069.2614%2064.0339C69.2284%2064.0475%2069.1983%2064.0675%2069.173%2064.0927C69.1476%2064.118%2069.1276%2064.1479%2069.1138%2064.1808C69.1001%2064.2138%2069.0931%2064.2491%2069.0931%2064.2848V65.4389H67.9341C67.8983%2065.4389%2067.8628%2065.446%2067.8297%2065.4596C67.7966%2065.4733%2067.7666%2065.4933%2067.7413%2065.5185C67.7159%2065.5437%2067.6958%2065.5736%2067.6821%2065.6066C67.6684%2065.6395%2067.6614%2065.6748%2067.6614%2065.7105C67.6614%2065.7462%2067.6684%2065.7815%2067.6821%2065.8144C67.6958%2065.8474%2067.7159%2065.8773%2067.7413%2065.9026C67.7666%2065.9278%2067.7966%2065.9478%2067.8297%2065.9614C67.8628%2065.9751%2067.8983%2065.9821%2067.9341%2065.9821H69.0931V67.1363C69.0931%2067.1719%2069.1002%2067.2072%2069.1139%2067.2402C69.1276%2067.2731%2069.1477%2067.3031%2069.173%2067.3283C69.1983%2067.3535%2069.2284%2067.3735%2069.2614%2067.3872C69.2945%2067.4008%2069.33%2067.4078%2069.3658%2067.4078C69.4382%2067.4078%2069.5075%2067.3792%2069.5587%2067.3283C69.6098%2067.2774%2069.6385%2067.2083%2069.6385%2067.1363V65.9821H70.7975C70.8333%2065.9821%2070.8688%2065.9751%2070.9019%2065.9614C70.935%2065.9478%2070.965%2065.9278%2070.9904%2065.9025C71.0157%2065.8773%2071.0358%2065.8474%2071.0495%2065.8144C71.0632%2065.7815%2071.0702%2065.7462%2071.0702%2065.7105C71.0702%2065.6748%2071.0632%2065.6395%2071.0495%2065.6066C71.0358%2065.5736%2071.0157%2065.5437%2070.9904%2065.5185C70.965%2065.4932%2070.935%2065.4732%2070.9019%2065.4596C70.8688%2065.4459%2070.8333%2065.4389%2070.7975%2065.4389Z'%20fill='white'%20/%3e%3cpath%20d='M98.9691%2046.6488C100.852%2046.6488%20102.378%2045.129%20102.378%2043.2542C102.378%2041.3794%20100.852%2039.8596%2098.9691%2039.8596C97.0865%2039.8596%2095.5603%2041.3794%2095.5603%2043.2542C95.5603%2045.129%2097.0865%2046.6488%2098.9691%2046.6488Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M100.385%2042.9692H99.2257V41.815C99.2257%2041.7794%2099.2186%2041.7441%2099.2049%2041.7111C99.1912%2041.6782%2099.1711%2041.6482%2099.1458%2041.623C99.1205%2041.5978%2099.0904%2041.5778%2099.0573%2041.5641C99.0242%2041.5505%2098.9888%2041.5435%2098.953%2041.5435C98.9172%2041.5435%2098.8817%2041.5505%2098.8486%2041.5641C98.8155%2041.5778%2098.7855%2041.5978%2098.7601%2041.623C98.7348%2041.6482%2098.7147%2041.6782%2098.701%2041.7111C98.6873%2041.7441%2098.6802%2041.7794%2098.6802%2041.815V42.9692H97.5213C97.4854%2042.9692%2097.45%2042.9762%2097.4169%2042.9899C97.3838%2043.0035%2097.3537%2043.0235%2097.3284%2043.0487C97.3031%2043.074%2097.283%2043.1039%2097.2693%2043.1369C97.2556%2043.1698%2097.2485%2043.2051%2097.2485%2043.2408C97.2485%2043.2765%2097.2556%2043.3118%2097.2693%2043.3447C97.283%2043.3777%2097.3031%2043.4076%2097.3284%2043.4328C97.3537%2043.458%2097.3838%2043.4781%2097.4169%2043.4917C97.45%2043.5053%2097.4854%2043.5124%2097.5213%2043.5124H98.6803V44.6665C98.6803%2044.7022%2098.6873%2044.7375%2098.701%2044.7705C98.7147%2044.8034%2098.7348%2044.8334%2098.7601%2044.8586C98.7855%2044.8838%2098.8155%2044.9038%2098.8486%2044.9174C98.8817%2044.9311%2098.9172%2044.9381%2098.953%2044.9381C99.0253%2044.9381%2099.0947%2044.9095%2099.1458%2044.8586C99.197%2044.8076%2099.2257%2044.7386%2099.2257%2044.6665V43.5124H100.385C100.42%2043.5124%20100.456%2043.5053%20100.489%2043.4917C100.522%2043.478%20100.552%2043.458%20100.578%2043.4328C100.603%2043.4076%20100.623%2043.3777%20100.637%2043.3447C100.65%2043.3118%20100.657%2043.2764%20100.657%2043.2408C100.657%2043.2051%20100.65%2043.1698%20100.637%2043.1368C100.623%2043.1039%20100.603%2043.074%20100.578%2043.0487C100.552%2043.0235%20100.522%2043.0035%20100.489%2042.9899C100.456%2042.9762%20100.42%2042.9692%20100.385%2042.9692Z'%20fill='white'%20/%3e%3cpath%20d='M40.2432%2046.3512C42.1258%2046.3512%2043.652%2044.8314%2043.652%2042.9566C43.652%2041.0818%2042.1258%2039.562%2040.2432%2039.562C38.3605%2039.562%2036.8344%2041.0818%2036.8344%2042.9566C36.8344%2044.8314%2038.3605%2046.3512%2040.2432%2046.3512Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M41.6587%2042.6716H40.4997V41.5174C40.4997%2041.4818%2040.4926%2041.4465%2040.4789%2041.4135C40.4652%2041.3806%2040.4451%2041.3506%2040.4198%2041.3254C40.3945%2041.3002%2040.3644%2041.2802%2040.3313%2041.2665C40.2982%2041.2529%2040.2628%2041.2459%2040.227%2041.2458C40.1912%2041.2458%2040.1557%2041.2529%2040.1226%2041.2665C40.0895%2041.2802%2040.0595%2041.3002%2040.0341%2041.3254C40.0088%2041.3506%2039.9887%2041.3806%2039.975%2041.4135C39.9613%2041.4465%2039.9542%2041.4818%2039.9542%2041.5174V42.6716H38.7952C38.7594%2042.6716%2038.724%2042.6786%2038.6909%2042.6923C38.6578%2042.7059%2038.6277%2042.7259%2038.6024%2042.7511C38.5771%2042.7764%2038.557%2042.8063%2038.5433%2042.8392C38.5296%2042.8722%2038.5225%2042.9075%2038.5225%2042.9432C38.5225%2043.0152%2038.5513%2043.0843%2038.6024%2043.1352C38.6535%2043.1862%2038.7229%2043.2148%2038.7952%2043.2148H39.9542V44.3689C39.9542%2044.4046%2039.9613%2044.4399%2039.975%2044.4729C39.9887%2044.5058%2040.0088%2044.5357%2040.0341%2044.561C40.0594%2044.5862%2040.0895%2044.6062%2040.1226%2044.6198C40.1557%2044.6335%2040.1912%2044.6405%2040.227%2044.6405C40.2628%2044.6405%2040.2982%2044.6335%2040.3313%2044.6198C40.3644%2044.6062%2040.3945%2044.5862%2040.4198%2044.561C40.4451%2044.5357%2040.4652%2044.5058%2040.4789%2044.4729C40.4926%2044.4399%2040.4997%2044.4046%2040.4997%2044.3689V43.2148H41.6587C41.6945%2043.2148%2041.73%2043.2077%2041.7631%2043.1941C41.7961%2043.1804%2041.8262%2043.1604%2041.8515%2043.1352C41.8769%2043.11%2041.897%2043.0801%2041.9107%2043.0471C41.9244%2043.0142%2041.9314%2042.9788%2041.9314%2042.9432C41.9314%2042.8711%2041.9027%2042.8021%2041.8515%2042.7511C41.8004%2042.7002%2041.731%2042.6716%2041.6587%2042.6716Z'%20fill='white'%20/%3e%3cpath%20d='M65.7644%2038.2673C65.8266%2038.4547%2065.8468%2038.6533%2065.8235%2038.8492C65.8003%2039.0452%2065.7342%2039.2337%2065.6299%2039.4014C65.5256%2039.5692%2065.3856%2039.7121%2065.2199%2039.8202C65.0541%2039.9282%2064.8665%2039.9988%2064.6704%2040.0269L63.0942%2050.741L60.5086%2049.4834L63.1092%2038.7887C63.0837%2038.4575%2063.1811%2038.1285%2063.3829%2037.864C63.5847%2037.5995%2063.877%2037.4179%2064.2042%2037.3536C64.5315%2037.2894%2064.8711%2037.3469%2065.1586%2037.5153C65.4462%2037.6837%2065.6617%2037.9513%2065.7644%2038.2673Z'%20fill='%239E616A'%20/%3e%3cpath%20d='M46.9382%2072.5819C47.0533%2072.4213%2047.1317%2072.2375%2047.1677%2072.0435C47.2038%2071.8495%2047.1967%2071.65%2047.1469%2071.459C47.0972%2071.268%2047.006%2071.0902%2046.8798%2070.9381C46.7536%2070.786%2046.5954%2070.6634%2046.4164%2070.5787L47.4798%2059.1823L45.2526%2060.3191L44.5571%2071.3011C44.4343%2071.61%2044.4295%2071.9529%2044.5436%2072.2651C44.6577%2072.5772%2044.8829%2072.8368%2045.1764%2072.9947C45.4699%2073.1526%2045.8113%2073.1977%2046.1361%2073.1217C46.4608%2073.0456%2046.7462%2072.8536%2046.9382%2072.5819Z'%20fill='%239E616A'%20/%3e%3cpath%20d='M48.4598%2066.8178L58.0175%2066.4517L58.5689%2056.5679H47.5408L48.4598%2066.8178Z'%20fill='%239E616A'%20/%3e%3cpath%20d='M46.6859%20101.723L48.3192%20101.723L49.0961%2095.45H46.6856L46.6859%20101.723Z'%20fill='%239E616A'%20/%3e%3cpath%20d='M46.2808%20100.921L48.8626%20100.767V101.869L51.3172%20103.557C51.4385%20103.641%2051.5298%20103.76%2051.5778%20103.899C51.6259%20104.038%2051.6281%20104.188%2051.5843%20104.328C51.5404%20104.468%2051.4528%20104.591%2051.3341%20104.678C51.2154%20104.765%2051.0719%20104.811%2050.9246%20104.811H47.8509L47.321%20103.722L47.1142%20104.811H45.9553L46.2808%20100.921Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M53.9503%20101.723L55.5836%20101.723L56.3605%2095.45H53.95L53.9503%20101.723Z'%20fill='%239E616A'%20/%3e%3cpath%20d='M48.3272%2064.4975C48.3272%2064.4975%2045.4675%2066.7966%2047.0177%2075.0074C46.7817%2075.0354%2047.049%2075.4988%2047.049%2075.4988L47.2727%2082.1891L47.4455%2082.9558L46.8708%2084.1931L47.1077%2085.5374L46.3773%2097.7382L49.0756%2098.0857L51.6578%2085.4159L52.1495%2083.9914L52.6428%2082.7428L52.3767%2081.4114L52.5949%2079.3448L54.0835%2072.3763L54.448%2084.4621L53.9394%2085.6159L54.2224%2086.8824L53.592%2087.5548L53.3428%2098.8625L56.22%2098.9965L58.6006%2087.5975L58.416%2086.1429L58.7327%2085.0673V82.555L59.2752%2081.3693L60.4578%2074.9041C60.4578%2074.9041%2060.8145%2069.8509%2058.2116%2063.9045L48.3272%2064.4975Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M49.4926%2048.3535C49.4926%2048.3535%2045.8807%2049.0649%2045.2583%2052.1324C44.6359%2055.1999%2044.2355%2062.1415%2044.2355%2062.1415L44.3718%2063.1082L47.8658%2063.915L50.0958%2054.1886L49.4926%2048.3535Z'%20fill='%233F3D56'%20/%3e%3cpath%20d='M57.7357%2049.389C57.7357%2049.389%2058.1018%2048.878%2060.1522%2048.7992C60.2366%2048.796%2060.1321%2048.6292%2060.1321%2048.6292L61.1181%2043.8298L64.4042%2045.6416L63.8495%2050.6731L58.4497%2056.7892L57.7357%2049.389Z'%20fill='%233F3D56'%20/%3e%3cpath%20d='M55.6874%2063.6967C54.1404%2063.6968%2051.8118%2063.5268%2048.3062%2063.0085C48.0804%2062.9746%2047.8714%2062.8697%2047.7098%2062.7091C47.5481%2062.5485%2047.4422%2062.3406%2047.4076%2062.1158C47.2931%2061.9955%2047.2186%2061.8429%2047.1943%2061.6789C47.1699%2061.5149%2047.1968%2061.3474%2047.2714%2061.1992L47.2747%2061.1928L47.1953%2061.0996C47.0724%2060.9559%2047.0002%2060.776%2046.9898%2060.5876C46.9794%2060.3992%2047.0312%2060.2125%2047.1375%2060.0562L46.0518%2052.3221C45.9416%2051.5541%2046.1103%2050.7721%2046.5274%2050.1168C46.9445%2049.4616%2047.5828%2048.976%2048.3273%2048.7476L48.7281%2048.6233L50.2436%2046.6492L50.2735%2046.6495L55.1391%2046.714L56.718%2048.7107L59.2704%2049.3101L59.2771%2049.3487L59.8697%2052.7585C60.1779%2054.5319%2059.471%2055.2295%2058.5688%2056.7891L58.8336%2061.1691L58.9538%2061.3865C59.0204%2061.5068%2059.0428%2061.6465%2059.0169%2061.7815C58.991%2061.9165%2058.9186%2062.0383%2058.8121%2062.1257C58.8926%2062.3548%2058.8981%2062.6034%2058.8278%2062.8358L58.7654%2063.0413C58.7655%2063.0472%2058.7488%2063.1307%2058.6141%2063.2326C58.3711%2063.4164%2057.6734%2063.6967%2055.6874%2063.6967Z'%20fill='%233F3D56'%20/%3e%3cpath%20d='M53.5452%20100.921L56.127%20100.767V101.869L58.5816%20103.557C58.7029%20103.641%2058.7942%20103.76%2058.8422%20103.899C58.8903%20104.038%2058.8925%20104.188%2058.8487%20104.328C58.8048%20104.468%2058.7172%20104.591%2058.5985%20104.678C58.4798%20104.765%2058.3363%20104.811%2058.189%20104.811H55.1153L54.5855%20103.722L54.3786%20104.811H53.2197L53.5452%20100.921Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M56.2568%2042.3472C56.5943%2040.2764%2055.1821%2038.3253%2053.1027%2037.9893C51.0232%2037.6533%2049.0639%2039.0595%2048.7265%2041.1303C48.389%2043.2011%2049.8012%2045.1522%2051.8807%2045.4882C53.9601%2045.8242%2055.9194%2044.418%2056.2568%2042.3472Z'%20fill='%239E616A'%20/%3e%3cpath%20d='M54.7221%2038.0272C53.324%2037.0697%2052.0929%2036.9238%2051.0816%2037.1954C50.9505%2036.9935%2050.7667%2036.8309%2050.5498%2036.7251C49.7611%2034.746%2047.3607%2033.5574%2045.3008%2034.1352C43.2275%2034.7167%2041.797%2037.0037%2042.1871%2039.1132C42.4289%2040.4207%2043.2552%2041.553%2043.5876%2042.8407C44.231%2045.3334%2042.6615%2048.1888%2040.2061%2048.9923C42.5309%2049.4571%2045.0899%2048.043%2045.9239%2045.8326C46.329%2044.759%2046.3534%2043.5868%2046.4049%2042.441C46.4185%2041.6502%2046.5158%2040.863%2046.6952%2040.0924C46.7842%2039.7468%2046.9101%2039.4115%2047.0705%2039.0924C47.42%2038.391%2048.0005%2037.8302%2048.7151%2037.5035C48.6511%2037.7006%2048.6351%2037.91%2048.6684%2038.1145C48.7017%2038.3189%2048.7834%2038.5126%2048.9067%2038.6794C48.3615%2039.3595%2048.0647%2040.0951%2048.0647%2040.5355C46.9321%2042.5969%2048.5517%2044.3675%2050.6218%2045.4953C51.4474%2045.9475%2052.4008%2046.113%2053.3314%2045.9657L53.418%2045.5976L53.5353%2045.9292L53.927%2047.041C54.3788%2047.2586%2054.8268%2047.4973%2055.2708%2047.7568C55.1021%2046.9679%2054.9656%2046.1805%2054.8717%2045.4106C54.7417%2044.3627%2055.1949%2042.8027%2055.5219%2041.854C55.7246%2041.2693%2055.8286%2040.6552%2055.8298%2040.0366V40.0096L56.1481%2041.0278L57.307%2040.5355C57.0914%2039.304%2057.307%2037.9059%2054.7221%2038.0272Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M102.385%20105H17.6147C17.5676%20105%2017.5226%20104.981%2017.4894%20104.948C17.4562%20104.915%2017.4376%20104.87%2017.4376%20104.823C17.4376%20104.776%2017.4562%20104.731%2017.4894%20104.698C17.5226%20104.665%2017.5676%20104.646%2017.6147%20104.646H102.385C102.432%20104.646%20102.477%20104.665%20102.511%20104.698C102.544%20104.731%20102.562%20104.776%20102.562%20104.823C102.562%20104.87%20102.544%20104.915%20102.511%20104.948C102.477%20104.981%20102.432%20105%20102.385%20105Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M39.8535%2069.5646C41.7362%2069.5646%2043.2624%2068.0448%2043.2624%2066.17C43.2624%2064.2952%2041.7362%2062.7754%2039.8535%2062.7754C37.9709%2062.7754%2036.4447%2064.2952%2036.4447%2066.17C36.4447%2068.0448%2037.9709%2069.5646%2039.8535%2069.5646Z'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M98.1312%2069.1185C100.014%2069.1185%20101.54%2067.5987%20101.54%2065.7239C101.54%2063.8492%20100.014%2062.3293%2098.1312%2062.3293C96.2485%2062.3293%2094.7224%2063.8492%2094.7224%2065.7239C94.7224%2067.5987%2096.2485%2069.1185%2098.1312%2069.1185Z'%20fill='%23E6E6E6'%20/%3e%3c/g%3e%3cg%20style='mix-blend-mode:%20color'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4886_419'%3e%3crect%20width='120'%20height='88'%20fill='white'%20transform='translate(0%2017)'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Lu = "data:image/svg+xml,%3csvg%20width='120'%20height='120'%20viewBox='0%200%20120%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3crect%20x='36.4597'%20y='20'%20width='66.2857'%20height='80'%20rx='1.85453'%20fill='url(%23paint0_linear_3271_25820)'%20/%3e%3crect%20x='52.2826'%20y='29.3268'%20width='46.4762'%20height='4.95238'%20rx='2.47619'%20fill='%23D2D9D7'%20/%3e%3crect%20x='52.2826'%20y='47.8721'%20width='46.4762'%20height='4.95238'%20rx='2.47619'%20fill='%23D2D9D7'%20/%3e%3crect%20x='52.2826'%20y='66.4171'%20width='46.4762'%20height='4.95238'%20rx='2.47619'%20fill='%23D2D9D7'%20/%3e%3crect%20x='52.2826'%20y='84.962'%20width='46.4762'%20height='4.95238'%20rx='2.47619'%20fill='%23D2D9D7'%20/%3e%3crect%20x='41.1561'%20y='27.4729'%20width='8.7619'%20height='8.7619'%20rx='2.47267'%20fill='%23D2D9D7'%20/%3e%3crect%20x='41.1561'%20y='46.0172'%20width='8.7619'%20height='8.7619'%20rx='2.47267'%20fill='%23D2D9D7'%20/%3e%3crect%20x='41.1561'%20y='64.5625'%20width='8.7619'%20height='8.7619'%20rx='2.47267'%20fill='%23D2D9D7'%20/%3e%3crect%20x='41.1561'%20y='83.1073'%20width='8.7619'%20height='8.7619'%20rx='2.47267'%20fill='%23D2D9D7'%20/%3e%3cmask%20id='mask0_3271_25820'%20style='mask-type:%20alpha'%20maskUnits='userSpaceOnUse'%20x='18'%20y='31'%20width='58'%20height='58'%3e%3ccircle%20cx='46.9329'%20cy='60.1615'%20r='28.5714'%20fill='%23E6EFFF'%20/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_3271_25820)'%3e%3crect%20x='52.1116'%20y='-31.4642'%20width='89.1913'%20height='164.3'%20rx='9.38856'%20fill='%235A756B'%20/%3e%3crect%20x='47.4172'%20y='-31.4642'%20width='89.1913'%20height='164.3'%20rx='9.38856'%20fill='%23D2D9D7'%20/%3e%3crect%20x='38.0273'%20y='-15.0333'%20width='89.1913'%20height='138.481'%20rx='9.38856'%20fill='%23D2D9D7'%20/%3e%3crect%20x='35.6801'%20y='-12.6862'%20width='84.497'%20height='133.787'%20rx='7.04142'%20fill='%23E1E6E4'%20stroke='%235A756B'%20stroke-width='4.69428'%20/%3e%3crect%20x='55.5652'%20y='45.9652'%20width='57.4978'%20height='6.1331'%20rx='3.06655'%20fill='%23D2D9D7'%20/%3e%3crect%20x='55.5652'%20y='68.9666'%20width='57.4978'%20height='6.1331'%20rx='3.06655'%20fill='%23D2D9D7'%20/%3e%3crect%20x='41.765'%20y='43.6671'%20width='10.6667'%20height='10.6667'%20rx='3.06655'%20fill='%23D2D9D7'%20/%3e%3crect%20x='41.765'%20y='66.6666'%20width='10.6667'%20height='10.6667'%20rx='3.06655'%20fill='%23D2D9D7'%20/%3e%3c/g%3e%3ccircle%20opacity='0.1'%20cx='46.636'%20cy='60.134'%20r='28.5596'%20fill='%23F0F2F2'%20stroke='url(%23paint1_linear_3271_25820)'%20stroke-width='0.785549'%20/%3e%3cmask%20id='mask1_3271_25820'%20style='mask-type:%20alpha'%20maskUnits='userSpaceOnUse'%20x='17'%20y='31'%20width='58'%20height='58'%3e%3ccircle%20cx='46.2551'%20cy='60.1615'%20r='28.5714'%20fill='%23C4C4C4'%20/%3e%3c/mask%3e%3cg%20mask='url(%23mask1_3271_25820)'%3e%3cpath%20opacity='0.5'%20d='M10.1985%2069.5933L64.6747%2021.3855V39.4634L10.1985%2087.6712V69.5933Z'%20fill='url(%23paint2_linear_3271_25820)'%20/%3e%3cpath%20opacity='0.5'%20d='M18.4409%2086.5343L72.917%2038.382V50.4201L18.4409%2098.5724V86.5343Z'%20fill='url(%23paint3_linear_3271_25820)'%20/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_3271_25820'%20x1='69.6025'%20y1='20'%20x2='69.6025'%20y2='100'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23F0F2F2'%20/%3e%3cstop%20offset='1'%20stop-color='%23E1E6E4'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_3271_25820'%20x1='22.2136'%20y1='47.5289'%20x2='72.0499'%20y2='74.1808'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%234B685E'%20/%3e%3cstop%20offset='0.322917'%20stop-color='%234B685E'%20stop-opacity='0.17'%20/%3e%3cstop%20offset='0.791667'%20stop-color='%23BBBBBB'%20stop-opacity='0.173333'%20/%3e%3cstop%20offset='1'%20stop-color='%234B685E'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_3271_25820'%20x1='37.4366'%20y1='21.3855'%20x2='37.4366'%20y2='87.6712'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='white'%20/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_3271_25820'%20x1='45.679'%20y1='38.382'%20x2='45.679'%20y2='104.591'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='white'%20/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'%20/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", ku = "data:image/svg+xml;base64,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", Eu = "data:image/svg+xml,%3csvg%20width='134'%20height='120'%20viewBox='0%200%20134%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_4845_623)'%3e%3cpath%20d='M63.1349%2044.1872H53.0449V41.126C56.2333%2038.9084%2059.0583%2039.1012%2062.7745%2041.3061L63.1349%2044.1872Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M50.7084%2098.5613L48.4994%2098.5611L48.1691%2090.0459L50.7088%2090.0461L50.7084%2098.5613Z'%20fill='%23FFB8B8'%20/%3e%3cpath%20d='M51.2717%20100.701L44.1491%20100.701V100.611C44.1491%20100.247%2044.2208%2099.8867%2044.3601%2099.5506C44.4994%2099.2144%2044.7036%2098.909%2044.9611%2098.6517C45.2185%2098.3944%2045.5241%2098.1903%2045.8605%2098.0511C46.1968%2097.9119%2046.5573%2097.8402%2046.9214%2097.8402L51.2718%2097.8404L51.2717%20100.701Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M63.1503%2098.5613L65.3593%2098.5611L65.6896%2090.0459L63.15%2090.0461L63.1503%2098.5613Z'%20fill='%23FFB8B8'%20/%3e%3cpath%20d='M62.5869%2097.8404L66.9372%2097.8402C67.3012%2097.8402%2067.6619%2097.9119%2067.9983%2098.0511C68.3346%2098.1903%2068.6402%2098.3944%2068.8977%2098.6517C69.1551%2098.909%2069.3593%2099.2144%2069.4986%2099.5505C69.638%2099.8867%2069.7097%20100.247%2069.7097%20100.611V100.701L62.5871%20100.701L62.5869%2097.8404Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M63.2084%2097.4699C63.0241%2097.4693%2062.8454%2097.4062%2062.7016%2097.291C62.5578%2097.1758%2062.4574%2097.0152%2062.4167%2096.8356L56.9417%2072.969C56.9297%2072.9084%2056.8966%2072.8539%2056.8484%2072.8152C56.8001%2072.7766%2056.7397%2072.7562%2056.6779%2072.7576H56.6765C56.6144%2072.7565%2056.5539%2072.7774%2056.5058%2072.8165C56.4576%2072.8557%2056.4249%2072.9107%2056.4134%2072.9717L51.3856%2096.6773C51.3464%2096.8587%2051.2464%2097.0212%2051.1021%2097.138C50.9579%2097.2548%2050.778%2097.3188%2050.5924%2097.3195H48.1973C48.0868%2097.3195%2047.9775%2097.2969%2047.876%2097.2532C47.7746%2097.2094%2047.6831%2097.1454%2047.6073%2097.065C47.5315%2096.9847%2047.473%2096.8897%2047.4352%2096.7858C47.3975%2096.682%2047.3814%2096.5716%2047.3879%2096.4614L49.1719%2066.4154L49.8897%2066.2031L49.9032%2066.2033L64.0037%2066.3266L67.0068%2096.3395C67.0173%2096.4466%2067.0063%2096.5546%2066.9746%2096.6574C66.9428%2096.7602%2066.8909%2096.8556%2066.8219%2096.9381C66.7528%2097.0206%2066.668%2097.0885%2066.5724%2097.1379C66.4768%2097.1873%2066.3724%2097.2172%2066.2651%2097.2258L63.2734%2097.4672C63.2516%2097.469%2063.23%2097.4699%2063.2084%2097.4699Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M57.3855%2038.7009C59.8296%2038.7009%2061.8109%2036.7207%2061.8109%2034.2781C61.8109%2031.8355%2059.8296%2029.8553%2057.3855%2029.8553C54.9414%2029.8553%2052.9601%2031.8355%2052.9601%2034.2781C52.9601%2036.7207%2054.9414%2038.7009%2057.3855%2038.7009Z'%20fill='%23FFB8B8'%20/%3e%3cpath%20d='M54.6745%2069.7096C53.8981%2069.7192%2053.1248%2069.6104%2052.3812%2069.3871C51.7199%2069.1877%2051.1064%2068.8553%2050.5784%2068.4101C50.0505%2067.9649%2049.6193%2067.4165%2049.3113%2066.7985C49.2138%2066.6126%2049.1921%2066.3961%2049.251%2066.1945C49.739%2064.5297%2052.0976%2055.8762%2050.5927%2048.9971C50.3803%2048.0414%2050.3627%2047.0528%2050.5408%2046.0902C50.719%2045.1276%2051.0893%2044.2107%2051.6297%2043.3943C52.1575%2042.5842%2052.8431%2041.8887%2053.6457%2041.3492C54.4483%2040.8096%2055.3515%2040.4372%2056.3012%2040.2541L56.3012%2040.2539C56.5508%2040.2052%2056.8018%2040.1653%2057.047%2040.135C58.0969%2040.0059%2059.1623%2040.1102%2060.1671%2040.4406C61.1719%2040.771%2062.0912%2041.3193%2062.8592%2042.0462C63.6501%2042.7874%2064.2672%2043.6941%2064.6664%2044.7015C65.0656%2045.7089%2065.237%2046.792%2065.1683%2047.8734L64.0118%2066.4215C64.0038%2066.5606%2063.9598%2066.6951%2063.884%2066.8121C63.8083%2066.929%2063.7034%2067.0242%2063.5797%2067.0883C62.2477%2067.7859%2058.2465%2069.7096%2054.6745%2069.7096Z'%20fill='%233F3D56'%20/%3e%3cpath%20d='M62.3848%2031.0226C61.9251%2029.868%2061.0831%2028.9059%2059.9993%2028.2968C58.9154%2027.6878%2057.6554%2027.4687%2056.4294%2027.6762L57.8247%2028.803C56.0911%2028.8614%2054.2663%2028.7373%2053.0285%2029.9518C53.4225%2029.9408%2053.939%2030.7832%2054.3331%2030.7723C53.5963%2030.7868%2052.9283%2031.3042%2052.6029%2031.9649C52.3015%2032.6438%2052.231%2033.4026%2052.4021%2034.1253C52.5477%2034.8472%2053.6577%2036.5385%2053.9564%2037.2117C53.9051%2035.4524%2057.3707%2031.256%2059.063%2031.6939C58.2032%2032.0127%2057.4571%2032.5789%2056.9188%2033.3209C58.0701%2032.7402%2059.3722%2032.5273%2060.6487%2032.711C60.9401%2032.7778%2061.2408%2032.7946%2061.5379%2032.7607C61.72%2032.7247%2061.8898%2032.6427%2062.0311%2032.5224C62.1724%2032.4022%2062.2805%2032.2477%2062.345%2032.0738C62.4096%2031.8999%2062.4285%2031.7123%2062.3998%2031.529C62.3712%2031.3458%2062.296%2031.1729%2062.1815%2031.0269L62.3848%2031.0226Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M54.3696%2068.5959C54.2578%2068.5956%2054.1473%2068.5723%2054.045%2068.5274L45.6485%2064.8647C45.4701%2064.7882%2045.3254%2064.65%2045.2409%2064.4754C45.1563%2064.3009%2045.1377%2064.1016%2045.1885%2063.9144L50.747%2042.929C50.8503%2042.5385%2051.0305%2042.1726%2051.2771%2041.8526C51.5237%2041.5326%2051.8317%2041.2649%2052.1831%2041.0653C52.5344%2040.8657%2052.9221%2040.7382%2053.3233%2040.6901C53.7246%2040.6421%2054.1315%2040.6745%2054.52%2040.7856L56.7426%2041.4195L55.178%2067.8326C55.1699%2067.9629%2055.1306%2068.0894%2055.0633%2068.2013C54.996%2068.3132%2054.9027%2068.4072%2054.7913%2068.4754C54.6646%2068.5538%2054.5186%2068.5955%2054.3696%2068.5959Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M69.9097%2063.9142L69.5402%2062.5223L69.0052%2060.4982L68.7475%2059.5277L68.2124%2057.509L64.3511%2042.9286C64.2481%2042.538%2064.0681%2042.1718%2063.8216%2041.8516C63.5751%2041.5315%2063.2671%2041.2637%2062.9156%2041.0641C62.5642%2040.8645%2062.1764%2040.7371%2061.775%2040.6893C61.3736%2040.6415%2060.9667%2040.6743%2060.5782%2040.7858L58.3566%2041.4196L59.4574%2059.9976L59.571%2061.937L59.6431%2063.1597V63.1615L59.7583%2065.0901L59.9205%2067.8326C59.9338%2068.0385%2060.0246%2068.2317%2060.1747%2068.3734C60.3248%2068.5151%2060.523%2068.5946%2060.7295%2068.5961C60.8411%2068.5954%2060.9515%2068.5721%2061.0539%2068.5277L69.4502%2064.865C69.6286%2064.7886%2069.7735%2064.6502%2069.8579%2064.4755C69.9424%2064.3008%2069.9607%2064.1014%2069.9097%2063.9142Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M68.7474%2059.5276L59.5711%2061.937L59.4574%2059.9976L68.2125%2057.509L68.7474%2059.5276Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M69.5402%2062.5222L59.7583%2065.09L59.6431%2063.1614V63.1596L69.0052%2060.4982L69.5402%2062.5222Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M55.5278%2060.4154L55.4141%2062.3188L46.4144%2059.6393L46.9421%2057.6477L55.5278%2060.4154Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M55.3403%2063.572L46.1565%2060.6099L45.6286%2062.6069L55.2286%2065.4646L55.3403%2063.572Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M46.3167%2065.5626C46.5905%2065.4912%2046.8453%2065.3606%2047.0632%2065.1801C47.281%2064.9997%2047.4566%2064.7736%2047.5776%2064.518C47.6986%2064.2623%2047.7621%2063.9833%2047.7635%2063.7005C47.7649%2063.4177%2047.7043%2063.138%2047.5858%2062.8812L51.9033%2049.3351L48.8418%2048.6943L44.8834%2061.9752C44.4649%2062.2027%2044.1444%2062.5757%2043.9826%2063.0235C43.8208%2063.4714%2043.8291%2063.963%2044.0057%2064.4051C44.1824%2064.8473%2044.5152%2065.2094%2044.9412%2065.4227C45.3671%2065.636%2045.8565%2065.6858%2046.3167%2065.5626Z'%20fill='%23FFB8B8'%20/%3e%3cpath%20d='M52.0231%2042.6757C52.9022%2042.7654%2053.3967%2043.7532%2053.1781%2044.9832L52.1293%2050.8857C52.0506%2051.3281%2051.6863%2051.6785%2051.3834%2051.6028L47.8356%2050.7165C47.5626%2050.6483%2047.4621%2050.2607%2047.6168%2049.8728L49.7466%2044.5331C50.2092%2043.3734%2051.1708%2042.5889%2052.0231%2042.6757Z'%20fill='%233F3D56'%20/%3e%3cpath%20d='M57.3692%2026C58.8669%2026.0002%2060.3058%2026.5829%2061.3811%2027.6248C62.4565%2028.6668%2063.0838%2030.0861%2063.1303%2031.5822H64.216C64.3115%2031.5822%2064.4032%2031.6202%2064.4708%2031.6877C64.5384%2031.7553%2064.5763%2031.8469%2064.5763%2031.9424V33.383C64.5763%2033.4785%2064.5384%2033.5701%2064.4708%2033.6376C64.4032%2033.7051%2064.3115%2033.7431%2064.216%2033.7431H51.9638C51.8682%2033.7431%2051.7766%2033.7051%2051.709%2033.6376C51.6414%2033.5701%2051.6034%2033.4785%2051.6034%2033.383V31.7623C51.6034%2031.0056%2051.7526%2030.2563%2052.0423%2029.5572C52.3321%2028.858%2052.7568%2028.2228%2053.2922%2027.6877C53.8276%2027.1526%2054.4632%2026.7282%2055.1627%2026.4386C55.8622%2026.149%2056.612%2026%2057.3692%2026Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M56.8393%2058.8184C56.9383%2058.8298%2057.0363%2058.8491%2057.1323%2058.8759L63.9154%2053.0624L63.5189%2050.9294L66.6617%2049.9106L67.7308%2053.6186C67.8172%2053.9181%2067.804%2054.2376%2067.6932%2054.529C67.5825%2054.8204%2067.3801%2055.0681%2067.1165%2055.2348L58.526%2060.6676C58.5321%2061.0514%2058.4211%2061.428%2058.2079%2061.7472C57.9946%2062.0664%2057.6891%2062.3132%2057.3321%2062.4547C56.975%2062.5962%2056.5834%2062.6257%2056.2092%2062.5393C55.8349%2062.4529%2055.4959%2062.2547%2055.2371%2061.971C54.9784%2061.6873%2054.8122%2061.3317%2054.7606%2060.9513C54.7091%2060.5709%2054.7746%2060.1839%2054.9486%2059.8416C55.1225%2059.4994%2055.3966%2059.2182%2055.7343%2059.0354C56.072%2058.8526%2056.4575%2058.7769%2056.8393%2058.8184Z'%20fill='%23FFB8B8'%20/%3e%3cpath%20d='M63.9331%2043.1632C64.8721%2042.9005%2065.8104%2043.6148%2066.1248%2044.8317L67.6335%2050.6715C67.7466%2051.1092%2067.5269%2051.5745%2067.1838%2051.6238L63.1646%2052.2016C62.8554%2052.246%2062.5829%2051.929%2062.5715%2051.5116L62.4155%2045.7649C62.3816%2044.5169%2063.0227%2043.4179%2063.9331%2043.1632Z'%20fill='%233F3D56'%20/%3e%3cpath%20d='M117.957%2080.4664C116.106%2078.0064%20114.643%2075.2778%20113.619%2072.3755C113.559%2072.2019%20113.564%2072.0128%20113.631%2071.8421C113.698%2071.6713%20113.823%2071.5298%20113.985%2071.4428L120.317%2068.0518C120.42%2067.9965%20120.534%2067.9653%20120.65%2067.9606C120.766%2067.9559%20120.882%2067.9777%20120.989%2068.0245C121.097%2068.0717%20121.194%2068.143%20121.27%2068.233C121.347%2068.323%20121.403%2068.4293%20121.432%2068.5439C122.169%2071.3407%20123.555%2073.9248%20125.476%2076.0872C125.555%2076.1752%20125.613%2076.2801%20125.646%2076.3939C125.678%2076.5077%20125.684%2076.6274%20125.663%2076.7438C125.643%2076.8585%20125.597%2076.967%20125.529%2077.0612C125.461%2077.1554%20125.372%2077.2327%20125.269%2077.2873L118.936%2080.6784C118.775%2080.7647%20118.587%2080.7908%20118.408%2080.752C118.228%2080.7131%20118.068%2080.612%20117.957%2080.4664Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M118.389%2080.1419C118.423%2080.1844%20118.471%2080.2136%20118.524%2080.2247C118.577%2080.2357%20118.633%2080.2277%20118.681%2080.2022L125.014%2076.8111C125.044%2076.7951%20125.071%2076.7722%20125.091%2076.7441C125.112%2076.7161%20125.125%2076.6837%20125.131%2076.6496C125.138%2076.6135%20125.136%2076.5764%20125.126%2076.5411C125.116%2076.5059%20125.097%2076.4735%20125.073%2076.4465C123.094%2074.2203%20121.668%2071.5601%20120.909%2068.6809C120.9%2068.6453%20120.884%2068.6122%20120.86%2068.5843C120.836%2068.5563%20120.806%2068.5342%20120.773%2068.5197C120.741%2068.5055%20120.706%2068.4989%20120.672%2068.5003C120.637%2068.5017%20120.603%2068.5112%20120.573%2068.528L114.24%2071.919C114.192%2071.9449%20114.155%2071.9867%20114.134%2072.0373C114.114%2072.0878%20114.112%2072.1439%20114.129%2072.1958C115.135%2075.0462%20116.571%2077.7259%20118.389%2080.1419Z'%20fill='white'%20/%3e%3cpath%20d='M120.733%2072.8911L117.284%2074.4126C117.153%2074.4703%20117.004%2074.4736%20116.871%2074.4219C116.737%2074.3701%20116.629%2074.2675%20116.571%2074.1365L116.486%2073.9434C116.428%2073.8123%20116.425%2073.6637%20116.477%2073.5301C116.529%2073.3966%20116.631%2073.289%20116.762%2073.2311L120.211%2071.7095C120.342%2071.6518%20120.491%2071.6485%20120.625%2071.7002C120.758%2071.752%20120.866%2071.8546%20120.924%2071.9856L121.009%2072.1787C121.067%2072.3098%20121.07%2072.4584%20121.019%2072.592C120.967%2072.7255%20120.864%2072.8331%20120.733%2072.8911Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M121.994%2075.232L118.545%2076.7535C118.414%2076.8112%20118.266%2076.8146%20118.132%2076.7628C117.998%2076.7111%20117.891%2076.6085%20117.833%2076.4775L117.747%2076.2844C117.69%2076.1533%20117.686%2076.0046%20117.738%2075.8711C117.79%2075.7375%20117.893%2075.63%20118.024%2075.572L121.472%2074.0505C121.604%2073.9928%20121.752%2073.9894%20121.886%2074.0412C122.02%2074.0929%20122.127%2074.1955%20122.185%2074.3265L122.271%2074.5196C122.328%2074.6507%20122.332%2074.7994%20122.28%2074.9329C122.228%2075.0665%20122.125%2075.174%20121.994%2075.232Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M113.906%2073.2814C113.668%2073.1284%20113.466%2072.9251%20113.315%2072.6859C113.164%2072.4466%20113.068%2072.1772%20113.032%2071.8967C112.997%2071.6161%20113.023%2071.3311%20113.11%2071.0619C113.197%2070.7927%20113.341%2070.5458%20113.534%2070.3385L112.079%2049.7098L116.269%2050.1159L116.384%2070.3176C116.711%2070.6639%20116.9%2071.118%20116.914%2071.5939C116.928%2072.0698%20116.768%2072.5345%20116.462%2072.8998C116.157%2073.2652%20115.728%2073.5058%20115.256%2073.5761C114.785%2073.6465%20114.305%2073.5416%20113.906%2073.2814Z'%20fill='%23A0616A'%20/%3e%3cpath%20d='M113.028%2056.6413C112.93%2056.5708%20112.849%2056.4792%20112.791%2056.3732C112.733%2056.2672%20112.699%2056.1496%20112.693%2056.029L112.386%2050.4691C112.356%2049.9182%20112.53%2049.3756%20112.877%2048.9459C113.223%2048.5162%20113.716%2048.2299%20114.261%2048.142C114.806%2048.0542%20115.364%2048.1711%20115.828%2048.4702C116.292%2048.7693%20116.628%2049.2295%20116.773%2049.7619L118.121%2054.7328C118.177%2054.9402%20118.149%2055.1614%20118.042%2055.3478C117.935%2055.5341%20117.758%2055.6705%20117.551%2055.7269L113.715%2056.7664C113.598%2056.7982%20113.476%2056.8035%20113.357%2056.7819C113.238%2056.7602%20113.126%2056.7122%20113.028%2056.6413Z'%20fill='%233F3D56'%20/%3e%3cpath%20d='M105.887%2098.6424H103.678L102.627%2090.1272H105.887L105.887%2098.6424Z'%20fill='%23A0616A'%20/%3e%3cpath%20d='M102.1%2098.0116H106.36V100.692H99.4179C99.4179%20100.34%2099.4873%2099.9917%2099.6221%2099.6664C99.7569%2099.3412%2099.9545%2099.0457%20100.204%2098.7968C100.453%2098.5478%20100.748%2098.3504%20101.074%2098.2157C101.399%2098.0809%20101.748%2098.0116%20102.1%2098.0116Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M114.175%2098.6424H111.966L110.915%2090.1272H114.176L114.175%2098.6424Z'%20fill='%23A0616A'%20/%3e%3cpath%20d='M110.388%2098.0116H114.649V100.692H107.706C107.706%20100.34%20107.776%2099.9917%20107.91%2099.6664C108.045%2099.3412%20108.243%2099.0457%20108.492%2098.7968C108.741%2098.5478%20109.037%2098.3504%20109.362%2098.2157C109.687%2098.0809%20110.036%2098.0116%20110.388%2098.0116Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M105.783%2094.3527L103.351%2094.2368C103.144%2094.227%20102.948%2094.1382%20102.805%2093.9888C102.661%2093.8393%20102.58%2093.6404%20102.579%2093.4332C101.938%2083.5438%20101.05%2072.9397%20102.409%2068.8432C102.408%2068.7264%20102.433%2068.6109%20102.481%2068.5045C102.529%2068.3981%20102.599%2068.3033%20102.687%2068.2266C102.775%2068.1499%20102.879%2068.0931%20102.991%2068.0601C103.103%2068.0271%20103.221%2068.0187%20103.336%2068.0355L113.065%2069.4469C113.257%2069.4738%20113.433%2069.5691%20113.561%2069.7153C113.688%2069.8615%20113.759%2070.0488%20113.759%2070.2428C115.001%2075.0933%20115.057%2083.889%20115.01%2093.028C115.011%2093.135%20114.991%2093.241%20114.95%2093.34C114.91%2093.439%20114.85%2093.5291%20114.775%2093.605C114.7%2093.6809%20114.61%2093.7411%20114.511%2093.7822C114.412%2093.8233%20114.307%2093.8445%20114.2%2093.8445H111.578C111.385%2093.8453%20111.197%2093.7766%20111.05%2093.651C110.903%2093.5254%20110.806%2093.3512%20110.777%2093.1601L109.16%2082.8839C109.136%2082.7335%20109.059%2082.5968%20108.942%2082.4989C108.825%2082.4011%20108.677%2082.3487%20108.525%2082.3515C108.373%2082.3543%20108.227%2082.4121%20108.114%2082.5142C108.001%2082.6163%20107.928%2082.7558%20107.91%2082.9069L106.626%2093.6396C106.602%2093.8362%20106.507%2094.0173%20106.359%2094.1488C106.211%2094.2802%20106.019%2094.3531%20105.821%2094.3538C105.808%2094.3538%20105.796%2094.3534%20105.783%2094.3527Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M107.495%2070.2438C105.351%2069.0533%20103.675%2068.7404%20102.868%2068.6599C102.76%2068.6496%20102.656%2068.6175%20102.562%2068.5657C102.467%2068.514%20102.384%2068.4435%20102.317%2068.3587C102.249%2068.2732%20102.2%2068.1749%20102.171%2068.0696C102.142%2067.9643%20102.135%2067.8543%20102.15%2067.7462L104.481%2050.4501C104.615%2049.4383%20105.006%2048.4775%20105.617%2047.6594C106.227%2046.8412%20107.037%2046.1929%20107.97%2045.776C108.872%2045.3614%20109.866%2045.1845%20110.856%2045.2621C111.846%2045.3396%20112.8%2045.6691%20113.626%2046.2191C113.706%2046.2722%20113.785%2046.3265%20113.862%2046.3818C114.814%2047.079%20115.538%2048.0422%20115.943%2049.1501C116.348%2050.258%20116.416%2051.461%20116.138%2052.6075C114.709%2058.4517%20114.218%2068.0328%20114.134%2069.8942C114.127%2070.0529%20114.074%2070.206%20113.98%2070.3344C113.887%2070.4627%20113.757%2070.5605%20113.608%2070.6154C112.729%2070.9348%20111.801%2071.1%20110.865%2071.1035C109.686%2071.1107%20108.526%2070.8146%20107.495%2070.2438Z'%20fill='%233F3D56'%20/%3e%3cpath%20d='M109.444%2043.4275C111.888%2043.4275%20113.87%2041.4474%20113.87%2039.0048C113.87%2036.5622%20111.888%2034.582%20109.444%2034.582C107%2034.582%20105.019%2036.5622%20105.019%2039.0048C105.019%2041.4474%20107%2043.4275%20109.444%2043.4275Z'%20fill='%23A0616A'%20/%3e%3cpath%20d='M112.576%2042.5038C111.75%2043.3827%20110.217%2042.9109%20110.11%2041.7102C110.101%2041.617%20110.102%2041.5232%20110.112%2041.4301C110.167%2040.8982%20110.474%2040.4154%20110.401%2039.8538C110.384%2039.714%20110.332%2039.5808%20110.249%2039.4668C109.592%2038.5864%20108.047%2039.8606%20107.426%2039.0636C107.046%2038.5749%20107.493%2037.8054%20107.201%2037.2592C106.815%2036.5383%20105.673%2036.8939%20104.957%2036.4991C104.16%2036.0598%20104.208%2034.8379%20104.732%2034.0946C105.372%2033.1882%20106.494%2032.7046%20107.602%2032.6349C108.709%2032.5652%20109.809%2032.8644%20110.843%2033.2672C112.018%2033.7248%20113.183%2034.3573%20113.907%2035.3898C114.786%2036.6455%20114.87%2038.3336%20114.431%2039.8019C114.163%2040.695%20113.25%2041.7861%20112.576%2042.5038Z'%20fill='%232F2E41'%20/%3e%3cpath%20d='M116.081%2046.8037C116.003%2046.4399%20115.338%2045.9429%20114.387%2045.5378C112.858%2044.9188%20111.204%2044.6695%20109.56%2044.8103C107.916%2044.9512%20106.329%2045.478%20104.928%2046.3481C104.83%2046.3533%20104.736%2046.3905%20104.662%2046.454C104.587%2046.5174%20104.536%2046.6036%20104.515%2046.6992L101.315%2060.8439L100.899%2062.686L100.623%2063.9051L100.207%2065.7418L99.9852%2066.7232C99.971%2066.786%2099.9704%2066.851%2099.9834%2066.914C99.9964%2066.977%20100.023%2067.0365%20100.061%2067.0885C100.099%2067.1405%20100.147%2067.1838%20100.203%2067.2155C100.259%2067.2472%20100.321%2067.2667%20100.385%2067.2725L114.203%2068.4645C114.216%2068.4645%20114.23%2068.4663%20114.243%2068.4663C114.357%2068.4656%20114.466%2068.4218%20114.549%2068.3436C114.632%2068.2654%20114.682%2068.1587%20114.69%2068.045L114.821%2066.0444L114.962%2063.9051L115.023%2062.9777L115.162%2060.8439L116.082%2046.8271V46.8145L116.081%2046.8037Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M93.4078%2047.6941C93.4299%2047.7912%2093.4443%2047.89%2093.4509%2047.9894L101.191%2052.4519L103.072%2051.3695L105.078%2053.9936L101.053%2056.8604L92.223%2049.8984C91.8628%2050.0316%2091.4707%2050.052%2091.0986%2049.957C90.7265%2049.862%2090.3922%2049.6561%2090.1401%2049.3666C89.888%2049.0771%2089.7301%2048.7177%2089.6873%2048.3363C89.6446%2047.9549%2089.719%2047.5696%2089.9007%2047.2315C90.0824%2046.8934%2090.3628%2046.6186%2090.7046%2046.4436C91.0464%2046.2687%2091.4334%2046.2019%2091.8141%2046.2521C92.1948%2046.3023%2092.5512%2046.4672%2092.8359%2046.7248C93.1206%2046.9823%2093.3201%2047.3204%2093.4078%2047.6941Z'%20fill='%23A0616A'%20/%3e%3cpath%20d='M101.467%2052.0725C101.454%2051.9525%20101.469%2051.831%20101.509%2051.7171C101.549%2051.6033%20101.615%2051.4999%20101.7%2051.4147L105.64%2047.4768C106.03%2047.0867%20106.551%2046.8548%20107.102%2046.8258C107.654%2046.7969%20108.196%2046.9729%20108.625%2047.32C109.054%2047.6672%20109.339%2048.1607%20109.426%2048.7056C109.512%2049.2505%20109.394%2049.808%20109.093%2050.2708L106.288%2054.5911C106.171%2054.7712%20105.987%2054.8975%20105.777%2054.9422C105.566%2054.9869%20105.347%2054.9465%20105.167%2054.8297L101.832%2052.6673C101.731%2052.6018%20101.645%2052.5143%20101.582%2052.4114C101.519%2052.3085%20101.48%2052.1927%20101.467%2052.0725Z'%20fill='%233F3D56'%20/%3e%3cpath%20d='M115.162%2060.844L115.023%2062.9778L100.899%2062.6861L101.315%2060.844H115.162Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M114.962%2063.9052L114.821%2066.0444L100.207%2065.7419L100.623%2063.9052H114.962Z'%20fill='%23CCCCCC'%20/%3e%3cpath%20d='M109.531%2030.4117C108.033%2030.4119%20106.594%2030.9947%20105.519%2032.0366C104.444%2033.0785%20103.816%2034.4978%20103.77%2035.994H102.684C102.589%2035.994%20102.497%2036.0319%20102.429%2036.0995C102.362%2036.167%20102.324%2036.2586%20102.324%2036.3541V37.7947C102.324%2037.8902%20102.362%2037.9818%20102.429%2038.0494C102.497%2038.1169%20102.589%2038.1548%20102.684%2038.1548H114.936C115.032%2038.1548%20115.124%2038.1169%20115.191%2038.0494C115.259%2037.9818%20115.297%2037.8902%20115.297%2037.7947V36.174C115.297%2035.4173%20115.148%2034.668%20114.858%2033.9689C114.568%2033.2698%20114.143%2032.6345%20113.608%2032.0995C113.073%2031.5644%20112.437%2031.1399%20111.738%2030.8504C111.038%2030.5608%20110.288%2030.4117%20109.531%2030.4117Z'%20fill='%2317AD49'%20/%3e%3cpath%20d='M30.6466%2087.7749C29.5063%2088.1755%2028.282%2088.2758%2027.0916%2088.0662C25.9011%2087.8567%2024.7848%2087.3442%2023.8501%2086.5783C21.4696%2084.5815%2020.7232%2081.2917%2020.1159%2078.2455L18.3196%2069.2355L22.0803%2071.8234C24.7847%2073.6844%2027.5501%2075.6051%2029.4226%2078.3008C31.2951%2080.9964%2032.1125%2084.6762%2030.608%2087.593'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M30.3252%2098.6832C30.7058%2095.9124%2031.0972%2093.1059%2030.8302%2090.3054C30.5931%2087.8182%2029.8338%2085.3889%2028.2881%2083.397C27.4676%2082.3418%2026.4692%2081.4376%2025.3379%2080.7252C25.0428%2080.5391%2024.7713%2081.0064%2025.065%2081.1917C27.0227%2082.4282%2028.5368%2084.254%2029.3892%2086.4059C30.3306%2088.799%2030.4817%2091.4076%2030.3195%2093.9498C30.2214%2095.4871%2030.0135%2097.0143%2029.804%2098.5396C29.7874%2098.6086%2029.7977%2098.6813%2029.8328%2098.7429C29.8678%2098.8046%2029.925%2098.8507%2029.9927%2098.8719C30.0618%2098.8905%2030.1355%2098.8811%2030.1977%2098.8458C30.26%2098.8105%2030.3058%2098.7521%2030.3252%2098.6832Z'%20fill='%23F2F2F2'%20/%3e%3cpath%20d='M26.659%2093.7802C26.17%2094.5231%2025.4977%2095.1276%2024.707%2095.5354C23.9164%2095.9433%2023.0339%2096.1407%2022.1447%2096.1088C19.8595%2096.0004%2017.9543%2094.4064%2016.2393%2092.8931L11.1667%2088.417L14.5239%2088.2564C16.9382%2088.1409%2019.4149%2088.0332%2021.7144%2088.7773C24.014%2089.5214%2026.1348%2091.3122%2026.5553%2093.691'%20fill='%23E6E6E6'%20/%3e%3cpath%20d='M31.4009%20100.276C29.5688%2097.0364%2027.4439%2093.4359%2023.6469%2092.2851C22.5911%2091.9662%2021.4841%2091.852%2020.3854%2091.9485C20.0392%2091.9784%2020.1256%2092.5118%2020.4713%2092.482C22.3129%2092.3292%2024.151%2092.8152%2025.676%2093.8582C27.1436%2094.8565%2028.2862%2096.2445%2029.2533%2097.7163C29.8457%2098.6178%2030.3764%2099.5576%2030.9071%20100.496C31.0767%20100.796%2031.5724%20100.58%2031.4009%20100.276Z'%20fill='%23F2F2F2'%20/%3e%3cpath%20d='M133.82%20101H5.53217C5.48438%20101%205.43856%20100.981%205.40477%20100.947C5.37098%20100.914%205.35199%20100.868%205.35199%20100.82C5.35199%20100.772%205.37098%20100.726%205.40477%20100.693C5.43856%20100.659%205.48438%20100.64%205.53217%20100.64H133.82C133.868%20100.64%20133.913%20100.659%20133.947%20100.693C133.981%20100.726%20134%20100.772%20134%20100.82C134%20100.868%20133.981%20100.914%20133.947%20100.947C133.913%20100.981%20133.868%20101%20133.82%20101Z'%20fill='%23CCCCCC'%20/%3e%3c/g%3e%3cg%20style='mix-blend-mode:%20color'%3e%3crect%20x='7'%20width='120'%20height='120'%20fill='white'%20/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4845_623'%3e%3crect%20width='134'%20height='75'%20fill='white'%20transform='translate(0%2026)'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Pu = "data:image/svg+xml,%3csvg%20width='120'%20height='120'%20viewBox='0%200%20120%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_6342_255)'%3e%3cg%20style='mix-blend-mode:%20color'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip1_6342_255)'%3e%3crect%20width='130'%20height='104.129'%20transform='translate(-5%208)'%20fill='white'%20/%3e%3cpath%20d='M63.666%20111.894H27.8884L27.733%2055.3505H63.5101L63.666%20111.894Z'%20fill='%23F0F2F2'%20/%3e%3cpath%20d='M63.5101%2055.3505H45.6213V111.894H63.5101V55.3505Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M44.452%2044.2189H31.8182V55.3505H44.452V44.2189Z'%20fill='%23F0F2F2'%20/%3e%3cpath%20d='M44.4521%2044.2189H41.4411V55.3505H44.4521V44.2189Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M64.5572%2054.7012H24.7512V55.3504H64.5572V54.7012Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M37.8236%2060.2051H34.795V66.5906H37.8236V60.2051Z'%20fill='white'%20/%3e%3cpath%20d='M45.6213%2069.0973C45.6213%2069.1647%2041.6166%2069.219%2036.6774%2069.219C31.7367%2069.219%2027.7325%2069.1647%2027.7325%2069.0973C27.7325%2069.0299%2031.7362%2068.9756%2036.6774%2068.9756C41.6166%2068.9751%2045.6213%2069.0299%2045.6213%2069.0973Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M55.8678%2060.2051H52.8392V66.5906H55.8678V60.2051Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M63.666%2069.0973C63.666%2069.1647%2059.6613%2069.219%2054.7221%2069.219C49.7815%2069.219%2045.7772%2069.1647%2045.7772%2069.0973C45.7772%2069.0299%2049.781%2068.9756%2054.7221%2068.9756C59.6608%2068.9751%2063.666%2069.0299%2063.666%2069.0973Z'%20fill='%23F0F2F2'%20/%3e%3cpath%20d='M55.8678%2072.8832H52.8392V79.2687H55.8678V72.8832Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M63.666%2081.7748C63.666%2081.8422%2059.6613%2081.8965%2054.7221%2081.8965C49.7815%2081.8965%2045.7772%2081.8422%2045.7772%2081.7748C45.7772%2081.7074%2049.781%2081.6531%2054.7221%2081.6531C59.6608%2081.6531%2063.666%2081.7079%2063.666%2081.7748Z'%20fill='%23F0F2F2'%20/%3e%3cpath%20d='M55.8678%2085.944H52.8392V92.3295H55.8678V85.944Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M63.666%2094.8356C63.666%2094.903%2059.6613%2094.9573%2054.7221%2094.9573C49.7815%2094.9573%2045.7772%2094.9025%2045.7772%2094.8356C45.7772%2094.7682%2049.781%2094.7139%2054.7221%2094.7139C59.6608%2094.7134%2063.666%2094.7682%2063.666%2094.8356Z'%20fill='%23F0F2F2'%20/%3e%3cpath%20d='M55.8678%2099.0043H52.8392V105.39H55.8678V99.0043Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M63.666%20107.896C63.666%20107.963%2059.6613%20108.018%2054.7221%20108.018C49.7815%20108.018%2045.7772%20107.963%2045.7772%20107.896C45.7772%20107.828%2049.781%20107.774%2054.7221%20107.774C59.6608%20107.774%2063.666%20107.828%2063.666%20107.896Z'%20fill='%23F0F2F2'%20/%3e%3cpath%20d='M37.8236%2073.0768H34.795V79.4623H37.8236V73.0768Z'%20fill='white'%20/%3e%3cpath%20d='M45.6213%2081.9684C45.6213%2082.0358%2041.6166%2082.0906%2036.6774%2082.0906C31.7367%2082.0906%2027.7325%2082.0358%2027.7325%2081.9684C27.7325%2081.901%2031.7362%2081.8467%2036.6774%2081.8467C41.6166%2081.8467%2045.6213%2081.901%2045.6213%2081.9684Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M37.8236%2085.948H34.795V92.3335H37.8236V85.948Z'%20fill='white'%20/%3e%3cpath%20d='M45.6213%2094.8401C45.6213%2094.9075%2041.6166%2094.9618%2036.6774%2094.9618C31.7367%2094.9618%2027.7325%2094.907%2027.7325%2094.8401C27.7325%2094.7732%2031.7362%2094.7184%2036.6774%2094.7184C41.6166%2094.7179%2045.6213%2094.7727%2045.6213%2094.8401Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M37.8236%2098.8196H34.795V105.205H37.8236V98.8196Z'%20fill='white'%20/%3e%3cpath%20d='M45.6213%20107.711C45.6213%20107.779%2041.6166%20107.833%2036.6774%20107.833C31.7367%20107.833%2027.7325%20107.779%2027.7325%20107.711C27.7325%20107.644%2031.7362%20107.59%2036.6774%20107.59C41.6166%20107.59%2045.6213%20107.644%2045.6213%20107.711Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M89.0673%2059.6085H49.7004V111.532H89.0673V59.6085Z'%20fill='%23F0F2F2'%20/%3e%3cpath%20d='M89.0674%2059.6085H70.6088V111.532H89.0674V59.6085Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M61.4944%2066.6382H57.9548V75.2381H61.4944V66.6382Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M61.4944%20100.296H57.9548V108.895H61.4944V100.296Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M70.6088%2078.6132C70.6088%2078.7098%2065.9281%2078.7883%2060.1551%2078.7883C54.3801%2078.7883%2049.7005%2078.7098%2049.7005%2078.6132C49.7005%2078.5167%2054.3806%2078.4382%2060.1551%2078.4382C65.9281%2078.4382%2070.6088%2078.5167%2070.6088%2078.6132Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M61.4944%2083.5946H57.9548V92.1945H61.4944V83.5946Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M70.6088%2095.5691C70.6088%2095.6656%2065.9281%2095.7441%2060.1551%2095.7441C54.3801%2095.7441%2049.7005%2095.6656%2049.7005%2095.5691C49.7005%2095.4725%2054.3806%2095.394%2060.1551%2095.394C65.9281%2095.3945%2070.6088%2095.473%2070.6088%2095.5691Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M78.0685%2066.6382H74.5289V75.2381H78.0685V66.6382Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M85.7476%2066.6382H82.208V75.2381H85.7476V66.6382Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M78.0685%2082.9564H74.5289V91.5558H78.0685V82.9564Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M85.7476%2082.9564H82.208V91.5558H85.7476V82.9564Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M78.0685%2099.2747H74.5289V107.874H78.0685V99.2747Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M85.7476%2099.2747H82.208V107.874H85.7476V99.2747Z'%20fill='%23E1E6E4'%20/%3e%3cpath%20d='M92.027%2057.8009H46.7413V59.6733H92.027V57.8009Z'%20fill='%23B8C1C0'%20/%3e%3cpath%20d='M46.0835%2023.3171C46.2465%2022.1633%2044.5743%2021.2142%2043.3178%2021.1158C42.7186%2021.0689%2042.096%2021.158%2041.5285%2020.9655C40.2985%2020.548%2039.8073%2019.0006%2038.6072%2018.508C37.7102%2018.1394%2036.677%2018.4674%2035.8073%2018.8938C34.9376%2019.3202%2034.0778%2019.8564%2033.1062%2019.9172C32.2612%2019.97%2031.3434%2019.6647%2030.6037%2020.0667C30.0527%2020.3664%2029.7639%2020.9845%2029.2562%2021.3493C28.7594%2021.706%2028.1112%2021.7816%2027.4947%2021.8145C26.8782%2021.847%2026.24%2021.8534%2025.6785%2022.1037C25.1171%2022.3541%2024.6527%2022.9321%2024.7693%2023.5223L46.0835%2023.3171Z'%20fill='%23F0F2F2'%20/%3e%3cpath%20d='M105.855%2043.3706C106.158%2041.1651%20103.046%2039.3509%20100.706%2039.1621C99.5906%2039.0722%2098.4322%2039.2429%2097.3754%2038.8743C95.0858%2038.0762%2094.1713%2035.1185%2091.9374%2034.1762C90.2674%2033.4718%2088.3446%2034.0985%2086.7257%2034.9135C85.1069%2035.7284%2083.5068%2036.7535%2081.6978%2036.8693C80.1242%2036.9702%2078.4154%2036.3868%2077.0391%2037.1552C76.0134%2037.7282%2075.4759%2038.9098%2074.5303%2039.607C73.6054%2040.2894%2072.3986%2040.4336%2071.2512%2040.4963C70.1039%2040.5591%2068.9157%2040.5707%2067.8706%2041.0487C66.8254%2041.5273%2065.9607%2042.632%2066.178%2043.7612L105.855%2043.3706Z'%20fill='%23F0F2F2'%20/%3e%3cpath%20d='M115.209%20111.791C115.209%20111.791%20114.911%20109.757%20114.315%20109.444C113.718%20109.131%20113.356%20110.043%20113.356%20110.043C113.356%20110.043%20113.215%20108.1%20112.37%20107.518C111.525%20106.937%20110.89%20108.128%20110.89%20108.128C110.89%20108.128%20110.242%20105.661%20109.083%20105.661C107.924%20105.661%20107.339%20109.269%20107.339%20109.269C107.339%20109.269%20106.656%20108.194%20105.955%20108.801C105.253%20109.408%20105.253%20111.79%20105.253%20111.79H115.209V111.791Z'%20fill='url(%23paint0_linear_6342_255)'%20/%3e%3cpath%20d='M24.2871%20111.791C24.2871%20111.791%2023.9885%20109.757%2023.3923%20109.444C22.7961%20109.131%2022.4334%20110.043%2022.4334%20110.043C22.4334%20110.043%2022.293%20108.1%2021.4478%20107.518C20.6027%20106.937%2019.968%20108.128%2019.968%20108.128C19.968%20108.128%2019.3196%20105.661%2018.1604%20105.661C17.0012%20105.661%2016.417%20109.269%2016.417%20109.269C16.417%20109.269%2015.7331%20108.194%2015.0324%20108.801C14.3312%20109.408%2014.3312%20111.79%2014.3312%20111.79H24.2871V111.791Z'%20fill='url(%23paint1_linear_6342_255)'%20/%3e%3cpath%20d='M16.2672%20111.791H7.28854C7.28854%20111.791%207.58442%20109.943%208.17972%20109.812C8.77503%20109.681%209.05186%20110.538%209.05186%20110.538C9.05186%20110.538%209.02484%20107.96%2010.137%20107.521C11.2488%20107.082%2012.1816%20109.36%2012.1816%20109.36C12.1816%20109.36%2012.8788%20108.061%2013.8289%20108.145C14.779%20108.228%2015.0204%20110.373%2015.0204%20110.373C15.0204%20110.373%2015.885%20109.628%2016.2672%20111.791Z'%20fill='url(%23paint2_linear_6342_255)'%20/%3e%3cpath%20d='M105.897%20111.791H100.381C100.381%20111.791%20100.394%20110.592%20100.936%20110.274C101.478%20109.956%20101.8%20110.577%20101.8%20110.577C101.8%20110.577%20102.021%20108.373%20103.032%20108.373C104.043%20108.373%20104.527%20110.274%20104.527%20110.274C104.527%20110.274%20104.753%20109.699%20105.314%20109.807C105.875%20109.914%20105.897%20111.791%20105.897%20111.791Z'%20fill='url(%23paint3_linear_6342_255)'%20/%3e%3cpath%20d='M38.4064%20111.791H32.8901C32.8901%20111.791%2032.9029%20110.592%2033.4451%20110.274C33.9872%20109.956%2034.3097%20110.577%2034.3097%20110.577C34.3097%20110.577%2034.5307%20108.373%2035.5415%20108.373C36.5522%20108.373%2037.0359%20110.274%2037.0359%20110.274C37.0359%20110.274%2037.2623%20109.699%2037.8235%20109.807C38.3838%20109.914%2038.4064%20111.791%2038.4064%20111.791Z'%20fill='url(%23paint4_linear_6342_255)'%20/%3e%3cpath%20d='M-5%20111.805L11.177%20111.648L27.354%20111.591L59.708%20111.483L92.062%20111.591L108.239%20111.647L124.416%20111.805L108.239%20111.964L92.062%20112.02L59.708%20112.128L27.354%20112.019L11.177%20111.962L-5%20111.805Z'%20fill='%23263238'%20/%3e%3cpath%20d='M60.581%2010.5908C53.2505%2010.7609%2047.2731%2016.7351%2047.0985%2024.0656C47.0241%2027.205%2048.0001%2030.1115%2049.6952%2032.4651L49.6914%2032.4664L49.8259%2032.6495C49.8324%2032.6579%2049.8388%2032.6669%2049.8446%2032.6753L59.6263%2045.98C60.4872%2047.1512%2062.2496%2047.1144%2063.0607%2045.9081L71.902%2032.7639C73.5751%2030.2124%2074.7225%2027.5452%2074.7225%2024.4012C74.7238%2016.6627%2068.3603%2010.4104%2060.581%2010.5908ZM60.9095%2034.4475C55.1734%2034.4475%2050.5238%2029.7979%2050.5238%2024.0617C50.5238%2018.3255%2055.1734%2013.6759%2060.9095%2013.6759C66.6457%2013.6759%2071.2953%2018.3255%2071.2953%2024.0617C71.2953%2029.7979%2066.645%2034.4475%2060.9095%2034.4475Z'%20fill='%235D6C6B'%20/%3e%3cg%20opacity='0.3'%3e%3cpath%20d='M58.2874%2010.5908C50.957%2010.7609%2044.9796%2016.7351%2044.805%2024.0656C44.7306%2027.205%2045.7066%2030.1115%2047.4017%2032.4651L47.3978%2032.4664L47.5324%2032.6495C47.5388%2032.6579%2047.5453%2032.6669%2047.5511%2032.6753L57.3328%2045.98C58.1937%2047.1512%2059.9561%2047.1144%2060.7671%2045.9081L69.6084%2032.7639C71.2816%2030.2124%2072.429%2027.5452%2072.429%2024.4012C72.4303%2016.6627%2066.0668%2010.4104%2058.2874%2010.5908ZM58.616%2034.4475C52.8798%2034.4475%2048.2302%2029.7979%2048.2302%2024.0617C48.2302%2018.3255%2052.8798%2013.6759%2058.616%2013.6759C64.3522%2013.6759%2069.0018%2018.3255%2069.0018%2024.0617C69.0018%2029.7979%2064.3515%2034.4475%2058.616%2034.4475Z'%20fill='%23B8C1C0'%20/%3e%3c/g%3e%3cpath%20d='M58.7622%2010.5908C51.4317%2010.7609%2045.4543%2016.7351%2045.2797%2024.0656C45.2046%2027.205%2046.1813%2030.1115%2047.8764%2032.4651L47.8725%2032.4664L48.0071%2032.6495C48.0135%2032.6579%2048.02%2032.6669%2048.0258%2032.6753L57.8075%2045.98C58.6684%2047.1512%2060.4308%2047.1144%2061.2419%2045.9081L70.0831%2032.7639C71.7563%2030.2124%2072.9037%2027.5452%2072.9037%2024.4012C72.905%2016.6627%2066.5421%2010.4104%2058.7622%2010.5908ZM59.0907%2032.5751C54.7464%2032.5751%2051.2247%2029.0534%2051.2247%2024.7091C51.2247%2020.3648%2054.7464%2016.8431%2059.0907%2016.8431C63.435%2016.8431%2066.9567%2020.3648%2066.9567%2024.7091C66.956%2029.0534%2063.4344%2032.5751%2059.0907%2032.5751Z'%20fill='%23D2D9D7'%20/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_6342_255'%20x1='110.261'%20y1='105.62'%20x2='110.261'%20y2='111.749'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23D2D9D7'%20/%3e%3cstop%20offset='1'%20stop-color='%23B4C0BC'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_6342_255'%20x1='19.3393'%20y1='105.62'%20x2='19.3393'%20y2='111.749'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23D2D9D7'%20/%3e%3cstop%20offset='1'%20stop-color='%23B4C0BC'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_6342_255'%20x1='11.805'%20y1='107.435'%20x2='11.805'%20y2='111.761'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23D2D9D7'%20/%3e%3cstop%20offset='1'%20stop-color='%23B4C0BC'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_6342_255'%20x1='103.156'%20y1='108.35'%20x2='103.156'%20y2='111.768'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23D2D9D7'%20/%3e%3cstop%20offset='1'%20stop-color='%23B4C0BC'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint4_linear_6342_255'%20x1='35.6649'%20y1='108.35'%20x2='35.6649'%20y2='111.768'%20gradientUnits='userSpaceOnUse'%20%3e%3cstop%20stop-color='%23D2D9D7'%20/%3e%3cstop%20offset='1'%20stop-color='%23B4C0BC'%20/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_6342_255'%3e%3crect%20width='120'%20height='120'%20fill='white'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_6342_255'%3e%3crect%20width='130'%20height='104.129'%20fill='white'%20transform='translate(-5%208)'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Yu = (e) => {
  const { size: t, image: r, emptyStateCustomClasses: n } = ye(e), s = F(() => a.value.baseClasses + " " + n.value), a = F(() => {
    const l = L(
      "spr-background-color spr-flex spr-h-full spr-w-full spr-flex-col spr-items-center spr-justify-center spr-gap-size-spacing-2xs spr-text-center",
      {
        "spr-px-size-spacing-sm spr-py-size-spacing-md spr-min-h-[240px]": t.value === "small",
        "spr-px-size-spacing-sm spr-py-size-spacing-2xl spr-min-h-[360px]": t.value === "large"
      }
    ), u = L({
      "spr-h-[200px] spr-w-[200px]": t.value === "large",
      "spr-h-[120px] spr-w-[120px]": t.value === "small"
    });
    return {
      baseClasses: l,
      imageSizeClasses: u
    };
  }), i = F(() => r.value ? new URL((/* @__PURE__ */ Object.assign({ "../../assets/images/empty-states/bug.svg": Su, "../../assets/images/empty-states/clock.svg": ju, "../../assets/images/empty-states/dashboard.svg": Tu, "../../assets/images/empty-states/employees.svg": Ou, "../../assets/images/empty-states/government-id.svg": _u, "../../assets/images/empty-states/integration.svg": zu, "../../assets/images/empty-states/list.svg": Lu, "../../assets/images/empty-states/social-media-handles.svg": ku, "../../assets/images/empty-states/work-in-progress.svg": Eu, "../../assets/images/empty-states/work-location.svg": Pu }))[`../../assets/images/empty-states/${r.value}.svg`], import.meta.url).href : "");
  return {
    emptyStateClasses: a,
    getImageUrl: i,
    containerClasses: s
  };
}, Uu = ["src"], Fu = { class: "spr-flex spr-flex-col spr-items-center spr-justify-center spr-gap-size-spacing-md" }, Bu = { class: "spr-text-color-strong spr-body-md spr-body-md-regular-medium spr-flex spr-flex-col" }, Ru = { class: "spr-text-color-base spr-body-sm-regular" }, ar = /* @__PURE__ */ ae({
  __name: "empty-state",
  props: wu,
  emits: ["onClick"],
  setup(e) {
    const t = e, { emptyStateClasses: r, getImageUrl: n, containerClasses: s } = Yu(t);
    return (a, i) => (f(), C("div", {
      id: "empty-state",
      class: x(o(s))
    }, [
      ee(a.$slots, "default", {
        class: x(o(r).imageSizeClasses)
      }),
      a.$slots.default ? _("", !0) : (f(), C("div", {
        key: 0,
        class: x(o(r).imageSizeClasses)
      }, [
        A("img", {
          src: o(n),
          alt: "empty",
          class: "spr-h-full spr-w-full spr-object-cover"
        }, null, 8, Uu)
      ], 2)),
      A("section", Fu, [
        A("div", Bu, [
          A("span", null, G(a.description), 1),
          A("div", Ru, G(a.subDescription), 1)
        ]),
        ee(a.$slots, "button")
      ])
    ], 2));
  }
}), Vu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ar
}, Symbol.toStringTag, { value: "Module" })), Qu = {
  employees: {
    type: Array,
    default: () => []
  },
  initialDate: {
    type: Date,
    default: () => /* @__PURE__ */ new Date()
  },
  search: {
    type: String,
    default: ""
  },
  selectedCell: {
    type: Object,
    default: () => ({
      employeeId: "",
      date: "",
      shift: null
    })
  },
  loading: {
    type: Boolean,
    default: !1
  },
  emptyStateTitle: {
    type: String,
    default: "No List Found"
  },
  emptyStateDescription: {
    type: String,
    default: ""
  },
  emptyStateButtonText: {
    type: String,
    default: "Add Employee"
  },
  hideAddButton: {
    type: Boolean,
    default: !1
  },
  infiniteLoading: {
    type: Boolean,
    default: !1
  },
  loadingTextCompleted: {
    type: String,
    default: ""
  }
}, Hu = {};
var $2 = { exports: {} }, Zu = $2.exports, qr;
function Gu() {
  return qr || (qr = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Zu, function() {
      var r = 1e3, n = 6e4, s = 36e5, a = "millisecond", i = "second", l = "minute", u = "hour", d = "day", c = "week", p = "month", h = "quarter", y = "year", M = "date", g = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, m = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, I = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(j) {
        var T = ["th", "st", "nd", "rd"], O = j % 100;
        return "[" + j + (T[(O - 20) % 10] || T[O] || T[0]) + "]";
      } }, N = function(j, T, O) {
        var S = String(j);
        return !S || S.length >= T ? j : "" + Array(T + 1 - S.length).join(O) + j;
      }, w = { s: N, z: function(j) {
        var T = -j.utcOffset(), O = Math.abs(T), S = Math.floor(O / 60), Y = O % 60;
        return (T <= 0 ? "+" : "-") + N(S, 2, "0") + ":" + N(Y, 2, "0");
      }, m: function j(T, O) {
        if (T.date() < O.date()) return -j(O, T);
        var S = 12 * (O.year() - T.year()) + (O.month() - T.month()), Y = T.clone().add(S, p), U = O - Y < 0, J = T.clone().add(S + (U ? -1 : 1), p);
        return +(-(S + (O - Y) / (U ? Y - J : J - Y)) || 0);
      }, a: function(j) {
        return j < 0 ? Math.ceil(j) || 0 : Math.floor(j);
      }, p: function(j) {
        return { M: p, y, w: c, d, D: M, h: u, m: l, s: i, ms: a, Q: h }[j] || String(j || "").toLowerCase().replace(/s$/, "");
      }, u: function(j) {
        return j === void 0;
      } }, E = "en", $ = {};
      $[E] = I;
      var D = "$isDayjsObject", z = function(j) {
        return j instanceof V || !(!j || !j[D]);
      }, k = function j(T, O, S) {
        var Y;
        if (!T) return E;
        if (typeof T == "string") {
          var U = T.toLowerCase();
          $[U] && (Y = U), O && ($[U] = O, Y = U);
          var J = T.split("-");
          if (!Y && J.length > 1) return j(J[0]);
        } else {
          var oe = T.name;
          $[oe] = T, Y = oe;
        }
        return !S && Y && (E = Y), Y || !S && E;
      }, b = function(j, T) {
        if (z(j)) return j.clone();
        var O = typeof T == "object" ? T : {};
        return O.date = j, O.args = arguments, new V(O);
      }, P = w;
      P.l = k, P.i = z, P.w = function(j, T) {
        return b(j, { locale: T.$L, utc: T.$u, x: T.$x, $offset: T.$offset });
      };
      var V = function() {
        function j(O) {
          this.$L = k(O.locale, null, !0), this.parse(O), this.$x = this.$x || O.x || {}, this[D] = !0;
        }
        var T = j.prototype;
        return T.parse = function(O) {
          this.$d = function(S) {
            var Y = S.date, U = S.utc;
            if (Y === null) return /* @__PURE__ */ new Date(NaN);
            if (P.u(Y)) return /* @__PURE__ */ new Date();
            if (Y instanceof Date) return new Date(Y);
            if (typeof Y == "string" && !/Z$/i.test(Y)) {
              var J = Y.match(v);
              if (J) {
                var oe = J[2] - 1 || 0, de = (J[7] || "0").substring(0, 3);
                return U ? new Date(Date.UTC(J[1], oe, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, de)) : new Date(J[1], oe, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, de);
              }
            }
            return new Date(Y);
          }(O), this.init();
        }, T.init = function() {
          var O = this.$d;
          this.$y = O.getFullYear(), this.$M = O.getMonth(), this.$D = O.getDate(), this.$W = O.getDay(), this.$H = O.getHours(), this.$m = O.getMinutes(), this.$s = O.getSeconds(), this.$ms = O.getMilliseconds();
        }, T.$utils = function() {
          return P;
        }, T.isValid = function() {
          return this.$d.toString() !== g;
        }, T.isSame = function(O, S) {
          var Y = b(O);
          return this.startOf(S) <= Y && Y <= this.endOf(S);
        }, T.isAfter = function(O, S) {
          return b(O) < this.startOf(S);
        }, T.isBefore = function(O, S) {
          return this.endOf(S) < b(O);
        }, T.$g = function(O, S, Y) {
          return P.u(O) ? this[S] : this.set(Y, O);
        }, T.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, T.valueOf = function() {
          return this.$d.getTime();
        }, T.startOf = function(O, S) {
          var Y = this, U = !!P.u(S) || S, J = P.p(O), oe = function(Ne, me) {
            var Se = P.w(Y.$u ? Date.UTC(Y.$y, me, Ne) : new Date(Y.$y, me, Ne), Y);
            return U ? Se : Se.endOf(d);
          }, de = function(Ne, me) {
            return P.w(Y.toDate()[Ne].apply(Y.toDate("s"), (U ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(me)), Y);
          }, Me = this.$W, se = this.$M, ie = this.$D, Ce = "set" + (this.$u ? "UTC" : "");
          switch (J) {
            case y:
              return U ? oe(1, 0) : oe(31, 11);
            case p:
              return U ? oe(1, se) : oe(0, se + 1);
            case c:
              var ge = this.$locale().weekStart || 0, ve = (Me < ge ? Me + 7 : Me) - ge;
              return oe(U ? ie - ve : ie + (6 - ve), se);
            case d:
            case M:
              return de(Ce + "Hours", 0);
            case u:
              return de(Ce + "Minutes", 1);
            case l:
              return de(Ce + "Seconds", 2);
            case i:
              return de(Ce + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, T.endOf = function(O) {
          return this.startOf(O, !1);
        }, T.$set = function(O, S) {
          var Y, U = P.p(O), J = "set" + (this.$u ? "UTC" : ""), oe = (Y = {}, Y[d] = J + "Date", Y[M] = J + "Date", Y[p] = J + "Month", Y[y] = J + "FullYear", Y[u] = J + "Hours", Y[l] = J + "Minutes", Y[i] = J + "Seconds", Y[a] = J + "Milliseconds", Y)[U], de = U === d ? this.$D + (S - this.$W) : S;
          if (U === p || U === y) {
            var Me = this.clone().set(M, 1);
            Me.$d[oe](de), Me.init(), this.$d = Me.set(M, Math.min(this.$D, Me.daysInMonth())).$d;
          } else oe && this.$d[oe](de);
          return this.init(), this;
        }, T.set = function(O, S) {
          return this.clone().$set(O, S);
        }, T.get = function(O) {
          return this[P.p(O)]();
        }, T.add = function(O, S) {
          var Y, U = this;
          O = Number(O);
          var J = P.p(S), oe = function(se) {
            var ie = b(U);
            return P.w(ie.date(ie.date() + Math.round(se * O)), U);
          };
          if (J === p) return this.set(p, this.$M + O);
          if (J === y) return this.set(y, this.$y + O);
          if (J === d) return oe(1);
          if (J === c) return oe(7);
          var de = (Y = {}, Y[l] = n, Y[u] = s, Y[i] = r, Y)[J] || 1, Me = this.$d.getTime() + O * de;
          return P.w(Me, this);
        }, T.subtract = function(O, S) {
          return this.add(-1 * O, S);
        }, T.format = function(O) {
          var S = this, Y = this.$locale();
          if (!this.isValid()) return Y.invalidDate || g;
          var U = O || "YYYY-MM-DDTHH:mm:ssZ", J = P.z(this), oe = this.$H, de = this.$m, Me = this.$M, se = Y.weekdays, ie = Y.months, Ce = Y.meridiem, ge = function(me, Se, ne, te) {
            return me && (me[Se] || me(S, U)) || ne[Se].slice(0, te);
          }, ve = function(me) {
            return P.s(oe % 12 || 12, me, "0");
          }, Ne = Ce || function(me, Se, ne) {
            var te = me < 12 ? "AM" : "PM";
            return ne ? te.toLowerCase() : te;
          };
          return U.replace(m, function(me, Se) {
            return Se || function(ne) {
              switch (ne) {
                case "YY":
                  return String(S.$y).slice(-2);
                case "YYYY":
                  return P.s(S.$y, 4, "0");
                case "M":
                  return Me + 1;
                case "MM":
                  return P.s(Me + 1, 2, "0");
                case "MMM":
                  return ge(Y.monthsShort, Me, ie, 3);
                case "MMMM":
                  return ge(ie, Me);
                case "D":
                  return S.$D;
                case "DD":
                  return P.s(S.$D, 2, "0");
                case "d":
                  return String(S.$W);
                case "dd":
                  return ge(Y.weekdaysMin, S.$W, se, 2);
                case "ddd":
                  return ge(Y.weekdaysShort, S.$W, se, 3);
                case "dddd":
                  return se[S.$W];
                case "H":
                  return String(oe);
                case "HH":
                  return P.s(oe, 2, "0");
                case "h":
                  return ve(1);
                case "hh":
                  return ve(2);
                case "a":
                  return Ne(oe, de, !0);
                case "A":
                  return Ne(oe, de, !1);
                case "m":
                  return String(de);
                case "mm":
                  return P.s(de, 2, "0");
                case "s":
                  return String(S.$s);
                case "ss":
                  return P.s(S.$s, 2, "0");
                case "SSS":
                  return P.s(S.$ms, 3, "0");
                case "Z":
                  return J;
              }
              return null;
            }(me) || J.replace(":", "");
          });
        }, T.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, T.diff = function(O, S, Y) {
          var U, J = this, oe = P.p(S), de = b(O), Me = (de.utcOffset() - this.utcOffset()) * n, se = this - de, ie = function() {
            return P.m(J, de);
          };
          switch (oe) {
            case y:
              U = ie() / 12;
              break;
            case p:
              U = ie();
              break;
            case h:
              U = ie() / 3;
              break;
            case c:
              U = (se - Me) / 6048e5;
              break;
            case d:
              U = (se - Me) / 864e5;
              break;
            case u:
              U = se / s;
              break;
            case l:
              U = se / n;
              break;
            case i:
              U = se / r;
              break;
            default:
              U = se;
          }
          return Y ? U : P.a(U);
        }, T.daysInMonth = function() {
          return this.endOf(p).$D;
        }, T.$locale = function() {
          return $[this.$L];
        }, T.locale = function(O, S) {
          if (!O) return this.$L;
          var Y = this.clone(), U = k(O, S, !0);
          return U && (Y.$L = U), Y;
        }, T.clone = function() {
          return P.w(this.$d, this);
        }, T.toDate = function() {
          return new Date(this.valueOf());
        }, T.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, T.toISOString = function() {
          return this.$d.toISOString();
        }, T.toString = function() {
          return this.$d.toUTCString();
        }, j;
      }(), Z = V.prototype;
      return b.prototype = Z, [["$ms", a], ["$s", i], ["$m", l], ["$H", u], ["$W", d], ["$M", p], ["$y", y], ["$D", M]].forEach(function(j) {
        Z[j[1]] = function(T) {
          return this.$g(T, j[0], j[1]);
        };
      }), b.extend = function(j, T) {
        return j.$i || (j(T, V, b), j.$i = !0), b;
      }, b.locale = k, b.isDayjs = z, b.unix = function(j) {
        return b(1e3 * j);
      }, b.en = $[E], b.Ls = $, b.p = {}, b;
    });
  }($2)), $2.exports;
}
var Wu = Gu();
const ue = /* @__PURE__ */ c2(Wu);
var D2 = { exports: {} }, Ku = D2.exports, en;
function Ju() {
  return en || (en = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Ku, function() {
      return function(r, n, s) {
        n.prototype.isBetween = function(a, i, l, u) {
          var d = s(a), c = s(i), p = (u = u || "()")[0] === "(", h = u[1] === ")";
          return (p ? this.isAfter(d, l) : !this.isBefore(d, l)) && (h ? this.isBefore(c, l) : !this.isAfter(c, l)) || (p ? this.isBefore(d, l) : !this.isAfter(d, l)) && (h ? this.isAfter(c, l) : !this.isBefore(c, l));
        };
      };
    });
  }(D2)), D2.exports;
}
var Xu = Ju();
const qu = /* @__PURE__ */ c2(Xu);
ue.extend(qu);
const ed = (e, t) => {
  const { initialDate: r, hideAddButton: n } = ye(e), s = {
    dateFormat: B("YYYY-MM-DD"),
    companyDropDown: B([]),
    departmentDropDown: B([]),
    branchDropDown: B([]),
    currentDate: B(ue(r.value)),
    searchTerm: B(""),
    selectedCompany: B(""),
    selectedDepartment: B(""),
    selectedBranch: B(""),
    isHover: B(!1),
    hoveredCell: B(),
    employeeId: B(),
    sort: B(""),
    tableBodyRef: B(null)
  }, a = Ie(e, "search", t), i = Ie(e, "selectedCell", t), l = F(() => s.sort.value ? s.sort.value === "asc" ? "ph:arrow-up" : "ph:arrow-down" : "ph:caret-up-down-light"), u = F(() => s.currentDate.value.startOf("week")), d = F(() => Array.from({ length: 7 }).map(($, D) => u.value.add(D, "day"))), c = F(() => {
    const $ = u.value, D = u.value.add(6, "day"), z = "MMM YYYY";
    return $.format("YYYY") !== D.format("YYYY") ? `${$.format(z)} - ${D.format(z)}` : $.format("MMM") !== D.format("MMM") ? `${$.format("MMM")} - ${D.format(z)}` : `${$.format(z)}`;
  }), p = ($, D) => $.format(D), h = ($) => $.isSame(ue(), "day"), y = () => {
    s.currentDate.value = s.currentDate.value.subtract(1, "week");
  }, M = () => {
    s.currentDate.value = s.currentDate.value.add(1, "week");
  }, g = () => {
    if (!s.currentDate.value) return;
    const $ = s.currentDate.value.startOf("week"), D = s.currentDate.value.endOf("week");
    t("update:firstLastDayOfWeek", {
      firstDay: $.format(s.dateFormat.value),
      lastDay: D.format(s.dateFormat.value)
    });
  }, v = () => {
    const $ = ue(), D = s.currentDate.value.startOf("week"), z = s.currentDate.value.endOf("week");
    $.isBetween(D, z, "day", "[]") || (s.currentDate.value = $);
  }, m = ($) => {
    i.value = $, t("onCellClick", $);
  }, I = ($, D, z) => {
    s.isHover.value = $, s.hoveredCell.value = $ ? D : void 0, s.employeeId.value = z;
  }, N = ($, D) => s.hoveredCell.value === $ && s.isHover.value && s.employeeId.value === D && !n.value, w = () => {
    s.sort.value === "asc" ? s.sort.value = "" : s.sort.value = s.sort.value === "desc" ? "asc" : "desc", t("update:sort", s.sort.value);
  };
  kt(
    s.tableBodyRef,
    () => {
      t("loadMore");
    },
    {
      distance: 50,
      direction: "bottom"
    }
  );
  const E = F(() => {
    const $ = L(" spr-border spr-border-color-weak spr-border-solid"), D = L(
      "spr-bg-color-weak spr-flex spr-w-full spr-items-center spr-justify-between spr-p-size-spacing-sm"
    ), z = L(
      " spr-flex spr-flex-col spr-h-full spr-divide-color-weak spr-divide-x-0 spr-divide-y spr-divide-solid"
    ), k = L(
      "spr-h-full spr-table spr-w-full spr-table-fixed spr-border-collapse spr-border-spacing-0 spr-rounded-border"
    ), b = L(
      "spr-sticky spr-left-0 spr-z-20 spr-background-color spr-body-xs-regular-medium spr-p-size-spacing-xs spr-text-left spr-overflow-hidden spr-h-full spr-border-x-0 spr-border-t-0 "
    ), P = L(
      "spr-background-color spr-border-x-0 spr-border-t-0 spr-border-l  spr-p-size-spacing-sm spr-text-center"
    ), V = L(
      "spr-flex  spr-flex-row spr-w-full spr-items-center spr-gap-size-spacing-3xs lg:spr-flex-col spr-overflow-hidden"
    ), Z = L(
      "spr-font-size-400 spr-line-height-500 spr-letter-spacing-dense spr-flex spr-h-size-spacing-md spr-w-size-spacing-md spr-items-center spr-justify-center spr-rounded-full spr-font-main spr-font-normal"
    );
    return g(), ce(s.searchTerm, (j, T) => {
      j !== T && (a.value = j);
    }), {
      borderClasses: $,
      headerWrapper: D,
      contentWrapper: z,
      calendarTable: k,
      tableHeaderEmployeeName: b,
      tableHeader: P,
      headerContent: V,
      headerDate: Z
    };
  });
  return {
    weekDates: d,
    weekRangeDisplay: c,
    getCalendarClasses: E,
    getSortIcon: l,
    formatDate: p,
    isToday: h,
    prevWeek: y,
    nextWeek: M,
    goToToday: v,
    onCellClick: m,
    handleHover: I,
    showAddShift: N,
    handleSorting: w,
    ...s
  };
}, td = { class: "spr-flex spr-items-center spr-justify-center spr-gap-size-spacing-3xs" }, rd = { class: "spr-flex" }, nd = { class: "spr-heading-xs" }, sd = { class: "spr-table-wrapper spr-relative spr-flex spr-h-full spr-flex-col spr-overflow-hidden" }, ad = { class: "spr-h-full" }, od = { class: "spr-body-sm-regular" }, id = { class: "spr-flex spr-flex-col spr-gap-size-spacing-3xs spr-overflow-hidden" }, ld = { class: "spr-label-xs-regular" }, ud = { class: "spr-text-color-supporting spr-label-xs-regular spr-uppercase" }, dd = {
  key: 0,
  class: "spr-mt-size-spacing-xs"
}, cd = ["onMouseover", "onMouseleave"], pd = {
  key: 0,
  class: "spr-flex spr-flex-col spr-justify-start spr-gap-size-spacing-3xs"
}, fd = ["onClick"], gd = ["onClick"], hd = { key: 1 }, yd = { key: 0 }, Cd = ["colspan"], vd = { key: 0 }, md = { key: 1 }, Md = { key: 1 }, bd = { class: "spr-flex spr-flex-col spr-gap-size-spacing-3xs spr-overflow-hidden" }, Nd = { class: "spr-mt-size-spacing-xs" }, $d = { class: "spr-flex spr-flex-col spr-justify-start spr-gap-size-spacing-3xs" }, Dd = { class: "spr-flex spr-flex-col spr-items-center spr-justify-start" }, Id = {
  key: 2,
  class: "spr-h-full"
}, Ad = {
  key: 0,
  class: "spr-h-full"
}, xd = ["colspan"], wd = /* @__PURE__ */ ae({
  __name: "calendar",
  props: Qu,
  emits: Hu,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      // State
      weekDates: s,
      weekRangeDisplay: a,
      getCalendarClasses: i,
      dateFormat: l,
      getSortIcon: u,
      sort: d,
      tableBodyRef: c,
      // Function
      formatDate: p,
      isToday: h,
      prevWeek: y,
      nextWeek: M,
      goToToday: g,
      onCellClick: v,
      handleHover: m,
      showAddShift: I,
      handleSorting: N
    } = ed(r, n);
    return (w, E) => (f(), K(Ss, {
      flexbox: "",
      "has-content-padding": !1,
      class: "spr-flex spr-h-full spr-flex-col spr-overflow-hidden"
    }, {
      content: H(() => [
        A("div", {
          class: x(o(i).contentWrapper)
        }, [
          A("div", {
            class: x([o(i).headerWrapper])
          }, [
            A("div", td, [
              A("div", rd, [
                R(be, {
                  id: "calendar-prev-week",
                  variant: "tertiary",
                  "has-icon": "",
                  onClick: o(y)
                }, {
                  default: H(() => [
                    R(o(W), {
                      icon: "ph:caret-left-fill",
                      class: "spr-text-color-success-base"
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                R(be, {
                  id: "calendar-next-week",
                  variant: "tertiary",
                  "has-icon": "",
                  onClick: o(M)
                }, {
                  default: H(() => [
                    R(o(W), {
                      icon: "ph:caret-right-fill",
                      class: "spr-text-color-success-base"
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              A("div", nd, G(o(a)), 1)
            ]),
            R(be, {
              id: "calendar-today",
              variant: "secondary",
              size: "large",
              onClick: o(g)
            }, {
              default: H(() => E[2] || (E[2] = [
                Oe(" Today ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ], 2),
          ee(w.$slots, "filter"),
          A("div", sd, [
            A("div", ad, [
              A("table", {
                id: "table-calendar",
                "aria-describedby": "calendar",
                class: x(o(i).calendarTable)
              }, [
                A("thead", null, [
                  A("tr", null, [
                    A("th", {
                      class: x([
                        o(i).tableHeaderEmployeeName,
                        "spr-sticky spr-left-0",
                        o(i).borderClasses
                      ])
                    }, [
                      A("div", {
                        class: x(o(i).headerContent)
                      }, [
                        E[3] || (E[3] = A("div", null, "Employee Name", -1)),
                        A("div", {
                          id: "calendar-sort-button",
                          class: x(["spr-flex spr-cursor-pointer spr-flex-row spr-items-center spr-p-size-spacing-6xs"]),
                          onClick: E[0] || (E[0] = //@ts-ignore
                          (...$) => o(N) && o(N)(...$))
                        }, [
                          R(o(W), {
                            icon: o(u),
                            height: "16",
                            width: "16",
                            class: x([{ "spr-text-kangkong-700": o(d) }])
                          }, null, 8, ["icon", "class"])
                        ])
                      ], 2)
                    ], 2),
                    (f(!0), C(X, null, le(o(s), ($, D) => (f(), C("th", {
                      key: D,
                      class: x([o(i).borderClasses, o(i).tableHeader])
                    }, [
                      A("div", {
                        class: x(o(i).headerContent)
                      }, [
                        A("div", {
                          class: x([
                            o(i).headerDate,
                            {
                              "spr-background-color-brand-base spr-text-color-inverted-strong": o(h)($)
                            }
                          ])
                        }, G(o(p)($, "DD")), 3),
                        A("div", od, G(o(p)($, "ddd").toUpperCase()), 1)
                      ], 2)
                    ], 2))), 128))
                  ])
                ]),
                w.employees.length > 0 && !w.loading ? (f(), C("tbody", {
                  key: 0,
                  ref_key: "tableBodyRef",
                  ref: c,
                  class: "spr-h-full spr-overflow-y-auto"
                }, [
                  (f(!0), C(X, null, le(w.employees, ($) => (f(), C("tr", {
                    key: $.id
                  }, [
                    A("td", {
                      class: x([
                        o(i).borderClasses,
                        "spr-bg-white spr-sticky spr-left-0 spr-z-10 spr-content-start spr-border-y spr-border-l-0 spr-border-r spr-border-t-0 spr-p-size-spacing-xs"
                      ])
                    }, [
                      A("div", id, [
                        R(Et, {
                          src: $.avatar,
                          initial: $.name,
                          size: "md",
                          variant: $.avatar ? "image" : "initial",
                          color: "tertiary"
                        }, null, 8, ["src", "initial", "variant"]),
                        A("div", ld, G($.name), 1),
                        A("div", ud, G($.position), 1)
                      ]),
                      $.hoursWorked && $.hoursTarget ? (f(), C("div", dd, [
                        R(P2, {
                          label: `${$.hoursWorked || 0}/${$.hoursTarget || 48} HRS`,
                          tone: "neutral"
                        }, {
                          icon: H(() => [
                            R(o(W), { icon: "ph:clock" })
                          ]),
                          _: 2
                        }, 1032, ["label"])
                      ])) : _("", !0)
                    ], 2),
                    (f(!0), C(X, null, le(o(s), (D, z) => (f(), C("td", {
                      key: z,
                      class: x([
                        o(i).borderClasses,
                        "spr-min-w-[180px] spr-content-start spr-space-y-size-spacing-3xs spr-border-x spr-border-b spr-border-t-0 spr-p-size-spacing-sm last:spr-mb-size-spacing-lg last:spr-border-r-0"
                      ]),
                      onMouseover: (k) => o(m)(!0, z, $.id),
                      onMouseleave: (k) => o(m)(!1, z, $.id)
                    }, [
                      $.schedule[o(p)(D, o(l))] && $.schedule[o(p)(D, o(l))].length > 0 ? (f(), C("section", pd, [
                        (f(!0), C(X, null, le($.schedule[o(p)(D, o(l))], (k, b) => (f(), C("div", {
                          key: b,
                          class: "spr-w-full"
                        }, [
                          k.type === "restday" ? (f(), C("div", {
                            key: 0,
                            class: "spr-flex spr-flex-col spr-items-center spr-justify-start",
                            onClick: (P) => o(v)({
                              employeeId: $.id,
                              date: o(p)(D, o(l)),
                              shift: "restday"
                            })
                          }, [
                            R(Ht, {
                              type: "restday",
                              fullwidth: ""
                            })
                          ], 8, fd)) : (f(), C("div", {
                            key: 1,
                            class: "spr-flex spr-flex-col spr-items-center spr-justify-start",
                            onClick: (P) => o(v)({
                              employeeId: $.id,
                              date: o(p)(D, o(l)),
                              shift: k
                            })
                          }, [
                            R(Ht, {
                              "view-only": !1,
                              title: `${k.startTime} - ${k.endTime}`,
                              description: k.location,
                              "sub-description": k.type,
                              type: k.color,
                              fullwidth: ""
                            }, null, 8, ["title", "description", "sub-description", "type"])
                          ], 8, gd))
                        ]))), 128))
                      ])) : _("", !0),
                      o(I)(z, $.id) ? (f(), C("section", hd, [
                        R(Ht, {
                          status: "pending",
                          type: "exempt",
                          "view-only": !1,
                          fullwidth: "",
                          onOnClick: (k) => o(v)({ employeeId: $.id, date: o(p)(D, o(l)), shift: null })
                        }, {
                          prefix: H(() => [
                            R(o(W), { icon: "ph:plus" })
                          ]),
                          default: H(() => [
                            E[4] || (E[4] = A("div", { class: "spr-label-xs-medium" }, "Add New Shift", -1))
                          ]),
                          _: 2
                        }, 1032, ["onOnClick"])
                      ])) : _("", !0)
                    ], 42, cd))), 128))
                  ]))), 128)),
                  r.infiniteLoading || r.loadingTextCompleted ? (f(), C("tr", yd, [
                    A("td", {
                      colspan: o(s).length + 1,
                      class: "spr-flex spr-h-full spr-items-center spr-justify-center spr-p-size-spacing-xs"
                    }, [
                      r.infiniteLoading ? (f(), C("div", vd, [
                        R(o(W), {
                          icon: "svg-spinners:ring-resize",
                          class: "spr-text-color-success-base spr-font-size-400"
                        })
                      ])) : (f(), C("div", md, G(r.loadingTextCompleted), 1))
                    ], 8, Cd)
                  ])) : _("", !0)
                ], 512)) : _("", !0),
                w.employees.length === 0 && w.loading ? (f(), C("tbody", Md, [
                  (f(), C(X, null, le(10, ($) => A("tr", { key: $ }, [
                    A("td", {
                      class: x([
                        o(i).borderClasses,
                        "spr-bg-white spr-sticky spr-left-0 spr-z-10 spr-content-start spr-border-y spr-border-l-0 spr-border-r spr-border-t-0 spr-p-size-spacing-xs"
                      ])
                    }, [
                      A("div", bd, [
                        R(Et, {
                          size: "md",
                          variant: "initial",
                          color: "tertiary",
                          loading: ""
                        }),
                        E[5] || (E[5] = A("div", {
                          class: x([{ "spr-skeletal-loader spr-h-6 spr-rounded-md": !0 }])
                        }, null, -1)),
                        E[6] || (E[6] = A("div", {
                          class: x([{ "spr-skeletal-loader spr-h-6 spr-rounded-md": !0 }])
                        }, null, -1))
                      ]),
                      A("div", Nd, [
                        R(P2, { loading: "" })
                      ])
                    ], 2),
                    (f(), C(X, null, le(7, (D) => A("td", {
                      key: D,
                      class: x([
                        o(i).borderClasses,
                        "spr-min-w-[180px] spr-content-start spr-space-y-size-spacing-3xs spr-border-x spr-border-b spr-border-t-0 spr-p-size-spacing-sm last:spr-mb-size-spacing-lg last:spr-border-r-0"
                      ])
                    }, [
                      A("section", $d, [
                        (f(), C(X, null, le(1, (z) => A("div", {
                          key: z,
                          class: "spr-w-full"
                        }, [
                          A("div", Dd, [
                            R(Ht, {
                              type: "restday",
                              fullwidth: "",
                              loading: ""
                            })
                          ])
                        ])), 64))
                      ])
                    ], 2)), 64))
                  ])), 64))
                ])) : (f(), C("tbody", Id, [
                  w.loading ? _("", !0) : (f(), C("tr", Ad, [
                    A("td", {
                      colspan: o(s).length + 1,
                      class: "spr-flex spr-h-full spr-items-center spr-justify-center"
                    }, [
                      ee(w.$slots, "empty-state", {}, () => [
                        R(ar, {
                          size: "large",
                          description: w.emptyStateTitle,
                          "sub-description": w.emptyStateDescription
                        }, Pt({ _: 2 }, [
                          w.emptyStateButtonText ? {
                            name: "button",
                            fn: H(() => [
                              R(be, { tone: "success" }, {
                                default: H(() => [
                                  R(o(W), {
                                    icon: "ph:plus",
                                    onClick: E[1] || (E[1] = ($) => w.$emit("onClickEmptyButton"))
                                  }),
                                  Oe(G(w.emptyStateButtonText), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            key: "0"
                          } : void 0
                        ]), 1032, ["description", "sub-description"])
                      ])
                    ], 8, xd)
                  ]))
                ]))
              ], 2)
            ])
          ])
        ], 2)
      ]),
      _: 3
    }));
  }
}), Sd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wd
}, Symbol.toStringTag, { value: "Module" })), jd = ["lg", "md", "sm"], Td = ["regular", "bold", "thin", "light", "fill", "duotone"], Od = ["tag", "day"], _d = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], zd = {
  label: {
    type: String,
    default: ""
  },
  size: {
    type: String,
    validator: (e) => jd.includes(e),
    default: "md"
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  active: {
    type: Boolean,
    default: !1
  },
  closable: {
    type: Boolean,
    default: !1
  },
  avatarUrl: {
    type: String,
    default: ""
  },
  avatarVariant: {
    type: String,
    default: ""
  },
  avatarInitials: {
    type: String,
    default: ""
  },
  icon: {
    type: String,
    default: ""
  },
  iconWeight: {
    type: String,
    validator: (e) => Td.includes(e),
    default: "regular"
  },
  closeIconSize: {
    type: Number,
    default: 16
  },
  badge: {
    type: Boolean,
    default: !1
  },
  badgeText: {
    type: String,
    default: "0"
  },
  badgeVariant: {
    type: String,
    default: "brand"
  },
  removable: {
    type: Boolean,
    default: !1
  },
  visible: {
    type: Boolean,
    default: !0
  },
  variant: {
    type: String,
    validator: (e) => Od.includes(e),
    default: "tag"
  },
  day: {
    type: String,
    default: "Sunday",
    validator: (e) => _d.includes(e)
  }
}, Ld = {
  close: (e) => e instanceof MouseEvent || e instanceof KeyboardEvent,
  update: (e) => typeof e == "boolean"
}, kd = (e, t, r) => {
  const { disabled: n, active: s, variant: a, iconWeight: i, icon: l } = ye(e), u = F(() => a.value === "day" ? L(
    "spr-background-color spr-label-xs-medium spr-inline-flex spr-items-center spr-justify-center spr-rounded-full spr-transition-all spr-aspect-square spr-h-10 spr-w-10 spr-body-sm-regular spr-border spr-border-solid",
    {
      // Base cursor state
      "hover:spr-cursor-pointer": !n.value,
      // Disabled state (highest priority)
      "spr-cursor-not-allowed spr-text-color-on-fill-disabled spr-background-color-disabled spr-border-color-disabled": n.value,
      // Active and enabled state
      "spr-text-color-strong spr-background-color-brand-base spr-text-color-inverted-strong spr-border-color-brand-base": s.value && !n.value,
      // Default state (with hover/pressed)
      "spr-text-color-strong spr-border-color-weak hover:spr-background-color-hover active:spr-background-color-pressed": !s.value && !n.value
    }
  ) : L(
    "spr-body-xs-regular spr-py-1.5 spr-px-2 spr-text-color-strong spr-inline-flex spr-items-center spr-justify-center spr-gap-1 spr-rounded-full spr-transition-all spr-group",
    {
      // Base cursor state
      "hover:spr-cursor-pointer": !n.value,
      // Disabled state (highest priority)
      "spr-cursor-not-allowed spr-text-color-on-fill-disabled spr-background-color-disabled spr-border-solid spr-border-[1px] spr-border-color-disabled": n.value,
      // Active and enabled state
      "spr-background-color-brand-weak spr-border-solid spr-border-[1px] spr-border-color-brand-base": s.value && !n.value,
      // Default state (with hover/pressed)
      "spr-background-color-surface spr-border spr-border-solid spr-border-color-weak group-hover:spr-background-color-hover group-active:spr-background-color-pressed": !s.value && !n.value,
      // Reset close button styles
      "[&_.chips-close]:hover:spr-cursor-pointer [&_.chips-close]:spr-p-0 [&_.chips-close]:spr-m-0 [&_.chips-close]:spr-border-0 [&_.chips-close]:spr-bg-transparent [&_.chips-close]:spr-inline-flex [&_.chips-close]:spr-items-center [&_.chips-close]:spr-leading-[0]": !0
    }
  )), d = () => {
    n.value || t("update", !s.value);
  }, c = (M) => {
    n.value || t("close", M);
  }, p = F(() => i.value === "regular" ? l.value : `${l.value}-${i.value}`), h = F(() => e.avatarUrl || e.avatarVariant || e.avatarInitials), y = F(() => e.icon || r.icon);
  return {
    chipsBaseClasses: u,
    handleClose: c,
    handleClick: d,
    getIcon: p,
    hasAvatar: h,
    hasIcon: y
  };
}, Ed = ["disabled"], Pd = {
  key: 0,
  class: "chips-icon spr-inline-flex spr-items-center spr-leading-[0]"
}, Yd = {
  key: 1,
  class: "spr-flex spr-items-center spr-justify-center"
}, Ud = { class: "spr-chips-label" }, Fd = {
  key: 2,
  class: "chips-badge"
}, Bd = ["aria-disabled"], _t = /* @__PURE__ */ ae({
  __name: "chips",
  props: zd,
  emits: Ld,
  setup(e, { emit: t }) {
    const r = e, n = t, s = It(), { chipsBaseClasses: a, handleClose: i, handleClick: l, getIcon: u, hasAvatar: d, hasIcon: c } = kd(r, n, s);
    return (p, h) => p.visible ? (f(), C("div", {
      key: 0,
      class: x(o(a)),
      disabled: p.disabled,
      role: "button",
      tabindex: "0",
      onClick: h[2] || (h[2] = //@ts-ignore
      (...y) => o(l) && o(l)(...y)),
      onKeyup: h[3] || (h[3] = m0(
        //@ts-ignore
        (...y) => o(l) && o(l)(...y),
        ["enter"]
      ))
    }, [
      p.variant === "tag" ? (f(), C(X, { key: 0 }, [
        o(c) ? (f(), C("span", Pd, [
          ee(p.$slots, "icon", {}, () => [
            R(o(W), {
              icon: o(u),
              class: "spr-font-size-300"
            }, null, 8, ["icon"])
          ])
        ])) : _("", !0),
        o(d) ? (f(), C("span", Yd, [
          R(Et, {
            size: "2xs",
            src: r.avatarUrl,
            variant: r.avatarVariant,
            initial: r.avatarInitials
          }, null, 8, ["src", "variant", "initial"])
        ])) : _("", !0),
        A("span", Ud, G(p.label), 1),
        p.badge ? (f(), C("span", Fd, [
          R(bt, {
            text: p.badgeText,
            variant: p.badgeVariant,
            size: "small",
            position: "default"
          }, null, 8, ["text", "variant"])
        ])) : _("", !0),
        p.closable ? (f(), C("span", {
          key: 3,
          class: "chips-close",
          role: "button",
          tabindex: "0",
          "aria-disabled": p.disabled,
          onClick: h[0] || (h[0] = Mt(
            //@ts-ignore
            (...y) => o(i) && o(i)(...y),
            ["stop"]
          )),
          onKeyup: h[1] || (h[1] = m0(Mt(
            //@ts-ignore
            (...y) => o(i) && o(i)(...y),
            ["stop"]
          ), ["enter"]))
        }, [
          ee(p.$slots, "close-icon", {}, () => [
            R(o(W), { icon: "ph:x" })
          ])
        ], 40, Bd)) : _("", !0)
      ], 64)) : (f(), C(X, { key: 1 }, [
        Oe(G(p.day.charAt(0)), 1)
      ], 64))
    ], 42, Ed)) : _("", !0);
  }
}), Rd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _t
}, Symbol.toStringTag, { value: "Module" })), Vd = ["su", "mo", "tu", "we", "th", "fr", "sa"], Qd = ["fixed", "absolute"], Hd = [
  "auto",
  "auto-start",
  "auto-end",
  "top",
  "top-start",
  "top-end",
  "right",
  "right-start",
  "right-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "left",
  "left-start",
  "left-end"
], Zd = {
  id: {
    type: String,
    required: !0,
    default: "date-picker"
  },
  modelValue: {
    type: String,
    default: "",
    required: !0
  },
  label: {
    type: String,
    default: ""
  },
  active: {
    type: Boolean,
    default: !1
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  error: {
    type: Boolean,
    default: !1
  },
  currentYear: {
    type: String,
    default: (/* @__PURE__ */ new Date()).getFullYear().toString()
  },
  minMaxYear: {
    type: Object,
    default: () => ({
      min: 1900,
      max: (/* @__PURE__ */ new Date()).getFullYear()
    })
  },
  restDays: {
    type: Array,
    validator: (e) => e.every((t) => Vd.includes(t)),
    default: []
  },
  disabledDates: {
    type: Object
  },
  displayHelper: {
    type: Boolean,
    default: !1
  },
  helperText: {
    type: String,
    default: ""
  },
  helperIcon: {
    type: String,
    default: null
  },
  width: {
    type: String,
    default: "100%"
  },
  popperStrategy: {
    type: String,
    validator: (e) => Qd.includes(e),
    default: "absolute"
  },
  placement: {
    type: String,
    validator: (e) => Hd.includes(e),
    default: "bottom"
  },
  format: {
    type: String,
    default: "MM-DD-YYYY",
    description: "Format for the selected date. For example: MM/DD/YYYY, YYYY-MM-DD, etc."
  }
}, Gd = {
  "update:modelValue": (e) => typeof e == "string",
  getInputValue: (e) => e === null || typeof e == "string",
  getDateFormats: (e) => typeof e == "object" && e !== null && !Array.isArray(e) && Object.keys(e).every((t) => typeof e[t] == "string"),
  getMonthList: (e) => Array.isArray(e),
  getYearList: (e) => Array.isArray(e),
  getDateErrors: (e) => Array.isArray(e) && e.every(
    (t) => t !== null && typeof t == "object" && typeof t.title == "string" && typeof t.message == "string"
  )
};
var I2 = { exports: {} }, Wd = I2.exports, tn;
function Kd() {
  return tn || (tn = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Wd, function() {
      return function(r, n) {
        n.prototype.isSameOrBefore = function(s, a) {
          return this.isSame(s, a) || this.isBefore(s, a);
        };
      };
    });
  }(I2)), I2.exports;
}
var Jd = Kd();
const Xd = /* @__PURE__ */ c2(Jd);
var A2 = { exports: {} }, qd = A2.exports, rn;
function e3() {
  return rn || (rn = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(qd, function() {
      return function(r, n) {
        n.prototype.isSameOrAfter = function(s, a) {
          return this.isSame(s, a) || this.isAfter(s, a);
        };
      };
    });
  }(A2)), A2.exports;
}
var t3 = e3();
const r3 = /* @__PURE__ */ c2(t3);
ue.extend(Xd);
ue.extend(r3);
const n3 = (e, t) => {
  const { active: r, disabled: n, readonly: s, error: a, currentYear: i, minMaxYear: l, restDays: u, disabledDates: d, format: c } = ye(e), p = Ie(e, "modelValue", t), h = F(() => {
    const Q = L("spr-body-sm-regular spr-text-color-strong spr-block", {
      "spr-text-color-on-fill-disabled": n.value
    }), q = L(
      "spr-flex spr-justify-between spr-items-center spr-gap-6 spr-rounded-lg spr-bg-white-50 spr-min-w-[180px] spr-py-1.5 spr-px-3",
      {
        // Normal State
        "spr-border spr-border-solid spr-border-mushroom-200 focus:spr-border-kangkong-700": !a.value && !n.value && !r.value && !m.value || s.value,
        // Active State
        "spr-border spr-border-solid spr-border-kangkong-700 spr-border-[1.5px] spr-border-solid": (r.value || m.value === !0) && !s.value,
        // Error State
        "spr-border spr-border-solid spr-border-tomato-600 focus:spr-border-tomato-600": a.value,
        // Disabled State
        "spr-background-color-disabled spr-border-white-100 focus:spr-border-white-100 spr-cursor-not-allowed !spr-text-white-400": n.value,
        // Readonly State
        "spr-cursor-default": s.value
      }
    ), re = L(
      "spr-h-full spr-border-none spr-bg-transparent spr-outline-none",
      "spr-font-size-200",
      "placeholder:spr-text-color-weak",
      {
        "spr-text-color-strong": !n.value && !s.value,
        "spr-text-color-on-fill-disabled": n.value || s.value,
        "spr-cursor-not-allowed": n.value
      }
    ), pe = L(
      "spr-body-sm-regular",
      "spr-flex spr-items-center spr-gap-size-spacing-5xs",
      "spr-mt-size-spacing-4xs",
      {
        "spr-text-color-danger-base": a.value,
        "spr-text-color-supporting": !a.value
      }
    ), Ae = L(
      "spr-relative spr-box-border spr-flex spr-h-[40px] spr-items-center spr-justify-center spr-p-2",
      "spr-transition spr-duration-150 spr-ease-in-out"
    ), je = L(
      "spr-subheading-xs spr-relative spr-flex spr-cursor-pointer spr-items-center spr-justify-center spr-rounded-lg spr-p-4",
      "spr-border spr-border-solid",
      "spr-transition spr-duration-150 spr-ease-in-out",
      "active:spr-scale-95"
    ), _e = L(
      "spr-subheading-xs spr-relative spr-flex spr-cursor-pointer spr-items-center spr-justify-center spr-rounded-lg spr-p-4",
      "spr-border spr-border-solid",
      "spr-transition spr-duration-150 spr-ease-in-out",
      "active:spr-scale-95"
    );
    return {
      labelClasses: Q,
      datePickerBaseInputClasses: q,
      datePickerInputClasses: re,
      datePickerInputHelperClasses: pe,
      calendarTabItemsBaseClasses: Ae,
      monthsTabItemsBaseClasses: je,
      yearsTabItemsBaseClasses: _e
    };
  }), y = B(null), M = B(null), g = B(null), v = B(null), m = B(!1), I = B("tab-calendar"), N = B(ue()), w = B(
    Array.from({ length: 7 }, (Q, q) => ({
      text: ue().day(q).format("dd"),
      fullText: ue().day(q).format("dddd"),
      dayValue: q
    }))
  ), E = B(
    Array.from({ length: 12 }, (Q, q) => ({
      text: ue().month(q).format("MMM"),
      fullText: ue().month(q).format("MMMM"),
      monthValue: q
    }))
  ), $ = B(""), D = B(""), z = B(""), k = B([]), b = B({
    selectedMonth: ue().month(),
    selectedYear: Number(i.value),
    calendarDays: []
  }), P = F(
    () => ue().year(b.value.selectedYear).month(b.value.selectedMonth).isSame(ue().year(l.value.min).month(0), "month")
  ), V = F(
    () => ue().year(b.value.selectedYear).month(b.value.selectedMonth).isSame(ue().year(l.value.max).month(11), "month")
  ), Z = () => {
    const Q = ue().year(b.value.selectedYear).month(b.value.selectedMonth).startOf("month").day(), q = ue().year(b.value.selectedYear).month(b.value.selectedMonth).endOf("month").date(), re = Q, pe = re + q, Ae = pe % 7 === 0 ? 0 : 7 - pe % 7, je = [];
    for (let _e = re; _e > 0; _e--) {
      const Bt = ue().year(b.value.selectedYear).month(b.value.selectedMonth).date(-_e + 1);
      je.push({ date: Bt, inactive: !0 });
    }
    for (let _e = 1; _e <= q; _e++) {
      const Bt = ue().year(b.value.selectedYear).month(b.value.selectedMonth).date(_e);
      je.push({ date: Bt, inactive: !1 });
    }
    for (let _e = 1; _e <= Ae; _e++) {
      const Bt = ue().year(b.value.selectedYear).month(b.value.selectedMonth + 1).date(_e);
      je.push({ date: Bt, inactive: !0 });
    }
    b.value.calendarDays = je.map((_e) => ({ ..._e, date: _e.date.toDate() }));
  }, j = () => {
    if (P.value) return;
    const Q = ue().year(b.value.selectedYear).month(b.value.selectedMonth).subtract(1, "month");
    b.value.selectedMonth = Q.month(), b.value.selectedYear = Q.year(), Z();
  }, T = () => {
    if (V.value) return;
    const Q = ue().year(b.value.selectedYear).month(b.value.selectedMonth).add(1, "month");
    b.value.selectedMonth = Q.month(), b.value.selectedYear = Q.year(), Z();
  }, O = (Q) => {
    const q = u.value.map((re) => {
      var pe;
      return (pe = w.value.find((Ae) => Ae.text.toLowerCase() === re.toLowerCase())) == null ? void 0 : pe.dayValue;
    });
    return J(Q) ? !1 : !!q.includes(Q.date.getDay());
  }, S = (Q) => Q.date.toDateString() === N.value.format("ddd MMM DD YYYY"), Y = (Q) => !Q.inactive && !de(Q), U = (Q) => !!(Q.inactive && !de(Q)), J = (Q) => {
    var re;
    const q = (re = p2("text", $.value)) == null ? void 0 : re.monthValue;
    return D.value && !$.value && !z.value && !de(Q) ? Q.date.getDate() === Number(D.value) && !Q.inactive : D.value && $ && !z.value && !de(Q) ? Q.date.getDate() === Number(D.value) && Q.date.getMonth() === q && !Q.inactive : D.value && $.value && z.value && !de(Q) ? Q.date.getDate() === Number(D.value) && Q.date.getMonth() === q && Q.date.getFullYear().toString() === z.value && !Q.inactive : !1;
  }, oe = (Q) => {
    var re;
    const q = (re = p2("text", $.value)) == null ? void 0 : re.monthValue;
    return D.value && !$.value && !de(Q) ? Q.date.getDate() !== Number(D.value) : D.value && $ && !de(Q) ? Q.date.getDate() !== Number(D.value) || Q.date.getMonth() !== q : !!(!D.value && $.value && !de(Q) || !D.value && !$.value && !de(Q));
  }, de = (Q) => !!(Me(Q) || se(Q) || ie(Q) || Ce(Q) || ge(Q) || ve(Q) || Ne(Q)), Me = (Q) => {
    if (d != null && d.value && d.value.from && d.value.to) {
      const q = ue(d.value.from, "MM-DD-YYYY").startOf("day"), re = ue(d.value.to, "MM-DD-YYYY").endOf("day"), pe = ue(Q.date);
      return pe.isSameOrAfter(q, "day") && pe.isSameOrBefore(re, "day");
    }
    return !1;
  }, se = (Q) => {
    if (d != null && d.value && (d != null && d.value.pastDates)) {
      const q = ue(Q.date);
      if (typeof d.value.pastDates == "boolean")
        return q.isBefore(N.value.startOf("day"));
      {
        const re = ue(d.value.pastDates);
        return q.isBefore(ue(re, "MM-DD-YYYY").startOf("day"));
      }
    }
    return !1;
  }, ie = (Q) => {
    if (d != null && d.value && (d != null && d.value.futureDates)) {
      const q = ue(Q.date);
      if (typeof d.value.futureDates == "boolean")
        return q.isAfter(N.value.endOf("day"));
      {
        const re = ue(d.value.futureDates);
        return q.isAfter(ue(re, "MM-DD-YYYY").endOf("day"));
      }
    }
    return !1;
  }, Ce = (Q) => {
    if (d != null && d.value && (d != null && d.value.selectedDates) && d.value.selectedDates.length > 0) {
      const q = ue(Q.date);
      return d.value.selectedDates.forEach((re) => {
        ue(re).isValid() || console.error(`Error: disabledDates Props - Selected Dates - Invalid date format: "${re}"`);
      }), d.value.selectedDates.some((re) => q.isSame(ue(re, "MM-DD-YYYY"), "day"));
    }
    return !1;
  }, ge = (Q) => {
    if (d != null && d.value && (d != null && d.value.weekends)) {
      const q = ue(Q.date);
      return q.day() === 0 || q.day() === 6;
    }
    return !1;
  }, ve = (Q) => {
    if (d != null && d.value && (d != null && d.value.weekdays)) {
      const q = ue(Q.date);
      return q.day() > 0 && q.day() < 6;
    }
    return !1;
  }, Ne = (Q) => {
    if (d != null && d.value && (d != null && d.value.selectedDays)) {
      const q = ue(Q.date);
      return d.value.selectedDays.some((re) => {
        const pe = w.value.find((Ae) => Ae.text.toLowerCase() === re.toLowerCase());
        return pe || console.error(`Error: disabledDates Props - Selected Days - Invalid day: "${re}"`), pe ? q.day() === w.value.indexOf(pe) : !1;
      });
    }
    return !1;
  }, me = (Q) => {
    const q = ue(Q.date), re = q.format("MM"), pe = q.format("DD"), Ae = q.format("YYYY");
    $.value = re, D.value = pe, z.value = Ae, p.value = q.format(c.value), b.value.selectedMonth = Q.date.getMonth(), b.value.selectedYear = Q.date.getFullYear(), Ut(), Z(), Ft(), g2(), k.value = [], t("getDateErrors", k.value), setTimeout(() => {
      m.value = !1;
    }, 100);
  }, Se = (Q) => {
    I.value = "tab-calendar";
    const q = Q.monthValue + 1, re = q < 10 ? `0${q}` : `${q}`;
    $.value = re, b.value.selectedMonth = Q.monthValue, Ut(), Z(), Ft(), k.value = [], t("getDateErrors", k.value);
  }, ne = B({
    currentPage: 0,
    itemsPerPage: 12,
    yearsArray: Array.from(
      { length: l.value.max - l.value.min + 1 },
      (Q, q) => l.value.min + q
    ).filter((Q) => Q <= l.value.max && Q >= l.value.min)
  }), te = F(() => {
    const Q = ne.value.currentPage * ne.value.itemsPerPage, q = ne.value.yearsArray.slice(Q);
    return q.length < ne.value.itemsPerPage ? q : ne.value.yearsArray.slice(Q, Q + ne.value.itemsPerPage);
  }), Re = () => {
    const Q = ne.value.yearsArray.indexOf(b.value.selectedYear);
    Q !== -1 && (ne.value.currentPage = Math.floor(Q / ne.value.itemsPerPage));
  }, o0 = () => {
    ne.value.currentPage > 0 && ne.value.currentPage--;
  }, aa = () => {
    (ne.value.currentPage + 1) * ne.value.itemsPerPage < ne.value.yearsArray.length && ne.value.currentPage++;
  }, oa = F(() => ne.value.currentPage === 0), ia = F(() => (ne.value.currentPage + 1) * ne.value.itemsPerPage >= ne.value.yearsArray.length), la = (Q) => {
    I.value = "tab-calendar", z.value = Q, b.value.selectedYear = Number(Q), Ut(), Z(), Ft(), k.value = [], t("getDateErrors", k.value);
  }, ua = F(() => n.value || s.value), vr = (Q) => {
    var q, re;
    switch (Q) {
      case "MinMaxYear": {
        const pe = Number(i.value) || (/* @__PURE__ */ new Date()).getFullYear(), { min: Ae, max: je } = l.value;
        (Ae > pe || je < pe) && console.error(
          `Error: minMaxYear Props - The current year (${pe}) is outside of the valid range. min: ${Ae}, max: ${je}.`
        );
        break;
      }
      case "disabledDatesToFrom": {
        if ((q = d == null ? void 0 : d.value) != null && q.from && ((re = d == null ? void 0 : d.value) != null && re.to)) {
          const pe = ue(d.value.from, "MM-DD-YYYY"), Ae = ue(d.value.to, "MM-DD-YYYY");
          pe.isAfter(Ae) && console.error('Error: disabledDates props - The "from" date cannot be later than the "to" date.'), Ae.isBefore(pe) && console.error('Error: disabledDates props - The "to" date cannot be earlier than the "from" date.');
        }
        break;
      }
    }
  }, mr = () => {
    if (p.value) {
      let Q = ue(p.value, c.value);
      if (Q.isValid() || (Q = ue(p.value, "MM-DD-YYYY")), !Q.isValid()) {
        const q = ["YYYY-MM-DD", "MM/DD/YYYY", "DD/MM/YYYY", "YYYY/MM/DD"];
        for (const re of q) {
          const pe = ue(p.value, re);
          if (pe.isValid()) {
            Q = pe;
            break;
          }
        }
      }
      if (Q.isValid()) {
        const q = Q.format("MM"), re = Q.format("DD"), pe = Q.format("YYYY");
        f2(), $.value = q, D.value = re, z.value = pe, p.value = Q.format(c.value), b.value.selectedMonth = Q.get("month"), b.value.selectedYear = Q.get("year"), Ut(), Z(), Ft(), !$.value && !D.value && !z.value ? t("getInputValue", null) : t("getInputValue", Q.format(c.value));
      } else
        console.error(`Error: Could not parse date "${p.value}" with format "${c.value}"`);
    }
  }, p2 = (Q, q) => E.value.find(
    (re) => re[Q].toString().toLowerCase() === q.toString().toLowerCase()
  ), da = (Q) => L(h.value.datePickerInputClasses, `spr-w-[${Q}] spr-min-w-[${Q}]`), ca = (Q) => L("spr-cursor-pointer", {
    "spr-background-color-pressed !spr-shadow-button": I.value === Q
  }), pa = () => {
    m.value = !1, $.value = $.value.replace(/[^A-Za-z0-9\s]/g, "").toLocaleUpperCase(), k.value = [], t("getDateErrors", k.value), Ut(), f2(), !$.value && !D.value && !z.value && t("getInputValue", null), $.value && D.value && z.value && g2();
  }, fa = () => {
    m.value = !1, D.value = D.value.replace(/[^0-9]/g, ""), k.value = [], t("getDateErrors", k.value), f2(), !$.value && !D.value && !z.value && t("getInputValue", null), $.value && D.value && z.value && g2();
  }, ga = () => {
    m.value = !1, z.value = z.value.replace(/[^0-9]/g, ""), k.value = [], t("getDateErrors", k.value), z.value.length === 4 && (f2(), !$.value && !D.value && !z.value && t("getInputValue", null), $.value && D.value && z.value && g2());
  }, Ut = () => {
    if ($.value.length >= 2)
      if (!isNaN(Number($.value)) && !isNaN(parseFloat($.value))) {
        const q = $.value.replace(/\b0(\d)\b/g, "$1"), re = Number(q), pe = E.value.find((Ae) => Ae.monthValue + 1 === re);
        pe && ($.value = pe.text.toUpperCase());
      } else {
        const q = E.value.find(
          (re) => re.text.toLowerCase() === $.value.toLowerCase()
        );
        q && ($.value = q.text.toUpperCase());
      }
  }, f2 = W2(() => {
    var Q;
    if ($.value && D.value && z.value) {
      const q = `${$.value}-${D.value}-${z.value}`, re = ue(q, "MM-DD-YYYY").isValid(), pe = Number(z.value) >= l.value.min && Number(z.value) <= l.value.max;
      if (re && pe) {
        k.value = k.value.filter((je) => je.title !== "Invalid Date");
        const Ae = (Q = p2("text", $.value)) == null ? void 0 : Q.monthValue;
        b.value.selectedMonth = Number(Ae), b.value.selectedYear = Number(z.value), Z(), Ft();
      } else if (!k.value.some((je) => je.title === "Invalid Date")) {
        let je;
        pe ? je = `Invalid Date Format. Please use ${c.value}` : je = `Year must be between ${l.value.min} and ${l.value.max}.`, k.value.push({
          title: "Invalid Date",
          message: je
        }), m.value = !1, t("getDateErrors", k.value), console.error(`Invalid Date: "${q}". ${je}`);
      }
    }
  }, 500), ha = (Q) => {
    I.value === Q ? I.value = "tab-calendar" : I.value = Q;
  }, ya = (Q, q) => {
    q && q instanceof KeyboardEvent && q.key === "Backspace" && (Q === "date" && D.value === "" && Je(() => {
      M.value && M.value.focus();
    }), Q === "year" && z.value === "" && Je(() => {
      g.value && g.value.focus();
    }));
  }, Ft = () => {
    if ($.value && D.value && z.value) {
      const Q = E.value.find(
        (re) => re.text.toLowerCase() === $.value.toLowerCase()
      ), q = ne.value.yearsArray.find((re) => re === Number(z.value));
      if (Q && q) {
        const re = ue(`${$.value}-${D.value}-${z.value}`, "MM-DD-YYYY"), pe = {
          // Standard date formats
          mmddyyyy: re.format("MM-DD-YYYY"),
          ddmmyyyy: re.format("DD-MM-YYYY"),
          yyyymmdd: re.format("YYYY-MM-DD"),
          yyyyMMdd: re.format("YYYY-MM-DD"),
          // Date with slashes and shortened styles
          mmddyyyyWithSlashes: re.format("MM/DD/YYYY"),
          yyyyMMddWithSlashes: re.format("YYYY/MM/DD"),
          // Short date formats
          shortDate: re.format("MMM D, YYYY"),
          shortDateWithPeriod: re.format("MMM. D, YYYY"),
          mmmdd: re.format("MMM. DD"),
          // Full date format
          fullDate: re.format("dddd, MMMM D, YYYY"),
          // Month and year formats
          monthYear: re.format("MMMM YYYY"),
          // Miscellaneous formats
          mmddyy: re.format("MMDDYY"),
          mm: re.format("MM"),
          yyyy: re.format("YYYY"),
          dd: re.format("DD"),
          // ISO format with timezone offset
          isoDateWithTimeZone: re.format("YYYY-MM-DDTHH:mm:ssZ"),
          // ISO format without timezone offset
          isoDateWithoutTimeZone: re.format("YYYY-MM-DDTHH:mm:ss")
        };
        t("getDateFormats", pe);
      }
    }
  }, g2 = () => {
    let Q = $.value;
    if (!(!isNaN(Number($.value)) && !isNaN(parseFloat($.value)))) {
      const pe = E.value.find(
        (Ae) => Ae.text.toLowerCase() === $.value.toLowerCase()
      );
      pe && (Q = pe.monthValue < 10 ? `0${pe.monthValue + 1}` : `${pe.monthValue + 1}`);
    }
    const re = ue(`${Q}-${D.value}-${z.value}`, "MM-DD-YYYY");
    t("getInputValue", p.value = re.format(c.value));
  }, Ca = () => {
    t("getMonthList", E.value);
  }, va = () => {
    t("getYearList", ne.value.yearsArray);
  }, ma = () => {
    $.value = "", D.value = "", z.value = "";
  };
  return ce(m, (Q) => {
    Q === !1 && setTimeout(() => {
      I.value = "tab-calendar", Re();
    }, 500);
  }), ce(z, (Q) => {
    if (Q) {
      const q = parseInt(Q, 10);
      if (isNaN(q)) return;
      const re = ne.value.yearsArray.indexOf(q);
      if (re !== -1) {
        const pe = Math.floor(re / ne.value.itemsPerPage);
        ne.value.currentPage = pe;
      }
    }
  }), ce(l, () => {
    ne.value.yearsArray = Array.from(
      { length: l.value.max - l.value.min + 1 },
      (Q, q) => l.value.min + q
    ).filter((Q) => Q <= l.value.max && Q >= l.value.min), ne.value.currentPage = 0;
  }), Yt(y, () => {
    m.value = !1;
  }), Be(() => {
    vr("MinMaxYear"), vr("disabledDatesToFrom"), mr(), Z(), Re(), Ca(), va();
  }), ce(p, () => {
    mr();
  }), {
    datePickerClasses: h,
    datePickerRef: y,
    monthInputRef: M,
    dateInputRef: g,
    yearInputRef: v,
    datePopperState: m,
    currentTab: I,
    currentDate: N,
    daysOfWeek: w,
    monthsList: E,
    dateInput: D,
    monthInput: $,
    yearInput: z,
    datePickerErrors: k,
    calendarTabPageData: b,
    calendarTabIsMinMonth: P,
    calendarTabIsMaxMonth: V,
    calendarTabPrevMonth: j,
    calendarTabNextMonth: T,
    calendarTabIsRestDay: O,
    calendarTabIsTodayIndicator: S,
    calendarTabIsActiveMonthDates: Y,
    calendarTabIsInactiveMonthDates: U,
    calendarTabIsSelectedDate: J,
    calendarTabIsUnSelectedDate: oe,
    calendarTabIsDateIsDisabled: de,
    calendarTabHandleDateInput: me,
    monthTabHandleSelectedMonth: Se,
    yearTabCurrentYearPage: te,
    yearTabGoToPreviousPage: o0,
    yearTabGoToNextPage: aa,
    yearTabIsPreviousButtonDisabled: oa,
    yearTabIsNextButtonDisabled: ia,
    yearTabHandleSelectedYear: la,
    isDatePickerPopperDisabled: ua,
    getMonthObject: p2,
    getDatePickerInputClasses: da,
    getTabClasses: ca,
    handleMonthInput: pa,
    handleDateInput: fa,
    handleYearInput: ga,
    handleTabClick: ha,
    handleBackspace: ya,
    clearDate: ma
  };
}, s3 = ["id"], a3 = ["for"], o3 = { class: "spr-flex spr-h-full spr-items-center spr-gap-1.5" }, i3 = ["id", "disabled", "readonly"], l3 = ["id", "disabled", "readonly"], u3 = ["id", "disabled", "readonly"], d3 = { class: "spr-flex spr-items-center spr-justify-center" }, c3 = {
  class: /* @__PURE__ */ x([
    "spr-flex spr-justify-between spr-gap-2 spr-px-4 spr-py-3",
    "spr-border spr-border-x-0 spr-border-b spr-border-t-0 spr-border-solid spr-border-mushroom-200"
  ])
}, p3 = { class: "spr-flex spr-gap-1" }, f3 = {
  key: 0,
  class: "spr-flex spr-gap-1"
}, g3 = {
  key: 1,
  class: "spr-flex spr-gap-1"
}, h3 = { class: "spr-px-4 spr-pb-4 spr-pt-2" }, y3 = {
  key: 0,
  class: "spr-grid spr-grid-cols-7"
}, C3 = ["onClick"], v3 = {
  key: 0,
  class: "spr-background-color-brand-base spr-absolute spr-bottom-1 spr-m-auto spr-h-1 spr-w-1 spr-rounded-full"
}, m3 = { key: 1 }, M3 = {
  key: 1,
  class: "spr-grid spr-grid-cols-4 spr-gap-2"
}, b3 = ["onClick"], N3 = {
  key: 0,
  class: "spr-background-color-brand-base spr-absolute spr-bottom-2 spr-m-auto spr-h-1 spr-w-1 spr-rounded-full"
}, $3 = {
  key: 2,
  class: "spr-grid spr-grid-cols-4 spr-gap-2"
}, D3 = ["onClick"], I3 = {
  key: 0,
  class: "spr-background-color-brand-base spr-absolute spr-bottom-2 spr-m-auto spr-h-1 spr-w-1 spr-rounded-full"
}, A3 = /* @__PURE__ */ ae({
  __name: "date-picker",
  props: Zd,
  emits: Gd,
  setup(e, { expose: t, emit: r }) {
    const n = e, s = r, {
      datePickerClasses: a,
      datePickerRef: i,
      monthInputRef: l,
      dateInputRef: u,
      yearInputRef: d,
      datePopperState: c,
      currentTab: p,
      currentDate: h,
      daysOfWeek: y,
      dateInput: M,
      monthsList: g,
      monthInput: v,
      yearInput: m,
      calendarTabPageData: I,
      calendarTabIsMinMonth: N,
      calendarTabIsMaxMonth: w,
      calendarTabIsRestDay: E,
      calendarTabIsTodayIndicator: $,
      calendarTabIsActiveMonthDates: D,
      calendarTabIsInactiveMonthDates: z,
      calendarTabIsSelectedDate: k,
      calendarTabIsUnSelectedDate: b,
      calendarTabIsDateIsDisabled: P,
      calendarTabHandleDateInput: V,
      getMonthObject: Z,
      getTabClasses: j,
      isDatePickerPopperDisabled: T,
      calendarTabPrevMonth: O,
      calendarTabNextMonth: S,
      monthTabHandleSelectedMonth: Y,
      yearTabCurrentYearPage: U,
      yearTabGoToPreviousPage: J,
      yearTabGoToNextPage: oe,
      yearTabIsPreviousButtonDisabled: de,
      yearTabIsNextButtonDisabled: Me,
      yearTabHandleSelectedYear: se,
      handleMonthInput: ie,
      handleDateInput: Ce,
      handleYearInput: ge,
      handleTabClick: ve,
      handleBackspace: Ne,
      clearDate: me
    } = n3(n, s);
    return t({
      clear: () => me()
    }), (Se, ne) => (f(), C("div", null, [
      R(o(we), {
        shown: o(c),
        "onUpdate:shown": ne[15] || (ne[15] = (te) => fe(c) ? c.value = te : null),
        "aria-id": "date-picker-wrapper",
        distance: "4",
        placement: n.placement,
        triggers: [],
        "popper-hide-triggers": [],
        "auto-hide": !1,
        disabled: o(T),
        container: `#${n.id}`,
        strategy: n.popperStrategy === "fixed" || n.popperStrategy === "absolute" ? n.popperStrategy : "absolute",
        delay: 0,
        style: De({
          width: n.width
        })
      }, {
        popper: H(() => [
          A("div", {
            ref_key: "datePickerRef",
            ref: i
          }, [
            A("div", c3, [
              A("div", p3, [
                R(be, {
                  class: x(o(j)("tab-months")),
                  variant: "secondary",
                  size: "small",
                  onClick: ne[13] || (ne[13] = (te) => o(ve)("tab-months"))
                }, {
                  default: H(() => {
                    var te;
                    return [
                      Oe(G((te = o(Z)("monthValue", o(I).selectedMonth)) == null ? void 0 : te.fullText), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["class"]),
                R(be, {
                  class: x(o(j)("tab-years")),
                  variant: "secondary",
                  size: "small",
                  onClick: ne[14] || (ne[14] = (te) => o(ve)("tab-years"))
                }, {
                  default: H(() => [
                    Oe(G(o(I).selectedYear), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              o(p) === "tab-calendar" ? (f(), C("div", f3, [
                R(be, {
                  class: "spr-cursor-pointer",
                  variant: "secondary",
                  size: "small",
                  disabled: o(N),
                  onClick: o(O)
                }, {
                  default: H(() => [
                    R(o(W), { icon: "ph:caret-left" })
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                R(be, {
                  class: "spr-cursor-pointer",
                  variant: "secondary",
                  size: "small",
                  disabled: o(w),
                  onClick: o(S)
                }, {
                  default: H(() => [
                    R(o(W), { icon: "ph:caret-right" })
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])) : _("", !0),
              o(p) === "tab-years" ? (f(), C("div", g3, [
                R(be, {
                  class: "spr-cursor-pointer",
                  variant: "secondary",
                  size: "small",
                  disabled: o(de),
                  onClick: o(J)
                }, {
                  default: H(() => [
                    R(o(W), { icon: "ph:caret-left" })
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                R(be, {
                  class: "spr-cursor-pointer",
                  variant: "secondary",
                  size: "small",
                  disabled: o(Me),
                  onClick: o(oe)
                }, {
                  default: H(() => [
                    R(o(W), { icon: "ph:caret-right" })
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])) : _("", !0)
            ]),
            A("div", h3, [
              o(p) === "tab-calendar" ? (f(), C("div", y3, [
                (f(!0), C(X, null, le(o(y), (te, Re) => (f(), C("div", {
                  key: Re,
                  class: "spr-py-1 spr-text-center spr-font-semibold"
                }, G(te.text), 1))), 128)),
                (f(!0), C(X, null, le(o(I).calendarDays, (te) => (f(), C(X, {
                  key: te.date
                }, [
                  Se.minMaxYear.min <= te.date.getFullYear() && Se.minMaxYear.max >= te.date.getFullYear() ? (f(), C("div", {
                    key: 0,
                    class: x([
                      o(a).calendarTabItemsBaseClasses,
                      {
                        // Rest Days
                        "spr-background-color-disabled": o(E)(te),
                        // Today Indicator - only apply brand color if not selected
                        "spr-text-color-brand-base": o($)(te) && !o(k)(te),
                        // Active Month Dates - only apply if not selected and not today
                        "spr-text-color-strong": o(D)(te) && !o(k)(te) && !o($)(te),
                        // Inactive Month Dates (Past/Future)
                        "spr-text-color-disabled": o(z)(te),
                        // Selected Date
                        "spr-background-color-brand-base active:spr-background-color-brand-pressed spr-text-color-inverted-strong spr-cursor-pointer !spr-text-white-50 active:spr-scale-95": o(k)(te),
                        // Unselected Date
                        "hover:spr-background-color-hover spr-border-color-weak active:spr-background-color-pressed spr-cursor-pointer spr-border spr-border-solid active:spr-scale-95": o(b)(te),
                        // Disabled Dates
                        "spr-cursor-not-allowed spr-opacity-30": o(P)(te)
                      }
                    ]),
                    onClick: (Re) => o(P)(te) ? null : o(V)(te)
                  }, [
                    A("span", null, G(te.date.getDate()), 1),
                    o($)(te) ? (f(), C("div", v3)) : _("", !0)
                  ], 10, C3)) : (f(), C("div", m3))
                ], 64))), 128))
              ])) : _("", !0),
              o(p) === "tab-months" ? (f(), C("div", M3, [
                (f(!0), C(X, null, le(o(g), (te, Re) => (f(), C("div", {
                  key: Re,
                  class: x([
                    o(a).monthsTabItemsBaseClasses,
                    {
                      "spr-text-color-brand-base": te.monthValue === o(h).month(),
                      "spr-border-color-weak hover:spr-background-color-hover active:spr-background-color-pressed": te.text.toLowerCase() !== o(v).toLowerCase(),
                      "spr-border-color-brand-base spr-background-color-single-active": te.text.toLowerCase() === o(v).toLowerCase()
                    }
                  ]),
                  onClick: (o0) => o(Y)(te)
                }, [
                  A("span", null, G(te.text), 1),
                  te.monthValue === o(h).month() ? (f(), C("div", N3)) : _("", !0)
                ], 10, b3))), 128))
              ])) : _("", !0),
              o(p) === "tab-years" ? (f(), C("div", $3, [
                (f(!0), C(X, null, le(o(U), (te, Re) => (f(), C("div", {
                  key: Re,
                  class: x([
                    o(a).yearsTabItemsBaseClasses,
                    {
                      "spr-text-color-brand-base": te === o(h).year(),
                      "spr-border-color-weak hover:spr-background-color-hover active:spr-background-color-pressed": te !== Number(o(m)),
                      "spr-border-color-brand-base spr-background-color-single-active": te === Number(o(m))
                    }
                  ]),
                  onClick: (o0) => o(se)(String(te))
                }, [
                  A("span", null, G(te), 1),
                  te === o(h).year() ? (f(), C("div", I3)) : _("", !0)
                ], 10, D3))), 128))
              ])) : _("", !0)
            ])
          ], 512)
        ]),
        default: H(() => [
          A("div", {
            id: n.id,
            class: "spr-grid spr-gap-size-spacing-4xs"
          }, [
            n.label ? (f(), C("label", {
              key: 0,
              for: n.id,
              class: x(o(a).labelClasses)
            }, G(n.label), 11, a3)) : _("", !0),
            A("div", {
              ref_key: "datePickerRef",
              ref: i,
              class: x(o(a).datePickerBaseInputClasses),
              onClick: ne[12] || (ne[12] = (te) => c.value = !0)
            }, [
              A("div", o3, [
                rt(A("input", {
                  id: `${n.id}-month`,
                  ref_key: "monthInputRef",
                  ref: l,
                  "onUpdate:modelValue": ne[0] || (ne[0] = (te) => fe(v) ? v.value = te : null),
                  class: x(["spr-w-[38px] spr-min-w-[38px]", o(a).datePickerInputClasses]),
                  type: "text",
                  placeholder: "MMM",
                  maxlength: "3",
                  disabled: n.disabled,
                  readonly: n.readonly,
                  autocomplete: "off",
                  onInput: ne[1] || (ne[1] = //@ts-ignore
                  (...te) => o(ie) && o(ie)(...te)),
                  onKeyup: ne[2] || (ne[2] = //@ts-ignore
                  (...te) => o(ie) && o(ie)(...te)),
                  onKeydown: ne[3] || (ne[3] = (te) => o(Ne)("month", te))
                }, null, 42, i3), [
                  [i0, o(v)]
                ]),
                ne[16] || (ne[16] = A("span", { class: "spr-text-color-strong spr-font-size-200 spr-text-color-weak" }, "/", -1)),
                rt(A("input", {
                  id: `${n.id}-date`,
                  ref_key: "dateInputRef",
                  ref: u,
                  "onUpdate:modelValue": ne[4] || (ne[4] = (te) => fe(M) ? M.value = te : null),
                  class: x(["spr-w-[24px] spr-min-w-[24px] spr-text-center", o(a).datePickerInputClasses]),
                  type: "text",
                  placeholder: "DD",
                  maxlength: "2",
                  disabled: n.disabled,
                  readonly: n.readonly,
                  autocomplete: "off",
                  onInput: ne[5] || (ne[5] = //@ts-ignore
                  (...te) => o(Ce) && o(Ce)(...te)),
                  onKeyup: ne[6] || (ne[6] = //@ts-ignore
                  (...te) => o(Ce) && o(Ce)(...te)),
                  onKeydown: ne[7] || (ne[7] = (te) => o(Ne)("date", te))
                }, null, 42, l3), [
                  [i0, o(M)]
                ]),
                ne[17] || (ne[17] = A("span", { class: "spr-text-color-strong spr-font-size-200 spr-text-color-weak" }, "/", -1)),
                rt(A("input", {
                  id: `${n.id}-year`,
                  ref_key: "yearInputRef",
                  ref: d,
                  "onUpdate:modelValue": ne[8] || (ne[8] = (te) => fe(m) ? m.value = te : null),
                  class: x(["spr-w-[42px] spr-min-w-[42px]", o(a).datePickerInputClasses]),
                  type: "text",
                  placeholder: "YYYY",
                  maxlength: "4",
                  disabled: n.disabled,
                  readonly: n.readonly,
                  autocomplete: "off",
                  onInput: ne[9] || (ne[9] = //@ts-ignore
                  (...te) => o(ge) && o(ge)(...te)),
                  onKeyup: ne[10] || (ne[10] = //@ts-ignore
                  (...te) => o(ge) && o(ge)(...te)),
                  onKeydown: ne[11] || (ne[11] = (te) => o(Ne)("year", te))
                }, null, 42, u3), [
                  [i0, o(m)]
                ])
              ]),
              A("div", d3, [
                R(o(W), {
                  class: "spr-text-color-supporting spr-h-4 spr-w-4",
                  icon: "ph:calendar-blank"
                })
              ])
            ], 2)
          ], 8, s3)
        ]),
        _: 1
      }, 8, ["shown", "placement", "disabled", "container", "strategy", "style"]),
      n.displayHelper ? (f(), C("div", {
        key: 0,
        class: x(o(a).datePickerInputHelperClasses)
      }, [
        ee(Se.$slots, "helperMessage", {}, () => [
          n.helperIcon ? (f(), K(o(W), {
            key: 0,
            icon: n.helperIcon,
            width: "20px",
            height: "20px"
          }, null, 8, ["icon"])) : _("", !0),
          A("span", null, G(n.helperText), 1)
        ])
      ], 2)) : _("", !0)
    ]));
  }
}), x3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: A3
}, Symbol.toStringTag, { value: "Module" })), w3 = ["default", "center"], S3 = [
  "application/pdf",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "text/plain",
  "text/csv"
], j3 = [
  "image/apng",
  "image/avif",
  "image/gif",
  "image/jpeg",
  "image/png",
  "image/svg+xml",
  "image/webp"
], nn = [...j3, ...S3], T3 = {
  /**
   * @description Media upload type
   */
  type: {
    type: String,
    validator: (e) => w3.includes(e),
    default: "default"
  },
  title: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  multiple: {
    type: Boolean,
    default: !1
  },
  modelValue: {
    type: Array,
    required: !0,
    default: []
  },
  maxFileSize: {
    type: Number,
    default: 10
    // 10MB
  },
  fileTypes: {
    type: Array,
    validator: (e) => e.every((t) => nn.includes(t)),
    default: () => [...nn]
    // If null, accept all file types
  },
  showError: {
    type: Boolean,
    default: !1
  },
  errorMessages: {
    type: Array,
    default: []
  },
  hideFilePreviewIcon: {
    type: Boolean,
    default: !1
  },
  hideDropzoneLabel: {
    type: Boolean,
    default: !1
  },
  supportedFileTypeLabel: {
    type: String,
    default: null
  }
}, O3 = ["update:modelValue"], _3 = (e, t) => {
  const r = B(null), n = B(null), s = B(null), a = Ie(e, "modelValue", t), i = (v) => {
    if (!(e.disabled || v === null))
      if (v instanceof Event) {
        const I = v.target.files;
        a.value = I ? Array.from(I) : [];
      } else
        a.value = v.filter((m) => e.fileTypes.includes(m.type));
  }, l = (v, m) => {
    e.disabled && (m.dataTransfer.dropEffect = "none");
  }, { isOverDropZone: u } = vi(r, {
    onDrop: i,
    onOver: l,
    multiple: e.multiple,
    dataTypes: e.fileTypes,
    preventDefaultForUnhandled: !1
  }), d = F(() => {
    const v = L(
      "spr-rounded-border-radius-xl spr-mt-size-spacing-3xs spr-flex",
      {
        "spr-min-w-[56px] spr-py-size-spacing-2xs spr-px-size-spacing-xs": e.type !== "center",
        "spr-min-h-[160px] spr-p-size-spacing-xs spr-flex-col spr-justify-center spr-items-center": e.type === "center",
        "spr-border spr-border-solid spr-border-color-brand-base spr-background-color-single-active": u.value && !e.disabled,
        "file-upload_wrapper": !u.value && !e.showError,
        "file-upload_wrapper-error": !u.value && e.showError,
        "spr-border-color-base spr-background-color-surface": !e.disabled && !e.showError,
        "spr-border-color-danger-base spr-background-color-danger-weak": !e.disabled && e.showError,
        "spr-border-color-disabled spr-background-color-disabled": e.disabled,
        "spr-cursor-not-allowed file-upload_wrapper": e.disabled && u.value
      }
    ), m = L(
      "spr-flex spr-items-center spr-gap-size-spacing-3xs",
      {
        "spr-flex-auto ": e.type !== "center",
        "spr-mb-size-spacing-xs": e.type === "center",
        "spr-text-color-strong": !e.disabled,
        "spr-text-color-disabled": e.disabled
      }
    ), I = L(
      "spr-grid spr-content-center spr-body-xs-regular",
      {
        "spr-w-fit ": e.type !== "center",
        "spr-text-color-base": !e.disabled,
        "spr-text-color-disabled": e.disabled
      }
    ), N = L(
      "spr-rounded-border-radius-xl",
      "spr-border spr-border-solid spr-border-color-weak spr-background-color",
      "spr-mt-size-spacing-3xs spr-px-size-spacing-xs spr-py-size-spacing-2xs",
      "spr-flex spr-flex-col spr-gap-size-spacing-xs",
      {
        "spr-min-h-[160px] spr-justify-center": e.type === "center",
        "spr-text-color-strong": !e.disabled,
        "spr-text-color-disabled": e.disabled
      }
    );
    return {
      wrapperClasses: v,
      inputClasses: m,
      sublabelClasses: I,
      fileListClasses: N
    };
  }), c = (v) => {
    a.value.splice(v, 1);
  }, p = () => {
    n.value !== null && n.value.click();
  }, h = B(null), y = (v) => {
    s.value !== null && (s.value.click(), h.value = v);
  }, M = (v) => {
    var m;
    ((m = v.target.files) == null ? void 0 : m.length) <= 0 || h.value !== null && (a.value[h.value] = v.target.files[0], h.value = null);
  }, g = F(() => e.supportedFileTypeLabel ? e.supportedFileTypeLabel : e.fileTypes ? e.fileTypes.map((m) => {
    switch (m) {
      case "application/msword":
        return "MS WORD";
      case "application/vnd.ms-excel":
        return "MS EXCEL";
      case "application/vnd.ms-powerpoint":
        return "MS PPT";
      case "text/plain":
        return "TXT";
      case "image/svg+xml":
        return "SVG";
      default:
        return m.split("/")[1].toUpperCase();
    }
  }).join(", ") : "");
  return {
    fileUploadRef: r,
    initialInputFileRef: n,
    listInputFileRef: s,
    fileUploadClasses: d,
    onFileChangeHandler: i,
    deleteFile: c,
    clickInitialInputFile: p,
    clickListInputFile: y,
    replaceFile: M,
    supportedFileTypeLabel: g
  };
}, z3 = { class: "media-upload" }, L3 = {
  key: 0,
  class: "spr-body-md-regular"
}, k3 = ["multiple", "disabled", "accept"], E3 = {
  key: 0,
  class: "spr-body-sm-regular"
}, P3 = {
  key: 0,
  class: "spr-grid spr-content-center spr-text-center spr-body-xs-regular spr-text-color-danger-base"
}, Y3 = ["accept"], U3 = { class: "spr-flex spr-justify-between" }, F3 = { class: "spr-flex-auto spr-flex spr-break-all spr-overflow-hidden spr-whitespace-break-spaces spr-items-center" }, B3 = { class: "spr-body-sm-regular" }, R3 = { class: "spr-flex spr-gap-size-spacing-5xs spr-items-start" }, V3 = {
  key: 0,
  class: "spr-flex spr-gap-size-spacing-5xs spr-body-sm-regular spr-text-color-danger-base"
}, Q3 = { class: "spr-self-start" }, H3 = /* @__PURE__ */ ae({
  __name: "file-upload",
  props: T3,
  emits: O3,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      fileUploadRef: s,
      initialInputFileRef: a,
      listInputFileRef: i,
      fileUploadClasses: l,
      onFileChangeHandler: u,
      deleteFile: d,
      clickInitialInputFile: c,
      clickListInputFile: p,
      replaceFile: h,
      supportedFileTypeLabel: y
    } = _3(r, n);
    return (M, g) => (f(), C("div", z3, [
      r.title ? (f(), C("label", L3, G(r.title), 1)) : _("", !0),
      r.modelValue.length <= 0 ? (f(), C("div", {
        key: 1,
        ref_key: "fileUploadRef",
        ref: s,
        class: x(o(l).wrapperClasses)
      }, [
        A("div", {
          class: x(o(l).inputClasses)
        }, [
          A("input", {
            ref_key: "initialInputFileRef",
            ref: a,
            type: "file",
            hidden: "",
            multiple: r.multiple,
            disabled: r.disabled,
            accept: r.fileTypes.join(","),
            onChange: g[0] || (g[0] = //@ts-ignore
            (...v) => o(u) && o(u)(...v))
          }, null, 40, k3),
          R(o(W), {
            icon: "ph:cloud-arrow-up",
            width: "28px",
            height: "28px"
          }),
          R(be, {
            size: "small",
            tone: "neutral",
            variant: "secondary",
            disabled: r.disabled,
            onClick: o(c)
          }, {
            default: H(() => g[2] || (g[2] = [
              Oe("Browse Files")
            ])),
            _: 1
          }, 8, ["disabled", "onClick"]),
          r.hideDropzoneLabel ? _("", !0) : (f(), C("label", E3, G("or drop your " + (r.multiple ? "files" : "file") + " to upload"), 1))
        ], 2),
        r.showError ? (f(), C("div", P3, [
          (f(!0), C(X, null, le(r.errorMessages, (v, m) => (f(), C("label", { key: m }, G(v), 1))), 128))
        ])) : (f(), C("div", {
          key: 1,
          class: x(o(l).sublabelClasses)
        }, [
          A("label", null, "Supports: " + G(o(y)), 1),
          A("label", null, G(r.maxFileSize) + "MB maximum file size", 1)
        ], 2))
      ], 2)) : (f(), C("div", {
        key: 2,
        class: x(o(l).fileListClasses)
      }, [
        A("input", {
          ref_key: "listInputFileRef",
          ref: i,
          type: "file",
          multiple: "false",
          accept: r.fileTypes.join(","),
          hidden: "",
          onChange: g[1] || (g[1] = //@ts-ignore
          (...v) => o(h) && o(h)(...v))
        }, null, 40, Y3),
        (f(!0), C(X, null, le(M.modelValue, (v, m) => (f(), C("div", {
          key: m,
          class: "spr-flex spr-flex-col spr-gap-size-spacing-4xs"
        }, [
          A("div", U3, [
            A("div", F3, [
              r.hideFilePreviewIcon ? _("", !0) : (f(), K(o(W), {
                key: 0,
                icon: "ph:check-circle-fill",
                width: "16px",
                height: "16px",
                class: "spr-text-color-brand-base spr-flex-none"
              })),
              A("label", B3, G(v ? v.name : ""), 1)
            ]),
            A("div", R3, [
              R(be, {
                size: "small",
                tone: "neutral",
                variant: "secondary",
                disabled: r.disabled,
                onClick: (I) => o(p)(m)
              }, {
                default: H(() => g[3] || (g[3] = [
                  Oe("Replace")
                ])),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              R(be, {
                size: "small",
                tone: "danger",
                variant: "secondary",
                disabled: r.disabled,
                onClick: (I) => o(d)(m)
              }, {
                default: H(() => [
                  R(o(W), { icon: "ph:trash" })
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]),
          r.showError && r.errorMessages[m] ? (f(), C("div", V3, [
            R(o(W), {
              class: "spr-flex-none",
              icon: "ph:warning-circle-fill",
              width: "20px",
              height: "20px"
            }),
            A("span", Q3, G(r.errorMessages[m]), 1)
          ])) : _("", !0)
        ]))), 128))
      ], 2))
    ]));
  }
}), Z3 = /* @__PURE__ */ gt(H3, [["__scopeId", "data-v-bd78bd3c"]]), G3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z3
}, Symbol.toStringTag, { value: "Module" })), W3 = (e, t) => {
  const {
    options: r,
    filterMenu: n,
    filterData: s,
    loading: a,
    filterable: i,
    filling: l,
    deselected: u,
    hasSearchApi: d,
    hasAdvancedFilterApi: c
  } = ye(e), p = Ie(e, "modelValue", t), h = Ie(e, "search", t), y = Ie(e, "searchFilter", t), M = B(!1), g = B(""), v = B(""), m = B(!1), I = B(!1), N = B({}), w = B({}), E = B(
    n.value
  ), $ = B([]), D = B(null), z = B([]), k = B(""), b = F(() => {
    var Ce;
    if (l.value) return r.value;
    const se = d.value ? "" : g.value.toLowerCase();
    return (Ce = r.value) == null ? void 0 : Ce.filter((ge, ve) => (p.value.find((me) => me.value === ge.value && me.isSelected) && (r.value[ve].isSelected = !0), ge.text.toLowerCase().includes(se)));
  }), P = F(() => {
    if (a.value) return s.value;
    const se = c.value ? "" : v.value.toLowerCase();
    return s.value.filter((Ce, ge) => ($.value.find(
      (Ne) => Ne.value === Ce.value && Ne.isSelected && Ne.column === k.value
    ) && (s.value[ge].isSelected = !0), Ce.text.toLowerCase().includes(se.toLowerCase())));
  }), V = F(() => Object.values(w.value).some((se) => se.isFilterVisible)), Z = F(() => $.value.filter((se) => se.isSelected && se.column === k.value)), j = F(() => e.id ? `filter-popover-${e.id}` : `filter-popover-${ue().valueOf().toString().slice(-8)}`), T = (se) => {
    w.value[se].isFilterVisible = !0, k.value !== se && (v.value = "", k.value = se, t("getFilterData", se));
  }, O = (se) => {
    Object.keys(w.value).forEach((ie) => {
      w.value[ie].isFilterVisible = ie === se;
    });
  }, S = () => {
    var se;
    (se = n.value) != null && se.length && (w.value = n.value.reduce(
      (ie, { isFilterVisible: Ce, columnName: ge, field: ve }) => (ie[ve] = { isFilterVisible: Ce || !1, columnName: ge, field: ve, count: 0, selected: {} }, ie),
      {}
    ));
  }, Y = (se) => $.value.filter((ie) => ie.column === se).length;
  Yt(D, () => {
    M.value = !1;
  });
  const U = () => {
    var se;
    (se = r.value) != null && se.length && b.value.forEach((ie, Ce) => {
      b.value[Ce].isSelected = !0;
    });
  }, J = (se) => {
    const ie = P.value.filter((ge) => ge.isSelected && ge.column === se), Ce = ie.filter(
      (ge) => !$.value.some((ve) => ve.value === ge.value && ve.column === ge.column)
    );
    $.value = [...$.value, ...Ce], w.value[se].count = ie.length, w.value[se].isFilterVisible = !1, v.value = "", t("selectedFilter", $.value);
  }, oe = (se) => {
    P.value.map((ie) => (ie.value === se && (ie.isSelected = !1), ie)), $.value = $.value.filter((ie) => ie.value !== se), w.value[k.value].count = $.value.length, t("selectedFilter", $.value);
  }, de = () => {
    if (V.value) {
      t("infiniteScrollFilterTrigger", k.value);
      return;
    }
    t("infiniteScrollTrigger", !0);
  };
  ce(k, (se) => {
    O(se);
  }), ce(u, (se) => {
    se && (b.value.forEach(({ value: ie }, Ce) => {
      ie === se && (b.value[Ce].isSelected = !1);
    }), p.value = p.value.filter(
      ({ value: ie }) => ie !== se
    ));
  }), ce(
    () => b.value,
    (se) => {
      const ie = se.filter((ve) => ve.isSelected), ge = Array.from(
        new Map(
          [...p.value, ...ie].map((ve) => [
            ve.value,
            ve
          ])
        ).values()
      ).filter((ve) => {
        const Ne = b.value.find((me) => me.value === ve.value);
        return !(Ne && !Ne.isSelected);
      });
      JSON.stringify(p.value) !== JSON.stringify(ge) && (p.value = ge);
    },
    { deep: !0 }
  ), ce(g, (se, ie) => {
    se !== ie && (h.value = se);
  }), ce(v, (se, ie) => {
    se === ie || !c.value || (y.value = se);
  }), kt(() => z.value[0], de, { distance: 10 }), kt(D, de, { distance: 10 });
  const Me = F(() => {
    const se = L("spr-relative spr-inline-block spr-w-full"), ie = L(
      "spr-border-color-weak spr-border spr-border-x-0 spr-border-t-0 spr-border-solid spr-p-size-spacing-2xs",
      "spr-flex spr-items-center",
      { "spr-justify-between": n.value.length > 0 && i.value },
      { "spr-justify-end": n.value.length === 0 || !i.value }
    ), Ce = L(
      "spr-flex spr-flex-col spr-divide-x-0 spr-divide-y spr-divide-solid spr-divide-mushroom-200"
    ), ge = L("spr-flex spr-items-center spr-justify-between spr-p-size-spacing-2xs"), ve = L(
      "spr-flex spr-w-[328px] spr-flex-wrap spr-gap-size-spacing-2xs spr-p-size-spacing-xs"
    ), Ne = L(
      "spr-h-[264px] spr-p-size-spacing-sm spr-flex spr-items-center spr-justify-center"
    ), me = L("spr-flex spr-justify-end spr-gap-2 spr-p-size-spacing-2xs"), Se = L(
      "spr-body-xs-regular spr-flex spr-cursor-pointer spr-justify-between spr-rounded-border-radius-md spr-p-size-spacing-4xs",
      "hover:spr-background-color-hover"
    );
    return S(), {
      MainClasses: se,
      MenuOptionClasses: ie,
      PopperWrapperClasses: Ce,
      PopperHeaderClasses: ge,
      PopperContentClasses: ve,
      LoadingStateClasses: Ne,
      ActionButtonClasses: me,
      filterListClasses: Se
    };
  });
  return {
    isFilterOpen: M,
    searchValue: g,
    isAddFilterVisible: m,
    isAdvanceFilterVisible: I,
    filterMenuList: E,
    getFiltereredOption: b,
    mappedMenuData: N,
    getSelectedFilterMenuOption: Z,
    getFilteredMenuOption: P,
    filterMenuSearchvalue: v,
    mappedFilterMenuList: w,
    filterClass: Me,
    generateStableId: j,
    filterOptionRef: D,
    filterMenuOptionList: z,
    selectAllOptions: U,
    getMappedFilterData: T,
    saveSelectedFilter: J,
    getSelectedItemPerFilterMenu: Y,
    handleRemoveFilterValues: oe
  };
}, K3 = {
  modelValue: {
    type: [Array, String],
    default: () => []
  },
  options: {
    type: Array,
    required: !0,
    default: () => []
  },
  label: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  filterable: {
    type: Boolean,
    default: !1
  },
  id: {
    type: String,
    default: "spr-filter"
  },
  filterMenu: {
    type: Array,
    default: () => []
  },
  filterData: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: !1
  },
  filling: {
    type: Boolean,
    default: !1
  },
  search: {
    type: String,
    default: ""
  },
  searchFilter: {
    type: String,
    default: ""
  },
  width: {
    type: String,
    default: "100%"
  },
  deselected: {
    type: String,
    default: ""
  },
  hasSearchApi: {
    type: Boolean,
    default: !1
  },
  hasAvatar: {
    type: Boolean,
    default: !1
  },
  error: {
    type: Boolean,
    default: !1
  },
  helperText: {
    type: String,
    default: ""
  },
  hasAdvancedFilterApi: {
    type: Boolean,
    default: !1
  }
}, J3 = {
  getFilterData: (e) => typeof e == "string",
  "update:modelValue": (e) => Array.isArray(e),
  "update:search": (e) => typeof e == "string",
  "update:searchFilter": (e) => typeof e == "string",
  selectedFilter: (e) => Array.isArray(e),
  infiniteScrollTrigger: Boolean,
  infiniteScrollFilterTrigger: (e) => typeof e == "string"
}, X3 = ["id"], q3 = {
  key: 0,
  class: "spr-flex spr-items-center spr-gap-2"
}, e4 = { class: "spr-space-x-size-spacing-3xs spr-space-y-size-spacing-3xs" }, t4 = ["onClick"], r4 = { class: "spr-p-size-spacing-2xs" }, n4 = {
  key: 0,
  class: "spr-h-[70px] spr-space-x-2 spr-space-y-2 spr-overflow-auto spr-p-size-spacing-2xs"
}, s4 = ["id"], a4 = ["onClick"], o4 = { class: "spr-body-sm-regular" }, i4 = { class: "spr-body-xs-regular spr-text-color-supporting" }, l4 = { key: 1 }, u4 = /* @__PURE__ */ ae({
  __name: "filter",
  props: K3,
  emits: J3,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      isFilterOpen: s,
      searchValue: a,
      isAddFilterVisible: i,
      getFiltereredOption: l,
      getSelectedFilterMenuOption: u,
      getFilteredMenuOption: d,
      filterMenuSearchvalue: c,
      mappedFilterMenuList: p,
      filterClass: h,
      generateStableId: y,
      filterOptionRef: M,
      filterMenuOptionList: g,
      selectAllOptions: v,
      getMappedFilterData: m,
      saveSelectedFilter: I,
      getSelectedItemPerFilterMenu: N,
      handleRemoveFilterValues: w
    } = W3(r, n);
    return (E, $) => (f(), K(o(we), {
      shown: o(s),
      "onUpdate:shown": $[5] || ($[5] = (D) => fe(s) ? s.value = D : null),
      "aria-id": "filter-option-wrapper",
      distance: "4",
      placement: "bottom",
      triggers: [],
      "popper-hide-triggers": [],
      container: `#${o(y)}`,
      "auto-hide": !1,
      delay: 0,
      "popper-class": "filter-menu-popper",
      style: De({
        width: r.width,
        position: "relative"
      })
    }, {
      popper: H(() => [
        A("div", {
          class: x(o(h).MenuOptionClasses)
        }, [
          E.filterMenu.length > 0 && E.filterable ? (f(), C("div", q3, [
            A("div", e4, [
              (f(!0), C(X, null, le(E.filterMenu, (D) => (f(), C(X, {
                key: D.field
              }, [
                o(p)[D.field].count ? (f(), K(_t, {
                  key: 0,
                  label: o(p)[D.field].columnName,
                  icon: "ph:funnel-simple"
                }, null, 8, ["label"])) : _("", !0)
              ], 64))), 128))
            ]),
            R(o(we), {
              shown: o(i),
              "onUpdate:shown": $[4] || ($[4] = (D) => fe(i) ? i.value = D : null),
              "aria-id": "filter-menu-wrapper",
              distance: "4",
              placement: "right-start",
              triggers: ["click"],
              "auto-hide": !1,
              delay: 0,
              "popover-base": "filter-menu-base"
            }, {
              popper: H(() => [
                A("div", {
                  class: x(o(h).PopperWrapperClasses)
                }, [
                  A("div", {
                    class: x(o(h).PopperHeaderClasses)
                  }, [
                    $[6] || ($[6] = Oe(" Add Filter ")),
                    A("span", {
                      class: "spr-cursor-pointer",
                      onClick: $[2] || ($[2] = (D) => i.value = !1)
                    }, [
                      R(o(W), { icon: "ph:x" })
                    ])
                  ], 2),
                  A("div", {
                    class: x(o(h).PopperContentClasses)
                  }, [
                    (f(!0), C(X, null, le(E.filterMenu, (D) => (f(), K(o(we), {
                      key: D.field,
                      shown: o(p)[D.field].isFilterVisible,
                      "onUpdate:shown": (z) => o(p)[D.field].isFilterVisible = z,
                      "aria-id": "filter-menu-wrapper",
                      placement: "right",
                      triggers: ["click"],
                      delay: 0,
                      "auto-hide": !1,
                      "popover-base": "filter-menu-field"
                    }, {
                      popper: H(() => [
                        A("div", {
                          class: x(["spr-w-[320px]", o(h).PopperWrapperClasses])
                        }, [
                          A("div", {
                            class: x(o(h).PopperHeaderClasses)
                          }, [
                            $[7] || ($[7] = Oe(" Add Filter ")),
                            A("span", {
                              class: "spr-cursor-pointer",
                              onClick: (z) => o(p)[D.field].isFilterVisible = !1
                            }, [
                              R(o(W), { icon: "ph:x" })
                            ], 8, t4)
                          ], 2),
                          A("div", r4, [
                            R(Ee, {
                              id: `${r.id}-search`,
                              modelValue: o(c),
                              "onUpdate:modelValue": $[3] || ($[3] = (z) => fe(c) ? c.value = z : null),
                              type: "text",
                              placeholder: "Search"
                            }, {
                              icon: H(() => [
                                R(o(W), { icon: "ph:magnifying-glass" })
                              ]),
                              _: 1
                            }, 8, ["id", "modelValue"])
                          ]),
                          o(u).length > 0 ? (f(), C("div", n4, [
                            (f(!0), C(X, null, le(o(u), (z, k) => (f(), K(_t, {
                              key: k,
                              label: z.text,
                              active: !0,
                              closable: "",
                              onClose: (b) => o(w)(z.value)
                            }, null, 8, ["label", "onClose"]))), 128))
                          ])) : _("", !0),
                          o(d).length > 0 ? (f(), C("div", {
                            key: 1,
                            id: D.field,
                            ref_for: !0,
                            ref_key: "filterMenuOptionList",
                            ref: g,
                            class: "spr-h-[264px] spr-space-y-size-spacing-6xs spr-overflow-auto spr-p-size-spacing-2xs"
                          }, [
                            (f(!0), C(X, null, le(o(d), (z, k) => (f(), C("div", {
                              key: z.value,
                              class: x([
                                o(h).filterListClasses,
                                { "spr-background-color-multiple-active": o(d)[k].isSelected }
                              ])
                            }, [
                              R($t, {
                                id: "filter-menu-option",
                                modelValue: o(d)[k].isSelected,
                                "onUpdate:modelValue": (b) => o(d)[k].isSelected = b,
                                class: "spr-w-full",
                                checked: o(d)[k].isSelected,
                                label: o(d)[k].text,
                                description: o(d)[k].subtext
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "checked", "label", "description"])
                            ], 2))), 128))
                          ], 8, s4)) : (f(), C("div", {
                            key: 2,
                            class: x(o(h).LoadingStateClasses)
                          }, [
                            r.loading ? ee(E.$slots, "loading", { key: 0 }, () => [
                              $[8] || ($[8] = Oe(" loading... "))
                            ]) : ee(E.$slots, "empty", { key: 1 }, () => [
                              $[9] || ($[9] = Oe(" No Result Found! "))
                            ])
                          ], 2)),
                          A("div", {
                            class: x(o(h).ActionButtonClasses)
                          }, [
                            R(be, {
                              id: "cancel-button",
                              variant: "secondary",
                              size: "small",
                              onClick: (z) => o(p)[D.field].isFilterVisible = !1
                            }, {
                              default: H(() => $[10] || ($[10] = [
                                Oe(" Cancel ")
                              ])),
                              _: 2
                            }, 1032, ["onClick"]),
                            R(be, {
                              id: "save-button",
                              size: "small",
                              tone: "success",
                              onClick: (z) => o(I)(D.field)
                            }, {
                              default: H(() => $[11] || ($[11] = [
                                Oe(" Save ")
                              ])),
                              _: 2
                            }, 1032, ["onClick"])
                          ], 2)
                        ], 2)
                      ]),
                      default: H(() => [
                        R(_t, {
                          active: o(p)[D.field].isFilterVisible,
                          label: o(p)[D.field].columnName,
                          badge: o(N)(D.field) > 0,
                          "badge-text": o(N)(D.field).toString(),
                          "badge-variant": "danger",
                          icon: "ph:funnel-simple",
                          onClick: (z) => o(m)(D.field)
                        }, null, 8, ["active", "label", "badge", "badge-text", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["shown", "onUpdate:shown"]))), 128))
                  ], 2)
                ], 2)
              ]),
              default: H(() => [
                R(be, {
                  id: "add-filter-button",
                  "has-icon": "",
                  variant: "secondary",
                  size: "small"
                }, {
                  default: H(() => [
                    R(o(W), { icon: "ph:faders-horizontal" })
                  ]),
                  _: 1
                })
              ]),
              _: 3
            }, 8, ["shown"])
          ])) : _("", !0),
          R(be, {
            id: "select-all-button",
            variant: "secondary",
            size: "small",
            onClick: o(v)
          }, {
            default: H(() => $[12] || ($[12] = [
              Oe("Select All")
            ])),
            _: 1
          }, 8, ["onClick"])
        ], 2),
        o(l).length > 0 && !E.filling ? (f(), C("div", {
          key: 0,
          ref_key: "filterOptionRef",
          ref: M,
          class: "spr-max-h-[264px] spr-space-y-size-spacing-6xs spr-overflow-auto spr-p-size-spacing-3xs"
        }, [
          (f(!0), C(X, null, le(o(l), (D, z) => (f(), C("div", {
            key: D.value,
            class: x([
              o(h).filterListClasses,
              {
                "spr-background-color-multiple-active": o(l)[z].isSelected
              }
            ])
          }, [
            A("div", {
              class: "spr-flex spr-w-full spr-flex-row spr-items-center spr-justify-items-start spr-gap-size-spacing-3xs",
              onClick: (k) => o(l)[z].isSelected = !o(l)[z].isSelected
            }, [
              R($t, {
                modelValue: o(l)[z].isSelected,
                "onUpdate:modelValue": (k) => o(l)[z].isSelected = k,
                checked: o(l)[z].isSelected
              }, null, 8, ["modelValue", "onUpdate:modelValue", "checked"]),
              r.hasAvatar ? (f(), K(Et, {
                key: 0,
                size: "md",
                alt: "User Avatar",
                src: o(l)[z].avatar,
                variant: o(l)[z].avatar ? "image" : "initial",
                initial: o(l)[z].text
              }, null, 8, ["src", "variant", "initial"])) : _("", !0),
              A("div", null, [
                A("div", o4, G(o(l)[z].text), 1),
                A("div", i4, G(o(l)[z].subtext), 1)
              ])
            ], 8, a4)
          ], 2))), 128))
        ], 512)) : (f(), C("div", l4, [
          E.filling ? ee(E.$slots, "loading-state", { key: 0 }, () => [
            A("div", {
              class: x(o(h).LoadingStateClasses)
            }, "Loading...", 2)
          ]) : ee(E.$slots, "empty-state", { key: 1 }, () => [
            A("div", {
              class: x(o(h).LoadingStateClasses)
            }, "Result not found!", 2)
          ])
        ]))
      ]),
      default: H(() => [
        A("div", {
          id: o(y),
          style: De({
            width: r.width,
            position: "relative"
          }),
          onClick: $[1] || ($[1] = (D) => s.value = !0)
        }, [
          ee(E.$slots, "default", {}, () => [
            R(Ee, {
              id: r.id,
              modelValue: o(a),
              "onUpdate:modelValue": $[0] || ($[0] = (D) => fe(a) ? a.value = D : null),
              type: "text",
              placeholder: E.placeholder,
              label: E.label,
              disabled: E.disabled,
              "helper-text": r.helperText,
              "display-helper": !!r.helperText,
              error: r.error
            }, {
              icon: H(() => [
                R(o(W), { icon: "ph:magnifying-glass" })
              ]),
              _: 1
            }, 8, ["id", "modelValue", "placeholder", "label", "disabled", "helper-text", "display-helper", "error"])
          ])
        ], 12, X3)
      ]),
      _: 3
    }, 8, ["shown", "container", "style"]));
  }
}), d4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u4
}, Symbol.toStringTag, { value: "Module" })), c4 = {
  show: {
    type: Boolean,
    default: !1
  }
};
function p4(e) {
  const t = v2(e, "show"), r = F(() => ({
    wrapperClass: "spr-bg-white-50 spr-body-md-regular spr-text-color-strong spr-bg-white spr-fixed spr-bottom-8 spr-left-1/2 spr-z-50 spr-flex spr-w-full spr-max-w-[1024px] spr--translate-x-1/2 spr-items-center spr-gap-4 spr-rounded-border-radius-md  spr-drop-shadow-md"
  }));
  return { isVisible: t, floatingActionClasses: r };
}
const f4 = {
  key: 0,
  class: "spr-flex spr-w-full spr-items-center spr-justify-between spr-px-size-spacing-md spr-py-size-spacing-2xs"
}, g4 = {
  key: 1,
  class: "spr-flex spr-items-center spr-gap-1"
}, h4 = /* @__PURE__ */ ae({
  __name: "floating-action",
  props: c4,
  setup(e) {
    const t = e, { isVisible: r, floatingActionClasses: n } = p4(t);
    return (s, a) => (f(), K(mt, {
      name: "slide-up",
      "enter-active-class": "spr-transition spr-duration-[150ms] spr-ease-in-out",
      "enter-from-class": "spr-translate-y-20",
      "enter-to-class": "spr-translate-y-0",
      "leave-active-class": "spr-transition spr-duration-[150ms] spr-ease-in-out",
      "leave-from-class": "spr-translate-y-0",
      "leave-to-class": "spr-translate-y-20"
    }, {
      default: H(() => [
        o(r) ? (f(), C("div", {
          key: 0,
          class: x([o(n).wrapperClass])
        }, [
          s.$slots.default ? _("", !0) : (f(), C("div", f4, [
            s.$slots.message ? ee(s.$slots, "message", { key: 0 }) : _("", !0),
            s.$slots.actions ? (f(), C("div", g4, [
              ee(s.$slots, "actions")
            ])) : _("", !0)
          ])),
          ee(s.$slots, "default")
        ], 2)) : _("", !0)
      ]),
      _: 3
    }));
  }
}), y4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: h4
}, Symbol.toStringTag, { value: "Module" })), C4 = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function or(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(C4), e.apply(this, r);
}
function sn(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var r = e[0].split("."), n = t[0].split("."), s = 0; s < 3; s++) {
    var a = Number(r[s]), i = Number(n[s]);
    if (a > i) return 1;
    if (i > a) return -1;
    if (!isNaN(a) && isNaN(i)) return 1;
    if (isNaN(a) && !isNaN(i)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var v4 = {}.constructor;
function zt(e) {
  return e != null && e.constructor === v4;
}
function T0(e) {
  "@babel/helpers - typeof";
  return T0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, T0(e);
}
function t0(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function m4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function r0(e, t, r) {
  return t && m4(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var M4 = "1.2.0", b4 = "1.7.35", an = " ext. ", N4 = /^\d+$/, ke = /* @__PURE__ */ function() {
  function e(t) {
    t0(this, e), js(t), this.metadata = t, Ts.call(this, t);
  }
  return r0(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(r) {
        return r !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(r) {
      return this.metadata.countries[r];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(r) {
      return this.getCountryMetadata(r) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(r) {
      if (this.getCountryCodesForCallingCode(r))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[r])
          return !0;
      } else {
        var n = this.countryCallingCodes()[r];
        if (n && n.length === 1 && n[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(r) {
      return this.nonGeographic() ? !!this.nonGeographic()[r] : !this.getCountryCodesForCallingCode(r);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(r, n) {
      if (r && N4.test(r) && (n = r, r = null), r && r !== "001") {
        if (!this.hasCountry(r))
          throw new Error("Unknown country: ".concat(r));
        this.numberingPlan = new on(this.getCountryMetadata(r), this);
      } else if (n) {
        if (!this.hasCallingCode(n))
          throw new Error("Unknown calling code: ".concat(n));
        this.numberingPlan = new on(this.getNumberingPlanMetadata(n), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(r) {
      var n = this.countryCallingCodes()[r];
      if (n)
        return n.length === 1 && n[0].length === 3 ? void 0 : n;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(r) {
      var n = this.getCountryCodesForCallingCode(r);
      if (n)
        return n[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(r) {
      var n = this.getCountryCodeForCallingCode(r);
      if (n)
        return this.getCountryMetadata(n);
      if (this.nonGeographic()) {
        var s = this.nonGeographic()[r];
        if (s)
          return s;
      } else {
        var a = this.countryCallingCodes()[r];
        if (a && a.length === 1 && a[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(r) {
      return this.numberingPlan.type(r);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), on = /* @__PURE__ */ function() {
  function e(t, r) {
    t0(this, e), this.globalMetadataObject = r, this.metadata = t, Ts.call(this, r.metadata);
  }
  return r0(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(r) {
      return r[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var r = this, n = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return n.map(function(s) {
        return new $4(s, r);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(r) {
      return r[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(r) {
      if (this.hasTypes() && ln(this.types(), r))
        return new I4(ln(this.types(), r), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? an : this.metadata[13] || an;
    }
  }]), e;
}(), $4 = /* @__PURE__ */ function() {
  function e(t, r) {
    t0(this, e), this._format = t, this.metadata = r;
  }
  return r0(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !D4.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), D4 = /^\(?\$1\)?$/, I4 = /* @__PURE__ */ function() {
  function e(t, r) {
    t0(this, e), this.type = t, this.metadata = r;
  }
  return r0(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function ln(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function js(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!zt(e) || !zt(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(zt(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + A4(e) + ": " + e, "."));
}
var A4 = function(t) {
  return T0(t);
};
function n0(e, t) {
  if (t = new ke(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function x4(e, t) {
  return t.countries.hasOwnProperty(e);
}
function Ts(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? sn(t, M4) === -1 ? this.v2 = !0 : sn(t, b4) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function ir(e, t) {
  return w4(e, void 0, t);
}
function w4(e, t, r) {
  var n = r.type(t), s = n && n.possibleLengths() || r.possibleLengths();
  if (!s)
    return "IS_POSSIBLE";
  var a = e.length, i = s[0];
  return i === a ? "IS_POSSIBLE" : i > a ? "TOO_SHORT" : s[s.length - 1] < a ? "TOO_LONG" : s.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function S4(e, t, r) {
  if (t === void 0 && (t = {}), r = new ke(r), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return Os(e.phone || e.nationalNumber, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Os(e, t) {
  switch (ir(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function nt(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function j4(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = T4(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function T4(e, t) {
  if (e) {
    if (typeof e == "string") return un(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return un(e, t);
  }
}
function un(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var O4 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function lr(e, t, r) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    r = new ke(r), r.selectNumberingPlan(e.country, e.countryCallingCode);
    var n = t.v2 ? e.nationalNumber : e.phone;
    if (nt(n, r.nationalNumberPattern())) {
      if (f0(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || f0(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var s = j4(O4), a; !(a = s()).done; ) {
        var i = a.value;
        if (f0(n, i, r))
          return i;
      }
    }
  }
}
function f0(e, t, r) {
  return t = r.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : nt(e, t.pattern());
}
function _4(e, t, r) {
  if (t = t || {}, r = new ke(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return lr(e, t, r.metadata) !== void 0;
  var n = t.v2 ? e.nationalNumber : e.phone;
  return nt(n, r.nationalNumberPattern());
}
function z4(e, t, r) {
  var n = new ke(r), s = n.getCountryCodesForCallingCode(e);
  return s ? s.filter(function(a) {
    return L4(t, a, r);
  }) : [];
}
function L4(e, t, r) {
  var n = new ke(r);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var ur = 2, k4 = 17, E4 = 3, Ze = "0-9０-９٠-٩۰-۹", P4 = "-‐-―−ー－", Y4 = "／/", U4 = "．.", F4 = "  ­​⁠　", B4 = "()（）［］\\[\\]", R4 = "~⁓∼～", Y2 = "".concat(P4).concat(Y4).concat(U4).concat(F4).concat(B4).concat(R4), dr = "+＋", V4 = new RegExp("([" + Ze + "])");
function Q4(e, t, r, n) {
  if (t) {
    var s = new ke(n);
    s.selectNumberingPlan(t, r);
    var a = new RegExp(s.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var i = e.match(V4);
      if (!(i && i[1] != null && i[1].length > 0 && i[1] === "0"))
        return e;
    }
  }
}
function H4(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(e);
    if (n) {
      var s, a, i = n.length - 1, l = i > 0 && n[i];
      if (t.nationalPrefixTransformRule() && l)
        s = e.replace(r, t.nationalPrefixTransformRule()), i > 1 && (a = n[1]);
      else {
        var u = n[0];
        s = e.slice(u.length), l && (a = n[1]);
      }
      var d;
      if (l) {
        var c = e.indexOf(n[1]), p = e.slice(0, c);
        p === t.numberingPlan.nationalPrefix() && (d = t.numberingPlan.nationalPrefix());
      } else
        d = n[0];
      return {
        nationalNumber: s,
        nationalPrefix: d,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function O0(e, t) {
  var r = H4(e, t), n = r.carrierCode, s = r.nationalNumber;
  if (s !== e) {
    if (!Z4(e, s, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !G4(s, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: s,
    carrierCode: n
  };
}
function Z4(e, t, r) {
  return !(nt(e, r.nationalNumberPattern()) && !nt(t, r.nationalNumberPattern()));
}
function G4(e, t) {
  switch (ir(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function W4(e, t, r, n) {
  var s = t ? n0(t, n) : r;
  if (e.indexOf(s) === 0) {
    n = new ke(n), n.selectNumberingPlan(t, r);
    var a = e.slice(s.length), i = O0(a, n), l = i.nationalNumber, u = O0(e, n), d = u.nationalNumber;
    if (!nt(d, n.nationalNumberPattern()) && nt(l, n.nationalNumberPattern()) || ir(d, n) === "TOO_LONG")
      return {
        countryCallingCode: s,
        number: a
      };
  }
  return {
    number: e
  };
}
function _s(e, t, r, n) {
  if (!e)
    return {};
  var s;
  if (e[0] !== "+") {
    var a = Q4(e, t, r, n);
    if (a && a !== e)
      s = !0, e = "+" + a;
    else {
      if (t || r) {
        var i = W4(e, t, r, n), l = i.countryCallingCode, u = i.number;
        if (l)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: l,
            number: u
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  n = new ke(n);
  for (var d = 2; d - 1 <= E4 && d <= e.length; ) {
    var c = e.slice(1, d);
    if (n.hasCallingCode(c))
      return n.selectNumberingPlan(c), {
        countryCallingCodeSource: s ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: e.slice(d)
      };
    d++;
  }
  return {};
}
function K4(e) {
  return e.replace(new RegExp("[".concat(Y2, "]+"), "g"), " ").trim();
}
var J4 = /(\$\d)/;
function X4(e, t, r) {
  var n = r.useInternationalFormat, s = r.withNationalPrefix, a = e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    s && t.nationalPrefixFormattingRule() ? t.format().replace(J4, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return n ? K4(a) : a;
}
var q4 = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function ec(e, t, r) {
  var n = new ke(r);
  if (n.selectNumberingPlan(e, t), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (q4.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
var tc = ";ext=", wt = function(t) {
  return "([".concat(Ze, "]{1,").concat(t, "})");
};
function zs(e) {
  var t = "20", r = "15", n = "9", s = "6", a = "[  \\t,]*", i = "[:\\.．]?[  \\t,-]*", l = "#?", u = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", p = "[  \\t]*", h = "(?:,{2}|;)", y = tc + wt(t), M = a + u + i + wt(t) + l, g = a + d + i + wt(n) + l, v = c + wt(s) + "#", m = p + h + i + wt(r) + l, I = p + "(?:,)+" + i + wt(n) + l;
  return y + "|" + M + "|" + g + "|" + v + "|" + m + "|" + I;
}
var rc = "[" + Ze + "]{" + ur + "}", nc = "[" + dr + "]{0,1}(?:[" + Y2 + "]*[" + Ze + "]){3,}[" + Y2 + Ze + "]*", sc = new RegExp("^[" + dr + "]{0,1}(?:[" + Y2 + "]*[" + Ze + "]){1,2}$", "i"), ac = nc + // Phone number extensions
"(?:" + zs() + ")?", oc = new RegExp(
  // Either a short two-digit-only phone number
  "^" + rc + "$|^" + ac + "$",
  "i"
);
function ic(e) {
  return e.length >= ur && oc.test(e);
}
function lc(e) {
  return sc.test(e);
}
function uc(e) {
  var t = e.number, r = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
function dc(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = cc(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cc(e, t) {
  if (e) {
    if (typeof e == "string") return dn(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return dn(e, t);
  }
}
function dn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function cn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cn(Object(r), !0).forEach(function(n) {
      pc(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pc(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var fn = {
  formatExtension: function(t, r, n) {
    return "".concat(t).concat(n.ext()).concat(r);
  }
};
function fc(e, t, r, n) {
  if (r ? r = pn(pn({}, fn), r) : r = fn, n = new ke(n), e.country && e.country !== "001") {
    if (!n.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    n.country(e.country);
  } else if (e.countryCallingCode)
    n.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var s = n.countryCallingCode(), a = r.v2 ? e.nationalNumber : e.phone, i;
  switch (t) {
    case "NATIONAL":
      return a ? (i = U2(a, e.carrierCode, "NATIONAL", n, r), g0(i, e.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (i = U2(a, null, "INTERNATIONAL", n, r), i = "+".concat(s, " ").concat(i), g0(i, e.ext, n, r.formatExtension)) : "+".concat(s);
    case "E.164":
      return "+".concat(s).concat(a);
    case "RFC3966":
      return uc({
        number: "+".concat(s).concat(a),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!r.fromCountry)
        return;
      var l = hc(a, e.carrierCode, s, r.fromCountry, n);
      return g0(l, e.ext, n, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function U2(e, t, r, n, s) {
  var a = gc(n.formats(), e);
  return a ? X4(e, a, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && s && s.nationalPrefix === !1),
    carrierCode: t,
    metadata: n
  }) : e;
}
function gc(e, t) {
  for (var r = dc(e), n; !(n = r()).done; ) {
    var s = n.value;
    if (s.leadingDigitsPatterns().length > 0) {
      var a = s.leadingDigitsPatterns()[s.leadingDigitsPatterns().length - 1];
      if (t.search(a) !== 0)
        continue;
    }
    if (nt(t, s.pattern()))
      return s;
  }
}
function g0(e, t, r, n) {
  return t ? n(e, t, r) : e;
}
function hc(e, t, r, n, s) {
  var a = n0(n, s.metadata);
  if (a === r) {
    var i = U2(e, t, "NATIONAL", s);
    return r === "1" ? r + " " + i : i;
  }
  var l = ec(n, void 0, s.metadata);
  if (l)
    return "".concat(l, " ").concat(r, " ").concat(U2(e, null, "INTERNATIONAL", s));
}
function gn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gn(Object(r), !0).forEach(function(n) {
      yc(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yc(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Cc(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vc(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function mc(e, t, r) {
  return vc(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Mc = /* @__PURE__ */ function() {
  function e(t, r, n) {
    if (Cc(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (typeof t == "string") {
      if (t[0] === "+" && !r)
        throw new TypeError("`metadata` argument not passed");
      if (zt(r) && zt(r.countries)) {
        n = r;
        var s = t;
        if (!$c.test(s))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var a = _s(s, void 0, void 0, n), i = a.countryCallingCode, l = a.number;
        if (r = l, t = i, !r)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!r)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof r != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    js(n);
    var u = Nc(t, n), d = u.country, c = u.countryCallingCode;
    this.country = d, this.countryCallingCode = c, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return mc(e, [{
    key: "setExt",
    value: function(r) {
      this.ext = r;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : z4(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return S4(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return _4(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var r = new ke(this.getMetadata());
      return r.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(r) {
      return this.number === r.number && this.ext === r.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return lr(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(r, n) {
      return fc(this, r, n ? hn(hn({}, n), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(r) {
      return this.format("NATIONAL", r);
    }
  }, {
    key: "formatInternational",
    value: function(r) {
      return this.format("INTERNATIONAL", r);
    }
  }, {
    key: "getURI",
    value: function(r) {
      return this.format("RFC3966", r);
    }
  }]), e;
}(), bc = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function Nc(e, t) {
  var r, n, s = new ke(t);
  return bc(e) ? (r = e, s.selectNumberingPlan(r), n = s.countryCallingCode()) : n = e, {
    country: r,
    countryCallingCode: n
  };
}
var $c = /^\+\d+$/;
function _0(e) {
  "@babel/helpers - typeof";
  return _0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _0(e);
}
function Dc(e, t, r) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ic(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ac(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && o2(e, t);
}
function xc(e) {
  var t = ks();
  return function() {
    var n = i2(e), s;
    if (t) {
      var a = i2(this).constructor;
      s = Reflect.construct(n, arguments, a);
    } else
      s = n.apply(this, arguments);
    return wc(this, s);
  };
}
function wc(e, t) {
  if (t && (_0(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ls(e);
}
function Ls(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function z0(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return z0 = function(n) {
    if (n === null || !Sc(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n)) return t.get(n);
      t.set(n, s);
    }
    function s() {
      return x2(n, arguments, i2(this).constructor);
    }
    return s.prototype = Object.create(n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), o2(s, n);
  }, z0(e);
}
function x2(e, t, r) {
  return ks() ? x2 = Reflect.construct : x2 = function(s, a, i) {
    var l = [null];
    l.push.apply(l, a);
    var u = Function.bind.apply(s, l), d = new u();
    return i && o2(d, i.prototype), d;
  }, x2.apply(null, arguments);
}
function ks() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Sc(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function o2(e, t) {
  return o2 = Object.setPrototypeOf || function(n, s) {
    return n.__proto__ = s, n;
  }, o2(e, t);
}
function i2(e) {
  return i2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, i2(e);
}
var tt = /* @__PURE__ */ function(e) {
  Ac(r, e);
  var t = xc(r);
  function r(n) {
    var s;
    return Ic(this, r), s = t.call(this, n), Object.setPrototypeOf(Ls(s), r.prototype), s.name = s.constructor.name, s;
  }
  return Dc(r);
}(/* @__PURE__ */ z0(Error)), yn = new RegExp("(?:" + zs() + ")$", "i");
function jc(e) {
  var t = e.search(yn);
  if (t < 0)
    return {};
  for (var r = e.slice(0, t), n = e.match(yn), s = 1; s < n.length; ) {
    if (n[s])
      return {
        number: r,
        ext: n[s]
      };
    s++;
  }
}
var Tc = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Oc(e) {
  return Tc[e];
}
function _c(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = zc(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zc(e, t) {
  if (e) {
    if (typeof e == "string") return Cn(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Cn(e, t);
  }
}
function Cn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function vn(e) {
  for (var t = "", r = _c(e.split("")), n; !(n = r()).done; ) {
    var s = n.value;
    t += Lc(s, t) || "";
  }
  return t;
}
function Lc(e, t, r) {
  return e === "+" ? t ? void 0 : "+" : Oc(e);
}
function kc(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Ec(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ec(e, t) {
  if (e) {
    if (typeof e == "string") return mn(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return mn(e, t);
  }
}
function mn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Pc(e, t) {
  var r = t.countries, n = t.metadata;
  n = new ke(n);
  for (var s = kc(r), a; !(a = s()).done; ) {
    var i = a.value;
    if (n.country(i), n.leadingDigits()) {
      if (e && e.search(n.leadingDigits()) === 0)
        return i;
    } else if (lr({
      phone: e,
      country: i
    }, void 0, n.metadata))
      return i;
  }
}
function Yc(e, t) {
  var r = t.nationalNumber, n = t.defaultCountry, s = t.metadata, a = s.getCountryCodesForCallingCode(e);
  if (a)
    return a.length === 1 ? a[0] : Pc(r, {
      countries: a,
      defaultCountry: n,
      metadata: s.metadata
    });
}
var Es = "+", Uc = "[\\-\\.\\(\\)]?", Mn = "([" + Ze + "]|" + Uc + ")", Fc = "^\\" + Es + Mn + "*[" + Ze + "]" + Mn + "*$", Bc = new RegExp(Fc, "g"), L0 = Ze, Rc = "[" + L0 + "]+((\\-)*[" + L0 + "])*", Vc = "a-zA-Z", Qc = "[" + Vc + "]+((\\-)*[" + L0 + "])*", Hc = "^(" + Rc + "\\.)*" + Qc + "\\.?$", Zc = new RegExp(Hc, "g"), bn = "tel:", k0 = ";phone-context=", Gc = ";isub=";
function Wc(e) {
  var t = e.indexOf(k0);
  if (t < 0)
    return null;
  var r = t + k0.length;
  if (r >= e.length)
    return "";
  var n = e.indexOf(";", r);
  return n >= 0 ? e.substring(r, n) : e.substring(r);
}
function Kc(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Bc.test(e) || Zc.test(e);
}
function Jc(e, t) {
  var r = t.extractFormattedPhoneNumber, n = Wc(e);
  if (!Kc(n))
    throw new tt("NOT_A_NUMBER");
  var s;
  if (n === null)
    s = r(e) || "";
  else {
    s = "", n.charAt(0) === Es && (s += n);
    var a = e.indexOf(bn), i;
    a >= 0 ? i = a + bn.length : i = 0;
    var l = e.indexOf(k0);
    s += e.substring(i, l);
  }
  var u = s.indexOf(Gc);
  if (u > 0 && (s = s.substring(0, u)), s !== "")
    return s;
}
var Xc = 250, qc = new RegExp("[" + dr + Ze + "]"), e6 = new RegExp("[^" + Ze + "#]+$");
function t6(e, t, r) {
  if (t = t || {}, r = new ke(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new tt("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var n = n6(e, t.v2, t.extract), s = n.number, a = n.ext, i = n.error;
  if (!s) {
    if (t.v2)
      throw i === "TOO_SHORT" ? new tt("TOO_SHORT") : new tt("NOT_A_NUMBER");
    return {};
  }
  var l = a6(s, t.defaultCountry, t.defaultCallingCode, r), u = l.country, d = l.nationalNumber, c = l.countryCallingCode, p = l.countryCallingCodeSource, h = l.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new tt("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < ur) {
    if (t.v2)
      throw new tt("TOO_SHORT");
    return {};
  }
  if (d.length > k4) {
    if (t.v2)
      throw new tt("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var y = new Mc(c, d, r.metadata);
    return u && (y.country = u), h && (y.carrierCode = h), a && (y.ext = a), y.__countryCallingCodeSource = p, y;
  }
  var M = (t.extended ? r.hasSelectedNumberingPlan() : u) ? nt(d, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: u,
    countryCallingCode: c,
    carrierCode: h,
    valid: M,
    possible: M ? !0 : !!(t.extended === !0 && r.possibleLengths() && Os(d, r)),
    phone: d,
    ext: a
  } : M ? s6(u, d, a) : {};
}
function r6(e, t, r) {
  if (e) {
    if (e.length > Xc) {
      if (r)
        throw new tt("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var n = e.search(qc);
    if (!(n < 0))
      return e.slice(n).replace(e6, "");
  }
}
function n6(e, t, r) {
  var n = Jc(e, {
    extractFormattedPhoneNumber: function(i) {
      return r6(i, r, t);
    }
  });
  if (!n)
    return {};
  if (!ic(n))
    return lc(n) ? {
      error: "TOO_SHORT"
    } : {};
  var s = jc(n);
  return s.ext ? s : {
    number: n
  };
}
function s6(e, t, r) {
  var n = {
    country: e,
    phone: t
  };
  return r && (n.ext = r), n;
}
function a6(e, t, r, n) {
  var s = _s(vn(e), t, r, n.metadata), a = s.countryCallingCodeSource, i = s.countryCallingCode, l = s.number, u;
  if (i)
    n.selectNumberingPlan(i);
  else if (l && (t || r))
    n.selectNumberingPlan(t, r), t && (u = t), i = r || n0(t, n.metadata);
  else return {};
  if (!l)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: i
    };
  var d = O0(vn(l), n), c = d.nationalNumber, p = d.carrierCode, h = Yc(i, {
    nationalNumber: c,
    defaultCountry: t,
    metadata: n
  });
  return h && (u = h, h === "001" || n.country(u)), {
    country: u,
    countryCallingCode: i,
    countryCallingCodeSource: a,
    nationalNumber: c,
    carrierCode: p
  };
}
function Nn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $n(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nn(Object(r), !0).forEach(function(n) {
      o6(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Nn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function o6(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function i6(e, t, r) {
  return t6(e, $n($n({}, t), {}, {
    v2: !0
  }), r);
}
function Dn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function l6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dn(Object(r), !0).forEach(function(n) {
      u6(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Dn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function u6(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function d6(e, t) {
  return g6(e) || f6(e, t) || p6(e, t) || c6();
}
function c6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p6(e, t) {
  if (e) {
    if (typeof e == "string") return In(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return In(e, t);
  }
}
function In(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function f6(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], s = !0, a = !1, i, l;
    try {
      for (r = r.call(e); !(s = (i = r.next()).done) && (n.push(i.value), !(t && n.length === t)); s = !0)
        ;
    } catch (u) {
      a = !0, l = u;
    } finally {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (a) throw l;
      }
    }
    return n;
  }
}
function g6(e) {
  if (Array.isArray(e)) return e;
}
function h6(e) {
  var t = Array.prototype.slice.call(e), r = d6(t, 4), n = r[0], s = r[1], a = r[2], i = r[3], l, u, d;
  if (typeof n == "string")
    l = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!s || typeof s == "string")
    i ? (u = a, d = i) : (u = void 0, d = a), s && (u = l6({
      defaultCountry: s
    }, u));
  else if (zt(s))
    a ? (u = s, d = a) : d = s;
  else throw new Error("Invalid second argument: ".concat(s));
  return {
    text: l,
    options: u,
    metadata: d
  };
}
function An(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? An(Object(r), !0).forEach(function(n) {
      y6(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : An(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function y6(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function C6(e, t, r) {
  t && t.defaultCountry && !x4(t.defaultCountry, r) && (t = xn(xn({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return i6(e, t, r);
  } catch (n) {
    if (!(n instanceof tt)) throw n;
  }
}
function v6() {
  var e = h6(arguments), t = e.text, r = e.options, n = e.metadata;
  return C6(t, r, n);
}
function m6(e) {
  return new ke(e).getCountries();
}
function M6() {
  return or(v6, arguments);
}
function Ps() {
  return or(m6, arguments);
}
function w2() {
  return or(n0, arguments);
}
const b6 = (e, t) => {
  const { preSelectedCountryCode: r, disabledCountryCallingCode: n, disabled: s } = ye(e), a = F(() => ({
    countryCallingCodeClasses: L(
      "spr-font-weight-regular spr-font-size-200 spr-line-height-500 spr-letter-spacing-none spr-font-main",
      "spr-flex spr-items-center spr-gap-size-spacing-5xs",
      {
        "spr-cursor-not-allowed": s.value,
        "spr-cursor-default": n.value && !s.value,
        "spr-cursor-pointer": !n.value && !s.value
      }
    )
  })), i = Ie(e, "modelValue", t), l = B({
    countryCode: ["PH"],
    countryCallingCode: ["63"]
  }), u = B(!1), d = (g) => {
    const v = w2(g), m = Ps().find((I) => w2(I) === String(v) && I === g);
    m && v ? (l.value = {
      countryCode: [m],
      countryCallingCode: [v]
    }, h(), t("getSelectedCountryCallingCode", {
      countryCode: m,
      countryCallingCode: v
    })) : console.error(`No valid country found for the code: ${g}`);
  }, c = (g) => {
    const v = g.target, m = v.value;
    /^[+]?\d*[\d\s-]*$/.test(m) || (v.value = m.replace(/[^0-9+\s-]/g, "")), t("getContactNumberErrors", []), m.length > 0 && h();
  }, p = (g) => {
    l.value = {
      countryCode: [g[0]],
      countryCallingCode: [w2(g[0])]
    }, t("getContactNumberErrors", []), h(), t("getSelectedCountryCallingCode", {
      countryCode: l.value.countryCode[0],
      countryCallingCode: l.value.countryCallingCode[0]
    });
  }, h = () => {
    if (!i.value) return;
    const g = i.value.replace(/\D/g, ""), v = M6(g, {
      defaultCountry: l.value.countryCode[0],
      extract: !1
    });
    if (v && v.isValid()) {
      let m = v.formatInternational();
      m = m.replace(`+${l.value.countryCallingCode[0]} `, ""), i.value = m;
    } else
      t("getContactNumberErrors", [
        {
          title: "Invalid Contact Number",
          message: "Must be a valid contact number"
        }
      ]);
  }, y = (g) => {
    t("update:modelValue", g);
  }, M = (g) => {
    u.value = g;
  };
  return ce(r, (g) => {
    g && d(g);
  }), Be(() => {
    t("getSelectedCountryCallingCode", {
      countryCode: l.value.countryCode[0],
      countryCallingCode: l.value.countryCallingCode[0]
    }), r.value && d(r.value);
  }), {
    inputContactNumberClasses: a,
    formattedValue: i,
    selectedCountry: l,
    popperState: u,
    handleContactNumberInput: c,
    handleSelectedCountryCode: p,
    formatContactNumber: h,
    handleUpdateModelValue: y,
    handlePopperState: M
  };
};
/*! countries-list v3.1.1 by Annexare | MIT */
var cr = { AD: { name: "Andorra", native: "Andorra", phone: [376], continent: "EU", capital: "Andorra la Vella", currency: ["EUR"], languages: ["ca"] }, AE: { name: "United Arab Emirates", native: "دولة الإمارات العربية المتحدة", phone: [971], continent: "AS", capital: "Abu Dhabi", currency: ["AED"], languages: ["ar"] }, AF: { name: "Afghanistan", native: "افغانستان", phone: [93], continent: "AS", capital: "Kabul", currency: ["AFN"], languages: ["ps", "uz", "tk"] }, AG: { name: "Antigua and Barbuda", native: "Antigua and Barbuda", phone: [1268], continent: "NA", capital: "Saint John's", currency: ["XCD"], languages: ["en"] }, AI: { name: "Anguilla", native: "Anguilla", phone: [1264], continent: "NA", capital: "The Valley", currency: ["XCD"], languages: ["en"] }, AL: { name: "Albania", native: "Shqipëria", phone: [355], continent: "EU", capital: "Tirana", currency: ["ALL"], languages: ["sq"] }, AM: { name: "Armenia", native: "Հայաստան", phone: [374], continent: "AS", capital: "Yerevan", currency: ["AMD"], languages: ["hy", "ru"] }, AO: { name: "Angola", native: "Angola", phone: [244], continent: "AF", capital: "Luanda", currency: ["AOA"], languages: ["pt"] }, AQ: { name: "Antarctica", native: "Antarctica", phone: [672], continent: "AN", capital: "", currency: [], languages: [] }, AR: { name: "Argentina", native: "Argentina", phone: [54], continent: "SA", capital: "Buenos Aires", currency: ["ARS"], languages: ["es", "gn"] }, AS: { name: "American Samoa", native: "American Samoa", phone: [1684], continent: "OC", capital: "Pago Pago", currency: ["USD"], languages: ["en", "sm"] }, AT: { name: "Austria", native: "Österreich", phone: [43], continent: "EU", capital: "Vienna", currency: ["EUR"], languages: ["de"] }, AU: { name: "Australia", native: "Australia", phone: [61], continent: "OC", capital: "Canberra", currency: ["AUD"], languages: ["en"] }, AW: { name: "Aruba", native: "Aruba", phone: [297], continent: "NA", capital: "Oranjestad", currency: ["AWG"], languages: ["nl", "pa"] }, AX: { name: "Aland", native: "Åland", phone: [358], continent: "EU", capital: "Mariehamn", currency: ["EUR"], languages: ["sv"], partOf: "FI" }, AZ: { name: "Azerbaijan", native: "Azərbaycan", phone: [994], continent: "AS", continents: ["AS", "EU"], capital: "Baku", currency: ["AZN"], languages: ["az"] }, BA: { name: "Bosnia and Herzegovina", native: "Bosna i Hercegovina", phone: [387], continent: "EU", capital: "Sarajevo", currency: ["BAM"], languages: ["bs", "hr", "sr"] }, BB: { name: "Barbados", native: "Barbados", phone: [1246], continent: "NA", capital: "Bridgetown", currency: ["BBD"], languages: ["en"] }, BD: { name: "Bangladesh", native: "Bangladesh", phone: [880], continent: "AS", capital: "Dhaka", currency: ["BDT"], languages: ["bn"] }, BE: { name: "Belgium", native: "België", phone: [32], continent: "EU", capital: "Brussels", currency: ["EUR"], languages: ["nl", "fr", "de"] }, BF: { name: "Burkina Faso", native: "Burkina Faso", phone: [226], continent: "AF", capital: "Ouagadougou", currency: ["XOF"], languages: ["fr", "ff"] }, BG: { name: "Bulgaria", native: "България", phone: [359], continent: "EU", capital: "Sofia", currency: ["BGN"], languages: ["bg"] }, BH: { name: "Bahrain", native: "‏البحرين", phone: [973], continent: "AS", capital: "Manama", currency: ["BHD"], languages: ["ar"] }, BI: { name: "Burundi", native: "Burundi", phone: [257], continent: "AF", capital: "Bujumbura", currency: ["BIF"], languages: ["fr", "rn"] }, BJ: { name: "Benin", native: "Bénin", phone: [229], continent: "AF", capital: "Porto-Novo", currency: ["XOF"], languages: ["fr"] }, BL: { name: "Saint Barthelemy", native: "Saint-Barthélemy", phone: [590], continent: "NA", capital: "Gustavia", currency: ["EUR"], languages: ["fr"] }, BM: { name: "Bermuda", native: "Bermuda", phone: [1441], continent: "NA", capital: "Hamilton", currency: ["BMD"], languages: ["en"] }, BN: { name: "Brunei", native: "Negara Brunei Darussalam", phone: [673], continent: "AS", capital: "Bandar Seri Begawan", currency: ["BND"], languages: ["ms"] }, BO: { name: "Bolivia", native: "Bolivia", phone: [591], continent: "SA", capital: "Sucre", currency: ["BOB", "BOV"], languages: ["es", "ay", "qu"] }, BQ: { name: "Bonaire", native: "Bonaire", phone: [5997], continent: "NA", capital: "Kralendijk", currency: ["USD"], languages: ["nl"] }, BR: { name: "Brazil", native: "Brasil", phone: [55], continent: "SA", capital: "Brasília", currency: ["BRL"], languages: ["pt"] }, BS: { name: "Bahamas", native: "Bahamas", phone: [1242], continent: "NA", capital: "Nassau", currency: ["BSD"], languages: ["en"] }, BT: { name: "Bhutan", native: "ʼbrug-yul", phone: [975], continent: "AS", capital: "Thimphu", currency: ["BTN", "INR"], languages: ["dz"] }, BV: { name: "Bouvet Island", native: "Bouvetøya", phone: [47], continent: "AN", capital: "", currency: ["NOK"], languages: ["no", "nb", "nn"] }, BW: { name: "Botswana", native: "Botswana", phone: [267], continent: "AF", capital: "Gaborone", currency: ["BWP"], languages: ["en", "tn"] }, BY: { name: "Belarus", native: "Белару́сь", phone: [375], continent: "EU", capital: "Minsk", currency: ["BYN"], languages: ["be", "ru"] }, BZ: { name: "Belize", native: "Belize", phone: [501], continent: "NA", capital: "Belmopan", currency: ["BZD"], languages: ["en", "es"] }, CA: { name: "Canada", native: "Canada", phone: [1], continent: "NA", capital: "Ottawa", currency: ["CAD"], languages: ["en", "fr"] }, CC: { name: "Cocos (Keeling) Islands", native: "Cocos (Keeling) Islands", phone: [61], continent: "AS", capital: "West Island", currency: ["AUD"], languages: ["en"] }, CD: { name: "Democratic Republic of the Congo", native: "République démocratique du Congo", phone: [243], continent: "AF", capital: "Kinshasa", currency: ["CDF"], languages: ["fr", "ln", "kg", "sw", "lu"] }, CF: { name: "Central African Republic", native: "Ködörösêse tî Bêafrîka", phone: [236], continent: "AF", capital: "Bangui", currency: ["XAF"], languages: ["fr", "sg"] }, CG: { name: "Republic of the Congo", native: "République du Congo", phone: [242], continent: "AF", capital: "Brazzaville", currency: ["XAF"], languages: ["fr", "ln"] }, CH: { name: "Switzerland", native: "Schweiz", phone: [41], continent: "EU", capital: "Bern", currency: ["CHE", "CHF", "CHW"], languages: ["de", "fr", "it"] }, CI: { name: "Ivory Coast", native: "Côte d'Ivoire", phone: [225], continent: "AF", capital: "Yamoussoukro", currency: ["XOF"], languages: ["fr"] }, CK: { name: "Cook Islands", native: "Cook Islands", phone: [682], continent: "OC", capital: "Avarua", currency: ["NZD"], languages: ["en"] }, CL: { name: "Chile", native: "Chile", phone: [56], continent: "SA", capital: "Santiago", currency: ["CLF", "CLP"], languages: ["es"] }, CM: { name: "Cameroon", native: "Cameroon", phone: [237], continent: "AF", capital: "Yaoundé", currency: ["XAF"], languages: ["en", "fr"] }, CN: { name: "China", native: "中国", phone: [86], continent: "AS", capital: "Beijing", currency: ["CNY"], languages: ["zh"] }, CO: { name: "Colombia", native: "Colombia", phone: [57], continent: "SA", capital: "Bogotá", currency: ["COP"], languages: ["es"] }, CR: { name: "Costa Rica", native: "Costa Rica", phone: [506], continent: "NA", capital: "San José", currency: ["CRC"], languages: ["es"] }, CU: { name: "Cuba", native: "Cuba", phone: [53], continent: "NA", capital: "Havana", currency: ["CUC", "CUP"], languages: ["es"] }, CV: { name: "Cape Verde", native: "Cabo Verde", phone: [238], continent: "AF", capital: "Praia", currency: ["CVE"], languages: ["pt"] }, CW: { name: "Curacao", native: "Curaçao", phone: [5999], continent: "NA", capital: "Willemstad", currency: ["ANG"], languages: ["nl", "pa", "en"] }, CX: { name: "Christmas Island", native: "Christmas Island", phone: [61], continent: "AS", capital: "Flying Fish Cove", currency: ["AUD"], languages: ["en"] }, CY: { name: "Cyprus", native: "Κύπρος", phone: [357], continent: "EU", capital: "Nicosia", currency: ["EUR"], languages: ["el", "tr", "hy"] }, CZ: { name: "Czech Republic", native: "Česká republika", phone: [420], continent: "EU", capital: "Prague", currency: ["CZK"], languages: ["cs"] }, DE: { name: "Germany", native: "Deutschland", phone: [49], continent: "EU", capital: "Berlin", currency: ["EUR"], languages: ["de"] }, DJ: { name: "Djibouti", native: "Djibouti", phone: [253], continent: "AF", capital: "Djibouti", currency: ["DJF"], languages: ["fr", "ar"] }, DK: { name: "Denmark", native: "Danmark", phone: [45], continent: "EU", continents: ["EU", "NA"], capital: "Copenhagen", currency: ["DKK"], languages: ["da"] }, DM: { name: "Dominica", native: "Dominica", phone: [1767], continent: "NA", capital: "Roseau", currency: ["XCD"], languages: ["en"] }, DO: { name: "Dominican Republic", native: "República Dominicana", phone: [1809, 1829, 1849], continent: "NA", capital: "Santo Domingo", currency: ["DOP"], languages: ["es"] }, DZ: { name: "Algeria", native: "الجزائر", phone: [213], continent: "AF", capital: "Algiers", currency: ["DZD"], languages: ["ar"] }, EC: { name: "Ecuador", native: "Ecuador", phone: [593], continent: "SA", capital: "Quito", currency: ["USD"], languages: ["es"] }, EE: { name: "Estonia", native: "Eesti", phone: [372], continent: "EU", capital: "Tallinn", currency: ["EUR"], languages: ["et"] }, EG: { name: "Egypt", native: "مصر‎", phone: [20], continent: "AF", continents: ["AF", "AS"], capital: "Cairo", currency: ["EGP"], languages: ["ar"] }, EH: { name: "Western Sahara", native: "الصحراء الغربية", phone: [212], continent: "AF", capital: "El Aaiún", currency: ["MAD", "DZD", "MRU"], languages: ["es"] }, ER: { name: "Eritrea", native: "ኤርትራ", phone: [291], continent: "AF", capital: "Asmara", currency: ["ERN"], languages: ["ti", "ar", "en"] }, ES: { name: "Spain", native: "España", phone: [34], continent: "EU", capital: "Madrid", currency: ["EUR"], languages: ["es", "eu", "ca", "gl", "oc"] }, ET: { name: "Ethiopia", native: "ኢትዮጵያ", phone: [251], continent: "AF", capital: "Addis Ababa", currency: ["ETB"], languages: ["am"] }, FI: { name: "Finland", native: "Suomi", phone: [358], continent: "EU", capital: "Helsinki", currency: ["EUR"], languages: ["fi", "sv"] }, FJ: { name: "Fiji", native: "Fiji", phone: [679], continent: "OC", capital: "Suva", currency: ["FJD"], languages: ["en", "fj", "hi", "ur"] }, FK: { name: "Falkland Islands", native: "Falkland Islands", phone: [500], continent: "SA", capital: "Stanley", currency: ["FKP"], languages: ["en"] }, FM: { name: "Micronesia", native: "Micronesia", phone: [691], continent: "OC", capital: "Palikir", currency: ["USD"], languages: ["en"] }, FO: { name: "Faroe Islands", native: "Føroyar", phone: [298], continent: "EU", capital: "Tórshavn", currency: ["DKK"], languages: ["fo"] }, FR: { name: "France", native: "France", phone: [33], continent: "EU", capital: "Paris", currency: ["EUR"], languages: ["fr"] }, GA: { name: "Gabon", native: "Gabon", phone: [241], continent: "AF", capital: "Libreville", currency: ["XAF"], languages: ["fr"] }, GB: { name: "United Kingdom", native: "United Kingdom", phone: [44], continent: "EU", capital: "London", currency: ["GBP"], languages: ["en"] }, GD: { name: "Grenada", native: "Grenada", phone: [1473], continent: "NA", capital: "St. George's", currency: ["XCD"], languages: ["en"] }, GE: { name: "Georgia", native: "საქართველო", phone: [995], continent: "AS", continents: ["AS", "EU"], capital: "Tbilisi", currency: ["GEL"], languages: ["ka"] }, GF: { name: "French Guiana", native: "Guyane française", phone: [594], continent: "SA", capital: "Cayenne", currency: ["EUR"], languages: ["fr"] }, GG: { name: "Guernsey", native: "Guernsey", phone: [44], continent: "EU", capital: "St. Peter Port", currency: ["GBP"], languages: ["en", "fr"] }, GH: { name: "Ghana", native: "Ghana", phone: [233], continent: "AF", capital: "Accra", currency: ["GHS"], languages: ["en"] }, GI: { name: "Gibraltar", native: "Gibraltar", phone: [350], continent: "EU", capital: "Gibraltar", currency: ["GIP"], languages: ["en"] }, GL: { name: "Greenland", native: "Kalaallit Nunaat", phone: [299], continent: "NA", capital: "Nuuk", currency: ["DKK"], languages: ["kl"] }, GM: { name: "Gambia", native: "Gambia", phone: [220], continent: "AF", capital: "Banjul", currency: ["GMD"], languages: ["en"] }, GN: { name: "Guinea", native: "Guinée", phone: [224], continent: "AF", capital: "Conakry", currency: ["GNF"], languages: ["fr", "ff"] }, GP: { name: "Guadeloupe", native: "Guadeloupe", phone: [590], continent: "NA", capital: "Basse-Terre", currency: ["EUR"], languages: ["fr"] }, GQ: { name: "Equatorial Guinea", native: "Guinea Ecuatorial", phone: [240], continent: "AF", capital: "Malabo", currency: ["XAF"], languages: ["es", "fr"] }, GR: { name: "Greece", native: "Ελλάδα", phone: [30], continent: "EU", capital: "Athens", currency: ["EUR"], languages: ["el"] }, GS: { name: "South Georgia and the South Sandwich Islands", native: "South Georgia", phone: [500], continent: "AN", capital: "King Edward Point", currency: ["GBP"], languages: ["en"] }, GT: { name: "Guatemala", native: "Guatemala", phone: [502], continent: "NA", capital: "Guatemala City", currency: ["GTQ"], languages: ["es"] }, GU: { name: "Guam", native: "Guam", phone: [1671], continent: "OC", capital: "Hagåtña", currency: ["USD"], languages: ["en", "ch", "es"] }, GW: { name: "Guinea-Bissau", native: "Guiné-Bissau", phone: [245], continent: "AF", capital: "Bissau", currency: ["XOF"], languages: ["pt"] }, GY: { name: "Guyana", native: "Guyana", phone: [592], continent: "SA", capital: "Georgetown", currency: ["GYD"], languages: ["en"] }, HK: { name: "Hong Kong", native: "香港", phone: [852], continent: "AS", capital: "City of Victoria", currency: ["HKD"], languages: ["zh", "en"] }, HM: { name: "Heard Island and McDonald Islands", native: "Heard Island and McDonald Islands", phone: [61], continent: "AN", capital: "", currency: ["AUD"], languages: ["en"] }, HN: { name: "Honduras", native: "Honduras", phone: [504], continent: "NA", capital: "Tegucigalpa", currency: ["HNL"], languages: ["es"] }, HR: { name: "Croatia", native: "Hrvatska", phone: [385], continent: "EU", capital: "Zagreb", currency: ["EUR"], languages: ["hr"] }, HT: { name: "Haiti", native: "Haïti", phone: [509], continent: "NA", capital: "Port-au-Prince", currency: ["HTG", "USD"], languages: ["fr", "ht"] }, HU: { name: "Hungary", native: "Magyarország", phone: [36], continent: "EU", capital: "Budapest", currency: ["HUF"], languages: ["hu"] }, ID: { name: "Indonesia", native: "Indonesia", phone: [62], continent: "AS", capital: "Jakarta", currency: ["IDR"], languages: ["id"] }, IE: { name: "Ireland", native: "Éire", phone: [353], continent: "EU", capital: "Dublin", currency: ["EUR"], languages: ["ga", "en"] }, IL: { name: "Israel", native: "יִשְׂרָאֵל", phone: [972], continent: "AS", capital: "Jerusalem", currency: ["ILS"], languages: ["he", "ar"] }, IM: { name: "Isle of Man", native: "Isle of Man", phone: [44], continent: "EU", capital: "Douglas", currency: ["GBP"], languages: ["en", "gv"] }, IN: { name: "India", native: "भारत", phone: [91], continent: "AS", capital: "New Delhi", currency: ["INR"], languages: ["hi", "en"] }, IO: { name: "British Indian Ocean Territory", native: "British Indian Ocean Territory", phone: [246], continent: "AS", capital: "Diego Garcia", currency: ["USD"], languages: ["en"] }, IQ: { name: "Iraq", native: "العراق", phone: [964], continent: "AS", capital: "Baghdad", currency: ["IQD"], languages: ["ar", "ku"] }, IR: { name: "Iran", native: "ایران", phone: [98], continent: "AS", capital: "Tehran", currency: ["IRR"], languages: ["fa"] }, IS: { name: "Iceland", native: "Ísland", phone: [354], continent: "EU", capital: "Reykjavik", currency: ["ISK"], languages: ["is"] }, IT: { name: "Italy", native: "Italia", phone: [39], continent: "EU", capital: "Rome", currency: ["EUR"], languages: ["it"] }, JE: { name: "Jersey", native: "Jersey", phone: [44], continent: "EU", capital: "Saint Helier", currency: ["GBP"], languages: ["en", "fr"] }, JM: { name: "Jamaica", native: "Jamaica", phone: [1876], continent: "NA", capital: "Kingston", currency: ["JMD"], languages: ["en"] }, JO: { name: "Jordan", native: "الأردن", phone: [962], continent: "AS", capital: "Amman", currency: ["JOD"], languages: ["ar"] }, JP: { name: "Japan", native: "日本", phone: [81], continent: "AS", capital: "Tokyo", currency: ["JPY"], languages: ["ja"] }, KE: { name: "Kenya", native: "Kenya", phone: [254], continent: "AF", capital: "Nairobi", currency: ["KES"], languages: ["en", "sw"] }, KG: { name: "Kyrgyzstan", native: "Кыргызстан", phone: [996], continent: "AS", capital: "Bishkek", currency: ["KGS"], languages: ["ky", "ru"] }, KH: { name: "Cambodia", native: "Kâmpŭchéa", phone: [855], continent: "AS", capital: "Phnom Penh", currency: ["KHR"], languages: ["km"] }, KI: { name: "Kiribati", native: "Kiribati", phone: [686], continent: "OC", capital: "South Tarawa", currency: ["AUD"], languages: ["en"] }, KM: { name: "Comoros", native: "Komori", phone: [269], continent: "AF", capital: "Moroni", currency: ["KMF"], languages: ["ar", "fr"] }, KN: { name: "Saint Kitts and Nevis", native: "Saint Kitts and Nevis", phone: [1869], continent: "NA", capital: "Basseterre", currency: ["XCD"], languages: ["en"] }, KP: { name: "North Korea", native: "북한", phone: [850], continent: "AS", capital: "Pyongyang", currency: ["KPW"], languages: ["ko"] }, KR: { name: "South Korea", native: "대한민국", phone: [82], continent: "AS", capital: "Seoul", currency: ["KRW"], languages: ["ko"] }, KW: { name: "Kuwait", native: "الكويت", phone: [965], continent: "AS", capital: "Kuwait City", currency: ["KWD"], languages: ["ar"] }, KY: { name: "Cayman Islands", native: "Cayman Islands", phone: [1345], continent: "NA", capital: "George Town", currency: ["KYD"], languages: ["en"] }, KZ: { name: "Kazakhstan", native: "Қазақстан", phone: [7], continent: "AS", continents: ["AS", "EU"], capital: "Astana", currency: ["KZT"], languages: ["kk", "ru"] }, LA: { name: "Laos", native: "ສປປລາວ", phone: [856], continent: "AS", capital: "Vientiane", currency: ["LAK"], languages: ["lo"] }, LB: { name: "Lebanon", native: "لبنان", phone: [961], continent: "AS", capital: "Beirut", currency: ["LBP"], languages: ["ar", "fr"] }, LC: { name: "Saint Lucia", native: "Saint Lucia", phone: [1758], continent: "NA", capital: "Castries", currency: ["XCD"], languages: ["en"] }, LI: { name: "Liechtenstein", native: "Liechtenstein", phone: [423], continent: "EU", capital: "Vaduz", currency: ["CHF"], languages: ["de"] }, LK: { name: "Sri Lanka", native: "śrī laṃkāva", phone: [94], continent: "AS", capital: "Colombo", currency: ["LKR"], languages: ["si", "ta"] }, LR: { name: "Liberia", native: "Liberia", phone: [231], continent: "AF", capital: "Monrovia", currency: ["LRD"], languages: ["en"] }, LS: { name: "Lesotho", native: "Lesotho", phone: [266], continent: "AF", capital: "Maseru", currency: ["LSL", "ZAR"], languages: ["en", "st"] }, LT: { name: "Lithuania", native: "Lietuva", phone: [370], continent: "EU", capital: "Vilnius", currency: ["EUR"], languages: ["lt"] }, LU: { name: "Luxembourg", native: "Luxembourg", phone: [352], continent: "EU", capital: "Luxembourg", currency: ["EUR"], languages: ["fr", "de", "lb"] }, LV: { name: "Latvia", native: "Latvija", phone: [371], continent: "EU", capital: "Riga", currency: ["EUR"], languages: ["lv"] }, LY: { name: "Libya", native: "‏ليبيا", phone: [218], continent: "AF", capital: "Tripoli", currency: ["LYD"], languages: ["ar"] }, MA: { name: "Morocco", native: "المغرب", phone: [212], continent: "AF", capital: "Rabat", currency: ["MAD"], languages: ["ar"] }, MC: { name: "Monaco", native: "Monaco", phone: [377], continent: "EU", capital: "Monaco", currency: ["EUR"], languages: ["fr"] }, MD: { name: "Moldova", native: "Moldova", phone: [373], continent: "EU", capital: "Chișinău", currency: ["MDL"], languages: ["ro"] }, ME: { name: "Montenegro", native: "Црна Гора", phone: [382], continent: "EU", capital: "Podgorica", currency: ["EUR"], languages: ["sr", "bs", "sq", "hr"] }, MF: { name: "Saint Martin", native: "Saint-Martin", phone: [590], continent: "NA", capital: "Marigot", currency: ["EUR"], languages: ["en", "fr", "nl"] }, MG: { name: "Madagascar", native: "Madagasikara", phone: [261], continent: "AF", capital: "Antananarivo", currency: ["MGA"], languages: ["fr", "mg"] }, MH: { name: "Marshall Islands", native: "M̧ajeļ", phone: [692], continent: "OC", capital: "Majuro", currency: ["USD"], languages: ["en", "mh"] }, MK: { name: "North Macedonia", native: "Северна Македонија", phone: [389], continent: "EU", capital: "Skopje", currency: ["MKD"], languages: ["mk"] }, ML: { name: "Mali", native: "Mali", phone: [223], continent: "AF", capital: "Bamako", currency: ["XOF"], languages: ["fr"] }, MM: { name: "Myanmar (Burma)", native: "မြန်မာ", phone: [95], continent: "AS", capital: "Naypyidaw", currency: ["MMK"], languages: ["my"] }, MN: { name: "Mongolia", native: "Монгол улс", phone: [976], continent: "AS", capital: "Ulan Bator", currency: ["MNT"], languages: ["mn"] }, MO: { name: "Macao", native: "澳門", phone: [853], continent: "AS", capital: "", currency: ["MOP"], languages: ["zh", "pt"] }, MP: { name: "Northern Mariana Islands", native: "Northern Mariana Islands", phone: [1670], continent: "OC", capital: "Saipan", currency: ["USD"], languages: ["en", "ch"] }, MQ: { name: "Martinique", native: "Martinique", phone: [596], continent: "NA", capital: "Fort-de-France", currency: ["EUR"], languages: ["fr"] }, MR: { name: "Mauritania", native: "موريتانيا", phone: [222], continent: "AF", capital: "Nouakchott", currency: ["MRU"], languages: ["ar"] }, MS: { name: "Montserrat", native: "Montserrat", phone: [1664], continent: "NA", capital: "Plymouth", currency: ["XCD"], languages: ["en"] }, MT: { name: "Malta", native: "Malta", phone: [356], continent: "EU", capital: "Valletta", currency: ["EUR"], languages: ["mt", "en"] }, MU: { name: "Mauritius", native: "Maurice", phone: [230], continent: "AF", capital: "Port Louis", currency: ["MUR"], languages: ["en"] }, MV: { name: "Maldives", native: "Maldives", phone: [960], continent: "AS", capital: "Malé", currency: ["MVR"], languages: ["dv"] }, MW: { name: "Malawi", native: "Malawi", phone: [265], continent: "AF", capital: "Lilongwe", currency: ["MWK"], languages: ["en", "ny"] }, MX: { name: "Mexico", native: "México", phone: [52], continent: "NA", capital: "Mexico City", currency: ["MXN"], languages: ["es"] }, MY: { name: "Malaysia", native: "Malaysia", phone: [60], continent: "AS", capital: "Kuala Lumpur", currency: ["MYR"], languages: ["ms"] }, MZ: { name: "Mozambique", native: "Moçambique", phone: [258], continent: "AF", capital: "Maputo", currency: ["MZN"], languages: ["pt"] }, NA: { name: "Namibia", native: "Namibia", phone: [264], continent: "AF", capital: "Windhoek", currency: ["NAD", "ZAR"], languages: ["en", "af"] }, NC: { name: "New Caledonia", native: "Nouvelle-Calédonie", phone: [687], continent: "OC", capital: "Nouméa", currency: ["XPF"], languages: ["fr"] }, NE: { name: "Niger", native: "Niger", phone: [227], continent: "AF", capital: "Niamey", currency: ["XOF"], languages: ["fr"] }, NF: { name: "Norfolk Island", native: "Norfolk Island", phone: [672], continent: "OC", capital: "Kingston", currency: ["AUD"], languages: ["en"] }, NG: { name: "Nigeria", native: "Nigeria", phone: [234], continent: "AF", capital: "Abuja", currency: ["NGN"], languages: ["en"] }, NI: { name: "Nicaragua", native: "Nicaragua", phone: [505], continent: "NA", capital: "Managua", currency: ["NIO"], languages: ["es"] }, NL: { name: "Netherlands", native: "Nederland", phone: [31], continent: "EU", capital: "Amsterdam", currency: ["EUR"], languages: ["nl"] }, NO: { name: "Norway", native: "Norge", phone: [47], continent: "EU", capital: "Oslo", currency: ["NOK"], languages: ["no", "nb", "nn"] }, NP: { name: "Nepal", native: "नेपाल", phone: [977], continent: "AS", capital: "Kathmandu", currency: ["NPR"], languages: ["ne"] }, NR: { name: "Nauru", native: "Nauru", phone: [674], continent: "OC", capital: "Yaren", currency: ["AUD"], languages: ["en", "na"] }, NU: { name: "Niue", native: "Niuē", phone: [683], continent: "OC", capital: "Alofi", currency: ["NZD"], languages: ["en"] }, NZ: { name: "New Zealand", native: "New Zealand", phone: [64], continent: "OC", capital: "Wellington", currency: ["NZD"], languages: ["en", "mi"] }, OM: { name: "Oman", native: "عمان", phone: [968], continent: "AS", capital: "Muscat", currency: ["OMR"], languages: ["ar"] }, PA: { name: "Panama", native: "Panamá", phone: [507], continent: "NA", capital: "Panama City", currency: ["PAB", "USD"], languages: ["es"] }, PE: { name: "Peru", native: "Perú", phone: [51], continent: "SA", capital: "Lima", currency: ["PEN"], languages: ["es"] }, PF: { name: "French Polynesia", native: "Polynésie française", phone: [689], continent: "OC", capital: "Papeetē", currency: ["XPF"], languages: ["fr"] }, PG: { name: "Papua New Guinea", native: "Papua Niugini", phone: [675], continent: "OC", capital: "Port Moresby", currency: ["PGK"], languages: ["en"] }, PH: { name: "Philippines", native: "Pilipinas", phone: [63], continent: "AS", capital: "Manila", currency: ["PHP"], languages: ["en"] }, PK: { name: "Pakistan", native: "Pakistan", phone: [92], continent: "AS", capital: "Islamabad", currency: ["PKR"], languages: ["en", "ur"] }, PL: { name: "Poland", native: "Polska", phone: [48], continent: "EU", capital: "Warsaw", currency: ["PLN"], languages: ["pl"] }, PM: { name: "Saint Pierre and Miquelon", native: "Saint-Pierre-et-Miquelon", phone: [508], continent: "NA", capital: "Saint-Pierre", currency: ["EUR"], languages: ["fr"] }, PN: { name: "Pitcairn Islands", native: "Pitcairn Islands", phone: [64], continent: "OC", capital: "Adamstown", currency: ["NZD"], languages: ["en"] }, PR: { name: "Puerto Rico", native: "Puerto Rico", phone: [1787, 1939], continent: "NA", capital: "San Juan", currency: ["USD"], languages: ["es", "en"] }, PS: { name: "Palestine", native: "فلسطين", phone: [970], continent: "AS", capital: "Ramallah", currency: ["ILS"], languages: ["ar"] }, PT: { name: "Portugal", native: "Portugal", phone: [351], continent: "EU", capital: "Lisbon", currency: ["EUR"], languages: ["pt"] }, PW: { name: "Palau", native: "Palau", phone: [680], continent: "OC", capital: "Ngerulmud", currency: ["USD"], languages: ["en"] }, PY: { name: "Paraguay", native: "Paraguay", phone: [595], continent: "SA", capital: "Asunción", currency: ["PYG"], languages: ["es", "gn"] }, QA: { name: "Qatar", native: "قطر", phone: [974], continent: "AS", capital: "Doha", currency: ["QAR"], languages: ["ar"] }, RE: { name: "Reunion", native: "La Réunion", phone: [262], continent: "AF", capital: "Saint-Denis", currency: ["EUR"], languages: ["fr"] }, RO: { name: "Romania", native: "România", phone: [40], continent: "EU", capital: "Bucharest", currency: ["RON"], languages: ["ro"] }, RS: { name: "Serbia", native: "Србија", phone: [381], continent: "EU", capital: "Belgrade", currency: ["RSD"], languages: ["sr"] }, RU: { name: "Russia", native: "Россия", phone: [7], continent: "AS", continents: ["AS", "EU"], capital: "Moscow", currency: ["RUB"], languages: ["ru"] }, RW: { name: "Rwanda", native: "Rwanda", phone: [250], continent: "AF", capital: "Kigali", currency: ["RWF"], languages: ["rw", "en", "fr"] }, SA: { name: "Saudi Arabia", native: "العربية السعودية", phone: [966], continent: "AS", capital: "Riyadh", currency: ["SAR"], languages: ["ar"] }, SB: { name: "Solomon Islands", native: "Solomon Islands", phone: [677], continent: "OC", capital: "Honiara", currency: ["SBD"], languages: ["en"] }, SC: { name: "Seychelles", native: "Seychelles", phone: [248], continent: "AF", capital: "Victoria", currency: ["SCR"], languages: ["fr", "en"] }, SD: { name: "Sudan", native: "السودان", phone: [249], continent: "AF", capital: "Khartoum", currency: ["SDG"], languages: ["ar", "en"] }, SE: { name: "Sweden", native: "Sverige", phone: [46], continent: "EU", capital: "Stockholm", currency: ["SEK"], languages: ["sv"] }, SG: { name: "Singapore", native: "Singapore", phone: [65], continent: "AS", capital: "Singapore", currency: ["SGD"], languages: ["en", "ms", "ta", "zh"] }, SH: { name: "Saint Helena", native: "Saint Helena", phone: [290], continent: "AF", capital: "Jamestown", currency: ["SHP"], languages: ["en"] }, SI: { name: "Slovenia", native: "Slovenija", phone: [386], continent: "EU", capital: "Ljubljana", currency: ["EUR"], languages: ["sl"] }, SJ: { name: "Svalbard and Jan Mayen", native: "Svalbard og Jan Mayen", phone: [4779], continent: "EU", capital: "Longyearbyen", currency: ["NOK"], languages: ["no"] }, SK: { name: "Slovakia", native: "Slovensko", phone: [421], continent: "EU", capital: "Bratislava", currency: ["EUR"], languages: ["sk"] }, SL: { name: "Sierra Leone", native: "Sierra Leone", phone: [232], continent: "AF", capital: "Freetown", currency: ["SLL"], languages: ["en"] }, SM: { name: "San Marino", native: "San Marino", phone: [378], continent: "EU", capital: "City of San Marino", currency: ["EUR"], languages: ["it"] }, SN: { name: "Senegal", native: "Sénégal", phone: [221], continent: "AF", capital: "Dakar", currency: ["XOF"], languages: ["fr"] }, SO: { name: "Somalia", native: "Soomaaliya", phone: [252], continent: "AF", capital: "Mogadishu", currency: ["SOS"], languages: ["so", "ar"] }, SR: { name: "Suriname", native: "Suriname", phone: [597], continent: "SA", capital: "Paramaribo", currency: ["SRD"], languages: ["nl"] }, SS: { name: "South Sudan", native: "South Sudan", phone: [211], continent: "AF", capital: "Juba", currency: ["SSP"], languages: ["en"] }, ST: { name: "Sao Tome and Principe", native: "São Tomé e Príncipe", phone: [239], continent: "AF", capital: "São Tomé", currency: ["STN"], languages: ["pt"] }, SV: { name: "El Salvador", native: "El Salvador", phone: [503], continent: "NA", capital: "San Salvador", currency: ["SVC", "USD"], languages: ["es"] }, SX: { name: "Sint Maarten", native: "Sint Maarten", phone: [1721], continent: "NA", capital: "Philipsburg", currency: ["ANG"], languages: ["nl", "en"] }, SY: { name: "Syria", native: "سوريا", phone: [963], continent: "AS", capital: "Damascus", currency: ["SYP"], languages: ["ar"] }, SZ: { name: "Eswatini", native: "Eswatini", phone: [268], continent: "AF", capital: "Lobamba", currency: ["SZL"], languages: ["en", "ss"] }, TC: { name: "Turks and Caicos Islands", native: "Turks and Caicos Islands", phone: [1649], continent: "NA", capital: "Cockburn Town", currency: ["USD"], languages: ["en"] }, TD: { name: "Chad", native: "Tchad", phone: [235], continent: "AF", capital: "N'Djamena", currency: ["XAF"], languages: ["fr", "ar"] }, TF: { name: "French Southern Territories", native: "Territoire des Terres australes et antarctiques fr", phone: [262], continent: "AN", capital: "Port-aux-Français", currency: ["EUR"], languages: ["fr"] }, TG: { name: "Togo", native: "Togo", phone: [228], continent: "AF", capital: "Lomé", currency: ["XOF"], languages: ["fr"] }, TH: { name: "Thailand", native: "ประเทศไทย", phone: [66], continent: "AS", capital: "Bangkok", currency: ["THB"], languages: ["th"] }, TJ: { name: "Tajikistan", native: "Тоҷикистон", phone: [992], continent: "AS", capital: "Dushanbe", currency: ["TJS"], languages: ["tg", "ru"] }, TK: { name: "Tokelau", native: "Tokelau", phone: [690], continent: "OC", capital: "Fakaofo", currency: ["NZD"], languages: ["en"] }, TL: { name: "East Timor", native: "Timor-Leste", phone: [670], continent: "OC", capital: "Dili", currency: ["USD"], languages: ["pt"] }, TM: { name: "Turkmenistan", native: "Türkmenistan", phone: [993], continent: "AS", capital: "Ashgabat", currency: ["TMT"], languages: ["tk", "ru"] }, TN: { name: "Tunisia", native: "تونس", phone: [216], continent: "AF", capital: "Tunis", currency: ["TND"], languages: ["ar"] }, TO: { name: "Tonga", native: "Tonga", phone: [676], continent: "OC", capital: "Nuku'alofa", currency: ["TOP"], languages: ["en", "to"] }, TR: { name: "Turkey", native: "Türkiye", phone: [90], continent: "AS", continents: ["AS", "EU"], capital: "Ankara", currency: ["TRY"], languages: ["tr"] }, TT: { name: "Trinidad and Tobago", native: "Trinidad and Tobago", phone: [1868], continent: "NA", capital: "Port of Spain", currency: ["TTD"], languages: ["en"] }, TV: { name: "Tuvalu", native: "Tuvalu", phone: [688], continent: "OC", capital: "Funafuti", currency: ["AUD"], languages: ["en"] }, TW: { name: "Taiwan", native: "臺灣", phone: [886], continent: "AS", capital: "Taipei", currency: ["TWD"], languages: ["zh"] }, TZ: { name: "Tanzania", native: "Tanzania", phone: [255], continent: "AF", capital: "Dodoma", currency: ["TZS"], languages: ["sw", "en"] }, UA: { name: "Ukraine", native: "Україна", phone: [380], continent: "EU", capital: "Kyiv", currency: ["UAH"], languages: ["uk"] }, UG: { name: "Uganda", native: "Uganda", phone: [256], continent: "AF", capital: "Kampala", currency: ["UGX"], languages: ["en", "sw"] }, UM: { name: "U.S. Minor Outlying Islands", native: "United States Minor Outlying Islands", phone: [1], continent: "OC", capital: "", currency: ["USD"], languages: ["en"] }, US: { name: "United States", native: "United States", phone: [1], continent: "NA", capital: "Washington D.C.", currency: ["USD", "USN", "USS"], languages: ["en"] }, UY: { name: "Uruguay", native: "Uruguay", phone: [598], continent: "SA", capital: "Montevideo", currency: ["UYI", "UYU"], languages: ["es"] }, UZ: { name: "Uzbekistan", native: "O'zbekiston", phone: [998], continent: "AS", capital: "Tashkent", currency: ["UZS"], languages: ["uz", "ru"] }, VA: { name: "Vatican City", native: "Vaticano", phone: [379], continent: "EU", capital: "Vatican City", currency: ["EUR"], languages: ["it", "la"] }, VC: { name: "Saint Vincent and the Grenadines", native: "Saint Vincent and the Grenadines", phone: [1784], continent: "NA", capital: "Kingstown", currency: ["XCD"], languages: ["en"] }, VE: { name: "Venezuela", native: "Venezuela", phone: [58], continent: "SA", capital: "Caracas", currency: ["VES"], languages: ["es"] }, VG: { name: "British Virgin Islands", native: "British Virgin Islands", phone: [1284], continent: "NA", capital: "Road Town", currency: ["USD"], languages: ["en"] }, VI: { name: "U.S. Virgin Islands", native: "United States Virgin Islands", phone: [1340], continent: "NA", capital: "Charlotte Amalie", currency: ["USD"], languages: ["en"] }, VN: { name: "Vietnam", native: "Việt Nam", phone: [84], continent: "AS", capital: "Hanoi", currency: ["VND"], languages: ["vi"] }, VU: { name: "Vanuatu", native: "Vanuatu", phone: [678], continent: "OC", capital: "Port Vila", currency: ["VUV"], languages: ["bi", "en", "fr"] }, WF: { name: "Wallis and Futuna", native: "Wallis et Futuna", phone: [681], continent: "OC", capital: "Mata-Utu", currency: ["XPF"], languages: ["fr"] }, WS: { name: "Samoa", native: "Samoa", phone: [685], continent: "OC", capital: "Apia", currency: ["WST"], languages: ["sm", "en"] }, XK: { name: "Kosovo", native: "Republika e Kosovës", phone: [377, 381, 383, 386], continent: "EU", capital: "Pristina", currency: ["EUR"], languages: ["sq", "sr"], userAssigned: !0 }, YE: { name: "Yemen", native: "اليَمَن", phone: [967], continent: "AS", capital: "Sana'a", currency: ["YER"], languages: ["ar"] }, YT: { name: "Mayotte", native: "Mayotte", phone: [262], continent: "AF", capital: "Mamoudzou", currency: ["EUR"], languages: ["fr"] }, ZA: { name: "South Africa", native: "South Africa", phone: [27], continent: "AF", capital: "Pretoria", currency: ["ZAR"], languages: ["af", "en", "nr", "st", "ss", "tn", "ts", "ve", "xh", "zu"] }, ZM: { name: "Zambia", native: "Zambia", phone: [260], continent: "AF", capital: "Lusaka", currency: ["ZMW"], languages: ["en"] }, ZW: { name: "Zimbabwe", native: "Zimbabwe", phone: [263], continent: "AF", capital: "Harare", currency: ["USD", "ZAR", "BWP", "GBP", "AUD", "CNY", "INR", "JPY"], languages: ["en", "sn", "nd"] } }, N6 = { AD: "AND", AE: "ARE", AF: "AFG", AG: "ATG", AI: "AIA", AL: "ALB", AM: "ARM", AO: "AGO", AQ: "ATA", AR: "ARG", AS: "ASM", AT: "AUT", AU: "AUS", AW: "ABW", AX: "ALA", AZ: "AZE", BA: "BIH", BB: "BRB", BD: "BGD", BE: "BEL", BF: "BFA", BG: "BGR", BH: "BHR", BI: "BDI", BJ: "BEN", BL: "BLM", BM: "BMU", BN: "BRN", BO: "BOL", BQ: "BES", BR: "BRA", BS: "BHS", BT: "BTN", BV: "BVT", BW: "BWA", BY: "BLR", BZ: "BLZ", CA: "CAN", CC: "CCK", CD: "COD", CF: "CAF", CG: "COG", CH: "CHE", CI: "CIV", CK: "COK", CL: "CHL", CM: "CMR", CN: "CHN", CO: "COL", CR: "CRI", CU: "CUB", CV: "CPV", CW: "CUW", CX: "CXR", CY: "CYP", CZ: "CZE", DE: "DEU", DJ: "DJI", DK: "DNK", DM: "DMA", DO: "DOM", DZ: "DZA", EC: "ECU", EE: "EST", EG: "EGY", EH: "ESH", ER: "ERI", ES: "ESP", ET: "ETH", FI: "FIN", FJ: "FJI", FK: "FLK", FM: "FSM", FO: "FRO", FR: "FRA", GA: "GAB", GB: "GBR", GD: "GRD", GE: "GEO", GF: "GUF", GG: "GGY", GH: "GHA", GI: "GIB", GL: "GRL", GM: "GMB", GN: "GIN", GP: "GLP", GQ: "GNQ", GR: "GRC", GS: "SGS", GT: "GTM", GU: "GUM", GW: "GNB", GY: "GUY", HK: "HKG", HM: "HMD", HN: "HND", HR: "HRV", HT: "HTI", HU: "HUN", ID: "IDN", IE: "IRL", IL: "ISR", IM: "IMN", IN: "IND", IO: "IOT", IQ: "IRQ", IR: "IRN", IS: "ISL", IT: "ITA", JE: "JEY", JM: "JAM", JO: "JOR", JP: "JPN", KE: "KEN", KG: "KGZ", KH: "KHM", KI: "KIR", KM: "COM", KN: "KNA", KP: "PRK", KR: "KOR", KW: "KWT", KY: "CYM", KZ: "KAZ", LA: "LAO", LB: "LBN", LC: "LCA", LI: "LIE", LK: "LKA", LR: "LBR", LS: "LSO", LT: "LTU", LU: "LUX", LV: "LVA", LY: "LBY", MA: "MAR", MC: "MCO", MD: "MDA", ME: "MNE", MF: "MAF", MG: "MDG", MH: "MHL", MK: "MKD", ML: "MLI", MM: "MMR", MN: "MNG", MO: "MAC", MP: "MNP", MQ: "MTQ", MR: "MRT", MS: "MSR", MT: "MLT", MU: "MUS", MV: "MDV", MW: "MWI", MX: "MEX", MY: "MYS", MZ: "MOZ", NA: "NAM", NC: "NCL", NE: "NER", NF: "NFK", NG: "NGA", NI: "NIC", NL: "NLD", NO: "NOR", NP: "NPL", NR: "NRU", NU: "NIU", NZ: "NZL", OM: "OMN", PA: "PAN", PE: "PER", PF: "PYF", PG: "PNG", PH: "PHL", PK: "PAK", PL: "POL", PM: "SPM", PN: "PCN", PR: "PRI", PS: "PSE", PT: "PRT", PW: "PLW", PY: "PRY", QA: "QAT", RE: "REU", RO: "ROU", RS: "SRB", RU: "RUS", RW: "RWA", SA: "SAU", SB: "SLB", SC: "SYC", SD: "SDN", SE: "SWE", SG: "SGP", SH: "SHN", SI: "SVN", SJ: "SJM", SK: "SVK", SL: "SLE", SM: "SMR", SN: "SEN", SO: "SOM", SR: "SUR", SS: "SSD", ST: "STP", SV: "SLV", SX: "SXM", SY: "SYR", SZ: "SWZ", TC: "TCA", TD: "TCD", TF: "ATF", TG: "TGO", TH: "THA", TJ: "TJK", TK: "TKL", TL: "TLS", TM: "TKM", TN: "TUN", TO: "TON", TR: "TUR", TT: "TTO", TV: "TUV", TW: "TWN", TZ: "TZA", UA: "UKR", UG: "UGA", UM: "UMI", US: "USA", UY: "URY", UZ: "UZB", VA: "VAT", VC: "VCT", VE: "VEN", VG: "VGB", VI: "VIR", VN: "VNM", VU: "VUT", WF: "WLF", WS: "WSM", XK: "XKX", YE: "YEM", YT: "MYT", ZA: "ZAF", ZM: "ZMB", ZW: "ZWE" }, $6 = (e) => ({ ...cr[e], iso2: e, iso3: N6[e] }), D6 = () => Object.keys(cr).map((e) => $6(e));
D6();
const I6 = Ps().map((e) => {
  const t = cr[e], r = t ? t.name : e, n = w2(e);
  return {
    text: `${r} (+${n})`,
    value: e,
    countryCode: e,
    countryCallingCode: n
  };
}), A6 = {
  modelValue: {
    type: String,
    required: !0
  },
  placeholder: {
    type: String,
    default: "Enter Phone Number"
  },
  preSelectedCountryCode: {
    type: String,
    default: "PH"
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  disabledCountryCallingCode: {
    type: Boolean,
    default: !1
  }
}, x6 = {
  "update:modelValue": (e) => typeof e == "string",
  getSelectedCountryCallingCode: (e) => typeof e.countryCode == "string" && typeof e.countryCallingCode == "string",
  getParsedInternationalNumber: (e) => typeof e == "string",
  getContactNumberErrors: (e) => Array.isArray(e) && e.every(
    (t) => t !== null && typeof t == "object" && typeof t.title == "string" && typeof t.message == "string"
  )
}, w6 = /* @__PURE__ */ ae({
  __name: "input-contact-number",
  props: A6,
  emits: x6,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      inputContactNumberClasses: s,
      formattedValue: a,
      selectedCountry: i,
      popperState: l,
      handleContactNumberInput: u,
      handleSelectedCountryCode: d,
      formatContactNumber: c,
      handleUpdateModelValue: p,
      handlePopperState: h
    } = b6(r, n);
    return (y, M) => (f(), K(Ee, Ye({
      modelValue: o(a),
      "onUpdate:modelValue": M[1] || (M[1] = (g) => fe(a) ? a.value = g : null)
    }, y.$attrs, {
      type: "contact-number",
      placeholder: r.placeholder,
      active: o(l),
      disabled: r.disabled,
      onKeyup: o(u),
      onBlur: o(c),
      "onUpdate:modelValue": o(p)
    }), {
      prefix: H(() => [
        R(e0, {
          id: "contact-number-country-dropdown",
          modelValue: o(i).countryCode,
          "onUpdate:modelValue": [
            M[0] || (M[0] = (g) => o(i).countryCode = g),
            o(d)
          ],
          class: "[&>#dropdown-wrapper]:spr-my-1",
          "menu-list": o(I6),
          placement: "bottom-start",
          width: r.disabledCountryCallingCode ? "35px" : "45px",
          "popper-width": "330px",
          disabled: r.disabled || r.disabledCountryCallingCode,
          onGetPopperState: o(h)
        }, {
          default: H(() => [
            A("span", {
              class: x(o(s).countryCallingCodeClasses)
            }, [
              Oe(" +" + G(o(i).countryCallingCode[0]) + " ", 1),
              r.disabledCountryCallingCode ? _("", !0) : (f(), K(o(W), {
                key: 0,
                icon: "ph:caret-down",
                width: "16px",
                height: "16px"
              }))
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue", "menu-list", "width", "disabled", "onUpdate:modelValue", "onGetPopperState"])
      ]),
      _: 1
    }, 16, ["modelValue", "placeholder", "active", "disabled", "onKeyup", "onBlur", "onUpdate:modelValue"]));
  }
}), S6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: w6
}, Symbol.toStringTag, { value: "Module" })), j6 = /* @__PURE__ */ ae({
  __name: "input-dropdown",
  setup(e) {
    return (t, r) => (f(), K(Ee, Ye(t.$attrs, {
      class: { "spr-cursor-pointer": t.$attrs.readonly === "" || t.$attrs.readonly === "true" || t.$attrs.readonly }
    }), {
      icon: H(() => [
        R(o(W), { icon: "ph:caret-down" })
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), T6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j6
}, Symbol.toStringTag, { value: "Module" })), O6 = /* @__PURE__ */ ae({
  __name: "input-email",
  setup(e) {
    return (t, r) => (f(), K(Ee, Q2(H2(t.$attrs)), Pt({
      prefix: H(() => [
        R(o(W), { icon: "ph:envelope" })
      ]),
      _: 2
    }, [
      le(t.$slots, (n, s) => ({
        name: s,
        fn: H(() => [
          ee(t.$slots, s)
        ])
      }))
    ]), 1040));
  }
}), _6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: O6
}, Symbol.toStringTag, { value: "Module" })), z6 = () => {
  const e = B(!1), t = F(() => e.value ? "ph:eye" : "ph:eye-closed"), r = F(() => e.value ? "text" : "password");
  return {
    showPassword: e,
    evaluateEyeIcon: t,
    evaluatePasswordInputType: r
  };
}, L6 = /* @__PURE__ */ ae({
  __name: "input-password",
  setup(e) {
    const { showPassword: t, evaluateEyeIcon: r, evaluatePasswordInputType: n } = z6();
    return (s, a) => (f(), K(Ee, Ye(s.$attrs, { type: o(n) }), Pt({
      icon: H(() => [
        R(o(W), {
          icon: o(r),
          class: x(["spr-cursor-pointer spr-transition spr-duration-150 spr-ease-in-out", "hover:spr-text-color-base"]),
          onClick: a[0] || (a[0] = (i) => t.value = !o(t))
        }, null, 8, ["icon"])
      ]),
      _: 2
    }, [
      le(s.$slots, (i, l) => ({
        name: l,
        fn: H(() => [
          ee(s.$slots, l)
        ])
      }))
    ]), 1040, ["type"]));
  }
}), k6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L6
}, Symbol.toStringTag, { value: "Module" })), E6 = /* @__PURE__ */ ae({
  __name: "input-url",
  setup(e) {
    return (t, r) => (f(), K(Ee, Ye(t.$attrs, { type: "url" }), Pt({
      prefix: H(() => [
        r[0] || (r[0] = A("span", null, " https:// ", -1))
      ]),
      icon: H(() => [
        R(o(W), { icon: "ph:question-fill" })
      ]),
      _: 2
    }, [
      le(t.$slots, (n, s) => ({
        name: s,
        fn: H(() => [
          ee(t.$slots, s)
        ])
      }))
    ]), 1040));
  }
}), P6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E6
}, Symbol.toStringTag, { value: "Module" })), Y6 = /* @__PURE__ */ ae({
  __name: "input-username",
  setup(e) {
    return (t, r) => (f(), K(Ee, Q2(H2(t.$attrs)), Pt({
      prefix: H(() => [
        R(o(W), { icon: "ph:user" })
      ]),
      _: 2
    }, [
      le(t.$slots, (n, s) => ({
        name: s,
        fn: H(() => [
          ee(t.$slots, s)
        ])
      }))
    ]), 1040));
  }
}), U6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y6
}, Symbol.toStringTag, { value: "Module" }));
function F6(e) {
  return !(typeof e != "object" || e instanceof Array);
}
class B6 {
  filterOutNonSupportedKeys(t, r) {
    const n = /* @__PURE__ */ Object.create({});
    return F6(t) ? (Object.keys(t).forEach((s) => {
      r.indexOf(s) >= 0 ? n[s] = t[s] : console.warn("Warning - unsupported key provided to configuration: ", s);
    }), n) : /* @__PURE__ */ Object.create({});
  }
}
const wn = [
  "cname",
  "secureDistribution",
  "privateCdn",
  "signUrl",
  "longUrlSignature",
  "shorten",
  "useRootPath",
  "secure",
  "forceVersion",
  "analytics",
  "queryParams"
];
class pr extends B6 {
  /**
   * @param {IURLConfig} userURLConfig
   */
  constructor(t) {
    super();
    const r = this.filterOutNonSupportedKeys(t, wn);
    Object.assign(this, {
      secure: !0
    }, r);
  }
  extend(t) {
    const r = this.filterOutNonSupportedKeys(t, wn);
    return new pr(Object.assign({}, this, r));
  }
  /**
   * @param {string} value Sets the cname
   */
  setCname(t) {
    return this.cname = t, this;
  }
  /**
   * @param {string} value Sets the secureDistribution
   */
  setSecureDistribution(t) {
    return this.secureDistribution = t, this;
  }
  /**
   * @param {boolean} value Sets whether to use a private CDN (Removes cloudName from URL)
   */
  setPrivateCdn(t) {
    return this.privateCdn = t, this;
  }
  /**
   * @param value Sets whether or not to sign the URL
   */
  setSignUrl(t) {
    return this.signUrl = t, this;
  }
  /**
   * @param value Sets whether or not to use a long signature
   */
  setLongUrlSignature(t) {
    return this.longUrlSignature = t, this;
  }
  /**
   * @param value Sets whether or not to shorten the URL
   */
  setShorten(t) {
    return this.shorten = t, this;
  }
  /**
   * @param value Sets whether or not to use a root path
   */
  setUseRootPath(t) {
    return this.useRootPath = t, this;
  }
  /**
   * @param value Sets whether or not to deliver the asset through https
   */
  setSecure(t) {
    return this.secure = t, this;
  }
  /**
   * @param value Sets whether to force a version in the URL
   */
  setForceVersion(t) {
    return this.forceVersion = t, this;
  }
  /**
   * @param params Sets additional params
   */
  setQueryParams(t) {
    return this.queryParams = t, this;
  }
}
class l2 {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(t) {
    this.values = [], this.delimiter = ":", this.hasValue(t) && this.addValue(t);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(t) {
    return typeof t < "u" && t !== null && t !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(t) {
    return Array.isArray(t) ? this.values = this.values.concat(t) : this.values.push(t), this.values = this.values.filter((r) => this.hasValue(r)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(t) {
    return this.delimiter = t, this;
  }
}
class R6 extends Error {
  constructor(t = "Unsupported") {
    super(t);
  }
}
function fr(e) {
  return new R6(e);
}
function V6() {
  return this._qualifierModel || { error: fr(`unsupported qualifier ${this.constructor.name}`) };
}
class Q6 {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return V6.apply(this);
  }
}
class s0 extends Q6 {
  constructor(t, r) {
    super(), this.delimiter = "_", this.key = t, r instanceof l2 ? this.qualifierValue = r : (this.qualifierValue = new l2(), this.qualifierValue.addValue(r));
  }
  toString() {
    const { key: t, delimiter: r, qualifierValue: n } = this;
    return `${t}${r}${n.toString()}`;
  }
  addValue(t) {
    return this.qualifierValue.addValue(t), this;
  }
}
class pt extends s0 {
  constructor(t, r) {
    let n;
    r ? n = new l2([t, `${r}`]).setDelimiter(":") : n = t, super("fl", n), this.flagValue = r;
  }
  toString() {
    return super.toString().replace(/\./g, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
}
function H6(e, t) {
  const r = Array.from(e.entries());
  return t.forEach((n) => {
    r.push(["fl", n]);
  }), r.sort().map((n) => n[1]);
}
function Z6() {
  var e, t, r;
  const n = this._actionModel && Object.keys(this._actionModel).length, s = (r = (t = (e = this._actionModel) === null || e === void 0 ? void 0 : e.source) === null || t === void 0 ? void 0 : t.transformation) === null || r === void 0 ? void 0 : r.error;
  return s && s instanceof Error ? { error: s } : n ? this._actionModel : { error: fr(`unsupported action ${this.constructor.name}`) };
}
class G6 {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return Z6.apply(this);
  }
}
class gr extends G6 {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(t) {
    return this.actionTag = t, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), H6(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(t) {
    if (typeof t == "string") {
      const [r, n] = t.toLowerCase().split("_");
      r === "fl" ? this.flags.push(new pt(n)) : this.qualifiers.set(r, new s0(r, n));
    } else
      this.qualifiers.set(t.key, t);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(t) {
    return typeof t == "string" ? this.flags.push(new pt(t)) : t instanceof pt && this.flags.push(t), this;
  }
  addValueToQualifier(t, r) {
    return this.qualifiers.get(t).addValue(r), this;
  }
}
function W6(e) {
  return e && (e.match(/^#/) ? `rgb:${e.substr(1)}` : e);
}
class K6 extends gr {
  constructor(t) {
    super(), this._actionModel = {}, this.addQualifier(new s0("b", new l2(W6(t)).setDelimiter("_"))), this._actionModel.color = t, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(t) {
    const { color: r } = t;
    return new this(r);
  }
}
class Sn {
  constructor(t) {
    this.raw = t;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: fr(`unsupported action ${this.constructor.name}`) };
  }
}
function J6(e) {
  const t = e;
  return "error" in t && !!t.error;
}
function X6() {
  return new pt("lossy");
}
function q6() {
  return new pt("preserve_transparency");
}
function e5(e) {
  return new pt("progressive", e);
}
class t5 extends l2 {
  constructor(t) {
    super(t), this.val = t;
  }
  getValue() {
    return this.val;
  }
}
function xt(e) {
  const t = {};
  return Object.keys(e).forEach((r) => {
    t[e[r]] = r;
  }), t;
}
const r5 = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad",
  autoPad: "auto_pad"
}, n5 = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, s5 = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, a5 = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, o5 = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, i5 = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, l5 = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
};
xt(i5);
xt(l5);
xt(r5);
const u5 = xt(n5);
xt(s5);
xt(a5);
xt(o5);
class d5 extends gr {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(t, r, n) {
    super(), this._actionModel = {};
    let s;
    r instanceof t5 ? s = r.getValue() : s = r, this._actionModel.actionType = u5[t], this._actionModel[n] = s, this.addQualifier(new s0(t, r));
  }
}
class c5 extends pt {
  constructor(t) {
    super("progressive", t);
  }
}
class F2 extends d5 {
  constructor(t, r) {
    super(t, r, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(X6()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(t) {
    return t instanceof c5 ? (this._actionModel.progressive = { mode: t.getFlagValue() }, this.addFlag(t)) : (this._actionModel.progressive = { mode: t }, this.addFlag(e5(t))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag(q6()), this;
  }
  static fromJson(t) {
    const { formatType: r, lossy: n, progressive: s, preserveTransparency: a } = t;
    let i;
    return r ? i = new this("f", r) : i = new this("f"), s && (s.mode ? i.progressive(s.mode) : i.progressive()), n && i.lossy(), a && i.preserveTransparency(), i;
  }
}
class a0 {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(t) {
    let r;
    if (typeof t == "string") {
      if (t.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      r = new Sn(t);
    } else
      r = t;
    return this.actions.push(r), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(t) {
    return t instanceof a0 ? this.actions = this.actions.concat(t.actions) : this.actions.push(new Sn(t)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((t) => t.toString()).filter((t) => t).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(t) {
    return this.addAction(t);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(t) {
    return this.addAction(t);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(t) {
    return this.addAction(t);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(t) {
    return this.addAction(new F2("q", t)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(t) {
    return this.addAction(new F2("f", t)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(t) {
    return t.setLayerType("u"), this.addAction(t);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(t) {
    return this.addAction(t);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(t) {
    return this.addAction(t);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(t) {
    return this.addAction(t);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(t) {
    return this.addAction(new K6(t));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(t) {
    return this.addAction(t);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(t) {
    const r = new gr();
    let n = t;
    return typeof t == "string" && (n = new pt(t)), r.addQualifier(n), this.addAction(r);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(t) {
    return this.addAction(t);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(t) {
    return this.addAction(t);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(t) {
    return this.addAction(t);
  }
  toJson() {
    const t = [];
    for (const r of this.actions) {
      const n = r.toJson();
      if (J6(n))
        return n;
      t.push(n);
    }
    return { actions: t };
  }
}
class p5 extends a0 {
}
class f5 extends a0 {
}
function g5(e) {
  return e.match(/^https?:\//);
}
function h5(e) {
  return e.indexOf("/") < 0;
}
function y5(e) {
  return e.match(/^v[0-9]+/);
}
function C5(e, t) {
  const r = t.secure, n = t.privateCdn, s = t.cname, a = t.secureDistribution;
  return !r && !s ? `http://res.cloudinary.com/${e}` : r && !a && n ? `https://${e}-res.cloudinary.com` : r && !a ? `https://res.cloudinary.com/${e}` : r && a && n ? `https://${a}` : r && a ? `https://${a}/${e}` : !r && s ? `http://${s}/${e}` : "ERROR";
}
function v5(e) {
  return e || "image";
}
function m5(e) {
  return e || "upload";
}
function M5(e, t, r) {
  const n = r !== !1;
  return t ? `v${t}` : y5(e) || g5(e) || h5(e) ? "" : n ? "v1" : "";
}
function hr(e, t, r) {
  let n = t >> 0, s = String(r);
  return e.length > n ? String(e) : (n = n - e.length, n > s.length && (s += b5(s, n / s.length)), s.slice(0, n) + String(e));
}
function b5(e, t) {
  let r = t, n = "";
  for (; r > 0; )
    n += e, r--;
  return n;
}
const N5 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", B2 = {};
let jn = 0;
N5.split("").forEach((e) => {
  let t = jn.toString(2);
  t = hr(t, 6, "0"), B2[t] = e, jn++;
});
function $5(e) {
  if (e.split(".").length < 2)
    throw new Error("invalid semVer, must have at least two segments");
  return e.split(".").reverse().join(".");
}
function D5(e) {
  if (e.split(".").length < 2)
    throw new Error("invalid semVer, must have at least two segments");
  return e.split(".").map((t) => {
    const r = +t;
    if (isNaN(r) || r < 0)
      throw "Invalid version number provided";
    return hr(t, 2, "0");
  }).join(".");
}
function Tn(e) {
  let t = "";
  const n = e.split(".").length * 6, s = $5(e), a = D5(s);
  let l = parseInt(a.split(".").join("")).toString(2);
  if (l = hr(l, n, "0"), l.length % 6 !== 0)
    throw "Version must be smaller than 43.21.26)";
  return l.match(/.{1,6}/g).forEach((u) => {
    t += B2[u];
  }), t;
}
function I5(e) {
  const t = {
    sdkSemver: e.sdkSemver,
    techVersion: e.techVersion,
    sdkCode: e.sdkCode,
    product: e.product,
    feature: "0",
    osType: e.osType,
    osVersion: e.osVersion
  };
  return e.accessibility && (t.feature = "D"), e.lazyload && (t.feature = "C"), e.responsive && (t.feature = "A"), e.placeholder && (t.feature = "B"), t;
}
const A5 = "1.21.0";
function x5(e) {
  const [t, r] = e.split("."), n = parseInt(t).toString(2), s = parseInt(r).toString(2), a = n.padStart(6, "0"), i = s.padStart(6, "0");
  return B2[a] + B2[i];
}
function w5() {
  const e = "0.0.0";
  if (typeof window < "u")
    return e;
  try {
    return process.versions.node || e;
  } catch {
    return e;
  }
}
function S5(e) {
  const t = {
    techVersion: w5(),
    sdkCode: "T",
    sdkSemver: A5.split("-")[0],
    product: "A",
    osType: "Z",
    osVersion: "0.0",
    responsive: !1,
    placeholder: !1,
    lazyload: !1,
    accessibility: !1
  };
  return e ? Object.assign(Object.assign({}, t), e) : t;
}
function On(e) {
  const t = S5(e), r = I5(t);
  try {
    const n = j5(r.techVersion), s = Tn(r.sdkSemver), a = Tn(n), i = x5(r.osVersion), l = r.feature, u = r.sdkCode, { product: d, osType: c } = r;
    return `D${d}${u}${s}${a}${c}${i}${l}`;
  } catch {
    return "E";
  }
}
function j5(e) {
  const t = e.split(".");
  return `${t[0]}.${t[1]}`;
}
const _n = {
  "image/upload": "images",
  "image/private": "private_images",
  "image/authenticated": "authenticated_images",
  "raw/upload": "files",
  "video/upload": "videos"
};
class T5 {
  constructor(t, r = {}, n) {
    this.setPublicID(t), this.setCloudConfig(r), this.setURLConfig(n);
  }
  /**
   * @description Sets the URL Config for this asset
   * @param urlConfig
   * @return {this}
   */
  setURLConfig(t) {
    return this.urlConfig = new pr(t), this;
  }
  /**
   * @description Sets the Cloud Config for this asset
   * @param urlConfig
   * @return {this}
   */
  setCloudConfig(t) {
    return this.cloudName = t.cloudName, this.apiKey = t.apiKey, this.apiSecret = t.apiSecret, this.authToken = t.authToken, this;
  }
  /**
   * @description Sets the public ID of the asset.
   * @param {string} publicID The public ID of the asset.
   * @return {this}
   */
  setPublicID(t) {
    return this.publicID = t ? t.toString() : "", this;
  }
  /**
   * @description Sets the delivery type of the asset.
   * @param {DELIVERY_TYPE | string} newType The type of the asset.
   * @return {this}
   */
  setDeliveryType(t) {
    return this.deliveryType = t, this;
  }
  /**
   * @description Sets the URL SEO suffix of the asset.
   * @param {string} newSuffix The SEO suffix.
   * @return {this}
   */
  setSuffix(t) {
    return this.suffix = t, this;
  }
  /**
   * @description Sets the signature of the asset.
   * @param {string} signature The signature.
   * @return {this}
   */
  setSignature(t) {
    return this.signature = t, this;
  }
  /**
   * @description Sets the version of the asset.
   * @param {string} newVersion The version of the asset.
   * @return {this}
   */
  setVersion(t) {
    return t && (this.version = t), this;
  }
  /**
   * @description Sets the asset type.
   * @param {string} newType The type of the asset.
   * @return {this}
   */
  setAssetType(t) {
    return t && (this.assetType = t), this;
  }
  sign() {
    return this;
  }
  /**
   * @description Serializes to URL string
   * @param overwriteOptions
   */
  toURL(t = {}) {
    return this.createCloudinaryURL(null, t.trackedAnalytics);
  }
  /**
   * @description Validate various options before attempting to create a URL
   * The function will throw in case a violation
   * @throws Validation errors
   */
  validateAssetForURLCreation() {
    if (typeof this.cloudName > "u")
      throw "You must supply a cloudName when initializing the asset";
    const t = this.suffix && this.suffix.indexOf(".") >= 0, r = this.suffix && this.suffix.indexOf("/") >= 0;
    if (t || r)
      throw "`suffix`` should not include . or /";
  }
  /**
   * @description return an SEO friendly name for a combination of asset/delivery, some examples:
   * * image/upload -> images
   * * video/upload -> videos
   * If no match is found, return `{asset}/{delivery}`
   */
  getResourceType() {
    const t = v5(this.assetType), r = m5(this.deliveryType), n = !!this.suffix, s = `${t}/${r}`, a = _n[`${t}/${r}`], i = this.urlConfig.useRootPath, l = this.urlConfig.shorten;
    if (i) {
      if (s === "image/upload")
        return "";
      throw new Error(`useRootPath can only be used with assetType: 'image' and deliveryType: 'upload'. Provided: ${s} instead`);
    }
    if (l && s === "image/upload")
      return "iu";
    if (n) {
      if (a)
        return a;
      throw new Error(`URL Suffix only supported for ${Object.keys(_n).join(", ")}, Provided: ${s} instead`);
    }
    return s;
  }
  getSignature() {
    return this.signature ? `s--${this.signature}--` : "";
  }
  /**
   *
   * @description Creates a fully qualified CloudinaryURL
   * @return {string} CloudinaryURL
   * @throws Validation Errors
   */
  createCloudinaryURL(t, r) {
    if (!this.publicID)
      return "";
    this.validateAssetForURLCreation();
    const n = C5(this.cloudName, this.urlConfig), s = t ? t.toString() : "", a = M5(this.publicID, this.version, this.urlConfig.forceVersion), i = this.publicID;
    if (typeof t == "string")
      return [n, this.getResourceType(), this.getSignature(), s, a, i.replace(/,/g, "%2C"), this.suffix].filter((u) => u).join("/");
    {
      const l = [
        encodeURI(n),
        this.getResourceType(),
        this.getSignature(),
        encodeURI(s),
        a,
        encodeURI(i).replace(/,/g, "%2C"),
        this.suffix && encodeURI(this.suffix)
      ].filter((c) => c).join("/").replace(/\?/g, "%3F").replace(/=/g, "%3D"), u = this.urlConfig.analytics !== !1 && !i.includes("?");
      let d = "";
      if (typeof this.urlConfig.queryParams == "object")
        try {
          const c = new URLSearchParams(this.urlConfig.queryParams);
          u && c.set("_a", On(r)), d = c.toString();
        } catch {
          console.error("Error: URLSearchParams is not available so the queryParams object cannot be parsed, please try passing as an already parsed string");
        }
      else
        d = this.urlConfig.queryParams || "", u && (d += `${d.length > 0 ? "&" : ""}_a=${On(r)}`);
      return d ? `${l}?${d}` : l;
    }
  }
}
class Ys extends T5 {
  constructor(t, r, n, s) {
    super(t, r, n), this.transformation = s;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Animated} animated
   * @return {this}
   */
  animated(t) {
    return this.transformation.animated(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Border} border
   * @return {this}
   */
  border(t) {
    return this.transformation.border(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Reshape} reshape
   * @return {this}
   */
  reshape(t) {
    return this.transformation.reshape(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Resize} resize
   * @return {this}
   */
  resize(t) {
    return this.transformation.resize(t), this;
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(t) {
    return this.addAction(new F2("q", t)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(t) {
    return this.addAction(new F2("f", t)), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.RoundCorners} roundCorners
   * @return {this}
   */
  roundCorners(t) {
    return this.transformation.roundCorners(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {this}
   */
  overlay(t) {
    return this.transformation.overlay(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Variable} variableAction
   * @return {this}
   */
  addVariable(t) {
    return this.transformation.addVariable(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Condition} conditionalAction
   * @return {this}
   */
  conditional(t) {
    return this.transformation.conditional(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Effect} effect
   * @return {this}
   */
  effect(t) {
    return this.transformation.effect(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Adjust} action
   * @return {this}
   */
  adjust(t) {
    return this.transformation.adjust(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Rotate} rotate
   * @return {this}
   */
  rotate(t) {
    return this.transformation.rotate(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(t) {
    return this.transformation.namedTransformation(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Delivery} deliveryAction
   * @return {this}
   */
  delivery(t) {
    return this.transformation.delivery(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Qualifiers.color} color
   * @return {this}
   */
  backgroundColor(t) {
    return this.transformation.backgroundColor(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.PSDTools} action
   * @return {this}
   */
  psdTools(t) {
    return this.transformation.psdTools(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Extract} action
   * @return {this}
   */
  extract(t) {
    return this.transformation.extract(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(t) {
    return this.transformation.addFlag(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.CustomFunction} customFunction
   * @return {this}
   */
  customFunction(t) {
    return this.transformation.customFunction(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(t) {
    return this.transformation.addAction(t), this;
  }
  /**
   * @description Extend your transformation with another transformation
   * @param { string | SDK.Transformation } tx
   */
  addTransformation(t) {
    return this.transformation.addTransformation(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {string}
   */
  toString() {
    return this.transformation.toString();
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {this}
   */
  underlay(t) {
    return this.transformation.underlay(t), this;
  }
  toURL(t = {}) {
    return this.createCloudinaryURL(this.transformation, t == null ? void 0 : t.trackedAnalytics);
  }
}
class O5 extends Ys {
  constructor(t, r, n) {
    super(t, r, n, new p5());
  }
}
class _5 extends Ys {
  constructor(t, r, n) {
    super(t, r, n, new f5()), this.assetType = "video";
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Transcode} action
   * @return {this}
   */
  transcode(t) {
    return this.transformation.transcode(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.VideoEdit} action
   * @return {this}
   */
  videoEdit(t) {
    return this.transformation.videoEdit(t), this;
  }
}
class z5 {
  constructor(t) {
    t && (this.cloudinaryConfig = t);
  }
  image(t) {
    return new O5(t, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
  }
  video(t) {
    return new _5(t, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
  }
  setConfig(t) {
    return this.cloudinaryConfig = t, this;
  }
  getConfig() {
    return this.cloudinaryConfig;
  }
  extendConfig() {
  }
}
const L5 = "dfeykvudc", zn = {
  hr: "Sprout HR",
  "hr-mobile": "Sprout HR Mobile",
  "performance-plus": "Sprout Performance+",
  "recruit-plus": "Sprout Recruit+",
  sail: "Sprout SAIL",
  readycash: "Sprout ReadyCash",
  readywage: "Sprout ReadyWage"
};
function k5(e) {
  const t = new z5({
    cloud: {
      cloudName: L5
    }
  }), r = F(() => t.image(`sprout-${e.name}-${e.theme}`).toURL()), n = F(() => {
    if (e.name in zn)
      return zn[e.name];
    const s = e.name.charAt(0).toUpperCase(), a = e.name.slice(1);
    return `Sprout ${`${s}${a}`}`;
  });
  return {
    logoSrc: r,
    logoTitle: n
  };
}
const E5 = ["white", "dark", "gray", "green"], P5 = [
  "benchmark",
  "ecosystem",
  "engage",
  "finances",
  "hr-mobile",
  "hr",
  "inbound",
  "insight",
  "readycash",
  "readywage",
  "payroll",
  "performance-plus",
  "procurement",
  "professional-services",
  "recruit",
  "recruit-plus",
  "sail",
  "sidekick",
  "wellness"
], Y5 = {
  name: {
    type: String,
    validator: (e) => P5.includes(e),
    default: "hr"
  },
  theme: {
    type: String,
    validator: (e) => E5.includes(e),
    default: "dark"
  },
  width: {
    type: [String, Number],
    default: "50"
    // If number, it will be treated as px
  }
}, U5 = ["src", "alt", "title", "width"], F5 = /* @__PURE__ */ ae({
  __name: "logo",
  props: Y5,
  setup(e) {
    const t = e, { logoSrc: r, logoTitle: n } = k5(t);
    return (s, a) => (f(), C("div", null, [
      A("img", Ye(s.$attrs, {
        src: o(r),
        alt: o(n),
        title: o(n),
        width: s.width
      }), null, 16, U5)
    ]));
  }
}), B5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F5
}, Symbol.toStringTag, { value: "Module" })), R5 = ["sm", "md", "lg", "xl"], V5 = {
  modelValue: {
    type: Boolean,
    default: !1
  },
  title: {
    type: String,
    default: ""
  },
  closeButtonX: {
    type: Boolean,
    default: !0
  },
  contentPadding: {
    type: Boolean,
    default: !0
  },
  hasFooter: {
    type: Boolean,
    default: !0
  },
  size: {
    type: String,
    validator: (e) => R5.includes(e),
    default: "md"
  },
  staticBackdrop: {
    type: Boolean,
    default: !1
  }
}, Q5 = {
  "update:modelValue": (e) => e
}, H5 = (e, t) => {
  const { size: r, contentPadding: n, staticBackdrop: s } = ye(e), a = F(() => {
    const d = L(
      "spr-fixed spr-bottom-0 spr-left-0 spr-right-0 spr-top-0 spr-z-[1050] spr-h-full spr-w-full spr-bg-[#4C5857] spr-opacity-60"
    ), c = L(
      "spr-fixed spr-z-[1100] spr-left-1/2 spr-top-1/2 spr-transform -spr-translate-x-1/2 -spr-translate-y-1/2",
      "spr-background-color spr-rounded-xl",
      "spr-border spr-border-solid spr-border-color-weak",
      "sm:spr-w-[calc(100%-2rem)] sm:spr-max-w-[calc(100%-2rem)]",
      {
        "spr-w-[360px] spr-max-w-[480px]": r.value === "sm",
        "spr-w-[480px] spr-max-w-[720px]": r.value === "md",
        "spr-w-[720px] spr-max-w-[960px]": r.value === "lg",
        "spr-w-[900px] spr-max-w-[1200px]": r.value === "xl"
      },
      { "bounce-animation": i.value }
    ), p = L(
      "spr-flex spr-items-start spr-justify-between spr-gap-2 spr-px-4 spr-py-3",
      "spr-text-color-strong spr-subheading-xs",
      "spr-border-color-weak spr-border-x-0 spr-border-b spr-border-t-0 spr-border-solid",
      "spr-rounded-tl-xl spr-rounded-tr-xl",
      "sm:spr-p-2"
    ), h = L(
      "spr-text-color-weak spr-subheading-xs spr-mt-0.5 spr-cursor-pointer",
      "spr-transition spr-duration-150 spr-ease-in-out",
      "hover:spr-text-color-base",
      "active:spr-text-color-strong active:spr-scale-75"
    ), y = L(
      "spr-body-sm-regular spr-max-h-[calc(100vh-200px)] spr-overflow-y-auto spr-overflow-x-hidden",
      {
        "spr-p-4 sm:spr-p-2": n.value
      }
    ), M = L(
      "spr-border-color-weak spr-border-x-0 spr-border-b-0 spr-border-t spr-border-solid",
      "spr-flex spr-w-full spr-items-center spr-px-size-spacing-xs spr-py-size-spacing-2xs",
      "spr-text-color-strong spr-subheading-xs"
    );
    return {
      backdropClasses: d,
      baseClasses: c,
      headerClasses: p,
      headerCloseButtonXClasses: h,
      contentClasses: y,
      footerClasses: M
    };
  }), i = B(!1), l = () => {
    t("update:modelValue", !1);
  };
  return {
    modalClasses: a,
    staticBackdropClicked: i,
    handleCloseModal: l,
    handleBackdropClick: () => {
      s.value ? (i.value = !0, setTimeout(() => {
        i.value = !1;
      }, 500)) : l();
    }
  };
}, Z5 = { key: 0 }, G5 = /* @__PURE__ */ ae({
  __name: "modal",
  props: V5,
  emits: Q5,
  setup(e, { emit: t }) {
    const r = e, n = t, { modalClasses: s, handleCloseModal: a, handleBackdropClick: i } = H5(r, n);
    return (l, u) => (f(), C(X, null, [
      R(mt, { name: "backdrop-transition" }, {
        default: H(() => [
          r.modelValue ? (f(), C("div", {
            key: 0,
            class: x(o(s).backdropClasses),
            onClick: u[0] || (u[0] = //@ts-ignore
            (...d) => o(i) && o(i)(...d))
          }, null, 2)) : _("", !0)
        ]),
        _: 1
      }),
      R(mt, { name: "modal-transition" }, {
        default: H(() => [
          r.modelValue ? (f(), C("div", {
            key: 0,
            id: "modal",
            class: x(o(s).baseClasses)
          }, [
            l.$slots.header || l.title ? (f(), C("header", {
              key: 0,
              class: x(o(s).headerClasses)
            }, [
              !l.$slots.header && l.title ? (f(), C("span", Z5, G(l.title), 1)) : _("", !0),
              ee(l.$slots, "header", {}, void 0, !0),
              r.closeButtonX ? (f(), C("span", {
                key: 1,
                class: x(o(s).headerCloseButtonXClasses),
                onClick: u[1] || (u[1] = //@ts-ignore
                (...d) => o(a) && o(a)(...d))
              }, [
                R(o(W), {
                  class: "spr-h-[20px] spr-w-[20px]",
                  icon: "ph:x"
                })
              ], 2)) : _("", !0)
            ], 2)) : _("", !0),
            A("div", {
              class: x(o(s).contentClasses)
            }, [
              ee(l.$slots, "default", {}, void 0, !0)
            ], 2),
            l.$slots.footer ? (f(), C("footer", {
              key: 1,
              class: x(o(s).footerClasses)
            }, [
              ee(l.$slots, "footer", {}, void 0, !0)
            ], 2)) : _("", !0)
          ], 2)) : _("", !0)
        ]),
        _: 3
      })
    ], 64));
  }
}), W5 = /* @__PURE__ */ gt(G5, [["__scopeId", "data-v-4f331f4e"]]), K5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W5
}, Symbol.toStringTag, { value: "Module" })), J5 = ["xs", "sm", "lg"], X5 = {
  size: {
    type: String,
    validator: (e) => J5.includes(e),
    default: "lg"
  },
  label: {
    type: Boolean,
    default: !0
  },
  value: {
    type: Number,
    default: 0,
    validator(e, t) {
      return e < 0 || e > t.max ? (console.error(`Invalid prop: "value" (${e}) must be between 0 and ${t.max}.`), !1) : !0;
    }
  },
  max: {
    type: Number,
    default: 100,
    validator(e) {
      return e <= 0 || e > 100 ? (console.error('Invalid prop: "max" must be between 1 and 100.'), !1) : !0;
    }
  }
}, q5 = (e) => {
  const t = F(() => {
    switch (e.size) {
      case "xs":
        return "spr-h-1";
      case "sm":
        return "spr-h-2";
      case "lg":
        return "spr-h-3";
      default:
        return "spr-h-3";
    }
  }), r = F(() => Math.min(e.value / (e.max || 100) * 100, 100)), n = F(() => ({
    width: r.value + "%",
    height: "100%"
  }));
  return {
    handleProgressBarSize: t,
    percentage: r,
    handleProgressBarStyle: n
  };
}, e9 = ["aria-valuemax"], t9 = {
  key: 0,
  class: "spr-text-color-base spr-font-weight-regular spr-font-size-100 spr-line-height-100 spr-font-main"
}, r9 = /* @__PURE__ */ ae({
  __name: "progress-bar",
  props: X5,
  setup(e) {
    const t = e, { handleProgressBarSize: r, percentage: n, handleProgressBarStyle: s } = q5(t);
    return (a, i) => (f(), C("div", {
      class: "spr-flex spr-w-full spr-flex-col spr-gap-size-spacing-5xs",
      "aria-valuemin": 0,
      "aria-valuemax": t.max || 100,
      role: "progressbar"
    }, [
      A("div", {
        class: x([o(r), "spr-overflow-hidden spr-rounded-lg spr-bg-white-100"])
      }, [
        A("div", {
          class: "spr-background-color-success-base spr-transition-all spr-duration-300",
          style: De(o(s))
        }, null, 4)
      ], 2),
      t.label ? (f(), C("span", t9, G(o(n)) + "%", 1)) : _("", !0)
    ], 8, e9));
  }
}), n9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r9
}, Symbol.toStringTag, { value: "Module" })), s9 = {
  id: {
    type: String,
    required: !0
  },
  modelValue: {
    type: [String, Number, Boolean]
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  name: {
    type: String,
    required: !0
  },
  value: {
    type: [String, Number, Boolean],
    required: !0
  },
  description: {
    type: String
  },
  bordered: {
    type: Boolean,
    default: !1
  },
  fullWidth: {
    type: Boolean,
    default: !1
  }
}, a9 = ["update:modelValue"], o9 = (e, t, r) => {
  const { modelValue: n, disabled: s, description: a, bordered: i, fullWidth: l } = ye(e), u = B(null), d = K0(u), c = F(() => {
    const h = L("spr-sr-only spr-peer spr-inline-block", {
      "spr-cursor-not-allowed": s.value
    }), y = L(
      "spr-inline-block spr-w-4 spr-h-4 spr-rounded-full spr-border-2 spr-border-solid spr-shrink-0",
      {
        "spr-mr-2": r.default,
        "group-active:spr-scale-95": !s.value
      },
      // Hover State
      {
        // Hover state with matching value
        "spr-background-color-brand-hover spr-border-2 spr-border-color-brand-hover spr-shadow-[inset_0px_0px_0px_2.5px_#fff]": d.value && String(n == null ? void 0 : n.value) === String(e.value) && !s.value && !i.value,
        // Hover state but different value
        "spr-background-color-base spr-border-2 spr-border-color-supporting spr-shadow-[inset_0px_0px_0px_2.5px_#fff]": d.value && String(n == null ? void 0 : n.value) !== String(e.value) && !s.value && !i.value,
        // Bordered Hover state but different value
        "spr-background-color-base spr-border-2 spr-border-color-supporting": d.value && String(n == null ? void 0 : n.value) !== String(e.value) && !s.value && i.value
      },
      // Active State
      {
        // Active state with matching value
        "spr-border-color-brand-base spr-background-color-brand-base spr-shadow-[inset_0px_0px_0px_2.5px_#fff] animate-shadow-grow": String(n == null ? void 0 : n.value) === String(e.value) && !s.value && !i.value,
        // Active state with different value
        "spr-border-color-supporting spr-shadow-[inset_0px_0px_0px_2.5px#fff]": String(n == null ? void 0 : n.value) !== String(e.value) && !s.value && !i.value,
        //Bordered Active state with matching value
        "spr-border-color-brand-base spr-background-color-brand-base animate-shadow-grow": String(n == null ? void 0 : n.value) === String(e.value) && !s.value && i.value,
        //Bordered Active state with different value
        "spr-border-color-supporting": String(n == null ? void 0 : n.value) !== String(e.value) && !s.value && i.value
      },
      // Disabled State
      {
        "spr-cursor-not-allowed": s.value,
        // Disabled state with matching value
        "spr-border-color-disabled spr-background-color-disabled spr-shadow-[inset_0px_0px_0px_2.5px_#fff]": s.value && String(n == null ? void 0 : n.value) === String(e.value) && !i.value,
        // Disabled state but different value
        "spr-border-color-disabled spr-background-color spr-cursor-not-allowed": s.value && String(n == null ? void 0 : n.value) !== String(e.value) && !i.value,
        // Bordered Disabled state with matching value
        "spr-bg-white-400 spr-shadow-[inset_0px_0px_0px_2.5px_#fff]": s.value && String(n == null ? void 0 : n.value) === String(e.value) && i.value,
        // Bordered Disabled state but different value
        "spr-border-white-400 spr-background-color-disabled": s.value && String(n == null ? void 0 : n.value) !== String(e.value) && i.value
      }
    ), M = L(
      "spr-group spr-m-0 spr-inline-flex spr-w-auto spr-items-center spr-p-0 spr-font-main",
      "spr-text-color-strong spr-inline-flex spr-items-center spr-p-0",
      {
        "spr-text-color-disabled": s.value && !i.value,
        "spr-text-color-on-fill-disabled": s.value && i.value,
        "spr-cursor-pointer": !s.value,
        "spr-cursor-not-allowed": s.value
      }
    ), g = L(
      "spr-border spr-rounded-md spr-p-size-spacing-2xs spr-border-solid spr-box-border",
      {
        //enabled state
        "spr-border-color-brand-base spr-background-color-brand-weak": String(n == null ? void 0 : n.value) === String(e.value) && !s.value,
        // matching value
        "spr-border-color-weak spr-bg-white-50 hover:spr-background-color-hover": String(n == null ? void 0 : n.value) !== String(e.value) && !s.value,
        // different value
        //disabled state
        "spr-border-color-disabled spr-background-color-disabled": s.value,
        "spr-w-full": l.value,
        "spr-w-fit": !l.value
      }
    );
    return {
      baseClasses: h,
      baseIndicatorClasses: y,
      labelClasses: M,
      borderedClasses: g
    };
  }), p = Ie(e, "modelValue", t);
  return {
    radioRef: u,
    radioClasses: c,
    proxyValue: p,
    description: a,
    bordered: i
  };
}, i9 = ["id", "name", "value", "disabled"], l9 = ["for", "disabled"], u9 = { class: "spr-flex spr-flex-col spr-gap-size-spacing-6xs" }, d9 = /* @__PURE__ */ ae({
  __name: "radio",
  props: s9,
  emits: a9,
  setup(e, { emit: t }) {
    const r = e, n = t, s = It(), { proxyValue: a, radioRef: i, radioClasses: l } = o9(r, n, s);
    return (u, d) => (f(), C("div", {
      class: x(["spr-relative", { "spr-w-full": r.fullWidth }])
    }, [
      rt(A("input", {
        id: r.id,
        ref_key: "radioRef",
        ref: i,
        "onUpdate:modelValue": d[0] || (d[0] = (c) => fe(a) ? a.value = c : null),
        type: "radio",
        name: r.name,
        value: r.value,
        disabled: r.disabled,
        class: x(o(l).baseClasses)
      }, null, 10, i9), [
        [Sa, o(a)]
      ]),
      A("label", {
        ref_key: "radioRef",
        ref: i,
        for: r.id,
        disabled: r.disabled,
        class: x([o(l).labelClasses, { [o(l).borderedClasses]: r.bordered }])
      }, [
        A("span", {
          class: x(o(l).baseIndicatorClasses)
        }, null, 2),
        A("div", u9, [
          ee(u.$slots, "default", {}, void 0, !0),
          r.description && r.description !== "" ? (f(), C("span", {
            key: 0,
            class: x(["spr-text-xs spr-font-normal spr-leading-4 spr-text-mushroom-600", { "spr-text-color-disabled": r.disabled }])
          }, G(r.description), 3)) : _("", !0)
        ])
      ], 10, l9)
    ], 2));
  }
}), c9 = /* @__PURE__ */ gt(d9, [["__scopeId", "data-v-95e7fa1a"]]), p9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: c9
}, Symbol.toStringTag, { value: "Module" })), f9 = [
  "auto",
  "auto-start",
  "auto-end",
  "top",
  "top-start",
  "top-end",
  "right",
  "right-start",
  "right-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "left",
  "left-start",
  "left-end"
], g9 = ["fixed", "absolute"], h9 = {
  id: {
    type: String,
    required: !0,
    default: "select-ladderized"
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  options: {
    type: Array,
    required: !0,
    default: () => []
  },
  label: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: ""
  },
  helperText: {
    type: String,
    default: ""
  },
  helperIcon: {
    type: String,
    default: null
  },
  displayHelper: {
    type: Boolean,
    default: !1
  },
  clearable: {
    type: Boolean,
    default: !1
  },
  searchableOptions: {
    type: Boolean,
    default: !1
  },
  searchableOptionsPlaceholder: {
    type: String,
    default: "Search..."
  },
  placement: {
    type: String,
    validator: (e) => f9.includes(e),
    default: "bottom"
  },
  wrapperPosition: {
    type: String,
    default: "relative"
  },
  width: {
    type: String,
    default: "100%"
  },
  popperWidth: {
    type: String,
    default: "100%"
  },
  popperStrategy: {
    type: String,
    validator: (e) => g9.includes(e),
    default: "absolute"
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  removeCurrentLevelInBackLabel: {
    type: Boolean,
    default: !1
  }
}, y9 = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  "update:modelValue": (e) => !0
}, C9 = (e, t) => {
  const { options: r, disabled: n } = ye(e), s = F(() => ({
    baseClasses: "spr-flex spr-flex-col spr-gap-size-spacing-4xs",
    labelClasses: "spr-body-sm-regular spr-text-color-strong spr-block"
  })), a = B(!1), i = B(null), l = F(() => n.value), u = Ie(e, "modelValue", t), d = F(() => r.value), c = B(""), p = B(!1), h = B(!1), y = (w) => !w.sublevel || w.sublevel.length === 0, M = (w, E, $ = []) => {
    for (const D of w) {
      const z = [...$, D.text];
      if (D.value === E)
        return z;
      if (D.sublevel) {
        const k = M(D.sublevel, E, z);
        if (k) return k;
      }
    }
    return null;
  }, g = (w, E) => {
    h.value = !1, u.value = w;
    let $ = E;
    if (!$ && w.length > 0) {
      const D = (z, k) => {
        for (const b of z) {
          if (b.value === k) return b;
          if (b.sublevel) {
            const P = D(b.sublevel, k);
            if (P) return P;
          }
        }
      };
      $ = D(d.value, w[w.length - 1]);
    }
    if ($) {
      const D = M(d.value, $.value);
      c.value = D ? D.join(" > ") : $.text || "", y($) && (a.value = !1);
    } else w.length === 0 && !h.value && (c.value = "");
  }, v = () => {
    p.value = !0, m();
  }, m = W2(() => {
  }, 300), I = () => {
    h.value = !0, c.value = "", t("update:modelValue", []);
  }, N = () => {
    a.value = !0, p.value = !1;
  };
  return ce(
    () => u.value,
    (w) => {
      if (h.value) {
        c.value = "", h.value = !1;
        return;
      }
      if (Array.isArray(w) && w.length > 0) {
        let E = d.value;
        const $ = [];
        for (const D of w) {
          const z = E.find((k) => k.value === D);
          if (!z) break;
          $.push(z.text), E = z.sublevel || [];
        }
        c.value = $.join(" > ");
      }
    },
    { immediate: !0 }
  ), Yt(i, () => {
    a.value = !1;
  }), {
    ladderizedClasses: s,
    ladderizedSelectPopperState: a,
    ladderizedSelectRef: i,
    ladderizedSelectOptions: d,
    isLadderizedSelectPopperDisabled: l,
    ladderizedSelectModel: u,
    inputText: c,
    handleSelectedLadderizedItem: g,
    handleSearch: v,
    handleClear: I,
    handleOptionsToggle: N
  };
}, v9 = ["for"], m9 = { class: "spr-flex spr-items-center spr-gap-1" }, M9 = {
  key: 1,
  class: "spr-flex spr-items-center spr-justify-center spr-p-2 spr-text-center"
}, b9 = /* @__PURE__ */ ae({
  __name: "select-ladderized",
  props: h9,
  emits: y9,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      ladderizedClasses: s,
      ladderizedSelectPopperState: a,
      ladderizedSelectRef: i,
      ladderizedSelectOptions: l,
      isLadderizedSelectPopperDisabled: u,
      ladderizedSelectModel: d,
      inputText: c,
      handleSelectedLadderizedItem: p,
      handleSearch: h,
      handleClear: y,
      handleOptionsToggle: M
    } = C9(r, n);
    return (g, v) => (f(), C("div", {
      class: x(o(s).baseClasses)
    }, [
      r.label ? (f(), C("label", {
        key: 0,
        for: r.id,
        class: x(o(s).labelClasses)
      }, G(r.label), 11, v9)) : _("", !0),
      R(o(we), {
        shown: o(a),
        "aria-id": "ladderized-select-wrapper",
        distance: "4",
        placement: r.placement,
        triggers: [],
        "popper-hide-triggers": [],
        "auto-hide": !1,
        disabled: o(u),
        container: "#ladderized-select-wrapper",
        strategy: r.popperStrategy === "fixed" || r.popperStrategy === "absolute" ? r.popperStrategy : "absolute",
        delay: 0,
        style: De({
          position: r.wrapperPosition,
          width: r.width
        })
      }, {
        popper: H(() => [
          A("div", {
            ref_key: "ladderizedSelectRef",
            ref: i,
            class: "spr-grid spr-max-h-[300px] spr-gap-0.5 spr-overflow-y-auto spr-overflow-x-hidden"
          }, [
            o(l).length > 0 ? (f(), K(sr, {
              key: 0,
              modelValue: o(d),
              "onUpdate:modelValue": [
                v[2] || (v[2] = (m) => fe(d) ? d.value = m : null),
                o(p)
              ],
              ladderized: !0,
              "menu-list": o(l),
              "menu-level": o(d).length,
              "remove-current-level-in-back-label": r.removeCurrentLevelInBackLabel,
              "searchable-menu": r.searchableOptions,
              "searchable-menu-placeholder": r.searchableOptionsPlaceholder
            }, null, 8, ["modelValue", "menu-list", "menu-level", "remove-current-level-in-back-label", "searchable-menu", "searchable-menu-placeholder", "onUpdate:modelValue"])) : (f(), C("div", M9, v[3] || (v[3] = [
              A("span", { class: "spr-body-sm-regular spr-m-0" }, "No results found", -1)
            ])))
          ], 512)
        ]),
        default: H(() => [
          A("div", {
            onClick: v[1] || (v[1] = //@ts-ignore
            (...m) => o(M) && o(M)(...m))
          }, [
            R(Ee, {
              id: `input-${r.id}`,
              modelValue: o(c),
              "onUpdate:modelValue": v[0] || (v[0] = (m) => fe(c) ? c.value = m : null),
              class: "spr-cursor-pointer",
              placeholder: r.placeholder,
              autocomplete: "off",
              "helper-text": r.helperText,
              "helper-icon": r.helperIcon,
              "display-helper": r.displayHelper,
              readonly: "",
              disabled: r.disabled,
              onKeyup: o(h)
            }, {
              icon: H(() => [
                A("div", m9, [
                  r.clearable && o(c) ? (f(), K(o(W), {
                    key: 0,
                    class: "spr-cursor-pointer",
                    icon: "ph:x",
                    onClick: Mt(o(y), ["stop"])
                  }, null, 8, ["onClick"])) : _("", !0),
                  R(o(W), { icon: "ph:caret-down" })
                ])
              ]),
              _: 1
            }, 8, ["id", "modelValue", "placeholder", "helper-text", "helper-icon", "display-helper", "disabled", "onKeyup"])
          ]),
          A("div", {
            id: "ladderized-select-wrapper",
            style: De({ width: r.popperWidth })
          }, null, 4)
        ]),
        _: 1
      }, 8, ["shown", "placement", "disabled", "strategy", "style"])
    ], 2));
  }
}), N9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: b9
}, Symbol.toStringTag, { value: "Module" })), $9 = ["A-Z", "Z-A"], D9 = [
  "auto",
  "auto-start",
  "auto-end",
  "top",
  "top-start",
  "top-end",
  "right",
  "right-start",
  "right-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "left",
  "left-start",
  "left-end"
], I9 = ["fixed", "absolute"], A9 = {
  id: {
    type: String,
    required: !0,
    default: "multi-select"
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  searchValue: {
    type: String,
    default: ""
  },
  options: {
    type: Array,
    required: !0,
    default: []
  },
  groupItemsBy: {
    type: String,
    validator: (e) => e === void 0 || $9.includes(e)
  },
  textField: {
    type: String,
    default: "text",
    description: "Field name to use for display text when using dynamic object arrays"
  },
  valueField: {
    type: String,
    default: "value",
    description: "Field name to use for value when using dynamic object arrays"
  },
  placeholder: {
    type: String
  },
  label: {
    type: String,
    default: ""
  },
  placement: {
    type: String,
    validator: (e) => D9.includes(e),
    default: "bottom"
  },
  popperStrategy: {
    type: String,
    validator: (e) => I9.includes(e),
    default: "absolute"
  },
  popperWidth: {
    type: String,
    default: "100%"
  },
  width: {
    type: String,
    default: "100%"
  },
  wrapperPosition: {
    type: String,
    default: "relative"
  },
  displayText: {
    type: String,
    default: ""
  },
  displayHelper: {
    type: Boolean,
    default: !1
  },
  helperIcon: {
    type: String,
    default: null
  },
  helperText: {
    type: String,
    default: ""
  },
  active: {
    type: Boolean,
    default: !1
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  error: {
    type: Boolean,
    default: !1
  },
  clearable: {
    type: Boolean,
    default: !1
  },
  chipped: {
    type: Boolean,
    default: !1
  },
  searchable: {
    type: Boolean,
    default: !1
  },
  loading: {
    type: Boolean,
    default: !1
  },
  disabledLocalSearch: {
    type: Boolean,
    default: !1
  }
}, x9 = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  "update:modelValue": (e) => !0,
  "update:search": (e) => typeof e == "string",
  "infinite-scroll-trigger": Boolean
}, w9 = (e, t) => {
  const { displayText: r, options: n, textField: s, valueField: a, active: i, disabled: l, error: u, disabledLocalSearch: d } = ye(e), c = F(() => {
    const O = L("spr-flex spr-flex-col spr-gap-size-spacing-4xs"), S = L("spr-body-sm-regular spr-text-color-strong spr-block", {
      "spr-text-color-on-fill-disabled": l.value
    }), Y = L(
      "spr-relative spr-flex spr-items-center spr-min-h-9 spr-rounded-border-radius-md spr-border-[1.5px] spr-border-solid",
      {
        "spr-cursor-pointer": !l.value,
        // Border State
        "spr-border-color-weak": !z.value && !u.value && !l.value && !i.value,
        "spr-border-color-brand-base": !z.value && i.value,
        "spr-border-color-danger-base": !z.value && u.value,
        // Border State Focused
        "focus: spr-border-kangkong-700": z.value && !u.value && !l.value && !i.value,
        "focus: spr-border-tomato-600": z.value && u.value,
        "focus: spr-border-white-100": z.value && l.value,
        // Disabled State
        "spr-background-color-disabled spr-cursor-not-allowed spr-border-mushroom-100": l.value
      }
    ), U = L(
      "spr-flex spr-gap-1 spr-justify-between spr-w-full spr-outline-none spr-ring-0 spr-border-none spr-rounded-border-radius-md spr-font-size-200",
      "spr-font-size-200 [font-weight:inherit]",
      "placeholder:spr-text-mushroom-300",
      {
        "spr-text-color-strong": !l.value,
        // Disabled State
        "spr-text-color-on-fill-disabled !spr-cursor-not-allowed": l.value
      }
    ), J = L(
      "spr-flex spr-items-center spr-justify-center spr-h-inherit spr-px-2 [&>svg]:spr-min-h-4 [&>svg]:spr-min-w-4",
      {
        "spr-text-mushroom-300": !u.value,
        "spr-text-tomato-600": u.value
      }
    ), oe = L(
      "spr-flex spr-flex-row spr-items-start spr-justify-between spr-w-full"
    ), de = L(
      "spr-body-sm-regular spr-flex spr-items-center spr-gap-size-spacing-5xs spr-flex-1",
      {
        "spr-text-color-danger-base": u.value,
        "spr-text-color-supporting": !u.value
      }
    );
    return {
      baseClasses: O,
      labelClasses: S,
      chippedInputTextBaseClasses: Y,
      chippedInputTextClasses: U,
      chippedIconClasses: J,
      chippedHelperContainerClasses: oe,
      chippedHelperClasses: de
    };
  }), p = B(null), h = B(!1), y = F(() => l.value), M = Ie(e, "modelValue", t), g = B([]), v = B([]), m = B(!1), I = B(""), N = B(""), w = B(null), E = Ie(e, "searchValue", t), $ = B(""), D = B(null), { focused: z } = J0(w), k = F(() => Array.isArray(M.value) ? M.value : M.value !== void 0 && M.value !== null ? [M.value] : []), b = () => {
    if (!n.value || !Array.isArray(n.value) || n.value.length === 0) {
      v.value = [];
      return;
    }
    const O = n.value[0];
    if (typeof O == "string") {
      v.value = n.value.map((S) => ({
        text: S,
        value: S
      }));
      return;
    }
    if (typeof O == "number") {
      v.value = n.value.filter((S) => typeof S == "number").map((S) => ({
        text: S.toString(),
        value: S
      }));
      return;
    }
    if (typeof O == "object" && O !== null) {
      if ("text" in O && "value" in O) {
        v.value = n.value;
        return;
      }
      v.value = n.value.map((S) => {
        const Y = S[s.value] !== void 0 ? String(S[s.value]) : "Unnamed";
        let U = a.value && S[a.value] !== void 0 ? S[a.value] : S;
        return U === void 0 && (U = ""), {
          text: Y,
          value: typeof U == "object" ? JSON.stringify(U) : String(U),
          _originalObject: S
        };
      });
      return;
    }
    v.value = n.value;
  }, P = () => {
    h.value = !h.value;
  }, V = (O) => {
    const S = O.map((Y) => {
      if (typeof Y.value == "string" && Y.value.startsWith("{") && Y.value.endsWith("}"))
        try {
          return JSON.parse(Y.value);
        } catch {
          return Y.value;
        }
      return Y.value;
    });
    m.value = !0, M.value = S, N.value = O.length > 3 ? `${O.length} items selected` : O.map((Y) => Y.text).join(", "), j();
  }, Z = (O) => {
    let S = Array.isArray(M.value) ? [...M.value] : [M.value];
    S = S.filter((Y) => {
      let U = Y;
      if (typeof U == "string" && U.startsWith("{") && U.endsWith("}"))
        try {
          U = JSON.parse(U);
        } catch {
        }
      if (typeof O == "string" && O.startsWith("{") && O.endsWith("}"))
        try {
          O = JSON.parse(O);
        } catch {
        }
      return typeof U == "object" && typeof O == "object" ? JSON.stringify(U) !== JSON.stringify(O) : U != O;
    }), t("update:modelValue", S);
  }, j = () => {
    if (v.value.length) {
      if (!d.value) {
        const O = k.value;
        if (!O || !O.length) {
          g.value = [], I.value = "", N.value = "";
          return;
        }
        g.value = v.value.filter((S) => O.some((Y) => {
          let U = S.value, J = Y;
          if (typeof U == "string" && U.startsWith("{") && U.endsWith("}"))
            try {
              U = JSON.parse(U);
            } catch {
            }
          if (typeof J == "string" && J.startsWith("{") && J.endsWith("}"))
            try {
              J = JSON.parse(J);
            } catch {
            }
          return typeof U == "object" && typeof J == "object" ? JSON.stringify(U) === JSON.stringify(J) : U == J;
        }));
      }
      g.value.length > 3 ? I.value = `${g.value.length} items selected` : I.value = g.value.map((O) => O.text).join(", "), N.value = I.value, r.value && !m.value && (!I.value || I.value === "") && (I.value = r.value, N.value = r.value);
    }
  }, T = () => {
    t("update:modelValue", []), g.value = [], I.value = "", h.value = !1;
  };
  return ce(M, () => {
    j();
  }), ce(
    v,
    () => {
      j();
    },
    { deep: !0 }
  ), ce(
    n,
    () => {
      b(), j();
    },
    { deep: !0 }
  ), ce($, () => {
    E.value = $.value;
  }), Yt(p, () => {
    h.value = !1, j();
  }), kt(
    D,
    () => {
      t("infinite-scroll-trigger", !0);
    },
    { distance: 10 }
  ), Be(() => {
    b(), k.value.length > 0 ? j() : r.value && (I.value = r.value, N.value = r.value);
  }), {
    multiSelectClasses: c,
    multiSelectPopperState: h,
    multiSelectRef: p,
    multiSelectModel: M,
    multiSelectOptions: v,
    multiSelectedListItems: g,
    inputText: I,
    isMultiSelectPopperDisabled: y,
    searchInput: $,
    multipleSelectPopperRef: D,
    handleMultiSelectedItem: V,
    handleChippedRemoveItem: Z,
    handleClear: T,
    handleOptionsToggle: P
  };
}, S9 = ["for"], j9 = { class: "spr-h-auto spr-w-full" }, T9 = {
  key: 1,
  class: "spr-placeholder spr-px-3 spr-text-gray-400"
}, O9 = { class: "spr-flex spr-items-center spr-gap-1" }, _9 = { class: "spr-flex spr-items-center spr-gap-1" }, z9 = ["value"], L9 = ["id"], k9 = /* @__PURE__ */ ae({
  __name: "select-multiple",
  props: A9,
  emits: x9,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      multiSelectClasses: s,
      multiSelectPopperState: a,
      multiSelectRef: i,
      multiSelectModel: l,
      multiSelectOptions: u,
      multiSelectedListItems: d,
      inputText: c,
      isMultiSelectPopperDisabled: p,
      searchInput: h,
      multipleSelectPopperRef: y,
      handleMultiSelectedItem: M,
      handleChippedRemoveItem: g,
      handleClear: v,
      handleOptionsToggle: m
    } = w9(r, n);
    return (I, N) => (f(), C("div", {
      class: x(o(s).baseClasses)
    }, [
      r.label ? (f(), C("label", {
        key: 0,
        for: I.id,
        class: x(o(s).labelClasses)
      }, G(r.label), 11, S9)) : _("", !0),
      R(o(we), {
        shown: o(a),
        "aria-id": "multi-select-wrapper",
        distance: "4",
        placement: r.placement,
        triggers: [],
        "popper-hide-triggers": [],
        "auto-hide": !1,
        disabled: o(p),
        container: `#${r.id}`,
        strategy: r.popperStrategy === "fixed" || r.popperStrategy === "absolute" ? r.popperStrategy : "absolute",
        delay: 0,
        style: De({
          position: r.wrapperPosition,
          width: r.width
        })
      }, {
        popper: H(() => [
          A("div", {
            ref_key: "multipleSelectPopperRef",
            ref: y,
            class: "spr-grid spr-max-h-[300px] spr-gap-0.5 spr-overflow-y-auto spr-overflow-x-hidden spr-p-2"
          }, [
            R(ct, {
              modelValue: o(d),
              "onUpdate:modelValue": [
                N[3] || (N[3] = (w) => fe(d) ? d.value = w : null),
                o(M)
              ],
              "search-value": o(h),
              "onUpdate:searchValue": N[4] || (N[4] = (w) => fe(h) ? h.value = w : null),
              "searchable-menu": r.searchable,
              "searchable-menu-placeholder": "Search",
              "menu-list": o(u),
              "group-items-by": r.groupItemsBy,
              "pre-selected-items": Array.isArray(o(l)) ? o(l).flat() : [o(l)],
              loading: r.loading,
              "multi-select": "",
              "disabled-local-search": r.disabledLocalSearch
            }, null, 8, ["modelValue", "search-value", "searchable-menu", "menu-list", "group-items-by", "pre-selected-items", "loading", "disabled-local-search", "onUpdate:modelValue"])
          ], 512)
        ]),
        default: H(() => [
          A("div", {
            ref_key: "multiSelectRef",
            ref: i
          }, [
            A("div", {
              onClick: N[2] || (N[2] = //@ts-ignore
              (...w) => o(m) && o(m)(...w))
            }, [
              r.chipped ? (f(), C(X, { key: 0 }, [
                A("div", {
                  class: x(o(s).chippedInputTextBaseClasses)
                }, [
                  A("div", {
                    ref: "chippedInputTextRef",
                    class: x(o(s).chippedInputTextClasses)
                  }, [
                    A("div", j9, [
                      o(d).length > 0 ? (f(!0), C(X, { key: 0 }, le(o(d), (w) => (f(), K(_t, {
                        key: w.value,
                        class: "spr-m-1 spr-inline-block",
                        label: String(w.text),
                        closable: "",
                        visible: "",
                        onClose: (E) => o(g)(String(w.value))
                      }, null, 8, ["label", "onClose"]))), 128)) : (f(), C("span", T9, G(r.placeholder), 1))
                    ]),
                    A("div", {
                      class: x(o(s).chippedIconClasses)
                    }, [
                      A("div", O9, [
                        r.clearable && o(c) ? (f(), K(o(W), {
                          key: 0,
                          class: "spr-cursor-pointer",
                          icon: "ph:x",
                          onClick: Mt(o(v), ["stop"])
                        }, null, 8, ["onClick"])) : _("", !0),
                        R(o(W), { icon: "ph:caret-down" })
                      ])
                    ], 2)
                  ], 2)
                ], 2),
                r.displayHelper ? (f(), C("div", {
                  key: 0,
                  class: x(o(s).chippedHelperContainerClasses)
                }, [
                  r.displayHelper ? (f(), C("div", {
                    key: 0,
                    class: x(o(s).chippedHelperClasses)
                  }, [
                    ee(I.$slots, "helperMessage", {}, () => [
                      r.helperIcon ? (f(), K(o(W), {
                        key: 0,
                        icon: r.helperIcon,
                        width: "20px",
                        height: "20px"
                      }, null, 8, ["icon"])) : _("", !0),
                      A("span", null, G(r.helperText), 1)
                    ])
                  ], 2)) : _("", !0)
                ], 2)) : _("", !0)
              ], 64)) : (f(), K(Ee, {
                key: 1,
                id: `input-${r.id}`,
                modelValue: o(c),
                "onUpdate:modelValue": N[0] || (N[0] = (w) => fe(c) ? c.value = w : null),
                class: x({
                  "spr-cursor-pointer": !0
                }),
                placeholder: r.placeholder,
                autocomplete: "off",
                "helper-text": r.helperText,
                "helper-icon": r.helperIcon,
                "display-helper": r.displayHelper,
                active: r.active,
                readonly: !0,
                disabled: r.disabled,
                error: r.error
              }, {
                icon: H(() => [
                  A("div", _9, [
                    r.clearable && o(c) ? (f(), K(o(W), {
                      key: 0,
                      class: "spr-cursor-pointer",
                      icon: "ph:x",
                      onClick: Mt(o(v), ["stop"])
                    }, null, 8, ["onClick"])) : _("", !0),
                    R(o(W), { icon: "ph:caret-down" })
                  ])
                ]),
                helperMessage: H(() => [
                  ee(I.$slots, "helperMessage")
                ]),
                _: 3
              }, 8, ["id", "modelValue", "placeholder", "helper-text", "helper-icon", "display-helper", "active", "disabled", "error"])),
              o(u) && o(u).length ? rt((f(), C("select", {
                key: 2,
                "onUpdate:modelValue": N[1] || (N[1] = (w) => fe(l) ? l.value = w : null),
                multiple: "",
                hidden: ""
              }, [
                (f(!0), C(X, null, le(o(u), (w) => (f(), C("option", {
                  key: w.value,
                  value: w.value
                }, G(w.text), 9, z9))), 128))
              ], 512)), [
                [ja, o(l)]
              ]) : _("", !0)
            ]),
            A("div", {
              id: r.id,
              style: De({
                width: r.popperWidth
              })
            }, null, 12, L9)
          ], 512)
        ]),
        _: 3
      }, 8, ["shown", "placement", "disabled", "container", "strategy", "style"])
    ], 2));
  }
}), E9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: k9
}, Symbol.toStringTag, { value: "Module" })), P9 = ["A-Z", "Z-A"], Y9 = [
  "auto",
  "auto-start",
  "auto-end",
  "top",
  "top-start",
  "top-end",
  "right",
  "right-start",
  "right-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "left",
  "left-start",
  "left-end"
], U9 = ["fixed", "absolute"], F9 = {
  id: {
    type: String,
    required: !0,
    default: "select"
  },
  modelValue: {
    type: [String, Number, Object, Array],
    default: ""
  },
  options: {
    type: Array,
    required: !0,
    default: []
  },
  groupItemsBy: {
    type: String,
    validator: (e) => e === void 0 || P9.includes(e)
  },
  textField: {
    type: String,
    default: "text",
    description: "Field name to use for display text when using dynamic object arrays"
  },
  valueField: {
    type: String,
    default: "value",
    description: "Field name to use for value when using dynamic object arrays"
  },
  placeholder: {
    type: String
  },
  label: {
    type: String,
    default: ""
  },
  placement: {
    type: String,
    validator: (e) => Y9.includes(e),
    default: "bottom"
  },
  popperStrategy: {
    type: String,
    validator: (e) => U9.includes(e),
    default: "absolute"
  },
  popperWidth: {
    type: String,
    default: "100%"
  },
  width: {
    type: String,
    default: "100%"
  },
  wrapperPosition: {
    type: String,
    default: "relative"
  },
  displayText: {
    type: String,
    default: ""
  },
  displayHelper: {
    type: Boolean,
    default: !1
  },
  helperIcon: {
    type: String,
    default: null
  },
  helperText: {
    type: String,
    default: ""
  },
  active: {
    type: Boolean,
    default: !1
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  error: {
    type: Boolean,
    default: !1
  },
  clearable: {
    type: Boolean,
    default: !1
  },
  searchable: {
    type: Boolean,
    default: !1
  },
  disabledLocalSearch: {
    type: Boolean,
    default: !1
  }
}, B9 = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  "update:modelValue": (e) => !0,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  "infinite-scroll-trigger": (e) => !0,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  "search-string": (e) => !0
}, R9 = (e, t) => {
  const { displayText: r, options: n, disabled: s, textField: a, valueField: i, disabledLocalSearch: l } = ye(e), u = F(() => {
    const j = L("spr-flex spr-flex-col spr-gap-size-spacing-4xs"), T = L("spr-body-sm-regular spr-text-color-strong spr-block", {
      "spr-text-color-on-fill-disabled": s.value
    });
    return {
      baseClasses: j,
      labelClasses: T
    };
  }), d = B(null), c = B(!1), p = F(() => s.value), h = B(null), y = Ie(e, "modelValue", t), M = B(), g = B([]), v = B(!1), m = B(""), I = B(""), N = B(!1), w = F(() => Array.isArray(y.value) ? y.value : y.value !== void 0 && y.value !== null ? [y.value] : []), E = F(() => y.value === void 0 || y.value === null ? [] : Array.isArray(y.value) ? y.value : [y.value]), $ = () => {
    if (!n.value || !Array.isArray(n.value) || n.value.length === 0) {
      g.value = [];
      return;
    }
    const j = n.value[0];
    if (typeof j == "string") {
      g.value = n.value.map((T) => ({
        text: T,
        value: T
      }));
      return;
    }
    if (typeof j == "number") {
      g.value = n.value.map((T) => ({
        text: T.toString(),
        value: T
        // Keep the value as a number instead of converting to string
      }));
      return;
    }
    if (typeof j == "object" && j !== null) {
      if ("text" in j && "value" in j) {
        g.value = n.value;
        return;
      }
      g.value = n.value.map((T) => {
        const O = T[a.value] || "Unnamed", S = i.value && T[i.value] !== void 0 ? T[i.value] : T;
        return {
          text: O,
          value: typeof S == "object" ? JSON.stringify(S) : S.toString(),
          _originalObject: T
          // Store the original object for reference
        };
      });
      return;
    }
    g.value = n.value;
  }, D = F(() => {
    if (l.value)
      return g.value;
    const j = m.value.toString().toLowerCase().trim();
    return j ? g.value.filter((T) => {
      var O;
      return (O = T.text) == null ? void 0 : O.toString().toLowerCase().includes(j);
    }) : g.value;
  }), z = () => {
    N.value = !0, k();
  }, k = W2(() => {
    t("search-string", m.value);
  }, 300), b = () => {
    c.value = !c.value, N.value = !1;
  }, P = (j) => {
    if (j.length === 0) {
      y.value = "";
      return;
    }
    v.value = !0;
    const T = j[0];
    if ("_originalObject" in T)
      y.value = T._originalObject;
    else {
      const O = T.value, S = T.text || "";
      typeof O == "string" && !isNaN(Number(O)) && O.trim() !== "" ? y.value = Number(O) : y.value = O, m.value = S;
    }
    I.value = m.value, setTimeout(() => {
      c.value = !1;
    }, 10);
  }, V = () => {
    if (!g.value.length) return;
    const j = w.value;
    if (!j || !j.length) {
      M.value = [], r.value && !v.value && !N.value && (!m.value || m.value === "") ? (m.value = r.value, I.value = r.value) : !v.value && (!m.value || m.value === "") && (m.value = "", I.value = "");
      return;
    }
    const T = j.map((S) => S == null ? { original: "", string: "" } : typeof S == "object" ? {
      original: S,
      string: JSON.stringify(S),
      isObject: !0,
      id: "id" in S ? S.id : void 0
    } : {
      original: S,
      string: S.toString(),
      isObject: !1
    }), O = T.map((S) => S.string);
    M.value = g.value.filter((S) => "_originalObject" in S && S._originalObject ? T.some((Y) => {
      if (Y.isObject && typeof Y.original == "object") {
        const U = S._originalObject;
        if (Y.original === U) return !0;
        const J = JSON.stringify(U);
        if (Y.string === J) return !0;
        if (Y.id !== void 0 && "id" in U)
          return Y.id === U.id;
      }
      return !1;
    }) : typeof S.value == "number" ? T.some((Y) => Y.original === S.value || Y.string === String(S.value)) : O.includes(String(S.value))), N.value || (m.value = M.value.map((S) => S.text).join(", "), r.value && !v.value && (!m.value || m.value === "") ? (m.value = r.value, I.value = r.value) : I.value = m.value);
  }, Z = () => {
    t("update:modelValue", ""), m.value = "";
  };
  return ce(y, () => {
    V();
  }), ce(g, () => {
    V();
  }), ce(
    n,
    () => {
      $();
    },
    { deep: !0 }
  ), Yt(d, () => {
    c.value = !1, N.value && (m.value = I.value), N.value = !1;
  }), kt(
    h,
    () => {
      t("infinite-scroll-trigger", !0);
    },
    { distance: 10 }
  ), Be(() => {
    $(), w.value.length > 0 ? V() : r.value && (m.value = r.value, I.value = r.value);
  }), {
    selectClasses: u,
    selectPopperState: c,
    selectRef: d,
    selectPopperRef: h,
    selectModel: E,
    // Use compatible format for lists
    selectOptions: g,
    filteredSelectOptions: D,
    selectedListItems: M,
    inputText: m,
    isSelectPopperDisabled: p,
    isSearching: N,
    handleOptionsToggle: b,
    handleSelectedItem: P,
    handleSearch: z,
    handleClear: Z
  };
}, V9 = ["for"], Q9 = { class: "spr-flex spr-cursor-pointer spr-items-center" }, H9 = ["value"], Z9 = ["value"], G9 = ["id"], W9 = {
  key: 1,
  class: "spr-flex spr-items-center spr-justify-center spr-p-2 spr-text-center"
}, K9 = {
  key: 1,
  class: "spr-flex spr-items-center spr-justify-center spr-p-2 spr-text-center"
}, J9 = {
  key: 1,
  class: "spr-flex spr-items-center spr-justify-center spr-p-2 spr-text-center"
}, X9 = /* @__PURE__ */ ae({
  __name: "select",
  props: F9,
  emits: B9,
  setup(e, { emit: t }) {
    const r = e, n = t, {
      selectClasses: s,
      selectPopperState: a,
      selectRef: i,
      selectPopperRef: l,
      selectModel: u,
      selectOptions: d,
      filteredSelectOptions: c,
      selectedListItems: p,
      inputText: h,
      isSelectPopperDisabled: y,
      isSearching: M,
      handleSelectedItem: g,
      handleSearch: v,
      handleClear: m,
      handleOptionsToggle: I
    } = R9(r, n);
    return (N, w) => (f(), C("div", {
      class: x(o(s).baseClasses)
    }, [
      r.label ? (f(), C("label", {
        key: 0,
        for: N.id,
        class: x(o(s).labelClasses)
      }, G(r.label), 11, V9)) : _("", !0),
      R(o(we), {
        shown: o(a),
        "aria-id": "select-wrapper",
        distance: "4",
        placement: r.placement,
        triggers: [],
        "popper-hide-triggers": [],
        "auto-hide": !1,
        disabled: o(y),
        container: `#${r.id}`,
        strategy: r.popperStrategy === "fixed" || r.popperStrategy === "absolute" ? r.popperStrategy : "absolute",
        delay: 0,
        style: De({
          position: r.wrapperPosition,
          width: r.width
        })
      }, {
        popper: H(() => [
          A("div", {
            ref_key: "selectPopperRef",
            ref: l,
            class: "spr-grid spr-max-h-[300px] spr-gap-0.5 spr-overflow-y-auto spr-overflow-x-hidden spr-p-2"
          }, [
            o(M) ? (f(), C(X, { key: 0 }, [
              r.disabledLocalSearch ? (f(), C(X, { key: 1 }, [
                o(d).length > 0 ? (f(), K(ct, {
                  key: 0,
                  modelValue: o(p),
                  "onUpdate:modelValue": [
                    w[3] || (w[3] = (E) => fe(p) ? p.value = E : null),
                    o(g)
                  ],
                  "menu-list": o(d),
                  "group-items-by": r.groupItemsBy,
                  "pre-selected-items": Array.isArray(o(u)) ? o(u).flat() : [o(u)]
                }, null, 8, ["modelValue", "menu-list", "group-items-by", "pre-selected-items", "onUpdate:modelValue"])) : (f(), C("div", K9, w[6] || (w[6] = [
                  A("span", { class: "spr-body-sm-regular spr-m-0" }, "No results found", -1)
                ])))
              ], 64)) : (f(), C(X, { key: 0 }, [
                o(c).length > 0 ? (f(), K(ct, {
                  key: 0,
                  modelValue: o(p),
                  "onUpdate:modelValue": [
                    w[2] || (w[2] = (E) => fe(p) ? p.value = E : null),
                    o(g)
                  ],
                  "menu-list": o(c),
                  "group-items-by": r.groupItemsBy,
                  "pre-selected-items": Array.isArray(o(u)) ? o(u).flat() : [o(u)]
                }, null, 8, ["modelValue", "menu-list", "group-items-by", "pre-selected-items", "onUpdate:modelValue"])) : (f(), C("div", W9, w[5] || (w[5] = [
                  A("span", { class: "spr-body-sm-regular spr-m-0" }, "No results found", -1)
                ])))
              ], 64))
            ], 64)) : (f(), C(X, { key: 1 }, [
              o(d).length > 0 ? (f(), K(ct, {
                key: 0,
                modelValue: o(p),
                "onUpdate:modelValue": [
                  w[4] || (w[4] = (E) => fe(p) ? p.value = E : null),
                  o(g)
                ],
                "menu-list": o(d),
                "group-items-by": r.groupItemsBy,
                "pre-selected-items": Array.isArray(o(u)) ? o(u).flat() : [o(u)]
              }, null, 8, ["modelValue", "menu-list", "group-items-by", "pre-selected-items", "onUpdate:modelValue"])) : (f(), C("div", J9, w[7] || (w[7] = [
                A("span", { class: "spr-body-sm-regular spr-m-0" }, "No results found", -1)
              ])))
            ], 64))
          ], 512)
        ]),
        default: H(() => [
          A("div", {
            ref_key: "selectRef",
            ref: i
          }, [
            A("div", {
              onClick: w[1] || (w[1] = //@ts-ignore
              (...E) => o(I) && o(I)(...E))
            }, [
              R(Ee, {
                id: `input-${r.id}`,
                modelValue: o(h),
                "onUpdate:modelValue": w[0] || (w[0] = (E) => fe(h) ? h.value = E : null),
                class: x({
                  "spr-cursor-pointer": !r.searchable
                }),
                placeholder: r.placeholder,
                autocomplete: "off",
                "helper-text": r.helperText,
                "helper-icon": r.helperIcon,
                "display-helper": r.displayHelper,
                active: r.active,
                readonly: !r.searchable,
                disabled: r.disabled,
                error: r.error,
                onKeyup: o(v)
              }, {
                icon: H(() => [
                  A("div", Q9, [
                    r.clearable && o(h) ? (f(), K(o(W), {
                      key: 0,
                      class: "spr-cursor-pointer",
                      icon: "ph:x",
                      onClick: Mt(o(m), ["stop"])
                    }, null, 8, ["onClick"])) : _("", !0),
                    R(o(W), { icon: "ph:caret-down" })
                  ])
                ]),
                helperMessage: H(() => [
                  ee(N.$slots, "helperMessage")
                ]),
                _: 3
              }, 8, ["id", "modelValue", "class", "placeholder", "helper-text", "helper-icon", "display-helper", "active", "readonly", "disabled", "error", "onKeyup"]),
              o(d) && o(d).length ? (f(), C("select", {
                key: 0,
                value: Array.isArray(o(u)) ? o(u)[0] : o(u),
                "data-testid": "qa-hidden-select",
                tabindex: "-1",
                "aria-hidden": "true",
                hidden: ""
              }, [
                (f(!0), C(X, null, le(o(d), (E) => (f(), C("option", {
                  key: E.value,
                  value: E.value
                }, G(E.text), 9, Z9))), 128))
              ], 8, H9)) : _("", !0)
            ]),
            A("div", {
              id: r.id,
              style: De({
                width: r.popperWidth
              })
            }, null, 12, G9)
          ], 512)
        ]),
        _: 3
      }, 8, ["shown", "placement", "disabled", "container", "strategy", "style"])
    ], 2));
  }
}), q9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: X9
}, Symbol.toStringTag, { value: "Module" })), ep = {
  quickActions: {
    type: Array,
    validator: (e) => Array.isArray(e),
    default: () => []
  },
  hasSearch: {
    type: Boolean,
    validator: (e) => typeof e == "boolean",
    default: !1
  },
  activeNav: {
    type: Object,
    validator: (e) => typeof e == "object",
    default: () => ({ parentNav: "", menu: "", submenu: "" })
  },
  navLinks: {
    type: Object,
    default: () => []
  },
  notificationCount: {
    type: [String, Number],
    validator: (e) => typeof e == "number" || typeof e == "string",
    default: ""
  },
  requestCount: {
    type: [String, Number],
    validator: (e) => typeof e == "number" || typeof e == "string",
    default: ""
  },
  userMenu: {
    type: Object,
    validator: (e) => typeof e == "object",
    default: !1
  },
  isNotifActive: {
    type: Boolean,
    validator: (e) => typeof e == "boolean",
    default: !1
  },
  isRequestActive: {
    type: Boolean,
    validator: (e) => typeof e == "boolean",
    default: !1
  },
  isNavApi: {
    type: Boolean,
    validator: (e) => typeof e == "boolean",
    default: !1
  }
}, tp = {
  "get-navlink-item": String,
  search: Function,
  notifications: Function,
  requests: Function
}, rp = (e, t) => {
  const r = B(e.navLinks), n = B(!1), s = B(!1), a = B(!1), i = (m) => {
    const I = m.split(" ");
    return (I[0].charAt(0) + (I[1] ? I[1].charAt(0) : "")).toUpperCase();
  }, l = (m, I, N, w) => {
    if (m && m.redirect)
      if (m.redirect.openInNewTab)
        window.open(m.redirect.link, "_blank");
      else if (m.redirect.isAbsoluteURL)
        location.href = m.redirect.link;
      else {
        const E = { ...m };
        (I || N || w) && (E.activeNav = {
          parentNav: I,
          menu: N,
          submenu: w
        }), t("get-navlink-item", E);
      }
  }, u = (m) => m.toLowerCase().split(" ").map((I, N) => N === 0 ? I : I.charAt(0).toUpperCase() + I.slice(1)).join(""), d = (...m) => m.map(u).join("_"), c = (m) => {
    const I = window.location.hostname, N = new URL(m).hostname;
    return I === N || window.location.hostname === "localhost";
  }, p = (m) => {
    const I = new URL(m);
    return I ? I.pathname : "";
  }, h = (m) => c(m.url) ? p(m.url) : m.url, y = (m) => {
    const I = {};
    return m.forEach((N) => {
      I[N.groupId] || (I[N.groupId] = []), I[N.groupId].push(N);
    }), Object.values(I).map((N) => ({ parentLinks: N.map(M) }));
  }, M = (m) => {
    const I = (E, $) => !E || E.length === 0 ? {} : E.reduce((D, z) => {
      const k = String(z[$] || "");
      return D[k] = D[k] || [], D[k].push(z), D;
    }, {}), N = (E, $) => Object.entries(E).map(([D, z]) => ({
      [$]: D,
      items: z.map(M)
    })), w = I(m.children ?? void 0, "groupName");
    return {
      title: m.label,
      icon: m.icon || void 0,
      redirect: m.url ? {
        openInNewTab: m.isNewTab || !1,
        isAbsoluteURL: !c(m.url),
        link: h(m)
      } : void 0,
      menuLinks: N(w, "menuHeading"),
      submenuLinks: N(w, "subMenuHeading")
    };
  }, g = (m) => m.filter((I) => I !== null && "groupId" in I && "label" in I && typeof I.groupId == "string" && typeof I.label == "string"), v = async (m) => {
    const I = { top: [], bottom: [] };
    if (m.top && Array.isArray(m.top)) {
      const N = g(m.top);
      I.top = y(N);
    }
    if (m.bottom && Array.isArray(m.bottom)) {
      const N = g(m.bottom);
      I.bottom = y(N);
    }
    return I;
  };
  return Be(async () => {
    e.isNavApi && (r.value = await v(e.navLinks));
  }), {
    navLinks: r,
    isQuckActionMenuVisible: n,
    isUserMenuVisible: s,
    userProfileError: a,
    getUserInitials: i,
    handleRedirect: l,
    generateId: d,
    transformedNavItems: v
  };
}, np = {
  class: /* @__PURE__ */ x([
    "spr-hidden-scrolls spr-fixed spr-bottom-0 spr-left-0 spr-top-0",
    "spr-background-color spr-w-auto spr-overflow-y-auto spr-overflow-x-hidden",
    "spr-border-color-weak spr-border-b-0 spr-border-l-0 spr-border-r spr-border-t-0 spr-border-solid",
    "spr-transition spr-duration-150 spr-ease-in-out"
  ])
}, sp = { class: "spr-grid spr-justify-center spr-gap-2 spr-px-3 spr-pb-4 spr-pt-4" }, ap = {
  class: /* @__PURE__ */ x([
    "spr-grid spr-justify-center spr-p-2",
    "[&>img]:spr-mx-auto [&>img]:spr-h-[24px] [&>img]:spr-w-[24px] [&>img]:spr-object-cover"
  ])
}, op = {
  class: /* @__PURE__ */ x([
    "spr-px-4 spr-py-3",
    "spr-border-color-weak spr-flex spr-justify-between spr-border-x-0 spr-border-b spr-border-t-0 spr-border-solid"
  ])
}, ip = { class: "spr-max-h-[268px] spr-overflow-auto" }, lp = ["onClick"], up = { class: "spr-grid spr-justify-between" }, dp = { class: "spr-body-sm-regular-medium spr-text-color-strong spr-m-0 spr-truncate" }, cp = { class: "spr-body-xs-regular spr-text-color-base spr-m-0 spr-truncate" }, pp = ["id"], fp = ["src", "alt"], gp = ["src", "alt"], hp = { class: "spr-border-color-weak spr-border-x-0 spr-border-b spr-border-t-0 spr-border-solid spr-p-2" }, yp = { class: "spr-body-sm-regular-medium spr-m-0" }, Cp = ["id"], vp = {
  key: 0,
  class: "spr-background-color-brand-base spr-absolute spr-left-0 spr-top-0 spr-h-full spr-w-[2px]"
}, mp = ["id", "onClick"], Mp = { class: "spr-background-color-brand-base spr-absolute spr-left-0 spr-top-0 spr-h-full spr-w-[2px]" }, bp = ["id", "onClick"], Np = {
  key: 0,
  class: "spr-background-color-brand-base spr-absolute spr-left-0 spr-top-0 spr-h-full spr-w-[2px]"
}, $p = { class: "spr-label-xs-medium spr-uppercase" }, Dp = ["id", "onClick"], Ip = ["src", "alt"], Ap = ["src", "alt"], xp = {
  key: 0,
  class: "spr-background-color-hover spr-h-[2px] spr-w-full"
}, wp = {
  key: 0,
  class: "spr-grid spr-justify-center spr-gap-2 spr-px-3 spr-pb-4 spr-pt-0"
}, Sp = ["id"], jp = ["src", "alt"], Tp = ["src", "alt"], Op = { class: "spr-border-color-weak spr-border-x-0 spr-border-b spr-border-t-0 spr-border-solid spr-p-2" }, _p = { class: "spr-body-sm-regular-medium spr-m-0" }, zp = ["id"], Lp = {
  key: 0,
  class: "spr-background-color-brand-base spr-absolute spr-left-0 spr-top-0 spr-h-full spr-w-[2px]"
}, kp = ["id", "onClick"], Ep = { class: "spr-background-color-brand-base spr-absolute spr-left-0 spr-top-0 spr-h-full spr-w-[2px]" }, Pp = ["id", "onClick"], Yp = { class: "spr-label-xs-medium spr-uppercase" }, Up = ["id", "onClick"], Fp = ["src", "alt"], Bp = ["src", "alt"], Rp = {
  key: 0,
  class: "spr-background-color-hover spr-h-[2px] spr-w-full"
}, Vp = {
  key: 0,
  class: "spr-grid spr-gap-2 spr-py-6"
}, Qp = {
  key: 1,
  class: /* @__PURE__ */ x([
    "spr-border-color-weak spr-absolute spr-bottom-0 spr-p-3.5",
    "spr-border-b-0 spr-border-l-0 spr-border-r-0 spr-border-t spr-border-solid",
    "spr-flex spr-justify-center"
  ])
}, Hp = ["src"], Zp = { key: 1 }, Gp = {
  class: /* @__PURE__ */ x([
    "spr-px-2 spr-py-2",
    "spr-border-color-weak spr-flex spr-justify-between spr-border-x-0 spr-border-b spr-border-t-0 spr-border-solid"
  ])
}, Wp = { class: "spr-flex spr-items-center spr-gap-2" }, Kp = {
  class: /* @__PURE__ */ x([
    "spr-background-color spr-flex spr-h-[36px] spr-w-[36px] spr-items-center spr-justify-center spr-rounded-full",
    "spr-border-color-weak spr-border spr-border-solid",
    "[&>img]:spr-h-[36px] [&>img]:spr-w-[36px] [&>img]:spr-rounded-full [&>img]:spr-object-cover"
  ])
}, Jp = ["src"], Xp = { key: 1 }, qp = { class: "spr-grid spr-justify-between spr-gap-1" }, e8 = { class: "spr-body-sm-regular spr-m-0 spr-truncate" }, t8 = { class: "spr-body-xs-regular spr-m-0 spr-truncate spr-text-color-supporting" }, r8 = { class: "spr-max-h-[268px] spr-overflow-auto" }, n8 = ["id", "onClick"], s8 = { class: "spr-body-sm-regular spr-text-color-strong spr-m-0 spr-truncate" }, a8 = /* @__PURE__ */ ae({
  __name: "sidenav",
  props: ep,
  emits: tp,
  setup(e, { emit: t }) {
    const r = e, n = t, { navLinks: s, isQuckActionMenuVisible: a, isUserMenuVisible: i, userProfileError: l, getUserInitials: u, handleRedirect: d, generateId: c } = rp(
      r,
      n
    );
    return (p, h) => (f(), C("div", np, [
      A("div", {
        class: x({
          "spr-hidden-scrolls spr-flex spr-h-full spr-flex-col spr-justify-between spr-overflow-auto": !0,
          "spr-max-h-[calc(100vh-60px)]": r.notificationCount === null && r.requestCount === null,
          "spr-max-h-[calc(100vh-194px)]": r.notificationCount && r.requestCount || r.notificationCount === 0 || r.requestCount === 0,
          "!spr-max-h-[calc(100vh-150px)]": r.requestCount === "" || r.notificationCount === ""
        })
      }, [
        A("div", sp, [
          A("div", ap, [
            ee(p.$slots, "logo-image")
          ]),
          r.quickActions && r.quickActions.length > 0 ? (f(), K(o(we), {
            key: 0,
            shown: o(a),
            "onUpdate:shown": h[2] || (h[2] = (y) => fe(a) ? a.value = y : null),
            "aria-id": "quick-action-menu-wrapper",
            distance: "18",
            placement: "right-start",
            triggers: [],
            "popper-hide-triggers": [],
            "instant-move": ""
          }, {
            popper: H(() => [
              A("div", op, [
                h[10] || (h[10] = A("h3", { class: "spr-body-sm-regular-medium spr-m-0" }, "Quick Actions", -1)),
                R(o(W), {
                  icon: "ph:x",
                  class: x([
                    "spr-text-color-weak spr-h-[20px] spr-w-[20px] spr-cursor-pointer",
                    "spr-transition spr-duration-150 spr-ease-in-out",
                    "active:spr-scale-90"
                  ]),
                  onClick: h[1] || (h[1] = (y) => a.value = !o(a))
                })
              ]),
              A("div", ip, [
                (f(!0), C(X, null, le(r.quickActions, (y, M) => (f(), C(X, { key: M }, [
                  y.menuHeading ? (f(), C("h5", {
                    key: 0,
                    class: x([
                      {
                        "spr-label-xs-medium spr-text-color-supporting spr-m-0 spr-p-2": !0,
                        "spr-mt-3": M !== 0
                      }
                    ])
                  }, G(y.menuHeading), 3)) : _("", !0),
                  (f(!0), C(X, null, le(y.items, (g, v) => (f(), C(X, { key: v }, [
                    g.hidden ? _("", !0) : (f(), C("div", {
                      key: 0,
                      class: x([
                        "spr-flex spr-cursor-pointer spr-gap-2 spr-px-4 spr-py-3 spr-align-middle spr-duration-150 spr-ease-in-out",
                        "hover:spr-background-color-hover",
                        "active:spr-background-color-pressed"
                      ]),
                      onClick: (m) => o(d)(g, "", "", "")
                    }, [
                      A("div", {
                        class: x({
                          "spr-flex spr-items-center spr-rounded-border-radius-md spr-p-2": !0,
                          "spr-border spr-border-solid spr-border-kangkong-400 spr-bg-kangkong-50 spr-text-kangkong-800": g.iconBgColor === "green",
                          "spr-border spr-border-solid spr-border-ubas-400 spr-bg-ubas-50 spr-text-ubas-800": g.iconBgColor === "purple"
                        })
                      }, [
                        g.icon ? (f(), K(o(W), {
                          key: 0,
                          icon: g.icon,
                          class: "spr-h-[1em] spr-w-[1em] spr-text-[20px]"
                        }, null, 8, ["icon"])) : _("", !0)
                      ], 2),
                      A("div", up, [
                        A("h5", dp, G(g.title), 1),
                        A("p", cp, G(g.description), 1)
                      ])
                    ], 8, lp))
                  ], 64))), 128))
                ], 64))), 128))
              ])
            ]),
            default: H(() => [
              A("div", {
                class: x({
                  "spr-flex spr-w-full spr-cursor-pointer spr-items-center spr-text-center spr-text-[28px] spr-transition spr-duration-150 spr-ease-in-out": !0,
                  "hover:spr-brightness-75": !0,
                  "active:spr-text-color-success-pressed active:spr-scale-90": !0,
                  "spr-text-color-inverted-disabled spr-rotate-180": o(a),
                  "spr-text-color-brand-base": !o(a)
                }),
                onClick: h[0] || (h[0] = (y) => a.value = !o(a))
              }, [
                R(o(W), {
                  icon: "ph:plus-circle-fill",
                  class: "spr-w-full"
                })
              ], 2)
            ]),
            _: 1
          }, 8, ["shown"])) : _("", !0),
          r.hasSearch ? (f(), C("div", {
            key: 1,
            id: "sidenav_search",
            class: x([
              "spr-flex spr-cursor-pointer spr-items-center spr-justify-center spr-rounded-border-radius-md spr-p-2 spr-transition spr-duration-150 spr-ease-in-out",
              "hover:spr-background-color-hover",
              "active:spr-background-color-single-active active:spr-scale-90",
              "spr-max-w-9 spr-max-h-9 spr-m-auto spr-box-border"
            ]),
            onClick: h[3] || (h[3] = (y) => n("search", "search-triggered"))
          }, [
            R(o(W), {
              icon: "ph:magnifying-glass",
              class: "spr-h-[1.25em] spr-w-[1.25em]"
            })
          ])) : _("", !0),
          (f(!0), C(X, null, le(o(s).top, (y, M) => (f(), C(X, { key: M }, [
            (f(!0), C(X, null, le(y.parentLinks, (g, v) => (f(), C(X, { key: v }, [
              g.menuLinks && g.menuLinks.length > 0 ? (f(), K(o(we), {
                key: 0,
                "aria-id": "sidenav-menu-wrapper",
                distance: "18",
                placement: "right",
                triggers: ["click", "hover"],
                "instant-move": ""
              }, {
                popper: H(() => [
                  A("div", hp, [
                    A("h3", yp, G(g.title), 1)
                  ]),
                  (f(!0), C(X, null, le(g.menuLinks, (m, I) => (f(), C(X, { key: I }, [
                    m.menuHeading ? (f(), C("h5", {
                      key: 0,
                      class: x({
                        "spr-label-xs-medium spr-text-color-supporting spr-m-0 spr-p-2": !0,
                        "spr-mt-2": I !== 0
                      })
                    }, G(m.menuHeading), 3)) : _("", !0),
                    (f(!0), C(X, null, le(m.items, (N, w) => (f(), C(X, { key: w }, [
                      N.submenuLinks && N.submenuLinks.length > 0 ? (f(), K(o(we), {
                        key: 0,
                        "aria-id": "sidenav-submenu-wrapper",
                        distance: "4",
                        placement: "right-start",
                        triggers: ["click", "hover"],
                        "instant-move": ""
                      }, {
                        popper: H(() => [
                          (f(!0), C(X, null, le(N.submenuLinks, (E, $) => (f(), C(X, { key: $ }, [
                            R(o(we), {
                              "aria-id": "sidenav-sub-submenu-subheading-wrapper",
                              triggers: ["click", "hover"],
                              "instant-move": ""
                            }, {
                              default: H(() => [
                                E.subMenuHeading ? (f(), C("h5", {
                                  key: 0,
                                  class: x({
                                    "spr-label-xs-medium spr-text-color-supporting spr-m-0 spr-p-2": !0,
                                    "spr-mt-2": $ !== 0
                                  })
                                }, G(E.subMenuHeading), 3)) : _("", !0)
                              ]),
                              _: 2
                            }, 1024),
                            (f(!0), C(X, null, le(E.items, (D, z) => (f(), K(o(we), {
                              key: z,
                              "aria-id": "sidenav-sub-submenu-wrapper",
                              triggers: ["click", "hover"],
                              "instant-move": ""
                            }, {
                              default: H(() => [
                                D.hidden ? _("", !0) : (f(), C("div", {
                                  key: 0,
                                  id: `${o(c)(g.title, N.title, D.title)}`,
                                  class: x({
                                    "spr-body-sm-regular spr-relative spr-m-0 spr-flex spr-cursor-pointer spr-justify-between spr-px-2 spr-py-1.5 spr-align-middle spr-duration-150 spr-ease-in-out": !0,
                                    "spr-background-color-single-active": r.activeNav.submenu === D.title,
                                    "hover:spr-background-color-hover": r.activeNav.submenu !== D.title,
                                    "active:spr-background-color-pressed": !0
                                  }),
                                  onClick: (k) => o(d)(
                                    D,
                                    g.title,
                                    N.title,
                                    D.title
                                  )
                                }, [
                                  rt(A("div", Mp, null, 512), [
                                    [C0, r.activeNav.submenu === D.title]
                                  ]),
                                  A("span", null, G(D.title), 1)
                                ], 10, mp))
                              ]),
                              _: 2
                            }, 1024))), 128))
                          ], 64))), 128))
                        ]),
                        default: H(() => [
                          A("div", {
                            id: `${o(c)(g.title, N.title)}`,
                            class: x({
                              "spr-body-sm-regular spr-relative spr-m-0 spr-flex spr-cursor-pointer spr-justify-between spr-px-2 spr-py-1.5 spr-align-middle spr-duration-150 spr-ease-in-out": !0,
                              "spr-background-color-single-active": r.activeNav.menu === N.title,
                              "hover:spr-background-color-hover": r.activeNav.menu !== N.title,
                              "active:spr-background-color-pressed": !0
                            })
                          }, [
                            r.activeNav.menu === N.title ? (f(), C("div", vp)) : _("", !0),
                            A("span", null, G(N.title), 1),
                            R(o(W), {
                              icon: "ph:caret-right",
                              class: "spr-h-[16px] spr-w-[16px] spr-transform spr-font-normal spr-transition-transform spr-duration-300"
                            })
                          ], 10, Cp)
                        ]),
                        _: 2
                      }, 1024)) : (f(), C(X, { key: 1 }, [
                        N.hidden ? _("", !0) : (f(), C("div", {
                          key: 0,
                          id: `${o(c)(g.title, N.title)}`,
                          class: x({
                            "spr-body-sm-regular spr-relative spr-m-0 spr-flex spr-cursor-pointer spr-justify-between spr-px-2 spr-py-1.5 spr-align-middle spr-duration-150 spr-ease-in-out": !0,
                            "spr-background-color-single-active": r.activeNav.menu === N.title,
                            "hover:spr-background-color-hover": r.activeNav.menu !== N.title,
                            "active:spr-background-color-pressed": !0
                          }),
                          onClick: (E) => o(d)(N, g.title, N.title, "")
                        }, [
                          r.activeNav.menu === N.title ? (f(), C("div", Np)) : _("", !0),
                          A("span", null, G(N.title), 1)
                        ], 10, bp))
                      ], 64))
                    ], 64))), 128))
                  ], 64))), 128))
                ]),
                default: H(() => [
                  A("div", {
                    id: `${o(c)(g.title)}`,
                    class: x({
                      "spr-flex spr-cursor-pointer spr-items-center spr-justify-center spr-rounded-border-radius-md spr-p-2 spr-transition spr-duration-150 spr-ease-in-out spr-max-w-9 spr-max-h-9 spr-m-auto spr-box-border": !0,
                      "spr-background-color-single-active spr-border-color-brand-base spr-border-[1.5px] spr-border-solid active:spr-scale-90": r.activeNav.parentNav === g.title,
                      "hover:spr-background-color-hover": r.activeNav.parentNav != g.title,
                      "active:spr-background-color-single-active active:spr-scale-90": !0
                    })
                  }, [
                    g.icon && g.icon.includes("https://") ? (f(), C(X, { key: 0 }, [
                      g.icon && r.activeNav.parentNav !== g.title ? (f(), C("img", {
                        key: 0,
                        src: g.icon,
                        alt: `${g.title} icon`,
                        class: "spr-h-[1.25em] spr-w-[1.25em] spr-max-w-[1.25em]"
                      }, null, 8, fp)) : r.activeNav.parentNav === g.title ? (f(), C("img", {
                        key: 1,
                        src: g.icon.replace(/\.(svg|png|jpg)$/, "-fill.$1"),
                        alt: `${g.title} icon`,
                        class: "spr-h-[1.25em] spr-w-[1.25em] spr-max-w-[1.25em]"
                      }, null, 8, gp)) : _("", !0)
                    ], 64)) : (f(), C(X, { key: 1 }, [
                      g.icon && r.activeNav.parentNav !== g.title ? (f(), K(o(W), {
                        key: 0,
                        icon: g.icon,
                        class: "spr-h-[1.25em] spr-w-[1.25em]"
                      }, null, 8, ["icon"])) : r.activeNav.parentNav === g.title ? (f(), K(o(W), {
                        key: 1,
                        icon: `${g.icon}-fill`,
                        class: "spr-text-kangkong-700 spr-h-[1.25em] spr-w-[1.25em]"
                      }, null, 8, ["icon"])) : (f(), K(o(W), {
                        key: 2,
                        icon: "ph:globe"
                      }))
                    ], 64))
                  ], 10, pp)
                ]),
                _: 2
              }, 1024)) : (f(), C(X, { key: 1 }, [
                g.hidden ? _("", !0) : (f(), K(o(Qt), {
                  key: 0,
                  "aria-id": "sidenav-tooltip-wrapper",
                  placement: "right",
                  distance: "18",
                  triggers: ["hover"]
                }, {
                  popper: H(() => [
                    A("span", $p, G(g.title), 1)
                  ]),
                  default: H(() => [
                    A("div", {
                      id: `${o(c)(g.title)}`,
                      class: x({
                        "spr-flex spr-cursor-pointer spr-items-center spr-justify-center spr-rounded-border-radius-md spr-p-2 spr-transition spr-duration-150 spr-ease-in-out spr-max-w-9 spr-max-h-9 spr-m-auto spr-box-border": !0,
                        "spr-background-color-single-active spr-border-color-brand-base spr-border-[1.5px] spr-border-solid active:spr-scale-90": r.activeNav.parentNav === g.title,
                        "hover:spr-background-color-hover": r.activeNav.parentNav != g.title,
                        "active:spr-background-color-single-active active:spr-scale-90": !0
                      }),
                      onClick: (m) => o(d)(g, g.title, "", "")
                    }, [
                      g.icon && g.icon.includes("https://") ? (f(), C(X, { key: 0 }, [
                        g.icon && r.activeNav.parentNav !== g.title ? (f(), C("img", {
                          key: 0,
                          src: g.icon,
                          alt: `${g.title} icon`,
                          class: "spr-h-[1.25em] spr-w-[1.25em] spr-max-w-[1.25em]"
                        }, null, 8, Ip)) : r.activeNav.parentNav === g.title ? (f(), C("img", {
                          key: 1,
                          src: g.icon.replace(/\.(svg|png|jpg)$/, "-fill.$1"),
                          alt: `${g.title} icon`,
                          class: "spr-h-[1.25em] spr-w-[1.25em] spr-max-w-[1.25em]"
                        }, null, 8, Ap)) : _("", !0)
                      ], 64)) : (f(), C(X, { key: 1 }, [
                        g.icon && r.activeNav.parentNav !== g.title ? (f(), K(o(W), {
                          key: 0,
                          icon: g.icon,
                          class: "spr-h-[1.25em] spr-w-[1.25em]"
                        }, null, 8, ["icon"])) : r.activeNav.parentNav === g.title ? (f(), K(o(W), {
                          key: 1,
                          icon: `${g.icon}-fill`,
                          class: "spr-text-kangkong-700 spr-h-[1.25em] spr-w-[1.25em]"
                        }, null, 8, ["icon"])) : (f(), K(o(W), {
                          key: 2,
                          icon: "ph:globe"
                        }))
                      ], 64))
                    ], 10, Dp)
                  ]),
                  _: 2
                }, 1024))
              ], 64))
            ], 64))), 128)),
            o(s).top.length > 0 && M < o(s).top.length - 1 ? (f(), C("div", xp)) : _("", !0)
          ], 64))), 128))
        ]),
        o(s).bottom && o(s).bottom.length > 0 ? (f(), C("div", wp, [
          (f(!0), C(X, null, le(o(s).bottom, (y, M) => (f(), C(X, { key: M }, [
            (f(!0), C(X, null, le(y.parentLinks, (g, v) => (f(), C(X, { key: v }, [
              g.menuLinks && g.menuLinks.length > 0 ? (f(), K(o(we), {
                key: 0,
                "aria-id": "sidenav-menu-wrapper",
                distance: "18",
                placement: "right",
                triggers: ["click", "hover"],
                "instant-move": ""
              }, {
                popper: H(() => [
                  A("div", Op, [
                    A("h3", _p, G(g.title), 1)
                  ]),
                  (f(!0), C(X, null, le(g.menuLinks, (m, I) => (f(), C(X, { key: I }, [
                    m.menuHeading ? (f(), C("h5", {
                      key: 0,
                      class: x({
                        "spr-label-xs-medium spr-text-color-supporting spr-m-0 spr-p-2": !0,
                        "spr-mt-3": I !== 0
                      })
                    }, G(m.menuHeading), 3)) : _("", !0),
                    (f(!0), C(X, null, le(m.items, (N, w) => (f(), C(X, { key: w }, [
                      N.submenuLinks && N.submenuLinks.length > 0 ? (f(), K(o(we), {
                        key: 0,
                        "aria-id": "sidenav-submenu-wrapper",
                        distance: "4",
                        placement: "right-start",
                        triggers: ["click", "hover"],
                        "instant-move": ""
                      }, {
                        popper: H(() => [
                          (f(!0), C(X, null, le(N.submenuLinks, (E, $) => (f(), C(X, { key: $ }, [
                            R(o(we), {
                              "aria-id": "sidenav-sub-submenu-subheading-wrapper",
                              triggers: ["click", "hover"],
                              "instant-move": ""
                            }, {
                              default: H(() => [
                                E.subMenuHeading ? (f(), C("h5", {
                                  key: 0,
                                  class: x({
                                    "spr-label-xs-medium spr-text-color-supporting spr-m-0 spr-p-2": !0,
                                    "spr-mt-3": $ !== 0
                                  })
                                }, G(E.subMenuHeading), 3)) : _("", !0)
                              ]),
                              _: 2
                            }, 1024),
                            (f(!0), C(X, null, le(E.items, (D, z) => (f(), K(o(we), {
                              key: z,
                              "aria-id": "sidenav-sub-submenu-wrapper",
                              triggers: ["click", "hover"],
                              "instant-move": ""
                            }, {
                              default: H(() => [
                                D.hidden ? _("", !0) : (f(), C("div", {
                                  key: 0,
                                  id: `${o(c)(g.title, N.title, D.title)}`,
                                  class: x({
                                    "spr-body-sm-regular spr-relative spr-m-0 spr-flex spr-cursor-pointer spr-justify-between spr-px-2 spr-py-1.5 spr-align-middle spr-duration-150 spr-ease-in-out": !0,
                                    "spr-background-color-single-active": r.activeNav.submenu === D.title,
                                    "hover:spr-background-color-hover": r.activeNav.submenu !== D.title,
                                    "active:spr-background-color-pressed": !0
                                  }),
                                  onClick: (k) => o(d)(
                                    D,
                                    g.title,
                                    N.title,
                                    D.title
                                  )
                                }, [
                                  rt(A("div", Ep, null, 512), [
                                    [C0, r.activeNav.submenu === D.title]
                                  ]),
                                  A("span", null, G(D.title), 1)
                                ], 10, kp))
                              ]),
                              _: 2
                            }, 1024))), 128))
                          ], 64))), 128))
                        ]),
                        default: H(() => [
                          A("div", {
                            id: `${o(c)(g.title, N.title)}`,
                            class: x({
                              "spr-body-sm-regular spr-relative spr-m-0 spr-flex spr-cursor-pointer spr-justify-between spr-px-2 spr-py-1.5 spr-align-middle spr-duration-150 spr-ease-in-out": !0,
                              "spr-background-color-single-active": r.activeNav.menu === N.title,
                              "hover:spr-background-color-hover": r.activeNav.menu !== N.title,
                              "active:spr-background-color-pressed": !0
                            })
                          }, [
                            r.activeNav.menu === N.title ? (f(), C("div", Lp)) : _("", !0),
                            A("span", null, G(N.title), 1),
                            R(o(W), {
                              icon: "ph:caret-right",
                              class: "spr-h-[16px] spr-w-[16px] spr-transform spr-font-normal spr-transition-transform spr-duration-300"
                            })
                          ], 10, zp)
                        ]),
                        _: 2
                      }, 1024)) : (f(), C(X, { key: 1 }, [
                        N.hidden ? _("", !0) : (f(), C("div", {
                          key: 0,
                          id: `${o(c)(g.title, N.title)}`,
                          class: x([
                            "spr-body-sm-regular spr-m-0 spr-flex spr-cursor-pointer spr-justify-between spr-px-2 spr-py-1.5 spr-align-middle spr-duration-300 spr-ease-in-out",
                            "hover:spr-background-color-hover",
                            "active:spr-background-color-pressed",
                            "last:spr-rounded-b-xl"
                          ]),
                          onClick: (E) => o(d)(N, g.title, N.title, "")
                        }, [
                          A("span", null, G(N.title), 1)
                        ], 8, Pp))
                      ], 64))
                    ], 64))), 128))
                  ], 64))), 128))
                ]),
                default: H(() => [
                  A("div", {
                    id: `${o(c)(g.title)}`,
                    class: x({
                      "spr-flex spr-cursor-pointer spr-items-center spr-justify-center spr-rounded-border-radius-md spr-p-2 spr-transition spr-duration-150 spr-ease-in-out spr-max-w-9 spr-max-h-9 spr-m-auto spr-box-border": !0,
                      "spr-background-color-single-active spr-border-color-brand-base spr-border-[1.5px] spr-border-solid active:spr-scale-90": r.activeNav.parentNav === g.title,
                      "hover:spr-background-color-hover": r.activeNav.parentNav != g.title,
                      "active:spr-background-color-single-active active:spr-scale-90": !0
                    })
                  }, [
                    g.icon && g.icon.includes("https://") ? (f(), C(X, { key: 0 }, [
                      g.icon && r.activeNav.parentNav !== g.title ? (f(), C("img", {
                        key: 0,
                        src: g.icon,
                        alt: `${g.title} icon`,
                        class: "spr-h-[1.25em] spr-w-[1.25em] spr-max-w-[1.25em]"
                      }, null, 8, jp)) : r.activeNav.parentNav === g.title ? (f(), C("img", {
                        key: 1,
                        src: g.icon.replace(/\.(svg|png|jpg)$/, "-fill.$1"),
                        alt: `${g.title} icon`,
                        class: "spr-h-[1.25em] spr-w-[1.25em] spr-max-w-[1.25em]"
                      }, null, 8, Tp)) : _("", !0)
                    ], 64)) : (f(), C(X, { key: 1 }, [
                      g.icon && r.activeNav.parentNav !== g.title ? (f(), K(o(W), {
                        key: 0,
                        icon: g.icon,
                        class: "spr-h-[1.25em] spr-w-[1.25em]"
                      }, null, 8, ["icon"])) : r.activeNav.parentNav === g.title ? (f(), K(o(W), {
                        key: 1,
                        icon: `${g.icon}-fill`,
                        class: "spr-text-kangkong-700 spr-h-[1.25em] spr-w-[1.25em]"
                      }, null, 8, ["icon"])) : (f(), K(o(W), {
                        key: 2,
                        icon: "ph:globe"
                      }))
                    ], 64))
                  ], 10, Sp)
                ]),
                _: 2
              }, 1024)) : (f(), C(X, { key: 1 }, [
                g.hidden ? _("", !0) : (f(), K(o(Qt), {
                  key: 0,
                  "aria-id": "sidenav-tooltip-wrapper",
                  placement: "right",
                  distance: "18",
                  triggers: ["hover"]
                }, {
                  popper: H(() => [
                    A("span", Yp, G(g.title), 1)
                  ]),
                  default: H(() => [
                    A("div", {
                      id: `${o(c)(g.title)}`,
                      class: x({
                        "spr-flex spr-cursor-pointer spr-items-center spr-justify-center spr-rounded-border-radius-md spr-p-2 spr-transition spr-duration-150 spr-ease-in-out spr-max-w-9 spr-max-h-9 spr-m-auto spr-box-border": !0,
                        "spr-background-color-single-active spr-border-color-brand-base spr-border-[1.5px] spr-border-solid active:spr-scale-90": r.activeNav.parentNav === g.title,
                        "hover:spr-background-color-hover": r.activeNav.parentNav != g.title,
                        "active:spr-background-color-single-active active:spr-scale-90": !0
                      }),
                      onClick: (m) => o(d)(g, g.title, "", "")
                    }, [
                      g.icon && g.icon.includes("https://") ? (f(), C(X, { key: 0 }, [
                        g.icon && r.activeNav.parentNav !== g.title ? (f(), C("img", {
                          key: 0,
                          src: g.icon,
                          alt: `${g.title} icon`,
                          class: "spr-h-[1.25em] spr-w-[1.25em] spr-max-w-[1.25em]"
                        }, null, 8, Fp)) : r.activeNav.parentNav === g.title ? (f(), C("img", {
                          key: 1,
                          src: g.icon.replace(/\.(svg|png|jpg)$/, "-fill.$1"),
                          alt: `${g.title} icon`,
                          class: "spr-h-[1.25em] spr-w-[1.25em] spr-max-w-[1.25em]"
                        }, null, 8, Bp)) : _("", !0)
                      ], 64)) : (f(), C(X, { key: 1 }, [
                        g.icon && r.activeNav.parentNav !== g.title ? (f(), K(o(W), {
                          key: 0,
                          icon: g.icon,
                          class: "spr-h-[1.25em] spr-w-[1.25em]"
                        }, null, 8, ["icon"])) : r.activeNav.parentNav === g.title ? (f(), K(o(W), {
                          key: 1,
                          icon: `${g.icon}-fill`,
                          class: "spr-text-kangkong-700 spr-h-[1.25em] spr-w-[1.25em]"
                        }, null, 8, ["icon"])) : (f(), K(o(W), {
                          key: 2,
                          icon: "ph:globe"
                        }))
                      ], 64))
                    ], 10, Up)
                  ]),
                  _: 2
                }, 1024))
              ], 64))
            ], 64))), 128)),
            o(s).bottom.length > 0 && M < o(s).bottom.length - 1 ? (f(), C("div", Rp)) : _("", !0)
          ], 64))), 128))
        ])) : _("", !0)
      ], 2),
      r.notificationCount || r.requestCount || r.notificationCount === 0 || r.requestCount === 0 ? (f(), C("div", Vp, [
        R(o(Qt), {
          "aria-id": "sidenav-tooltip-wrapper",
          placement: "right",
          distance: "4",
          triggers: ["hover"]
        }, {
          popper: H(() => h[11] || (h[11] = [
            A("span", { class: "spr-label-xs-medium spr-uppercase" }, "NOTIFICATIONS", -1)
          ])),
          default: H(() => [
            r.notificationCount || r.notificationCount === 0 ? (f(), C("div", {
              key: 0,
              id: "sidenav_notification",
              class: x([
                "spr-relative spr-flex spr-cursor-pointer spr-items-center spr-justify-center spr-2 spr-rounded-border-radius-md",
                "spr-transition spr-duration-150 spr-ease-in-out spr-w-9 spr-h-9 spr-m-auto",
                "active:spr-background-color-single-active active:spr-scale-90",
                { "spr-background-color-single-active spr-border-color-brand-base spr-border-[1.5px] spr-border-solid active:spr-scale-90": r.isNotifActive },
                { "hover:spr-background-color-hover": !r.isNotifActive }
              ]),
              onClick: h[4] || (h[4] = (y) => n("notifications", "notifications-triggered"))
            }, [
              r.isNotifActive ? (f(), K(o(W), {
                key: 1,
                icon: "ph:bell-fill",
                class: "spr-text-kangkong-700 spr-h-[1.25em] spr-w-[1.25em]"
              })) : (f(), K(o(W), {
                key: 0,
                icon: "ph:bell",
                class: "spr-h-[1.25em] spr-w-[1.25em]"
              })),
              r.notificationCount !== 0 ? (f(), K(bt, {
                key: 2,
                class: "spr-absolute -spr-top-0.5 spr-right-0.5",
                text: String(r.notificationCount),
                variant: "danger",
                size: "small"
              }, null, 8, ["text"])) : _("", !0)
            ], 2)) : _("", !0)
          ]),
          _: 1
        }),
        R(o(Qt), {
          "aria-id": "sidenav-tooltip-wrapper",
          placement: "right",
          distance: "4",
          triggers: ["hover"]
        }, {
          popper: H(() => h[12] || (h[12] = [
            A("span", { class: "spr-label-xs-medium spr-uppercase" }, "REQUESTS", -1)
          ])),
          default: H(() => [
            r.requestCount || r.requestCount === 0 ? (f(), C("div", {
              key: 0,
              id: "sidenav_request",
              class: x([
                "spr-relative spr-flex spr-cursor-pointer spr-items-center spr-justify-center spr-2 spr-rounded-border-radius-md",
                "spr-transition spr-duration-150 spr-ease-in-out spr-w-9 spr-h-9 spr-m-auto",
                "active:spr-background-color-single-active active:spr-scale-90",
                { "spr-background-color-single-active spr-border-color-brand-base spr-border-[1.5px] spr-border-solid active:spr-scale-90": r.isRequestActive },
                { "hover:spr-background-color-hover": !r.isRequestActive }
              ]),
              onClick: h[5] || (h[5] = (y) => n("requests", "requests-triggered"))
            }, [
              r.isRequestActive ? (f(), K(o(W), {
                key: 1,
                icon: "ph:file-text-fill",
                class: "spr-text-kangkong-700 spr-h-[1.25em] spr-w-[1.25em]"
              })) : (f(), K(o(W), {
                key: 0,
                icon: "ph:file-text",
                class: "spr-h-[1.25em] spr-w-[1.25em]"
              })),
              r.requestCount !== 0 ? (f(), K(bt, {
                key: 2,
                class: "spr-absolute -spr-top-0.5 spr-right-0.5",
                text: String(r.requestCount),
                variant: "danger",
                size: "small"
              }, null, 8, ["text"])) : _("", !0)
            ], 2)) : _("", !0)
          ]),
          _: 1
        })
      ])) : _("", !0),
      r.userMenu ? (f(), C("div", Qp, [
        R(o(we), {
          shown: o(i),
          "onUpdate:shown": h[9] || (h[9] = (y) => fe(i) ? i.value = y : null),
          "aria-id": "user-menu-wrapper",
          distance: "1",
          placement: "right",
          triggers: ["click", "hover"],
          "instant-move": ""
        }, {
          popper: H(() => [
            A("div", Gp, [
              A("div", Wp, [
                A("div", Kp, [
                  r.userMenu.profileImage && !o(l) ? (f(), C("img", {
                    key: 0,
                    src: r.userMenu.profileImage,
                    alt: "profile-image",
                    onError: h[8] || (h[8] = (y) => l.value = !0)
                  }, null, 40, Jp)) : (f(), C("span", Xp, G(o(u)(r.userMenu.name)), 1))
                ]),
                A("div", qp, [
                  A("h3", e8, G(r.userMenu.name), 1),
                  A("p", t8, G(r.userMenu.email), 1)
                ])
              ])
            ]),
            A("div", r8, [
              (f(!0), C(X, null, le(r.userMenu.items, (y, M) => (f(), C(X, { key: M }, [
                y.hidden ? _("", !0) : (f(), C("div", {
                  key: 0,
                  id: `usermenu_${o(c)(y.title)}`,
                  class: x([
                    "spr-flex spr-cursor-pointer spr-gap-2 spr-p-2 spr-align-middle spr-duration-150 spr-ease-in-out",
                    "hover:spr-background-color-hover",
                    "active:spr-background-color-pressed spr-bg-red",
                    "last-of-type:spr-border-t last-of-type:spr-border-solid last-of-type:spr-border-0 last-of-type:spr-border-color-weak"
                  ]),
                  onClick: (g) => o(d)(y, "", "", "")
                }, [
                  y.icon ? (f(), K(o(W), {
                    key: 0,
                    icon: y.icon,
                    class: "spr-h-[1em] spr-w-[1em] spr-text-[20px]"
                  }, null, 8, ["icon"])) : _("", !0),
                  A("h5", s8, G(y.title), 1)
                ], 8, n8))
              ], 64))), 128))
            ])
          ]),
          default: H(() => [
            A("div", {
              id: "sidenav_user_menu",
              class: x([
                "spr-background-color spr-flex spr-h-[36px] spr-w-[36px] spr-cursor-pointer spr-items-center spr-justify-center spr-rounded-full",
                "spr-border-color-weak spr-border spr-border-solid",
                "spr-transition spr-duration-150 spr-ease-in-out",
                "hover:spr-background-color-hover",
                "active:spr-background-color-pressed active:spr-scale-90",
                "[&>img]:spr-h-[36px] [&>img]:spr-w-[36px] [&>img]:spr-rounded-full [&>img]:spr-object-cover"
              ]),
              onClick: h[7] || (h[7] = (y) => i.value = !o(i))
            }, [
              r.userMenu.profileImage && !o(l) ? (f(), C("img", {
                key: 0,
                src: r.userMenu.profileImage,
                alt: "profile-image",
                onError: h[6] || (h[6] = (y) => l.value = !0)
              }, null, 40, Hp)) : (f(), C("span", Zp, G(o(u)(r.userMenu.name)), 1))
            ])
          ]),
          _: 1
        }, 8, ["shown"])
      ])) : _("", !0)
    ]));
  }
}), o8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a8
}, Symbol.toStringTag, { value: "Module" })), i8 = (e, t) => {
  const { size: r, position: n, isStacking: s } = ye(e), a = F(() => {
    const p = L(
      "spr-right-4 spr-top-1/2 spr-z-[1015] spr-flex spr-h-full spr-min-h-[200px] spr-translate-y-[-50%] spr-flex-col spr-rounded-border-radius-xl spr-bg-white-50 spr-drop-shadow",
      {
        "spr-fixed": !s.value,
        "spr-w-[360px] sm:spr-w-[calc(100%-35px)]": r.value === "sm",
        "spr-w-[420px] sm:spr-w-[calc(100%-35px)]": r.value === "md",
        "spr-w-[480px] sm:spr-w-[calc(100%-35px)]": r.value === "lg"
      }
    ), h = L(
      "spr-tw-min-h-12 spr-text-color-strong spr-flex spr-justify-between spr-border-0 spr-border-b spr-border-solid spr-border-mushroom-200 spr-p-4"
    ), y = L("spr-subheading-xs"), M = L("spr-text-color-weak spr-h-5 spr-w-5 spr-cursor-pointer"), g = L("spr-h-full spr-overflow-y-auto"), v = L(
      "spr-bottom-0 spr-left-0 spr-w-full spr-rounded-b-border-radius-xl spr-border-0 spr-border-t spr-border-solid spr-border-mushroom-200 spr-bg-white-50 spr-py-3"
    ), m = L(
      { "spr-transition-all spr-duration-[150ms] spr-ease-[ease-in-out]": !s.value }
    ), I = L("spr-opacity-0", {
      "spr-translate-x-full -spr-translate-y-2/4": !s.value && n.value === "right"
    }), N = L({
      "spr-translate-x-0 -spr-translate-y-2/4": !s.value && n.value === "right"
    }), w = L(
      "spr-fixed spr-left-0 spr-top-0 spr-z-[1010] spr-h-full spr-w-full spr-bg-mushroom-700/60"
    );
    return {
      sidepanelBaseClasses: p,
      sidepanelHeaderClasses: h,
      sidepanelHeaderTitleClasses: y,
      sidepanelHeaderIconClasses: M,
      sidepanelContentClasses: g,
      sidepanelFooterClasses: v,
      sidepanelTransitionActiveClasses: m,
      sidepanelTransitionHiddenClasses: I,
      sidepanelTransitionVisibleClasses: N,
      backdropBaseClasses: w
    };
  }), i = B(null), l = () => {
    t("close");
  };
  let u = !1;
  const d = (p) => {
    u || s.value || i.value && !i.value.contains(p.target) && e.closeOutside && t("close");
  }, c = (p) => {
    p.key === "Escape" && e.isOpen && e.escapeClose && t("close");
  };
  return ce(
    () => e.isOpen,
    (p) => {
      p ? (u = !0, setTimeout(() => {
        u = !1;
      })) : t("onClose");
    }
  ), Be(() => {
    document.addEventListener("click", d), window.addEventListener("keydown", c);
  }), Vn(() => {
    document.removeEventListener("click", d), window.removeEventListener("keydown", c);
  }), {
    sidepanelClasses: a,
    sidepanelRef: i,
    handleClose: l
  };
}, l8 = ["sm", "md", "lg", "xl"], u8 = ["right"], d8 = {
  /**
   * @description Controls whether the side panel is open. 
   * Set to `true` to display the side panel or `false` to hide it.
  */
  isOpen: {
    type: Boolean,
    default: !1
  },
  /**
   * @description The title displayed in the side panel's header.
   * If not provided, defaults to 'Sidepanel Header'.
  */
  headerTitle: {
    type: String,
    default: "Sidepanel Header"
  },
  /**
   * @description Specifies the size of the side panel.
   * Acceptable values are: `'sm'`, `'md'`, `'lg'`, `'xl'`.
   * Defaults to `'sm'`.
  */
  size: {
    type: String,
    validator: (e) => l8.includes(e),
    default: "sm"
  },
  /**
   * @description Sets the height of the side panel.
   * Accepts a string (e.g., `'500px'`, `'70vh'`) or a number (interpreted as pixels).
   * Defaults to `'calc(100vh - 32px)'`.
  */
  height: {
    type: [String, Number],
    default: "calc(100vh - 32px)"
  },
  /**
   * @description Controls the visibility of the side panel header.
   * Set to `true` to hide the header, or `false` to display it.
   * Defaults to `false`.
  */
  hideHeader: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Specifies the position of the side panel.
   * Currently, only `'right'` is supported.
   * Defaults to `'right'`.
  */
  position: {
    type: String,
    validator: (e) => u8.includes(e),
    default: "right"
  },
  /**
   * @description Determines whether a backdrop is displayed behind the side panel.
   * Set to `true` to enable the backdrop, or `false` to disable it.
   * Defaults to `true`.
  */
  hasBackdrop: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Controls whether clicking outside the side panel should close it.
   * Set to `true` to enable closing on outside click, or `false` to disable it.
   * Defaults to `false`.
  */
  closeOutside: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Controls whether clicking ESC button should close it.
   * Set to `true` to enable closing on ESC button click, or `false` to disable it.
   * Defaults to `true`.
  */
  escapeClose: {
    type: Boolean,
    default: !0
  },
  isStacking: {
    type: Boolean,
    default: !1
  }
}, c8 = {
  close: Function,
  onClose: Function
}, p8 = { key: 1 }, f8 = /* @__PURE__ */ ae({
  __name: "sidepanel",
  props: d8,
  emits: c8,
  setup(e, { emit: t }) {
    const r = e, n = t, { sidepanelClasses: s, sidepanelRef: a, handleClose: i } = i8(r, n);
    return (l, u) => (f(), C(X, null, [
      !r.isStacking && l.isOpen && l.hasBackdrop ? (f(), C("div", {
        key: 0,
        class: x(o(s).backdropBaseClasses)
      }, null, 2)) : _("", !0),
      R(mt, {
        "enter-active-class": o(s).sidepanelTransitionActiveClasses,
        "leave-active-class": o(s).sidepanelTransitionActiveClasses,
        "enter-from-class": o(s).sidepanelTransitionHiddenClasses,
        "enter-to-class": o(s).sidepanelTransitionVisibleClasses,
        "leave-from-class": o(s).sidepanelTransitionVisibleClasses,
        "leave-to-class": o(s).sidepanelTransitionHiddenClasses,
        appear: !r.isStacking
      }, {
        default: H(() => [
          r.isOpen || r.isStacking ? (f(), C("div", {
            key: 0,
            ref_key: "sidepanelRef",
            ref: a,
            role: "dialog",
            "aria-labelledby": "sidepanel-title",
            "aria-describedby": "sidepanel-content",
            class: x(o(s).sidepanelBaseClasses),
            style: De({ height: typeof l.height == "number" ? `${l.height}px` : l.height })
          }, [
            r.hideHeader ? _("", !0) : (f(), C(X, { key: 0 }, [
              l.$slots.header ? (f(), C("div", p8, [
                ee(l.$slots, "header")
              ])) : (f(), C("div", {
                key: 0,
                class: x(o(s).sidepanelHeaderClasses)
              }, [
                A("div", {
                  id: "sidepanel-title",
                  class: x(o(s).sidepanelHeaderTitleClasses)
                }, G(l.headerTitle), 3),
                R(o(W), {
                  class: x(o(s).sidepanelHeaderIconClasses),
                  icon: "ph:x",
                  onClick: o(i)
                }, null, 8, ["class", "onClick"])
              ], 2))
            ], 64)),
            A("div", {
              id: "sidepanel-content",
              class: x(o(s).sidepanelContentClasses)
            }, [
              ee(l.$slots, "default")
            ], 2),
            l.$slots.footer ? (f(), C("div", {
              key: 1,
              class: x(o(s).sidepanelFooterClasses)
            }, [
              ee(l.$slots, "footer")
            ], 2)) : _("", !0)
          ], 6)) : _("", !0)
        ]),
        _: 3
      }, 8, ["enter-active-class", "leave-active-class", "enter-from-class", "enter-to-class", "leave-from-class", "leave-to-class", "appear"])
    ], 64));
  }
}), g8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: f8
}, Symbol.toStringTag, { value: "Module" })), h8 = (e, t, r) => {
  const n = Ie(e, "stack", t, { deep: !0 });
  ii(n, (h) => {
    t("update:stack", h);
  });
  const s = (h) => {
    n.value.includes(h) || (n.value.push(h), c());
  }, a = (h) => {
    const y = n.value.indexOf(h);
    y !== -1 && (n.value.splice(y, 1), d(), d(), c());
  }, i = B("transform: translateX()"), l = B(0), { history: u, undo: d } = Ci(l);
  mi(r, (h) => {
    const y = h[0], { width: M } = y.contentRect;
    l.value = l.value !== M ? M : l.value, c();
  });
  const c = () => {
    if (n.value.length <= 1) {
      i.value = "transform: translateX()";
      return;
    }
    i.value = `transform: translateX(${u.value[0].snapshot}px);`;
  };
  ce(
    n,
    () => {
      c();
    },
    { flush: "post" }
  );
  const p = F(() => {
    const h = "spr-fixed spr-left-0 spr-top-0 spr-z-[1010] spr-h-full spr-w-full spr-bg-mushroom-700/60", y = L(
      "spr-fixed spr-right-4 spr-top-1/2 spr-z-[1015] spr-flex spr-flex-row-reverse spr-gap-size-spacing-xs spr-transition-all spr-ease-[ease-in-out] spr-duration-[300ms]"
    ), M = L(
      "spr-transition-all spr-ease-[ease-in-out] spr-duration-[150ms]"
    ), g = L(
      "spr-transition-all spr-ease-[ease-in-out] spr-duration-[150ms]"
    ), v = L("spr-transition-all spr-ease-[ease-in-out] spr-duration-[300ms]"), m = L("spr-opacity-0", {
      "spr-translate-x-1/2": n.value.length <= 1
    }), I = L("spr-opacity-0", {
      "spr-translate-x-1/2": n.value.length <= 0,
      "-spr-translate-x-1/2": n.value.length > 0
    });
    return {
      sidepanelStackBackdropClasses: h,
      sidepanelStackBaseClasses: y,
      sidepanelStackTransitionEnterActiveClasses: M,
      sidepanelStackTransitionLeaveActiveClasses: g,
      sidepanelStackMoveClasses: v,
      sidepanelStackEnterFromClasses: m,
      sidepanelStackLeaveToClasses: I
    };
  });
  return {
    showPanel: s,
    hidePanel: a,
    stackingSidepanelClasses: p,
    stackingSidepanelBaseTransform: i,
    activePanels: n
  };
}, y8 = {
  stack: {
    type: Array,
    default: [],
    required: !0
  }
}, C8 = {
  "update:stack": (e) => e
}, v8 = /* @__PURE__ */ ae({
  __name: "stacking-sidepanel",
  props: y8,
  emits: C8,
  setup(e, { expose: t, emit: r }) {
    const n = Ta("stacking-sidepanel-base"), s = e, a = r, { showPanel: i, hidePanel: l, stackingSidepanelClasses: u, stackingSidepanelBaseTransform: d, activePanels: c } = h8(s, a, n);
    return t({
      showPanel: i,
      hidePanel: l
    }), (p, h) => (f(), C(X, null, [
      o(c).length > 0 ? (f(), C("div", {
        key: 0,
        class: x(o(u).sidepanelStackBackdropClasses)
      }, null, 2)) : _("", !0),
      A("div", {
        ref: "stacking-sidepanel-base",
        class: x([o(u).sidepanelStackBaseClasses]),
        style: De(o(d))
      }, [
        R(Qn, {
          "enter-active-class": o(u).sidepanelStackTransitionEnterActiveClasses,
          "leave-active-class": o(u).sidepanelStackTransitionLeaveActiveClasses,
          "move-class": o(u).sidepanelStackMoveClasses,
          "enter-from-class": o(u).sidepanelStackEnterFromClasses,
          "leave-to-class": o(u).sidepanelStackLeaveToClasses,
          appear: ""
        }, {
          default: H(() => [
            (f(!0), C(X, null, le(o(c), (y) => (f(), C("div", { key: y }, [
              ee(p.$slots, y)
            ]))), 128))
          ]),
          _: 3
        }, 8, ["enter-active-class", "leave-active-class", "move-class", "enter-from-class", "leave-to-class"])
      ], 6)
    ], 64));
  }
}), m8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v8
}, Symbol.toStringTag, { value: "Module" })), M8 = (e, t) => {
  const r = B(null), n = B(!1), s = B(e.modelValue), a = F(() => e.size === "sm" ? "spr-h-1" : "spr-h-2"), i = F(() => e.size === "sm" ? "spr-text-base" : "spr-text-[20px]"), l = F(() => e.max === e.min ? "0%" : `${(Math.min(e.max, Math.max(e.min, s.value)) - e.min) / (e.max - e.min) * 100}%`), u = (M) => {
    const g = Math.min(e.max, Math.max(e.min, M));
    s.value = g, t("update:modelValue", g);
  }, d = (M) => {
    if (!r.value) return;
    const g = r.value.getBoundingClientRect();
    let m = ((M instanceof MouseEvent ? M.clientX : M.touches[0].clientX) - g.left) / g.width;
    m = Math.min(1, Math.max(0, m));
    let I = e.min + m * (e.max - e.min);
    if (e.step > 0) {
      let N = Math.round((I - e.min) / e.step) * e.step + e.min;
      N > e.max && (N = e.max), N < e.min && (N = e.min), N + e.step > e.max && I > N && (N = e.max), I = N;
    }
    u(I);
  }, c = (M) => {
    if (e.disabled) return;
    n.value = !0, d(M);
    const g = (m) => {
      e.disabled || d(m);
    }, v = () => {
      n.value = !1, window.removeEventListener("pointermove", g), window.removeEventListener("pointerup", v);
    };
    window.addEventListener("pointermove", g), window.addEventListener("pointerup", v);
  }, p = (M) => {
    !r.value || e.disabled || (M.key === "ArrowRight" && u(s.value + e.step), M.key === "ArrowLeft" && u(s.value - e.step));
  };
  Be(() => {
    var M, g;
    (M = r.value) == null || M.addEventListener("keydown", p), (g = r.value) == null || g.addEventListener("pointerdown", c);
  }), ce(
    () => e.modelValue,
    (M) => {
      s.value = M;
    }
  );
  const h = F(() => ({
    left: l.value,
    transition: n.value ? "none" : "left 0.15s linear",
    willChange: "left"
  })), y = F(() => ({
    width: l.value,
    transition: n.value ? "none" : "width 0.15s linear",
    willChange: "width"
  }));
  return {
    sliderRef: r,
    handleSliderSize: a,
    handleSliderThumbSize: i,
    startDrag: c,
    thumbPosition: l,
    handleThumbStyle: h,
    handleSliderStyle: y
  };
}, b8 = ["sm", "lg"], N8 = {
  size: {
    type: String,
    validator: (e) => b8.includes(e),
    default: "lg"
  },
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
  step: {
    type: Number,
    default: 1
  },
  modelValue: {
    type: Number,
    default: 0
  },
  disabled: {
    type: Boolean,
    default: !1
  }
}, $8 = ["aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-disabled"], D8 = /* @__PURE__ */ ae({
  __name: "slider",
  props: N8,
  emits: ["update:modelValue", "slideend"],
  setup(e, { emit: t }) {
    const r = e, n = t, { sliderRef: s, handleSliderSize: a, handleSliderThumbSize: i, startDrag: l, handleSliderStyle: u, handleThumbStyle: d } = M8(r, n);
    return (c, p) => (f(), C("div", {
      ref_key: "sliderRef",
      ref: s,
      class: x([
        o(a),
        "spr-relative spr-w-full spr-rounded-lg spr-bg-white-100",
        r.disabled ? "spr-cursor-not-allowed spr-opacity-50" : "spr-cursor-pointer"
      ]),
      role: "slider",
      "aria-valuenow": r.modelValue,
      "aria-valuemin": r.min,
      "aria-valuemax": r.max,
      "aria-disabled": r.disabled,
      tabindex: "0",
      onPointerdown: p[0] || (p[0] = //@ts-ignore
      (...h) => o(l) && o(l)(...h))
    }, [
      A("div", {
        class: x([
          o(a),
          "spr-absolute spr-left-0 spr-top-1/2 spr--translate-y-1/2 spr-rounded-lg spr-bg-kangkong-600",
          { "spr-cursor-not-allowed": r.disabled }
        ]),
        style: De(o(u))
      }, null, 6),
      R(o(W), {
        icon: "ph:circle-fill",
        class: x([
          o(i),
          "spr-absolute spr-top-1/2 spr--translate-x-1/2 spr--translate-y-1/2 spr-transform spr-rounded-full spr-text-kangkong-600 hover:spr-text-kangkong-700 active:spr-border-2 active:spr-border-solid active:spr-text-kangkong-800",
          { "spr-pointer-events-none spr-cursor-not-allowed": r.disabled }
        ]),
        style: De(o(d)),
        onPointerdown: o(l)
      }, null, 8, ["class", "style", "onPointerdown"])
    ], 42, $8));
  }
}), I8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: D8
}, Symbol.toStringTag, { value: "Module" })), A8 = ["success", "information", "danger", "caution"], x8 = {
  /**
   * @description Text label shown in snack
   */
  text: {
    type: String,
    required: !0
  },
  /**
   * @description Snack tone either as 'success', 'information', 'danger', 'caution'
   */
  tone: {
    type: String,
    validator: (e) => A8.includes(e),
    default: "information"
  },
  /**
   * @description To show action label in snack. Default is false
   */
  showAction: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Text label for the action function.
   */
  actionText: {
    type: String,
    default: "action"
  },
  /**
   * @description On click function of the action text.
   */
  action: {
    type: Function,
    default: () => {
    }
  },
  /**
   * @description To show icon in snack. Default is false.
   */
  showIcon: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Duration to show snack. Default is 4000 ms (4s) declared on store
   */
  duration: {
    type: Number
  },
  actionIconProps: {
    type: Object
  }
}, w8 = {
  click: (e) => e instanceof MouseEvent
}, S8 = (e, t) => {
  const r = B(null), { text: n, actionText: s, tone: a, showAction: i, showIcon: l, duration: u, actionIconProps: d } = e, c = F(() => ({
    text: n,
    actionText: s,
    tone: a,
    showAction: i,
    showIcon: l,
    duration: u,
    actionIconProps: d
  })), p = F(() => L({
    "spr-text-kangkong-500": a === "success",
    "spr-text-tomato-500": a === "danger",
    "spr-text-carrot-500": a === "caution",
    "spr-text-blueberry-500": a === "information"
  })), h = F(() => e.tone == "caution" ? "ph:warning-fill" : e.tone == "danger" ? "ph:warning-circle-fill" : e.tone == "success" ? "ph:check-circle-fill" : "ph:info-fill");
  return {
    snackRef: r,
    snackProps: c,
    snackToneCssClass: p,
    snackIcon: h,
    handleClick: (M) => {
      t("click", M);
    }
  };
}, j8 = { class: "spr-flex spr-flex-auto spr-items-center" }, Ln = "24px", T8 = /* @__PURE__ */ ae({
  __name: "snack",
  props: x8,
  emits: w8,
  setup(e, { emit: t }) {
    const r = e, n = t, { snackRef: s, snackProps: a, snackToneCssClass: i, snackIcon: l, handleClick: u } = S8(r, n);
    return (d, c) => (f(), C("div", Ye(o(a), {
      ref_key: "snackRef",
      ref: s,
      class: "snackbar spr-background-color-inverted spr-text-color-inverted-strong spr-font-size-200 spr-line-height-400 spr-border-color-strong spr-box-border spr-flex spr-h-fit spr-flex-row spr-items-center spr-rounded-border-radius-lg spr-border spr-border-solid spr-px-size-spacing-2xs spr-py-size-spacing-3xs",
      onClick: c[1] || (c[1] = //@ts-ignore
      (...p) => o(u) && o(u)(...p))
    }), [
      A("div", j8, [
        ee(d.$slots, "icon", {}, () => [
          d.showIcon ? (f(), K(o(W), {
            key: 0,
            icon: o(l),
            width: Ln,
            height: Ln,
            class: x([o(i), "spr-mr-size-spacing-3xs spr-flex-shrink-0"])
          }, null, 8, ["icon", "class"])) : _("", !0)
        ], !0),
        ee(d.$slots, "label", {}, () => [
          A("label", null, G(d.text), 1)
        ], !0)
      ]),
      d.showAction ? ee(d.$slots, "default", { key: 0 }, () => [
        A("label", {
          class: x([
            o(i),
            "spr-font-size-100 spr-line-height-100 spr-ml-size-spacing-3xs spr-flex spr-items-center spr-font-medium spr-uppercase selection:spr-cursor-pointer"
          ]),
          onClick: c[0] || (c[0] = () => d.action())
        }, [
          d.actionIconProps ? (f(), K(be, {
            key: 0,
            "icon-only": "",
            class: x(["!spr-p-size-spacing-4xs hover:spr-cursor-pointer", { "spr-mr-2": d.actionText !== "" }]),
            size: "small",
            variant: "secondary",
            tone: d.actionIconProps.tone
          }, {
            default: H(() => [
              R(o(W), {
                icon: d.actionIconProps.icon,
                width: "20",
                height: "20"
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["class", "tone"])) : _("", !0),
          Oe(" " + G(d.actionText), 1)
        ], 2)
      ], !0) : _("", !0)
    ], 16));
  }
}), Us = /* @__PURE__ */ gt(T8, [["__scopeId", "data-v-0821f487"]]), O8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Us
}, Symbol.toStringTag, { value: "Module" }));
function C2(e, t, r) {
  return Array.isArray(e) ? (e.length = Math.max(e.length, t), e.splice(t, 1, r), r) : (e[t] = r, r);
}
function h0(e, t) {
  if (Array.isArray(e)) {
    e.splice(t, 1);
    return;
  }
  delete e[t];
}
function _8() {
  return Fs().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function Fs() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const z8 = typeof Proxy == "function", L8 = "devtools-plugin:setup", k8 = "plugin:settings:set";
let St, E0;
function E8() {
  var e;
  return St !== void 0 || (typeof window < "u" && window.performance ? (St = !0, E0 = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (St = !0, E0 = globalThis.perf_hooks.performance) : St = !1), St;
}
function P8() {
  return E8() ? E0.now() : Date.now();
}
class Y8 {
  constructor(t, r) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = r;
    const n = {};
    if (t.settings)
      for (const i in t.settings) {
        const l = t.settings[i];
        n[i] = l.defaultValue;
      }
    const s = `__vue-devtools-plugin-settings__${t.id}`;
    let a = Object.assign({}, n);
    try {
      const i = localStorage.getItem(s), l = JSON.parse(i);
      Object.assign(a, l);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return a;
      },
      setSettings(i) {
        try {
          localStorage.setItem(s, JSON.stringify(i));
        } catch {
        }
        a = i;
      },
      now() {
        return P8();
      }
    }, r && r.on(k8, (i, l) => {
      i === this.plugin.id && this.fallbacks.setSettings(l);
    }), this.proxiedOn = new Proxy({}, {
      get: (i, l) => this.target ? this.target.on[l] : (...u) => {
        this.onQueue.push({
          method: l,
          args: u
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (i, l) => this.target ? this.target[l] : l === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(l) ? (...u) => (this.targetQueue.push({
        method: l,
        args: u,
        resolve: () => {
        }
      }), this.fallbacks[l](...u)) : (...u) => new Promise((d) => {
        this.targetQueue.push({
          method: l,
          args: u,
          resolve: d
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const r of this.onQueue)
      this.target.on[r.method](...r.args);
    for (const r of this.targetQueue)
      r.resolve(await this.target[r.method](...r.args));
  }
}
function Bs(e, t) {
  const r = e, n = Fs(), s = _8(), a = z8 && r.enableEarlyProxy;
  if (s && (n.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !a))
    s.emit(L8, e, t);
  else {
    const i = a ? new Y8(r, s) : null;
    (n.__VUE_DEVTOOLS_PLUGINS__ = n.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: r,
      setupFn: t,
      proxy: i
    }), i && t(i.proxiedTarget);
  }
}
/*!
 * pinia v2.3.1
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */
let Zt;
const u2 = (e) => Zt = e, Rs = process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
function Dt(e) {
  return e && typeof e == "object" && Object.prototype.toString.call(e) === "[object Object]" && typeof e.toJSON != "function";
}
var Ke;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(Ke || (Ke = {}));
const it = typeof window < "u", kn = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof global == "object" && global.global === global ? global : typeof globalThis == "object" ? globalThis : { HTMLElement: null };
function U8(e, { autoBom: t = !1 } = {}) {
  return t && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob(["\uFEFF", e], { type: e.type }) : e;
}
function yr(e, t, r) {
  const n = new XMLHttpRequest();
  n.open("GET", e), n.responseType = "blob", n.onload = function() {
    Hs(n.response, t, r);
  }, n.onerror = function() {
    console.error("could not download file");
  }, n.send();
}
function Vs(e) {
  const t = new XMLHttpRequest();
  t.open("HEAD", e, !1);
  try {
    t.send();
  } catch {
  }
  return t.status >= 200 && t.status <= 299;
}
function S2(e) {
  try {
    e.dispatchEvent(new MouseEvent("click"));
  } catch {
    const r = document.createEvent("MouseEvents");
    r.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(r);
  }
}
const j2 = typeof navigator == "object" ? navigator : { userAgent: "" }, Qs = /Macintosh/.test(j2.userAgent) && /AppleWebKit/.test(j2.userAgent) && !/Safari/.test(j2.userAgent), Hs = it ? (
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
  typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype && !Qs ? F8 : (
    // Use msSaveOrOpenBlob as a second approach
    "msSaveOrOpenBlob" in j2 ? B8 : (
      // Fallback to using FileReader and a popup
      R8
    )
  )
) : () => {
};
function F8(e, t = "download", r) {
  const n = document.createElement("a");
  n.download = t, n.rel = "noopener", typeof e == "string" ? (n.href = e, n.origin !== location.origin ? Vs(n.href) ? yr(e, t, r) : (n.target = "_blank", S2(n)) : S2(n)) : (n.href = URL.createObjectURL(e), setTimeout(function() {
    URL.revokeObjectURL(n.href);
  }, 4e4), setTimeout(function() {
    S2(n);
  }, 0));
}
function B8(e, t = "download", r) {
  if (typeof e == "string")
    if (Vs(e))
      yr(e, t, r);
    else {
      const n = document.createElement("a");
      n.href = e, n.target = "_blank", setTimeout(function() {
        S2(n);
      });
    }
  else
    navigator.msSaveOrOpenBlob(U8(e, r), t);
}
function R8(e, t, r, n) {
  if (n = n || open("", "_blank"), n && (n.document.title = n.document.body.innerText = "downloading..."), typeof e == "string")
    return yr(e, t, r);
  const s = e.type === "application/octet-stream", a = /constructor/i.test(String(kn.HTMLElement)) || "safari" in kn, i = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((i || s && a || Qs) && typeof FileReader < "u") {
    const l = new FileReader();
    l.onloadend = function() {
      let u = l.result;
      if (typeof u != "string")
        throw n = null, new Error("Wrong reader.result type");
      u = i ? u : u.replace(/^data:[^;]*;/, "data:attachment/file;"), n ? n.location.href = u : location.assign(u), n = null;
    }, l.readAsDataURL(e);
  } else {
    const l = URL.createObjectURL(e);
    n ? n.location.assign(l) : location.href = l, n = null, setTimeout(function() {
      URL.revokeObjectURL(l);
    }, 4e4);
  }
}
function Te(e, t) {
  const r = "🍍 " + e;
  typeof __VUE_DEVTOOLS_TOAST__ == "function" ? __VUE_DEVTOOLS_TOAST__(r, t) : t === "error" ? console.error(r) : t === "warn" ? console.warn(r) : console.log(r);
}
function Cr(e) {
  return "_a" in e && "install" in e;
}
function Zs() {
  if (!("clipboard" in navigator))
    return Te("Your browser doesn't support the Clipboard API", "error"), !0;
}
function Gs(e) {
  return e instanceof Error && e.message.toLowerCase().includes("document is not focused") ? (Te('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn"), !0) : !1;
}
async function V8(e) {
  if (!Zs())
    try {
      await navigator.clipboard.writeText(JSON.stringify(e.state.value)), Te("Global state copied to clipboard.");
    } catch (t) {
      if (Gs(t))
        return;
      Te("Failed to serialize the state. Check the console for more details.", "error"), console.error(t);
    }
}
async function Q8(e) {
  if (!Zs())
    try {
      Ws(e, JSON.parse(await navigator.clipboard.readText())), Te("Global state pasted from clipboard.");
    } catch (t) {
      if (Gs(t))
        return;
      Te("Failed to deserialize the state from clipboard. Check the console for more details.", "error"), console.error(t);
    }
}
async function H8(e) {
  try {
    Hs(new Blob([JSON.stringify(e.state.value)], {
      type: "text/plain;charset=utf-8"
    }), "pinia-state.json");
  } catch (t) {
    Te("Failed to export the state as JSON. Check the console for more details.", "error"), console.error(t);
  }
}
let et;
function Z8() {
  et || (et = document.createElement("input"), et.type = "file", et.accept = ".json");
  function e() {
    return new Promise((t, r) => {
      et.onchange = async () => {
        const n = et.files;
        if (!n)
          return t(null);
        const s = n.item(0);
        return t(s ? { text: await s.text(), file: s } : null);
      }, et.oncancel = () => t(null), et.onerror = r, et.click();
    });
  }
  return e;
}
async function G8(e) {
  try {
    const r = await Z8()();
    if (!r)
      return;
    const { text: n, file: s } = r;
    Ws(e, JSON.parse(n)), Te(`Global state imported from "${s.name}".`);
  } catch (t) {
    Te("Failed to import the state from JSON. Check the console for more details.", "error"), console.error(t);
  }
}
function Ws(e, t) {
  for (const r in t) {
    const n = e.state.value[r];
    n ? Object.assign(n, t[r]) : e.state.value[r] = t[r];
  }
}
function Ve(e) {
  return {
    _custom: {
      display: e
    }
  };
}
const Ks = "🍍 Pinia (root)", T2 = "_root";
function W8(e) {
  return Cr(e) ? {
    id: T2,
    label: Ks
  } : {
    id: e.$id,
    label: e.$id
  };
}
function K8(e) {
  if (Cr(e)) {
    const r = Array.from(e._s.keys()), n = e._s;
    return {
      state: r.map((a) => ({
        editable: !0,
        key: a,
        value: e.state.value[a]
      })),
      getters: r.filter((a) => n.get(a)._getters).map((a) => {
        const i = n.get(a);
        return {
          editable: !1,
          key: a,
          value: i._getters.reduce((l, u) => (l[u] = i[u], l), {})
        };
      })
    };
  }
  const t = {
    state: Object.keys(e.$state).map((r) => ({
      editable: !0,
      key: r,
      value: e.$state[r]
    }))
  };
  return e._getters && e._getters.length && (t.getters = e._getters.map((r) => ({
    editable: !1,
    key: r,
    value: e[r]
  }))), e._customProperties.size && (t.customProperties = Array.from(e._customProperties).map((r) => ({
    editable: !0,
    key: r,
    value: e[r]
  }))), t;
}
function J8(e) {
  return e ? Array.isArray(e) ? e.reduce((t, r) => (t.keys.push(r.key), t.operations.push(r.type), t.oldValue[r.key] = r.oldValue, t.newValue[r.key] = r.newValue, t), {
    oldValue: {},
    keys: [],
    operations: [],
    newValue: {}
  }) : {
    operation: Ve(e.type),
    key: Ve(e.key),
    oldValue: e.oldValue,
    newValue: e.newValue
  } : {};
}
function X8(e) {
  switch (e) {
    case Ke.direct:
      return "mutation";
    case Ke.patchFunction:
      return "$patch";
    case Ke.patchObject:
      return "$patch";
    default:
      return "unknown";
  }
}
let Tt = !0;
const O2 = [], Ct = "pinia:mutations", ze = "pinia", { assign: q8 } = Object, R2 = (e) => "🍍 " + e;
function e7(e, t) {
  Bs({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: O2,
    app: e
  }, (r) => {
    typeof r.now != "function" && Te("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html."), r.addTimelineLayer({
      id: Ct,
      label: "Pinia 🍍",
      color: 15064968
    }), r.addInspector({
      id: ze,
      label: "Pinia 🍍",
      icon: "storage",
      treeFilterPlaceholder: "Search stores",
      actions: [
        {
          icon: "content_copy",
          action: () => {
            V8(t);
          },
          tooltip: "Serialize and copy the state"
        },
        {
          icon: "content_paste",
          action: async () => {
            await Q8(t), r.sendInspectorTree(ze), r.sendInspectorState(ze);
          },
          tooltip: "Replace the state with the content of your clipboard"
        },
        {
          icon: "save",
          action: () => {
            H8(t);
          },
          tooltip: "Save the state as a JSON file"
        },
        {
          icon: "folder_open",
          action: async () => {
            await G8(t), r.sendInspectorTree(ze), r.sendInspectorState(ze);
          },
          tooltip: "Import the state from a JSON file"
        }
      ],
      nodeActions: [
        {
          icon: "restore",
          tooltip: 'Reset the state (with "$reset")',
          action: (n) => {
            const s = t._s.get(n);
            s ? typeof s.$reset != "function" ? Te(`Cannot reset "${n}" store because it doesn't have a "$reset" method implemented.`, "warn") : (s.$reset(), Te(`Store "${n}" reset.`)) : Te(`Cannot reset "${n}" store because it wasn't found.`, "warn");
          }
        }
      ]
    }), r.on.inspectComponent((n, s) => {
      const a = n.componentInstance && n.componentInstance.proxy;
      if (a && a._pStores) {
        const i = n.componentInstance.proxy._pStores;
        Object.values(i).forEach((l) => {
          n.instanceData.state.push({
            type: R2(l.$id),
            key: "state",
            editable: !0,
            value: l._isOptionsAPI ? {
              _custom: {
                value: e2(l.$state),
                actions: [
                  {
                    icon: "restore",
                    tooltip: "Reset the state of this store",
                    action: () => l.$reset()
                  }
                ]
              }
            } : (
              // NOTE: workaround to unwrap transferred refs
              Object.keys(l.$state).reduce((u, d) => (u[d] = l.$state[d], u), {})
            )
          }), l._getters && l._getters.length && n.instanceData.state.push({
            type: R2(l.$id),
            key: "getters",
            editable: !1,
            value: l._getters.reduce((u, d) => {
              try {
                u[d] = l[d];
              } catch (c) {
                u[d] = c;
              }
              return u;
            }, {})
          });
        });
      }
    }), r.on.getInspectorTree((n) => {
      if (n.app === e && n.inspectorId === ze) {
        let s = [t];
        s = s.concat(Array.from(t._s.values())), n.rootNodes = (n.filter ? s.filter((a) => "$id" in a ? a.$id.toLowerCase().includes(n.filter.toLowerCase()) : Ks.toLowerCase().includes(n.filter.toLowerCase())) : s).map(W8);
      }
    }), globalThis.$pinia = t, r.on.getInspectorState((n) => {
      if (n.app === e && n.inspectorId === ze) {
        const s = n.nodeId === T2 ? t : t._s.get(n.nodeId);
        if (!s)
          return;
        s && (n.nodeId !== T2 && (globalThis.$store = e2(s)), n.state = K8(s));
      }
    }), r.on.editInspectorState((n, s) => {
      if (n.app === e && n.inspectorId === ze) {
        const a = n.nodeId === T2 ? t : t._s.get(n.nodeId);
        if (!a)
          return Te(`store "${n.nodeId}" not found`, "error");
        const { path: i } = n;
        Cr(a) ? i.unshift("state") : (i.length !== 1 || !a._customProperties.has(i[0]) || i[0] in a.$state) && i.unshift("$state"), Tt = !1, n.set(a, i, n.state.value), Tt = !0;
      }
    }), r.on.editComponentState((n) => {
      if (n.type.startsWith("🍍")) {
        const s = n.type.replace(/^🍍\s*/, ""), a = t._s.get(s);
        if (!a)
          return Te(`store "${s}" not found`, "error");
        const { path: i } = n;
        if (i[0] !== "state")
          return Te(`Invalid path for store "${s}":
${i}
Only state can be modified.`);
        i[0] = "$state", Tt = !1, n.set(a, i, n.state.value), Tt = !0;
      }
    });
  });
}
function t7(e, t) {
  O2.includes(R2(t.$id)) || O2.push(R2(t.$id)), Bs({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: O2,
    app: e,
    settings: {
      logStoreChanges: {
        label: "Notify about new/deleted stores",
        type: "boolean",
        defaultValue: !0
      }
      // useEmojis: {
      //   label: 'Use emojis in messages ⚡️',
      //   type: 'boolean',
      //   defaultValue: true,
      // },
    }
  }, (r) => {
    const n = typeof r.now == "function" ? r.now.bind(r) : Date.now;
    t.$onAction(({ after: i, onError: l, name: u, args: d }) => {
      const c = Js++;
      r.addTimelineEvent({
        layerId: Ct,
        event: {
          time: n(),
          title: "🛫 " + u,
          subtitle: "start",
          data: {
            store: Ve(t.$id),
            action: Ve(u),
            args: d
          },
          groupId: c
        }
      }), i((p) => {
        lt = void 0, r.addTimelineEvent({
          layerId: Ct,
          event: {
            time: n(),
            title: "🛬 " + u,
            subtitle: "end",
            data: {
              store: Ve(t.$id),
              action: Ve(u),
              args: d,
              result: p
            },
            groupId: c
          }
        });
      }), l((p) => {
        lt = void 0, r.addTimelineEvent({
          layerId: Ct,
          event: {
            time: n(),
            logType: "error",
            title: "💥 " + u,
            subtitle: "end",
            data: {
              store: Ve(t.$id),
              action: Ve(u),
              args: d,
              error: p
            },
            groupId: c
          }
        });
      });
    }, !0), t._customProperties.forEach((i) => {
      ce(() => o(t[i]), (l, u) => {
        r.notifyComponentUpdate(), r.sendInspectorState(ze), Tt && r.addTimelineEvent({
          layerId: Ct,
          event: {
            time: n(),
            title: "Change",
            subtitle: i,
            data: {
              newValue: l,
              oldValue: u
            },
            groupId: lt
          }
        });
      }, { deep: !0 });
    }), t.$subscribe(({ events: i, type: l }, u) => {
      if (r.notifyComponentUpdate(), r.sendInspectorState(ze), !Tt)
        return;
      const d = {
        time: n(),
        title: X8(l),
        data: q8({ store: Ve(t.$id) }, J8(i)),
        groupId: lt
      };
      l === Ke.patchFunction ? d.subtitle = "⤵️" : l === Ke.patchObject ? d.subtitle = "🧩" : i && !Array.isArray(i) && (d.subtitle = i.type), i && (d.data["rawEvent(s)"] = {
        _custom: {
          display: "DebuggerEvent",
          type: "object",
          tooltip: "raw DebuggerEvent[]",
          value: i
        }
      }), r.addTimelineEvent({
        layerId: Ct,
        event: d
      });
    }, { detached: !0, flush: "sync" });
    const s = t._hotUpdate;
    t._hotUpdate = ot((i) => {
      s(i), r.addTimelineEvent({
        layerId: Ct,
        event: {
          time: n(),
          title: "🔥 " + t.$id,
          subtitle: "HMR update",
          data: {
            store: Ve(t.$id),
            info: Ve("HMR update")
          }
        }
      }), r.notifyComponentUpdate(), r.sendInspectorTree(ze), r.sendInspectorState(ze);
    });
    const { $dispose: a } = t;
    t.$dispose = () => {
      a(), r.notifyComponentUpdate(), r.sendInspectorTree(ze), r.sendInspectorState(ze), r.getSettings().logStoreChanges && Te(`Disposed "${t.$id}" store 🗑`);
    }, r.notifyComponentUpdate(), r.sendInspectorTree(ze), r.sendInspectorState(ze), r.getSettings().logStoreChanges && Te(`"${t.$id}" store installed 🆕`);
  });
}
let Js = 0, lt;
function En(e, t, r) {
  const n = t.reduce((s, a) => (s[a] = e2(e)[a], s), {});
  for (const s in n)
    e[s] = function() {
      const a = Js, i = r ? new Proxy(e, {
        get(...u) {
          return lt = a, Reflect.get(...u);
        },
        set(...u) {
          return lt = a, Reflect.set(...u);
        }
      }) : e;
      lt = a;
      const l = n[s].apply(i, arguments);
      return lt = void 0, l;
    };
}
function r7({ app: e, store: t, options: r }) {
  if (!t.$id.startsWith("__hot:")) {
    if (t._isOptionsAPI = !!r.state, !t._p._testing) {
      En(t, Object.keys(r.actions), t._isOptionsAPI);
      const n = t._hotUpdate;
      e2(t)._hotUpdate = function(s) {
        n.apply(this, arguments), En(t, Object.keys(s._hmrPayload.actions), !!t._isOptionsAPI);
      };
    }
    t7(
      e,
      // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
      t
    );
  }
}
function n7() {
  const e = Hn(!0), t = e.run(() => B({}));
  let r = [], n = [];
  const s = ot({
    install(a) {
      u2(s), s._a = a, a.provide(Rs, s), a.config.globalProperties.$pinia = s, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && it && e7(a, s), n.forEach((i) => r.push(i)), n = [];
    },
    use(a) {
      return this._a ? r.push(a) : n.push(a), this;
    },
    _p: r,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: e,
    _s: /* @__PURE__ */ new Map(),
    state: t
  });
  return process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && it && typeof Proxy < "u" && s.use(r7), s;
}
function Xs(e, t) {
  for (const r in t) {
    const n = t[r];
    if (!(r in e))
      continue;
    const s = e[r];
    Dt(s) && Dt(n) && !fe(n) && !B0(n) ? e[r] = Xs(s, n) : e[r] = n;
  }
  return e;
}
const qs = () => {
};
function Pn(e, t, r, n = qs) {
  e.push(t);
  const s = () => {
    const a = e.indexOf(t);
    a > -1 && (e.splice(a, 1), n());
  };
  return !r && Bn() && Rn(s), s;
}
function jt(e, ...t) {
  e.slice().forEach((r) => {
    r(...t);
  });
}
const s7 = (e) => e(), Yn = Symbol(), y0 = Symbol();
function P0(e, t) {
  e instanceof Map && t instanceof Map ? t.forEach((r, n) => e.set(n, r)) : e instanceof Set && t instanceof Set && t.forEach(e.add, e);
  for (const r in t) {
    if (!t.hasOwnProperty(r))
      continue;
    const n = t[r], s = e[r];
    Dt(s) && Dt(n) && e.hasOwnProperty(r) && !fe(n) && !B0(n) ? e[r] = P0(s, n) : e[r] = n;
  }
  return e;
}
const a7 = process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function o7(e) {
  return !Dt(e) || !e.hasOwnProperty(a7);
}
const { assign: Ue } = Object;
function Un(e) {
  return !!(fe(e) && e.effect);
}
function Fn(e, t, r, n) {
  const { state: s, actions: a, getters: i } = t, l = r.state.value[e];
  let u;
  function d() {
    !l && (process.env.NODE_ENV === "production" || !n) && (r.state.value[e] = s ? s() : {});
    const c = process.env.NODE_ENV !== "production" && n ? (
      // use ref() to unwrap refs inside state TODO: check if this is still necessary
      ye(B(s ? s() : {}).value)
    ) : ye(r.state.value[e]);
    return Ue(c, a, Object.keys(i || {}).reduce((p, h) => (process.env.NODE_ENV !== "production" && h in c && console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${h}" in store "${e}".`), p[h] = ot(F(() => {
      u2(r);
      const y = r._s.get(e);
      return i[h].call(y, y);
    })), p), {}));
  }
  return u = Y0(e, d, t, r, n, !0), u;
}
function Y0(e, t, r = {}, n, s, a) {
  let i;
  const l = Ue({ actions: {} }, r);
  if (process.env.NODE_ENV !== "production" && !n._e.active)
    throw new Error("Pinia destroyed");
  const u = { deep: !0 };
  process.env.NODE_ENV !== "production" && (u.onTrigger = (b) => {
    d ? y = b : d == !1 && !D._hotUpdating && (Array.isArray(y) ? y.push(b) : console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug."));
  });
  let d, c, p = [], h = [], y;
  const M = n.state.value[e];
  !a && !M && (process.env.NODE_ENV === "production" || !s) && (n.state.value[e] = {});
  const g = B({});
  let v;
  function m(b) {
    let P;
    d = c = !1, process.env.NODE_ENV !== "production" && (y = []), typeof b == "function" ? (b(n.state.value[e]), P = {
      type: Ke.patchFunction,
      storeId: e,
      events: y
    }) : (P0(n.state.value[e], b), P = {
      type: Ke.patchObject,
      payload: b,
      storeId: e,
      events: y
    });
    const V = v = Symbol();
    Je().then(() => {
      v === V && (d = !0);
    }), c = !0, jt(p, P, n.state.value[e]);
  }
  const I = a ? function() {
    const { state: P } = r, V = P ? P() : {};
    this.$patch((Z) => {
      Ue(Z, V);
    });
  } : (
    /* istanbul ignore next */
    process.env.NODE_ENV !== "production" ? () => {
      throw new Error(`🍍: Store "${e}" is built using the setup syntax and does not implement $reset().`);
    } : qs
  );
  function N() {
    i.stop(), p = [], h = [], n._s.delete(e);
  }
  const w = (b, P = "") => {
    if (Yn in b)
      return b[y0] = P, b;
    const V = function() {
      u2(n);
      const Z = Array.from(arguments), j = [], T = [];
      function O(U) {
        j.push(U);
      }
      function S(U) {
        T.push(U);
      }
      jt(h, {
        args: Z,
        name: V[y0],
        store: D,
        after: O,
        onError: S
      });
      let Y;
      try {
        Y = b.apply(this && this.$id === e ? this : D, Z);
      } catch (U) {
        throw jt(T, U), U;
      }
      return Y instanceof Promise ? Y.then((U) => (jt(j, U), U)).catch((U) => (jt(T, U), Promise.reject(U))) : (jt(j, Y), Y);
    };
    return V[Yn] = !0, V[y0] = P, V;
  }, E = /* @__PURE__ */ ot({
    actions: {},
    getters: {},
    state: [],
    hotState: g
  }), $ = {
    _p: n,
    // _s: scope,
    $id: e,
    $onAction: Pn.bind(null, h),
    $patch: m,
    $reset: I,
    $subscribe(b, P = {}) {
      const V = Pn(p, b, P.detached, () => Z()), Z = i.run(() => ce(() => n.state.value[e], (j) => {
        (P.flush === "sync" ? c : d) && b({
          storeId: e,
          type: Ke.direct,
          events: y
        }, j);
      }, Ue({}, u, P)));
      return V;
    },
    $dispose: N
  }, D = qt(process.env.NODE_ENV !== "production" || process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && it ? Ue(
    {
      _hmrPayload: E,
      _customProperties: ot(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    $
    // must be added later
    // setupStore
  ) : $);
  n._s.set(e, D);
  const k = (n._a && n._a.runWithContext || s7)(() => n._e.run(() => (i = Hn()).run(() => t({ action: w }))));
  for (const b in k) {
    const P = k[b];
    if (fe(P) && !Un(P) || B0(P))
      process.env.NODE_ENV !== "production" && s ? C2(g.value, b, v2(k, b)) : a || (M && o7(P) && (fe(P) ? P.value = M[b] : P0(P, M[b])), n.state.value[e][b] = P), process.env.NODE_ENV !== "production" && E.state.push(b);
    else if (typeof P == "function") {
      const V = process.env.NODE_ENV !== "production" && s ? P : w(P, b);
      k[b] = V, process.env.NODE_ENV !== "production" && (E.actions[b] = P), l.actions[b] = P;
    } else process.env.NODE_ENV !== "production" && Un(P) && (E.getters[b] = a ? (
      // @ts-expect-error
      r.getters[b]
    ) : P, it && (k._getters || // @ts-expect-error: same
    (k._getters = ot([]))).push(b));
  }
  if (Ue(D, k), Ue(e2(D), k), Object.defineProperty(D, "$state", {
    get: () => process.env.NODE_ENV !== "production" && s ? g.value : n.state.value[e],
    set: (b) => {
      if (process.env.NODE_ENV !== "production" && s)
        throw new Error("cannot set hotState");
      m((P) => {
        Ue(P, b);
      });
    }
  }), process.env.NODE_ENV !== "production" && (D._hotUpdate = ot((b) => {
    D._hotUpdating = !0, b._hmrPayload.state.forEach((P) => {
      if (P in D.$state) {
        const V = b.$state[P], Z = D.$state[P];
        typeof V == "object" && Dt(V) && Dt(Z) ? Xs(V, Z) : b.$state[P] = Z;
      }
      C2(D, P, v2(b.$state, P));
    }), Object.keys(D.$state).forEach((P) => {
      P in b.$state || h0(D, P);
    }), d = !1, c = !1, n.state.value[e] = v2(b._hmrPayload, "hotState"), c = !0, Je().then(() => {
      d = !0;
    });
    for (const P in b._hmrPayload.actions) {
      const V = b[P];
      C2(D, P, w(V, P));
    }
    for (const P in b._hmrPayload.getters) {
      const V = b._hmrPayload.getters[P], Z = a ? (
        // special handling of options api
        F(() => (u2(n), V.call(D, D)))
      ) : V;
      C2(D, P, Z);
    }
    Object.keys(D._hmrPayload.getters).forEach((P) => {
      P in b._hmrPayload.getters || h0(D, P);
    }), Object.keys(D._hmrPayload.actions).forEach((P) => {
      P in b._hmrPayload.actions || h0(D, P);
    }), D._hmrPayload = b._hmrPayload, D._getters = b._getters, D._hotUpdating = !1;
  })), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && it) {
    const b = {
      writable: !0,
      configurable: !0,
      // avoid warning on devtools trying to display this property
      enumerable: !1
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach((P) => {
      Object.defineProperty(D, P, Ue({ value: D[P] }, b));
    });
  }
  return n._p.forEach((b) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && it) {
      const P = i.run(() => b({
        store: D,
        app: n._a,
        pinia: n,
        options: l
      }));
      Object.keys(P || {}).forEach((V) => D._customProperties.add(V)), Ue(D, P);
    } else
      Ue(D, i.run(() => b({
        store: D,
        app: n._a,
        pinia: n,
        options: l
      })));
  }), process.env.NODE_ENV !== "production" && D.$state && typeof D.$state == "object" && typeof D.$state.constructor == "function" && !D.$state.constructor.toString().includes("[native code]") && console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${D.$id}".`), M && a && r.hydrate && r.hydrate(D.$state, M), d = !0, c = !0, D;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function i7(e, t, r) {
  let n, s;
  const a = typeof t == "function";
  n = e, s = a ? r : t;
  function i(l, u) {
    const d = Oa();
    if (l = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    (process.env.NODE_ENV === "test" && Zt && Zt._testing ? null : l) || (d ? _a(Rs, null) : null), l && u2(l), process.env.NODE_ENV !== "production" && !Zt)
      throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
    l = Zt, l._s.has(n) || (a ? Y0(n, t, s, l) : Fn(n, s, l), process.env.NODE_ENV !== "production" && (i._pinia = l));
    const c = l._s.get(n);
    if (process.env.NODE_ENV !== "production" && u) {
      const p = "__hot:" + n, h = a ? Y0(p, t, s, l, !0) : Fn(p, Ue({}, s), l, !0);
      u._hotUpdate(h), delete l.state.value[p], l._s.delete(p);
    }
    if (process.env.NODE_ENV !== "production" && it) {
      const p = V2();
      if (p && p.proxy && // avoid adding stores that are just built for hot module replacement
      !u) {
        const h = p.proxy, y = "_pStores" in h ? h._pStores : h._pStores = {};
        y[n] = c;
      }
    }
    return c;
  }
  return i.$id = n, i;
}
const l7 = (e) => ({
  ...e,
  id: Math.random() * 1e3
}), ea = /* @__PURE__ */ i7("snackbar-store", () => {
  const e = B([]), t = (s) => {
    e.value = e.value.filter((a) => a.id !== s.id);
  }, r = (s) => {
    const a = l7(s);
    e.value.push({ ...a, defaultAction: () => t(a) }), setTimeout(() => {
      t(a);
    }, s.duration || 4e3);
  };
  return {
    snacks: e,
    updateState: r,
    message: (s) => {
      r({ ...s });
    }
  };
}), u7 = () => {
  const e = ea();
  return {
    showSnackbar: (i) => {
      e.message(i);
    },
    showSuccess: (i) => {
      e.message({ ...i, tone: "success" });
    },
    showInformation: (i) => {
      e.message({ ...i, tone: "information" });
    },
    showDanger: (i) => {
      e.message({ ...i, tone: "danger" });
    },
    showCaution: (i) => {
      e.message({ ...i, tone: "caution" });
    }
  };
}, d7 = {
  key: 0,
  class: "snackbar-wrapper slide-in-element"
}, c7 = /* @__PURE__ */ ae({
  __name: "snackbar",
  setup(e, { expose: t }) {
    const r = n7(), n = ea(r), { showSnackbar: s, showSuccess: a, showInformation: i, showDanger: l, showCaution: u } = u7();
    return t({
      showSnackbar: (d) => s(d),
      showSuccess: (d) => a(d),
      showInformation: (d) => i(d),
      showDanger: (d) => l(d),
      showCaution: (d) => u(d)
    }), (d, c) => (f(), K(za, { to: "body" }, [
      R(mt, { name: "snackbar" }, {
        default: H(() => [
          o(n).snacks.length > 0 ? (f(), C("div", d7, [
            R(Qn, {
              name: "snackbar",
              tag: "ul"
            }, {
              default: H(() => [
                (f(!0), C(X, null, le(o(n).snacks, (p) => (f(), C("li", {
                  key: p.id,
                  class: "snackbar-snack spr-mb-size-spacing-3xs"
                }, [
                  R(Us, {
                    text: p.text,
                    "action-text": p.actionText,
                    tone: p.tone,
                    "show-action": p.showAction,
                    "show-icon": p.showIcon,
                    duration: p.duration,
                    "action-icon-props": p.actionIconProps,
                    action: p.action || p.defaultAction
                  }, {
                    default: H(() => [
                      ee(d.$slots, "default", {}, () => [
                        ee(d.$slots, "snackbarActions", {}, void 0, !0)
                      ], !0)
                    ]),
                    _: 2
                  }, 1032, ["text", "action-text", "tone", "show-action", "show-icon", "duration", "action-icon-props", "action"])
                ]))), 128))
              ]),
              _: 3
            })
          ])) : _("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), p7 = /* @__PURE__ */ gt(c7, [["__scopeId", "data-v-06cc3101"]]), f7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: p7
}, Symbol.toStringTag, { value: "Module" })), g7 = ["horizontal", "vertical"], ta = ["compact", "solid"], h7 = {
  /**
   * @description Variant of the stepper
   */
  variant: {
    type: String,
    validator: (e) => g7.includes(e),
    default: "vertical"
  },
  /**
   * @description steps of the stepper
   * @type {Array<Step>}
   * @property {number} number - Step number
   * @property {string} label - Text label shown in step
   * @property {string} status - Step state either as 'pending', 'active', 'completed'
   * @property {string} description - Description shown in step
   */
  steps: {
    type: Array,
    default: () => []
  },
  /**
   * @description has lines between steps
   */
  hasLines: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Display type of stepper if displayed as compact (no solid bg color) or solid
   */
  type: {
    type: String,
    validator: (e) => ta.includes(e),
    default: "compact"
  }
}, y7 = ["pending", "active", "completed"], C7 = {
  /**
   * @description Step number
   */
  number: {
    type: Number,
    required: !0
  },
  /**
   * @description Text label shown in step
   */
  label: {
    type: String,
    required: !1
  },
  description: {
    type: String,
    required: !1
  },
  /**
   * @description Step state either as 'pending', 'active', 'completed'
   */
  status: {
    type: String,
    validator: (e) => y7.includes(e),
    default: "pending"
  },
  /**
     * @description Display type of stepper if displayed as compact (no solid bg color) or solid
     */
  type: {
    type: String,
    validator: (e) => ta.includes(e)
  }
}, v7 = {
  click: (e) => e instanceof MouseEvent
}, m7 = (e, t) => ({
  stepClasses: F(() => {
    const s = L(
      "spr-flex spr-gap-2 spr-items-top",
      {
        "spr-p-size-spacing-3xs spr-rounded-border-radius-lg": e.type === "solid",
        "spr-background-color-brand-weak": e.status === "active" && e.type === "solid",
        "spr-opacity-60": e.status === "completed" && e.type === "solid"
      }
    ), a = L(
      "spr-flex spr-items-center spr-justify-center spr-rounded-border-radius-full spr-h-6 spr-w-6 spr-border spr-border-solid",
      {
        "spr-border-2": e.type !== "solid",
        "spr-border-1": e.type === "solid",
        "spr-background-color-brand-base spr-border-color-brand-base": e.status === "active",
        "spr-border-mushroom-300": e.status === "pending",
        "spr-border-kangkong-700": e.status === "completed",
        "spr-background-color-brand-base": e.status === "completed" && e.type === "solid"
      }
    ), i = L(
      "spr-body-md-regular-medium",
      {
        "spr-text-white-50": e.status === "active",
        "spr-text-mushroom-600": e.status === "pending",
        "spr-text-kangkong-700": e.status === "completed"
      }
    ), l = L("spr-flex spr-flex-col spr-mt-[2px]"), u = L(
      "spr-body-md-regular spr-whitespace-nowrap",
      {
        "spr-text-kangkong-700 !spr-body-md-regular-medium": e.status === "active" && e.type === "compact",
        "spr-text-mushroom-600": e.status === "pending",
        "spr-text-mushroom-950": e.status === "completed"
      }
    ), d = L(
      "spr-body-sm-regular spr-text-color-supporting spr-whitespace-nowrap"
    );
    return {
      baseClass: s,
      badgeClass: a,
      numberClass: i,
      labelClass: u,
      textContainerClass: l,
      descriptionClass: d
    };
  }),
  handleClick: (s) => {
    t("click", s);
  }
}), ra = /* @__PURE__ */ ae({
  __name: "step",
  props: C7,
  emits: v7,
  setup(e, { emit: t }) {
    const r = e, n = t, { stepClasses: s } = m7(r, n);
    return (a, i) => (f(), C("div", {
      class: x(o(s).baseClass)
    }, [
      A("div", {
        class: x(o(s).badgeClass)
      }, [
        r.status === "completed" && r.type === "solid" ? (f(), K(o(W), {
          key: 0,
          icon: "ph:check-bold",
          width: "14px",
          height: "14px",
          class: "spr-text-color-inverted-strong"
        })) : (f(), C("span", {
          key: 1,
          class: x(o(s).numberClass)
        }, G(r.number), 3))
      ], 2),
      A("div", {
        class: x(o(s).textContainerClass)
      }, [
        r.label ? (f(), C("span", {
          key: 0,
          class: x(o(s).labelClass)
        }, G(r.label), 3)) : _("", !0),
        r.description ? (f(), C("span", {
          key: 1,
          class: x(o(s).descriptionClass)
        }, G(r.description), 3)) : _("", !0)
      ], 2)
    ], 2));
  }
}), M7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ra
}, Symbol.toStringTag, { value: "Module" })), b7 = (e) => ({
  stepperClasses: F(() => {
    const n = L("spr-flex spr-gap-size-spacing-xs ", {
      "spr-flex-col spr-mb-size-spacing-xs": e.variant === "vertical",
      "spr-flex-row spr-mr-size-spacing-xs": e.variant === "horizontal"
    }), s = L("spr-flex spr-flex-grow", {
      "spr-flex-col": e.variant === "vertical",
      "spr-flex-rows": e.variant === "horizontal"
    }), a = L("spr-flex spr-min-w-6 spr-min-h-6", {
      "spr-ml-3.5 spr-pt-size-spacing-2xs": e.variant === "vertical",
      "spr-items-center spr-pl-size-spacing-xs spr-w-full": e.variant === "horizontal"
    }), i = L({
      "spr-w-0.5 spr-rounded-full spr-h-12": e.variant === "vertical",
      "spr-h-0.5 spr-rounded-full spr-w-full": e.variant === "horizontal"
    });
    return {
      baseClass: n,
      stepClass: s,
      lineContainerClass: a,
      linesClass: i
    };
  }),
  getLineColorClass: (n) => n.status === "completed" ? "spr-bg-kangkong-700" : "spr-bg-mushroom-200"
}), N7 = /* @__PURE__ */ ae({
  __name: "stepper",
  props: h7,
  setup(e) {
    const t = e, { stepperClasses: r, getLineColorClass: n } = b7(t);
    return (s, a) => (f(), C("div", {
      class: x(o(r).baseClass)
    }, [
      (f(!0), C(X, null, le(t.steps, (i, l) => (f(), C("div", {
        key: l,
        class: x(o(r).stepClass)
      }, [
        R(ra, {
          number: i.number,
          label: i.label,
          status: i.status,
          description: i.description,
          type: t.type
        }, null, 8, ["number", "label", "status", "description", "type"]),
        t.hasLines && l < t.steps.length - 1 ? (f(), C("div", {
          key: 0,
          class: x(o(r).lineContainerClass)
        }, [
          A("div", {
            class: x([o(r).linesClass, o(n)(i)])
          }, null, 2)
        ], 2)) : _("", !0)
      ], 2))), 128))
    ], 2));
  }
}), $7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: N7
}, Symbol.toStringTag, { value: "Module" })), D7 = ["default", "hover", "pressed", "disabled"], I7 = {
  /**
   * @description Switch UI state when hovered, pressed, disabled
   */
  state: {
    type: String,
    validator: (e) => D7.includes(e),
    default: "default"
  },
  /**
   * @description Switch input state when disabled
   */
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Required prop value for v-model
   */
  modelValue: {
    type: Boolean,
    required: !0,
    default: !1
  },
  /**
   * @description Switch id
   */
  id: {
    type: String,
    default: ""
  }
}, A7 = ["update:modelValue"], x7 = (e) => {
  const t = B(null), r = B(null), n = K0(t), { pressed: s } = ds({ target: r }), { disabled: a, state: i, modelValue: l } = ye(e), u = It(), d = (!u.default || u.default().length === 0) && !u.leftText, c = !u.rightText, p = F(() => ({
    ...a.value && { ariaDisabled: !0 },
    disabled: a.value,
    autofocus: i.value === "hover",
    modelValue: l
  })), h = F(() => e.disabled ? v() : s.value ? g() : n.value ? M() : y());
  function y() {
    return e.modelValue ? "spr-background-color-success-base" : "spr-switch-background-default";
  }
  function M() {
    return e.modelValue ? "spr-background-color-success-hover" : "spr-switch-background-hover";
  }
  function g() {
    return e.modelValue ? "spr-background-color-success-pressed" : "spr-switch-background-pressed";
  }
  function v() {
    return L(
      {
        "spr-background-color-success-base": e.modelValue,
        "spr-switch-background-default": !e.modelValue
      },
      "spr-opacity-60"
    );
  }
  const m = F(() => e.disabled ? "spr-text-color-disabled" : "spr-text-color-strong"), I = F(() => L(
    "spr-transition-colors",
    "before:spr-transition-all before:spr-duration-150",
    "after:spr-transition-all after:spr-duration-150"
  )), N = F(() => L(h.value, I.value)), w = F(() => L({
    "spr-cursor-not-allowed": e.disabled,
    "spr-cursor-pointer": !e.disabled
  }));
  return {
    switchWrapperRef: t,
    switchRef: r,
    switchProps: p,
    switchMarkClass: N,
    switchTextClass: m,
    switchInputClass: w,
    isLeftTextLabel: d,
    isRightTextLabel: c
  };
}, w7 = ["for"], S7 = ["id", "disabled"], j7 = ["for"], T7 = /* @__PURE__ */ ae({
  __name: "switch",
  props: I7,
  emits: A7,
  setup(e, { emit: t }) {
    const r = e, n = t, s = r.id ? r.id + "_" + Math.random().toString(36).substring(2, 8) : "switch_input_" + Math.random().toString(36).substring(2, 8), a = Ie(r, "modelValue", n), {
      switchWrapperRef: i,
      switchRef: l,
      switchProps: u,
      switchMarkClass: d,
      switchTextClass: c,
      switchInputClass: p,
      isLeftTextLabel: h,
      isRightTextLabel: y
    } = x7(r);
    return (M, g) => (f(), C("div", Ye(o(u), {
      class: ["spr-flex spr-items-center spr-gap-2", o(c)]
    }), [
      o(h) ? _("", !0) : (f(), C("label", {
        key: 0,
        for: o(s),
        class: "spr-cursor-pointer"
      }, [
        ee(M.$slots, "leftText", {}, () => [
          ee(M.$slots, "default", {}, void 0, !0)
        ], !0)
      ], 8, w7)),
      A("div", {
        ref_key: "switchWrapperRef",
        ref: i,
        class: x({
          "spr-relative spr-flex spr-items-center": !0,
          "spr-cursor-pointer spr-transition spr-duration-300 spr-ease-in-out active:spr-scale-90": !r.disabled
        })
      }, [
        rt(A("input", {
          id: o(s),
          ref_key: "switchRef",
          ref: l,
          "onUpdate:modelValue": g[0] || (g[0] = (v) => fe(a) ? a.value = v : null),
          type: "checkbox",
          name: "checkbox",
          class: x([
            "input spr-absolute spr-left-0 spr-top-0 spr-z-10 spr-m-0 spr-h-6 spr-w-12 spr-opacity-0",
            o(p)
          ]),
          disabled: r.disabled
        }, null, 10, S7), [
          [La, o(a)]
        ]),
        A("span", {
          class: x([
            "switch-mark spr-relative spr-box-border spr-inline-block spr-h-6 spr-w-12 spr-rounded-[40px] spr-p-1",
            o(d)
          ])
        }, null, 2)
      ], 2),
      o(y) ? _("", !0) : (f(), C("label", {
        key: 1,
        for: o(s),
        class: "spr-cursor-pointer"
      }, [
        ee(M.$slots, "rightText", {}, void 0, !0)
      ], 8, j7))
    ], 16));
  }
}), O7 = /* @__PURE__ */ gt(T7, [["__scopeId", "data-v-57bd4d3a"]]), _7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: O7
}, Symbol.toStringTag, { value: "Module" })), z7 = (e) => ({
  tableActionsBaseClasses: "spr-h-max spr-p-size-spacing-2xs spr-flex spr-justify-between",
  inputSearchClasses: "spr-w-full",
  searchFilterClasses: "spr-size-[30%] spr-flex spr-gap-size-spacing-2xs",
  updateSearchField: (a) => {
    e("update:searchModel", a);
  }
}), L7 = {
  /**
   * @description Toggle Search field,
   */
  toggleSearch: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Toggle Option button
   */
  toggleOption: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Toggle Filter Button
   */
  toggleFilter: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Search variable
   */
  searchModel: {
    type: String,
    default: ""
  }
}, k7 = {
  "update:searchModel": (e) => typeof e == "string"
}, na = /* @__PURE__ */ ae({
  __name: "table-actions",
  props: L7,
  emits: k7,
  setup(e, { emit: t }) {
    const r = t, n = e, {
      tableActionsBaseClasses: s,
      inputSearchClasses: a,
      searchFilterClasses: i,
      updateSearchField: l
    } = z7(r);
    return (u, d) => (f(), C("div", {
      class: x(o(s))
    }, [
      ee(u.$slots, "tableActionSection", {}, () => [
        A("div", {
          class: x(o(i))
        }, [
          n.toggleSearch ? (f(), K(nr, {
            key: 0,
            "model-value": n.searchModel,
            class: x(o(a)),
            placeholder: "Search",
            "onUpdate:modelValue": o(l)
          }, null, 8, ["model-value", "class", "onUpdate:modelValue"])) : _("", !0),
          n.toggleFilter ? (f(), K(be, {
            key: 1,
            variant: "secondary",
            "has-icon": ""
          }, {
            default: H(() => [
              R(o(W), { icon: "ph:sliders-horizontal" })
            ]),
            _: 1
          })) : _("", !0)
        ], 2),
        n.toggleOption ? (f(), K(be, { key: 0 }, {
          default: H(() => [
            R(o(W), { icon: "ph:dots-three-vertical" })
          ]),
          _: 1
        })) : _("", !0)
      ])
    ], 2));
  }
}), E7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: na
}, Symbol.toStringTag, { value: "Module" })), P7 = (e) => e, Y7 = {
  /**
   * @description Cell Content,
   */
  cell: {
    type: P7(Object),
    required: !0
  }
}, U7 = (e) => {
  const t = F(() => {
    var u;
    return ((u = e.cell) == null ? void 0 : u.icon) || "";
  }), r = F(() => {
    var u;
    return ((u = e.cell) == null ? void 0 : u.iconWeight) || "regular";
  }), n = F(() => {
    var u;
    return ((u = e.cell) == null ? void 0 : u.badge) || !1;
  }), s = F(() => {
    var u;
    return ((u = e.cell) == null ? void 0 : u.badgeText) || "";
  }), a = F(() => {
    var u;
    return ((u = e.cell) == null ? void 0 : u.badgeVariant) || "primary";
  }), i = F(() => {
    var u;
    return (u = e.cell) == null ? void 0 : u.avatarUrl;
  }), l = F(() => {
    var u;
    return ((u = e.cell) == null ? void 0 : u.avatarVariant) || "image";
  });
  return {
    computeIcon: t,
    computeIconWeight: r,
    computeBadge: n,
    computeBadgeText: s,
    computeBadgeVariant: a,
    computeAvatarUrl: i,
    computeAvatarVariant: l
  };
}, U0 = /* @__PURE__ */ ae({
  __name: "table-chips-title",
  props: Y7,
  setup(e) {
    const t = e, {
      computeIcon: r,
      computeIconWeight: n,
      computeBadge: s,
      computeBadgeText: a,
      computeBadgeVariant: i,
      computeAvatarUrl: l,
      computeAvatarVariant: u
    } = U7(t);
    return (d, c) => {
      var p;
      return f(), K(_t, {
        label: (p = t.cell) == null ? void 0 : p.title,
        icon: o(r),
        "icon-weight": o(n),
        badge: o(s),
        "badge-text": o(a),
        "badge-variant": o(i),
        "avatar-url": o(l),
        "avatar-variant": o(u)
      }, null, 8, ["label", "icon", "icon-weight", "badge", "badge-text", "badge-variant", "avatar-url", "avatar-variant"]);
    };
  }
}), F7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U0
}, Symbol.toStringTag, { value: "Module" })), B7 = (e) => e, R7 = {
  /**
   * @description Cell Content,
   */
  cell: {
    type: B7(Object),
    required: !0
  }
}, V7 = (e) => {
  const t = F(() => {
    var n;
    return ((n = e.cell) == null ? void 0 : n.tone) || "plain";
  }), r = F(() => {
    var n;
    return ((n = e.cell) == null ? void 0 : n.fill) || !1;
  });
  return {
    computeTone: t,
    computeFill: r
  };
}, F0 = /* @__PURE__ */ ae({
  __name: "table-lozenge-title",
  props: R7,
  setup(e) {
    const t = e, { computeTone: r, computeFill: n } = V7(t);
    return (s, a) => {
      var i, l, u;
      return f(), K(P2, {
        label: (i = t.cell) == null ? void 0 : i.title,
        tone: o(r),
        url: (l = t.cell) == null ? void 0 : l.avatarUrl,
        fill: o(n)
      }, Pt({ _: 2 }, [
        (u = t.cell) != null && u.icon ? {
          name: "icon",
          fn: H(() => {
            var d;
            return [
              R(o(W), {
                icon: (d = t.cell) == null ? void 0 : d.icon
              }, null, 8, ["icon"])
            ];
          }),
          key: "0"
        } : void 0
      ]), 1032, ["label", "tone", "url", "fill"]);
    };
  }
}), Q7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F0
}, Symbol.toStringTag, { value: "Module" })), H7 = {
  /**
   * @description Toggle Search field,
   */
  selectedRowCount: {
    required: !0,
    type: Number,
    default: 10
  },
  /**
   * @description Toggle Option button
   */
  totalItems: {
    required: !0,
    type: Number,
    default: 1
  },
  /**
   * @description Toggle Option button
   */
  currentPage: {
    required: !0,
    type: Number,
    default: 1
  },
  /**
   * @description Menu items
   */
  dropdownSelection: {
    type: Array,
    required: !0,
    default: [
      { text: 10, value: 10 },
      { text: 20, value: 20 },
      { text: 50, value: 50 },
      { text: 100, value: 100 }
    ]
  },
  /**
   * @description Toggle Search field,
   */
  bordered: {
    type: Boolean,
    default: !0
  }
}, Z7 = {
  "update:selectedRowCount": (e) => typeof e == "number",
  previous: () => !0,
  next: () => !0
}, G7 = (e, t) => {
  const { selectedRowCount: r, currentPage: n, totalItems: s, bordered: a } = ye(e), i = F(() => {
    const m = L("spr-p-size-spacing-xs spr-flex spr-justify-between spr-bg-white-50 spr-h-max", {
      "spr-border spr-border-solid spr-border-color-weak": a.value,
      "spr-border-x-0 spr-border-t spr-border-b-0 spr-border-solid spr-border-color-weak": !a.value
    }), I = L("spr-w-[120px] spr-h-full spr-space-x-2"), N = L("spr-mt-0.5 spr-pl-1 spr-text-mushroom-950"), w = L("spr-flex spr-justify-between spr-items-center spr-space-x-4"), E = L("spr-text-color-base spr-body-sm-regular"), $ = L("spr-flex spr-space-x-2"), D = L("spr-rounded-border-radius-md"), z = L("!spr-w-max");
    return {
      baseClass: m,
      dropdownInputFieldClass: I,
      rightSideClass: w,
      computeRowRangeClass: E,
      inputFieldIconClass: N,
      navigationContainerClass: $,
      navigationButtonClass: D,
      dropdownClass: z
    };
  }), l = B(e.dropdownSelection), u = F(() => {
    const m = (n.value - 1) * r.value + 1, I = Math.min(n.value * r.value, s.value);
    return `${m} - ${I} of ${s.value}`;
  }), d = F(() => `${r.value} Rows`), c = (m) => {
    t("update:selectedRowCount", Number(m));
  }, p = () => {
    t("previous");
  }, h = () => {
    t("next");
  }, y = F(() => e.currentPage === 1), M = F(() => e.totalItems <= e.currentPage * e.selectedRowCount), v = B(`dropdown-${(() => {
    const m = Date.now(), I = Math.floor(Math.random() * 1e6);
    return `dropdown-${m}-${I}`;
  })()}`);
  return {
    paginationClasses: i,
    handleSelectedItem: c,
    computeRowRange: u,
    computeSelectedRowCount: d,
    next: h,
    previous: p,
    disabledNext: y,
    disabledPrevious: M,
    dropdownSelection: l,
    dropdownId: v
  };
}, W7 = /* @__PURE__ */ ae({
  __name: "table-pagination",
  props: H7,
  emits: Z7,
  setup(e, { emit: t }) {
    const r = t, n = e, {
      paginationClasses: s,
      handleSelectedItem: a,
      computeRowRange: i,
      computeSelectedRowCount: l,
      next: u,
      previous: d,
      disabledNext: c,
      disabledPrevious: p,
      dropdownSelection: h,
      dropdownId: y
    } = G7(n, r);
    return (M, g) => (f(), C("div", {
      class: x(o(s).baseClass)
    }, [
      R(e0, {
        id: o(y),
        "menu-list": o(h),
        "dropdown-type": "single-select",
        placement: "bottom",
        class: x(o(s).dropdownClass),
        "onUpdate:modelValue": o(a)
      }, {
        default: H(() => [
          R(Ee, {
            modelValue: o(l),
            "onUpdate:modelValue": g[0] || (g[0] = (v) => fe(l) ? l.value = v : null),
            class: x(o(s).dropdownInputFieldClass),
            readonly: !0
          }, {
            icon: H(() => [
              R(o(W), {
                icon: "ph:caret-down-bold",
                class: x(o(s).inputFieldIconClass)
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["modelValue", "class"])
        ]),
        _: 1
      }, 8, ["id", "menu-list", "class", "onUpdate:modelValue"]),
      A("div", {
        class: x(o(s).rightSideClass)
      }, [
        A("div", {
          class: x(o(s).computeRowRangeClass)
        }, G(o(i)), 3),
        A("div", {
          class: x(o(s).navigationContainerClass)
        }, [
          R(be, {
            id: "previousButton",
            "has-icon": "",
            class: x(o(s).navigationButtonClass),
            disabled: o(c),
            onClick: o(d)
          }, {
            default: H(() => [
              R(o(W), { icon: "ph:caret-left" })
            ]),
            _: 1
          }, 8, ["class", "disabled", "onClick"]),
          R(be, {
            id: "nextButton",
            "has-icon": "",
            class: x(o(s).navigationButtonClass),
            disabled: o(p),
            onClick: o(u)
          }, {
            default: H(() => [
              R(o(W), { icon: "ph:caret-right" })
            ]),
            _: 1
          }, 8, ["class", "disabled", "onClick"])
        ], 2)
      ], 2)
    ], 2));
  }
}), K7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W7
}, Symbol.toStringTag, { value: "Module" })), sa = ["asc", "desc"], J7 = ["surface", "white"], X7 = {
  /**
   * @description Action Column,
   */
  action: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Table Values
   */
  dataTable: {
    type: Array,
    default: !1
  },
  /**
   * @description Table Headers
   */
  headers: {
    type: Array,
    required: !0,
    default: () => []
  },
  emptyState: {
    type: Object,
    default: () => ({
      description: "No results found",
      subDescription: "Try a different search term",
      image: "location",
      size: "large"
    })
  },
  emptyStateCustomClasses: {
    type: String,
    default: ""
  },
  tableActionSlotCustomClasses: {
    type: String,
    default: ""
  },
  loading: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Table Actions
   */
  tableActions: {
    type: Object,
    default: () => ({
      search: !1,
      filter: !1,
      option: !1
    })
  },
  /**
   * @description Search variable
   *
   */
  searchModel: {
    type: String,
    default: ""
  },
  sortOrder: {
    type: String,
    validator: (e) => sa.includes(e),
    default: "asc"
  },
  variant: {
    type: String,
    validator: (e) => J7.includes(e),
    default: "surface"
  },
  isRowClickable: {
    type: Boolean,
    default: !1
  },
  fullHeight: {
    type: Boolean,
    default: !0
  },
  removeHeaderOnEmpty: {
    type: Boolean,
    default: !1
  },
  isMultiSelect: {
    type: Boolean,
    default: !1
  },
  selectedKeyId: {
    type: String,
    default: ""
  },
  returnCompleteSelectedProperties: {
    type: Boolean,
    default: !1
  }
}, q7 = {
  "update:searchModel": (e) => typeof e == "string",
  onSort: (e) => typeof e.field == "string" && sa.includes(e.sortOrder),
  onRowClick: (e, t) => typeof e == "object" && typeof t == "number",
  onHover: (e) => typeof e.active == "boolean" && typeof e.data == "object",
  "update:selectedData": (e) => Array.isArray(e) && e.every(
    (t) => (typeof t == "object" || typeof t == "string" || typeof t == "number") && t !== null
  )
}, ef = (e, t, r) => {
  const { dataTable: n, action: s, headers: a, sortOrder: i, fullHeight: l, selectedKeyId: u, returnCompleteSelectedProperties: d } = ye(e), c = B(""), p = B(e.searchModel), h = B(i.value), y = B(!1), M = B([]), g = F(() => M.value.length === 0 ? !1 : M.value.length === m.value.length), v = F(() => M.value.length === 0 ? !1 : M.value.length > 0 && M.value.length < m.value.length), m = F(() => !c.value || i != null && i.value ? n.value : [...n.value].sort((Y, U) => {
    const J = k(Y[c.value]), oe = k(U[c.value]);
    return J < oe ? h.value === "asc" ? -1 : 1 : J > oe ? h.value === "asc" ? 1 : -1 : 0;
  })), I = (S) => {
    c.value === S ? h.value = h.value === "asc" ? "desc" : "asc" : (c.value = S, h.value = "asc"), t("onSort", { field: S, sortOrder: h.value });
  }, N = (S) => c.value !== S ? "ph:caret-up-down-light" : h.value === "asc" ? "ph:arrow-up" : "ph:arrow-down", w = F(() => s.value ? a.value.length + 1 : a.value.length), E = (S) => {
    t("update:searchModel", S);
  }, $ = F(
    () => e.tableActions.search || e.tableActions.filter || e.tableActions.option
  ), D = (S, Y) => {
    e.isRowClickable && t("onRowClick", S, Y);
  }, z = F(() => l.value ? "large" : "small"), k = (S) => typeof S == "string" ? S.toLowerCase() : typeof S == "object" && !Array.isArray(S) && S !== null ? S.title.toLowerCase() : Array.isArray(S) && S.length > 0 ? S[0].title.toLowerCase() : "", b = F(() => {
    const S = L(
      "spr-flex spr-flex-col spr-h-full spr-border-color-weak spr-w-full spr-overflow-hidden spr-rounded-border-radius-lg spr-border spr-border-solid spr-table-wrapper spr-relative"
    ), Y = L("spr-w-full spr-bottom-0 spr-left-0", {
      "spr-background-color-surface": e.variant === "surface",
      "spr-background-color": e.variant === "white"
    }), U = L({
      "spr-background-color": e.variant === "white",
      "spr-background-color-surface": e.variant === "surface"
    }), J = L(
      "spr-min-h-12 spr-px-size-spacing-2xs spr-py-size-spacing-3xs",
      "spr-text-color-strong spr-font-size-100 spr-font-line-height-100 spr-font-letter-spacing-normal spr-text-start spr-font-medium spr-uppercase",
      "spr-border-color-weak spr-border-x-0 spr-border-y spr-border-solid",
      {
        "spr-border-t-0": !r.default
      },
      U
    ), oe = "spr-flex spr-flex-row spr-items-center spr-gap-size-spacing-5xs", de = L({
      "spr-px-size-spacing-sm spr-py-size-spacing-xs": !!r.default
    }), Me = "spr-border-color-weak spr-w-full spr-border spr-border-solid", se = "spr-background-color-surface spr-text-color-strong spr-font-size-100 spr-font-line-height-100 spr-font-letter-spacing-normal spr-uppercase", ie = L("spr-min-h-[60px]", {
      "spr-cursor-pointer": e.isRowClickable
    }), Ce = "spr-border-color-weak spr-overflow-hidden spr-border-x-0 spr-border-b spr-border-t-0 spr-border-solid spr-p-3", ge = "spr-border-color-weak spr-overflow-hidden spr-border-x-0 spr-border-b spr-border-t-0 spr-border-solid spr-p-3", ve = L("spr-h-full"), Ne = L({
      "spr-overflow-y-auto spr-h-full": l.value,
      "spr-h-[250px]": !l.value && r.footer,
      "spr-h-[360px]": !l.value && !r.footer
    }), me = L({
      "spr-overflow-y-hidden spr-h-[calc(90vh-150px)] md:spr-h-[calc(80vh-150px)] sm:spr-h-[calc(70vh-150px)]": l.value && r.footer,
      // Adjust tbody height for header/footer
      "spr-overflow-y-auto spr-h-[75vh]": l.value && !r.footer,
      // Adjust tbody height for header/footer
      "spr-h-[250px]": !l.value && r.footer,
      "spr-h-[360px]": !l.value && !r.footer
    }), Se = L(
      "spr-border-color-weak spr-border-x-0 spr-border-b spr-border-t-0 spr-border-solid"
    ), ne = L("spr-px-size-spacing-2xs spr-py-size-spacing-3xs spr-w-[44px] "), te = L(`${me} ${e.emptyStateCustomClasses}`), Re = L(`${de} ${e.tableActionSlotCustomClasses}`);
    return {
      headerClasses: J,
      tableWrapperClasses: S,
      defaultSlotClasses: de,
      tableHeaderActionsClasses: Me,
      headerNameClass: oe,
      tableCellSlotClasses: se,
      multiselectRowClass: Se,
      multiselectClass: ne,
      tableRowClasses: ie,
      tableDataClasses: Ce,
      tableRowActionClasses: ge,
      tableBackgroundClasses: ve,
      tableBodyClasses: Ne,
      tableFooterClasses: Y,
      emptyStateClasses: te,
      tableActionSlotClasses: Re
    };
  }), P = (S, Y) => m.value[S][Y], V = (S) => typeof S == "object" && "title" in S, Z = (S) => {
    if (!u.value || !(u.value in S)) return;
    const Y = M.value.findIndex((U) => {
      const J = U[u.value], oe = S[u.value];
      return V(J) && V(oe) ? J.title === oe.title : U[u.value] === S[u.value];
    });
    Y !== -1 ? M.value.splice(Y, 1) : M.value.push(S), O();
  }, j = () => {
    g.value || v.value ? M.value = [] : M.value = [...m.value], O();
  }, T = (S) => !u.value || !(u.value in S) ? !1 : M.value.some((Y) => {
    const U = Y[u.value], J = S[u.value];
    return V(U) && V(J) ? U.title === J.title : Y[u.value] === S[u.value];
  }), O = () => {
    if (d.value)
      t("update:selectedData", M.value);
    else {
      const S = M.value.map((Y) => {
        const U = Y[u.value];
        return typeof U == "object" ? { ...U } : U;
      });
      t("update:selectedData", S);
    }
  };
  return ce(m, (S) => {
    S && e.isMultiSelect && M.value.length > 0 && S.forEach((Y) => {
      const U = M.value.findIndex((J) => {
        const oe = J[u.value], de = Y[u.value];
        return V(oe) && V(de) ? oe.title === de.title : J[u.value] === Y[u.value];
      });
      U === -1 && M.value.splice(U, 1);
    });
  }), {
    sortData: I,
    updateSearchField: E,
    handleRowClick: D,
    handleSelect: Z,
    handleSelectAll: j,
    sortedData: m,
    getHeaderCount: w,
    hasTableActions: $,
    searchField: p,
    getTableClasses: b,
    getEmptyStateSize: z,
    selectAll: y,
    selectedData: M,
    isAllSelected: g,
    isRowSelected: T,
    isIndeterminate: v,
    sortedDataItem: P,
    getSortIcon: N,
    sortField: c
  };
}, tf = {
  "aria-describedby": "describe",
  class: "spr-h-full spr-w-full spr-table-fixed",
  cellspacing: "0",
  cellpadding: "0"
}, rf = { key: 0 }, nf = { class: "spr-flex spr-items-center spr-justify-center" }, sf = ["onClick"], af = { key: 0 }, of = ["onClick"], lf = ["onClick", "onMouseover", "onMouseleave"], uf = { class: "spr-flex spr-items-center spr-justify-center" }, df = {
  key: 0,
  class: "spr-flex spr-flex-row spr-items-center spr-gap-2"
}, cf = {
  key: 1,
  class: "spr-flex spr-items-center spr-rounded-full spr-bg-mushroom-200 spr-p-1"
}, pf = {
  key: 0,
  class: "spr-flex spr-flex-wrap spr-gap-2"
}, ff = {
  key: 0,
  class: "spr-mt-1"
}, gf = {
  key: 1,
  class: "spr-mt-1"
}, hf = { key: 1 }, yf = {
  key: 0,
  class: "spr-mt-1"
}, Cf = {
  key: 1,
  class: "spr-mt-1"
}, vf = {
  key: 2,
  class: "spr-text-color-strong spr-font-size-200 spr-font-normal"
}, mf = {
  key: 2,
  class: "spr-text-color-base spr-text-xs spr-font-normal"
}, Mf = { class: "spr-flex spr-items-center" }, bf = {
  key: 0,
  class: "spr-h-full"
}, Nf = ["colspan"], $f = { key: 1 }, Df = ["colspan"], If = /* @__PURE__ */ ae({
  __name: "table",
  props: X7,
  emits: q7,
  setup(e, { emit: t }) {
    const r = e, n = t, s = It(), {
      sortedData: a,
      getHeaderCount: i,
      hasTableActions: l,
      searchField: u,
      getTableClasses: d,
      getEmptyStateSize: c,
      isAllSelected: p,
      isIndeterminate: h,
      sortField: y,
      isRowSelected: M,
      sortData: g,
      updateSearchField: v,
      handleRowClick: m,
      handleSelect: I,
      handleSelectAll: N,
      sortedDataItem: w,
      getSortIcon: E
    } = ef(r, n, s);
    return ($, D) => (f(), C("div", {
      class: x(o(d).tableWrapperClasses)
    }, [
      $.$slots.default ? (f(), C("div", {
        key: 0,
        class: x(o(d).tableActionSlotClasses)
      }, [
        ee($.$slots, "default")
      ], 2)) : _("", !0),
      o(l) ? (f(), C("div", {
        key: 1,
        class: x(o(d).tableHeaderActionsClasses)
      }, [
        R(na, {
          "search-model": o(u),
          "onUpdate:searchModel": [
            D[0] || (D[0] = (z) => fe(u) ? u.value = z : null),
            o(v)
          ],
          "toggle-search": r.tableActions.search,
          "toggle-option": r.tableActions.option,
          "toggle-filter": r.tableActions.filter
        }, {
          tableActionSection: H(() => [
            ee($.$slots, "tableActionSection")
          ]),
          _: 3
        }, 8, ["search-model", "toggle-search", "toggle-option", "toggle-filter", "onUpdate:searchModel"])
      ], 2)) : _("", !0),
      A("div", {
        class: x(o(d).tableBackgroundClasses)
      }, [
        A("table", tf, [
          A("thead", null, [
            r.removeHeaderOnEmpty && o(a).length <= 0 ? _("", !0) : (f(), C("tr", rf, [
              r.isMultiSelect ? (f(), C("th", {
                key: 0,
                class: x([o(d).multiselectClass, o(d).headerClasses])
              }, [
                A("div", nf, [
                  R($t, {
                    label: "",
                    checked: o(p) || o(h),
                    indeterminate: o(h),
                    "onUpdate:modelValue": o(N)
                  }, null, 8, ["checked", "indeterminate", "onUpdate:modelValue"])
                ])
              ], 2)) : _("", !0),
              (f(!0), C(X, null, le($.headers, (z, k) => (f(), C("th", {
                key: k,
                class: x([o(d).headerClasses])
              }, [
                A("div", {
                  class: x(o(d).headerNameClass)
                }, [
                  A("span", {
                    class: x([{ "spr-cursor-pointer": z.sort }]),
                    onClick: (b) => z.sort && o(g)(z.field)
                  }, G(z.name), 11, sf),
                  z.badgeText ? (f(), C("span", af, [
                    R(bt, {
                      text: z.badgeText,
                      variant: z.badgeVariant,
                      size: "small"
                    }, null, 8, ["text", "variant"])
                  ])) : _("", !0),
                  z.sort ? (f(), C("span", {
                    key: 1,
                    class: x([
                      "spr-flex spr-flex-row spr-items-center spr-p-size-spacing-6xs",
                      "hover:spr-rounded-border-radius-xs hover:spr-bg-mushroom-300",
                      { "spr-cursor-pointer": z.sort }
                    ]),
                    onClick: (b) => z.sort && o(g)(z.field)
                  }, [
                    R(o(W), {
                      icon: o(E)(z.field),
                      height: "16",
                      width: "16",
                      class: x([{ "spr-text-kangkong-700": o(y) === z.field }])
                    }, null, 8, ["icon", "class"])
                  ], 10, of)) : _("", !0)
                ], 2)
              ], 2))), 128)),
              $.action ? (f(), C("th", {
                key: 1,
                class: x(o(d).headerClasses)
              }, [
                ee($.$slots, "action-name", {
                  class: x(o(d).tableCellSlotClasses)
                })
              ], 2)) : _("", !0)
            ]))
          ]),
          o(a).length > 0 && !$.loading ? (f(), C("tbody", {
            key: 0,
            class: x(o(d).tableBodyClasses)
          }, [
            (f(!0), C(X, null, le(o(a), (z, k) => (f(), C("tr", {
              key: k,
              class: x([
                o(d).tableRowClasses,
                o(M)(z) ? "spr-bg-kangkong-100" : "hover:spr-background-color-hover"
              ]),
              onClick: (b) => o(m)(z, k),
              onMouseover: (b) => $.$emit("onHover", { active: !0, data: z }),
              onMouseleave: (b) => $.$emit("onHover", { active: !1, data: z })
            }, [
              r.isMultiSelect ? (f(), C("td", {
                key: 0,
                class: x([o(d).multiselectClass, o(d).multiselectRowClass])
              }, [
                A("div", uf, [
                  R($t, {
                    label: "",
                    checked: o(M)(z),
                    "onUpdate:modelValue": (b) => o(I)(z)
                  }, null, 8, ["checked", "onUpdate:modelValue"])
                ])
              ], 2)) : _("", !0),
              (f(!0), C(X, null, le($.headers, (b, P) => (f(), C("td", {
                key: P,
                class: x(o(d).tableDataClasses)
              }, [
                $.$slots[b.field] ? ee($.$slots, b.field, {
                  key: 0,
                  row: z,
                  rowIndex: k
                }) : (f(), C(X, { key: 1 }, [
                  o(a)[k][b.field] ? (f(), C("div", df, [
                    b.hasAvatar ? (f(), K(Et, {
                      key: 0,
                      size: "lg",
                      src: o(w)(k, b.field).image,
                      alt: "User Avatar",
                      variant: b.avatarVariant ? b.avatarVariant : "initial",
                      initial: o(w)(k, b.field).title
                    }, null, 8, ["src", "variant", "initial"])) : _("", !0),
                    b.hasIcon ? (f(), C("div", cf, [
                      R(o(W), {
                        icon: o(w)(k, b.field).icon || ""
                      }, null, 8, ["icon"])
                    ])) : _("", !0),
                    A("div", null, [
                      Array.isArray(o(w)(k, b.field).title) ? (f(), C("div", pf, [
                        (f(!0), C(X, null, le(o(w)(k, b.field).title, (V, Z) => (f(), C("div", { key: Z }, [
                          b.hasLozengeTitle ? (f(), C("div", ff, [
                            R(F0, {
                              cell: V
                            }, null, 8, ["cell"])
                          ])) : b.hasChipTitle ? (f(), C("div", gf, [
                            R(U0, {
                              cell: V
                            }, null, 8, ["cell"])
                          ])) : _("", !0)
                        ]))), 128))
                      ])) : (f(), C("div", hf, [
                        b.hasLozengeTitle ? (f(), C("div", yf, [
                          R(F0, {
                            cell: o(w)(k, b.field).title
                          }, null, 8, ["cell"])
                        ])) : b.hasChipTitle ? (f(), C("div", Cf, [
                          R(U0, {
                            cell: o(w)(k, b.field).title
                          }, null, 8, ["cell"])
                        ])) : (f(), C("div", vf, G(o(w)(k, b.field).title), 1))
                      ])),
                      b.hasSubtext ? (f(), C("div", mf, G(o(w)(k, b.field).subtext), 1)) : _("", !0)
                    ])
                  ])) : _("", !0)
                ], 64))
              ], 2))), 128)),
              $.action ? (f(), C("td", {
                key: 1,
                class: x(o(d).tableRowActionClasses)
              }, [
                A("div", Mf, [
                  ee($.$slots, "action", { row: z })
                ])
              ], 2)) : _("", !0)
            ], 42, lf))), 128))
          ], 2)) : (f(), C("tbody", {
            key: 1,
            class: x(o(d).emptyStateClasses)
          }, [
            $.loading ? (f(), C("tr", $f, [
              A("td", {
                colspan: o(i),
                class: "spr-overflow-hidden"
              }, [
                ee($.$slots, "loading", {}, () => [
                  D[1] || (D[1] = A("div", { class: "spr-flex spr-items-center spr-justify-center" }, "Loading...", -1))
                ])
              ], 8, Df)
            ])) : (f(), C("tr", bf, [
              A("td", {
                colspan: o(i),
                class: "spr-flex spr-h-full spr-items-center spr-justify-center"
              }, [
                ee($.$slots, "empty-state", {}, () => [
                  R(ar, { size: o(c) }, null, 8, ["size"])
                ])
              ], 8, Nf)
            ]))
          ], 2))
        ])
      ], 2),
      $.$slots.footer ? (f(), C("div", {
        key: 2,
        class: x(o(d).tableFooterClasses)
      }, [
        ee($.$slots, "footer")
      ], 2)) : _("", !0)
    ], 2));
  }
}), Af = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: If
}, Symbol.toStringTag, { value: "Module" })), xf = {
  /**
   * @description Tabs List,
   * option list: label, icon, iconFill, disabled
   */
  list: {
    type: Array,
    default: () => []
  },
  /**
   * @description Tabs Type (underlined, not underlined)
   */
  underlined: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Active Tab
   */
  activeTab: {
    type: String,
    default: ""
  }
}, wf = {
  tabIndex: (e) => typeof e == "number"
}, Sf = (e, t) => {
  const r = F(() => L({
    "spr-relative spr-px-size-spacing-xs spr-body-sm spr-text-color-strong spr-group": !0,
    "spr-transition-left spr-duration-150 spr-ease-in-out": !0,
    "capitalize spr-py-size-spacing-3xs": !e.underlined,
    "spr-uppercase spr-border-x-0 spr-border-t-0 spr-py-size-spacing-xs": e.underlined
  })), n = B({
    index: 0,
    previousIndex: -1,
    width: 0,
    undelineLeftOffset: 0
  }), s = () => {
    if (e.activeTab) {
      const l = e.list.filter(
        (u) => u.label.toString().trim() === e.activeTab.toString().trim()
      );
      if (l.length > 0) {
        const u = e.list.indexOf(l[0]);
        n.value.index = u;
      }
    } else
      n.value.index = 0;
    n.value.width = a.value[n.value.index].clientWidth, t("tabIndex", n.value.index);
  }, a = B([]), i = (l, u = !1) => {
    if (u) return;
    const d = n.value.index;
    if (d === l) return;
    n.value.previousIndex = d, n.value.index = l, n.value.width = a.value[l].clientWidth;
    const c = a.value[d].offsetLeft, h = a.value[l].offsetLeft - c;
    n.value.undelineLeftOffset += h, t("tabIndex", l);
  };
  return Be(() => {
    s();
  }), {
    tabsClasses: r,
    activeTab: n,
    tabElements: a,
    updateSelectedTabIndex: i
  };
}, jf = { class: "spr-relative spr-flex" }, Tf = ["onClick"], Of = { key: 0 }, _f = { key: 1 }, zf = /* @__PURE__ */ ae({
  __name: "tabs",
  props: xf,
  emits: wf,
  setup(e, { emit: t }) {
    const r = t, n = e, { tabsClasses: s, activeTab: a, tabElements: i, updateSelectedTabIndex: l } = Sf(n, r);
    return (u, d) => (f(), C("div", jf, [
      (f(!0), C(X, null, le(u.list, (c, p) => (f(), C("div", {
        key: p,
        ref_for: !0,
        ref_key: "tabElements",
        ref: i,
        class: x([
          o(s),
          {
            // Regular Tab
            "spr-rounded-l-md": !u.underlined && p === 0,
            "spr-rounded-r-md": !u.underlined && p === o(i).length - 1,
            // Regular Tab - Active
            "spr-border-color-success-base spr-cursor-pointer !spr-border !spr-border-solid": !u.underlined && o(a).index === p,
            // Regular Tab - Inactive
            "spr-border-color-weak hover:spr-background-color-hover spr-cursor-pointer !spr-border-x-[0.5px] !spr-border-y !spr-border-solid": !u.underlined && o(a).index !== p,
            // Regular Tab - Disabled
            "spr-background-color-disabled !spr-cursor-not-allowed !spr-text-color-on-fill-disabled": !u.underlined && c.disabled,
            // Underlined Tab - Active
            "spr-cursor-pointer": u.underlined && o(a).index === p,
            // Underlined Tab - Inactive
            "spr-border-color-base spr-cursor-pointer !spr-border-b !spr-border-solid": u.underlined && o(a).index !== p,
            "hover:spr-background-color-hover spr-cursor-pointer": u.underlined && o(a).index !== p && !c.disabled,
            // Underlined Tab - Disabled
            "spr-border-color-disabled spr-text-color-on-fill-disabled !spr-cursor-not-allowed spr-border-b": u.underlined && c.disabled
          }
        ]),
        onClick: (h) => o(l)(p, c.disabled)
      }, [
        !u.underlined && o(a).index === p ? (f(), C("div", {
          key: 0,
          class: x([
            "spr-background-color-single-active spr-tw-w-full spr-absolute spr-bottom-0 spr-left-0 spr-z-[5] spr-block spr-h-full spr-w-full",
            {
              "spr-rounded-l-md": o(a).index === 0,
              "spr-rounded-r-md": o(a).index === o(i).length - 1
            }
          ])
        }, null, 2)) : _("", !0),
        A("div", {
          class: x({
            "spr-relative spr-z-[10] spr-flex spr-items-center spr-gap-size-spacing-5xs spr-leading-none": !0,
            "spr-cursor-not-allowed": c.disabled
          })
        }, [
          c.icon ? (f(), C("div", Of, [
            R(o(W), {
              class: x({
                "spr-body-sm-regular": !0,
                "spr-text-color-brand-base": o(a).index === p
              }),
              icon: o(a).index === p && typeof c.iconFill == "string" ? c.iconFill : c.icon
            }, null, 8, ["class", "icon"])
          ])) : _("", !0),
          c.label ? (f(), C("div", _f, G(c.label), 1)) : _("", !0)
        ], 2)
      ], 10, Tf))), 128)),
      u.underlined ? (f(), C("div", {
        key: 0,
        class: x([
          "spr-background-color-success-base spr-absolute spr-bottom-0 spr-left-0 spr-z-10 spr-block spr-h-0.5 spr-rounded-full",
          "spr-transition-left spr-duration-150 spr-ease-in-out"
        ]),
        style: De({
          width: `${o(a).width}px`,
          left: `${o(a).undelineLeftOffset}px`
        })
      }, null, 4)) : _("", !0)
    ]));
  }
}), Lf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zf
}, Symbol.toStringTag, { value: "Module" })), kf = {
  id: {
    type: String,
    default: ""
  },
  modelValue: {
    type: String,
    default: ""
  },
  label: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: ""
  },
  active: {
    type: Boolean,
    default: !1
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  error: {
    type: Boolean,
    default: !1
  },
  minLength: {
    type: Number
  },
  maxLength: {
    type: Number
  },
  rows: {
    type: Number,
    default: 4
  },
  displayHelper: {
    type: Boolean,
    default: !1
  },
  helperIcon: {
    type: String,
    default: null
  },
  helperText: {
    type: String,
    default: ""
  },
  hasCounter: {
    type: Boolean,
    default: !1
  }
}, Ef = {
  "update:modelValue": (e) => typeof e == "string"
}, Pf = (e, t) => {
  const { error: r, disabled: n, readonly: s } = ye(e), a = Ie(e, "modelValue", t);
  return {
    textareaClasses: F(() => {
      const u = L("spr-flex spr-flex-col spr-gap-size-spacing-4xs"), d = L("spr-body-sm-regular spr-text-color-strong spr-block", {
        "spr-text-color-on-fill-disabled": n.value,
        "spr-text-color-base": s.value
      }), c = L(
        "spr-block spr-w-full spr-px-size-spacing-2xs spr-py-size-spacing-4xs spr-rounded-border-radius-md spr-outline-none spr-ring-0 spr-resize-none spr-font-main",
        "spr-text-color-strong spr-font-size-200",
        "spr-border spr-border-solid",
        "placeholder:spr-text-mushroom-300",
        {
          "spr-border-mushroom-200 focus:spr-border-kangkong-700": !r.value && !n.value,
          "spr-border-tomato-600 focus:spr-border-tomato-600": r.value,
          "spr-background-color-disabled spr-border-white-100 focus:spr-border-white-100 spr-cursor-not-allowed spr-text-color-on-fill-disabled": n.value,
          "spr-background-color-disabled spr-border-white-100 focus:spr-border-white-100 spr-cursor-not-allowed   spr-text-color-base": s.value
        }
      ), p = L("spr-body-sm-regular spr-flex spr-items-center spr-gap-size-spacing-5xs", {
        "spr-text-color-danger-base": r.value,
        "spr-text-color-supporting": !r.value
      }), h = L("spr-flex spr-items-center", {
        "spr-justify-between": e.displayHelper && e.hasCounter,
        "spr-justify-end": !e.displayHelper && e.hasCounter
      });
      return { wrapperClasses: u, labelClasses: d, textAreaClasses: c, helperClasses: p, slotWrapperClasses: h };
    }),
    onInput: (u) => {
      a.value = u.target.value;
    }
  };
}, Yf = ["for"], Uf = ["id", "rows", "placeholder", "value", "minlength", "maxlength", "readonly", "disabled"], Ff = /* @__PURE__ */ ae({
  __name: "textarea",
  props: kf,
  emits: Ef,
  setup(e, { emit: t }) {
    const r = e, n = t, { onInput: s, textareaClasses: a } = Pf(r, n);
    return (i, l) => (f(), C("div", {
      class: x(o(a).wrapperClasses)
    }, [
      i.label ? (f(), C("label", {
        key: 0,
        for: i.id,
        class: x(o(a).labelClasses)
      }, G(i.label), 11, Yf)) : _("", !0),
      A("textarea", Ye(i.$attrs, {
        id: r.id,
        class: o(a).textAreaClasses,
        rows: i.rows,
        placeholder: i.placeholder,
        value: i.modelValue,
        minlength: r.minLength,
        maxlength: r.maxLength,
        readonly: i.readonly,
        disabled: r.disabled,
        onInput: l[0] || (l[0] = //@ts-ignore
        (...u) => o(s) && o(s)(...u))
      }), null, 16, Uf),
      A("div", {
        class: x(o(a).slotWrapperClasses)
      }, [
        r.displayHelper ? (f(), C("div", {
          key: 0,
          class: x(o(a).helperClasses)
        }, [
          ee(i.$slots, "helperMessage", {}, () => [
            r.helperIcon ? (f(), K(o(W), {
              key: 0,
              icon: r.helperIcon,
              width: "20px",
              height: "20px"
            }, null, 8, ["icon"])) : _("", !0),
            A("span", null, G(r.helperText), 1)
          ])
        ], 2)) : _("", !0),
        r.hasCounter && r.maxLength ? (f(), C("div", {
          key: 1,
          class: x(o(a).helperClasses)
        }, [
          ee(i.$slots, "counter", {}, () => [
            A("span", null, G(`${i.modelValue.length}/${r.maxLength}`), 1)
          ])
        ], 2)) : _("", !0)
      ], 2)
    ], 2));
  }
}), Bf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ff
}, Symbol.toStringTag, { value: "Module" })), Rf = {
  modelValue: {
    type: String,
    required: !0
  },
  label: {
    type: String,
    default: ""
  },
  error: {
    type: Boolean,
    default: !1
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Interval in minutes
   */
  interval: {
    type: Number,
    default: 30
  },
  /**
   * @description '24' for 24-hour format, '12' for 12-hour format
   */
  format: {
    type: String,
    default: "24"
  },
  /**
   * @description disable user to type
   */
  disableTyping: {
    type: Boolean,
    default: !1
  },
  /**
   * @description disable user to type
   */
  fullWidth: {
    type: Boolean,
    default: !1
  },
  helperText: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: ""
  },
  id: {
    type: String,
    default: "time-picker"
  }
}, Vf = {
  "update:modelValue": (e) => e instanceof MouseEvent
}, Qf = (e, t) => {
  const { format: r, interval: n, fullWidth: s } = ye(e), a = B(!1), i = Ie(e, "modelValue", t), l = B(`time-picker-${ue().valueOf()}-${Math.floor(Math.random() * 1e3)}`), u = F(() => L("spr-max-h-[300px] spr-p-size-spacing-3xs spr-overflow-y-auto", {
    "spr-w-[240px]": !s.value
  })), d = (v) => {
    var w;
    const m = v.target;
    if (!m) return;
    const I = m.value.toUpperCase();
    (r.value === "12" ? /^[0-9:APM\s]*$/ : /^[0-9:]*$/).test(I) ? i.value = I : i.value = (w = i.value) == null ? void 0 : w.slice(0, -1);
  }, c = () => {
    const v = [], m = ue().startOf("day"), I = ue().endOf("day");
    let N = m;
    for (; N.isBefore(I) || N.isSame(I); )
      v.push(p(N)), N = N.add(n.value, "minute");
    return v;
  }, p = (v) => {
    let m = v.hour();
    const I = v.minute().toString().padStart(2, "0");
    if (e.format === "12") {
      const N = m >= 12 ? "PM" : "AM";
      return m = m % 12 || 12, `${m.toString().padStart(2, "0")}:${I} ${N}`;
    }
    return `${m.toString().padStart(2, "0")}:${I}`;
  }, h = F(() => c()), y = F(() => h.value), M = (v) => {
    i.value = v;
  }, g = F(() => e.placeholder ? e.placeholder : r.value === "12" ? "HH : MM AM/PM" : "HH : MM");
  return {
    optionClasses: u,
    filteredOptions: y,
    selectedValue: i,
    isOpen: a,
    getPlaceHolder: g,
    uniqueId: l,
    filterInput: d,
    selectOption: M
  };
}, Hf = ["id"], Zf = { key: 0 }, Gf = ["onMousedown"], Wf = {
  key: 0,
  class: "spr-text-color-brand-base spr-font-bold"
}, Kf = {
  key: 1,
  class: "spr-px-3 spr-py-2 spr-text-gray-500"
}, Jf = /* @__PURE__ */ ae({
  __name: "time-picker",
  props: Rf,
  emits: Vf,
  setup(e, { emit: t }) {
    const r = e, n = t, { optionClasses: s, isOpen: a, filteredOptions: i, selectedValue: l, getPlaceHolder: u, selectOption: d, filterInput: c, uniqueId: p } = Qf(r, n);
    return (h, y) => (f(), K(o(we), {
      shown: o(a),
      "onUpdate:shown": y[1] || (y[1] = (M) => fe(a) ? a.value = M : null),
      "aria-id": r.fullWidth ? "time-picker-wrapper-full-width" : "time-picker-wrapper",
      distance: "4",
      placement: "bottom-start",
      triggers: ["click"],
      "popper-hide-triggers": [],
      container: `#${o(p)}`,
      style: {
        width: "100%"
      },
      "instant-move": ""
    }, {
      popper: H(() => [
        A("div", {
          class: x(o(s))
        }, [
          o(i).length > 0 ? (f(), C("div", Zf, [
            (f(!0), C(X, null, le(o(i), (M) => {
              var g, v;
              return f(), C("div", {
                key: M,
                class: x([
                  "spr-body-xs-regular spr-flex spr-cursor-pointer spr-justify-between spr-rounded-border-radius-md spr-p-size-spacing-3xs",
                  "hover:spr-background-color-hover",
                  {
                    "spr-background-color-single-active spr-rounded-border-radius-md": M.toUpperCase() === ((g = o(l)) == null ? void 0 : g.toUpperCase())
                  }
                ]),
                onMousedown: Mt((m) => o(d)(M), ["prevent"])
              }, [
                Oe(G(M) + " ", 1),
                M.toUpperCase() === ((v = o(l)) == null ? void 0 : v.toUpperCase()) ? (f(), C("span", Wf, [
                  R(o(W), { icon: "ph:check" })
                ])) : _("", !0)
              ], 42, Gf);
            }), 128))
          ])) : (f(), C("div", Kf, "No matching options found"))
        ], 2)
      ]),
      default: H(() => [
        A("div", {
          id: o(p),
          style: {
            width: "100%"
          }
        }, [
          R(Ee, {
            id: r.id,
            modelValue: o(l),
            "onUpdate:modelValue": y[0] || (y[0] = (M) => fe(l) ? l.value = M : null),
            type: "text",
            placeholder: o(u),
            readonly: r.disableTyping,
            disabled: r.disabled,
            label: r.label,
            error: r.error,
            "display-helper": !!r.helperText,
            "helper-text": r.helperText,
            onInput: o(c)
          }, {
            icon: H(() => [
              R(o(W), { icon: "ph:clock" })
            ]),
            _: 1
          }, 8, ["id", "modelValue", "placeholder", "readonly", "disabled", "label", "error", "display-helper", "helper-text", "onInput"])
        ], 8, Hf)
      ]),
      _: 1
    }, 8, ["shown", "aria-id", "container"]));
  }
}), Xf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jf
}, Symbol.toStringTag, { value: "Module" })), qf = [
  "top",
  "top-start",
  "top-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "left",
  "left-start",
  "left-end",
  "right",
  "right-start",
  "right-end"
], eg = {
  /**
   * @description Tooltip Label
   */
  text: {
    type: String,
    default: ""
  },
  /**
   * @description Tooltip Placement
   */
  placement: {
    type: String,
    validator: (e) => qf.includes(e),
    default: "top"
  },
  hasMaxWidth: {
    type: Boolean,
    default: !0
  },
  fitContent: {
    type: Boolean,
    default: !0
  }
}, tg = (e) => ({
  placement: B(e.placement)
}), rg = { key: 0 }, ng = /* @__PURE__ */ ae({
  __name: "tooltip",
  props: eg,
  setup(e) {
    const t = e, r = It(), { placement: n } = tg(t);
    return (s, a) => t.text || o(r)["popper-content"] ? (f(), K(o(Qt), {
      key: 0,
      class: x([t.fitContent ? "spr-w-fit" : "spr-w-full"]),
      "aria-id": t.hasMaxWidth ? "tooltip-full-width-wrapper" : "tooltip-wrapper",
      placement: o(n)
    }, {
      popper: H(() => [
        t.text ? (f(), C("span", rg, G(t.text), 1)) : _("", !0),
        ee(s.$slots, "popper-content")
      ]),
      default: H(() => [
        ee(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "aria-id", "placement"])) : ee(s.$slots, "default", { key: 1 });
  }
}), sg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ng
}, Symbol.toStringTag, { value: "Module" })), ag = "design-system-next", og = "2.11.11", ig = "./dist/design-system-next.umd.js", lg = "./dist/design-system-next.es.js", ug = { type: "git", url: "https://dev.azure.com/sproutphil/Sprout%20Design%20System/_git/Sprout%20Design%20System%20Next" }, dg = "module", cg = ["dist", "dist/", "src/", "README.md", "LICENSE"], pg = { ".": { import: "./dist/design-system-next.es.js", require: "./dist/design-system-next.umd.js" }, "./style.css": "./dist/main.css" }, fg = { dev: "vite", build: "vue-tsc && vite build", "watch-build": "vue-tsc && vite build --watch", types: "vue-tsc", preview: "vite preview", "lint:script": 'eslint "**/*.{js,ts,vue}"', "lint:style": 'stylelint "**/*.{vue,css}"', "fix:style": 'stylelint --fix "**/*.{vue,css}"', lint: "npm run lint:script && npm run lint:style", prepublishOnly: "npm run build", "docs:dev": "vitepress dev docs", "docs:build": "vitepress build docs", "docs:serve": "vitepress serve docs", "docs:preview": "vitepress preview docs", clean: "rm -rf node_modules dist coverage package-lock.json && npm install" }, gg = { "@cloudinary/url-gen": "^1.21.0", "@eslint/js": "^9.17.0", "@iconify-icons/ph": "^1.2.5", "@iconify/vue": "^4.3.0", classnames: "^2.5.1", "countries-list": "^3.1.1", dayjs: "^1.11.13", "floating-vue": "^5.2.2", "libphonenumber-js": "^1.12.5", lodash: "^4.17.21", pinia: "^2.3.1", stylelint: "^16.12.0", "stylelint-config-recess-order": "^5.1.1", "stylelint-config-recommended": "^14.0.1", "stylelint-config-recommended-vue": "^1.5.0", "typescript-eslint": "^8.19.1", "vite-plugin-sass": "^0.1.0", vue: "^3.0.0" }, hg = { "@stylistic/stylelint-plugin": "^3.1.1", "@types/node": "^22.10.5", "@vitejs/plugin-vue": "^5.2.1", autoprefixer: "^10.4.20", eslint: "^9.17.0", "eslint-config-prettier": "^9.1.0", "eslint-plugin-vue": "^9.32.0", prettier: "^3.4.2", "prettier-plugin-tailwindcss": "^0.6.9", "rollup-plugin-gzip": "^4.0.1", "sass-embedded": "^1.83.1", tailwindcss: "^3.4.17", typescript: "~5.7.2", "unplugin-vue-components": "^28.0.0", vite: "^6.0.7", "vite-plugin-dts": "^4.4.0", "vite-tsconfig-paths": "^5.1.4", vitepress: "^1.5.0", "vue-eslint-parser": "^9.4.3", "vue-tsc": "^2.2.0" }, yg = { vue: "^3.0.0" }, Cg = { node: ">=20.0.0", npm: ">=10.0.0" }, vg = {
  name: ag,
  private: !1,
  version: og,
  main: ig,
  module: lg,
  repository: ug,
  type: dg,
  files: cg,
  exports: pg,
  scripts: fg,
  dependencies: gg,
  devDependencies: hg,
  peerDependencies: yg,
  engines: Cg
}, mg = "spr-", Mg = /* @__PURE__ */ Object.assign({ "../src/components/accordion/accordion.vue": Li, "../src/components/avatar/avatar.vue": Ji, "../src/components/badge/badge.vue": Gi, "../src/components/banner/banner.vue": nl, "../src/components/button/button-dropdown/button-dropdown.vue": X1, "../src/components/button/button.vue": xi, "../src/components/calendar-cell/calendar-cell.vue": uu, "../src/components/calendar/calendar.vue": Sd, "../src/components/card/card.vue": Cu, "../src/components/checkbox/checkbox.vue": p1, "../src/components/chips/chips.vue": Rd, "../src/components/collapsible/collapsible.vue": Bo, "../src/components/date-picker/date-picker.vue": x3, "../src/components/dropdown/dropdown.vue": W1, "../src/components/empty-state/empty-state.vue": Vu, "../src/components/file-upload/file-upload.vue": G3, "../src/components/filter/filter.vue": d4, "../src/components/floating-action/floating-action.vue": y4, "../src/components/input/input-contact-number/input-contact-number.vue": S6, "../src/components/input/input-dropdown/input-dropdown.vue": T6, "../src/components/input/input-email/input-email.vue": _6, "../src/components/input/input-password/input-password.vue": k6, "../src/components/input/input-search/input-search.vue": N1, "../src/components/input/input-url/input-url.vue": P6, "../src/components/input/input-username/input-username.vue": U6, "../src/components/input/input.vue": b1, "../src/components/list/ladderized-list/ladderized-list-back.vue": U1, "../src/components/list/ladderized-list/ladderized-list.vue": Q1, "../src/components/list/list.vue": k1, "../src/components/logo/logo.vue": B5, "../src/components/lozenge/lozenge.vue": Iu, "../src/components/modal/modal.vue": K5, "../src/components/progress-bar/progress-bar.vue": n9, "../src/components/radio/radio.vue": p9, "../src/components/select/select-ladderized/select-ladderized.vue": N9, "../src/components/select/select-multiple/select-multiple.vue": E9, "../src/components/select/select.vue": q9, "../src/components/sidenav/sidenav.vue": o8, "../src/components/sidepanel/sidepanel.vue": g8, "../src/components/sidepanel/stacking-sidepanel/stacking-sidepanel.vue": m8, "../src/components/slider/slider.vue": I8, "../src/components/snackbar/snack/snack.vue": O8, "../src/components/snackbar/snackbar.vue": f7, "../src/components/status/status.vue": iu, "../src/components/stepper/step/step.vue": M7, "../src/components/stepper/stepper.vue": $7, "../src/components/switch/switch.vue": _7, "../src/components/table/table-actions/table-actions.vue": E7, "../src/components/table/table-chips-title/table-chips-title.vue": F7, "../src/components/table/table-lozenge-title/table-lozenge-title.vue": Q7, "../src/components/table/table-pagination/table-pagination.vue": K7, "../src/components/table/table.vue": Af, "../src/components/tabs/tabs.vue": Lf, "../src/components/textarea/textarea.vue": Bf, "../src/components/time-picker/time-picker.vue": Xf, "../src/components/tooltip/tooltip.vue": sg }), bg = (e) => {
  Object.entries(Mg).forEach(([t, r]) => {
    var s;
    const n = (s = t.split("/").pop()) == null ? void 0 : s.replace(".vue", "");
    n && e.component(`${mg}${n}`, r.default);
  }), console.info(
    `%c🌱 Design System Next Installed v${vg.version} 🌱`,
    "font-weight: bold; font-size: 14px; color: green; padding: 16px 8px; border: 1px dashed green; border-radius: 4px; margin: 10px auto;"
  );
}, $g = { install: bg };
export {
  $g as default
};
